(function () {
    'use strict';

    angular
        .module('pharmaPortalApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.router',
            'infinite-scroll',
            'angular-loading-bar',
            'ui.select',
            'ngSanitize',
            'ngAnimate',
            'blockUI',
            'ui.tree',
            'ui.toggle',
            'duScroll',
            'ui.carousel',
            'ngMap',
            'floatThead',
            'ngJsTree',
            'angularMoment',
            'ui.calendar',
            'dndLists',
            'ui-notification',
            'highcharts-ng',
            'ngAvatar',
            'moment-picker',
            'ui.bootstrap.contextMenu',
            'ui-select-infinity'
            // jhipster-needle-angularjs-add-module JHipster will add new module here
        ])
        .run(run)
        .config(config);

    run.$inject = ['stateHandler', 'translationHandler', 'uibPaginationConfig', '$templateCache'];
    config.$inject = ['$qProvider', 'uiSelectConfig', 'blockUIConfig', 'NotificationProvider'];

    function run(stateHandler, translationHandler, uibPaginationConfig, $templateCache) {
        stateHandler.initialize();
        translationHandler.initialize();

        uibPaginationConfig.previousText = "‹";
        uibPaginationConfig.nextText = "›";
        uibPaginationConfig.firstText = "«";
        uibPaginationConfig.lastText = "»";

        $templateCache.put("bootstrap/match-multiple.tpl.html", "<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"col-md-12 ui-select-match-item btn btn-info btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-info\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span>&nbsp;<span uis-transclude-append=\"\"></span></span></span></span>");
    }

    function config($qProvider, uiSelectConfig, blockUIConfig, NotificationProvider) {
        $qProvider.errorOnUnhandledRejections(false);

        uiSelectConfig.theme = 'bootstrap';
        uiSelectConfig.closeOnSelect = true;
        uiSelectConfig.spinnerEnabled = true;
        uiSelectConfig.spinnerClass = 'fa fa-refresh ui-select-spin';

        // blockUI
        // Disable automatically blocking of the user interface
        blockUIConfig.autoBlock = false;

        new WOW().init();

        NotificationProvider.setOptions({
            delay: 5000,
            startTop: 20,
            startRight: 10,
            verticalSpacing: 20,
            horizontalSpacing: 20,
            positionX: 'right',
            positionY: 'top',
            maxCount: 1,
            replaceMessage: true
        });
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').filter('complaint', function() {
        return function (item, flag) {
            var out = [];
            for (var i = 0; i < item.length; i++) {
                if (item[i].selected == flag && item[i].invoicedQuantity > item[i].receivedQuantity) {
                    out.push(item[i]);
                }
            }
            return out;
        }
    })
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('User', User);

	User.$inject = [ '$resource' ];

	function User($resource) {
		var service = $resource('api/users/:login', {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
            'queryMyCompanyUsers': {method: 'GET', isArray: true, url: 'api/users/mycompanyusers'},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'save' : {
				method : 'POST'
			},
			'update' : {
				method : 'PUT'
			},
			'delete' : {
				method : 'DELETE'
			}
		});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('ProfileService', ProfileService);

	ProfileService.$inject = [ '$http' ];

	function ProfileService($http) {

		var dataPromise;

		var service = {
			getProfileInfo : getProfileInfo
		};

		return service;

		function getProfileInfo() {
			if (angular.isUndefined(dataPromise)) {
				dataPromise = $http.get('api/profile-info').then(function(result) {
					if (result.data.activeProfiles) {
						var response = {};
						response.activeProfiles = result.data.activeProfiles;
						response.ribbonEnv = result.data.ribbonEnv;
						response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
						response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
						return response;
					}
				});
			}
			return dataPromise;
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('pageRibbon', pageRibbon);

	pageRibbon.$inject = [ 'ProfileService', '$rootScope', '$translate' ];

	function pageRibbon(ProfileService, $rootScope, $translate) {
		var directive = {
			replace : true,
			restrict : 'AE',
			template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			ProfileService.getProfileInfo().then(function(response) {
				if (response.ribbonEnv) {
					scope.ribbonEnv = response.ribbonEnv;
					element.addClass(response.ribbonEnv);
					element.removeClass('hidden');
				}
			});
		}
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('SelloutIntegrationHistory', SelloutIntegrationHistory);

	SelloutIntegrationHistory.$inject = [ '$resource' ];

	function SelloutIntegrationHistory($resource) {
		var resourceUrl = 'api/sellout-integration-histories/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			},
            'getCompletedImports' : {
			    method : 'GET',
                isArray : true,
                url : 'api/completedSellouts'
            },
            'removeIntegration': {
                method : 'DELETE',
                url : 'api/sellout-integration-histories/removeIntegration/:id'
            }
		});
	}
})();

(function () {
    'use strict';
    angular.module('pharmaPortalApp').factory('ReportGroup', ReportGroup);

    ReportGroup.$inject = ['$resource', 'DateUtils'];

    function ReportGroup($resource, DateUtils) {
        var resourceUrl = 'api/reportGroups/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'isUsed': {
                method: 'GET',
                isArray: true,
                url:'api/parentIsUsed'
            },
            'update': {method: 'PUT'}
        });
    }
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('Report', Report);

	Report.$inject = [ '$resource' ];

	function Report($resource) {
		var resourceUrl = 'api/reports/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			},
            'getByReportGroup':{
			    method: 'GET',
                isArray: true,
                url : 'api/reportsByReportGroup'
            },
            'getUserReportsOrder':{
			    method:'GET',
                isArray: true,
                url:'userReportOrderRes/userReportsOrder'
            },
            'saveReportOrder':{
			    method:'PUT',
                isArray: true,
                url:'userReportOrderRes/saveOrder'
            }
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PurchaseOrderItem', PurchaseOrderItem);

	PurchaseOrderItem.$inject = [ '$resource' ];

	function PurchaseOrderItem($resource) {
		var resourceUrl = 'api/purchase-order-items/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PurchaseOrder', PurchaseOrder);

	PurchaseOrder.$inject = [ '$resource' ];

	function PurchaseOrder($resource) {
		var resourceUrl = 'api/purchase-orders/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('pharmaPortalApp').factory('PsychotropicsRequisitions', PsychotropicsRequisitions);

    PsychotropicsRequisitions.$inject = ['$resource'];

    function PsychotropicsRequisitions($resource) {
        var resourceUrl = 'api/psychotropics-requisitions';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'queryAllFilters': {
                method: 'GET',
                url: 'api/psychotropics-requisitions/all-filters',
                isArray: true
            },
            'queryWithFilters': {
                method: 'GET',
                url: 'api/psychotropics-requisitions/filters',
                isArray: true
            },
            'queryAllYearsToTree': {
                method: 'GET',
                url: 'api/psychotropics-requisitions/data-tree/years',
                isArray: true
            },
            'queryMonthAndYearToTree': {
                method: 'GET',
                url: 'api/psychotropics-requisitions/data-tree-new/initial-data',
                isArray: true
            },
            'queryAllEntitiesToTree': {
                method: 'GET',
                url: 'api/psychotropics-requisitions/data-tree/entities',
                isArray: true
            },
            'getAllTypesToTree': {
                method: 'GET',
                url: 'api/psychotropics-requisitions/data-tree/types',
                isArray: true
            },
            'getAllTablesToTree': {
                method: 'GET',
                url: 'api/psychotropics-requisitions/data-tree/tables',
                isArray: true
            },
            'queryAllMonthsToTree': {
                method: 'GET',
                url: 'api/psychotropics-requisitions/data-tree/months',
                isArray: true
            },
            'availableRequisition': {
                method: 'PUT',
                url: 'api/psychotropics-requisitions/available'
            },
            'validateRequisition': {
                method: 'PUT',
                url: 'api/psychotropics-requisitions/validate'

            },
            'availableListRequisitions': {
                method: 'PUT'
            },
            'validateListRequisitions': {
                method: 'PUT',
                url: 'api/psychotropics-requisitions/list/validate'
            },
            'cancelRequisition': {
                method: 'PUT',
                url: 'api/psychotropics-requisitions/cancel'
            }
            ,
            'deleteRequisition': {
                method: 'DELETE',
                url: 'api/psychotropics-requisitions/delete'
            },
            'deleteAllRequisition': {
                method: 'POST',
                url: 'api/psychotropics-requisitions/delete/list'
            },
            'getAllFiltersData': {
                method: 'GET',
                url: 'api/psychotropics-requisitions/all-entities'
            },
            'getAllRequisitionLines': {
                method: 'GET',
                isArray: true,
                url: 'api/psychotropics-requisitions/lines'
            },
            'getAllFilterLines': {
                method: 'GET',
                url: 'api/psychotropics-requisitions/lines/filters'
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('pharmaPortalApp').factory('ProductStockQtd', ProductStockQtd);

    ProductStockQtd.$inject = ['$resource'];

    function ProductStockQtd($resource) {
        var resourceUrl = 'api/product-stock-qtd/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('ProductList', ProductList);

	ProductList.$inject = [ '$resource' ];

	function ProductList($resource) {
		var resourceUrl = 'api/product-lists/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();

(function () {
    'use strict';
    angular
        .module('pharmaPortalApp')
        .factory('ProductErpIntegration', ProductErpIntegration);

    ProductErpIntegration.$inject = ['$resource'];

    function ProductErpIntegration($resource) {
        var resourceUrl = 'api/product-erp-integrations/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllProductLineByProductErpIntegration': {
                method: 'GET',
                isArray: true,
                url: 'api/product-erp-integration/findAllProductLineByProductErpIntegration'
            },
            'findAllPriceLineByProductErpIntegration': {
                method: 'GET',
                isArray: true,
                url: 'api/product-erp-integration/findAllPriceLineByProductErpIntegration'
            }
        });
    }
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('ProductCurrentAccountLock', ProductCurrentAccountLock);

	ProductCurrentAccountLock.$inject = [ '$resource' ];

	function ProductCurrentAccountLock($resource) {
		var resourceUrl = 'api/product-current-account-locks/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : false
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PortalSettings', PortalSettings);

	PortalSettings.$inject = [ '$resource' ];

	function PortalSettings($resource) {
		var resourceUrl = 'api/portal-settings';

		return $resource(resourceUrl, {}, {
            'query': {
                method : 'GET'
            },
			'update' : {
				method : 'PUT'
            },
            'saveActiveTradeGroups':{
                method:'GET',
                url:'api/activeTradeGroups/saveActiveGroup'
            },
            'deleteActiveTradeGroups': {
                method:'GET',
                url:'api/activeTradeGroups/deleteActiveTradeGroups'
            },
            'getAllActiveClientGroups':{
                method:'GET',
                isArray: true,
                url:'api/activeTradeGroups/getAllActiveGroups'
            }
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('Product', Product);

	Product.$inject = [ '$resource' ];

	function Product($resource) {
		var resourceUrl = 'api/portal-products/:id';

		return $resource(resourceUrl, {}, {
			'query' : { method : 'GET', isArray : true },
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : { method : 'PUT' },
            'getProductInfo': {
                method: 'GET',
                url: 'api/portal-product/getProductInfo'
            }
		});
	}
})();

(function() {
    'use strict';
    angular
        .module('pharmaPortalApp')
        .factory('PortalNotification', PortalNotification);

    PortalNotification.$inject = ['$resource', 'DateUtils'];

    function PortalNotification ($resource, DateUtils) {
        var resourceUrl =  'api/portalNotifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PortalApp', PortalApp);

	PortalApp.$inject = [ '$resource' ];

	function PortalApp($resource) {
		var resourceUrl = 'api/portal-apps/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PolicySettings', PolicySettings);

	PolicySettings.$inject = [ '$resource' ];

	function PolicySettings($resource) {
		var resourceUrl = 'api/policySettings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : false
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('pharmaPortalApp').factory('PolicyDefinition', PolicyDefinition);

    PolicyDefinition.$inject = ['$resource'];

    function PolicyDefinition($resource) {
        var resourceUrl = 'api/policy-definitions/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    try {
                        angular.forEach(data, function (meta) {

                        });
                    } catch (err) {
                    }
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    try {
                        angular.forEach(data, function (meta) {

                        });
                    } catch (err) {
                    }
                    return angular.toJson(data);
                }
            },
            'updateAll': {
                method: 'PUT',
                url: "api/policy-definitions-update-bulk",
                transformRequest: function (data) {
                    try {
                        angular.forEach(data, function (meta) {

                        });
                    } catch (err) {
                    }
                    return angular.toJson(data);
                }
            },
            'deleteBulk': {
                method: 'POST',
                url: "api/policy-definitions-delete-bulk",
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            }
        });
    }
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaTransfReceptionLine', PharmaTransfReceptionLine);

	PharmaTransfReceptionLine.$inject = [ '$resource' ];

	function PharmaTransfReceptionLine($resource) {
		var resourceUrl = 'api/pharma-transf-reception-line/:id';

		return $resource(resourceUrl, {}, {
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaTransfReception', PharmaTransfReception);

	PharmaTransfReception.$inject = [ '$resource' ];

	function PharmaTransfReception($resource) {
		var resourceUrl = 'api/pharma-transf-reception/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'save' : {
				method : 'PUT',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			},
			'submit' : {
				method : 'GET',
				url : 'api/pharma-transf-reception/:id/submit',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaTrade', PharmaTrade);

	PharmaTrade.$inject = [ '$resource' ];

	function PharmaTrade($resource) {
		var resourceUrl = 'api/pharma-trade/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function () {
    'use strict';
    angular.module('pharmaPortalApp').factory('PharmaSelfTest', PharmaSelfTest);

    PharmaSelfTest.$inject = ['$resource'];

    function PharmaSelfTest($resource) {
        var resourceUrl = 'api/pharma-self-test';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaSale', PharmaSale);

	PharmaSale.$inject = [ '$resource' ];

	function PharmaSale($resource) {
		var resourceUrl = 'api/pharma-sale/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReturn', PharmaReturn);

	PharmaReturn.$inject = [ '$resource' ];

	function PharmaReturn($resource) {
		var resourceUrl = 'api/pharma-return/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReceptionVatLine', PharmaReceptionVatLine);

	PharmaReceptionVatLine.$inject = [ '$resource' ];

	function PharmaReceptionVatLine($resource) {
		var resourceUrl = 'api/pharma-reception-vat-line/:id';

		return $resource(resourceUrl, {}, {
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReceptionServiceList', PharmaReceptionServiceList);

	PharmaReceptionServiceList.$inject = [ '$resource' ];

	function PharmaReceptionServiceList($resource) {
		var resourceUrl = 'api/pharmaReceptionServiceList/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReceptionServiceByVat', PharmaReceptionServiceByVat);

	PharmaReceptionServiceByVat.$inject = [ '$resource' ];

	function PharmaReceptionServiceByVat($resource) {
		var resourceUrl = 'api/pharmaReceptionServiceByVat/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReceptionLine', PharmaReceptionLine);

	PharmaReceptionLine.$inject = [ '$resource' ];

	function PharmaReceptionLine($resource) {
		var resourceUrl = 'api/pharma-reception-line/:id';

		return $resource(resourceUrl, {}, {
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReceptionInvoice', PharmaReceptionInvoice);

	PharmaReceptionInvoice.$inject = [ '$resource' ];

	function PharmaReceptionInvoice($resource) {
		var resourceUrl = 'api/pharma-reception-invoice/:id';

		return $resource(resourceUrl, {}, {
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaReception', PharmaReception);

	PharmaReception.$inject = [ '$resource' ];

	function PharmaReception($resource) {
		var resourceUrl = 'api/pharma-reception/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'save' : {
				method : 'PUT',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			},
			'submit' : {
				method : 'GET',
				url : 'api/pharma-reception/:id/submit/:createReceptionNote',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			},
			'submitInvoice' : {
				method : 'POST',
				url : 'api/pharma-reception/submitSupplierInvoice',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaPurchase', PharmaPurchase);

	PharmaPurchase.$inject = [ '$resource' ];

	function PharmaPurchase($resource) {
		var resourceUrl = 'api/pharma-purchase/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaPickingLine', PharmaPickingLine);

	PharmaPickingLine.$inject = [ '$resource' ];

	function PharmaPickingLine($resource) {
		var resourceUrl = 'api/pharma-picking-line/:id';

		return $resource(resourceUrl, {}, {
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaPicking', PharmaPicking);

	PharmaPicking.$inject = [ '$resource' ];

	function PharmaPicking($resource) {
		var resourceUrl = 'api/pharma-picking/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
            'pharmaciesFilter' : {
                method : 'GET',
                url : 'api/pharma-picking/pharmacies-filter',
                isArray : true
            },
            'usersFilter' : {
                method : 'GET',
                url : 'api/pharma-picking/users-filter',
                isArray : true
            },
            'suppliersFilter' : {
                method : 'GET',
                url : 'api/pharma-picking/suppliers-filter',
                isArray : true
            },
            'haveItemsToTransport' : {
                method : 'GET',
                isArray : false,
                url : 'api/pharma-picking/items-to-transport',
                transformResponse: [function (data, headers) {
                    return {body: data};
                }]
            },
			'save' : {
				method : 'PUT',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {
						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			},
            'update' : {
                method : 'PUT',
                url : 'api/pharma-picking'
            },
			'submit' : {
				method : 'GET',
				url : 'api/pharma-picking/submit'
			},
            'getAllImportFiles': {
                method : 'GET',
                url : 'api/pharma-picking-import-files',
                isArray: true
            },
            'deleteImportFile': {
                method : 'DELETE',
                url : 'api/pharma-picking-import-files/:id'
            },
            'getImportFileByPharmacyWarehouse': {
                method : 'GET',
                url : 'api/pharma-picking-import-files/pharmacy-warehouse',
                isArray: true
            },
            'importFileCompaniesFilter' : {
                method : 'GET',
                url : 'api/pharma-picking-import-files/companies',
                isArray : true
            },
            'getProductsForHistory' : {
                method : 'GET',
                url : 'api/pharma-picking-show-history',
                isArray : true
            },
            'getPickingHeaderForProductHistory' : {
                method : 'GET',
                url : 'api/pharma-picking-for-product-history',
                isArray : true
            },
		});
	}
})();

(function() {
    'use strict';
    angular
        .module('pharmaPortalApp')
        .factory('PharmaFaultSettings', PharmaFaultSettings);

    PharmaFaultSettings.$inject = ['$resource'];

    function PharmaFaultSettings ($resource) {
        var resourceUrl =  'api/pharma-fault-settings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('pharmaPortalApp')
        .factory('PharmaFaultReportLine', PharmaFaultReportLine);

    PharmaFaultReportLine.$inject = ['$resource'];

    function PharmaFaultReportLine ($resource) {
        var resourceUrl =  'api/pharma-fault-report-lines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular.module('pharmaPortalApp').factory('PharmaDashboard',
        PharmaDashboard);

    PharmaDashboard.$inject = ['$resource'];

    function PharmaDashboard($resource) {
        var resourceUrl = "api/pharma-dashboard";

        return $resource(
            resourceUrl,
            {},
            {
                'query': {
                    method: 'GET',
                    isArray: true
                },
                'getCampaignTypes': {
                    method: 'GET',
                    isArray: true,
                    url: 'api/campaigns/campaignTypes'
                },
                'getCampaignsByPeriod':{
                    method: 'GET',
                    isArray: true,
                    url: 'dashboardRes/campaignsByPeriod'
                },
                'getPortalUsers':{
                    method:'GET',
                    isArray:true,
                    url: 'dashboardRes/portalUsers'
                },
                'getPeriodFromInd': {
                    method: 'GET',
                    isArray: true,
                    url: 'dashboardRes/period'
                },
                'getPeriodTypeFromInd': {
                    method: 'GET',
                    isArray: true,
                    url: 'dashboardRes/periodType'
                },
                'queryTopSalesmanByPharmacyOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByPharmacyOrderByValue"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopSalesmanOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanOrderByValue"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopSalesmanByPharmacyOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByPharmacyOrderByQuantity"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopSalesmanOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanOrderByQuantity"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopSalesmanByCampaignTypeAndPharmacyOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByCampaignTypeAndPharmacyOrderByQuantity"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopSalesmanByCampaignTypeAndPharmacyOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByCampaignTypeAndPharmacyOrderByValue"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopSalesmanByCampaignTypeOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByCampaignTypeOrderByValue"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopSalesmanByCampaignTypeOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByCampaignTypeOrderByQuantity"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopSalesmanByCampaignOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByCampaignOrderByQuantity"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopSalesmanByCampaignOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByCampaignOrderByValue"},
                    url: '/dashboardRes/salesman'
                },
                'queryTopSalesmanByPharmacyAndCampaignOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByPharmacyAndCampaignOrderByQuantity"},
                    url: '/dashboardRes/salesman'
                },
                'queryTopSalesmanByPharmacyAndCampaignOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByPharmacyAndCampaignOrderByValue"},
                    url: '/dashboardRes/salesman'
                },
                'querySalesmanByPharmacyAndCampaign': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "salesmanByPharmacyAndCampaign"},
                    url: '/dashboardRes/salesman'
                },
                'querySalesmanByPharmacyAndCampaignType': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "salesmanByPharmacyAndCampaignType"},
                    url: '/dashboardRes/salesman'
                },
                'querySalesmanByPharmacy': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "salesmanByPharmacy"},
                    url: '/dashboardRes/salesman'
                },
                'queryPharmacyByCampaign': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "pharmacyByCampaign"},
                    url: '/dashboardRes/pharmacy'
                },
                'queryPharmacyByCampaignType': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "pharmacyByCampaignType"},
                    url: '/dashboardRes/pharmacy'
                },
                'queryPharmacyByPeriod': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "pharmacyByPeriod"},
                    url: '/dashboardRes/pharmacy'
                },
                'queryPharmacyByCampaignOrderByValue': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "pharmacyByCampaignOrderByValue"},
                    url: '/dashboardRes/pharmacy'
                },
                'queryPharmacyByCampaignTypeOrderByValue': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "pharmacyByCampaignTypeOrderByValue"},
                    url: '/dashboardRes/pharmacy'
                },
                'queryPharmaciesByTimeOrderByValue': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "pharmaciesByTimeOrderByValue"},
                    url: '/dashboardRes/pharmacy'
                },
                'queryPharmacySalesman': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "queryAllPharmacySalesman"},
                    url: '/dashboardRes/salesman'
                },
                'querySelloutPharmacySalesman': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByTime"},
                    url: '/dashboardRes/selloutSalesman'
                },
                'querySelloutPharmacySalesmanAndPharmacy': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanByTimeAndPharmacy"},
                    url: '/dashboardRes/selloutSalesman'
                },
                'queryAllSelloutPharmacySalesman': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "allSalesmanByTime"},
                    url: '/dashboardRes/selloutSalesman'
                },
                'queryAllSelloutPharmacySalesmanAndPharmacy': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "allSalesmanByTimeAndPharmacy"},
                    url: '/dashboardRes/selloutSalesman'
                },
                'querySelloutPharmacy':{
                  method: 'GET',
                  isArray: true,
                  params: {methodName: "topPharmacyByTime"},
                  url: '/dashboardRes/selloutPharmacy'
                },
                'queryPharmacyByTimeNoPharmacy':{
                    method:'GET',
                    isArray: true,
                    params:{methodName:"pharmaciesByTimeNoPharmacy"},
                    url: '/dashboardRes/pharmacy'
                },
                'queryPharmacyByCampaignTypeNoPharmacy':{
                    method:'GET',
                    isArray: true,
                    params:{methodName:"pharmaciesByCampaignTypeNoPharmacy"},
                    url: '/dashboardRes/pharmacy'
                },
                'queryPharmacyByCampaignNoPharmacy':{
                    method:'GET',
                    isArray: true,
                    params:{methodName:"pharmaciesByCampaignNoPharmacy"},
                    url: '/dashboardRes/pharmacy'
                },
                'queryTopAllSalesmanByPharmacyOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "topAllSalesmanByPharmacyOrderByValue"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopAllSalesmanOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "top10SalesmanOrderByValue"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopAllSalesmanByPharmacyOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "topAllSalesmanByPharmacyOrderByQuantity"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopAllSalesmanOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "topAllSalesmanOrderByQuantity"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopAllSalesmanByCampaignTypeAndPharmacyOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "topAllSalesmanByCampaignTypeAndPharmacyOrderByQuantity"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopAllSalesmanByCampaignTypeAndPharmacyOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "topAllSalesmanByCampaignTypeAndPharmacyOrderByValue"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopAllSalesmanByCampaignTypeOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "topAllSalesmanByCampaignTypeOrderByValue"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopAllSalesmanByCampaignTypeOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "topAllSalesmanByCampaignTypeOrderByQuantity"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopAllSalesmanByCampaignOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "topAllSalesmanByCampaignOrderByQuantity"},
                    url: 'dashboardRes/salesman'
                },
                'queryTopAllSalesmanByCampaignOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "topAllSalesmanByCampaignOrderByValue"},
                    url: '/dashboardRes/salesman'
                },
                'queryTopAllSalesmanByPharmacyAndCampaignOrderByQuantityList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "topAllSalesmanByPharmacyAndCampaignOrderByQuantity"},
                    url: '/dashboardRes/salesman'
                },
                'queryTopAllSalesmanByPharmacyAndCampaignOrderByValueList': {
                    method: 'GET',
                    isArray: true,
                    params: {methodName: "topAllSalesmanByPharmacyAndCampaignOrderByValue"},
                    url: '/dashboardRes/salesman'
                }
            });
    }
})();

(function () {
    'use strict';
    angular.module('pharmaPortalApp').factory('PharmaCovid', PharmaCovid);

    PharmaCovid.$inject = ['$resource'];

    function PharmaCovid($resource) {
        var resourceUrl = 'api/pharma-covid';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PharmaBalance', PharmaBalance);

	PharmaBalance.$inject = [ '$resource' ];

	function PharmaBalance($resource) {
		var resourceUrl = 'api/pharma-balance/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('ModuleSettings', ModuleSettings);

	ModuleSettings.$inject = [ '$resource' ];

	function ModuleSettings($resource) {
		var resourceUrl = 'api/moduleSettings/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : false
			},
			'save' : {
				method : 'POST',
				transformRequest : function(data) {
					try {
						angular.forEach(data, function(meta) {

						});
					} catch (err) {
					}
					return angular.toJson(data);
				}
			}
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('Company', Company);

	Company.$inject = [ '$resource' ];

	function Company($resource) {
		var resourceUrl = 'api/companies/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
            },
            'getAllNotEmpty':{
                method:'GET',
                isArray : true,
                url:"api/companies/findAllNotEmpty"
            },
			'findByClient' : {
				method : 'GET',
				url : "api/companies/findByClient/:client"
			},
            'findByPharmacyClient': {
                method: 'GET',
                isArray:true,
                url:"api/companies/typePharmacy"
            },
            'findAllWithPharmacyWarehouse': {
                method: 'GET',
                isArray:true,
                url:"api/companies/withPharmacyWarehouse"
            },
            'findByPharmacyClientAndSelloutNickname': {
                method: 'GET',
                isArray:true,
                url:"api/companies/findAllNotEmptyTypePharmacy"
            },
            'getClientGroups' : {
			    method: 'GET',
                isArray: true,
                url:"api/companies/clientGroups"
            },
            'getCompanySchedule': {
                method: 'GET',
                url:"api/pharmaSchedule/getByCompany"
            },
            'saveCompanySchedule': {
			    method:'PUT',
                url:"api/pharmaSchedule/update"
            },
            'isInactive': {
			    method: 'GET',
                url: "api/companies/isInactive"
            }
		});
	}
})();

(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('CampaignProduct', CampaignProduct);

	CampaignProduct.$inject = [ '$resource' ];

	function CampaignProduct($resource) {
		var resourceUrl = 'api/campaign-products/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();

(function() {
    'use strict';
    angular.module('pharmaPortalApp').factory('Campaign', Campaign);

    Campaign.$inject = [ '$resource' ];

    function Campaign($resource) {
        var resourceUrl = 'api/campaigns/:id';

        return $resource(resourceUrl, {}, {
            'query' : {
                method : 'GET',
                isArray : true
            },
            'get' : {
                method : 'GET',
                transformResponse : function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update' : {
                method : 'PUT'
            },
            'getAllCampaigns':{
                method : 'GET',
                isArray : true,
                url:"api/allCampaigns"
            },
            'activeByDashboardPeriod':{
                method : 'GET',
                isArray : true,
                url:"api/campaigns/activeByDashboardPeriod"
            },
            'getById':{
                method : 'GET',
                isArray : true,
                url: "api/campaigns/getById"
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').factory('AS400Messages', AS400Messages);

    AS400Messages.$inject = ['$resource'];

    function AS400Messages($resource) {
        var resourceUrl = 'api/as400';

        return $resource(
            resourceUrl,
            {},
            {
                'query': {
                    method: 'GET',
                    isArray: true
                },
                'getMessages': {
                    method: 'GET',
                    isArray: true,
                    url: 'api/as400/getMessages'
                }
            }
        )
    }
})();

(function () {
    'use strict';
    angular.module('pharmaPortalApp').factory('AdminSettings', AdminSettings);
    AdminSettings.$inject = ['$resource'];

    function AdminSettings($resource) {
        var resourceUrl = "api/admin-settings";

        return $resource(
            resourceUrl,
            {},
            {
                'query': {
                    method: 'GET',
                    isArray: true
                },
                'syncProductsServ': {
                    method: 'GET',
                    isArray: true,
                    url: 'adminSettingsRes/syncProducts'
                },
                'sendNotificationServ': {
                    method: 'GET',
                    isArray: true,
                    url:'adminSettingsRes/sendNotification'
                }
            });
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('Sessions', Sessions);

	Sessions.$inject = [ '$resource' ];

	function Sessions($resource) {
		return $resource('api/account/sessions/:series', {}, {
			'getAll' : {
				method : 'GET',
				isArray : true
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('Principal', Principal);

	Principal.$inject = ['$q', 'Account'];

	function Principal ($q, Account) {
		var _identity,
		_authenticated = false;

		var service = {
				authenticate: authenticate,
				hasAnyAuthority: hasAnyAuthority,
				hasAuthority: hasAuthority,
				identity: identity,
				isAuthenticated: isAuthenticated,
				isIdentityResolved: isIdentityResolved
		};

		return service;

		function authenticate (identity) {
			_identity = identity;
			_authenticated = identity !== null;
		}

		function hasAnyAuthority (authorities) {
			if (!_authenticated || !_identity || !_identity.authorities) {
				return false;
			}

			for (var i = 0; i < authorities.length; i++) {
				if (_identity.authorities.indexOf(authorities[i]) !== -1) {
					return true;
				}
			}

			return false;
		}

		function hasAuthority (authority) {
			if (!_authenticated) {
				return $q.when(false);
			}

			return this.identity().then(function(_id) {
				return _id.authorities && _id.authorities.indexOf(authority) !== -1;
			}, function(){
				return false;
			});
		}

		function identity (force) {
			var deferred = $q.defer();

			if (force === true) {
				_identity = undefined;
			}

			// check and see if we have retrieved the identity data from the server.
			// if we have, reuse it by immediately resolving
			if (angular.isDefined(_identity)) {
				deferred.resolve(_identity);

				return deferred.promise;
			}

			// retrieve the identity data from the server, update the identity
			// object, and then resolve.
			Account.get().$promise
			.then(getAccountThen)
			.catch(getAccountCatch);

			return deferred.promise;

			function getAccountThen (account) {
				_identity = account.data;
				_authenticated = true;
				deferred.resolve(_identity);
			}

			function getAccountCatch () {
				_identity = null;
				_authenticated = false;
				deferred.resolve(_identity);
			}
		}

		function isAuthenticated () {
			return _authenticated;
		}

		function isIdentityResolved () {
			return angular.isDefined(_identity);
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('PasswordResetInit', PasswordResetInit);

	PasswordResetInit.$inject = [ '$resource' ];

	function PasswordResetInit($resource) {
		var service = $resource('api/account/reset_password/init', {}, {});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('PasswordResetFinish', PasswordResetFinish);

	PasswordResetFinish.$inject = [ '$resource' ];

	function PasswordResetFinish($resource) {
		var service = $resource('api/account/reset_password/finish', {}, {});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('Password', Password);

	Password.$inject = [ '$resource' ];

	function Password($resource) {
		var service = $resource('api/account/change_password', {}, {});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('hasAuthority', hasAuthority);

	hasAuthority.$inject = [ 'Principal' ];

	function hasAuthority(Principal) {
		var directive = {
			restrict : 'A',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			var authority = attrs.hasAuthority.replace(/\s+/g, '');

			var setVisible = function() {
				element.removeClass('hidden');
			}, setHidden = function() {
				element.addClass('hidden');
			}, defineVisibility = function(reset) {

				if (reset) {
					setVisible();
				}

				Principal.hasAuthority(authority).then(function(result) {
					if (result) {
						setVisible();
					} else {
						setHidden();
					}
				});
			};

			if (authority.length > 0) {
				defineVisibility(true);

				scope.$watch(function() {
					return Principal.isAuthenticated();
				}, function() {
					defineVisibility(true);
				});
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('hasAnyAuthority', hasAnyAuthority);

	hasAnyAuthority.$inject = [ 'Principal' ];

	function hasAnyAuthority(Principal) {
		var directive = {
			restrict : 'A',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

			var setVisible = function() {
				element.removeClass('hidden');
			}, setHidden = function() {
				element.addClass('hidden');
			}, defineVisibility = function(reset) {
				var result;
				if (reset) {
					setVisible();
				}

				result = Principal.hasAnyAuthority(authorities);
				if (result) {
					setVisible();
				} else {
					setHidden();
				}
			};

			if (authorities.length > 0) {
				defineVisibility(true);

				scope.$watch(function() {
					return Principal.isAuthenticated();
				}, function() {
					defineVisibility(true);
				});
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('AuthServerProvider', AuthServerProvider);

	AuthServerProvider.$inject = [ '$http', '$localStorage' ];

	function AuthServerProvider($http, $localStorage) {
		var service = {
			getToken : getToken,
			hasValidToken : hasValidToken,
			login : login,
			logout : logout
		};

		return service;

		function getToken() {
			var token = $localStorage.authenticationToken;
			return token;
		}

		function hasValidToken() {
			var token = this.getToken();
			return !!token;
		}

		function login(credentials) {
			var data = 'j_username=' + encodeURIComponent(credentials.username) + '&j_password=' + encodeURIComponent(credentials.password) + '&remember-me='
					+ credentials.rememberMe + '&submit=Login';

			return $http.post('api/authentication', data, {
				headers : {
					'Content-Type' : 'application/x-www-form-urlencoded'
				}
			}).then(function(response) {
				return response;
			});
		}

		function logout() {

                // logout from the server
                $http.post('api/logout').then(function(response) {
                    delete $localStorage.authenticationToken;
                    // to get a new csrf token call the api
                    $http.get('api/account');
                    return response;
                });

		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('Auth', Auth);

	Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', '$localStorage', 'PortalPendingShoppingCarts'];

	function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Activate, Password, PasswordResetInit, PasswordResetFinish, $localStorage, PortalPendingShoppingCarts) {
		var service = {
			activateAccount: activateAccount,
			authorize: authorize,
			changePassword: changePassword,
			getPreviousState: getPreviousState,
			login: login,
			logout: logout,
			resetPasswordFinish: resetPasswordFinish,
			resetPasswordInit: resetPasswordInit,
			resetPreviousState: resetPreviousState,
			storePreviousState: storePreviousState,
			updateAccount: updateAccount
		};

		return service;

		function activateAccount (key, callback) {
			var cb = callback || angular.noop;

			return Activate.get(key,
					function (response) {
				return cb(response);
			},
			function (err) {
				return cb(err);
			}.bind(this)).$promise;
		}

		function authorize (force) {
			var authReturn = Principal.identity(force).then(authThen);

			return authReturn;

			function authThen () {
				var isAuthenticated = Principal.isAuthenticated();

				// an authenticated user can't access to login
				if (isAuthenticated && $rootScope.toState.parent === 'account' && $rootScope.toState.name === 'login') {
					$state.go('home');
				}

				// recover and clear previousState after external login redirect
				// (e.g. oauth2)
				if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
					var previousState = getPreviousState();
					resetPreviousState();
					$state.go(previousState.name, previousState.params);
				}

				if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
					if (isAuthenticated) {
						// user is signed in but not authorized for desired state
						$state.go('accessdenied');
					} else {
						// user is not authenticated. stow the state they wanted
						// before you send them to the login service, so you can return
						// them when you're done
						storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

						// now, send them to the signin state so they can log in
						$state.go('accessdenied').then(function() {
							LoginService.open();
						});
					}
				}
			}
		}

		function changePassword (newPassword, callback) {
			var cb = callback || angular.noop;

			return Password.save(newPassword, function () {
				return cb();
			}, function (err) {
				return cb(err);
			}).$promise;
		}

		function login (credentials, callback) {
			var cb = callback || angular.noop;
			var deferred = $q.defer();

			AuthServerProvider.login(credentials)
			.then(loginThen)
			.catch(function (err) {
				this.logout();
				deferred.reject(err);
				return cb(err);
			}.bind(this));

			function loginThen (data) {
				Principal.identity(true).then(function(account) {
					// After the login the language will be changed to
					// the language selected by the user during his registration
					if (account!== null) {
						$translate.use(account.langKey).then(function () {
							$translate.refresh();
						});
					}
					$localStorage.$reset();

					//TODO read sales order and purchases
                    var tmp = PortalPendingShoppingCarts.get(function (response) {
                        for(var i=0 ; i< response.length; i++){
                            switch (response[i].screen){
                                case "PURCHASE":
                                    $localStorage.purchaseOrder = JSON.parse(response[i].cart_info);
                                    break;
                                case "SALE":
                                    $localStorage.saleOrder = JSON.parse(response[i].cart_info);
                                    break;
                                case "CURRENT_COMPANY":
                                    $localStorage.currentCompany = JSON.parse(response[i].cart_info);
                                    break;
                                case "TRADE":
                                    $localStorage.tradeOrder = JSON.parse(response[i].cart_info);
                                    break;
                                case "RETURN":
                                    $localStorage.returnOrder = JSON.parse(response[i].cart_info);
                                    break;
                            }
                        }
                        deferred.resolve(data);
                    }, function (data) {
                        deferred.resolve(data);
                    });


				});
				return cb();
			}

			return deferred.promise;
		}

		function logout () {
            var tmp = [];

            var sales = saveSalesOrder();
            if(sales){
                tmp.push(sales);
            }
            var purchases = savePurchase();
            if(purchases){
                tmp.push(purchases);
            }
            var company = saveCurrentCompany();
            if(company){
                tmp.push(company);
            }
            var trade = saveTradeOrder();
            if(trade){
                tmp.push(trade);
            }
            var returnOrder = saveReturnOrder();
            if(returnOrder){
                tmp.push(returnOrder);
            }

            if(tmp.length > 0){
                PortalPendingShoppingCarts.save(tmp, function (result) {
                    delete $localStorage.saleOrder;
                    delete $localStorage.purchaseOrder;
                    delete $localStorage.currentCompany;
                    delete $localStorage.tradeOrder;
                    delete $localStorage.returnOrder;
                    AuthServerProvider.logout();
                    Principal.authenticate(null);

                }, function(result){
                    AuthServerProvider.logout();
                    Principal.authenticate(null);
                });
            }else{
                AuthServerProvider.logout();
                Principal.authenticate(null);
            }

		}

        function saveSalesOrder() {
            if($localStorage.saleOrder){
                var tmp = {};
                tmp.screen = "SALE";
                tmp.cart_info = JSON.stringify($localStorage.saleOrder);
                return tmp;
            }else{
                return null;
            }
        };

        function savePurchase() {
            if($localStorage.purchaseOrder && $localStorage.purchaseOrder != ""){
                var tmp = {};
                tmp.screen = "PURCHASE";
                tmp.cart_info = JSON.stringify($localStorage.purchaseOrder);
                return tmp;
            }else{
                return null;
            }
        };
        function saveCurrentCompany() {
            if($localStorage.currentCompany && $localStorage.currentCompany != ""){
                var tmp = {};
                tmp.screen = "CURRENT_COMPANY";
                tmp.cart_info = JSON.stringify($localStorage.currentCompany);
                return tmp;
            }else{
                return null;
            }
        };
        function saveTradeOrder() {
            if($localStorage.tradeOrder && $localStorage.tradeOrder != ""){
                var tmp = {};
                tmp.screen = "TRADE";
                tmp.cart_info = JSON.stringify($localStorage.tradeOrder);
                return tmp;
            }else{
                return null;
            }
        };
        function saveReturnOrder() {
            if($localStorage.returnOrder && $localStorage.returnOrder){
                var tmp = {};
                tmp.screen = "RETURN";
                tmp.cart_info = JSON.stringify($localStorage.returnOrder);
                return tmp;
            }else{
                return null;
            }
        };


		function resetPasswordFinish (keyAndPassword, callback) {
			var cb = callback || angular.noop;

			return PasswordResetFinish.save(keyAndPassword, function () {
				return cb();
			}, function (err) {
				return cb(err);
			}).$promise;
		}

		function resetPasswordInit (mail, callback) {
			var cb = callback || angular.noop;

			return PasswordResetInit.save(mail, function() {
				return cb();
			}, function (err) {
				return cb(err);
			}).$promise;
		}

		function updateAccount (account, callback) {
			var cb = callback || angular.noop;

			return Account.save(account,
					function () {
				return cb(account);
			},
			function (err) {
				return cb(err);
			}.bind(this)).$promise;
		}

		function getPreviousState() {
			var previousState = $sessionStorage.previousState;
			return previousState;
		}

		function resetPreviousState() {
			delete $sessionStorage.previousState;
		}

		function storePreviousState(previousStateName, previousStateParams) {
			var previousState = { "name": previousStateName, "params": previousStateParams };
			$sessionStorage.previousState = previousState;
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('Activate', Activate);

	Activate.$inject = [ '$resource' ];

	function Activate($resource) {
		var service = $resource('api/activate', {}, {
			'get' : {
				method : 'GET',
				params : {},
				isArray : false
			}
		});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('Account', Account);

	Account.$inject = [ '$resource' ];

	function Account($resource) {
		var service = $resource('api/account', {}, {
			'get' : {
				method : 'GET',
				params : {},
				isArray : false,
				interceptor : {
					response : function(response) {
						// expose response
						return response;
					}
				}
			}
		});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('SidenavController', SidenavController);

	SidenavController.$inject = ['$state', 'Auth', 'Principal', '$http', '$filter', '$scope', 'ModuleSettings', 'PolicySettings', 'ReportGroup', 'PortalSettings'];

	function SidenavController($state, Auth, Principal, $http, $filter, $scope, ModuleSettings, PolicySettings, ReportGroup, PortalSettings) {
		var vm = this;

		vm.moduleSettings = ModuleSettings.query();
		// vm.policyTypes = [];
		vm.loggedUser = null;
        vm.portalSettings = PortalSettings.query();

        vm.canTrade = true;
        vm.activeGroups = [];
		vm.openNav = openNav;
		vm.closeNav = closeNav;
		vm.logout = logout;
		vm.loadAll = loadAll;
		// vm.checkPolicySettings = checkPolicySettings;
		vm.expandNode = expandNode;
		vm.expandLevel2Node = expandLevel2Node;
		vm.getReportGroups = getReportGroups;

		function openNav() {
			loadAll();
			angular.element("#mySidenav").css("width", "300px");
			angular.element(".sidenav-overlay").css("width", "100%").css("backgroundColor", "rgba(0,0,0,0.4)");
		}

		function closeNav() {
			angular.element("#mySidenav").css("width", "0");
			angular.element(".sidenav-overlay").css("width", "0").css("backgroundColor", "white");
			loadAll();
		}

		function logout() {
			closeNav();
			Auth.logout();
			$state.go('home');
		}

		function loadAll() {
			Principal.identity().then(function(account) {
				vm.isPharma = false;
				if(account) {
					vm.loggedUser = account.login;
					if (account.company && account.company.clientType == "F") {
							vm.isPharma = true;
					}
                    if(account.authorities.length > 0) {
                        vm.reportGroups = ReportGroup.query();
                    }
				} else {
					vm.loggedUser = null;
				}

				if (vm.portalSettings.onlyTradeInGroup) {
                    PortalSettings.getAllActiveClientGroups(function (result2) {
                        vm.activeGroups = result2;
                        vm.canTrade = false;
                        for (var i = 0; i < vm.activeGroups.length; i++) {
                            if (account.company.clientGroup == vm.activeGroups[i].name) {
                                vm.canTrade = true;
                            }
                        }
                    });
                }
			});
		}
		loadAll();

		// function checkPolicySettings() {
		// 	$http.get("api/policy-builder/interfacesBySettings").then(function(result) {
		// 		vm.policyTypes = [];
        //
		// 		angular.forEach(result.data, function(v, k) {
		// 			vm.policyTypes.push({
		// 				'fqn' : v,
		// 				'name' : $filter('translate')(v)
		// 			});
		// 		});
		// 	});
		// }

		function expandNode(nodeNb) {
			$scope.nodeLevel2Status = null;
			if($scope.nodeStatus == nodeNb) {
				$scope.nodeStatus = null;
			} else {
				$scope.nodeStatus = nodeNb;
			}
		}

		function expandLevel2Node(nodeNb, nodeNb2) {
			$scope.nodeStatus = nodeNb;
			if($scope.nodeLevel2Status == nodeNb2) {
				$scope.nodeLevel2Status = null;
			} else {
				$scope.nodeLevel2Status = nodeNb2;
			}
		}

        function getReportGroups(nodeStatus) {
            if(nodeStatus != 1){
                vm.reportGroups = ReportGroup.query();
            }
        }
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('NavbarIOController', NavbarIOController);

	NavbarIOController.$inject = [ '$rootScope', '$scope', 'Principal', '$state', 'Auth', '$interval', '$animate', '$http', 'PortalSettings' ];

	function NavbarIOController ($rootScope, $scope, Principal, $state, Auth, $interval, $animate, $http, PortalSettings) {
		var vm = this;
		vm.settings = PortalSettings.query();
		
		vm.authenticationError = false;
		vm.username = null;
		vm.password = null;
		vm.rememberMe = true;
		vm.login = login;
		vm.logout = logout;
		vm.goHome = goHome;
		vm.requestResetPassword = requestResetPassword;

		vm.account = null;
		vm.isAuthenticated = null;
		vm.environment = null;

		$scope.$on('authenticationSuccess', function() {
			getAccount();
		});
		
		getAccount();
		
		$scope.status = {
			isLoginOpen: false
		};
		
		$rootScope.toggleDropdown = function($event) {
			$event.preventDefault();
			$event.stopPropagation();
			$scope.isNavCollapsed = false;
			$scope.status.isLoginOpen = !$scope.status.isLoginOpen;
		};
		
		function getAccount() {
			Principal.identity().then(function(account) {
				vm.account = account;
				if(account && account.authorities.length){
					vm.isAuthenticated = Principal.isAuthenticated;
					// $state.go('pharma-purchase');
				} else {
					if(vm.username && vm.password) {
						vm.authenticationError = true;
					}
				}
			}).catch(function () {
				vm.isAuthenticated = null;
				$state.go('home.io');
			});
		}
		
		function login(event) {
			event.preventDefault();
			Auth.login({
				username: vm.username,
				password: vm.password,
				rememberMe: vm.rememberMe
			}).then(function () {
				vm.authenticationError = false;
				$state.go('pharma-purchase');
			}).catch(function () {
				vm.authenticationError = true;
			});
		};

		function logout() {
			Auth.logout();
			$state.go('home.io');
		}
		
		function goHome() {
			$state.go('pharma-purchase');
		}
		
		function requestResetPassword () {
			$state.go('requestReset');
		}
		
		vm.getAccount = getAccount;
	}
})();
(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'PortalSettings', 'Notification', '$http', '$rootScope', '$timeout'];

    function NavbarController($state, Auth, Principal, ProfileService, LoginService, PortalSettings, Notification, $http, $rootScope, $timeout) {
        var vm = this;
        vm.settings = PortalSettings.query();

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        vm.isFullyAuthenticated = false;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.loadAll = loadAll;
        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.nameInitials = null;

        vm.$state = $state;

        // refresh again in 60 seconds
        $timeout(function(){
            getUnreadNotifications();
        },60000);

        $rootScope.$on('readOrUnreadEvent', function (event) {
            getUnreadNotifications();
        });

        function getUnreadNotifications() {
            $http.get('api/portalNotifications/unreadNotifications').then(function (result) {
                if (result.status === 200) {
                    vm.numberOfNotifications = result.data;
                } else {
                    Notification.error({message: $translate.instant(result.headers("X-pharmaPortalApp-alert")), delay: ''});
                }
            });
        }

        $rootScope.$on('updateNavbar', function (event) {
            Principal.identity(true).then(function (account) {
                vm.loggedUser = account;
            });
        });

        function loadAll() {
            Principal.identity().then(function (account) {
                vm.loggedUser = account;

                var name = vm.loggedUser.firstName + ' ' + vm.loggedUser.lastName;
                var initials = name.match(/\b\w/g) || [];
                initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
                vm.nameInitials = initials;

                if (account.authorities.length > 0) {
                    getUnreadNotifications();
                    vm.isFullyAuthenticated = true;
                } else {
                    vm.isFullyAuthenticated = false;
                }
            });
        }

        loadAll();

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            vm.isFullyAuthenticated = false;
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('activeMenu', activeMenu);

	activeMenu.$inject = [ '$translate', '$locale', 'tmhDynamicLocale' ];

	function activeMenu($translate, $locale, tmhDynamicLocale) {
		var directive = {
			restrict : 'A',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			var language = attrs.activeMenu;

			scope.$watch(function() {
				return $translate.use();
			}, function(selectedLanguage) {
				if (language === selectedLanguage) {
					tmhDynamicLocale.set(language);
					element.addClass('active');
				} else {
					element.removeClass('active');
				}
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('FooterController', FooterController);

	FooterController.$inject = [ '$state' ];

	function FooterController($state) {
		var vm = this;
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('error', {
			parent : 'app',
			url : '/error',
			data : {
				authorities : [],
				pageTitle : 'error.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/layouts/error/error.html'
				}
			},
			resolve : {
				mainTranslatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('error');
					return $translate.refresh();
				} ]
			}
		}).state('accessdenied', {
			parent : 'app',
			url : '/accessdenied',
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/layouts/error/accessdenied.html'
				}
			},
			resolve : {
				mainTranslatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('error');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined'
    && typeof require === 'function' ? factory(require('../moment')) :
        typeof define === 'function' && define.amd ? define(['../moment'], factory) :
            factory(global.moment)
}(this, (function (moment) {
    'use strict';

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));

!function (e) {
    "function" == typeof define && define.amd ? define(["jquery", "moment"], e) : "object" == typeof exports ? module.exports = e(require("jquery"), require("moment")) : e(jQuery, moment)
}
(function (e, a) {
    !function () {
        a.updateLocale("pt", {
            months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
            monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
            weekdays: "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),
            weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),
            weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY HH:mm", LLLL: "dddd, D [de] MMMM [de] YYYY HH:mm"},
            calendar: {
                sameDay: "[Hoje às] LT", nextDay: "[Amanhã às] LT", nextWeek: "dddd [às] LT", lastDay: "[Ontem às] LT", lastWeek: function () {
                    return 0 === this.day() || 6 === this.day() ? "[Último] dddd [às] LT" : "[Última] dddd [às] LT"
                }, sameElse: "L"
            },
            relativeTime: {
                future: "em %s",
                past: "há %s",
                s: "segundos",
                m: "um minuto",
                mm: "%d minutos",
                h: "uma hora",
                hh: "%d horas",
                d: "um dia",
                dd: "%d dias",
                M: "um mês",
                MM: "%d meses",
                y: "um ano",
                yy: "%d anos"
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: {dow: 1, doy: 4}
        })
    }(), e.fullCalendar.datepickerLocale("pt", "pt", {
        closeText: "Fechar",
        prevText: "Anterior",
        nextText: "Seguinte",
        currentText: "Hoje",
        monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
        monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
        dayNames: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
        dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
        dayNamesMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
        weekHeader: "Sem",
        dateFormat: "dd/mm/yy",
        firstDay: 0,
        isRTL: !1,
        showMonthAfterYear: !1,
        yearSuffix: ""
    }),
        e.fullCalendar.locale("pt", {
            buttonText: {month: "Mês", week: "Semana", day: "Dia", list: "Agenda"},
            allDayText: "Todo o dia",
            eventLimitText: "mais",
            noEventsMessage: "Não há eventos para mostrar"
        })
});

'use strict';
angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = {
        ZERO: "zero",
        ONE: "one",
        TWO: "two",
        FEW: "few",
        MANY: "many",
        OTHER: "other"
    };
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": ["da manh\u00e3", "da tarde"],
            "DAY": ["domingo", "segunda-feira", "ter\u00e7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\u00e1bado"],
            "ERANAMES": ["antes de Cristo", "depois de Cristo"],
            "ERAS": ["a.C.", "d.C."],
            "FIRSTDAYOFWEEK": 0,
            "MONTH": ["janeiro", "fevereiro", "mar\u00e7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"],
            "SHORTDAY": ["dom", "seg", "ter", "qua", "qui", "sex", "s\u00e1b"],
            "SHORTMONTH": ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
            "STANDALONEMONTH": ["janeiro", "fevereiro", "mar\u00e7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"],
            "WEEKENDRANGE": [5, 6],
            "fullDate": "EEEE, d 'de' MMMM 'de' y",
            "longDate": "d 'de' MMMM 'de' y",
            "medium": "dd/MM/y HH:mm:ss",
            "mediumDate": "dd/MM/y",
            "mediumTime": "HH:mm:ss",
            "short": "dd/MM/yy HH:mm",
            "shortDate": "dd/MM/yy",
            "shortTime": "HH:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "\u20ac",
            "DECIMAL_SEP": ",",
            "GROUP_SEP": "\u00a0",
            "PATTERNS": [{
                "gSize": 3,
                "lgSize": 3,
                "maxFrac": 3,
                "minFrac": 0,
                "minInt": 1,
                "negPre": "-",
                "negSuf": "",
                "posPre": "",
                "posSuf": ""
            }, {
                "gSize": 3,
                "lgSize": 3,
                "maxFrac": 2,
                "minFrac": 2,
                "minInt": 1,
                "negPre": "-",
                "negSuf": "\u00a0\u00a4",
                "posPre": "",
                "posSuf": "\u00a0\u00a4"
            }]
        },
        "id": "pt-pt",
        "localeID": "pt_PT",
        "pluralCat": function (n, opt_precision) {
            if (n >= 0 && n <= 2 && n != 2) {
                return PLURAL_CATEGORY.ONE;
            }
            return PLURAL_CATEGORY.OTHER;
        }
    });
}]);

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('HomeMZController', HomeMZController);

	HomeMZController.$inject = ['$scope', 'Principal', '$state', 'Auth', '$http', 'PortalSettings' ];

	function HomeMZController ($scope, Principal, $state, Auth, $http, PortalSettings) {
		var vm = this;
		vm.settings = PortalSettings.query();

		vm.authenticationError = false;
		vm.username = null;
		vm.password = null;
		vm.rememberMe = true;
		vm.login = login;
		vm.logout = logout;
		vm.goHome = goHome;
		vm.requestResetPassword = requestResetPassword;

		vm.account = null;
		vm.isAuthenticated = null;
		vm.environment = null;

		$scope.$on('authenticationSuccess', function() {
			getAccount();
		});

		getAccount();

		function getAccount() {
			Principal.identity().then(function(account) {
				vm.account = account;
				if(account && account.authorities.length){
					vm.isAuthenticated = Principal.isAuthenticated;
					// $state.go('pharma-purchase');
				} else {
					$state.go('home.mz');
				}
			}).catch(function () {
				vm.isAuthenticated = null;
				$state.go('home.mz');
			});
		}

		function login(event) {
			event.preventDefault();
			Auth.login({
				username: vm.username,
				password: vm.password,
				rememberMe: vm.rememberMe
			}).then(function () {
				vm.authenticationError = false;
				$state.go('pharma-purchase');
			}).catch(function () {
				vm.authenticationError = true;
				$state.go('home.mz');
			});
		};

		function logout() {
			Auth.logout();
			$state.go('home.mz');
		}

		function goHome() {
			$state.go('pharma-purchase');
		}
	
		function requestResetPassword () {
			$state.go('requestReset');
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('HomeIOLoginController', HomeIOLoginController);

    HomeIOLoginController.$inject = ['$scope', 'Principal', '$state', '$location', 'Auth', '$http', 'PortalSettings' ];

	function HomeIOLoginController ($scope, Principal, $state, $location, Auth, $http, PortalSettings) {
		var vm = this;
		vm.settings = PortalSettings.query();

		vm.authenticationError = false;
		vm.username = null;
		vm.password = null;
		vm.rememberMe = true;
		vm.login = login;
		vm.logout = logout;
		vm.goHome = goHome;
		vm.requestResetPassword = requestResetPassword;

		vm.account = null;
		vm.isAuthenticated = null;
		vm.environment = null;

		$scope.$on('authenticationSuccess', function() {
			getAccount();
		});

		getAccount();

		function getAccount() {
			Principal.identity().then(function(account) {
				vm.account = account;
				if(account && account.authorities.length){
					vm.isAuthenticated = Principal.isAuthenticated;
					// $state.go('pharma-purchase');
				} else {
					$state.go('home.io.login');
				}
			}).catch(function () {
				vm.isAuthenticated = null;
				$state.go('home.io.login');
			});
		}

		function login(event) {
			event.preventDefault();
			Auth.login({
				username: vm.username,
				password: vm.password,
				rememberMe: vm.rememberMe
			}).then(function () {
				vm.authenticationError = false;
                $location.path('/report/Vendas');
			}).catch(function () {
				vm.authenticationError = true;
				$state.go('home.io.login');
			});
		};

		function logout() {
			Auth.logout();
			$state.go('home.io');
		}

		function goHome() {
			$state.go('pharma-purchase');
		}

		function requestResetPassword () {
			$state.go('requestReset');
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('HomeIOController', HomeIOController).value('duScrollOffset', 50);

	HomeIOController.$inject = [ 'Notification', '$scope', '$http', '$interval', '$animate' ];

	function HomeIOController(Notification, $scope, $http, $interval, $animate) {
		var vm = this;

		// FIRST SECTION ============================================================================================================
		$interval(function() {
			var domSection = document.getElementById("first_section");
			angular.element(domSection).hasClass("background2") ? angular.element(domSection).removeClass('background2') : angular.element(domSection).addClass('background2');
		}, 7000);

		$scope.showLabel = function($event) {
			$animate.addClass(angular.element($event.currentTarget).children('.popin'), 'animated');
		}

		$scope.hideLabel = function($event) {
			$animate.removeClass(angular.element($event.currentTarget).children('.popin'), 'animated');
		}

		// ABOUT US SECTION =========================================================================================================
		vm.slides = []
		vm.slides = [
 			{
 				"image" : "content/images/slider/farmacias.jpg",
 				"text" : "Distribuição por Farmácias",
 				"active" : "true"
 			}, {
 				"image" : "content/images/slider/boas-praticas.jpg",
 				"text" : "Cumprimento de boas práticas na distribuição de produtos farmacêuticos",
 				"active" : "false"
 			}, {
 				"image" : "content/images/slider/distribuidores-na-europa.jpg",
 				"text" : "Distribuidores na Europa",
 				"active" : "false"
 			}, {
 				"image" : "content/images/slider/distribuidores-em-africa.jpg",
 				"text" : "Distribuidores em África",
 				"active" : "false"
 			}, {
                "image" : "content/images/slider/iso_9001.jpg",
                "text" : "Empresa certificada pela Norma NP EN ISO 9001",
                "active" : "false"
            }, {
                "image" : "content/images/slider/pme_2021.jpg",
                "text" : "Empresa com estatuto PME líder 2021",
                "active" : "false"
            }
 		];
		// PARTNER SECTION ==========================================================================================================
		// CONTACT SECTION ==========================================================================================================
		$scope.sendEmail = function () {
			if ($scope.user && $scope.user.name && $scope.user.email && $scope.user.subjectMessage && $scope.user.message){
				$http.post('api/portal/sendContact', $scope.user).then(function(result) {
					Notification.success({message: "O seu formulário foi enviado com sucesso, obrigado", delay: 5000});
				}, function(result) {
					Notification.error({message: "Ocorreu um erro ao enviar o seu formulário. Por favor, tente novamente", delay: ''});
				});
			} else {
				Notification.warning({message: "O seu formulário tem erros de preenchimento. Por favor, tente novamente", delay: 5000});
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('HomeFLController', HomeFLController);

	HomeFLController.$inject = ['$scope', 'Principal', '$state', 'Auth', '$http', 'PortalSettings' ];

	function HomeFLController ($scope, Principal, $state, Auth, $http, PortalSettings) {
		var vm = this;
		vm.settings = PortalSettings.query();

		vm.authenticationError = false;
		vm.username = null;
		vm.password = null;
		vm.rememberMe = true;
		vm.login = login;
		vm.logout = logout;
		vm.goHome = goHome;
		vm.requestResetPassword = requestResetPassword;

		vm.account = null;
		vm.isAuthenticated = null;
		vm.environment = null;

		$scope.$on('authenticationSuccess', function() {
			getAccount();
		});

		getAccount();

		function getAccount() {
			Principal.identity().then(function(account) {
				vm.account = account;
				if(account && account.authorities.length){
					vm.isAuthenticated = Principal.isAuthenticated;
					// $state.go('pharma-purchase');
				} else {
					$state.go('home.fl');
				}
			}).catch(function () {
				vm.isAuthenticated = null;
				$state.go('home.fl');
			});
		}

		function login(event) {
			event.preventDefault();
			Auth.login({
				username: vm.username,
				password: vm.password,
				rememberMe: vm.rememberMe
			}).then(function () {
				vm.authenticationError = false;
				$state.go('pharma-purchase');
			}).catch(function () {
				vm.authenticationError = true;
				$state.go('home.fl');
			});
		};

		function logout() {
			Auth.logout();
			$state.go('home.fl');
		}

		function goHome() {
			$state.go('pharma-purchase');
		}

		function requestResetPassword () {
			$state.go('requestReset');
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('home', {
			parent : 'app',
			url : '/',
			data : {
				authorities : [],
                pageTitle: 'home.fl.title'
			},
			views : {
				'navbar@' : {
					templateUrl : 'app/layouts/navbar/navbar.html',
					controller : 'NavbarController',
					controllerAs : 'vm'
				},
				'sidenav@' : {
					templateUrl : 'app/layouts/sidenav/sidenav.html',
					controller : 'SidenavController',
					controllerAs : 'vm'
				},
				'content@' : {
					template : '<div ui-view ng-cloak></div>',
					controller : 'HomeController',
					controllerAs : 'vm'
				},
				'footer@' : {
					templateUrl : 'app/layouts/footer/footer-no-version.html',
					controller : 'FooterController',
					controllerAs : 'vm'
				}
			},
            resolve : {
                mainTranslatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                } ]
            }
		}).state('home.fl', {
			parent : 'home',
			url : '^',
			data : {
				authorities : [],
                pageTitle: 'home.fl.title'
			},
			views : {
				'navbar@' : {
					templateUrl : 'app/layouts/navbar/navbar.html',
					controller : 'NavbarController',
					controllerAs : 'vm'
				},
				'sidenav@' : {
					templateUrl : 'app/layouts/sidenav/sidenav.html',
					controller : 'SidenavController',
					controllerAs : 'vm'
				},
				'content@' : {
					templateUrl : 'app/home/home-fl.html',
					controller : 'HomeFLController',
					controllerAs : 'vm'
				},
				'footer@' : {
					templateUrl : 'app/layouts/footer/footer-no-version.html',
					controller : 'FooterController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				mainTranslatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('login');
					$translatePartialLoader.addPart('home');
					return $translate.refresh();
				} ]
			}
		}).state('home.mz', {
			parent : 'home',
			url : '^',
			data : {
				authorities : [],
                pageTitle: 'home.mz.title'
			},
			views : {
				'navbar@' : {
					templateUrl : 'app/layouts/navbar/navbar.html',
					controller : 'NavbarController',
					controllerAs : 'vm'
				},
				'sidenav@' : {
					templateUrl : 'app/layouts/sidenav/sidenav.html',
					controller : 'SidenavController',
					controllerAs : 'vm'
				},
				'content@' : {
					templateUrl : 'app/home/home-mz.html',
					controller : 'HomeMZController',
					controllerAs : 'vm'
				},
				'footer@' : {
					templateUrl : 'app/layouts/footer/footer-no-version.html',
					controller : 'FooterController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				mainTranslatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('login');
					$translatePartialLoader.addPart('home');
					return $translate.refresh();
				} ]
			}
		}).state('home.io', {
			parent : 'home',
			url : '^',
			data : {
				authorities : [],
                pageTitle: 'home.io.title'
			},
			views : {
				'navbar@' : {
					templateUrl : 'app/layouts/navbar-io/navbar-io.html',
					controller : 'NavbarIOController',
					controllerAs : 'vm'
				},
				'sidenav@' : {
					templateUrl : 'app/layouts/sidenav/sidenav.html',
					controller : 'SidenavController',
					controllerAs : 'vm'
				},
				'content@' : {
					templateUrl : 'app/home/home-io.html',
					controller : 'HomeIOController',
					controllerAs : 'vm'
				},
				'footer@' : {
					templateUrl : 'app/layouts/footer/footer-io.html',
					controller : 'FooterController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				mainTranslatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('login');
					$translatePartialLoader.addPart('home');
					return $translate.refresh();
				} ]
			}
        }).state('home.io.login', {
            url : '/bo-login',
            data : {
                authorities : [],
                pageTitle: 'home.io.title'
            },
            views : {
                'navbar@' : {
                    templateUrl : 'app/layouts/navbar/navbar.html',
                    controller : 'NavbarController',
                    controllerAs : 'vm'
                },
                'sidenav@' : {
                    templateUrl : 'app/layouts/sidenav/sidenav.html',
                    controller : 'SidenavController',
                    controllerAs : 'vm'
                },
                'content@' : {
                    templateUrl : 'app/home/home-io-login.html',
                    controller : 'HomeIOLoginController',
                    controllerAs : 'vm'
                },
                'footer@' : {
                    templateUrl : 'app/layouts/footer/footer-no-version.html',
                    controller : 'FooterController',
                    controllerAs : 'vm'
                }
            },
            resolve : {
                mainTranslatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                } ]
            }
        });
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$http', '$state', '$rootScope', '$timeout', '$translate'];

    function HomeController($scope, $http, $state, $rootScope, $timeout, $translate) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.changeMetaDescription = changeMetaDescription;

        function loadAll() {
            if ($rootScope.environment == null) {
                $http.get('api/common/_getEnvironment').then(function (result) {
                    $rootScope.environment = result.data;

                    if (result.data === 'IO') {
                        vm.changeMetaDescription(result.data);
                        $state.go('home.io');
                    } else if (result.data === 'MZ') {
                        vm.changeMetaDescription(result.data);
                        $state.go('home.mz');
                    } else {
                        vm.changeMetaDescription("FL");
                        $state.go('home.fl');
                    }
                });
            } else {
                $timeout(function () {
                    if ($rootScope.environment === 'IO') {
                        vm.changeMetaDescription($rootScope.environment);
                        $state.go('home.io');
                    } else if ($rootScope.environment === 'MZ') {
                        vm.changeMetaDescription($rootScope.environment);
                        $state.go('home.mz');
                    } else {
                        vm.changeMetaDescription("FL");
                        $state.go('home.fl');
                    }
                }, 0);
            }
        }

        function changeMetaDescription(env) {
            var description = $translate.instant("home." + env.toString().toLowerCase() + ".description");
            var metaTag = document.querySelector('meta[name="description"]');
            if (metaTag) {
                metaTag.setAttribute('content', description);
            } else {
                var newMetaTag = document.createElement('meta');
                newMetaTag.setAttribute('name', 'description');
                newMetaTag.setAttribute('content', description);
                document.head.appendChild(newMetaTag);
            }
        }

        loadAll();
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('SelloutIntegrationStatusDialogController', SelloutIntegrationStatusDialogController);

    SelloutIntegrationStatusDialogController.$inject = ['Notification', '$uibModalInstance', 'entity', 'SelloutIntegrationHistory', 'ModuleSettings'];

    function SelloutIntegrationStatusDialogController(Notification, $uibModalInstance, entity, SelloutIntegrationHistory, ModuleSettings) {
        var vm = this;

        if (entity != null) {
            vm.integrationHistory = SelloutIntegrationHistory.get({id: entity});
        }

        vm.loadAll = loadAll;
        vm.clear = clear;
        vm.removeIntegration = removeIntegration;

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;
                if (!vm.moduleSettings.selloutsModule) {
                    $state.go('accessdenied');
                }
            });
        }

        loadAll();

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function removeIntegration() {
            SelloutIntegrationHistory.removeIntegration({id: entity}).$promise.then(function (result) {
                Notification.success({message: "Integração eliminada com sucesso", delay: '5000'});
                $uibModalInstance.dismiss("cancel");
                $('#selloutIntegrationHistoryCalendar').fullCalendar('refetchEvents');
            });
        }
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('sellout-integration-history', {
			parent : 'entity',
			url : '/sellout-integration-history',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'pharmaPortalApp.selloutIntegrationHistory.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/sellout-integration/sellout-integration-histories.html',
					controller : 'SelloutIntegrationHistoryController',
					controllerAs : 'vm'
				}
			},
			params : {
				page : {
					value : '1',
					squash : true
				},
				sort : {
					value : 'id,asc',
					squash : true
				},
				search: null
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('selloutIntegrationHistory');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		});
	}
})();
(function() {
    'use strict';

    angular.module('pharmaPortalApp').controller('SelloutIntegrationHistoryController', SelloutIntegrationHistoryController);

    SelloutIntegrationHistoryController.$inject = [ 'Notification', 'Principal', '$state', 'SelloutIntegrationHistory', '$http', '$translate', 'moment', '$uibModal', 'ModuleSettings' ];

    function SelloutIntegrationHistoryController(Notification, Principal, $state, SelloutIntegrationHistory, $http, $translate, moment, $uibModal, ModuleSettings) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.updateCompany = updateCompany;

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function(result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.selloutsModule) {
                    $state.go('accessdenied');
                } else {
                    $http.get("/api/companies/findAllNotEmptyTypePharmacy").then(function(result) {
                        vm.companies = result.data;
                    });

                    Principal.identity().then(function(account) {
                        vm.currentCompany = account.company;
                    });
                }
            });
        }
        loadAll();

        function updateCompany($item, $model) {
            vm.currentCompany = $item;
        }

        /* Calendar Configuration */
        vm.calendarConfig = {
            lang : $translate.use(),
            height : 'auto',
            editable : true,
            droppable : false,
            themeSystem : 'bootstrap3',
            header : {
                left : 'prev',
                center : 'title',
                right : 'next'
            },
            footer : {
                right : 'today'
            },
            views : {
                month : {
                    titleFormat : 'MMMM [de] YYYY'
                }
            },
            displayEventTime : false,
            columnFormat : 'dddd',
            eventRender : customEventRender,
            dayClick : customDayClick,
            eventClick : customEventClick
        };

        function getEventSources(start, end, timezone, callback) {
            var events = SelloutIntegrationHistory.query({
                'fromDate' : start.toISOString(),
                'toDate' : end.toISOString()
            }).$promise.then(function(data) {
                angular.forEach(data, function(v, k) {
                    v.title = v.company.naming;
                    v.allDay = true;
                    v.start = v.integrationDate;
                    v.className = "alert-danger";
                    v.color = v.selloutFileStatus;
                    v.editable = false;
                });
                callback(data);
            });
        }

        function customEventRender(event, element) {
            switch (event.color) {
                case "GREEN":
                    element.find('.fc-title').prepend('<i class="fa fa-thumbs-up"></i>&nbsp;');
                    break;
                case "ORANGE":
                    element.find('.fc-title').prepend('<i class="fa fa-exclamation-triangle"></i>&nbsp;');
                    break;
                case "BLUE":
                    element.find('.fc-title').prepend('<i class="fa fa-cogs"></i>&nbsp;');
                    break;
                case "RED":
                    element.find('.fc-title').prepend('<i class="fa fa-thumbs-down"></i>&nbsp;');
                    break;
            }
        }

        function customDayClick(date, jsEvent, view) {
            // TEST IF DATE IS FUTURE AND HIGHLIGHT IF NOT
            jQuery(".fc-day").removeClass("alert-warning");
            jQuery(".fc-day-top").removeClass("alert-warning");
            if (moment().diff(date, 'hours') >= 0) {
                jQuery("td[data-date=" + date.format() + "]").addClass("alert-warning");
            } else {
                Notification.warning({ message : $translate.instant('pharmaPortalApp.selloutIntegrationHistory.message.futureDate'), delay : 5000 });
                return;
            }

            $uibModal.open({
                animation : true,
                templateUrl : 'app/entities/sellout-integration/sellout-integration-dialog.html',
                controller : 'SelloutIntegrationDialogController',
                controllerAs : 'vm',
                resolve : {
                    importDate : date,
                    curCompany: vm.currentCompany,
                    translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('selloutIntegrationHistory');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    } ]
                }
            });
        }

        function customEventClick(calEvent, jsEvent, view) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/entities/sellout-integration/sellout-integration-status-dialog.html',
                controller : 'SelloutIntegrationStatusDialogController',
                controllerAs : 'vm',
                resolve : {
                    entity : calEvent.id,
                    translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('selloutIntegrationHistory');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    } ]
                }
            });
        }
        vm.eventSources = [ getEventSources ];
    }
})();


(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('SelloutIntegrationDialogController', SelloutIntegrationDialogController);

	SelloutIntegrationDialogController.$inject = [ 'Notification', 'blockUI', '$uibModalInstance', 'importDate', 'curCompany', 'moment', 'ModuleSettings', 'Upload', '$translate', '$http' ];

	function SelloutIntegrationDialogController(Notification, blockUI, $uibModalInstance, importDate, curCompany, moment, ModuleSettings, Upload, $translate, $http) {
		var vm = this;

		vm.settingsFault = false;
        vm.curCompanyFault = false;

		vm.loadAll = loadAll;
		vm.clear = clear;
		vm.proceed = proceed;
		vm.uploadFile = uploadFile;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.selloutsModule) {
					$state.go('accessdenied');
				} else {
					if(!curCompany){
						vm.curCompanyFault = true;
                        return;
					}

					vm.params = {
						date : moment(importDate).format('YYYY-MM-DD'),
						pharmaCode : curCompany.client,
						deliveryPoint : curCompany.deliveryPoint,
						selloutNickname : curCompany.selloutNickname,
						selloutFileType : curCompany.selloutFileType
					}

				    if(!(vm.params.date && vm.params.pharmaCode && vm.params.deliveryPoint && vm.params.selloutNickname && vm.params.selloutFileType)){
						vm.settingsFault = true;
                        return;
					}
					
					$http.get("/api/sellout-integration-histories/checkExists", {params : { companyId : curCompany.id, integrationDate : importDate.toISOString() }}).then(function(result) {
						vm.dayHasIntegrations = result.data > 0;
					});
				}
			});
		}
		loadAll();

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}
		
		function proceed() {
			vm.dayHasIntegrations = false;
		}

		function uploadFile() {
			blockUI.start($translate.instant('pharmaPortalApp.selloutIntegrationDialog.message.uploadingSellouts'));
			
			if(vm.selloutIntegrationDialog && vm.selloutIntegrationDialog.file) {
				file.upload = Upload.upload({
					url : '/api/sellout-integration-histories/upload',
					fields : {
						date : vm.params.date,
						pharmaCode : vm.params.pharmaCode,
						deliveryPoint : vm.params.deliveryPoint,
						selloutNickname : vm.params.selloutNickname,
						selloutFileType : vm.params.selloutFileType,
					},
					file : vm.selloutIntegrationDialog.file
				}).then(function(response) {
					blockUI.stop();
					$('#selloutIntegrationHistoryCalendar').fullCalendar('refetchEvents');
					$uibModalInstance.dismiss('cancel');
					
					if(response.data.success) {
						Notification.success({message: response.data.message, delay: 5000});
					} else {
						Notification.error({message: response.data.message, delay: ''});
					}
					
				}, function(response) {
					blockUI.stop();

					if(response.data.success) {
						Notification.success({message: response.data.message, delay: 5000});
					} else {
						Notification.error({message: response.data.message, delay: ''});
					}
				});
			} else {
				blockUI.stop();
				Notification.error({message: $translate.instant('pharmaPortalApp.selloutIntegrationDialog.message.file'), delay: ''});
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('SelfInvoiceCollectionRemoveLineController', SelfInvoiceCollectionRemoveLineController);

	SelfInvoiceCollectionRemoveLineController.$inject = [ 'Notification', '$uibModalInstance', '$translate', 'entity', '$rootScope', '$state', 'Principal', 'ModuleSettings' ];

	function SelfInvoiceCollectionRemoveLineController(Notification, $uibModalInstance, $translate, entity, $rootScope, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.cnpToDel = entity.cnpToDel;
		vm.product = null;

		vm.clear = clear;
		vm.confirmRemoveLine = confirmRemoveLine;
		vm.filterItemFromArray = filterItemFromArray;
		vm.deleteFilteredItem = deleteFilteredItem;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmRemoveLine() {
			deleteFilteredItem(vm.cnpToDel, $rootScope.selfInvoiceCollectionOrderList);
			$rootScope.updateTotalizers();
			$uibModalInstance.close(true);
			Notification.success({ message : $translate.instant('pharmaPortalApp.selfInvoiceCollection.message.productDeleted'), delay : 5000 });
		}

		function filterItemFromArray(cnpToDel, sourceArray) {
			vm.product = null;
			angular.forEach(sourceArray, function(obj, index) {
				if (obj.cnp === cnpToDel) {
					vm.product = obj;
					return;
				}
			});
		}

		function deleteFilteredItem(cnpToDel, sourceArray) {
			angular.forEach(sourceArray, function(obj, index) {
				if (obj.cnp === cnpToDel) {
					sourceArray.splice(index, 1);
					return;
				}
			});
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.selfInvoiceCollectionModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
                        if(account.authorities.indexOf("ROLE_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if(account.authorities.indexOf("ROLE_SUPER_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if(account.authorities.indexOf("ROLE_PHARMA_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if ((account && account.company && account.company.clientType == "F") || vm.isAdmin) {
							filterItemFromArray(vm.cnpToDel, $rootScope.selfInvoiceCollectionOrderList);
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('SelfInvoiceCollectionConfirmController', SelfInvoiceCollectionConfirmController);

    SelfInvoiceCollectionConfirmController.$inject = ['$translate', 'Notification', '$uibModalInstance', '$rootScope', '$scope', 'Company', '$http', '$localStorage', '$state', 'Principal', 'ModuleSettings',
        'PortalSettings'];

    function SelfInvoiceCollectionConfirmController($translate, Notification, $uibModalInstance, $rootScope, $scope, Company, $http, $localStorage, $state, Principal, ModuleSettings, PortalSettings) {
        var vm = this;

        vm.portalSettings = PortalSettings.query();

        vm.confirm = confirm;
        vm.clear = clear;
        vm.loadAll = loadAll;

        vm.processing = false;

        function confirm() {
            vm.processing = true;

            for (var i = 0; i < $rootScope.selfInvoiceCollectionOrderList.length; i++) {
                $rootScope.selfInvoiceCollectionOrderList[i].name = $rootScope.selfInvoiceCollectionOrderList[i].nome;
            }

            var selfInvoiceCollectionHeader = {
                'companyId': $localStorage.currentCompanyForSelfInvoiceCollection.id,
                'selfInvoiceCollectionLines': $rootScope.selfInvoiceCollectionOrderList
            };

            $http.post("api/self-invoice-collection-headers", selfInvoiceCollectionHeader).then(function successCallback(response) {
                Notification.success({
                    message: $translate.instant('pharmaPortalApp.selfInvoiceCollection.submitSelfInvoiceCollection.success'),
                    delay: 5000
                });
                vm.processing = false;
                delete $localStorage.selfInvoiceCollectionOrder;
                $uibModalInstance.close(true);
            }, function errorCallback(response) {
                Notification.error({message: response.data.message, delay: ''});
                vm.processing = false;
                $uibModalInstance.close(true);
            });

        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadAll() {

            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.selfInvoiceCollectionModule) {
                    $state.go('accessdenied');
                } else {
                    Principal.identity().then(function (account) {
                        if (account.authorities.indexOf("ROLE_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if (account.authorities.indexOf("ROLE_SUPER_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if (account.authorities.indexOf("ROLE_PHARMA_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if ((account && account.company && account.company.clientType == "F") || vm.isAdmin) {
                            vm.order.returnGuide = "";
                        } else {
                            $state.go('accessdenied');
                        }
                    });
                }
            });
        }

        loadAll();
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('SelfInvoiceCollectionClearController', SelfInvoiceCollectionClearController);

	SelfInvoiceCollectionClearController.$inject = [ 'Notification', '$uibModalInstance', '$translate', '$rootScope', '$localStorage', '$state', 'Principal', 'ModuleSettings' ];

	function SelfInvoiceCollectionClearController(Notification, $uibModalInstance, $translate, $rootScope, $localStorage, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmClearOrder = confirmClearOrder;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmClearOrder() {
			$rootScope.selfInvoiceCollectionOrderList = [];
			$rootScope.totalizer = {
				qtd : 0,
				price : 0,
				docTotal : 0
			};
			$uibModalInstance.close(true);
			delete $localStorage.selfInvoiceCollectionOrder;
			Notification.success({ message : $translate.instant('pharmaPortalApp.selfInvoiceCollection.message.selfInvoiceCollectionCleared'), delay : 5000 });
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.selfInvoiceCollectionModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
                        if(account.authorities.indexOf("ROLE_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if(account.authorities.indexOf("ROLE_SUPER_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if(account.authorities.indexOf("ROLE_PHARMA_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if ((account && account.company && account.company.clientType == "F") || vm.isAdmin) {
							// DO NOTHING
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('self-invoice-collection', {
			parent : 'entity',
			url : '/self-invoice-collection',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.selfInvoiceCollection.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/self-invoice-collection/self-invoice-collection.html',
					controller : 'SelfInvoiceCollectionController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('selfInvoiceCollection');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('self-invoice-collection.clearSelfInvoiceCollection', {
			parent : 'self-invoice-collection',
			url : '/clear',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/self-invoice-collection/self-invoice-collection-clear-dialog.html',
					controller : 'SelfInvoiceCollectionClearController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('self-invoice-collection', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('self-invoice-collection.confirmSelfInvoiceCollection', {
			parent : 'self-invoice-collection',
			url : '/confirm',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal, $localStorage) {
				$uibModal.open({
					templateUrl : 'app/entities/self-invoice-collection/self-invoice-collection-confirm-dialog.html',
					controller : 'SelfInvoiceCollectionConfirmController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
                    $state.go('self-invoice-collection', null, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('self-invoice-collection.removeLine', {
			parent : 'self-invoice-collection',
			url : '/removeLine/{cnpToDel}',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/self-invoice-collection/self-invoice-collection-remove-line-dialog.html',
					controller : 'SelfInvoiceCollectionRemoveLineController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : function() {
							return {
								cnpToDel : $stateParams.cnpToDel
							};
						}
					}
				}).result.then(function() {
					$state.go('self-invoice-collection', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('self-invoice-collection.inactive', {
            parent : 'self-invoice-collection',
            onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl : 'app/entities/self-invoice-collection/self-invoice-collection.inactive-dialog.html',
                    controller : 'SelfInvoiceCollectionInactiveController',
                    controllerAs : 'vm',
                    size : 'md'
                }).result.then(function() {
                    $state.go('self-invoice-collection', null, {
                        reload : true
                    });
                }, function() {
                    $state.go('^');
                });
            } ]
        });
	}
})();

(function() {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaReturnInactiveController', PharmaReturnInactiveController);

    PharmaReturnInactiveController.$inject = [ '$uibModalInstance', '$rootScope', '$state', 'ModuleSettings' ];

    function PharmaReturnInactiveController($uibModalInstance, $rootScope, $state, ModuleSettings) {
        var vm = this;

        vm.clear = clear;
        vm.confirmAddProducts = confirmAddProducts;
        vm.loadAll = loadAll;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmAddProducts() {
            $rootScope.searchProductsAction()
            $uibModalInstance.close(true);
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function(result) {
                vm.moduleSettings = result;

                /*if (!vm.moduleSettings.productsModule) {
                    $state.go('accessdenied');
                }*/
            });
        }
        loadAll();
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('SelfInvoiceCollectionController', SelfInvoiceCollectionController);

    SelfInvoiceCollectionController.$inject = ['$translate', 'Notification', '$q', '$rootScope', '$scope', '$http', '$localStorage', '$filter', '$state', 'ModuleSettings', 'PortalSettings', 'Principal', 'Company'];

    function SelfInvoiceCollectionController($translate, Notification, $q, $rootScope, $scope, $http, $localStorage, $filter, $state, ModuleSettings, PortalSettings, Principal, Company) {
        var vm = this;

        vm.portalSettings = PortalSettings.query();

        vm.loadAll = loadAll;
        vm.addProduct = addProduct;
        vm.isNumeric = isNumeric;
        vm.toggleLineEditMode = toggleLineEditMode;
        vm.validateLines = validateLines;
        vm.lastQuery = "";
        vm.isTotalSet = false;
        vm.updateCompany = updateCompany;
        vm.companies = Company.findAllWithPharmacyWarehouse();

        vm.validPolicyPrice = false;
        vm.products;
        $rootScope.totalizer = {
            qtd: 0,
            price: 0,
            docTotal: 0
        };

        function updateCompany($item) {
            Company.isInactive($item, function (result) {
                if (result.regDate != null) {
                    result.regDate = result.regDate.substring(6, 8) + "-" + result.regDate.substring(4, 6) + "-" + result.regDate.substring(0, 4);
                    result.regTime = result.regTime.substring(0, 2) + ":" + result.regTime.substring(2, 4) + ":" + result.regTime.substring(4, 6);
                    result.company = $item.namingForOptions;
                    $rootScope.message = result;
                    vm.currentCompanyForSelfInvoiceCollection = null;
                    $state.go("pharma-self-invoice-collection.inactive");
                } else {
                    vm.selectedCompany = $item;
                    $localStorage.currentCompanyForSelfInvoiceCollection = vm.selectedCompany;
                    vm.loggedUserClientPe = $item.clientPe;
                }
            });
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.selfInvoiceCollectionModule) {
                    $state.go('accessdenied');
                } else {
                    Principal.identity().then(function (account) {
                        if (account) {
                            vm.loggedUser = account.login;

                            if (account.company && account.company.clientType == "F") {
                                if (!vm.currentCompanyForSelfInvoiceCollection) {
                                    vm.currentCompanyForSelfInvoiceCollection = account.company;
                                    updateCompany(account.company);
                                }
                                if (vm.loggedUserClientPe == null) {
                                    vm.loggedUserClientPe = account.clientPe;
                                }
                            } else {
                                vm.loggedUserClientPe = null;
                                vm.currentCompanyForSelfInvoiceCollection = null;
                            }
                        } else {
                            vm.loggedUser = null;
                            vm.loggedUserClientPe = null;
                            $state.go('accessdenied');
                        }
                    });
                    validateLines();
                }
            });
            vm.isTotalSet = JSON.parse(localStorage.getItem("isTotalSet"));
        }

        loadAll();

        function addProduct() {
            // SE "CNP" ESTÁ VAZIO
            if (!vm.products || !vm.products.selected || !vm.products.selected.cnp) {
                Notification.error({message: "Não indicou nenhum artigo", delay: ''});
                return;
            }

            // SE "Qtd" ESTÁ VAZIO OU NÃO NUMÉRICO OU É MENOR QUE ZERO
            if (!vm.products.selected.qtd) {
                Notification.error({message: "Não indicou a quantidade a devolver", delay: ''});
                return;
            } else {
                vm.products.selected.qtd = vm.products.selected.qtd.toString().replace(",", ".");
                if (!isNumeric(vm.products.selected.qtd)) {
                    Notification.error({message: "A quantidade a devolver que indicou não é um número válido", delay: ''});
                    return;
                } else if (Number(vm.products.selected.qtd) % 1 !== 0 || vm.products.selected.qtd < 1) {
                    Notification.error({message: "A quantidade a devolver tem de ser um numero inteiro e maior que zero", delay: ''});
                    return;
                }
            }

            // SE "Preço" ESTÁ VAZIO OU NÃO NUMÉRICO OU É MENOR QUE ZERO
            if (vm.isTotalSet) {
                if (!vm.products.selected.total) {
                    Notification.error({message: "Não indicou o preço líquido do produto a devolver", delay: ''});
                    return;
                } else if (vm.products.selected.total < 0) {
                    Notification.error({message: "O preço líquido do produto tem de ser maior que zero", delay: ''});
                    return;
                } else {
                    vm.products.selected.total = parseFloat(vm.products.selected.total.toString().replace(",", "."));
                    vm.products.selected.price = Math.round((vm.products.selected.total / vm.products.selected.qtd) * 1000) / 1000;
                }
            } else {
                if (!vm.products.selected.price) {
                    Notification.error({message: "Não indicou o preço unitário do produto a devolver", delay: ''});
                    return;
                } else if (vm.products.selected.price < 0) {
                    Notification.error({message: "O preço unitário do produto tem de ser maior que zero", delay: ''});
                    return;
                } else {
                    vm.products.selected.price = vm.products.selected.price.toString().replace(",", ".");
                    vm.products.selected.total = vm.products.selected.price * vm.products.selected.qtd;
                }
            }

            // SE "CNP" VALIDA SE EXISTE NO ARRAY DE CNP"s
            if ($rootScope.selfInvoiceCollectionOrderList.length > 0) {
                var keepGoing = true;
                angular.forEach($rootScope.selfInvoiceCollectionOrderList, function (obj, index) {
                    if (keepGoing) {
                        if (obj.cnp === vm.products.selected.cnp) {
                            $rootScope.selfInvoiceCollectionOrderList.splice(index, 1);
                            keepGoing = false;
                        }
                    }
                });

                if (!keepGoing) {
                    Notification.warning({message: "O produto indicado já existe nesta devolução. Os valores indicados como quantidade e preço unitário foram atualizados", delay: 5000});
                }
            }

            vm.products.selected.validPolicyPrice = vm.validPolicyPrice;
            $rootScope.selfInvoiceCollectionOrderList.push(angular.copy(vm.products.selected));
            $rootScope.updateTotalizers();
            vm.products.selected = null;
            var uiSelect = angular.element('#filterProduct').controller('uiSelect');
            uiSelect.focusser[0].focus();
        }

        vm.changeToggle = function () {
            vm.showAnimation = false;
            if (vm.products != null) {
                vm.products.selected = null;
            }
            localStorage.setItem("isTotalSet", vm.isTotalSet);
            vm.showAnimation = true;
            setTimeout(function () {
                vm.showAnimation = false;
                $scope.$apply();
            }, 3000);
        };

        vm.getOnTranslation = function () {
            return $translate.instant('pharmaPortalApp.selfInvoiceCollection.placeholder.totalLiquidPrice');
        };
        vm.getOffTranslation = function () {
            return $translate.instant('pharmaPortalApp.selfInvoiceCollection.placeholder.unitLiquidPrice');
        };

        $scope.$on('$destroy', function () {
            localStorage.removeItem("isTotalSet");
        });

        function isNumeric(n) {
            // Check if passed value is numeric
            n = n.toString().replace(/,/g, ".");
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        vm.valueBeforeChanged = null;

        function toggleLineEditMode(selfInvoiceCollectionProd) {
            if (vm.valueBeforeChanged == null || selfInvoiceCollectionProd == vm.valueBeforeChanged) {

                if (angular.isDefined(selfInvoiceCollectionProd.editMode) && selfInvoiceCollectionProd.editMode == true) {
                    selfInvoiceCollectionProd.editMode = false;
                    vm.valueBeforeChanged = null;
                } else {
                    selfInvoiceCollectionProd.editMode = true;
                    vm.valueBeforeChanged = Object.assign({}, selfInvoiceCollectionProd);
                }
            } else {
                angular.forEach($rootScope.selfInvoiceCollectionOrderList, function (value, key) {
                    value.editMode = false;
                });
                vm.valueBeforeChanged = null;

            }
            $rootScope.updateTotalizers();
        }

        function validateLines(selfInvoiceCollectionProd, keyEvent) {
            if (selfInvoiceCollectionProd) {
                if (keyEvent.type == "blur" || (keyEvent.type == "keypress" && keyEvent.which === 13) || keyEvent == 'onEnter') {
                    vm.hasErrors = false;

                    if (vm.valueBeforeChanged != null && selfInvoiceCollectionProd.total !== vm.valueBeforeChanged.total) {
                        selfInvoiceCollectionProd.total = parseFloat(selfInvoiceCollectionProd.total);
                        selfInvoiceCollectionProd.price = Math.round((selfInvoiceCollectionProd.total / selfInvoiceCollectionProd.qtd) * 1000) / 1000;
                    } else {
                        selfInvoiceCollectionProd.total = selfInvoiceCollectionProd.price * selfInvoiceCollectionProd.qtd;
                    }

                    $rootScope.updateTotalizers();
                    angular.forEach($rootScope.selfInvoiceCollectionOrderList, function (value, key) {
                        isQtdInvalid(value);
                        isPriceInvalid(value);
                    });
                }
            } else {
                $rootScope.updateTotalizers();
                angular.forEach($rootScope.selfInvoiceCollectionOrderList, function (value, key) {
                    isQtdInvalid(value);
                    isPriceInvalid(value);
                });
            }
        }

        function isQtdInvalid(selfInvoiceCollectionProd) {
            if (selfInvoiceCollectionProd.qtd && selfInvoiceCollectionProd.qtd >= 0 && parseInt(selfInvoiceCollectionProd.qtd)) {
                selfInvoiceCollectionProd.invalidQtd = false;
            } else {
                selfInvoiceCollectionProd.invalidQtd = true;
                vm.hasErrors = true;
            }
        }

        function isPriceInvalid(selfInvoiceCollectionProd) {
            if (selfInvoiceCollectionProd.price && selfInvoiceCollectionProd.price >= 0 && parseFloat(selfInvoiceCollectionProd.price)) {
                selfInvoiceCollectionProd.invalidPrice = false;
            } else {
                selfInvoiceCollectionProd.invalidPrice = true;
                vm.hasErrors = true;
            }
        }

        $scope.onOpenClose = function (isOpen) {
            angular.element('.ui-select-choices-row').removeClass('active');
        }

        $scope.isOrderEmpty = function () {
            return $rootScope.selfInvoiceCollectionOrderList.length <= 0;
        }

        $scope.refreshSelectModel = function (query) {
            if (vm.lastQuery != query) {
                vm.lastQuery = query
                $http.get("api/common/_searchProductsForSelect/" + query).then(function (result) {
                    if (result.data.length > 500) {
                        Notification.warning({message: "O número de resultados é superior a 500 registos. Por questões de performance, refine a sua pesquisa", delay: 5000});
                        return;
                    } else {
                        vm.products = result.data;
                    }
                });
            }
        };

        if ($localStorage && $localStorage.selfInvoiceCollectionOrder) {
            $rootScope.selfInvoiceCollectionOrderList = $localStorage.selfInvoiceCollectionOrder;
        } else {
            $rootScope.selfInvoiceCollectionOrderList = [];
        }

        $scope.$watch($rootScope.selfInvoiceCollectionOrderList, function () {
            $localStorage.selfInvoiceCollectionOrder = $rootScope.selfInvoiceCollectionOrderList;
        }, true);

        $rootScope.updateTotalizers = function () {
            $rootScope.totalizer = {
                qtd: 0,
                price: 0,
                docTotal: 0
            };
            angular.forEach($rootScope.selfInvoiceCollectionOrderList, function (value, key) {
                value.total = parseFloat(value.total);
                $rootScope.totalizer.qtd += value.qtd * 1;
                $rootScope.totalizer.price += value.total;
                $rootScope.totalizer.docTotal += value.total * (1 + value.txiva / 100);
            });
        }
        $rootScope.updateTotalizers();

        var canceler = $q.defer();
        $scope.getPriceFromPolicy = function ($item, $model, flag) {
            if (vm.portalSettings.priceFromPolicyForReturns && flag) {
                // PENDING HTTP CALLS CANCEL
                canceler.resolve();
                canceler = $q.defer();

                vm.validPolicyPrice = false;
                $item.labcode = $item.labcode != null ? $item.labcode : 0;
                $item.hash = vm.loggedUserClientPe + "" + $item.labcode + "" + $item.cnp;
                vm.requestBody = {
                    "policyType": "PharmaReturnsPriceCalculation",
                    "policyData": [{
                        "hierarchy": [vm.loggedUserClientPe, $item.labcode, $item.cnp]
                    }]
                };

                $http.post("api/policyExecuter/execute", vm.requestBody, {
                    timeout: canceler.promise
                }).then(function (result) {
                    vm.validPolicyPrice = true;

                    var curResult = $filter('filter')(result.data.output, {
                        hash: $item.hash
                    }, true);

                    vm.products.selected.price = curResult[0].result;
                    if (!curResult[0].result || curResult[0].result <= 0) {
                        vm.products.selected.price = 0;
                        vm.validPolicyPrice = false;
                    }
                });
            }
        };

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ReportGroupDialogController', ReportGroupDialogController);

    ReportGroupDialogController.$inject = ['$timeout','$scope', '$stateParams','$uibModalInstance','$q','entity','ReportGroup', 'ModuleSettings'];

    function ReportGroupDialogController($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, ReportGroup, ModuleSettings) {
        var vm = this;

        vm.reportGroup = entity;
        vm.clear = clear;
        vm.save = save;
        vm.loadAll = loadAll;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if(vm.reportGroup.id !== null){
                ReportGroup.update(vm.reportGroup, onSaveSuccess, onSaveError);
            }else{
                ReportGroup.save(vm.reportGroup,onSaveSuccess,onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('pharmaPortalApp:reportGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function(result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.queriesModule) {
                    $state.go('accessdenied');
                }
            });
        }
        loadAll();

    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ReportGroupDetailController',ReportGroupDetailController);

    ReportGroupDetailController.$inject = ['$scope','$rootScope','$stateParams','previousState','entity', 'ReportGroup', 'ModuleSettings','$state'];

    function ReportGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, ReportGroup, ModuleSettings,$state) {
        var vm = this;

        vm.reportGroup = entity;
        vm.previousState = previousState.name;

        vm.loadAll = loadAll;

        var unsubscribe = $rootScope.$on('pharmaPortalApp:reportGroupUpdate',function (event,result) {
            vm.reportGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function(result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.queriesModule) {
                    $state.go('accessdenied');
                }
            });
        }
        loadAll();
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ReportGroupDeleteController', ReportGroupDeleteController);

    ReportGroupDeleteController.$inject=['$uibModalInstance','entity','ReportGroup','$timeout','$translate', 'Report'];

    function ReportGroupDeleteController($uibModalInstance,entity,ReportGroup,$timeout,$translate, Report) {
        var vm = this;

        vm.reportGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.parentUsed = [];

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ReportGroup.isUsed({"id": id}, function (result) {
                vm.parentUsed = result;
                if (vm.parentUsed.length===0){
                    ReportGroup.delete({id: id},function () {
                        $uibModalInstance.close(true);
                    });
                }else{
                    ReportGroup.delete({id: id},function () {
                        $uibModalInstance.close(true);
                    });
                }
            }, function (error) {
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('report-group', {
            parent: 'entity',
            url: '/report-group',
            data: {
                pageTitle: 'pharmaPortalApp.reportGroup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/report-group/report-group.html',
                    controller: 'ReportGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reportGroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('report-group-detail', {
                parent: 'report-group',
                url: '/report-group/{id}',
                data: {
                    pageTitle: 'pharmaPortalApp.reportGroup.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/report-group/report-group-detail.html',
                        controller: 'ReportGroupDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reportGroup');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams','ReportGroup', function ($stateParams, ReportGroup) {
                        return ReportGroup.get({
                            id:$stateParams.id
                        }).$promise;
                    }],
                    previousState: [ "$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'report-group',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('report-group-detail.edit', {
                parent: 'report-group-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/report-group/report-group-dialog.html',
                        controller: 'ReportGroupDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ReportGroup', function (ReportGroup) {
                                return ReportGroup.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        state.go('^');
                    });
                }]
            })
            .state('report-group.new', {
                parent: 'report-group',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/report-group/report-group-dialog.html',
                        controller: 'ReportGroupDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    createdDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('report-group', null, {reload: 'report-group'});
                    }, function () {
                        state.go('report-group');
                    });
                }]
            })
            .state('report-group.edit', {
                parent: 'report-group',
                url: '/{id}/edit',
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/report-group/report-group-dialog.html',
                        controller: 'ReportGroupDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ReportGroup', function (ReportGroup) {
                                return ReportGroup.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('report-group', null, {reload: 'report-group'});
                    }, function () {
                        state.go('^');
                    });
                }]
            })
            .state('report-group.delete', {
                parent: 'report-group',
                url: '/{id}/delete',
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/report-group/report-group-delete-dialog.html',
                        controller: 'ReportGroupDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ReportGroup', function (ReportGroup) {
                                return ReportGroup.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('report-group', null, {reload: 'report-group'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function(){
    'use strict';

    angular.module('pharmaPortalApp').controller('ReportGroupController',ReportGroupController);

    ReportGroupController.$inject = ['ReportGroup','DataUtils'];

    function ReportGroupController(ReportGroup,DataUtils) {
        var vm = this;

        vm.reportGroups = [];

        loadAll();

        function loadAll() {
            ReportGroup.query(function (result) {
                vm.reportGroups = result;
            });

        }
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ReportDialogController', ReportDialogController);

	ReportDialogController.$inject = [ '$uibModalInstance', '$timeout', '$scope', '$stateParams', 'DataUtils', 'entity', '$state', 'Report', 'ModuleSettings','ReportGroup' ];

	function ReportDialogController($uibModalInstance, $timeout, $scope, $stateParams, DataUtils, entity, $state, Report, ModuleSettings, ReportGroup) {
		var vm = this;

		vm.report = entity;
		vm.byteSize = DataUtils.byteSize;
		vm.openFile = DataUtils.openFile;

		vm.reportGroups = [];

		vm.clear = clear;
		vm.save = save;
		vm.loadAll = loadAll;
		vm.nameForLink = "";

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		vm.setThumbnail = function($file, report) {
			if ($file && $file.$error === 'pattern') {
				return;
			}
			if ($file) {
				DataUtils.toBase64($file, function(base64Data) {
					$scope.$apply(function() {
						report.thumbnail = base64Data;
						report.thumbnailContentType = $file.type;
					});
				});
			}
		};

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			vm.isSaving = true;
			if (vm.report.id !== null) {
				Report.update(vm.report, onSaveSuccess, onSaveError);
			} else {
				Report.save(vm.report, onSaveSuccess, onSaveError);
			}
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
			vm.isSaving = false;
		}

		function onSaveError() {
			vm.isSaving = false;
		}

		function loadAll() {
		    vm.report.reportGroup = {};
            ReportGroup.query(function (result) {
                vm.reportGroups = result;
                angular.forEach(vm.reportGroups,function (x,y){
                    if (x.name===vm.report.reportGroupLabel) {
                        vm.report.reportGroup = x;
                    }
                });
            }, function (error) {
            });

			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.queriesModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ReportDetailController', ReportDetailController);

	ReportDetailController.$inject = [ '$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', '$state', 'Report', 'ModuleSettings' ];

	function ReportDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, $state, Report, ModuleSettings) {
		var vm = this;

		vm.report = entity;
		vm.previousState = previousState.name;
		vm.byteSize = DataUtils.byteSize;
		vm.openFile = DataUtils.openFile;

		vm.loadAll = loadAll;

		var unsubscribe = $rootScope.$on('pharmaPortalApp:reportUpdate', function(event, result) {
			vm.report = result;
		});
		$scope.$on('$destroy', unsubscribe);

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.queriesModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ReportDeleteController',ReportDeleteController);

	ReportDeleteController.$inject = ['Notification', '$uibModalInstance', '$translate', 'entity', 'Report', '$state', 'ModuleSettings'];

	function ReportDeleteController(Notification, $uibModalInstance, $translate, entity, Report, $state, ModuleSettings) {
		var vm = this;

		vm.report = entity;

		vm.clear = clear;
		vm.confirmDelete = confirmDelete;
		vm.loadAll = loadAll;

		function clear () {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmDelete (id) {
			Report.delete({id: id}, function () { $uibModalInstance.close(true); });
			Notification.success({message: $translate.instant('pharmaPortalApp.report.deleted'), delay: 5000});
		}

		function loadAll () {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function (result) {
				vm.moduleSettings = result;
	
				if(!vm.moduleSettings.queriesModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
	}
})();
(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ReportByReportGroupController', ReportByReportGroupController);

    ReportByReportGroupController.$inject = ['DataUtils', 'Report', 'ParseLinks', '$http', '$state', '$stateParams', 'ModuleSettings', '$scope', 'Principal', '$timeout', 'Notification', '$translate'];

    function ReportByReportGroupController(DataUtils, Report, ParseLinks, $http, $state, $stateParams, ModuleSettings, $scope, Principal, $timeout, Notification, $translate) {
        var vm = this;

        vm.reportGroup = {
            group: $stateParams.reportGroup
        };
        vm.reports = [];
        vm.userReports = [];
        vm.orderedReports = [];
        vm.canSave = false;
        vm.userForQuery = {};

        vm.loadAll = loadAll;

        function loadAll() {
            vm.canSave = false;
            Principal.identity().then(function (account) {
                vm.loggedUser = account;
                vm.userForQuery.login = vm.loggedUser.login;
                Report.getUserReportsOrder(vm.userForQuery, function (result) {
                    vm.userReports = result;
                }, function (error) {
                });
            });
            Report.getByReportGroup(vm.reportGroup, function (result) {
                vm.reports = result;
                if (vm.userReports.length == 0) {
                    vm.orderedReports = vm.reports;
                    for (var i = 0; i < vm.orderedReports.length; i++) {
                        vm.orderedReports[i].order = i;
                    }
                } else {
                    for (var i = 0; i < vm.reports.length; i++) {
                        var report = vm.reports[i];
                        var found = false;
                        for (var j = 0; j < vm.userReports.length; j++) {
                            if (report.id == vm.userReports[j].reportId) {
                                report.order = vm.userReports[j].orderIndex;
                                vm.orderedReports.push(report);
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            report.order = vm.reports.length;
                            vm.orderedReports.push(report);
                        }
                    }
                }
                vm.orderedReports.sort(function (a, b) {
                    return a.order - b.order
                });
            }, function (error) {
            });
        }

        loadAll();

        $scope.onDrop = function (item) {
            item.selected = false;
            vm.canSave = true;
        };

        $scope.onDragStart = function (item) {
            item.selected = true;
        };

        $scope.save = function (list) {
            for (var i = 0; i < list.length; i++) {
                list[i].order = i;
                var report = {};
                report.userLogin = vm.loggedUser.login;
                report.reportId = list[i].id;
                report.orderIndex = list[i].order;

                Report.saveReportOrder(report, function (result) {
                    if (result != null) {
                        var success = true;
                    } else {
                        var success = false;
                        Notification.error({
                            message : $translate.instant('pharmaPortalApp.company.message.errorUpdating'),
                            delay : ''
                        });
                    }
                }, function (error) {
                    Notification.error({message : $translate.instant('pharmaPortalApp.company.message.errorUpdating'), delay : ''});
                });
            }
            Notification.success({message: $translate.instant('pharmaPortalApp.reports.saveSuccess'), delay: 5000});
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
            .state('report', {
                parent : 'entity',
                url : '/report?page&sort&search',
                data : {
                    authorities : [ 'ROLE_USER' ],
                    pageTitle : 'pharmaPortalApp.report.home.title'
                },
                views : {
                    'content@' : {
                        templateUrl : 'app/entities/report/reports.html',
                        controller : 'ReportController',
                        controllerAs : 'vm'
                    }
                },
                params : {
                    page : {
                        value : '1',
                        squash : true
                    },
                    sort : {
                        value : 'id,asc',
                        squash : true
                    },
                    search : null
                },
                resolve : {
                    pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page : PaginationUtil.parsePage($stateParams.page),
                            sort : $stateParams.sort,
                            predicate : PaginationUtil.parsePredicate($stateParams.sort),
                            ascending : PaginationUtil.parseAscending($stateParams.sort),
                            search : $stateParams.search
                        };
                    } ],
                    translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('report');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    } ]
                }
            })
            .state('report-detail', {
                parent : 'report',
                url : '/report/{id}',
                data : {
                    authorities : [ 'ROLE_USER' ],
                    pageTitle : 'pharmaPortalApp.report.detail.title'
                },
                views : {
                    'content@' : {
                        templateUrl : 'app/entities/report/report-detail.html',
                        controller : 'ReportDetailController',
                        controllerAs : 'vm'
                    }
                },
                resolve : {
                    translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('report');
                        return $translate.refresh();
                    } ],
                    entity : [ '$stateParams', 'Report', function($stateParams, Report) {
                        return Report.get({
                            id : $stateParams.id
                        }).$promise;
                    } ],
                    previousState : [ "$state", function($state) {
                        var currentStateData = {
                            name : $state.current.name || 'report',
                            params : $state.params,
                            url : $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    } ]
                }
            })
            .state('report-detail.edit', {
                parent : 'report-detail',
                url : '/detail/edit',
                data : {
                    authorities : [ 'ROLE_USER' ]
                },
                onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/report/report-dialog.html',
                        controller : 'ReportDialogController',
                        controllerAs : 'vm',
                        backdrop : 'static',
                        size : 'lg',
                        resolve : {
                            entity : [ 'Report', function(Report) {
                                return Report.get({
                                    id : $stateParams.id
                                }).$promise;
                            } ]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, {
                            reload : true
                        });
                    }, function() {
                        $state.go('^');
                    });
                } ]
            })
            .state('report.new', {
                parent : 'report',
                url : '/new',
                data : {
                    authorities : [ 'ROLE_USER' ]
                },
                onEnter : ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/report/report-dialog.html',
                        controller : 'ReportDialogController',
                        controllerAs : 'vm',
                        backdrop : 'static',
                        size : 'lg',
                        resolve : {
                            entity : function() {
                                return {
                                    title : null,
                                    link : null,
                                    thumbnail : "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",
                                    thumbnailContentType : "image/png",
                                    reportGroup: null,
                                    id : null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('report', null, {
                            reload : 'report'
                        });
                    }, function() {
                        $state.go('report');
                    });
                } ]
            })
            .state('report.edit', {
                parent : 'report',
                url : '/{id}/edit',
                data : {
                    authorities : [ 'ROLE_USER' ]
                },
                onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/report/report-dialog.html',
                        controller : 'ReportDialogController',
                        controllerAs : 'vm',
                        backdrop : 'static',
                        size : 'lg',
                        resolve : {
                            entity : [ 'Report', function(Report) {
                                return Report.get({
                                    id : $stateParams.id
                                }).$promise;
                            } ]
                        }
                    }).result.then(function() {
                        $state.go('report', null, {
                            reload : 'report'
                        });
                    }, function() {
                        $state.go('^');
                    });
                } ]
            })
            .state('report.delete', {
                parent : 'report',
                url : '/{id}/delete',
                data : {
                    authorities : [ 'ROLE_USER' ]
                },
                onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/report/report-delete-dialog.html',
                        controller : 'ReportDeleteController',
                        controllerAs : 'vm',
                        size : 'md',
                        resolve : {
                            entity : [ 'Report', function(Report) {
                                return Report.get({
                                    id : $stateParams.id
                                }).$promise;
                            } ]
                        }
                    }).result.then(function() {
                        $state.go('report', null, {
                            reload : 'report'
                        });
                    }, function() {
                        $state.go('^');
                    });
                } ]
            })
            .state('reportByReportGroup', {
                parent: 'report',
                url: '/{reportGroup}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_INTRANET'],
                    pageTitle: 'pharmaPortalApp.reports.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/report/report-by-report-group.html',
                        controller: 'ReportByReportGroupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('report');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'report',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('reportByParent', {
                parent : 'report',
                url : '/{parent}',
                data : {
                    authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
                    pageTitle : 'pharmaPortalApp.reports.detail.title'
                },
                views : {
                    'content@' : {
                        templateUrl : 'app/entities/report/report-by-parent.html',
                        controller : 'ReportByParentController',
                        controllerAs : 'vm'
                    }
                },
                resolve : {
                    translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('report');
                        return $translate.refresh();
                    } ],
                    previousState : [ "$state", function($state) {
                        var currentStateData = {
                            name : $state.current.name || 'report',
                            params : $state.params,
                            url : $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    } ]
                }
            });
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ReportController', ReportController);

    ReportController.$inject = ['Notification', 'DataUtils', 'Report', 'ParseLinks', 'paginationConstants', 'pagingParams', '$state', 'ModuleSettings'];

    function ReportController(Notification, DataUtils, Report, ParseLinks, paginationConstants, pagingParams, $state, ModuleSettings) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.queriesModule) {
                    $state.go('accessdenied');
                } else {
                    Report.query({
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, onSuccess, onError);

                }
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.reports = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PurchaseOrderItemDetailController', PurchaseOrderItemDetailController);

	PurchaseOrderItemDetailController.$inject = [ '$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PurchaseOrderItem' ];

	function PurchaseOrderItemDetailController($scope, $rootScope, $stateParams, previousState, entity, PurchaseOrderItem) {
		var vm = this;

		vm.purchaseOrderItem = entity;
		vm.previousState = previousState.name;

		var unsubscribe = $rootScope.$on('pharmaPortalApp:purchaseOrderItemUpdate', function(event, result) {
			vm.purchaseOrderItem = result;
		});
		$scope.$on('$destroy', unsubscribe);
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('purchase-order-item', {
			parent : 'entity',
			url : '/purchase-order-item?page&sort',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'pharmaPortalApp.purchaseOrderItem.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/purchase-order-item/purchase-order-items.html',
					controller : 'PurchaseOrderItemController',
					controllerAs : 'vm'
				}
			},
			params : {
				page : {
					value : '1',
					squash : true
				},
				sort : {
					value : 'id,asc',
					squash : true
				}
			},
			resolve : {
				pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
					return {
						page : PaginationUtil.parsePage($stateParams.page),
						sort : $stateParams.sort,
						predicate : PaginationUtil.parsePredicate($stateParams.sort),
						ascending : PaginationUtil.parseAscending($stateParams.sort)
					};
				} ],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('purchaseOrderItem');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('purchase-order-item-detail', {
			parent : 'entity',
			url : '/purchase-order-item/{id}',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'pharmaPortalApp.purchaseOrderItem.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/purchase-order-item/purchase-order-item-detail.html',
					controller : 'PurchaseOrderItemDetailController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('purchaseOrderItem');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'PurchaseOrderItem', function($stateParams, PurchaseOrderItem) {
					return PurchaseOrderItem.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'purchase-order-item',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		});
	}

})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PurchaseOrderItemController', PurchaseOrderItemController);

	PurchaseOrderItemController.$inject = [ 'Notification', '$scope', '$state', 'PurchaseOrderItem', 'ParseLinks', 'paginationConstants', 'pagingParams' ];

	function PurchaseOrderItemController(Notification, $scope, $state, PurchaseOrderItem, ParseLinks, paginationConstants, pagingParams) {
		var vm = this;

		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.clear = clear;
		vm.loadAll = loadAll;

		loadAll();

		function loadAll() {
			PurchaseOrderItem.query({
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort()
			}, onSuccess, onError);
			function sort() {
				var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
				if (vm.predicate !== 'id') {
					result.push('id');
				}
				return result;
			}
			function onSuccess(data, headers) {
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				vm.queryCount = vm.totalItems;
				vm.purchaseOrderItems = data;
				vm.page = pagingParams.page;
			}
			function onError(error) {
				Notification.error({message: error.data.message, delay: ''});
			}
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page : vm.page,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
			});
		}

		function clear() {
			vm.links = null;
			vm.page = 1;
			vm.predicate = 'id';
			vm.reverse = true;
			vm.transition();
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PurchaseOrderDetailController', PurchaseOrderDetailController);

	PurchaseOrderDetailController.$inject = [ '$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PurchaseOrder', 'PurchaseOrderItem' ];

	function PurchaseOrderDetailController($scope, $rootScope, $stateParams, previousState, entity, PurchaseOrder, PurchaseOrderItem) {
		var vm = this;

		vm.purchaseOrder = entity;
		vm.previousState = previousState.name;

		var unsubscribe = $rootScope.$on('pharmaPortalApp:purchaseOrderUpdate', function(event, result) {
			vm.purchaseOrder = result;
		});
		$scope.$on('$destroy', unsubscribe);
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('purchase-order', {
			parent : 'entity',
			url : '/purchase-order?page&sort',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'pharmaPortalApp.purchaseOrder.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/purchase-order/purchase-orders.html',
					controller : 'PurchaseOrderController',
					controllerAs : 'vm'
				}
			},
			params : {
				page : {
					value : '1',
					squash : true
				},
				sort : {
					value : 'id,asc',
					squash : true
				}
			},
			resolve : {
				pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
					return {
						page : PaginationUtil.parsePage($stateParams.page),
						sort : $stateParams.sort,
						predicate : PaginationUtil.parsePredicate($stateParams.sort),
						ascending : PaginationUtil.parseAscending($stateParams.sort)
					};
				} ],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('purchaseOrder');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('purchase-order-detail', {
			parent : 'entity',
			url : '/purchase-order/{id}',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'pharmaPortalApp.purchaseOrder.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/purchase-order/purchase-order-detail.html',
					controller : 'PurchaseOrderDetailController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('purchaseOrder');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'PurchaseOrder', function($stateParams, PurchaseOrder) {
					return PurchaseOrder.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'purchase-order',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		});
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PurchaseOrderController', PurchaseOrderController);

	PurchaseOrderController.$inject = [ 'Notification', '$scope', '$state', 'PurchaseOrder', 'ParseLinks', 'paginationConstants', 'pagingParams' ];

	function PurchaseOrderController(Notification, $scope, $state, PurchaseOrder, ParseLinks, paginationConstants, pagingParams) {
		var vm = this;

		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.clear = clear;
		vm.loadAll = loadAll;

		loadAll();

		function loadAll() {
			PurchaseOrder.query({
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort()
			}, onSuccess, onError);
			function sort() {
				var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
				if (vm.predicate !== 'id') {
					result.push('id');
				}
				return result;
			}
			function onSuccess(data, headers) {
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				vm.queryCount = vm.totalItems;
				vm.purchaseOrders = data;
				vm.page = pagingParams.page;
			}
			function onError(error) {
				Notification.error({message: error.data.message, delay: ''});
			}
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page : vm.page,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
			});
		}

		function clear() {
			vm.links = null;
			vm.page = 1;
			vm.predicate = 'id';
			vm.reverse = true;
			vm.transition();
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ProductListDialogController', ProductListDialogController);

	ProductListDialogController.$inject = [ 'Notification','$uibModalInstance', '$timeout', '$scope', '$stateParams', 'DataUtils', 'entity', 'ProductList', '$state' ];

	function ProductListDialogController( Notification, $uibModalInstance, $timeout, $scope, $stateParams, DataUtils, entity, ProductList, $state) {
		var vm = this;
		vm.productList = entity;
		vm.clear = clear;
		vm.save = save;
		vm.loadAll = loadAll;

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			vm.isSaving = true;
			if (vm.productList.id !== null) {
				ProductList.update(vm.productList, onSaveSuccess, onSaveError);
			} else {
				ProductList.save(vm.productList, onSaveSuccess, onSaveError);
			}
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
			vm.isSaving = false;
		}

        function onSaveError(response) {
            vm.isSaving = false;
            Notification.error({message : $translate.instant(response.headers('x-pharmaportalapp-error')), delay : ''});
        }

		function loadAll() {

		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ProductListDeleteController',ProductListDeleteController);

	ProductListDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductList', '$state'];

	function ProductListDeleteController($uibModalInstance, entity, ProductList, $state) {
		var vm = this;

		vm.productList = entity;
		vm.clear = clear;
		vm.confirmDelete = confirmDelete;
		vm.loadAll = loadAll;

		function clear () {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmDelete (id) {
			ProductList.delete({id: id}, function () { $uibModalInstance.close(true); });
		}

		function loadAll () {

		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider
				.state('product-list', {
					parent : 'entity',
					url : '/product-list?page&sort&search',
					data : {
						authorities : [ 'ROLE_USER' ],
						pageTitle : 'pharmaPortalApp.productList.home.title'
					},
					views : {
						'content@' : {
							templateUrl : 'app/entities/product-list/product-lists.html',
							controller : 'ProductListController',
							controllerAs : 'vm'
						}
					},
					params : {
						page : {
							value : '1',
							squash : true
						},
						sort : {
							value : 'id,asc',
							squash : true
						},
						search : null
					},
					resolve : {
						pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
							return {
								page : PaginationUtil.parsePage($stateParams.page),
								sort : $stateParams.sort,
								predicate : PaginationUtil.parsePredicate($stateParams.sort),
								ascending : PaginationUtil.parseAscending($stateParams.sort),
								search : $stateParams.search
							};
						} ],
						translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('productList');
							$translatePartialLoader.addPart('global');
							return $translate.refresh();
						} ]
					}
				})
				.state('product-list-detail', {
					parent : 'product-list',
					url : '/product-list/{id}',
					data : {
						authorities : [ 'ROLE_USER' ],
						pageTitle : 'pharmaPortalApp.productList.home.title'
					},
					views : {
						'content@' : {
							templateUrl : 'app/entities/product-list/product-list-detail.html',
							controller : 'ProductListDetailController',
							controllerAs : 'vm'
						}
					},
					resolve : {
						translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('productList');
							return $translate.refresh();
						} ],
						entity : [ '$stateParams', 'ProductList', function($stateParams, ProductList) {
							return ProductList.get({
								id : $stateParams.id
							}).$promise;
						} ],
						previousState : [ "$state", function($state) {
							var currentStateData = {
								name : $state.current.name || 'product-list',
								params : $state.params,
								url : $state.href($state.current.name, $state.params)
							};
							return currentStateData;
						} ]
					}
				})
				.state('product-list-detail.edit', {
					parent : 'product-list-detail',
					url : '/detail/edit',
					data : {
						authorities : [ 'ROLE_USER' ]
					},
					onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
						$uibModal.open({
							templateUrl : 'app/entities/product-list/product-list-dialog.html',
							controller : 'ProductListDialogController',
							controllerAs : 'vm',
							backdrop : 'static',
							size : 'lg',
							resolve : {
								entity : [ 'ProductList', function(ProductList) {
									return ProductList.get({
										id : $stateParams.id
									}).$promise;
								} ]
							}
						}).result.then(function() {
							$state.go('^', {}, {
								reload : false
							});
						}, function() {
							$state.go('^');
						});
					} ]
				})
				.state(
						'product-list.new',
						{
							parent : 'product-list',
							url : '/new',
							data : {
								authorities : [ 'ROLE_USER' ]
							},
							onEnter : [
									'$stateParams',
									'$state',
									'$uibModal',
									function($stateParams, $state, $uibModal) {
										$uibModal
												.open({
													templateUrl : 'app/entities/product-list/product-list-dialog.html',
													controller : 'ProductListDialogController',
													controllerAs : 'vm',
													backdrop : 'static',
													size : 'lg',
													resolve : {
														entity : function() {
															return {
																name : null,
																parent : null,
																id : null
															};
														}
													}
												}).result.then(function() {
											$state.go('product-list', null, {
												reload : 'product-list'
											});
										}, function() {
											$state.go('product-list');
										});
									} ]
						}).state('product-list.edit', {
					parent : 'product-list',
					url : '/{id}/edit',
					data : {
						authorities : [ 'ROLE_USER' ]
					},
					onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
						$uibModal.open({
							templateUrl : 'app/entities/product-list/product-list-dialog.html',
							controller : 'ProductListDialogController',
							controllerAs : 'vm',
							backdrop : 'static',
							size : 'lg',
							resolve : {
								entity : [ 'ProductList', function(ProductList) {
									return ProductList.get({
										id : $stateParams.id
									}).$promise;
								} ]
							}
						}).result.then(function() {
							$state.go('product-list', null, {
								reload : 'product-list'
							});
						}, function() {
							$state.go('^');
						});
					} ]
				}).state('product-list.delete', {
					parent : 'product-list',
					url : '/{id}/delete',
					data : {
						authorities : [ 'ROLE_USER' ]
					},
					onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
						$uibModal.open({
							templateUrl : 'app/entities/product-list/product-list-delete-dialog.html',
							controller : 'ProductListDeleteController',
							controllerAs : 'vm',
							size : 'md',
							resolve : {
								entity : [ 'ProductList', function(ProductList) {
									return ProductList.get({id : $stateParams.id}).$promise;
								} ]
							}
						}).result.then(function() {
							$state.go('product-list', null, {
								reload : 'product-list'
							});
						}, function() {
							$state.go('^');
						});
					} ]
				}).state('product-list-board', {
					parent : 'product-list',
					url : '/product-list-board',
					data : {
						authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
						pageTitle : 'pharmaPortalApp.productList.home.title'
					},
					views : {
						'content@' : {
							templateUrl : 'app/entities/product-list/product-list-board.html',
							controller : 'ProductListBoardController',
							controllerAs : 'vm'
						}
					},
					resolve : {
						translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('productList');
							return $translate.refresh();
						} ],
						previousState : [ "$state", function($state) {
							var currentStateData = {
								name : $state.current.name || 'product-list',
								params : $state.params,
								url : $state.href($state.current.name, $state.params)
							};
							return currentStateData;
						} ]
					}
				});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ProductListController', ProductListController);

	ProductListController.$inject = [ 'Notification', 'DataUtils', 'ProductList', 'ParseLinks', 'paginationConstants', 'pagingParams', '$state'];

	function ProductListController(Notification, DataUtils, ProductList, ParseLinks, paginationConstants, pagingParams, $state) {

		var vm = this;

		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.openFile = DataUtils.openFile;
		vm.byteSize = DataUtils.byteSize;

		vm.loadPage = loadPage;
		vm.transition = transition;
		vm.loadAll = loadAll;

        loadAll();

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page : vm.page,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search : vm.currentSearch
			});
		}

		function loadAll() {
            ProductList.query({
                page : pagingParams.page - 1,
                size : vm.itemsPerPage,
                sort : sort()
            }, onSuccess, onError);
            function sort() {
                var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.productLists = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                Notification.error({
                    message : error.data.message,
                    delay : ''
                });
            }
		}

	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp')
        .controller('ProductErpIntegrationDialogController', ProductErpIntegrationDialogController);

    ProductErpIntegrationDialogController.$inject = ['Notification', '$state', '$translate', '$uibModalInstance', 'ModuleSettings', 'Upload'];

    function ProductErpIntegrationDialogController(Notification, $state, $translate, $uibModalInstance, ModuleSettings, Upload) {
        var vm = this;
        vm.working = false;
        vm.loadAll = loadAll;
        vm.clear = clear;
        vm.uploadFile = uploadFile;

        loadAll();

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.productsModule) {
                    $state.go('accessdenied');
                } else {
                    vm.productErpIntegration = {};
                }
            });
        }

        function clear() {
            vm.working = false;
            $uibModalInstance.dismiss('cancel');
        }

        function uploadFile() {
            vm.working = true;
            file.upload = Upload.upload({
                url: '/api/product-erp-integration/upload',
                fields: {
                    integrationType: vm.productErpIntegration.integrationType
                },
                file: vm.productErpIntegration.file
            }).then(function (response) {
                if (response.status === 200) {
                    $uibModalInstance.dismiss("close");
                    Notification.success({
                        message: $translate.instant('pharmaPortalApp.productErpIntegration.import.success'),
                        delay: 5000
                    });
                    $state.go("product-erp-integration-detail", {id: response.data.id});
                } else {
                    if(response.headers("X-pharmaPortalApp-hasError") == "true") {
                        Notification.error({
                            message: response.headers("X-pharmaPortalApp-alert"),
                            delay: 5000
                        });
                    } else {
                        Notification.error({
                            message: $translate.instant('pharmaPortalApp.productErpIntegration.import.error'),
                            delay: 5000
                        });
                    }
                }
                vm.working = false;
            }, function (response) {
                if (response.data.success) {
                    Notification.success({
                        message: response.data.message,
                        delay: 5000
                    });
                } else {
                    Notification.error({
                        message: response.data.message,
                        delay: ''
                    });
                }
                vm.working = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ProductErpIntegrationDetailController', ProductErpIntegrationDetailController);

    ProductErpIntegrationDetailController.$inject = ['Notification', '$http', '$state', '$translate', '$filter', 'entity', 'ModuleSettings', '$stateParams', 'pagingParams',
                                                     '$scope', 'ParseLinks', 'ProductErpIntegration'];

    function ProductErpIntegrationDetailController(Notification, $http, $state, $translate, $filter, entity, ModuleSettings, $stateParams, pagingParams,
                                                   $scope, ParseLinks, ProductErpIntegration) {
        var vm = this;
        vm.working = false;
        vm.productErpIntegration = entity;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = 50;

        loadAll();
        vm.transition = transition;
        vm.canBeIntegrated = canBeIntegrated;
        vm.formatSizeUnits = formatSizeUnits;
        vm.formatErrorMessages = formatErrorMessages;
        vm.getIntegrationResult = getIntegrationResult;
        vm.getFormattedLineStatusMessage = getFormattedLineStatusMessage;
        vm.getFormattedClientPE = getFormattedClientPE;
        vm.integrateIntoERP = integrateIntoERP;

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.productsModule) {
                    $state.go('accessdenied');
                } else {
                    if (vm.productErpIntegration.integrationType == 'PRODUCTS') {
                        getProductLineByProductErpIntegration();
                    } else {
                        getPriceLineByProductErpIntegration();
                    }
                }
            });
        }

        function transition() {
            pagingParams.page = vm.page;
            if (vm.productErpIntegration.integrationType == 'PRODUCTS') {
                getProductLineByProductErpIntegration();
            } else {
                getPriceLineByProductErpIntegration();
            }
        }

        function getProductLineByProductErpIntegration() {
            ProductErpIntegration.findAllProductLineByProductErpIntegration({
                id: vm.productErpIntegration.id,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function getPriceLineByProductErpIntegration() {
            ProductErpIntegration.findAllPriceLineByProductErpIntegration({
                id: vm.productErpIntegration.id,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.lines = data;
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }

        function canBeIntegrated() {
            return (vm.productErpIntegration.integrationStatus !== 'INTEGRATED' && vm.productErpIntegration.validLines != 0);
        }

        function formatSizeUnits(bytes) {
            if (bytes >= 1073741824) {
                bytes = (bytes / 1073741824).toFixed(2) + " GB";
            } else if (bytes >= 1048576) {
                bytes = (bytes / 1048576).toFixed(2) + " MB";
            } else if (bytes >= 1024) {
                bytes = (bytes / 1024).toFixed(2) + " KB";
            } else if (bytes > 1) {
                bytes = bytes + " bytes";
            } else if (bytes == 1) {
                bytes = bytes + " byte";
            } else {
                bytes = "0 bytes";
            }
            return bytes;
        }

        function formatErrorMessages(messageArray) {
            return JSON.parse(messageArray);
        }

        function getIntegrationResult() {
            var str = "";
            if (vm.productErpIntegration.integrationType == 'PRODUCTS') {
                var insertedProds = $filter('filter')(vm.productErpIntegration.productLines, {
                    status: 'OK',
                    alreadyExist: false
                }, true);

                var updatedProds = $filter('filter')(vm.productErpIntegration.productLines, {
                    status: 'OK',
                    alreadyExist: true
                }, true);

                str += insertedProds.length + " " + $translate.instant('pharmaPortalApp.productErpIntegration.import.inserted') + " / ";
                str += updatedProds.length + " " + $translate.instant('pharmaPortalApp.productErpIntegration.import.updated');
            } else {
                var insertedPrices = $filter('filter')(vm.productErpIntegration.priceLines, {
                    status: 'OK',
                }, true);

                str += insertedPrices.length + " " + $translate.instant('pharmaPortalApp.productErpIntegration.import.inserted');
            }
            return str;
        }

        function getFormattedLineStatusMessage(productErpIntegration) {
            var str = "" + productErpIntegration.nbLines;
            str += " (" + productErpIntegration.validLines + " " + $translate.instant('pharmaPortalApp.productErpIntegration.import.valid') + " / ";
            str += productErpIntegration.errorLines + " " + $translate.instant('pharmaPortalApp.productErpIntegration.import.invalid') + ")";
            return str;
        }

        function getFormattedClientPE(priceLine) {
            var str = "";
            if (priceLine.cliente != null) {
                str += priceLine.cliente;
            } else if (priceLine.pontoEntrega != null) {
                str += "---";
            }
            if (priceLine.cliente != null || priceLine.pontoEntrega != null) {
                str += "/";
            }
            if (priceLine.pontoEntrega != null) {
                return priceLine.cliente + '/' + priceLine.pontoEntrega
            } else if (priceLine.cliente != null) {
                str += "---";
            }
            return str;
        }

        function integrateIntoERP() {
            vm.working = true;
            $http.put("api/product-erp-integration/integrateIntoERP", vm.productErpIntegration).then(function (response) {
                if (response.status === 200) {
                    Notification.success({
                        message: $translate.instant(response.data.statusMessage),
                        delay: 5000
                    });
                    vm.productErpIntegration = response.data;
                } else if (response.data.statusMessage != "") {
                    Notification.error({
                        message: $translate.instant(response.data.statusMessage),
                        delay: 5000
                    });
                } else {
                    Notification.error({
                        message: $translate.instant('pharmaPortalApp.productErpIntegration.integration.message.error'),
                        delay: 5000
                    });
                }
                vm.working = false;
            }, function (result) {
                console.log("Error! Status = " + result.status + " Message = " + result);
                Notification.error({
                    message: $translate.instant('pharmaPortalApp.productErpIntegration.integration.message.error'),
                    delay: 5000
                });
                vm.working = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp')
        .controller('ProductErpIntegrationDeleteController', ProductErpIntegrationDeleteController);

    ProductErpIntegrationDeleteController.$inject = ['Notification', '$uibModalInstance', '$translate', 'entity', 'ProductErpIntegration'];

    function ProductErpIntegrationDeleteController(Notification, $uibModalInstance, $translate, entity, ProductErpIntegration) {
        var vm = this;
        vm.working = false;
        vm.productErpIntegration = entity;

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            vm.working = false;
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            vm.working = true;
            ProductErpIntegration.delete({id: id}, onDeleteSuccess, onDeleteError);
        }

        function onDeleteSuccess() {
            vm.working = false;
            $uibModalInstance.close(true);
            Notification.success({
                message: $translate.instant('pharmaPortalApp.productErpIntegration.delete.deletedSuccess'),
                delay: 5000
            });
        }

        function onDeleteError() {
            vm.working = false;
            $uibModalInstance.close(true);
            Notification.error({
                message: $translate.instant('pharmaPortalApp.productErpIntegration.delete.deletedError'),
                delay: 5000
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('product-erp-integration', {
            parent: 'entity',
            url: '/product-erp-integration?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.productErpIntegration.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-erp-integration/product-erp-integrations.html',
                    controller: 'ProductErpIntegrationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'importationDate,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productErpIntegration');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-erp-integration-detail', {
            parent: 'entity',
            url: '/product-erp-integration/{id}?page&sort',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.productErpIntegration.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product-erp-integration/product-erp-integration-detail.html',
                    controller: 'ProductErpIntegrationDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productErpIntegration');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductErpIntegration', function ($stateParams, ProductErpIntegration) {
                    return ProductErpIntegration.get({id: $stateParams.id}).$promise;
                }]
            }
        })
        .state('product-erp-integration.delete', {
            parent: 'product-erp-integration',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product-erp-integration/product-erp-integration-delete-dialog.html',
                    controller: 'ProductErpIntegrationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductErpIntegration', function (ProductErpIntegration) {
                            return ProductErpIntegration.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('product-erp-integration', null, {reload: 'product-erp-integration'});
                }, function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ProductErpIntegrationController', ProductErpIntegrationController);

    ProductErpIntegrationController.$inject = ['Notification', '$state', '$uibModal', '$translate', 'ModuleSettings', '$window', 'ProductErpIntegration', 'ParseLinks', 'paginationConstants', 'pagingParams'];

    function ProductErpIntegrationController(Notification, $state, $uibModal, $translate, ModuleSettings, $window, ProductErpIntegration, ParseLinks, paginationConstants, pagingParams) {
        var vm = this;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.transition = transition;
        vm.openNewImportDialog = openNewImportDialog;
        vm.formatSizeUnits = formatSizeUnits;
        vm.getTemplate = getTemplate;
        vm.getFormattedLineStatusMessage = getFormattedLineStatusMessage;

        loadAll();

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.productsModule) {
                    $state.go('accessdenied');
                } else {
                    ProductErpIntegration.query({
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, onSuccess, onError);
                }
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.productErpIntegrations = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function openNewImportDialog() {
            $uibModal.open({
                templateUrl: 'app/entities/product-erp-integration/product-erp-integration-dialog.html',
                controller: 'ProductErpIntegrationDialogController',
                controllerAs: 'vm',
                size: 'lg'
            });
        }

        function formatSizeUnits(bytes) {
            if (bytes >= 1073741824) {
                bytes = (bytes / 1073741824).toFixed(2) + " GB";
            } else if (bytes >= 1048576) {
                bytes = (bytes / 1048576).toFixed(2) + " MB";
            } else if (bytes >= 1024) {
                bytes = (bytes / 1024).toFixed(2) + " KB";
            } else if (bytes > 1) {
                bytes = bytes + " bytes";
            } else if (bytes === 1) {
                bytes = bytes + " byte";
            } else {
                bytes = "0 bytes";
            }
            return bytes;
        }

        function getTemplate() {
            $window.open("/api/product-erp-integration/template");
        }

        function getFormattedLineStatusMessage(productErpIntegration) {
            var str = "" + productErpIntegration.nbLines;
            str += " (" + productErpIntegration.validLines + " " + $translate.instant('pharmaPortalApp.productErpIntegration.import.valid') + " / ";
            str += productErpIntegration.errorLines + " " + $translate.instant('pharmaPortalApp.productErpIntegration.import.invalid') + ")";
            return str;
        }
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('portal-settings', {
			parent : 'entity',
			url : '/portal-settings',
			data : {
				authorities : [ 'ROLE_ADMIN' ],
				pageTitle : 'pharmaPortalApp.portalSettings.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/portal-settings/portal-settings.html',
					controller : 'PortalSettingsController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('portalSettings');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('intranet-settings', {
			parent : 'entity',
			url : '/intranet-settings',
			data : {
				authorities : [ 'ROLE_ADMIN' ],
				pageTitle : 'pharmaPortalApp.portalSettings.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/portal-settings/intranet-settings.html',
					controller : 'IntranetSettingsController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('portalSettings');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PortalSettingsController', PortalSettingsController);

    PortalSettingsController.$inject = ['Notification', '$scope', '$http', 'PortalSettings', 'ModuleSettings', 'Company', '$timeout'];

    function PortalSettingsController(Notification, $scope, $http, PortalSettings, ModuleSettings, Company, $timeout) {
        var vm = this;

        vm.selfInvoiceCollectionEmail = undefined;

        vm.addSelfInvoiceCollectionEmail = addSelfInvoiceCollectionEmail;
        vm.removeSelfInvoiceCollectionEmail = removeSelfInvoiceCollectionEmail;

        vm.loadAll = loadAll;
        vm.save = save;
        Company.getClientGroups(function (result) {
            vm.clientGroups = result;
        }, function (error) {
        });

        vm.activeGroups = [];

        PortalSettings.getAllActiveClientGroups(function (result) {
            vm.activeGroups = result;
        });

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.settings = PortalSettings.query();

            vm.settings.$promise.then(function (result) {
                vm.settings.invoiceType = {code: vm.settings.invoiceTypeCode, description: vm.settings.invoiceTypeDesc};
                vm.settings.conferenceType = {code: vm.settings.billingTypeRetainedProductsCode, description: vm.settings.billingTypeRetainedProductsDesc};
                vm.settings.tradeInvoiceType = {code: vm.settings.tradeInvoiceTypeCode, description: vm.settings.tradeInvoiceTypeDesc};
                vm.settings.tradeCreditType = {code: vm.settings.tradeCreditTypeCode, description: vm.settings.tradeCreditTypeDesc};
                vm.settings.cecServiceType = {code: vm.settings.cecServiceTypeCode, description: vm.settings.cecServiceTypeDesc};
                vm.settings.warehouseSales = {code: vm.settings.warehouseSalesCode, description: vm.settings.warehouseSalesDesc};
                vm.settings.returnWarehouseTransfType = {code: vm.settings.returnWarehouseTransfTypeCode, description: vm.settings.returnWarehouseTransfTypeDesc};
                vm.settings.returnCreditType = {code: vm.settings.returnCreditTypeCode, description: vm.settings.returnCreditTypeDesc};
                vm.settings.billingType = {code: vm.settings.billingTypeCode, description: vm.settings.billingTypeDesc};
                vm.settings.transportType = {code: vm.settings.transportTypeCode, description: vm.settings.transportTypeDesc};
                vm.settings.selfInvoiceCollectionEmails = vm.settings.selfInvoiceCollectionEmails ? JSON.parse(vm.settings.selfInvoiceCollectionEmails) : [];
            });

            $http.get("api/common/_searchInvoiceTypesForSelect").then(function (result) {
                $scope.documentTypes = result.data;
            });

            $http.get("api/common/_searchInvoiceTypesWithCorrectionForSelect").then(function (result) {
                $scope.documentTypesWithCorrection = result.data;
            });

            $http.get("api/common/_getServicesForSelect").then(function (result) {
                $scope.serviceTypes = result.data;
            });

            $http.get("api/common/_searchWarehousesForSelect").then(function (result) {
                $scope.warehouses = result.data;
            });

            $http.get("api/companies/findAll").then(function (result) {
                $scope.companiesWithWarehouse = result.data;
            });
        }

        loadAll();

        function save() {
            try {
                if (angular.isDefined(vm.settings.conferenceType)) {
                    vm.settings.billingTypeRetainedProductsCode = vm.settings.conferenceType.code;
                    vm.settings.billingTypeRetainedProductsDesc = vm.settings.conferenceType.description;
                }
                if (angular.isDefined(vm.settings.invoiceType)) {
                    vm.settings.invoiceTypeCode = vm.settings.invoiceType.code;
                    vm.settings.invoiceTypeDesc = vm.settings.invoiceType.description;
                }
                if (angular.isDefined(vm.settings.tradeInvoiceType)) {
                    vm.settings.tradeInvoiceTypeCode = vm.settings.tradeInvoiceType.code;
                    vm.settings.tradeInvoiceTypeDesc = vm.settings.tradeInvoiceType.description;
                }
                if (angular.isDefined(vm.settings.tradeCreditType)) {
                    vm.settings.tradeCreditTypeCode = vm.settings.tradeCreditType.code;
                    vm.settings.tradeCreditTypeDesc = vm.settings.tradeCreditType.description;
                }
                if (angular.isDefined(vm.settings.cecServiceType)) {
                    vm.settings.cecServiceTypeCode = vm.settings.cecServiceType.code;
                    vm.settings.cecServiceTypeDesc = vm.settings.cecServiceType.description;
                }
                if (angular.isDefined(vm.settings.warehouseSales)) {
                    vm.settings.warehouseSalesCode = vm.settings.warehouseSales.code;
                    vm.settings.warehouseSalesDesc = vm.settings.warehouseSales.description;
                }
                if (angular.isDefined(vm.settings.returnWarehouseTransfType)) {
                    vm.settings.returnWarehouseTransfTypeCode = vm.settings.returnWarehouseTransfType.code;
                    vm.settings.returnWarehouseTransfTypeDesc = vm.settings.returnWarehouseTransfType.description;
                }
                if (angular.isDefined(vm.settings.returnCreditType)) {
                    vm.settings.returnCreditTypeCode = vm.settings.returnCreditType.code;
                    vm.settings.returnCreditTypeDesc = vm.settings.returnCreditType.description;
                }
                if (angular.isDefined(vm.settings.billingType)) {
                    vm.settings.billingTypeCode = vm.settings.billingType.code;
                    vm.settings.billingTypeDesc = vm.settings.billingType.description;
                }
                if (angular.isDefined(vm.settings.transportType)) {
                    vm.settings.transportTypeCode = vm.settings.transportType.code;
                    vm.settings.transportTypeDesc = vm.settings.transportType.description;
                }
                if (angular.isDefined(vm.settings.selfInvoiceCollectionEmails)) {
                    vm.settings.selfInvoiceCollectionEmails = JSON.stringify(vm.settings.selfInvoiceCollectionEmails);
                }

                PortalSettings.update(vm.settings, function () {
                    Notification.success({message: 'Parametrizações atualizadas com sucesso', delay: 5000});
                    $timeout(function () {
                        location.reload();
                    }, 2000);
                });

                if (vm.settings.onlyTradeInGroup) {
                    PortalSettings.deleteActiveTradeGroups(function (result) {
                        for (var i = 0; i < vm.activeGroups.length; i++) {
                            PortalSettings.saveActiveTradeGroups(vm.activeGroups[i], function (result) {
                                var flag = result;
                            }, function (error) {
                                var flag = error;
                            });
                        }
                    }, function (error) {
                        Notification.error({message: 'active trade groups nao apagados', delay: 5000});
                    });

                } else {
                    PortalSettings.deleteActiveTradeGroups(function (result) {
                        vm.activeGroups = [];
                    }, function (error) {
                        Notification.error({message: 'active trade groups nao apagados', delay: 5000});
                    });
                }

            } catch (err) {
                Notification.error({message: 'Não foi possível atualizar as parametrizações', delay: ''});
            }
        }

        $scope.setDocReason = function ($item) {
            if ($item.withreason == 'S') {
                vm.settings.rectifDocReason = $item.reasoncode + ' - ' + $item.reasondescription;
            } else {
                vm.settings.rectifDocReason = null;
            }
        }

        function addSelfInvoiceCollectionEmail() {
            if(!angular.isDefined(vm.settings.selfInvoiceCollectionEmails)) {
                vm.settings.selfInvoiceCollectionEmails = [];
            }
            vm.settings.selfInvoiceCollectionEmails.push({email: vm.selfInvoiceCollectionEmail});
            vm.selfInvoiceCollectionEmail = undefined;
        }

        function removeSelfInvoiceCollectionEmail(item) {
            var index = vm.settings.selfInvoiceCollectionEmails.indexOf(item);
            vm.settings.selfInvoiceCollectionEmails.splice(index, 1);
        }

    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('IntranetSettingsController', IntranetSettingsController);

	IntranetSettingsController.$inject = [ 'Notification', '$http', '$scope', 'PortalSettings', 'PharmaReceptionServiceByVat', 'PharmaReceptionServiceList', 'ModuleSettings' ];

	function IntranetSettingsController(Notification, $http, $scope, PortalSettings, PharmaReceptionServiceByVat, PharmaReceptionServiceList, ModuleSettings) {
		var vm = this;

		vm.pharmaReceptionServiceByVats = PharmaReceptionServiceByVat.query();
		vm.servicesToProvide = PharmaReceptionServiceList.query();

		vm.loadAll = loadAll;
		vm.addNewPharmaReceptionServiceByVat = addNewPharmaReceptionServiceByVat;
		vm.save = save;
		vm.savePharmaReceptionServiceByVats = savePharmaReceptionServiceByVats;
		vm.saveReceptionServiceList = saveReceptionServiceList;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.settings = PortalSettings.query();

			vm.settings.$promise.then(function(result) {
				vm.settings.balanceCentralWarehouse = { code : vm.settings.balanceCentralWarehouseCode, description : vm.settings.balanceCentralWarehouseDesc };
				vm.settings.balanceServiceType = { code : vm.settings.balanceServiceTypeCode, description : vm.settings.balanceServiceTypeDesc };
				vm.settings.balanceInvoiceType = { code : vm.settings.balanceInvoiceTypeCode, description : vm.settings.balanceInvoiceTypeDesc };
				vm.settings.balanceCreditType = { code : vm.settings.balanceCreditTypeCode, description : vm.settings.balanceCreditTypeDesc };
			});

			$http.get("api/common/_searchInvoiceTypesForSelect").then(function(result) {
				$scope.documentTypes = result.data;
			});

			$http.get("api/common/_getServicesForSelect").then(function(result) {
				$scope.serviceTypes = result.data;
			});

			$http.get("api/common/_searchWarehousesForSelect").then(function(result) {
				$scope.warehouses = result.data;
			});

			vm.pharmaReceptionServiceByVats.$promise.then(function(result) {
				angular.forEach(result, function(value, key) {
					value.serviceVatType = { code : value.code, description : value.description, vatRate : value.vatRate, vatCode : value.vatCode };
				})
			});
		}
		loadAll();

		function addNewPharmaReceptionServiceByVat() {
			if (!angular.isObject(vm.pharmaReceptionServiceByVats)) {
				vm.pharmaReceptionServiceByVats = [];
			}
			vm.pharmaReceptionServiceByVats.push(new PharmaReceptionServiceByVat());
		}

		function save() {
			try {
				if(savePharmaReceptionServiceByVats() && saveReceptionServiceList()) {
					vm.settings.balanceCentralWarehouseCode = vm.settings.balanceCentralWarehouse.code;
					vm.settings.balanceCentralWarehouseDesc = vm.settings.balanceCentralWarehouse.description;

					vm.settings.balanceServiceTypeCode = vm.settings.balanceServiceType.code;
					vm.settings.balanceServiceTypeDesc = vm.settings.balanceServiceType.description;

					vm.settings.balanceInvoiceTypeCode = vm.settings.balanceInvoiceType.code;
					vm.settings.balanceInvoiceTypeDesc = vm.settings.balanceInvoiceType.description;

					vm.settings.balanceCreditTypeCode = vm.settings.balanceCreditType.code;
					vm.settings.balanceCreditTypeDesc = vm.settings.balanceCreditType.description;

					PortalSettings.update(vm.settings, function(httpResponse) {
						Notification.success({message: 'Parametrizações atualizadas com sucesso', delay: 5000});
					});
				}
			} catch (err) {
				Notification.error({message: 'Não foi possível atualizar as parametrizações', delay: ''});
			}
		}

		function savePharmaReceptionServiceByVats() {
			var isValid = true;
			try {
				if(vm.settings.exportPurchaseInvoice) {
					if(vm.pharmaReceptionServiceByVats.length === 0) {
						Notification.error({message: 'Não indicou nenhum serviço para as diferenças de compras', delay: ''});
						isValid = false;
					} else {
						var uniqueVatRates = [];
						angular.forEach(vm.pharmaReceptionServiceByVats, function(value, key) {
							value.code = value.serviceVatType.code;
							value.description = value.serviceVatType.description;
							value.vatRate = value.serviceVatType.vatRate;
							value.vatCode = value.serviceVatType.vatCode;

							if(uniqueVatRates.indexOf(""+value.vatRate) > -1) {
								Notification.error({message: 'Apenas pode indicar um serviço por cada taxa de IVA', delay: ''});
								isValid = false;
							} else {
								uniqueVatRates.push(""+value.vatRate);
							}
						})
					}
				} else {
					vm.pharmaReceptionServiceByVats = [];
				}

				if(isValid) {
					PharmaReceptionServiceByVat.save(vm.pharmaReceptionServiceByVats);
				}

				return isValid;

			} catch (err) {
				Notification.error({message: 'Não foi possível atualizar as parametrizações dos códigos de serviço para as diferenças de compras', delay: ''});
			}
		}

		function saveReceptionServiceList() {
			var isValid = true;
			try {
				if(vm.settings.filterServicesToShow) {
					if(vm.servicesToProvide.length === 0) {
						Notification.error({message: 'A lista de serviços a disponibilizar não pode ser vazia', delay: ''});
						isValid = false;
					}
				} else {
					vm.servicesToProvide = [];
				}

				if(isValid) {
					PharmaReceptionServiceList.save(vm.servicesToProvide);
				}
				return isValid;

			} catch (err) {
			    Notification.error({message : 'Não foi possível atualizar as parametrizações da lista de serviços a disponibilizar', delay : ''});
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PortalProductStockDetailController', PortalProductStockDetailController);

	PortalProductStockDetailController.$inject = [ '$uibModalInstance', '$rootScope', '$scope', '$http', '$state', 'entity', 'ModuleSettings' ];

	function PortalProductStockDetailController($uibModalInstance, $rootScope, $scope, $http, $state, entity, ModuleSettings) {
		var vm = this;

		vm.internalCode = entity.internalCode;
		$scope.warehouseStockList = [];

		vm.clear = clear;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.productsModule) {
					$state.go('accessdenied');
				} else {
					$http.get("api/portal-product/stockDetails/" + vm.internalCode).then(function(result) {
						$scope.warehouseStockList = result.data;
					});
				}
			});
		}
		loadAll();

		$scope.getTotal = function() {
			var total = 0;
			for (var i = 0; i < $scope.warehouseStockList.length; i++) {
				var warehouseStock = $scope.warehouseStockList[i];
				total += (warehouseStock.stock * 1);
			}
			return total;
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PortalProductFullSearchController', PortalProductFullSearchController);

	PortalProductFullSearchController.$inject = [ '$uibModalInstance', '$rootScope', '$state', 'ModuleSettings' ];

	function PortalProductFullSearchController($uibModalInstance, $rootScope, $state, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmAddProducts = confirmAddProducts;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmAddProducts() {
			$rootScope.searchProductsAction()
			$uibModalInstance.close(true);
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.productsModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
	}
})();
(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PortalProductCnpDetailController', PortalProductCnpDetailController);

    PortalProductCnpDetailController.$inject = ['$uibModalInstance', '$http', '$state', 'product', 'ModuleSettings', 'Product'];

    function PortalProductCnpDetailController($uibModalInstance, $http, $state, product, ModuleSettings, Product) {
        var vm = this;

        vm.product = product;

        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.drawPlot = drawPlot;
        vm.productInfo = "";

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.productsModule) {
                    $state.go('accessdenied');
                } else {
                    Product.getProductInfo({"cnp": vm.product.cnp}, function (result) {
                        vm.productInfo = result;
                    }, function (error) {
                    });
                    $http.get("api/dbPharma/productPriceHistory/" + vm.product.society + "/" + vm.product.cnp).then(function (result2) {
                        vm.productPriceHistoryDetailsByCnp = result2.data;

                        var pvpArr = [];
                        var pvaArr = [];
                        var pvfArr = [];
                        var dateFromAPI = [];
                        var chartDate = [];
                        var monName = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];

                        for (var i = 0; i < vm.productPriceHistoryDetailsByCnp.length; i++) {
                            pvpArr.push(vm.productPriceHistoryDetailsByCnp[i].pvpciva);
                            pvaArr.push(vm.productPriceHistoryDetailsByCnp[i].pva);
                            pvfArr.push(vm.productPriceHistoryDetailsByCnp[i].pvf);
                            dateFromAPI.push(vm.productPriceHistoryDetailsByCnp[i].initdate);
                            var date = new Date(dateFromAPI[i]);
                            chartDate[i] = [date.getDate() + " " + monName [date.getMonth()] + " " + date.getFullYear()];
                        }
                        drawPlot(pvpArr, pvaArr, pvfArr, chartDate);
                    });
                }
            });
        }

        loadAll();

        function drawPlot(pvpArr, pvaArr, pvfArr, chartDate) {
            Highcharts.chart('container', {
                title: {
                    text: ''
                },
                xAxis: {
                    categories: chartDate
                },
                yAxis: {
                    title: {
                        text: ''
                    }
                },
                series: [{
                    name: "PVP",
                    data: pvpArr
                }, {
                    name: 'PVA',
                    data: pvaArr
                }, {
                    name: 'PVF',
                    data: pvfArr
                }],
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                },
                credits: {
                    enabled: false
                }
            });
        }
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('portal-product', {
			parent : 'entity',
			url : '/portal-product?page&sort&search',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.portalProduct.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/portal-product/portal-products.html',
					controller : 'PortalProductController',
					controllerAs : 'vm'
				}
			},
			params : {
				page : {
					value : '1',
					squash : true
				},
				sort : {
					value : 'id,asc',
					squash : true
				},
				search : null
			},
			resolve : {
				pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
					return {
						page : PaginationUtil.parsePage($stateParams.page),
						sort : $stateParams.sort,
						predicate : PaginationUtil.parsePredicate($stateParams.sort),
						ascending : PaginationUtil.parseAscending($stateParams.sort),
						search : $stateParams.search
					};
				} ],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('portalProduct');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('portal-product.fullSearch', {
			parent : 'portal-product',
			url : '/fullSearch',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/portal-product/portal-product-confirm.fullsearch-dialog.html',
					controller : 'PortalProductFullSearchController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('portal-product', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('portal-product.stockDetail', {
			parent : 'portal-product',
			url : '/stockDetail/{internalCode}',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/portal-product/portal-product-stock.detail-dialog.html',
					controller : 'PortalProductStockDetailController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : function() {
							return {
								internalCode : $stateParams.internalCode
							};
						}
					}
				}).result.then(function() {
					$state.go('portal-product', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
        }).state('portal-product.showDetail', {
            parent : 'portal-product',
            url : '/productDetails',
            data : {
                authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
            },
            params : {
                product : null
            },
            onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                if($stateParams.product != null) {
                    $uibModal.open({
                        templateUrl : 'app/entities/portal-product/portal-product-cnp.detail-dialog.html',
                        controller : 'PortalProductCnpDetailController',
                        controllerAs : 'vm',
                        size : 'lg modal-exl',
                        resolve : {
                            product : function() {
                                return $stateParams.product;
                            }
                        }
                    }).result.then(function() {
                        $state.go('portal-product', null, {
                            reload : false
                        });
                    }, function() {
                        $state.go('^');
                    });
                } else {
                    $state.go('portal-product', null, {
                        reload : false
                    });
                }
            } ]
		});
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PortalProductController', PortalProductController);

    PortalProductController.$inject = ['Notification', '$rootScope', '$scope', '$state', '$http', '$filter', '$translate', '$q', 'ModuleSettings', 'Principal', 'PortalSettings', 'AdminSettings'];

    function PortalProductController(Notification, $rootScope, $scope, $state, $http, $filter, $translate, $q, ModuleSettings, Principal, PortalSettings, AdminSettings) {
        var vm = this;

        vm.searchByLab = searchByLab;
        vm.clearSearchInTable = clearSearchInTable;
        vm.exportToExcel = exportToExcel;
        vm.loadAll = loadAll;

        vm.settings = PortalSettings.query();
        $scope.searchInTable = "";
        $scope.productsList = [];
        $scope.search = {
            searchQuery: "",
            showNoStock: false,
            showInactive: false,
            useExternalDB: false,
            dispSegFilter: ""
        };

        $scope.syncProducts = function () {
            AdminSettings.syncProductsServ();
            Notification.info({message: $translate.instant('pharmaPortalApp.portalProducts.externalSyncs.syncNotif'), delay: 5000});
        };

        $scope.searchProducts = function () {
            $scope.productsList = [];
            if ($scope.search && $scope.search.searchQuery && $scope.search.searchQuery.length > 2) {
                $rootScope.searchProductsAction();
            } else {
                // SE showNoStock então não permite
                if ($scope.search.showNoStock == true && $scope.search.dispSegFilter != "true") {
                    $rootScope.message = "NOK";
                    $scope.productsList = [];
                    $state.go("portal-product.fullSearch");
                } else {
                    // SE showNoStock = FALSE então ABRE DIALOG A CONFIRMAR
                    if ($scope.search.searchQuery == undefined) {
                        $scope.search.searchQuery = "";
                    }
                    $rootScope.message = "OK";
                    $state.go("portal-product.fullSearch");
                }
            }
        };

        var canceler = $q.defer();

        $rootScope.searchProductsAction = function () {
            canceler.resolve();
            canceler = $q.defer();

            $scope.resultProductsList = [];
            $http.post("api/common/_searchProductsFromDbPharmaWithOpts", $scope.search, {
                timeout: canceler.promise
            }).then(function (result) {
                $scope.resultProductsList = result.data;
            }).then(function () {
                $scope.productsList = [];

                if (vm.loggedUserClientPe && vm.settings.includeCMPColumn) {
                    vm.policyName = "CMPCalculation";
                    vm.policyData = [];

                    $($scope.resultProductsList).each(function (index, prod) {
                        var prodLab = prod.forncode ? "CIL" + prod.forncode : prod.labcode ? prod.labcode : "99999";
                        vm.policyData.push({
                            "hierarchy": [vm.loggedUserClientPe, prodLab, prod.cnp]
                        });
                        prod.hash = vm.loggedUserClientPe + "" + prodLab + "" + prod.cnp;
                    });

                    var requestBody = {
                        "policyType": vm.policyName,
                        "policyData": vm.policyData
                    };

                    $http.post("api/policyExecuter/execute", requestBody, {
                        timeout: canceler.promise
                    }).then(function (result2) {
                        $($scope.resultProductsList).each(function (index, prod) {

                            var curResult = $filter('filter')(result2.data.output, {
                                hash: prod.hash
                            }, true);

                            if (curResult[0]) {
                                prod.pcm = curResult[0].result;
                            } else {
                                prod.pcm = 0;
                            }
                        });
                    }, function (result) {
                        Notification.warning({message: "Error! Status = " + result.status + " Message = " + result, delay: 5000});
                    });
                }
                $scope.productsList = $scope.resultProductsList;
            });
        }

        $scope.isSearchEmpty = function () {
            return $scope.productsList.length <= 0;
        }

        function searchByLab(lab) {
            $scope.search.searchQuery = lab;
            $scope.searchProducts();
        }

        function clearSearchInTable() {
            $scope.searchInTable = "";
        }

        function exportToExcel() {
            $http.post("api/portal-product/toExcel", $scope.productsList, {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, "Produtos_Portal_" + dateTime + ".xlsx", true);
                Notification.success({
                    message: "Listagem de produtos exportada com sucesso",
                    delay: 5000
                });
            }, function errorCallback(response) {
                Notification.error({
                    message: "Erro ao exportar listagem",
                    delay: ''
                });
            });
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.productsModule) {
                    $state.go('accessdenied');
                }
            });

            Principal.identity().then(function (account) {
                if (account) {
                    vm.loggedUser = account;
                    if (account.company) {
                        vm.loggedUserClientPe = account.clientPe;
                    } else {
                        vm.loggedUserClientPe = null;
                    }
                } else {
                    vm.loggedUser = null;
                    vm.loggedUserClientPe = null;
                }
            });
        }

        loadAll();

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('pharmaPortalApp')
        .factory('PortalPendingShoppingCarts', PortalPendingShoppingCarts);

    PortalPendingShoppingCarts.$inject = ['$resource'];

    function PortalPendingShoppingCarts ($resource) {
        var resourceUrl =  'api/portal-pending-shopping-carts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete': { method:'DELETE',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PortalNotificationDialogController', PortalNotificationDialogController);

    PortalNotificationDialogController.$inject = ['Notification', '$scope', '$uibModalInstance', '$translate', 'entity', 'PortalNotification', 'User', 'Company'];

    function PortalNotificationDialogController(Notification, $scope, $uibModalInstance, $translate, entity, PortalNotification, User, Company) {
        var vm = this;
        vm.users = [];
        vm.companies = [];
        vm.portalNotification = entity;

        vm.clear = clear;
        vm.save = save;
        vm.loadAll = loadAll;

        function loadAll() {

            vm.users = User.queryMyCompanyUsers();

            Company.query(function (data) {
                vm.companies = data;
            }, function onError(error) {
                Notification.error({message: error.data.message, delay: ''});
            });
        }
        loadAll();

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if ((vm.portalNotification.destinationId != null && vm.portalNotification.companyDestinationId != null) || (vm.portalNotification.destinationId == null && vm.portalNotification.companyDestinationId == null)) {
                vm.errorDestination = true;
                vm.isSaving = false;
            } else {
                vm.isSaving = true;
                if (vm.portalNotification.id !== null) {
                    PortalNotification.update(vm.portalNotification, onSaveSuccess, onSaveError);
                } else {
                    PortalNotification.save(vm.portalNotification, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('pharmaPortalApp:portalNotificationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError(result) {
            vm.isSaving = false;
        }

        vm.categories = [{
            value: 'ERROR',
            label: $translate.instant('PortalNotificationCategory.ERROR'),
        }, {
            value: 'INFO',
            label: $translate.instant('PortalNotificationCategory.INFO'),
        }, {
            value: 'MESSAGE',
            label: $translate.instant('PortalNotificationCategory.MESSAGE'),
        }];

        vm.priorities = [{
            value: 'HIGH',
            label: $translate.instant('PortalNotificationPriority.HIGH')
        }, {
            value: 'MEDIUM',
            label: $translate.instant('PortalNotificationPriority.MEDIUM')
        }, {
            value: 'LOW',
            label: $translate.instant('PortalNotificationPriority.LOW')
        }];
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PortalNotificationDetailController', PortalNotificationDetailController);

    PortalNotificationDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function PortalNotificationDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.portalNotification = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('pharmaPortalApp:portalNotificationUpdate', function (event, result) {
            vm.portalNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular.module('pharmaPortalApp').controller('PortalNotificationDeleteController',PortalNotificationDeleteController);

    PortalNotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'PortalNotification'];

    function PortalNotificationDeleteController($uibModalInstance, entity, PortalNotification) {
        var vm = this;

        vm.portalNotification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PortalNotification.delete({id: id}, function () {$uibModalInstance.close(true); });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('portal-notification', {
            parent: 'entity',
            url: '/portal-notification?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.portalNotification.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/portal-notification/portal-notifications.html',
                    controller: 'PortalNotificationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portalNotification');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('portal-notification-detail', {
            parent: 'portal-notification',
            url: '/portal-notification/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.portalNotification.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/portal-notification/portal-notification-detail.html',
                    controller: 'PortalNotificationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('portalNotification');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PortalNotification', function($stateParams, PortalNotification) {
                    return PortalNotification.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'portalNotification',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('portal-notification.new', {
            parent: 'portal-notification',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-notification/portal-notification-dialog.html',
                    controller: 'PortalNotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                subject: null,
                                message: null,
                                category: null,
                                priority: null,
                                date: null,
                                isRead: false,
                                notificationToUser: null,
                                destination: null,
                                companyDestination: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('portal-notification', null, { reload: 'portal-notification' });
                }, function() {
                    $state.go('portal-notification');
                });
            }]
        })
        .state('portal-notification.delete', {
            parent: 'portal-notification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/portal-notification/portal-notification-delete-dialog.html',
                    controller: 'PortalNotificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PortalNotification', function(PortalNotification) {
                            return PortalNotification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('portal-notification', null, { reload: 'portal-notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PortalNotificationController', PortalNotificationController);

    PortalNotificationController.$inject = ['$scope', '$state', 'Notification', 'ParseLinks', 'paginationConstants', 'pagingParams', '$translate', '$http', '$timeout', 'PortalNotification', 'Principal', 'User'];

    function PortalNotificationController($scope, $state, Notification, ParseLinks, paginationConstants, pagingParams, $translate, $http, $timeout, PortalNotification, Principal, User) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.filterPortalNotifications = filterPortalNotifications;
        vm.clearFilter = clearFilter;

        vm.setRead = setRead;

        $scope.toggleAll = function () {
            var toggleStatus = $scope.isAllSelected;
            angular.forEach(vm.portalNotifications, function (itm) {
                itm.selected = toggleStatus;
            });
        };

        $scope.optionToggled = function () {
            $scope.isAllSelected = vm.portalNotifications.every(function (itm) {
                return itm.selected;
            })
        };

        $scope.isAnyOptionSelected = function () {
            var noSelection = true;
            angular.forEach(vm.portalNotifications, function (itm) {
                if (noSelection && itm.selected) {
                    noSelection = false;
                }
            });
            return noSelection;
        };

        $scope.markAsReadOrUnread = function (flag) {
            angular.forEach(vm.portalNotifications, function (itm) {
                if (itm.selected) {
                    if (itm.isRead != flag) {
                        itm.isRead = flag;
                        PortalNotification.update(itm);
                    }
                    itm.selected = false;
                }
            });
            $scope.isAllSelected = false;
            $timeout(function () {
                $scope.$emit('readOrUnreadEvent');
            }, 1000)
        };

        $scope.goToDetail = function (portalNotification) {
            if (portalNotification.isRead == true) {
                $state.go('portal-notification-detail', {id: portalNotification.id});
            } else {
                portalNotification.isRead = true;
                PortalNotification.update(portalNotification, function () {
                    $scope.$emit('readOrUnreadEvent');
                    $state.go('portal-notification-detail', {id: portalNotification.id});
                }, function () {
                    $state.go('portal-notification-detail', {id: portalNotification.id});
                });
            }
        };

        function setRead(portalNotification, isRead) {
            portalNotification.isRead = isRead;
            PortalNotification.update(portalNotification, function () {
                loadAll();
                $scope.$emit('readOrUnreadEvent')
            });
        }

        vm.openDatePopup = function (inputCalendar) {
            if (inputCalendar == 'start') {
                vm.datePopup.start.opened = true;
            }
        };

        vm.datePopup = {
            start: {
                opened: false
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            showWeeks: false
        };

        vm.categories = [
            {value: "ERROR", label: $translate.instant('PortalNotificationCategory.ERROR')},
            {value: "INFO", label: $translate.instant('PortalNotificationCategory.INFO')},
            {value: "MESSAGE", label: $translate.instant('PortalNotificationCategory.MESSAGE')}
        ];

        vm.priorities = [
            {value: "HIGH", label: $translate.instant('PortalNotificationPriority.HIGH')},
            {value: "MEDIUM", label: $translate.instant('PortalNotificationPriority.MEDIUM')},
            {value: "LOW", label: $translate.instant('PortalNotificationPriority.LOW')}
        ];

        vm.states = [
            {value: true, label: $translate.instant('pharmaPortalApp.portalNotification.isRead.read')},
            {value: false, label: $translate.instant('pharmaPortalApp.portalNotification.isRead.noRead')}
        ];

        vm.filter = [{
            date: null,
            origin: null,
            category: null,
            priority: null,
            isRead: null
        }];

        function clearFilter() {
            loadAll();
            vm.filter = [{
                date: null,
                origin: null,
                category: null,
                priority: null,
                isRead: null
            }];
        }

        function filterPortalNotifications() {
            if (vm.filter.date == null && vm.filter.origin == null && vm.filter.category == null && vm.filter.priority == null && vm.filter.isRead == null) {
                return vm.clearFilter();
            }

            var filterRequest = {};
            filterRequest.date = vm.filter.date != null ? vm.filter.date : null;
            filterRequest.origin = vm.filter.origin != null ? vm.filter.origin : null;
            filterRequest.category = vm.filter.category != null ? vm.filter.category : null;
            filterRequest.priority = vm.filter.priority != null ? vm.filter.priority : null;
            filterRequest.isRead = vm.filter.isRead != null ? vm.filter.isRead : null;

            $http.post('api/portalNotifications/searchFilter', filterRequest).then(function (result) {
                if (result.status === 200) {
                    vm.portalNotifications = result.data;
                    vm.links = ParseLinks.parse(result.headers('link'));
                    vm.totalItems = result.headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                } else {
                    Notification.error({message: $translate.instant(result.headers("X-pharmaPortalApp-alert")), delay: ''});
                }
            });
        }

        loadAll();

        $scope.saveUser = function () {
            User.update(vm.user);
        };

        function loadAll() {
            Principal.identity().then(function (account) {
                if (account) {
                    User.get({login: account.login}, function (result) {
                        vm.user = result;
                    });
                }
            });
            PortalNotification.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.portalNotifications = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                Notification.error({message: $translate.instant("error.data.message"), delay: ''});
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PortalAppDialogController', PortalAppDialogController);

	PortalAppDialogController.$inject = [ '$uibModalInstance', '$timeout', '$scope', '$stateParams', 'DataUtils', 'entity', 'PortalApp', '$state', 'ModuleSettings' ];

	function PortalAppDialogController($uibModalInstance, $timeout, $scope, $stateParams, DataUtils, entity, PortalApp, $state, ModuleSettings) {
		var vm = this;

		vm.portalApp = entity;
		vm.byteSize = DataUtils.byteSize;
		vm.openFile = DataUtils.openFile;

		vm.clear = clear;
		vm.save = save;
		vm.loadAll = loadAll;

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		vm.setThumbnail = function($file, portalApp) {
			if ($file && $file.$error === 'pattern') {
				return;
			}
			if ($file) {
				DataUtils.toBase64($file, function(base64Data) {
					$scope.$apply(function() {
						portalApp.thumbnail = base64Data;
						portalApp.thumbnailContentType = $file.type;
					});
				});
			}
		};

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			vm.isSaving = true;
			if (vm.portalApp.id !== null) {
				PortalApp.update(vm.portalApp, onSaveSuccess, onSaveError);
			} else {
				PortalApp.save(vm.portalApp, onSaveSuccess, onSaveError);
			}
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
			vm.isSaving = false;
		}

		function onSaveError() {
			vm.isSaving = false;
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.applicationsModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PortalAppDetailController', PortalAppDetailController);

	PortalAppDetailController.$inject = [ '$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'PortalApp', '$state', 'ModuleSettings' ];

	function PortalAppDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, PortalApp, $state, ModuleSettings) {
		var vm = this;

		vm.portalApp = entity;
		vm.previousState = previousState.name;
		vm.byteSize = DataUtils.byteSize;
		vm.openFile = DataUtils.openFile;

		vm.loadAll = loadAll;

		var unsubscribe = $rootScope.$on('pharmaPortalApp:portalAppUpdate', function(event, result) {
			vm.portalApp = result;
		});
		$scope.$on('$destroy', unsubscribe);

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.applicationsModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PortalAppDeleteController',PortalAppDeleteController);

	PortalAppDeleteController.$inject = ['$uibModalInstance', 'entity', 'PortalApp', '$state', 'ModuleSettings'];

	function PortalAppDeleteController($uibModalInstance, entity, PortalApp, $state, ModuleSettings) {
		var vm = this;

		vm.report = entity;
		vm.clear = clear;
		vm.confirmDelete = confirmDelete;
		vm.loadAll = loadAll;

		function clear () {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmDelete (id) {
			PortalApp.delete({id: id}, function () { $uibModalInstance.close(true); });
		}

		function loadAll () {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function (result) {
				vm.moduleSettings = result;

				if(!vm.moduleSettings.applicationsModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PortalAppBoardController', PortalAppBoardController);

	PortalAppBoardController.$inject = [ 'DataUtils', 'PortalApp', 'ParseLinks', '$http', '$stateParams', '$state', 'ModuleSettings' ];

	function PortalAppBoardController(DataUtils, PortalApp, ParseLinks, $http, $stateParams, $state, ModuleSettings) {
		var vm = this;

		vm.portalApps = [];

		vm.loadAll = loadAll;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.applicationsModule) {
					$state.go('accessdenied');
				} else {
					vm.portalApps = PortalApp.query();
				}
			});
		}
		loadAll();
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider
				.state('portal-app', {
					parent : 'entity',
					url : '/portal-app?page&sort&search',
					data : {
						authorities : [ 'ROLE_USER' ],
						pageTitle : 'pharmaPortalApp.portalApp.home.title'
					},
					views : {
						'content@' : {
							templateUrl : 'app/entities/portal-app/portal-apps.html',
							controller : 'PortalAppController',
							controllerAs : 'vm'
						}
					},
					params : {
						page : {
							value : '1',
							squash : true
						},
						sort : {
							value : 'id,asc',
							squash : true
						},
						search : null
					},
					resolve : {
						pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
							return {
								page : PaginationUtil.parsePage($stateParams.page),
								sort : $stateParams.sort,
								predicate : PaginationUtil.parsePredicate($stateParams.sort),
								ascending : PaginationUtil.parseAscending($stateParams.sort),
								search : $stateParams.search
							};
						} ],
						translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('portalApp');
							$translatePartialLoader.addPart('global');
							return $translate.refresh();
						} ]
					}
				})
				.state('portal-app-detail', {
					parent : 'portal-app',
					url : '/portal-app/{id}',
					data : {
						authorities : [ 'ROLE_USER' ],
						pageTitle : 'pharmaPortalApp.portalApp.home.title'
					},
					views : {
						'content@' : {
							templateUrl : 'app/entities/portal-app/portal-app-detail.html',
							controller : 'PortalAppDetailController',
							controllerAs : 'vm'
						}
					},
					resolve : {
						translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('portalApp');
							return $translate.refresh();
						} ],
						entity : [ '$stateParams', 'PortalApp', function($stateParams, PortalApp) {
							return PortalApp.get({
								id : $stateParams.id
							}).$promise;
						} ],
						previousState : [ "$state", function($state) {
							var currentStateData = {
								name : $state.current.name || 'portal-app',
								params : $state.params,
								url : $state.href($state.current.name, $state.params)
							};
							return currentStateData;
						} ]
					}
				})
				.state('portal-app-detail.edit', {
					parent : 'portal-app-detail',
					url : '/detail/edit',
					data : {
						authorities : [ 'ROLE_USER' ]
					},
					onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
						$uibModal.open({
							templateUrl : 'app/entities/portal-app/portal-app-dialog.html',
							controller : 'PortalAppDialogController',
							controllerAs : 'vm',
							backdrop : 'static',
							size : 'lg',
							resolve : {
								entity : [ 'PortalApp', function(PortalApp) {
									return PortalApp.get({
										id : $stateParams.id
									}).$promise;
								} ]
							}
						}).result.then(function() {
							$state.go('^', {}, {
								reload : false
							});
						}, function() {
							$state.go('^');
						});
					} ]
				})
				.state(
						'portal-app.new',
						{
							parent : 'portal-app',
							url : '/new',
							data : {
								authorities : [ 'ROLE_USER' ]
							},
							onEnter : [
									'$stateParams',
									'$state',
									'$uibModal',
									function($stateParams, $state, $uibModal) {
										$uibModal
												.open({
													templateUrl : 'app/entities/portal-app/portal-app-dialog.html',
													controller : 'PortalAppDialogController',
													controllerAs : 'vm',
													backdrop : 'static',
													size : 'lg',
													resolve : {
														entity : function() {
															return {
																title : null,
																link : null,
																thumbnail : "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",
																thumbnailContentType : "image/png",
																parent : null,
																id : null
															};
														}
													}
												}).result.then(function() {
											$state.go('portal-app', null, {
												reload : 'portal-app'
											});
										}, function() {
											$state.go('portal-app');
										});
									} ]
						}).state('portal-app.edit', {
					parent : 'portal-app',
					url : '/{id}/edit',
					data : {
						authorities : [ 'ROLE_USER' ]
					},
					onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
						$uibModal.open({
							templateUrl : 'app/entities/portal-app/portal-app-dialog.html',
							controller : 'PortalAppDialogController',
							controllerAs : 'vm',
							backdrop : 'static',
							size : 'lg',
							resolve : {
								entity : [ 'PortalApp', function(PortalApp) {
									return PortalApp.get({
										id : $stateParams.id
									}).$promise;
								} ]
							}
						}).result.then(function() {
							$state.go('portal-app', null, {
								reload : 'portal-app'
							});
						}, function() {
							$state.go('^');
						});
					} ]
				}).state('portal-app.delete', {
					parent : 'portal-app',
					url : '/{id}/delete',
					data : {
						authorities : [ 'ROLE_USER' ]
					},
					onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
						$uibModal.open({
							templateUrl : 'app/entities/portal-app/portal-app-delete-dialog.html',
							controller : 'PortalAppDeleteController',
							controllerAs : 'vm',
							size : 'md',
							resolve : {
								entity : [ 'PortalApp', function(PortalApp) {
									return PortalApp.get({id : $stateParams.id}).$promise;
								} ]
							}
						}).result.then(function() {
							$state.go('portal-app', null, {
								reload : 'portal-app'
							});
						}, function() {
							$state.go('^');
						});
					} ]
				}).state('portal-app-board', {
					parent : 'portal-app',
					url : '/portal-app-board',
					data : {
						authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
						pageTitle : 'pharmaPortalApp.portalApp.home.title'
					},
					views : {
						'content@' : {
							templateUrl : 'app/entities/portal-app/portal-app-board.html',
							controller : 'PortalAppBoardController',
							controllerAs : 'vm'
						}
					},
					resolve : {
						translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
							$translatePartialLoader.addPart('portalApp');
							return $translate.refresh();
						} ],
						previousState : [ "$state", function($state) {
							var currentStateData = {
								name : $state.current.name || 'portal-app',
								params : $state.params,
								url : $state.href($state.current.name, $state.params)
							};
							return currentStateData;
						} ]
					}
				});
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PortalAppController', PortalAppController);

    PortalAppController.$inject = ['Notification', 'DataUtils', 'PortalApp', 'ParseLinks', 'paginationConstants', 'pagingParams', '$state', 'ModuleSettings'];

    function PortalAppController(Notification, DataUtils, PortalApp, ParseLinks, paginationConstants, pagingParams, $state, ModuleSettings) {

        var vm = this;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.loadAll = loadAll;

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        loadAll();

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {

                vm.moduleSettings = result;
                if (!vm.moduleSettings.applicationsModule) {
                    $state.go('accessdenied');
                } else {
                    PortalApp.query({
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, onSuccess, onError);
                }
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.portalApps = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ProductStockQtdImportController', ProductStockQtdImportController);

    ProductStockQtdImportController.$inject = ['Notification', 'blockUI', '$uibModalInstance', '$translate', '$stateParams', 'ProductStockQtd', 'Upload'];

    function ProductStockQtdImportController(Notification, blockUI, $uibModalInstance, $translate, $stateParams, ProductStockQtd, Upload) {
        var vm = this;

        vm.excelAction = "update";
        vm.clear = clear;
        vm.uploadFile = uploadFile;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        ProductStockQtd.query({
            id: $stateParams.id
        }, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.productStockQtds = data;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }

        function uploadFile(file) {
            blockUI.start($translate.instant('pharmaPortalApp.policyDefinition.productStockQtd.message.uploadingFile'));

            file.upload = Upload.upload({
                url: '/api/product-stock-qtd/upload',
                fields: {
                    excelAction: vm.excelAction,
                    policyInputId: $stateParams.id
                },
                file: file
            }).then(function (response) {
                blockUI.stop();
                $uibModalInstance.dismiss('cancel');

                if (response.data.success) {
                    Notification.success({message: response.data.message, delay: 5000});
                } else {
                    Notification.error({message: response.data.message, delay: ''});
                }

            }, function (response) {
                blockUI.stop();

                if (response.data.success) {
                    Notification.success({message: response.data.message, delay: 5000});
                } else {
                    Notification.error({message: response.data.message, delay: ''});
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ProductStockQtdExportController', ProductStockQtdExportController);

    ProductStockQtdExportController.$inject = ['Notification', 'blockUI', '$http', '$uibModalInstance', '$stateParams', '$translate'];

    function ProductStockQtdExportController(Notification, blockUI, $http, $uibModalInstance, $stateParams, $translate) {
        var vm = this;

        vm.clear = clear;
        vm.exportToExcel = exportToExcel;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function exportToExcel() {
            blockUI.start($translate.instant('pharmaPortalApp.policyDefinition.productStockQtd.message.exportingFile'));

            $http.get("/api/product-stock-qtd/" + $stateParams.id + "/export", {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, "Lista_artigos_a_condicionar.xlsx", true);
                blockUI.stop();
                //Notification.success({message: response.data.message, delay: 5000});

            }, function errorCallback(response) {
                blockUI.stop();
                Notification.error({message: response.data.message, delay: ''});
            });
            vm.clear()
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('product-stock-qtd-list', {
            parent: 'policy-definition',
            url: '/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-definition/policy-entities/product-stock-qtd.html',
                    controller: 'ProductStockQtdController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md'
                }).result.then(function () {
                    $state.go('policy-definition', {}, {
                        reload: false
                    });
                }, function () {
                    $state.go('^');
                });
            }]
        }).state('product-stock-qtd-import', {
            parent: 'policy-definition',
            url: '/{id}/import',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-definition/policy-entities/product-stock-qtd-import.html',
                    controller: 'ProductStockQtdImportController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md'
                }).result.then(function () {
                    $state.go('policy-definition', {}, {
                        reload: false
                    });
                }, function () {
                    $state.go('^');
                });
            }]
        }).state('product-stock-qtd-export', {
            parent: 'policy-definition',
            url: '/{id}/export',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-definition/policy-entities/product-stock-qtd-export.html',
                    controller: 'ProductStockQtdExportController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md'
                }).result.then(function () {
                    $state.go('policy-definition', {}, {
                        reload: false
                    });
                }, function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ProductStockQtdController', ProductStockQtdController);

    ProductStockQtdController.$inject = ['Notification', '$uibModalInstance', '$translate', '$stateParams', 'ProductStockQtd'];

    function ProductStockQtdController(Notification, $uibModalInstance, $translate, $stateParams, ProductStockQtd) {
        var vm = this;

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        ProductStockQtd.query({
            id: $stateParams.id
        }, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.productStockQtds = data;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PolicyDefinitionEditDialogController', PolicyDefinitionEditDialogController);

    PolicyDefinitionEditDialogController.$inject = ['Notification', '$uibModalInstance', '$http', '$translate', '$scope', 'PolicyDefinition', '$uibModal', 'records', 'policyImplementations', 'policyTypes', 'policyType', 'newPolicy', '$window', '$q'];

    function PolicyDefinitionEditDialogController(Notification, $uibModalInstance, $http, $translate, $scope, PolicyDefinition, $uibModal, records, policyImplementations, policyTypes, policyType, newPolicy, $window, $q) {

        /***********************************************************************/
        /*** COMPONENTE PARA EDITAR/APAGAR MULTIPLAS HIERARQUIAS EM BULK *******/
        /*** VALIDO PARA HIERARQUIAS QUE PARTILHEM O MESMO METODO DE CALCULO ***/
        /***********************************************************************/

        var vm = this;
        $scope.policyDefinition = null;
        $scope.records = records;
        $scope.policyImplementations = policyImplementations;
        $scope.policyTypes = policyTypes;
        $scope.policyType = policyType;
        $scope.newPolicy = newPolicy;
        $scope.multiplePolicyDefinition = false;
        $scope.saveState = 0;
        $scope.hierarchySelections = [];
        $scope.hierarchySelectionIds = [];

        vm.doInit = doInit;
        vm.clear = clear;
        vm.nextSaveState = nextSaveState;
        vm.previousSaveState = previousSaveState;
        vm.isValidToDelete = isValidToDelete;
        vm.isImplDefined = isImplDefined;
        vm.deletePolicies = deletePolicies;
        vm.savePolicies = savePolicies;
        vm.getTemplate = getTemplate;
        vm.createNewPolicyDefinition = createNewPolicyDefinition;
        vm.initializePolicyDefinition = initializePolicyDefinition;
        vm.translateString = translateString;
        vm.addToSelectList = addToSelectList;
        var loadingItem = {type: 'loading'}, hasNextChunk = true;

        doInit();

        function doInit() {
            if ($scope.newPolicy === true) {
                $scope.policyDefinition = createNewPolicyDefinition();
                $scope.records = [$scope.policyDefinition];
                $scope.saveState = 1;
            } else if ($scope.records) {
                $scope.multiplePolicyDefinition = $scope.records.length > 1;
                if ($scope.records.length > 0) {
                    angular.forEach($scope.records, function (policyDefinition) {
                        initializePolicyDefinition(policyDefinition);
                    });
                    $scope.policyDefinition = $scope.records[0];
                }
            }
        }

        function createNewPolicyDefinition() {
            var policyDefinition = new PolicyDefinition();
            policyDefinition.policyType = $scope.policyType.fqn;
            $http.get("api/policy-builder/hierarchy/" + policyDefinition.policyType).then(function (result) {
                if (policyDefinition.hierarchy == null) {
                    policyDefinition.hierarchy = result.data;
                }
                angular.forEach(result.data.metadata, function (k) {
                    if (k.type === 'select' || k.type === 'enum') {
                        $http.get("api/" + k.url + "/").then(function (result) {
                            policyDefinition.hierarchy[k.name + "_list"] = result.data;
                        });
                    }
                });
            });
            return policyDefinition;
        }

        function initializePolicyDefinition(policyDefinition) {
            if (policyDefinition.hierarchy && policyDefinition.hierarchy.metadata) {
                angular.forEach(policyDefinition.hierarchy.metadata, function (value) {
                    if (value.type === 'select' || value.type === 'enum') {
                        $http.get("api/" + value.url + "/").then(function (result) {
                            policyDefinition.hierarchy[value.name + "_list"] = result.data;
                            if (policyDefinition.hierarchy[value.name]) {
                                policyDefinition.hierarchy[value.name] = eval("(" + policyDefinition.hierarchy[value.name] + ")");
                            }
                        });
                    }
                    if (value.type === 'searchSelect') {
                        if (policyDefinition.hierarchy[value.name]) {
                            policyDefinition.hierarchy[value.name] = eval("(" + policyDefinition.hierarchy[value.name] + ")");
                        }
                    }
                });
            }

            if (policyDefinition.input && policyDefinition.input.metadata) {
                angular.forEach(policyDefinition.input.metadata, function (value) {
                    if (value.type === 'date') {
                        if (policyDefinition.input[value.name] != null) {
                            policyDefinition.input[value.name] = moment(policyDefinition.input[value.name]).format('YYYY-MM-DD HH:mm');
                        }
                    }
                    if (value.type === 'select' || value.type === 'listSelect') {
                        $http.get("api/" + value.url + "/").then(function (result) {
                            policyDefinition.input[value.name + "_list"] = result.data;
                            if (policyDefinition.input[value.name]) {
                                policyDefinition.input[value.name] = eval("(" + policyDefinition.input[value.name] + ")");
                            }
                        });
                    }
                });
            }
        }

        function translateString(str) {
            return $translate.instant(str);
        }

        function nextSaveState() {
            $scope.saveState++;
        }

        function previousSaveState() {
            $scope.saveState--;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function isValidToDelete() {
            return $scope.records && $scope.records[0].id;
        }

        function isImplDefined() {
            return $scope.policyDefinition != null && $scope.policyDefinition.policyImplementation != null;
        }

        function deletePolicies() {
            $uibModal.open({
                templateUrl: 'app/entities/policy-definition/policy-definition-delete-dialog.html',
                controller: 'PolicyDefinitionDeleteDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    records: function () {
                        return $scope.records;
                    }
                }
            }).result.then(function (res) {
                $uibModalInstance.close(res);
            }, function () {
            });
        }

        function savePolicies() {
            angular.forEach($scope.records, function (policyDefinition) {
                if (policyDefinition.hierarchy.clientType) {
                    policyDefinition.hierarchy.clientType = JSON.stringify(policyDefinition.hierarchy.clientType);
                }
                if (policyDefinition.hierarchy.clientGroup) {
                    policyDefinition.hierarchy.clientGroup = JSON.stringify(policyDefinition.hierarchy.clientGroup);
                }
                if (policyDefinition.hierarchy.client) {
                    policyDefinition.hierarchy.client = JSON.stringify(policyDefinition.hierarchy.client);
                }
                if (policyDefinition.hierarchy.thirdParty) {
                    policyDefinition.hierarchy.thirdParty = JSON.stringify(policyDefinition.hierarchy.thirdParty);
                }
                if (policyDefinition.hierarchy.laboratory) {
                    policyDefinition.hierarchy.laboratory = JSON.stringify(policyDefinition.hierarchy.laboratory);
                }
                if (policyDefinition.hierarchy.product) {
                    policyDefinition.hierarchy.product = JSON.stringify(policyDefinition.hierarchy.product);
                }
                if (policyDefinition.hierarchy.customer) {
                    policyDefinition.hierarchy.customer = JSON.stringify(policyDefinition.hierarchy.customer);
                }
                if (policyDefinition.hierarchy.supplier) {
                    policyDefinition.hierarchy.supplier = JSON.stringify(policyDefinition.hierarchy.supplier);
                }
                if (policyDefinition.hierarchy.companyType) {
                    policyDefinition.hierarchy.companyType = JSON.stringify(policyDefinition.hierarchy.companyType);
                }
                if (policyDefinition.hierarchy.productList) {
                    policyDefinition.hierarchy.productList = JSON.stringify(policyDefinition.hierarchy.productList);
                }
                if (policyDefinition.hierarchy.modelList) {
                    policyDefinition.hierarchy.modelList = JSON.stringify(policyDefinition.hierarchy.modelList);
                }
                if (policyDefinition.hierarchy.username) {
                    policyDefinition.hierarchy.username = JSON.stringify(policyDefinition.hierarchy.username);
                }
                /* ATENÇAO NAO CORRER  JSON.stringify SOBRE HIERARQUIAS DO TIPO STRING, EX: A STRING "TRADE" VAI SER TRANSFORMADA EM ""TRADE"" E ISSO ESTRAGA O SQL QUANDO SE FOR A PROCURA DA POLITICA */
            });

            if ($scope.policyDefinition != null && $scope.policyDefinition.policyImplementation != null) {
                if ($scope.policyDefinition.input) {
                    if ($scope.policyDefinition.input.priceList) {
                        $scope.policyDefinition.input.priceList = JSON.stringify($scope.policyDefinition.input.priceList);
                    }
                    if ($scope.policyDefinition.input.warehouse) {
                        $scope.policyDefinition.input.warehouse = JSON.stringify($scope.policyDefinition.input.warehouse);
                    }
                    if ($scope.policyDefinition.input.logisticValueBasePriceList) {
                        $scope.policyDefinition.input.logisticValueBasePriceList = JSON.stringify($scope.policyDefinition.input.logisticValueBasePriceList);
                    }

                    var tmp_id;
                    angular.forEach($scope.records, function (policyDefinition) {
                        tmp_id = policyDefinition.input.id;
                        policyDefinition.input = angular.copy($scope.policyDefinition.input);
                        policyDefinition.input.id = tmp_id;
                    });

                    if ($scope.policyDefinition.id != null) {
                        PolicyDefinition.updateAll($scope.records, onSaveFinished, onSaveError);
                    } else {
                        PolicyDefinition.save($scope.policyDefinition, onSaveFinished, onSaveError);
                    }
                } else {
                    Notification.error({message: "Erro a guardar parâmetros do método de cálculo", delay: 5000});
                }
            } else {
                Notification.error({message: "Não indicou um método de cálculo válido", delay: 5000});
            }
        }

        var onSaveError = function (response) {
            if (response.status === 406) {
                Notification.error({
                    message: $translate.instant('pharmaPortalApp.policyDefinition.policyHierarchy.hash.notUnique'),
                    delay: 5000
                });
            } else {
                Notification.error({message: "Erro ao gravar política(s). Verifique parametrizações", delay: 5000});
            }
        }

        var onSaveFinished = function () {
            Notification.success({message: "Política(s) guardada(s) com sucesso", delay: 5000});
            clearHierarchySelections();
            if (!$scope.newPolicy) {
                $uibModalInstance.close(true);
            }
        };

        function getTemplate(templatePath) {
            $window.open(templatePath);
        }

        function addLoadingStateItem() {
            $scope.typeaheadArray.push(loadingItem);
        }

        function removeLoadingStateItem() {
            var index = $scope.typeaheadArray.indexOf(loadingItem);
            if (index < 0) {
                return;
            }
            $scope.typeaheadArray.splice(index, 1);
        }

        /******************************* SCOPED ***************************************/
        $scope.requestMoreItems = function (field) {
            if ($scope.isRequestMoreItems || !hasNextChunk) {
                $scope.isRequestMoreItems = false;
                return $q.reject();
            }

            addLoadingStateItem();

            $scope.isRequestMoreItems = true;
            return $scope.loadDataForTypeahead($scope.lastPage + 1, $scope.lastNeedle, field.url)
                .then(function (result) {
                    //se ja existir é porque nao há mais
                    if (result.data.length === 0) {
                        hasNextChunk = false;
                        return $q.reject();
                    } else {
                        $scope.typeaheadArray = $scope.typeaheadArray.concat(result.data);
                    }
                    return result;
                }, function (err) {
                    return $q.reject(err);
                })
                .finally(function () {
                    removeLoadingStateItem();
                    $scope.isRequestMoreItems = false;
                });
        };

        $scope.refreshList = function (field, query) {
            if ($scope.lastNeedle === query) {
                return;
            }
            hasNextChunk = true;
            $scope.loadDataForTypeahead(0, query, field.url).then(function (result) {
                $scope.typeaheadArray = result.data;
            });
        };

        $scope.loadDataForTypeahead = function (page, needle, url) {
            $scope.lastNeedle = needle;
            $scope.lastPage = page;
            return $http.get("api/" + url + "/", {params: {query: needle, page: page, size: 30}});
        }

        $scope.refreshSelectModel = function (query, url, fieldName) {
            $http.get("api/" + url + "/" + query).then(function (result) {
                if (result.data.length > 500) {
                    Notification.success({
                        message: "O número de resultados é superior a 500 registos. Por questões de performance, refine a sua pesquisa",
                        delay: 5000
                    });
                } else {
                    $scope.policyDefinition.hierarchy[fieldName + '_list'] = result.data;
                }
            });
        };

        $scope.updateInputs = function () {
            if ($scope.policyDefinition.policyImplementation != null) {
                $http.get("api/policy-builder/input/" + $scope.policyDefinition.policyImplementation).then(function (result) {
                    $scope.policyDefinition.input = result.data;
                }).finally(function () {
                    $scope.refreshInputs();
                });
            } else {
                $scope.policyDefinition.input = {metadata: []};
                $scope.refreshInputs();
            }
        }

        $scope.refreshInputs = function () {
            angular.forEach($scope.policyDefinition.input.metadata, function (value) {
                if (value.type === 'date') {
                    if ($scope.policyDefinition.input[value.name] != null) {
                        $scope.policyDefinition.input[value.name] = moment($scope.policyDefinition.input[value.name]).format('YYYY-MM-DD HH:mm');
                    }
                }
                if (value.type === 'select' || value.type === 'listSelect') {
                    $http.get("api/" + value.url + "/").then(function (result) {
                        $scope.policyDefinition.input[value.name + "_list"] = result.data;
                    });
                }
            });
        }

        $scope.addNew = function (fieldName) {
            if (!angular.isObject($scope.policyDefinition.input[fieldName])) {
                $scope.policyDefinition.input[fieldName] = [];
            }
            $scope.policyDefinition.input[fieldName].push('');
        }

        $scope.addNew12 = function (fieldName) {
            if (!angular.isObject($scope.policyDefinition.input[fieldName])) {
                $scope.policyDefinition.input[fieldName] = [];
            }
            var i;
            for (i = 1; i <= 12; i++) {
                $scope.policyDefinition.input[fieldName].push('');
            }
        }

        function addToSelectList(selectInput) {
            if ($scope.hierarchySelectionIds.indexOf(selectInput.generatedId) === -1) {
                $scope.hierarchySelections.push(selectInput);
                $scope.hierarchySelectionIds.push(selectInput.generatedId);
            }
        }

        function clearHierarchySelections() {
            $scope.hierarchySelectionIds = [];
            angular.forEach($scope.hierarchySelections, function (value) {
                value.selected = null;
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PolicyDefinitionDeleteDialogController', PolicyDefinitionDeleteDialogController);

    PolicyDefinitionDeleteDialogController.$inject = ['Notification', '$uibModalInstance', '$scope', '$translate', 'records', 'PolicyDefinition'];

    function PolicyDefinitionDeleteDialogController(Notification, $uibModalInstance, $scope, $translate, records, PolicyDefinition) {
        var vm = this;

        $scope.records = records;

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.getPolicyDesc = getPolicyDesc;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getPolicyDesc(policyDefinition) {
            return $translate.instant(policyDefinition.policyImplementation) + ' ' + policyDefinition.input.metadataValues;
        };

        function confirmDelete() {
            if ($scope.records) {
                var ids = [];
                angular.forEach($scope.records, function (value) {
                    ids.push(value.id);
                });

                PolicyDefinition.deleteBulk(ids, function () {
                    Notification.success({
                        message: "Política(s) apagada com sucesso",
                        delay: 5000
                    });
                    $uibModalInstance.close(true);
                }, function () {
                    Notification.error({
                        message: "Erro ao apagar política(s)",
                        delay: 5000
                    });
                    $uibModalInstance.close(false);
                });
            } else {
                $uibModalInstance.close(false);
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('policy-definition', {
            parent: 'entity',
            url: '/policy-definitions',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'pharmaPortalApp.policyDefinition.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/policy-definition/policy-definitions.html',
                    controller: 'PolicyDefinitionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('policyDefinition');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('policy-definition.delete', {
            parent: 'policy-definition',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-definition/policy-definition-delete-dialog.html',
                    controller: 'PolicyDefinitionDeleteDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        records: ['PolicyDefinition', function (PolicyDefinition) {
                            return [PolicyDefinition.get({
                                id: $stateParams.id
                            }).$promise];
                        }]
                    }
                }).result.then(function () {
                    $state.go('^');
                }, function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PolicyDefinitionController', PolicyDefinitionController);
    PolicyDefinitionController.$inject = ['Notification', '$scope', '$http', '$translate', 'PolicyDefinition', '$rootScope', '$window', '$q', '$uibModal'];

    function PolicyDefinitionController(Notification, $scope, $http, $translate, PolicyDefinition, $rootScope, $window, $q, $uibModal) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.reloadPolicyDefinitions = reloadPolicyDefinitions;
        vm.policyTypeSelection = policyTypeSelection;
        vm.stringEntity = stringEntity;
        vm.selectNode = selectNode;
        vm.hasPolicyDefinitionNode = hasPolicyDefinitionNode;
        vm.isPolicyDefinitionNode = isPolicyDefinitionNode;
        vm.toggleNode = toggleNode;
        vm.collapseAll = collapseAll;
        vm.expandAll = expandAll;
        vm.toggleSelectAll = toggleSelectAll;
        vm.updateSelection = updateSelection;
        vm.translateString = translateString;
        vm.openModal = openModal;
        vm.openModalEditForSelection = openModalEditForSelection;
        vm.openModalForNewPolicy = openModalForNewPolicy;
        vm.checkIfPolicyInputMatches = checkIfPolicyInputMatches;
        vm.initializePolicyDefinitionHierarchy = initializePolicyDefinitionHierarchy;

        vm.clearFilter = clearFilter;
        vm.toggleFilter = toggleFilter;
        vm.showNode = showNode;

        $scope.policyTypes = [];
        $scope.policyType;
        $scope.policyDefinitions = [];
        $scope.policyDefinition;
        $scope.selectedPolicyDefinition;
        $scope.searchPolicyDefinition;
        $scope.policyImplementations = [];
        $scope.policyImplementationsSelector = [];
        $scope.selectedNodes = [];
        $scope.typeaheadArray = [];
        $scope.lastNeedle = '';
        $scope.lastPage = 0;


        $scope.isSelectAll = false;
        $scope.filterObject = {};
        $scope.showFilter = false;

        function loadAll() {
            // GET POLICIES LIST
            $http.get("api/policy-builder/interfacesBySettings").then(function (result) {
                $scope.policyTypes = [];

                angular.forEach(result.data, function (v) {
                    $scope.policyTypes.push({
                        'fqn': v,
                        'name': $translate.instant(v)
                    });
                });
            });
        }


        vm.loadAll();

        function clearFilter() {
            $scope.filterObject = {};
            $scope.showFilter = false;
        }

        function toggleFilter() {
            $scope.showFilter = !$scope.showFilter
        }

        function isEmptyObject(obj) {
            return (obj && (Object.keys(obj).length === 0));
        }

        function showNode(node) {
            if (node && node.data && node.data.hierarchy && !isEmptyObject($scope.filterObject)) {
                // console.log(JSON.stringify({data: $scope.filterObject}, null, 4));
                var filterKeys = Object.keys($scope.filterObject);

                for (var key in filterKeys) {
                    // for (var key of Object.keys($scope.filterObject)) {
                    var value = $scope.filterObject[filterKeys[key]];
                    // var value = $scope.filterObject[key];
                    if (!value || (value === $translate.instant("select.none") || value === $translate.instant("select.all"))) {
                        continue;
                    }
                    if (filterKeys[key] === 'selectedImpl') {
                        return node.data.policyImplementation === value;
                    } else {
                        var nodeJson = node.data.hierarchy[filterKeys[key]];
                        var valueJson = JSON.stringify(value);
                        if (nodeJson !== valueJson) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }

        function stringEntity(node) {
            var stripNode = null;
            try {
                stripNode = JSON.parse(node);
            } catch (e) {
                //Strings sem estar no formato {x:y} ( tipo "TRADE" pex) dao erro
                return $translate.instant('context.' + node);
            }
            return "(" + stripNode.code + ") - " + stripNode.name;
        }

        function policyTypeSelection(selectedPolicy) {
            $scope.isSelectAll = false;
            clearFilter();

            $scope.policyType = selectedPolicy;
            if (selectedPolicy) {
                reloadPolicyDefinitions(true);

                $http.get("api/policy-builder/implementationsBySettings/" + $scope.policyType.fqn).then(function (result) {
                    $scope.policyImplementationsSelector.push($translate.instant("select.all"));
                    for (var i = 0; i < result.data.length; i++) {
                        $scope.policyImplementations.push(result.data[i]);
                        $scope.policyImplementationsSelector.push(result.data[i]);
                    }
                });
            } else {
                $scope.policyDefinitions = [];
            }
        }

        function reloadPolicyDefinitions(reloadImplementations) {
            $scope.searchPolicyDefinition = null;
            $scope.policyDefinition = null;
            $scope.policyDefinitions = [];
            if (reloadImplementations) {
                $scope.policyImplementations = [];
                $scope.policyImplementationsSelector = [];
            }

            $http.get("api/_tree/policy-definitions/" + $scope.policyType.fqn).then(function (result) {
                $scope.policyDefinitions = result.data;
                if ($scope.policyDefinitions && $scope.policyDefinitions.children &&
                    $scope.policyDefinitions.children.length > 0) {
                    $scope.searchPolicyDefinition = angular.copy($scope.policyDefinitions.children[0].data);
                    // inicializar para se ter as combos preenchidas
                    initializePolicyDefinitionHierarchy($scope.searchPolicyDefinition);
                }
            });

            // repor os selecionados se houver
            if ($scope.selectedNodes && $scope.selectedNodes.length > 0) {
                var reloadedSelectedNodes = [];
                angular.forEach($scope.selectedNodes, function (selected) {
                    angular.forEach($scope.policyDefinitions, function (policyDefinition) {
                        if (selected.id === policyDefinition.id) {
                            policyDefinition.selected = true;
                            reloadedSelectedNodes.push(angular.copy(policyDefinition));
                        }
                    });
                });

                $scope.selectedNodes = reloadedSelectedNodes;
            }
        }

        function initializePolicyDefinitionHierarchy(policyDefinition) {
            // $SCOPE.POLICYDEFINITION.HIERARCHY.METADATA
            if (policyDefinition.hierarchy && policyDefinition.hierarchy.metadata) {
                angular.forEach(policyDefinition.hierarchy.metadata, function (value) {
                    if (value.type === 'select' || value.type === 'enum') {
                        $http.get("api/" + value.url + "/").then(function (result) {
                            policyDefinition.hierarchy[value.name + "_list"] = result.data;
                            if (policyDefinition.hierarchy[value.name]) {
                                policyDefinition.hierarchy[value.name] = eval("(" + policyDefinition.hierarchy[value.name] + ")");
                            }
                        });
                    }

                    if (value.type === 'searchSelect') {
                        if (policyDefinition.hierarchy[value.name]) {
                            policyDefinition.hierarchy[value.name] = eval("(" + policyDefinition.hierarchy[value.name] + ")");
                        }
                    }
                });
            }
        }

        function selectNode(node, showModal) {
            if (node.id) {
                $scope.policyDefinition = angular.copy(node);
                $scope.selectedPolicyDefinition = node;
            } else {
                $scope.policyDefinition = angular.copy(node.$modelValue.data);
                $scope.selectedPolicyDefinition = node.$modelValue.data;
            }

            if (showModal === true) {
                openModal([$scope.policyDefinition]);
            }
        }

        function hasPolicyDefinitionNode(node) {
            if (node && node.children[0] && node.children[0].data && node.children[0].data.hierarchy) {
                return node.children[0].data.hierarchy !== 'undefined';
            } else {
                return false;
            }
        }

        function isPolicyDefinitionNode(node) {
            if (node && node.data && node.data.hierarchy) {
                return node.data.hierarchy !== 'undefined';
            } else {
                return false;
            }
        }

        function toggleNode(node) {
            node.toggle();
        }

        function collapseAll() {
            $scope.$broadcast('angular-ui-tree:collapse-all');
        }

        function expandAll() {
            $scope.$broadcast('angular-ui-tree:expand-all');
        }

        function toggleSelectAll() {
            expandAll();
            angular.forEach($scope.policyDefinitions.children, function (value) {
                updateSelectionRecursive(value, $scope.isSelectAll);
            });
        }

        function updateSelectionRecursive(node, selected) {
            if (isPolicyDefinitionNode(node)) {
                // se houver seleccao sao so os visiveis
                if (selected && !showNode(node)) {
                    selected = false;
                }
                node.selected = selected;
                updateSelection(node.data, selected);
            } else if (node.children) {
                angular.forEach(node.children, function (value) {
                    updateSelectionRecursive(value, selected);
                });
            }
        }

        function updateSelection(nodeData, selected) {
            var index = $scope.selectedNodes.findIndex(function (i) {
                return i.id === nodeData.id
            });
            if (selected === true && index === -1) {
                $scope.selectedNodes.push(angular.copy(nodeData));
            } else if (selected === false && index !== -1) {
                $scope.selectedNodes.splice(index, 1);
            }
        }

        function openModalEditForSelection() {
            if ($scope.selectedNodes && $scope.selectedNodes.length > 0) {
                openModal($scope.selectedNodes);
            } else {
                Notification.warning({
                    message: $translate.instant('pharmaPortalApp.policyDefinition.selectedNodes.empty'),
                    delay: 5000
                });
            }
        }

        function openModalForNewPolicy() {
            openModal([], true);
        }

        function openModal(nodesArray, newPolicy) {
            if (nodesArray && nodesArray.length > 1) {
                if (!checkIfPolicyInputMatches(nodesArray)) {
                    Notification.warning({
                        message: $translate.instant('pharmaPortalApp.policyDefinition.selectedNodes.metadataMatchesFail'),
                        delay: 5000
                    });
                    return;
                }
            }

            $uibModal.open({
                templateUrl: 'app/entities/policy-definition/policy-definition-edit-dialog.html',
                controller: 'PolicyDefinitionEditDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    records: function () {
                        return nodesArray;
                    },
                    policyImplementations: function () {
                        return $scope.policyImplementations;
                    },
                    policyTypes: function () {
                        return $scope.policyTypes;
                    },
                    policyType: function () {
                        return $scope.policyType;
                    },
                    newPolicy: function () {
                        return newPolicy;
                    }
                }
            }).result.then(function () {
                reloadPolicyDefinitions(false);
            }, function () {
                reloadPolicyDefinitions(false);
            });
        }

        function checkIfPolicyInputMatches(nodesArray) {
            if (nodesArray && nodesArray.length > 0) {
                var first = nodesArray[0].input['@class'];
                var comp;
                for (var i = 1; i < nodesArray.length; i++) {
                    comp = nodesArray[i].input['@class'];
                    if (first !== comp) {
                        return false;
                    }
                }
                return true;
            }
            return false;
        }

        function translateString(str) {
            return $translate.instant(str);
        }


        $scope.refreshSelectModelForSearchPolicyDefinition = function (query, url, fieldName) {
            $http.get("api/" + url + "/" + query).then(function (result) {
                if (result.data.length > 500) {
                    Notification.success({
                        message: "O número de resultados é superior a 500 registos. Por questões de performance, refine a sua pesquisa",
                        delay: 5000
                    });
                } else {
                    $scope.searchPolicyDefinition.hierarchy[fieldName + '_list'] = result.data;
                }
            });
        };
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaTransfReceptionSubmitController', PharmaTransfReceptionSubmitController);

	PharmaTransfReceptionSubmitController.$inject = [ 'Notification', 'blockUI', '$uibModalInstance', '$translate', '$state', '$http', '$filter', 'entity', 'PharmaTransfReception', 'PortalSettings' ];

	function PharmaTransfReceptionSubmitController(Notification, blockUI, $uibModalInstance, $translate, $state, $http, $filter, entity, PharmaTransfReception, PortalSettings) {
		var vm = this;

		vm.portalSettings = PortalSettings.query();
		
		vm.loadAll = loadAll;
		vm.getWarehouseFullDescription = getWarehouseFullDescription;
		vm.getTransferTypeFullDescription = getTransferTypeFullDescription;
		
		vm.clear = clear;
		vm.confirmPharmaTransfReceptionSubmit = confirmPharmaTransfReceptionSubmit;
		vm.hasDiffs = false;
		vm.pharmaTransfReception = entity;

		function loadAll() {
			$http.get("api/common/_searchWarehousesForSelect").then(function(result) {
				vm.warehouses = result.data;
			});
			$http.get("api/common/_searchQualityStatusesForSelect").then(function(result) {
				vm.qualityStatuses = [ {
					"code" : '',
					"description" : ''
				} ].concat(result.data);
			});
			$http.get("api/common/_getTransferTypeDescription").then(function(result) {
				vm.transferTypes = result.data;
			});

			$http.get("api/pharma-transf-reception/" + entity.id + "/getLinesDiffs").then(function(result) {
				vm.pharmaTransfReceptionLines = [];
				angular.forEach(result.data, function(value, key) {
					if (vm.hasDiffs == false) {
						vm.hasDiffs = value.quantitydifferences != 0;
					}
					if(value.quantitydifferences != 0){
						vm.pharmaTransfReceptionLines.push(value);
					}
				});
			});
		}
		vm.loadAll();

		function getWarehouseFullDescription(warehouseCode) {
			if (angular.isDefined(vm.warehouses) && warehouseCode != '') {
				var warehouse = $filter('filter')(vm.warehouses, {
					code : warehouseCode
				})[0];
				return warehouseCode + (warehouse != null ? ' - ' + warehouse.description : '');
			} else {
				return warehouseCode;
			}
		}

		function getTransferTypeFullDescription(transferTypeCode) {
			if (angular.isDefined(vm.transferTypes) && transferTypeCode != '') {
				var transferType = $filter('filter')(vm.transferTypes, {
					code : transferTypeCode
				})[0];
				return transferTypeCode + (transferType != null ? ' - ' + transferType.description : '');
			} else {
				return transferTypeCode;
			}
		}
		
		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function onSubmitSuccess(result) {
			$uibModalInstance.close(true);
			blockUI.stop();
			if (result.success){
				Notification.success({message: result.message, delay: 5000});
				$state.go("pharma-transf-reception", {}, {
					reload : true
				});
			} else {
				Notification.error({message: result.message, delay: ''});
				$state.go("pharma-transf-reception-edit", {
					id : vm.pharmaTransfReception.id
				}, {
					reload : true
				});
			}
		}

		function onSubmitError(result) {
			$uibModalInstance.close(true);
			blockUI.stop();
			
			if(result.success) {
				Notification.success({message: result.message, delay: 5000});
			} else {
				Notification.error({message: result.message, delay: ''});
			}
		}

		function confirmPharmaTransfReceptionSubmit() {
			blockUI.start($translate.instant('pharmaPortalApp.pharmaTransfReception.message.submittingPharmaTransfReception'));
			PharmaTransfReception.submit({
				id : vm.pharmaTransfReception.id
			}, onSubmitSuccess, onSubmitError);
		}

	}
})();

(function() {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaTransfReceptionInactiveController', PharmaTransfReceptionInactiveController);

    PharmaTransfReceptionInactiveController.$inject = [ '$uibModalInstance', '$rootScope', '$state', 'ModuleSettings' ];

    function PharmaTransfReceptionInactiveController($uibModalInstance, $rootScope, $state, ModuleSettings) {
        var vm = this;

        vm.clear = clear;
        vm.confirmAddProducts = confirmAddProducts;
        vm.loadAll = loadAll;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmAddProducts() {
            $rootScope.searchProductsAction()
            $uibModalInstance.close(true);
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function(result) {
                vm.moduleSettings = result;

                /*if (!vm.moduleSettings.productsModule) {
                    $state.go('accessdenied');
                }*/
            });
        }
        loadAll();
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaTransfReceptionNewController', PharmaTransfReceptionNewController);

	PharmaTransfReceptionNewController.$inject = [ 'Notification', '$scope', '$state', '$http', '$filter', 'PharmaTransfReception', 'Principal', 'ModuleSettings', 'Company', '$rootScope' ];

	function PharmaTransfReceptionNewController(Notification, $scope, $state, $http, $filter, PharmaTransfReception, Principal, ModuleSettings, Company, $rootScope) {
		var vm = this;

        $scope.sortType = "autoSort";
        $scope.sortReverse = true;

		vm.isSaving = false;
		vm.destinationWarehouse = null;
		vm.currentPharmaTransfReceptionHeader = [];

		vm.loadAll = loadAll;
		vm.getWarehouseFullDescription = getWarehouseFullDescription;
		vm.getTransferTypeFullDescription = getTransferTypeFullDescription;
		vm.getInvoiceTypeFullDescription = getInvoiceTypeFullDescription;
		vm.getClientFullDescription = getClientFullDescription;
		vm.save = save;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.receptionsWarehouseTransfModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						account ? vm.account = account : vm.account = null;
					});

					$http.get("api/common/_searchWarehousesForSelect").then(function(result) {
						vm.warehouses = result.data;
					});

					$http.get("api/common/_getTransferTypeDescription").then(function(result) {
						vm.transferTypes = result.data;
					});

					$http.get("api/common/_searchInvoiceTypesForSelect").then(function(result) {
						vm.invoiceTypes = result.data;
					});

					$http.get("api/companies/withWarehouse").then(function(result) {
						vm.clients = result.data;
					});
				}
			});
		}
		vm.loadAll();

		$scope.getReceptionsFromDestinationWarehouse = function($item, $model) {
			if ($item) {
                Company.isInactive({"id":$item.code}, function (result) {
                    if (result.regDate != null) {
                        result.regDate = result.regDate.substring(6, 8) + "-" + result.regDate.substring(4, 6) + "-" + result.regDate.substring(0, 4);
                        result.regTime = result.regTime.substring(0, 2) + ":" + result.regTime.substring(2, 4) + ":" + result.regTime.substring(4, 6);
                        result.company = $item.code + ' - ' + $item.description;
                        $rootScope.message = result;
                        vm.destinationWarehouse = null;
                        $state.go("pharma-transf-reception.inactive");
                    } else {
                        $http.post("api/common/_searchErpUniqueWarehouseTransfers", $item.code).then(function (result) {
                            vm.currentPharmaTransfReceptionHeader = result.data;
                        });
                    }
                });
			}
		};

		function getWarehouseFullDescription(warehouseCode) {
			if (angular.isDefined(vm.warehouses) && warehouseCode != '') {
				var warehouse = $filter('filter')(vm.warehouses, {
					code : warehouseCode
				})[0];
				return warehouseCode + (warehouse != null ? ' - ' + warehouse.description : '');
			} else {
				return warehouseCode;
			}
		}

		function getTransferTypeFullDescription(transferTypeCode) {
			if (angular.isDefined(vm.transferTypes) && transferTypeCode != '') {
				var transferType = $filter('filter')(vm.transferTypes, {
					code : transferTypeCode
				})[0];
				return transferTypeCode + (transferType != null ? ' - ' + transferType.description : '');
			} else {
				return transferTypeCode;
			}
		}

		function getInvoiceTypeFullDescription(invoiceTypeCode) {
			if (angular.isDefined(vm.invoiceTypes) && invoiceTypeCode != '') {
				var invoiceType = $filter('filter')(vm.invoiceTypes, {
					code : invoiceTypeCode
				})[0];
				return invoiceTypeCode + (invoiceType != null ? ' - ' + invoiceType.description : '');
			} else {
				return invoiceTypeCode;
			}
		}

		function getClientFullDescription(clientPE) {
			var client = clientPE.substring(0, clientPE.length - 2);
			var deliveryPoint = clientPE.substring(clientPE.length - 2, clientPE.length);

			if (angular.isDefined(vm.clients) && clientPE && clientPE != '' && clientPE.length > 2) {
				var clientDesc = $filter('filter')(vm.clients, {
					client : parseInt(clientPE.substring(0, clientPE.length - 2)),
					deliveryPoint : parseInt(clientPE.substring(clientPE.length - 2, clientPE.length))
				})[0];
				return client + '(' + deliveryPoint + ')' + (clientDesc != null ? ' - ' + clientDesc.naming : '');
			} else {
				return clientPE != "0" ? client + '(' + deliveryPoint + ')' : "";
			}
		}

		function save(key) {
			vm.isSaving = true;
			$http.post("api/common/_createWarehouseTransferFromErpByKey", {
				destinationWarehouse : vm.destinationWarehouse,
				key : key
			}).then(function(result) {
				vm.isSaving = false;
				$state.go("pharma-transf-reception-edit", {
					id : result.data.id
				});
			}, function(result) {
				vm.isSaving = false;
				if (result.status == 400) {
					Notification.error({ message : "Esta guia está em utilização no ERP", delay : '' });
				}
			});
		}

		vm.datePopup = {
			opened : false
		};

		vm.openDatePopup = function() {
			vm.datePopup.opened = true;
		};

		vm.dateOptions = {
			formatYear : 'yyyy',
			startingDay : 1,
			showWeeks : false
		};

		$scope.floatTheadOptions = {
			position : 'absolute',
			responsiveContainer : function($table) {
				return $table.closest(".table-responsive");
			}
		};
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaTransfReceptionLineNewController', PharmaTransfReceptionLineNewController);

	PharmaTransfReceptionLineNewController.$inject = [ 'Notification', '$uibModalInstance', '$scope', '$state', '$http', 'entity', 'PharmaTransfReceptionLine' ];

	function PharmaTransfReceptionLineNewController(Notification, $uibModalInstance, $scope, $state, $http, entity, PharmaTransfReceptionLine) {
		var vm = this;

		vm.clear = clear;
		vm.createPharmaTransfReceptionLine = createPharmaTransfReceptionLine;
		vm.loadSelects = loadSelects;

		vm.isSaving = false;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function onSaveSuccess(result) {
			vm.isSaving = false;
			$state.go("pharma-transf-reception-edit", {
				id : entity.id
			}, {
				reload : true
			});
			Notification.success({ message : "Linha adicionada com sucesso", delay : 5000 });
			$uibModalInstance.close(true);
		}

		function onSaveError(result) {
			vm.isSaving = false;

			if (result.data.success) {
				Notification.success({ message : result.data.message, delay : 5000 });
			} else {
				Notification.error({ message : result.data.message, delay : '' });
			}
		}

		function createPharmaTransfReceptionLine() {
			vm.isSaving = true;
			vm.pharmaTransfReceptionLine.pharmaTransfReceptionHeader = entity;
			vm.pharmaTransfReceptionLine.cnp = vm.pharmaTransfReceptionLine.product.cnp;
			vm.pharmaTransfReceptionLine.description = vm.pharmaTransfReceptionLine.product.fullName;
			vm.pharmaTransfReceptionLine.vatRate = vm.pharmaTransfReceptionLine.product.txiva;

			vm.pharmaTransfReceptionLine.invoicedQuantity = 0;

			vm.pharmaTransfReceptionLine.internalCode = vm.pharmaTransfReceptionLine.product.code;
			vm.pharmaTransfReceptionLine.modelCode = vm.pharmaTransfReceptionLine.product.model;
			vm.pharmaTransfReceptionLine.packageCode = vm.pharmaTransfReceptionLine.product.pack;
			vm.pharmaTransfReceptionLine.grandFamilyCode = vm.pharmaTransfReceptionLine.product.bigfam;
			vm.pharmaTransfReceptionLine.erpLine = false;

			PharmaTransfReceptionLine.save(vm.pharmaTransfReceptionLine, onSaveSuccess, onSaveError);
		}

		function loadSelects() {
			$http.get("api/common/_searchQualityStatusesForSelect").then(function(result) {
				vm.qualityStatuses = [{ "code" : '', "description" : '' }].concat(result.data);
			});
		}
		vm.loadSelects();

		$scope.onOpenClose = function(isOpen) {
			angular.element('.ui-select-choices-row').removeClass('active');
		}

		$scope.refreshSelectModel = function(query) {
			$http.get("api/common/_searchProductsForSelect/" + query).then(function(result) {
				if (result.data.length > 500) {
					Notification.warning({ message : "O número de resultados é superior a 500 registos. Por questões de performance, refine a sua pesquisa", delay : 5000 });
					return;
				} else {
					vm.products = result.data;
				}
			});
		};
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaTransfReceptionLineDeleteController', PharmaTransfReceptionLineDeleteController);

	PharmaTransfReceptionLineDeleteController.$inject = [ 'Notification', '$uibModalInstance', '$translate', '$state', 'entity', 'PharmaTransfReceptionLine' ];

	function PharmaTransfReceptionLineDeleteController(Notification, $uibModalInstance, $translate, $state, entity, PharmaTransfReceptionLine) {
		var vm = this;

		vm.clear = clear;
		vm.confirmPharmaTransfReceptionLineDelete = confirmPharmaTransfReceptionLineDelete;
		vm.pharmaTransfReceptionLine = entity;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function onDeleteSuccess(result) {
			$uibModalInstance.close(true);
			
			Notification.success({message: $translate.instant('pharmaPortalApp.pharmaTransfReception.message.pharmaTransfReceptionLineDeleted'), delay: 5000});
		}

		function onDeleteError(result) {
			$uibModalInstance.close(true);
			
			if(result.data.success) {
				Notification.success({message: result.data.message, delay: 5000});
			} else {
				Notification.error({message: result.data.message, delay: ''});
			}
		}

		function confirmPharmaTransfReceptionLineDelete() {
			PharmaTransfReceptionLine.delete({id: vm.pharmaTransfReceptionLine.id}, onDeleteSuccess, onDeleteError);
		}
		
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaTransfReceptionEditController', PharmaTransfReceptionEditController);

	PharmaTransfReceptionEditController.$inject = [ 'Notification', 'blockUI', 'previousState', '$scope', '$state', '$filter', '$http', '$window', '$translate', '$uibModal', 'ParseLinks', 'PharmaTransfReception', 'Upload',
			'entity', 'PortalSettings', 'ModuleSettings' ];

	function PharmaTransfReceptionEditController(Notification, blockUI, previousState, $scope, $state, $filter, $http, $window, $translate, $uibModal, ParseLinks, PharmaTransfReception, Upload, entity, PortalSettings, ModuleSettings) {
		var vm = this;

		vm.portalSettings = PortalSettings.query();
		vm.pharmaTransfReception = entity;
		vm.working = false;
		vm.previousState = previousState.name;

		vm.loadAll = loadAll;
		vm.submitPharmaTransfReception = submitPharmaTransfReception;
		vm.save = save;
		vm.backToReceptions = backToReceptions;
		vm.togglePharmaTransfReceptionLineEditMode = togglePharmaTransfReceptionLineEditMode;
		vm.onBlurFromLot = onBlurFromLot;
		vm.onBlurFromReceivedQuantity = onBlurFromReceivedQuantity;
		vm.getTemplate = getTemplate;
		vm.uploadFile = uploadFile;
		vm.exportToExcel = exportToExcel;
		vm.exportToLogitoolsExcel = exportToLogitoolsExcel;
		vm.getWarehouseFullDescription = getWarehouseFullDescription;
		vm.getTransferTypeFullDescription = getTransferTypeFullDescription;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function (result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.receptionsWarehouseTransfModule) {
					$state.go('accessdenied');
				} else {
					vm.manualReceptionLines = $filter('filter')(vm.pharmaTransfReception.pharmaTransfReceptionLines, {erpLine:false});

					$http.get("api/common/_searchQualityStatusesForSelect").then(function(result) {
						vm.qualityStatuses = [ { "code" : '', "description" : '' } ].concat(result.data);
					});

					$http.get("api/common/_searchWarehousesForSelect").then(function(result) {
						vm.warehouses = result.data;
					});

					$http.get("api/common/_getTransferTypeDescription").then(function(result) {
						vm.transferTypes = result.data;
					});
				}
			});
		}
		vm.loadAll();

		function submitPharmaTransfReception() {
			if (isDataValidForSubmission()){
				PharmaTransfReception.save(vm.pharmaTransfReception, onSaveSuccessFromSubmit, onSaveError);
			}
		}

		function isDataValidForSubmission(){
			var errors = [];
			if (angular.isDefined(vm.pharmaTransfReception.pharmaTransfReceptionLines) && vm.pharmaTransfReception.pharmaTransfReceptionLines.length > 0){
				for (var i = 0; i < vm.pharmaTransfReception.pharmaTransfReceptionLines.length; i++) {
					var value = vm.pharmaTransfReception.pharmaTransfReceptionLines[i];
					var receivedQuantity = (value.receivedQuantity != null && angular.isNumber(value.receivedQuantity) && !isNaN(value.receivedQuantity) ? value.receivedQuantity : 0);
					// negative quantities
					if (receivedQuantity < 0){
						errors.push($translate.instant('pharmaPortalApp.pharmaTransfReception.message.error.negativeQuantities', {cnp: value.cnp}));
					}
				}
				if (errors.length > 0){
					var message = '';
					for (var i = 0; i < errors.length; i++){
						if (i > 0){
							message += '<br>';
						}
						message += errors[i];
					}
					Notification.error({message: $translate.instant('pharmaPortalApp.pharmaTransfReception.message.error.submission') + '<br>' + message, delay: ''});
					return false;
				}
				return true;
			} else {
				Notification.error({message: $translate.instant('pharmaPortalApp.pharmaTransfReception.message.error.submission') + $translate.instant('pharmaPortalApp.pharmaTransfReception.message.error.noLines'), delay: ''});
				return false;
			}
		}

		function onSaveSuccessFromSubmit() {
			vm.working = false;
			$uibModal.open({
				templateUrl : 'app/entities/pharma-transf-reception/pharma-transf-reception-submit-dialog.html',
				controller : 'PharmaTransfReceptionSubmitController',
				controllerAs : 'vm',
				size : 'lg modal-exl',
				resolve : {
					entity : [ 'PharmaTransfReception', function(PharmaTransfReception) {
						return PharmaTransfReception.get({
							id : vm.pharmaTransfReception.id
						}).$promise;
					} ]
				}
			}).result.then(function() {
				// success callback implemented on own controller
			}, function() {
				$state.go('pharma-transf-reception-edit', {
					id : vm.pharmaTransfReception.id
				}, {
					reload : false
				});
			});
		}

		function save() {
			vm.working = true;
			PharmaTransfReception.save(vm.pharmaTransfReception, onSaveSuccess, onSaveError);
		}

		function onSaveSuccess(result) {
			vm.working = false;
			$state.go("pharma-transf-reception-edit", { id : result.id });
		}

		function onSaveError(result) {
			vm.working = false;
			if(result.data.success) {
				Notification.success({message: result.data.message, delay: 5000});
			} else {
				Notification.error({message: result.data.message, delay: ''});
			}
		}

		function backToReceptions(){
			// se nenhuma linha recepcionada apaga
			vm.manualReceptionLines = $filter('filter')(vm.pharmaTransfReception.pharmaTransfReceptionLines, {erpLine:false});
			if(vm.manualReceptionLines.length === 0) {
				PharmaTransfReception.delete({id: vm.pharmaTransfReception.id});
			}
			if(vm.previousState = 'pharma-transf-reception-edit') {
				$state.go('pharma-transf-reception');
			}else{
				$state.go(vm.previousState);
			}

		}

		function togglePharmaTransfReceptionLineEditMode(pharmaTransfReceptionLine) {
			pharmaTransfReceptionLine.editMode = !(angular.isDefined(pharmaTransfReceptionLine.editMode) && pharmaTransfReceptionLine.editMode == true);
			save();
		}

		function onBlurFromLot(pharmaTransfReceptionLine) {
			if (angular.isDefined(pharmaTransfReceptionLine.lot) && pharmaTransfReceptionLine.lot != null) {
				pharmaTransfReceptionLine.lot = pharmaTransfReceptionLine.lot.toUpperCase();
			}
			save();
		}

		function onBlurFromReceivedQuantity(pharmaTransfReceptionLine) {
			// check valid quantity
			if (pharmaTransfReceptionLine.receivedQuantity == null) {
				pharmaTransfReceptionLine.receivedQuantity = pharmaTransfReceptionLine.oldReceivedQuantity;
				return;
			}
			if (pharmaTransfReceptionLine.receivedQuantity < 0) {
				pharmaTransfReceptionLine.errorOnReceivedQuantity = true;
			} else {
				pharmaTransfReceptionLine.errorOnReceivedQuantity = false;
			}
			pharmaTransfReceptionLine.oldReceivedQuantity = pharmaTransfReceptionLine.receivedQuantity;
			save();
		}

		function getTemplate() {
			$window.open("api/pharma-transf-reception/template");
		}

		function uploadFile(file) {
			vm.working = true;
			save();
			blockUI.start($translate.instant('pharmaPortalApp.pharmaTransfReception.message.uploadingTemplate'));
			file.upload = Upload.upload({
				url : 'api/pharma-transf-reception/upload',
				fields : {
					pharmaTransfReceptionHeaderId : vm.pharmaTransfReception.id
				},
				file : file
			}).then(function(response) {
				file.result = response.data;
				if(response.data.success) {
					Notification.success({message: response.data.message, delay: 5000});
				} else {
					Notification.error({message: response.data.message, delay: ''});
				}

				$state.go("pharma-transf-reception-edit", { id : vm.pharmaTransfReception.id }, { reload : true });
				vm.working = false;
				blockUI.stop();
			}, function(response) {
				if (response.status == 200) {
					if(response.data.success) {
						Notification.success({message: response.data.message, delay: 5000});
					} else {
						Notification.error({message: response.data.message, delay: ''});
					}
				} else {
					Notification.error({message: response.status + ': ' + response.data, delay: ''});
				}

				$state.go("pharma-transf-reception-edit", { id : vm.pharmaTransfReception.id }, { reload : true });
				vm.working = false;
				blockUI.stop();
			}, function(evt) {
				// Math.min is to fix IE which reports 200% sometimes
				file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
			});
		}

		function exportToExcel() {
			save();
			$http.get("api/pharma-transf-reception/" + vm.pharmaTransfReception.id + "/toExcel", {
				responseType : "arraybuffer"
			}).then(function successCallback(response) {
				var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
				var blob = new Blob([ response.data ], {
					type : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				});
                saveAs(blob, "Recepção_" + vm.pharmaTransfReception.id + "_" + dateTime + ".xlsx", true);
				Notification.success({message: "Recepção exportada com sucesso", delay: 5000});
			}, function errorCallback(response) {
				Notification.error({message: "Erro ao exportar recepção", delay: ''});
			});
		}

		function exportToLogitoolsExcel() {
			if (isDataValidForSubmission()) {
				save();
				$http.get("api/pharma-transf-reception/" + vm.pharmaTransfReception.id + "/toLogitoolsExcel", {
					responseType : "arraybuffer"
				}).then(function successCallback(response) {
					var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
					var blob = new Blob([ response.data ], {
						type : "application/vnd.ms-excel"
					});
					saveAs(blob, "Recepção_" + vm.pharmaTransfReception.id + "_" + dateTime + ".xlsx", true);
					Notification.success({message: "Recepção exportada com sucesso", delay: 5000});
				}, function errorCallback(response) {
					Notification.error({message: "Erro ao exportar recepção", delay: ''});
				});
			} else {
				$("html, body").animate({
					scrollTop : 0
				});
			}
		}

		function getWarehouseFullDescription(warehouseCode) {
			if (angular.isDefined(vm.warehouses) && warehouseCode != '') {
				var warehouse = $filter('filter')(vm.warehouses, {
					code : warehouseCode
				})[0];
				return warehouseCode + (warehouse != null ? ' - ' + warehouse.description : '');
			} else {
				return warehouseCode;
			}
		}

		function getTransferTypeFullDescription(transferTypeCode) {
			if (angular.isDefined(vm.transferTypes) && transferTypeCode != '') {
				var transferType = $filter('filter')(vm.transferTypes, {
					code : transferTypeCode
				})[0];
				return transferTypeCode + (transferType != null ? ' - ' + transferType.description : '');
			} else {
				return transferTypeCode;
			}
		}

		$scope.floatTheadOptions = {
			position : 'absolute',
			responsiveContainer : function($table) {
				return $table.closest(".table-responsive");
			}
		};

		vm.datePopup = { opened : false };
		vm.openDatePopup = function() { vm.datePopup.opened = true; };
		vm.dateOptions = { formatYear : 'yyyy', startingDay : 1, showWeeks : false };
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaTransfReceptionDetailController', PharmaTransfReceptionDetailController);

	PharmaTransfReceptionDetailController.$inject = [ '$uibModalInstance', '$http', '$filter', 'pharmaTransfReception', 'PharmaTransfReception' ];

	function PharmaTransfReceptionDetailController($uibModalInstance, $http, $filter, pharmaTransfReception, PharmaTransfReception) {
		var vm = this;

		vm.pharmaTransfReception = pharmaTransfReception;

		vm.clear = clear;
		vm.loadAll = loadAll;
		vm.getWarehouseFullDescription = getWarehouseFullDescription;
		vm.getTransferTypeFullDescription = getTransferTypeFullDescription;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function loadAll() {
			vm.manualReceptionLines = $filter('filter')(vm.pharmaTransfReception.pharmaTransfReceptionLines, { erpLine : false });
			
			$http.get("api/common/_searchWarehousesForSelect").then(function(result) {
				vm.warehouses = result.data;
			});
			$http.get("api/common/_getTransferTypeDescription").then(function(result) {
				vm.transferTypes = result.data;
			});
		}
		vm.loadAll();

		function getWarehouseFullDescription(warehouseCode) {
			if (angular.isDefined(vm.warehouses)) {
				var warehouse = $filter('filter')(vm.warehouses, {
					code : warehouseCode
				})[0];
				return warehouseCode + (warehouse != null ? ' - ' + warehouse.description : '');
			} else {
				return warehouseCode;
			}
		}

		function getTransferTypeFullDescription(transferTypeCode) {
			if (angular.isDefined(vm.transferTypes) && transferTypeCode != '') {
				var transferType = $filter('filter')(vm.transferTypes, {
					code : transferTypeCode
				})[0];
				return transferTypeCode + (transferType != null ? ' - ' + transferType.description : '');
			} else {
				return transferTypeCode;
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaTransfReceptionDeleteController', PharmaTransfReceptionDeleteController);

	PharmaTransfReceptionDeleteController.$inject = [ 'Notification', '$uibModalInstance', '$translate', '$state', '$http', '$filter', 'pharmaTransfReception', 'PharmaTransfReception' ];

	function PharmaTransfReceptionDeleteController(Notification, $uibModalInstance, $translate, $state, $http, $filter, pharmaTransfReception, PharmaTransfReception) {
		var vm = this;

		vm.clear = clear;
		vm.confirmPharmaTransfReceptionDelete = confirmPharmaTransfReceptionDelete;
		vm.pharmaTransfReception = pharmaTransfReception;
		
		vm.loadAll = loadAll;
		vm.getWarehouseFullDescription = getWarehouseFullDescription;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function onDeleteSuccess(result) {
			$uibModalInstance.close(true);
			Notification.success({message: $translate.instant('pharmaPortalApp.pharmaTransfReception.message.pharmaTransfReceptionDeleted'), delay: 5000});
		}

		function onDeleteError(result) {
			$uibModalInstance.close(true);
			
			if(result.data.success) {
				Notification.success({message: result.data.message, delay: 5000});
			} else {
				Notification.error({message: result.data.message, delay: ''});
			}
		}

		function confirmPharmaTransfReceptionDelete() {
			PharmaTransfReception.delete({id: pharmaTransfReception.id}, onDeleteSuccess, onDeleteError);
		}

		function loadAll() {
			$http.get("api/common/_searchWarehousesForSelect").then(function(result) {
				vm.warehouses = result.data;
			});
		}
		vm.loadAll();

		function getWarehouseFullDescription(warehouseCode) {
			if (angular.isDefined(vm.warehouses)) {
				var warehouse = $filter('filter')(vm.warehouses, {
					code : warehouseCode
				})[0];
				return warehouseCode + (warehouse != null ? ' - ' + warehouse.description : '');
			} else {
				return warehouseCode;
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('pharma-transf-reception', {
			parent : 'entity',
			url : '/pharma-transf-reception',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaTransfReception.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-transf-reception/pharma-transf-reception.html',
					controller : 'PharmaTransfReceptionController',
					controllerAs : 'vm'
				}
			},
			params : {
				page : {
					value : '1',
					squash : true
				},
				sort : {
					value : 'receptionDate,desc',
					squash : true
				}
			},
			resolve : {
				pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
					return {
						page : PaginationUtil.parsePage($stateParams.page),
						sort : $stateParams.sort,
						predicate : PaginationUtil.parsePredicate($stateParams.sort),
						ascending : PaginationUtil.parseAscending($stateParams.sort)
					};
				} ],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaTransfReception');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-transf-reception-edit', {
			parent : 'entity',
			url : '/pharma-transf-reception/:id/edit',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaTransfReception.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-transf-reception/pharma-transf-reception-edit.html',
					controller : 'PharmaTransfReceptionEditController',
					controllerAs : 'vm',
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaTransfReception');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'PharmaTransfReception', function($stateParams, PharmaTransfReception) {
					return PharmaTransfReception.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'pharma-transf-reception',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		}).state('pharma-transf-reception.new', {
			parent : 'entity',
			url : '/pharma-transf-reception/new',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaTransfReception.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-transf-reception/pharma-transf-reception-new.html',
					controller : 'PharmaTransfReceptionNewController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaTransfReception');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'pharma-transf-reception',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		}).state('pharma-transf-reception.delete', {
			parent : 'pharma-transf-reception',
			url : '/{id}/delete',
			method : 'DELETE',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-transf-reception/pharma-transf-reception-delete-dialog.html',
					controller : 'PharmaTransfReceptionDeleteController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						pharmaTransfReception : [ 'PharmaTransfReception', function(PharmaTransfReception) {
							return PharmaTransfReception.get({
								id : $stateParams.id
							});
						} ]
					}
				}).result.then(function() {
					$state.go('pharma-transf-reception', null, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-transf-reception-line', {
			parent : 'entity',
			url : '/pharma-transf-reception-line',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaTransfReception.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-transf-reception/pharma-transf-reception-line.html',
					controller : 'PharmaTransfReceptionController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaTransfReception');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-transf-reception-line.new', {
			parent : 'pharma-transf-reception-edit',
			url : '/newLine',
			method : 'POST',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-transf-reception/pharma-transf-reception-line-new-dialog.html',
					controller : 'PharmaTransfReceptionLineNewController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : [ 'PharmaTransfReception', function(PharmaTransfReception) {
							return PharmaTransfReception.get({
								id : $stateParams.id
							});
						} ]
					}
				}).result.then(function() {
					$state.go('pharma-transf-reception-line.new', {
						id : $stateParams.id
					}, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-transf-reception-line.delete', {
			parent : 'pharma-transf-reception-edit',
			url : '/delete/{lineId}',
			method : 'DELETE',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-transf-reception/pharma-transf-reception-line-delete-dialog.html',
					controller : 'PharmaTransfReceptionLineDeleteController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : [ 'PharmaTransfReceptionLine', function(PharmaTransfReceptionLine) {
							return PharmaTransfReceptionLine.get({
								id : $stateParams.lineId
							});
						} ]
					}
				}).result.then(function() {
					$state.go('pharma-transf-reception-edit', {
						id : $stateParams.id
					}, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-transf-reception-detail', {
			parent : 'pharma-transf-reception',
			url : '/{id}/detail',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-transf-reception/pharma-transf-reception-detail-dialog.html',
					controller : 'PharmaTransfReceptionDetailController',
					controllerAs : 'vm',
					backdrop : 'static',
					size : 'lg',
					resolve : {
						pharmaTransfReception : [ 'PharmaTransfReception', function(PharmaTransfReception) {
							return PharmaTransfReception.get({
								id : $stateParams.id
							}).$promise;
						} ]
					}
				}).result.then(function() {
					$state.go('pharma-transf-reception', {}, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-transf-reception.inactive', {
            parent : 'pharma-transf-reception.new',
            onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl : 'app/entities/pharma-transf-reception/pharma-transf-reception-new.inactive-dialog.html',
                    controller : 'PharmaTransfReceptionInactiveController',
                    controllerAs : 'vm',
                    size : 'md'
                }).result.then(function() {
                    $state.go('pharma-transf-reception.new', null, {
                        reload : true
                    });
                }, function() {
                    $state.go('^');
                });
            } ]
        });
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaTransfReceptionController', PharmaTransfReceptionController);

    PharmaTransfReceptionController.$inject = ['Notification', '$scope', '$state', '$http', '$filter', 'PharmaTransfReception', 'ParseLinks', 'paginationConstants', 'pagingParams', 'ModuleSettings'];

    function PharmaTransfReceptionController(Notification, $scope, $state, $http, $filter, PharmaTransfReception, ParseLinks, paginationConstants, pagingParams, ModuleSettings) {
        var vm = this;
        vm.loadAll = loadAll;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.getWarehouseFullDescription = getWarehouseFullDescription;
        vm.getTransferTypeFullDescription = getTransferTypeFullDescription;
        vm.getInvoiceTypeFullDescription = getInvoiceTypeFullDescription;
        vm.getClientFullDescription = getClientFullDescription;

        vm.loadAll();

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.receptionsWarehouseTransfModule) {
                    $state.go('accessdenied');
                } else {
                    PharmaTransfReception.query({
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, onSuccess, onError);

                    $http.get("api/common/_searchWarehousesForSelect").then(function (result) {
                        vm.warehouses = result.data;
                    });
                    $http.get("api/common/_searchInvoiceTypesForSelect").then(function (result) {
                        vm.invoiceTypes = result.data;
                    });
                    $http.get("api/common/_getTransferTypeDescription").then(function (result) {
                        vm.transferTypes = result.data;
                    });
                    $http.get("api/companies/findAll").then(function (result) {
                        vm.clients = result.data;
                    });
                }
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.pharmaTransfReceptionHeaders = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }

        function getWarehouseFullDescription(warehouseCode) {
            if (angular.isDefined(vm.warehouses) && warehouseCode) {
                var warehouse = $filter('filter')(vm.warehouses, {
                    code: warehouseCode
                })[0];
                return warehouseCode + (warehouse != null ? ' - ' + warehouse.description : '');
            } else {
                return warehouseCode;
            }
        }

        function getTransferTypeFullDescription(transferTypeCode) {
            if (angular.isDefined(vm.transferTypes) && transferTypeCode) {
                var transferType = $filter('filter')(vm.transferTypes, {
                    code: transferTypeCode
                })[0];
                return transferTypeCode + (transferType != null ? ' - ' + transferType.description : '');
            } else {
                return transferTypeCode;
            }
        }

        function getInvoiceTypeFullDescription(invoiceTypeCode) {
            if (angular.isDefined(vm.invoiceTypes) && invoiceTypeCode) {
                var invoiceType = $filter('filter')(vm.invoiceTypes, {
                    code: invoiceTypeCode
                })[0];
                return invoiceTypeCode + (invoiceType != null ? ' - ' + invoiceType.description : '');
            } else {
                return invoiceTypeCode;
            }
        }

        function getClientFullDescription(clientPE) {
            var client = clientPE.substring(0, clientPE.length - 2);
            var deliveryPoint = clientPE.substring(clientPE.length - 2, clientPE.length);

            if (angular.isDefined(vm.clients) && clientPE && clientPE != '' && clientPE.length > 2) {
                var clientDesc = $filter('filter')(vm.clients, {
                    client: parseInt(clientPE.substring(0, clientPE.length - 2)),
                    deliveryPoint: parseInt(clientPE.substring(clientPE.length - 2, clientPE.length))
                })[0];
                return client + '(' + deliveryPoint + ')' + (clientDesc != null ? ' - ' + clientDesc.naming : '');
            } else {
                return clientPE != "0" ? client + '(' + deliveryPoint + ')' : "";
            }
        }

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('TradeRemoveProductController', TradeRemoveProductController);

	TradeRemoveProductController.$inject = [ 'Notification', '$uibModalInstance', '$translate', 'entity', '$rootScope', '$state', 'Principal', 'ModuleSettings' ];

	function TradeRemoveProductController(Notification, $uibModalInstance, $translate, entity, $rootScope, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.cnpToDel = entity.cnpToDel;
		vm.product = null;

		vm.clear = clear;
		vm.confirmRemoveProduct = confirmRemoveProduct;
		vm.filterItemFromArray = filterItemFromArray;
		vm.deleteFilteredItem = deleteFilteredItem;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmRemoveProduct() {
			deleteFilteredItem(vm.cnpToDel, $rootScope.orderList);
			$rootScope.updateTotalizers();
			$uibModalInstance.close(true);
			Notification.success({message: $translate.instant('pharmaPortalApp.pharmaTrade.message.productDeleted'), delay: 5000});
		}

		function filterItemFromArray(cnpToDel, sourceArray) {
			vm.product = null;
			angular.forEach(sourceArray, function(obj, index) {
				if (obj.cnp === cnpToDel) {
					vm.product = obj;
					return;
				}
			});
		}

		function deleteFilteredItem(cnpToDel, sourceArray) {
			angular.forEach(sourceArray, function(obj, index) {
				if (obj.cnp === cnpToDel) {
					sourceArray.splice(index, 1);
					return;
				}
			});
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.tradesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if(account && account.company && account.company.clientType == "F") {
							filterItemFromArray(vm.cnpToDel, $rootScope.orderList);
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('TradeConfirmOrderController', TradeConfirmOrderController);

    TradeConfirmOrderController.$inject = ['Notification', '$uibModalInstance', '$q', '$rootScope', '$scope', 'Company', '$http', '$localStorage', '$state', '$filter',
        'Principal', 'ModuleSettings', 'PortalSettings'];

    function TradeConfirmOrderController(Notification, $uibModalInstance, $q, $rootScope, $scope, Company, $http, $localStorage, $state, $filter, Principal, ModuleSettings,
                                         PortalSettings) {
        var vm = this;
        vm.companies = [];
        vm.portalSettings = PortalSettings.query();

        vm.confirmOrder = confirmOrder;
        vm.selectCompany = selectCompany;
        vm.unselectCompany = unselectCompany;
        vm.clear = clear;
        vm.loadAll = loadAll;

        vm.order;
        vm.mybody;
        vm.processing = false;

        function confirmOrder() {
            if (!vm.order || !vm.order.company) {
                Notification.error({
                    message: "Não indicou a entidade receptora da encomenda",
                    delay: ''
                });
                return;
            }

            vm.processing = true;

            vm.mybody = {
                'clientTo': vm.order.company.client,
                'deliveryPointTo': vm.order.company.deliveryPoint,
                'description': vm.order.description,
                'orderProducts': $rootScope.orderList,
                "sellerHasDiffPrice": vm.portalSettings.sellerHasDiffPrice,
                "tradeInvoiceTypeCode": vm.portalSettings.tradeInvoiceTypeCode,
                "tradeInvoiceTypeDesc": vm.portalSettings.tradeInvoiceTypeDesc,
                "tradeCreditTypeCode": vm.portalSettings.tradeCreditTypeCode,
                "tradeCreditTypeDesc": vm.portalSettings.tradeCreditTypeDesc
            };

            var loopPromises = [];

            if (vm.portalSettings.priceFromPolicyForTrades && vm.portalSettings.sellerHasDiffPrice) {
                var customerTo = zeroPad(vm.order.company.client, 5)
                var deliveryPointTo = zeroPad(vm.order.company.deliveryPoint, 2);
                var clientPeTo = customerTo + '' + deliveryPointTo;

                vm.policyData = [];
                vm.policyName = "PharmaTradePriceCalculation";

                $($rootScope.orderList).each(function (index, prod) {
                    vm.policyData.push({
                        "hierarchy": [clientPeTo, prod.labcode, prod.cnp]
                    });
                    prod.hash = clientPeTo + "" + prod.labcode + "" + prod.cnp;
                });

                vm.requestBody = {
                    "policyType": vm.policyName,
                    "policyData": vm.policyData
                };

                var deferred = $q.defer();
                loopPromises.push(deferred.promise);

                $http.post("api/policyExecuter/execute", vm.requestBody).then(function (result) {
                    $($rootScope.orderList).each(function (index, prod) {
                        var curResult = $filter('filter')(result.data.output, {
                            hash: prod.hash
                        }, true);

                        if (curResult[0].result > 0) {
                            prod.priceTo = "" + curResult[0].result;
                            vm.mybody.orderProducts[index].priceTo = "" + curResult[0].result;
                        } else {
                            vm.mybody.orderProducts[index].priceTo = prod.price;
                        }
                    });
                    deferred.resolve();
                });
            } else {
                angular.forEach($rootScope.orderList, function (value, key) {
                    var deferred = $q.defer();
                    loopPromises.push(deferred.promise);
                    value.priceTo = value.price;
                    vm.mybody.orderProducts[key].priceTo = value.price;
                    deferred.resolve();
                });
            }

            $q.all(loopPromises).then(function () {
                saveOrderToServer(vm.mybody);
            });

        }

		function saveOrderToServer(requestBody) {
			$http.post("api/pharma-trade/saveOrder", requestBody).then(function successCallback(response) {
				$rootScope.orderList = [];
				$rootScope.totalizer = {
					qtd : 0,
					price : 0,
					docTotal : 0
				};
				$uibModalInstance.close(true);
				delete $localStorage.order;
				if (response.data.success) {
					Notification.success({
						message : response.data.message,
						delay : 5000
					});
				} else {
					Notification.error({
						message : response.data.message,
						delay : ''
					});
				}
				vm.processing = false;
			}, function errorCallback(response) {
				vm.processing = false;
				$uibModalInstance.close(true);
				Notification.error({
					message : response.data.message,
					delay : ''
				});
			});
		}

        function zeroPad(num, places) {
            var zero = places - num.toString().length + 1;
            return Array(+(zero > 0 && zero)).join("0") + num;
        }

		function selectCompany($item, $model) {
		    Company.isInactive($item, function (result) {
                if (result.regDate != null) {
                    result.regDate = result.regDate.substring(6,8) + "-" + result.regDate.substring(4,6) + "-" + result.regDate.substring(0,4);
                    result.regTime = result.regTime.substring(0,2) + ":" + result.regTime.substring(2,4) + ":" + result.regTime.substring(4,6);
                    result.company = $item.namingForOptions;
                    $rootScope.message = result;
                    vm.order = null;
                    $state.go("pharma-trade.inactive");
                }else {
                    vm.order.company = $item;
                }
            });
		}

        function unselectCompany($item, $model) {
            vm.order = null;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

				if (!vm.moduleSettings.tradesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (account && account.company && account.company.clientType == "F") {
							$http.get("api/companies/typePharmacy").then(function(result) {
								if (vm.portalSettings.onlyTradeInGroup) {
									angular.forEach(result.data, function(v, k) {
										if (account.company.clientGroup === v.clientGroup && account.company.id != v.id) {
											vm.companies.push(v);
										}
									});
								} else {
									angular.forEach(result.data, function(v, k) {
										if (account.company.id != v.id) {
											vm.companies.push(v);
										}
									});
								}
							});
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('TradeClearOrderController', TradeClearOrderController);

	TradeClearOrderController.$inject = [ 'Notification', '$uibModalInstance', '$translate', '$rootScope', '$localStorage', '$state', 'Principal', 'ModuleSettings' ];

	function TradeClearOrderController(Notification, $uibModalInstance, $translate, $rootScope, $localStorage, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmClearOrder = confirmClearOrder;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmClearOrder() {
			$rootScope.orderList = [];
			$rootScope.totalizer = {
				qtd : 0,
				price : 0,
				docTotal : 0
			};
			$uibModalInstance.close(true);
			delete $localStorage.tradeOrder;
			Notification.success({message : $translate.instant('pharmaPortalApp.pharmaTrade.message.tradeCleared'), delay : 5000});
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.tradesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (account && account.company && account.company.clientType == "F") {
							// DO NOTHING
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('pharma-trade', {
			parent : 'entity',
			url : '/pharma-trade',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ],
				pageTitle : 'pharmaPortalApp.pharmaTrade.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-trade/pharma-trades.html',
					controller : 'PharmaTradeController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaTrade');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-trade.clearOrder', {
			parent : 'pharma-trade',
			url : '/clear',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-trade/trade-clear-order-dialog.html',
					controller : 'TradeClearOrderController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-trade', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-trade.confirmOrder', {
			parent : 'pharma-trade',
			url : '/confirm',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-trade/trade-confirm-order-dialog.html',
					controller : 'TradeConfirmOrderController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-trade', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-trade.removeProduct', {
			parent : 'pharma-trade',
			url : '/removeProduct/{cnpToDel}',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-trade/trade-remove-product-dialog.html',
					controller : 'TradeRemoveProductController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : function() {
							return {
								cnpToDel : $stateParams.cnpToDel
							};
						}
					}
				}).result.then(function() {
					$state.go('pharma-trade', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-trade.inactive', {
            parent : 'pharma-trade.confirmOrder',
            onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl : 'app/entities/pharma-trade/pharma-trade.inactive-dialog.html',
                    controller : 'PharmaTradeInactiveController',
                    controllerAs : 'vm',
                    size : 'md'
                }).result.then(function() {
                    $state.go('pharma-trade.confirmOrder', null, {
                        reload : true
                    });
                }, function() {
                    $state.go('^');
                });
            } ]
        });
	}
})();

(function() {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaTradeInactiveController', PharmaTradeInactiveController);

    PharmaTradeInactiveController.$inject = [ '$uibModalInstance', '$rootScope', '$state', 'ModuleSettings' ];

    function PharmaTradeInactiveController($uibModalInstance, $rootScope, $state, ModuleSettings) {
        var vm = this;

        vm.clear = clear;
        vm.confirmAddProducts = confirmAddProducts;
        vm.loadAll = loadAll;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmAddProducts() {
            $rootScope.searchProductsAction()
            $uibModalInstance.close(true);
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function(result) {
                vm.moduleSettings = result;

                /*if (!vm.moduleSettings.productsModule) {
                    $state.go('accessdenied');
                }*/
            });
        }
        loadAll();
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaTradeController', PharmaTradeController);

    PharmaTradeController.$inject = ['Notification', '$q', '$rootScope', '$scope', '$http', 'PharmaTrade', '$localStorage', '$filter', '$state', 'ModuleSettings', 'PortalSettings', 'Principal'];

    function PharmaTradeController(Notification, $q, $rootScope, $scope, $http, PharmaTrade, $localStorage, $filter, $state, ModuleSettings, PortalSettings, Principal) {
        var vm = this;

        vm.portalSettings = PortalSettings.query()

        vm.loadAll = loadAll;
        vm.addProduct = addProduct;
        vm.isNumeric = isNumeric;
        vm.exportToExcel = exportToExcel;
        vm.toggleLineEditMode = toggleLineEditMode;
        vm.validateLines = validateLines;
        vm.lastQuery = "";
        vm.validPolicyPrice = false;

        vm.products;
        $rootScope.totalizer = {
            qtd: 0,
            price: 0,
            docTotal: 0
        };

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.tradesModule) {
                    $state.go('accessdenied');
                } else {
                    Principal.identity().then(function (account) {
                        if (account) {
                            vm.loggedUser = account.login;
                            if (account.company && account.company.clientType == "F") {
                                vm.loggedUserClientPe = account.clientPe;

                                if (account.company.pharmaWarehouse) {
                                    vm.loggedUserWarehouse = account.company.pharmaWarehouse;
                                } else {
                                    vm.loggedUserWarehouse = account.company.warehouse;
                                }
                            } else {
                                vm.loggedUserClientPe = null;
                                $state.go('accessdenied');
                            }
                        } else {
                            vm.loggedUser = null;
                            vm.loggedUserClientPe = null;
                            $state.go('accessdenied');
                        }
                    });
                    validateLines();
                }
            });
        }

        loadAll();

        function addProduct() {
            // SE "CNP" ESTÁ VAZIO
            if (!vm.products || !vm.products.selected || !vm.products.selected.cnp) {
                Notification.error({
                    message: "Não indicou nenhum artigo",
                    delay: ''
                });
                return;
            }

            // SE "Qtd" ESTÁ VAZIO OU NÃO NUMÉRICO OU É MENOR QUE ZERO
            if (!vm.products.selected.qtd) {
                Notification.error({
                    message: "Não indicou a quantidade a encomendar",
                    delay: ''
                });
                return;
            } else {
                vm.products.selected.qtd = vm.products.selected.qtd.toString().replace(",", ".");
                if (!isNumeric(vm.products.selected.qtd)) {
                    Notification.error({
                        message: "A quantidade a encomendar que indicou não é um número válido",
                        delay: ''
                    });
                    return;
                } else if (vm.products.selected.qtd < 1) {
                    Notification.error({
                        message: "A quantidade a encomendar tem de ser maior que zero",
                        delay: ''
                    });
                    return;
                }
            }

            // SE "Preço" ESTÁ VAZIO OU NÃO NUMÉRICO OU É MENOR QUE ZERO
            if (!vm.products.selected.price) {
                Notification.error({
                    message: "Não indicou o preço unitário do produto a encomendar",
                    delay: ''
                });
                return;
            } else {
                vm.products.selected.price = vm.products.selected.price.toString().replace(",", ".");
                if (!isNumeric(vm.products.selected.qtd)) {
                    Notification.error({
                        message: "O preço unitário que indicou não é um número válido",
                        delay: ''
                    });
                    return;
                } else {
                    if (vm.products.selected.price < 0) {
                        Notification.error({
                            message: "O preço unitário do produto tem de ser maior que zero",
                            delay: ''
                        });
                        return;
                    }
                }
            }

            // SE "CNP" VALIDA SE EXISTE NO ARRAY DE CNP"s
            if ($rootScope.orderList.length > 0) {
                var keepGoing = true;
                angular.forEach($rootScope.orderList, function (obj, index) {
                    if (keepGoing) {
                        if (obj.cnp === vm.products.selected.cnp) {
                            $rootScope.orderList.splice(index, 1);
                            keepGoing = false;
                        }
                    }
                });

                if (!keepGoing) {
                    Notification.warning({
                        message: "O produto indicado já existe nesta encomenda. Os valores indicados como quantidade e preço unitário foram atualizados",
                        delay: 5000
                    });
                }
            }

            vm.products.selected.validPolicyPrice = vm.validPolicyPrice;
            $rootScope.orderList.push(angular.copy(vm.products.selected));
            $rootScope.updateTotalizers();
            vm.products.selected = null;
            // get the ui select controller
            var uiSelect = angular.element('#filterProduct').controller('uiSelect');
            // focus the focusser, putting focus onto select but without opening
            // the dropdown
            uiSelect.focusser[0].focus();
        }

        function isNumeric(n) {
            // Check if passed value is numeric
            n = n.toString().replace(/,/g, ".");
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        function exportToExcel() {
            $http.post("api/pharma-trade/toExcel", $rootScope.orderList, {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, "Trocas_Farmacias_" + dateTime + ".xlsx", true);
                Notification.success({
                    message: "Encomenda exportada com sucesso",
                    delay: 5000
                });
            }, function errorCallback(response) {
                Notification.error({
                    message: "Erro ao exportar encomenda",
                    delay: ''
                });
            });
        }

        function toggleLineEditMode(orderProdLine) {
            if (angular.isDefined(orderProdLine.editMode) && orderProdLine.editMode == true) {
                orderProdLine.editMode = false;
            } else {
                orderProdLine.editMode = true;
            }
            $rootScope.updateTotalizers();
        }

        function validateLines(orderProdLine, keyEvent) {
            if (orderProdLine) {
                if (keyEvent.type == "blur" || (keyEvent.type == "keypress" && keyEvent.which === 13)) {
                    vm.hasErrors = false;
                    orderProdLine.editMode = false;
                    $rootScope.updateTotalizers();
                    angular.forEach($rootScope.orderList, function (value, key) {
                        isQtdInvalid(value);
                        isPriceInvalid(value);
                    });
                }
            } else {
                $rootScope.updateTotalizers();
                angular.forEach($rootScope.orderList, function (value, key) {
                    isQtdInvalid(value);
                    isPriceInvalid(value);
                });
            }
        }

        function isQtdInvalid(orderProdLine) {
            if (orderProdLine.qtd && orderProdLine.qtd >= 0 && parseInt(orderProdLine.qtd)) {
                orderProdLine.invalidQtd = false;
            } else {
                orderProdLine.invalidQtd = true;
                vm.hasErrors = true;
            }
        }

        function isPriceInvalid(orderProdLine) {
            if (orderProdLine.price && orderProdLine.price >= 0 && parseFloat(orderProdLine.price)) {
                orderProdLine.invalidPrice = false;
            } else {
                orderProdLine.invalidPrice = true;
                vm.hasErrors = true;
            }
        }

        $scope.onOpenClose = function (isOpen) {
            angular.element('.ui-select-choices-row').removeClass('active');
        }

        $scope.isOrderEmpty = function () {
            return $rootScope.orderList.length <= 0;
        }

        $scope.refreshSelectModel = function (query) {
            if (vm.lastQuery != query) {
                vm.lastQuery = query
                $http.get("api/common/_searchProductsForSelect/" + query).then(function (result) {
                    if (result.data.length > 500) {
                        Notification.warning({
                            message: "O número de resultados é superior a 500 registos. Por questões de performance, refine a sua pesquisa",
                            delay: 5000
                        });
                        return;
                    } else {
                        vm.products = result.data;
                    }
                });
            }
        };

        if ($localStorage && $localStorage.tradeOrder) {
            $rootScope.orderList = $localStorage.tradeOrder;
        } else {
            $rootScope.orderList = [];
        }

        $scope.$watch($rootScope.orderList, function () {
            $localStorage.tradeOrder = $rootScope.orderList;
        }, true);

        $rootScope.updateTotalizers = function () {
            $rootScope.totalizer = {
                qtd: 0,
                price: 0,
                docTotal: 0
            };
            angular.forEach($rootScope.orderList, function (value, key) {
                $rootScope.totalizer.qtd += value.qtd * 1;
                $rootScope.totalizer.price += value.qtd * value.price;
                $rootScope.totalizer.docTotal += value.qtd * value.price * (1 + value.txiva / 100);
            });
        }
        $rootScope.updateTotalizers();

        var canceler = $q.defer();

        $scope.getPriceFromPolicy = function ($item, $model) {
            if (vm.portalSettings.priceFromPolicyForTrades) {
                // PENDING HTTP CALLS CANCEL
                canceler.resolve();
                canceler = $q.defer();

                vm.validPolicyPrice = false;
                $item.labcode = $item.labcode != null ? $item.labcode : 0;
                $item.hash = vm.loggedUserClientPe + "" + $item.labcode + "" + $item.cnp;
                vm.requestBody = {
                    "policyType": "PharmaTradePriceCalculation",
                    "policyData": [{
                        "hierarchy": [vm.loggedUserClientPe, $item.labcode, $item.cnp],
                        "parameters": [vm.loggedUserWarehouse]
                    }]
                };

                $http.post("api/policyExecuter/execute", vm.requestBody, {
                    timeout: canceler.promise
                }).then(function (result) {
                    vm.validPolicyPrice = true;

                    var curResult = $filter('filter')(result.data.output, {
                        hash: $item.hash
                    }, true);

                    vm.products.selected.price = curResult[0].result;
                    if (!curResult[0].result || curResult[0].result <= 0) {
                        vm.products.selected.price = 0;
                        vm.validPolicyPrice = false;
                    }
                });
            }
        }

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('pharma-supplier-complaint', {
			parent : 'entity',
			url : '/pharma-supplier-complaint/:id',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaPicking.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-supplier-complaint/pharma-supplier-complaint.html',
					controller : 'PharmaSupplierComplaintController',
					controllerAs : 'vm'
				}
			},
			params : {
                pharmaPicking: null
			},
			resolve : {
				pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams) {
				    if($stateParams.pharmaPicking){
				        return {pharmaPicking: $stateParams.pharmaPicking};
                    }else{
				        return null;
                    }
				} ],
                entity : [ '$stateParams', 'PharmaPicking', function($stateParams, PharmaPicking) {
                    if($stateParams.id){
                        return PharmaPicking.get({
                            id : $stateParams.id
                        }).$promise;
                    }else{
                        return null;
                    }
                } ],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaSupplierComplaint');
					$translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('pharmaPickingImportFile');
                    $translatePartialLoader.addPart('pharmaPicking');
					return $translate.refresh();
				} ]
			}
		})
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaSupplierComplaintController', PharmaSupplierComplaintController);

    PharmaSupplierComplaintController.$inject = ['Notification', '$scope', '$state', 'entity', '$http', '$filter', '$uibModal', '$rootScope', 'Company', 'PharmaPicking', 'ParseLinks', 'paginationConstants', 'pagingParams',
        'ModuleSettings', 'Principal', 'blockUI', '$translate', '$sce', '$localStorage', 'InvoiceAndClaim'];

    function PharmaSupplierComplaintController(Notification, $scope, $state, entity, $http, $filter, $uibModal, $rootScope, Company, PharmaPicking, ParseLinks, paginationConstants, pagingParams, ModuleSettings, Principal, blockUI, $translate, $sce, $localStorage, InvoiceAndClaim) {
        var vm = this;

        vm.generatePdf = generatePdf;

        function resetLocalStorage() {
            $localStorage.pharmaPicking = null;
            $localStorage.changeState = null;
        }

        vm.toInt = function(a,b) {
            return parseInt(a,10) + parseInt(b,10);
        };

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };

        function loadAll() {

            Principal.identity().then(function (account) {
                if (account) {
                    vm.user = account.login;
                    vm.userGeneric = account.generic;
                } else {
                    $state.go('accessdenied');
                }
            });

            if (pagingParams != null) {
                vm.pharmaPicking = angular.copy(pagingParams.pharmaPicking);
                vm.changeState = false;
            } else {
                if ($localStorage.pharmaPicking) {
                    vm.pharmaPicking = $localStorage.pharmaPicking;
                    vm.changeState = $localStorage.changeState;
                } else {
                    $state.go('pharma-picking');
                    return;
                }
            }
            // var t = $filter('complaint')(vm.pharmaPicking.pharmaPickingLines, vm.pharmaPicking.changeState);
            angular.forEach(vm.pharmaPicking.pharmaPickingLines, function (line) {
                if (line.selected == vm.pharmaPicking.changeState && line.invoicedQuantity > line.receivedQuantity) {
                    var i = line.invoicedQuantity ? line.invoicedQuantity : 0;
                    var r = line.receivedQuantity ? line.receivedQuantity : 0;
                    var s = line.suggestion ? line.suggestion : 0;
                    line.claimedQuantity = i - r - s;
                } else {
                    line.claimedQuantity = 0;
                }
            });

            $localStorage.pharmaPicking = vm.pharmaPicking;
            $localStorage.changeState = vm.changeState;

            vm.date = new Date();
        }

        loadAll();

        vm.back = function () {
            resetLocalStorage();
            $state.go('pharma-picking-detail.edit', {
                id: vm.pharmaPicking.id
            }, {
                reload: false
            });
        };

        function generatePdf() {
            var products = $filter('filter')(vm.pharmaPicking.pharmaPickingLines, function (line) {
                var i = line.invoicedQuantity ? line.invoicedQuantity : 0;
                var r = line.receivedQuantity ? line.receivedQuantity : 0;
                var c = line.claimedQuantity ? line.claimedQuantity : 0;
                return i - r - c > 0;
            }, true);
            InvoiceAndClaim.invoiceAndClaim(vm.pharmaPicking, products, vm.user)
        }

    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaSelfTestDialogController', PharmaSelfTestDialogController);

    PharmaSelfTestDialogController.$inject = ['Notification', '$translate', '$uibModalInstance', 'startDate', 'endDate'];

    function PharmaSelfTestDialogController(Notification, $translate, $uibModalInstance, startDate, endDate) {
        var vm = this;
        vm.startDate = startDate;
        vm.endDate = endDate;

        vm.proceed = proceed;
        vm.clear = clear;

        function proceed() {
            if (vm.startDate == null || vm.endDate == null) {
                Notification.error({message: $translate.instant("pharmaPortalApp.pharmaSelfTest.form.emptyFields")});
            } else if (vm.startDate > vm.endDate) {
                Notification.error({message: $translate.instant("pharmaPortalApp.pharmaSelfTest.form.invalidInterval")});
            } else {
                $uibModalInstance.close({startDate: vm.startDate, endDate: vm.endDate});
            }
        }

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        vm.openDatePopup = function (i) {
            if (i == 1) { vm.datePopup1.opened = true; }
            else { vm.datePopup2.opened = true; }
        };

        vm.dateOptions = {formatYear: 'yyyy', startingDay: 1, showWeeks: false};
        vm.datePopup1 = {opened: false};
        vm.datePopup2 = {opened: false};
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaSelfTestDetailController', PharmaSelfTestDetailController);

    PharmaSelfTestDetailController.$inject = ['Notification', 'blockUI', '$http', '$translate', '$timeout', '$uibModal', 'PharmaSelfTest'];

    function PharmaSelfTestDetailController(Notification, blockUI, $http, $translate, $timeout, $uibModal, PharmaSelfTest) {
        var vm = this;
        vm.startDate = null;
        vm.endDate = null;

        vm.exportCSV = exportCSV;
        vm.intervalModal = intervalModal;
        vm.itemsList = [];

        vm.loadAll = function () {
            if (vm.startDate == null || vm.endDate == null) {
                vm.intervalModal();
            }
        };
        vm.loadAll();

        function exportCSV() {
            $http.post("api/pharma-self-test/toCsv", vm.itemsList, {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var frmStartDate = moment(vm.startDate).format('YYYYMMDD');
                var frmEndDate = moment(vm.endDate).format('YYYYMMDD');

                var blob = new Blob([response.data], {
                    type: "text/csv"
                });
                saveAs(blob, "ReportAutoTestes-" + frmStartDate + "-" + frmEndDate + ".csv");
                Notification.success({
                    message: "Relatório exportado com sucesso",
                    delay: 5000
                });
            }, function errorCallback() {
                Notification.error({
                    message: "Erro ao exportar relatório",
                    delay: ''
                });
            });
        }

        function intervalModal() {
            $uibModal.open({
                templateUrl: 'app/entities/pharma-self-test/pharma-self-test-dialog.html',
                controller: 'PharmaSelfTestDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    startDate: vm.startDate,
                    endDate: vm.endDate,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pharmaSelfTest');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function (response) {
                blockUI.start($translate.instant('pharmaPortalApp.pharmaSelfTest.loading'));
                vm.startDate = response.startDate;
                vm.endDate = response.endDate;
                vm.itemsList = PharmaSelfTest.query({startDate: moment(response.startDate).format('YYYYMMDD'), endDate: moment(response.endDate).format('YYYYMMDD')});

                vm.itemsList.$promise.then(function () {
                    if(vm.itemsList && vm.itemsList.length <= 0){
                        Notification.warning({
                            message: "Sem resultados para o intervalo definido",
                            delay: 5000
                        });
                    }
                    $timeout(function () {
                        blockUI.stop();
                    }, 250);
                }, function () {
                    $timeout(function () {
                        blockUI.stop();
                    }, 250);
                });
            }, function () {
                blockUI.stop();
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pharma-self-test', {
            parent: 'entity',
            url: '/pharma-self-test',
            data: {
                authorities: ['ROLE_INFARMED'],
                pageTitle: 'pharmaPortalApp.pharmaSelfTest.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pharma-self-test/pharma-self-test-detail.html',
                    controller: 'PharmaSelfTestDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaSelfTest');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('SaleSuccessController', SaleSuccessController);

	SaleSuccessController.$inject = [ '$uibModalInstance', '$state', 'Principal', 'ModuleSettings' ];

	function SaleSuccessController($uibModalInstance, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmAddProducts = confirmAddProducts;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmAddProducts() {
			$uibModalInstance.close(true);
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.salesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (account && account.company) {
							// DO NOTHING
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('SaleRemoveProductController', SaleRemoveProductController);

	SaleRemoveProductController.$inject = [ 'Notification', '$uibModalInstance', 'entity', '$rootScope', '$state', 'Principal', 'ModuleSettings' ];

	function SaleRemoveProductController(Notification, $uibModalInstance, entity, $rootScope, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.cnpToDel = entity.cnpToDel;
		vm.product = null;

		vm.clear = clear;
		vm.confirmRemoveProduct = confirmRemoveProduct;
		vm.filterItemFromArray = filterItemFromArray;
		vm.deleteFilteredItem = deleteFilteredItem;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmRemoveProduct() {
			deleteFilteredItem(vm.cnpToDel, $rootScope.saleOrderList);
			$rootScope.updateSaleTotals();
			$uibModalInstance.close(true);
			Notification.warning({
				message : "O produto foi removido da encomenda",
				delay : 5000
			});
		}

		function filterItemFromArray(cnpToDel, sourceArray) {
			vm.product = null;
			angular.forEach(sourceArray, function(obj, index) {
				if (obj.cnp === cnpToDel) {
					vm.product = obj;
					return;
				}
			});
		}

		function deleteFilteredItem(cnpToDel, sourceArray) {
			angular.forEach(sourceArray, function(obj, index) {
				if (obj.cnp === cnpToDel) {
					sourceArray.splice(index, 1);
					return;
				}
			});
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.salesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (account && account.company) {
							filterItemFromArray(vm.cnpToDel, $rootScope.saleOrderList);
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('SaleConfirmOrderController', SaleConfirmOrderController);

    SaleConfirmOrderController.$inject = ['Notification', '$uibModalInstance', '$rootScope', '$http', '$localStorage', '$scope', 'PortalSettings', '$state', 'Principal',
        'ModuleSettings'];

    function SaleConfirmOrderController(Notification, $uibModalInstance, $rootScope, $http, $localStorage, $scope, PortalSettings, $state, Principal, ModuleSettings) {
        var vm = this;

        vm.orderInfoValues = [];
        vm.orderReady = false;
        vm.orderDescription;
        vm.bodyRequest;
        vm.processing = false;

        vm.clear = clear;
        vm.confirmOrder = confirmOrder;
        vm.loadAll = loadAll;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmOrder() {
            vm.processing = true;

            vm.bodyRequest = {
                "description": vm.orderDescription,
                "orderProducts": $rootScope.saleOrderList,
                "invoiceTypeCode": vm.portalSettings.invoiceTypeCode,
                "invoiceTypeDesc": vm.portalSettings.invoiceTypeDesc,
                "billingTypeRetainedProductsCode": vm.portalSettings.billingTypeRetainedProductsCode,
                "billingTypeRetainedProductsDesc": vm.portalSettings.billingTypeRetainedProductsDesc,
                "chargeShippingCosts": vm.portalSettings.chargeShippingCosts,
                "cecServiceTypeCode": vm.portalSettings.cecServiceTypeCode,
                "cecServiceTypeDesc": vm.portalSettings.cecServiceTypeDesc,
                "shippingCosts": vm.portalSettings.shippingCosts,
                "isRetainedProductsOrder": $rootScope.isRetainedProductsOrder,
                "currentClient": $localStorage.currentCompany.client,
                "currentClientPe": $localStorage.currentCompany.deliveryPoint
            };

            $http.post("/api/pharma-sale/saveOrder", vm.bodyRequest).then(function successCallback(response) {
                if (response.data.success) {
                    $rootScope.saleOrderList = [];
                    $rootScope.saleTotals = {
                        total: 0,
                        totalPvf: 0,
                        totalDesc: 0
                    };
                    $uibModalInstance.close(true);
                    delete $localStorage.saleOrder;
                    vm.processing = false;
                    Notification.success({message: response.data.message, delay: 5000});
                } else {
                    $uibModalInstance.close(true);
                    vm.processing = false;
                    Notification.error({message: response.data.message, delay: ''});
                }
            }, function errorCallback(response) {
                $uibModalInstance.close(true);
                vm.processing = false;
                Notification.error({message: response.data, delay: ''});
            });
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.salesModule) {
                    $state.go('accessdenied');
                } else {
                    vm.portalSettings = PortalSettings.query(function (settings) {
                        if (settings.hasMinOrderValue == true && settings.minOrderValue > $rootScope.saleTotals.total && $rootScope.saleTotals.total > 0) {
                            vm.orderInfoValues.minValue = settings.minOrderValue;
                            vm.orderInfoValues.curDiff = settings.minOrderValue - $rootScope.saleTotals.total;
                            vm.orderReady = false;
                        } else {
                            vm.orderInfoValues = [];
                            vm.orderReady = true;
                        }
                    });
                }
            });
        }

        loadAll();
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('SaleConfirmFullSearchController', SaleConfirmFullSearchController);

	SaleConfirmFullSearchController.$inject = [ '$uibModalInstance', '$rootScope', '$state', 'Principal', 'ModuleSettings' ];

	function SaleConfirmFullSearchController($uibModalInstance, $rootScope, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmAddProducts = confirmAddProducts;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmAddProducts() {
			$rootScope.searchProductsAction()
			$uibModalInstance.close(true);
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.salesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (account && account.company) {
							// DO NOTHING
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('SaleClearOrderController', SaleClearOrderController);

	SaleClearOrderController.$inject = [ 'Notification', '$uibModalInstance', '$rootScope', '$localStorage', '$state', 'Principal', 'ModuleSettings' ];

	function SaleClearOrderController(Notification, $uibModalInstance, $rootScope, $localStorage, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmClearOrder = confirmClearOrder;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmClearOrder() {
			$rootScope.saleOrderList = [];
			$rootScope.saleTotals = {
				total : 0,
				totalPvf : 0,
				totalDesc : 0
			};
			$uibModalInstance.close(true);
			delete $localStorage.saleOrder;
			Notification.warning({
				message : "Todos os produtos da encomenda foram removidos",
				delay : 5000
			});
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.salesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (account && account.company) {
							// DO NOTHING
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('SaleAlertController', SaleAlertController);

	SaleAlertController.$inject = [ '$uibModalInstance', '$state', 'Principal', 'ModuleSettings' ];

	function SaleAlertController($uibModalInstance, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmAlert = confirmAlert;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmAlert() {
			$uibModalInstance.close(true);
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.salesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (account && account.company) {
							// DO NOTHING
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('pharma-sale', {
			parent : 'entity',
			url : '/pharma-sale',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_COMERCIAL' ],
				pageTitle : 'pharmaPortalApp.pharmaSale.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-sale/pharma-sales.html',
					controller : 'PharmaSaleController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaSale');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-sale.alert', {
			parent : 'pharma-sale',
			url : '/alert',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_COMERCIAL' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-sale/sale-alert-dialog.html',
					controller : 'SaleAlertController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-sale', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-sale.success', {
			parent : 'pharma-sale',
			url : '/success',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_COMERCIAL' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-sale/sale-success-dialog.html',
					controller : 'SaleSuccessController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-sale', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-sale.clearOrder', {
			parent : 'pharma-sale',
			url : '/clear',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_COMERCIAL' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-sale/sale-clear-order-dialog.html',
					controller : 'SaleClearOrderController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-sale', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-sale.confirmOrder', {
			parent : 'pharma-sale',
			url : '/confirm',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_COMERCIAL' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-sale/sale-confirm-order-dialog.html',
					controller : 'SaleConfirmOrderController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-sale', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-sale.removeProduct', {
			parent : 'pharma-sale',
			url : '/removeProduct/{cnpToDel}',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_COMERCIAL' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-sale/sale-remove-product-dialog.html',
					controller : 'SaleRemoveProductController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : function() {
							return {
								cnpToDel : $stateParams.cnpToDel
							};
						}
					}
				}).result.then(function() {
					$state.go('pharma-sale', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-sale.fullSearch', {
			parent : 'pharma-sale',
			url : '/fullSearch',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_COMERCIAL' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-sale/sale-confirm.fullsearch-dialog.html',
					controller : 'SaleConfirmFullSearchController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-sale', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-sale.inactive', {
            parent : 'pharma-sale',
            onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl : 'app/entities/pharma-sale/pharma-sale.inactive-dialog.html',
                    controller : 'PharmaSaleInactiveController',
                    controllerAs : 'vm',
                    size : 'md'
                }).result.then(function() {
                    $state.go('pharma-sale', null, {
                        reload : true
                    });
                }, function() {
                    $state.go('^');
                });
            } ]
        });
	}
})();

(function() {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaSaleInactiveController', PharmaSaleInactiveController);

    PharmaSaleInactiveController.$inject = [ '$uibModalInstance', '$rootScope', '$state', 'ModuleSettings' ];

    function PharmaSaleInactiveController($uibModalInstance, $rootScope, $state, ModuleSettings) {
        var vm = this;

        vm.clear = clear;
        vm.confirmAddProducts = confirmAddProducts;
        vm.loadAll = loadAll;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmAddProducts() {
            $rootScope.searchProductsAction()
            $uibModalInstance.close(true);
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function(result) {
                vm.moduleSettings = result;

                /*if (!vm.moduleSettings.productsModule) {
                    $state.go('accessdenied');
                }*/
            });
        }
        loadAll();
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaSaleController', PharmaSaleController);

    PharmaSaleController.$inject = ['Notification', '$rootScope', '$scope', '$filter', '$state', '$http', '$q', '$localStorage', 'Company', 'PortalSettings', 'ModuleSettings', 'Principal'];

    function PharmaSaleController(Notification, $rootScope, $scope, $filter, $state, $http, $q, $localStorage, Company, PortalSettings, ModuleSettings, Principal) {
        var vm = this;
        vm.portalSettings = PortalSettings.query();
        vm.isPharma = false;
        vm.ownWarehouse = false;

        vm.companies = Company.query({size: 1000});
        vm.currentUserPe = null;
        vm.currentUserType = "";
        vm.currentUserClientGroup = "";

        vm.updateCompany = updateCompany;
        vm.loadAll = loadAll;
        vm.isValidForOrder = isValidForOrder;
        vm.isNumeric = isNumeric;
        vm.addProduct = addProduct;
        vm.checkProductValidToOrder = checkProductValidToOrder;
        vm.addAllProducts = addAllProducts;
        vm.searchByLab = searchByLab;
        vm.clearSearchInTable = clearSearchInTable;
        vm.toggleLineEditMode = toggleLineEditMode;
        vm.validateLines = validateLines;

        vm.exportSearchToExcel = exportSearchToExcel;
        vm.orderToExcel = orderToExcel;
        vm.confirmOrderDialog = confirmOrderDialog;

        $scope.searchInTable = "";
        $scope.productsList = [];
        $scope.search = {
            searchQuery: "",
            showNoStock: false,
            ownWarehouse: false
        };
        $rootScope.saleTotals = {
            total: 0,
            totalPV: 0,
            totalDesc: 0
        };

        function updateCompany($item, $model) {
            Company.isInactive($item, function (result) {
                if (result.regDate != null) {
                    result.regDate = result.regDate.substring(6,8) + "-" + result.regDate.substring(4,6) + "-" + result.regDate.substring(0,4);
                    result.regTime = result.regTime.substring(0,2) + ":" + result.regTime.substring(2,4) + ":" + result.regTime.substring(4,6);
                    result.company = $item.namingForOptions;
                    $rootScope.message = result;
                    vm.currentCompany = "";
                    $state.go("pharma-sale.inactive");
                } else {
                    if ($rootScope.saleOrderList.length > 0) {
                        vm.currentCompany = $localStorage.currentCompany;
                        Notification.error({
                            message: "Não é possível mudar de cliente se a encomenda atual não estiver vazia",
                            delay: ''
                        });
                    } else {
                        vm.selectedCompany = $item;
                        $localStorage.currentCompany = vm.currentCompany;

                        if ($item) {
                            vm.currentUserPe = $item.clientPe;
                            vm.currentUserType = $item.clientType;
                            vm.currentUserClientGroup = $item.clientGroup;
                            vm.isPharma = $item.clientType == "F";

                            if ($item.pharmaWarehouse) {
                                vm.ownWarehouse = $item.pharmaWarehouse;
                            } else {
                                vm.ownWarehouse = false;
                            }
                        }

                        // SE EXISTIR PESQUISA, VOLTA A FAZER
                        if ($scope.search.searchQuery != "") {
                            $scope.searchProducts();
                            if (!vm.isPharma && $scope.search.ownWarehouse) {
                                $scope.search.ownWarehouse = false;
                            }
                        } else {
                            $scope.search = {
                                searchQuery: "",
                                showNoStock: false,
                                ownWarehouse: false
                            };
                            $scope.productsList = [];
                        }
                    }
                }
            });
        };

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.salesModule) {
                    $state.go('accessdenied');
                } else {
                    Principal.identity().then(function (account) {
                        vm.isPharma = false;
                        vm.ownWarehouse = false;
                        vm.loggedUser = null;

                        if (account) {
                            vm.loggedUser = account.login;
                        } else {
                            $state.go('accessdenied');
                        }
                    });
                    validateLines();
                }
            });
        }

        loadAll();

        function isValidForOrder(product) {
            return (!product.pvp || !product.warehousestock || !product.qtd || product.pvp <= 0 || product.warehousestock <= 0 || product.qtd <= 0);
        }

        function isNumeric(n) { // Check if passed value is numeric
            n = n.toString().replace(/,/g, ".");
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        function addProduct(product) {
            switch (checkProductValidToOrder(product, $rootScope.saleOrderList)) {
                case 0:
                    // $rootScope.message = "Produto adicionado com sucesso";
                    // $state.go("pharma-sale.success");
                    break;
                case 1:
                    $rootScope.message = "O produto indicado já existia nesta encomenda. A quantidade a encomendar foi atualizada";
                    $state.go("pharma-sale.success");
                    break;
                case 2:
                    $rootScope.message = "O produto não tem um preço válido e maior que zero";
                    $state.go("pharma-sale.alert");
                    break;
                case 3:
                    $rootScope.message = "A quantidade a encomendar tem de ser um número válido e maior que zero";
                    $state.go("pharma-sale.alert");
                    break;
                case 4:
                    $rootScope.message = "Não existe stock disponível deste produto";
                    $state.go("pharma-sale.alert");
                    break;
                case 5:
                    $rootScope.message = "A quantidade a encomendar tem um valor superior ao stock disponível";
                    $state.go("pharma-sale.alert");
                    break;
            }
        }

        function checkProductValidToOrder(product, listOrderProducts) {
            if (!(product.pvp && isNumeric(product.pvp) && product.pvp > 0)) {
                // SE "Preço" ESTÁ VAZIO OU NÃO É NUMÉRICO OU FOR NEGATIVO OU IGUAL A ZERO
                return 2;
            } else if (!(product.qtd && isNumeric(product.qtd) && product.qtd > 0)) {
                // SE "Qtd" ESTÁ VAZIO OU NÃO É NUMÉRICO OU FOR NEGATIVO OU IGUAL A ZERO
                return 3;
            } else if (!(product.warehousestock && isNumeric(product.warehousestock) && product.warehousestock > 0)) {
                // SE "warehousestock" ESTÁ VAZIO OU NÃO É NUMÉRICO OU FOR NEGATIVO OU IGUAL A ZERO
                return 4;
            } else if (product.qtd > product.warehousestock) {
                // SE "QTD" FOR MAIOR QUE "STOCK"
                return 5;
            }

            if (listOrderProducts.length > 0) {
                // SE "CNP" VALIDA SE EXISTE NO ARRAY DE CNP"s
                var keepGoing = true;
                angular.forEach(listOrderProducts, function (obj, index) {
                    if (keepGoing) {
                        if (obj.cnp === product.cnp) {
                            if (product.qtd > 0) {
                                $rootScope.saleOrderList.splice(index, 1, angular.copy(product));
                            } else {
                                $rootScope.saleOrderList.splice(index, 1);
                            }
                            $rootScope.updateSaleTotals();
                            keepGoing = false;
                        }
                    }
                });
                if (!keepGoing) {
                    return 1;
                }
            }
            $rootScope.saleOrderList.push(angular.copy(product));
            $rootScope.updateSaleTotals();
            return 0;
        }

        function addAllProducts() {
            var error_flag = false;
            var exists_flag = false;
            var initialOrderSize = $rootScope.saleOrderList.length;
            var countWithError = 0;
            var countUpdated = 0;
            var countInserted = 0;

            var filteredList = $filter('filter')($scope.productsList, $scope.searchInTable);

            angular.forEach(filteredList, function (obj, index) {
                switch (checkProductValidToOrder(obj, $rootScope.saleOrderList)) {
                    case 0:
                        countInserted = countInserted + 1;
                        break;
                    case 1:
                        countUpdated = countUpdated + 1;
                        exists_flag = true;
                        break;
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        countWithError = countWithError + 1;
                        error_flag = true;
                        break;
                }
            });

            if (error_flag) {
                var str = "<b>Produtos adicionados:</b> " + countInserted + "<br/>";
                if (exists_flag) {
                    str += "<b>Produtos atualizados:</b> " + countUpdated + "<br/>";
                }
                str += "<b>Produtos sem preço válido, sem stock ou quantidade inválida:</b> " + countWithError + "<br/>";
                $rootScope.message = str;
                $state.go("pharma-sale.alert");
            } else {
                if (exists_flag) {
                    var str = "<b>Produtos adicionados:</b> " + countInserted + "<br/>";
                    str += "<b>Produtos atualizados:</b> " + countUpdated + "<br/>";
                    $rootScope.message = str;
                    $state.go("pharma-sale.success");
                }
            }
        }

        function searchByLab(lab) {
            $scope.search.searchQuery = lab;
            $scope.searchProducts();
        }

        function clearSearchInTable() {
            $scope.searchInTable = "";
        }

        function toggleLineEditMode(orderProdLine) {
            if (angular.isDefined(orderProdLine.editMode) && orderProdLine.editMode == true) {
                orderProdLine.editMode = false;
            } else {
                orderProdLine.editMode = true;
            }
            $rootScope.updateSaleTotals();
        }

        function validateLines(orderProd, keyEvent) {
            if (orderProd) {
                if (keyEvent.type == "blur" || (keyEvent.type == "keypress" && keyEvent.which === 13)) {
                    vm.hasErrors = false;
                    orderProd.editMode = false;
                    $rootScope.updateSaleTotals();
                    angular.forEach($rootScope.saleOrderList, function (value, key) {
                        isQtdInvalid(value);
                    });
                }
            } else {
                $rootScope.updateSaleTotals();
                angular.forEach($rootScope.saleOrderList, function (value, key) {
                    isQtdInvalid(value);
                });
            }
        }

        function isQtdInvalid(orderProd) {
            if (orderProd.qtd && orderProd.qtd >= 0 && parseInt(orderProd.qtd)) {
                orderProd.invalidQtd = false;
            } else {
                orderProd.invalidQtd = true;
                vm.hasErrors = true;
            }
        }

        $scope.searchProducts = function () {
            $scope.productsList = [];
            if ($scope.search && $scope.search.searchQuery && $scope.search.searchQuery.length > 2) {
                $rootScope.searchProductsAction();
            } else {
                // SE showNoStock então não permite
                if ($scope.search.showNoStock == true) {
                    $rootScope.message = "NOK";
                    $scope.productsList = [];
                    $state.go("pharma-sale.fullSearch");
                } else {
                    // SE showNoStock = FALSE então ABRE DIALOG A CONFIRMAR
                    if ($scope.search.searchQuery == undefined) {
                        $scope.search.searchQuery = "";
                    }
                    $rootScope.message = "OK";
                    $state.go("pharma-sale.fullSearch");
                }
            }
        };

        var canceler = $q.defer();
        $rootScope.searchProductsAction = function () {
            // PENDING HTTP CALLS CANCEL
            canceler.resolve();
            canceler = $q.defer();

            // DEFAULT QTD FROM SETTINGS
            vm.defaultQtd = 1;
            if (vm.portalSettings.defaultQtd != null) {
                vm.defaultQtd = vm.portalSettings.defaultQtd;
            }
            // HIDE NEGATIVE DISCOUNTS FROM SETTINGS
            vm.hideNegativeDiscounts = true;
            if (vm.portalSettings.showPvfOnNegativeDiscount) {
                vm.hideNegativeDiscounts = false;
            }

            // CHECK IF SEARCH IS OVER OWN WAREHOUSE OR POLICY GIVEN WAREHOUSE
            if ($scope.search.ownWarehouse) {
                $scope.search.customWarehouse = vm.ownWarehouse;
                searchForProducts();
            } else {
                getWarehouseForSearch();
            }
        }

        $rootScope.updateSaleTotals = function () {
            $rootScope.saleTotals = {
                total: 0,
                totalPV: 0,
                totalDesc: 0
            };

            angular.forEach($rootScope.saleOrderList, function (value, key) {
                $rootScope.saleTotals.total += (value.qtd * 1) * (value.pvp * 1);

                if (vm.isPharma) {
                    $rootScope.saleTotals.totalPV += (value.qtd * 1) * (value.pvfeur * 1);
                } else {
                    $rootScope.saleTotals.totalPV += (value.qtd * 1) * (value.pvaeur * 1);
                }
            });

            $rootScope.saleTotals.totalDesc = $rootScope.saleTotals.totalPV - $rootScope.saleTotals.total;

            if (vm.portalSettings.chargeShippingCosts == true && vm.portalSettings.hasMinOrderValue == true && vm.portalSettings.minOrderValue > $rootScope.saleTotals.total && $rootScope.saleTotals.total > 0) {
                $rootScope.saleTotals.total = $rootScope.saleTotals.total + vm.portalSettings.shippingCosts;
            }
        }
        $rootScope.updateSaleTotals();

        $scope.isOrderEmpty = function () {
            return $rootScope.saleOrderList.length <= 0;
        }

        $scope.isProductSearchEmpty = function () {
            return $scope.productsList.length <= 0;
        }

        $scope.isRetainedProductsOrder = function () {
            if ($rootScope.saleOrderList.length > 0) {
                var keepGoing = true;
                angular.forEach($rootScope.saleOrderList, function (value, key) {
                    if (keepGoing) {
                        if (value.originwarehouse) {
                            $scope.search.ownWarehouse = true;
                            keepGoing = false;
                        }
                    }
                });
                return true;
            } else {
                return false;
            }
        }

        if ($localStorage) {
            if ($localStorage.saleOrder && $localStorage.saleOrder) {
                $rootScope.saleOrderList = $localStorage.saleOrder;
            } else {
                $rootScope.saleOrderList = [];
            }

            if ($localStorage.currentCompany) {
                vm.currentCompany = $localStorage.currentCompany;

                vm.currentUserPe = vm.currentCompany.clientPe;
                vm.currentUserType = vm.currentCompany.clientType;
                vm.currentUserClientGroup = vm.currentCompany.clientGroup;
                vm.isPharma = vm.currentCompany.clientType == "F";

                if (vm.currentCompany.pharmaWarehouse) {
                    vm.ownWarehouse = vm.currentCompany.pharmaWarehouse;
                } else {
                    vm.ownWarehouse = false;
                }
            } else {
                vm.currentCompany = null;
                vm.currentUserPe = null;
                vm.currentUserType = null;
                vm.currentUserClientGroup = null;
                vm.isPharma = false;
            }
        }

        $scope.$watch($rootScope.saleOrderList, function () {
            $localStorage.saleOrder = $rootScope.saleOrderList;
        }, true);

        function dynamicSort(property) {
            var sortOrder = 1;
            if (property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
            }
            return function (a, b) {
                var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result * sortOrder;
            }
        }

        function exportSearchToExcel() {
            $http.post("api/pharma-sale/searchToExcel/" + vm.isPharma, $scope.productsList, {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, "Produtos_Portal_" + dateTime + ".xlsx", true);
                Notification.success({
                    message: "Lista de produtos exportada com sucesso",
                    delay: 5000
                });
            }, function errorCallback(response) {
                Notification.error({
                    message: "Erro ao exportar lista de produtos",
                    delay: ''
                });
            });
        }

        function orderToExcel() {
            $http.post("api/pharma-sale/orderToExcel/" + vm.isPharma, $rootScope.saleOrderList, {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, "Portal_Encomenda_" + dateTime + ".xlsx", true);
                Notification.success({
                    message: "Encomenda exportada com sucesso",
                    delay: 5000
                });
            }, function errorCallback(response) {
                Notification.error({
                    message: "Erro ao exportar encomenda",
                    delay: ''
                });
            });
        }

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };

        function getWarehouseForSearch() {
            // EXECUTAR POLITICA PARA OBTER ARMAZÉM A UTILIZAR E LISTA DE EXCLUSÕES
            var policyType = "PharmaOrdersStockSale";
            var policyData = [];
            policyData.push({
                "hierarchy": [vm.currentUserType, vm.currentUserClientGroup, vm.currentUserPe]
            });
            var requestBody = {
                "policyType": policyType,
                "policyData": policyData
            };

            $http.post("api/policyExecuter/execute", requestBody).then(function (result) {
                var curResult = $filter('filter')(result.data.output, {
                    hash: vm.currentUserType + '' + vm.currentUserClientGroup + '' + vm.currentUserPe
                }, true);

                if (curResult[0]) {
                    $scope.search.customWarehouse = curResult[0].result.warehouse
                    $scope.search.productStockQtdManipulation = curResult[0].result.productStockQtd
                    searchForProducts();
                }
            }, function (result) {
                Notification.warning({
                    message: "Error! Status = " + result.status + " Message = " + result,
                    delay: 5000
                });
            });
        }

        var canceler = $q.defer();

        function searchForProducts() {
            canceler.resolve();
            canceler = $q.defer();
            // PESQUISA "NORMAL"
            $scope.resultProductsList = [];
            $http.post("api/common/_searchFromDbPharmaProducts", $scope.search, {
                timeout: canceler.promise
            }).then(function (result) {
                $scope.resultProductsList = result.data;
            }).then(function () {
                $scope.productsList = [];
                vm.policyData = [];

                if ($scope.search.ownWarehouse) {
                    vm.policyName = "RetainedProductPriceSale";

                    $($scope.resultProductsList).each(function (index, prod) {
                        var prodLab = prod.forncode ? "CIL" + prod.forncode : prod.labcode ? prod.labcode : "99999";
                        vm.policyData.push({
                            "hierarchy": [vm.currentUserPe, prodLab, prod.cnp],
                            "parameters": [$scope.search.customWarehouse]
                        });
                        prod.hash = vm.currentUserPe + "" + prodLab + "" + prod.cnp;
                    });
                } else {
                    vm.policyName = "PharmaOrdersPriceSale";

                    $($scope.resultProductsList).each(function (index, prod) {
                        var prodLab = prod.forncode ? "CIL" + prod.forncode : prod.labcode ? prod.labcode : "99999";
                        vm.policyData.push({
                            "hierarchy": [vm.currentUserType, vm.currentUserPe, prodLab, prod.cnp]
                        });
                        prod.hash = vm.currentUserType + "" + vm.currentUserPe + "" + prodLab + "" + prod.cnp;
                    });
                }

                vm.requestBody = {
                    "policyType": vm.policyName,
                    "policyData": vm.policyData
                };

                $http.post("api/policyExecuter/execute", vm.requestBody, {
                    timeout: canceler.promise
                }).then(function (result) {
                    $($scope.resultProductsList).each(function (index, prod) {
                        var curResult = $filter('filter')(result.data.output, {
                            hash: prod.hash
                        }, true);

                        if (vm.portalSettings.allowZeroPriceProducts == true) {
                            // 1. PREÇO
                            prod.pvp = curResult[0].result;
                            if (prod.pvp < 0) {
                                prod.warehousestock = 0;
                            }

                        } else {
                            // 1. PREÇO
                            prod.pvp = curResult[0].result;
                            if (prod.pvp <= 0) {
                                prod.warehousestock = 0;
                            }
                        }

                        // 2. DIF PREÇO
                        if (vm.isPharma) {
                            if (prod.pvfeur) {
                                if (prod.pvp == 0 || prod.pvfeur == 0) {
                                    prod.pvfdesc = 0;
                                } else {
                                    prod.pvfdesc = (1 - (prod.pvp / prod.pvfeur)) * 100;

                                    if (prod.pvfdesc < 0 && vm.hideNegativeDiscounts) {
                                        prod.pvfdesc = 0;
                                        prod.pvfeur = prod.pvp;
                                    }
                                }
                            } else {
                                prod.pvfeur = prod.pvp;
                                prod.pvfdesc = 0;
                                prod.qtd = vm.defaultQtd;
                            }
                        } else {
                            if (prod.pvaeur) {
                                if (prod.pvp == 0 || prod.pvaeur == 0) {
                                    prod.pvadesc = 0;
                                } else {
                                    prod.pvadesc = (1 - (prod.pvp / prod.pvaeur)) * 100;
                                    if (prod.pvadesc < 0 && vm.hideNegativeDiscounts) {
                                        prod.pvadesc = 0;
                                        prod.pvaeur = prod.pvp;
                                    }
                                }
                            } else {
                                prod.pvaeur = prod.pvp;
                                prod.pvadesc = 0;
                                prod.qtd = vm.defaultQtd;
                            }
                        }
                        // 3. SE ESTAMOS A TRATAR PRODUTOS RETIDOS ENTÃO
                        // ADICIONA AO PRODUTO O WAREHOUSE DE ORIGEM
                        if ($scope.search.ownWarehouse) {
                            prod.originwarehouse = vm.ownWarehouse;
                        }

                        // 4. STOCK
                        if (prod.warehousestock > 0) {
                            prod.qtd = vm.defaultQtd;
                            $scope.productsList.push(prod);
                        } else {
                            prod.qtd = 0;
                            prod.warehousestock = 0;
                            if ($scope.search && $scope.search.showNoStock) {
                                $scope.productsList.push(prod);
                            }
                        }

                        $scope.productsList.sort(dynamicSort("fullName"));
                    });

                }, function (result) {
                    Notification.warning({
                        message: "Error! Status = " + result.status + " Message = " + result,
                        delay: 5000
                    });
                });
            });
        }

        function confirmOrderDialog() {
            $rootScope.isRetainedProductsOrder = $scope.search.ownWarehouse;
            $state.go('pharma-sale.confirmOrder');
        }
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ReturnRemoveLineController', ReturnRemoveLineController);

	ReturnRemoveLineController.$inject = [ 'Notification', '$uibModalInstance', '$translate', 'entity', '$rootScope', '$state', 'Principal', 'ModuleSettings' ];

	function ReturnRemoveLineController(Notification, $uibModalInstance, $translate, entity, $rootScope, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.cnpToDel = entity.cnpToDel;
		vm.product = null;

		vm.clear = clear;
		vm.confirmRemoveLine = confirmRemoveLine;
		vm.filterItemFromArray = filterItemFromArray;
		vm.deleteFilteredItem = deleteFilteredItem;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmRemoveLine() {
			deleteFilteredItem(vm.cnpToDel, $rootScope.orderList);
			$rootScope.updateTotalizers();
			$uibModalInstance.close(true);
			Notification.success({ message : $translate.instant('pharmaPortalApp.pharmaReturn.message.productDeleted'), delay : 5000 });
		}

		function filterItemFromArray(cnpToDel, sourceArray) {
			vm.product = null;
			angular.forEach(sourceArray, function(obj, index) {
				if (obj.cnp === cnpToDel) {
					vm.product = obj;
					return;
				}
			});
		}

		function deleteFilteredItem(cnpToDel, sourceArray) {
			angular.forEach(sourceArray, function(obj, index) {
				if (obj.cnp === cnpToDel) {
					sourceArray.splice(index, 1);
					return;
				}
			});
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.returnsModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
                        if(account.authorities.indexOf("ROLE_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if(account.authorities.indexOf("ROLE_SUPER_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if(account.authorities.indexOf("ROLE_PHARMA_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if ((account && account.company && account.company.clientType == "F") || vm.isAdmin) {
							filterItemFromArray(vm.cnpToDel, $rootScope.orderList);
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ReturnConfirmController', ReturnConfirmController);

    ReturnConfirmController.$inject = ['Notification', '$uibModalInstance', '$rootScope', '$scope', 'Company', '$http', '$localStorage', '$state', 'Principal', 'ModuleSettings',
        'PortalSettings'];

    function ReturnConfirmController(Notification, $uibModalInstance, $rootScope, $scope, Company, $http, $localStorage, $state, Principal, ModuleSettings, PortalSettings) {
        var vm = this;

        vm.portalSettings = PortalSettings.query();

        vm.confirmOrder = confirmOrder;
        vm.clear = clear;
        vm.loadAll = loadAll;

        vm.order;
        vm.mybody;
        vm.processing = false;

        function confirmOrder() {
            vm.processing = true;

			vm.mybody = {
			    'company' : $localStorage.currentCompany.id,
				'returnGuide' : vm.order != null ? vm.order.returnGuide : "",
				'orderProducts' : $rootScope.orderList,
				"returnInternalClientId" : vm.portalSettings.returnInternalClient.id,
				"returnWarehouseTransfTypeCode" : vm.portalSettings.returnWarehouseTransfTypeCode,
				"returnWarehouseTransfTypeDesc" : vm.portalSettings.returnWarehouseTransfTypeDesc,
				"returnCreditTypeCode" : vm.portalSettings.returnCreditTypeCode,
				"returnCreditTypeDesc" : vm.portalSettings.returnCreditTypeDesc
			};

            saveOrderToServer(vm.mybody);
        }

		function saveOrderToServer(requestBody) {
			$http.post("api/pharma-return/saveReturn", requestBody).then(function successCallback(response) {
				$rootScope.orderList = [];
				$rootScope.totalizer = {
					qtd : 0,
					price : 0,
					docTotal : 0
				};
				$uibModalInstance.close(true);
				delete $localStorage.order;
				if (response.data.success) {
					Notification.success({ message : response.data.message, delay : 5000 });
				} else {
					Notification.error({ message : response.data.message, delay : '' });
				}
				vm.processing = false;
			}, function errorCallback(response) {
				vm.processing = false;
				$uibModalInstance.close(true);
				Notification.error({ message : response.data.message, delay : '' });
			});
		}

        function zeroPad(num, places) {
            var zero = places - num.toString().length + 1;
            return Array(+(zero > 0 && zero)).join("0") + num;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

				if (!vm.moduleSettings.returnsModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
                        if(account.authorities.indexOf("ROLE_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if(account.authorities.indexOf("ROLE_SUPER_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if(account.authorities.indexOf("ROLE_PHARMA_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if ((account && account.company && account.company.clientType == "F") || vm.isAdmin) {
                            vm.order.returnGuide = "";
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ReturnClearController', ReturnClearController);

	ReturnClearController.$inject = [ 'Notification', '$uibModalInstance', '$translate', '$rootScope', '$localStorage', '$state', 'Principal', 'ModuleSettings' ];

	function ReturnClearController(Notification, $uibModalInstance, $translate, $rootScope, $localStorage, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmClearOrder = confirmClearOrder;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmClearOrder() {
			$rootScope.orderList = [];
			$rootScope.totalizer = {
				qtd : 0,
				price : 0,
				docTotal : 0
			};
			$uibModalInstance.close(true);
			delete $localStorage.returnOrder;
			Notification.success({ message : $translate.instant('pharmaPortalApp.pharmaReturn.message.returnCleared'), delay : 5000 });
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.returnsModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
                        if(account.authorities.indexOf("ROLE_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if(account.authorities.indexOf("ROLE_SUPER_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if(account.authorities.indexOf("ROLE_PHARMA_ADMIN") !== -1) {
                            vm.isAdmin = true;
                        }
                        if ((account && account.company && account.company.clientType == "F") || vm.isAdmin) {
							// DO NOTHING
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('pharma-return', {
			parent : 'entity',
			url : '/pharma-return',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ],
				pageTitle : 'pharmaPortalApp.pharmaReturn.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-return/pharma-returns.html',
					controller : 'PharmaReturnController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaReturn');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-return.clearReturn', {
			parent : 'pharma-return',
			url : '/clear',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-return/return-clear-dialog.html',
					controller : 'ReturnClearController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-return', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-return.confirmReturn', {
			parent : 'pharma-return',
			url : '/confirm',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-return/return-confirm-dialog.html',
					controller : 'ReturnConfirmController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-return', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-return.removeLine', {
			parent : 'pharma-return',
			url : '/removeLine/{cnpToDel}',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-return/return-remove-line-dialog.html',
					controller : 'ReturnRemoveLineController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : function() {
							return {
								cnpToDel : $stateParams.cnpToDel
							};
						}
					}
				}).result.then(function() {
					$state.go('pharma-return', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-return.inactive', {
            parent : 'pharma-return',
            onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl : 'app/entities/pharma-return/pharma-return.inactive-dialog.html',
                    controller : 'PharmaReturnInactiveController',
                    controllerAs : 'vm',
                    size : 'md'
                }).result.then(function() {
                    $state.go('pharma-return', null, {
                        reload : true
                    });
                }, function() {
                    $state.go('^');
                });
            } ]
        });
	}
})();

(function() {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaReturnInactiveController', PharmaReturnInactiveController);

    PharmaReturnInactiveController.$inject = [ '$uibModalInstance', '$rootScope', '$state', 'ModuleSettings' ];

    function PharmaReturnInactiveController($uibModalInstance, $rootScope, $state, ModuleSettings) {
        var vm = this;

        vm.clear = clear;
        vm.confirmAddProducts = confirmAddProducts;
        vm.loadAll = loadAll;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmAddProducts() {
            $rootScope.searchProductsAction()
            $uibModalInstance.close(true);
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function(result) {
                vm.moduleSettings = result;

                /*if (!vm.moduleSettings.productsModule) {
                    $state.go('accessdenied');
                }*/
            });
        }
        loadAll();
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaReturnController', PharmaReturnController);

    PharmaReturnController.$inject = ['$translate', 'Notification', '$q', '$rootScope', '$scope', '$http', 'PharmaReturn', '$localStorage', '$filter', '$state', 'ModuleSettings', 'PortalSettings', 'Principal', 'Company'];

    function PharmaReturnController($translate, Notification, $q, $rootScope, $scope, $http, PharmaReturn, $localStorage, $filter, $state, ModuleSettings, PortalSettings, Principal, Company) {
        var vm = this;

        vm.portalSettings = PortalSettings.query();

        vm.loadAll = loadAll;
        vm.addProduct = addProduct;
        vm.isNumeric = isNumeric;
        vm.exportToExcel = exportToExcel;
        vm.toggleLineEditMode = toggleLineEditMode;
        vm.validateLines = validateLines;
        vm.lastQuery = "";
        vm.isTotalSet = false;
        vm.updateCompany = updateCompany;
        vm.companies = Company.findByPharmacyClient();

        vm.validPolicyPrice = false;
        vm.products;
        $rootScope.totalizer = {
            qtd: 0,
            price: 0,
            docTotal: 0
        };

        function updateCompany($item) {
            Company.isInactive($item, function (result) {
                if (result.regDate != null) {
                    result.regDate = result.regDate.substring(6, 8) + "-" + result.regDate.substring(4, 6) + "-" + result.regDate.substring(0, 4);
                    result.regTime = result.regTime.substring(0, 2) + ":" + result.regTime.substring(2, 4) + ":" + result.regTime.substring(4, 6);
                    result.company = $item.namingForOptions;
                    $rootScope.message = result;
                    vm.currentCompany = null;
                    $state.go("pharma-return.inactive");
                } else {
                    vm.selectedCompany = $item;
                    $localStorage.currentCompany = vm.selectedCompany;
                    vm.loggedUserClientPe = $item.clientPe;
                }
            });
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.returnsModule) {
                    $state.go('accessdenied');
                } else {
                    Principal.identity().then(function (account) {
                        if (account) {
                            vm.loggedUser = account.login;

                            if (account.company && account.company.clientType == "F") {
                                if (!vm.currentCompany) {
                                    vm.currentCompany = account.company;
                                    updateCompany(account.company);
                                }
                                if (vm.loggedUserClientPe == null) {
                                    vm.loggedUserClientPe = account.clientPe;
                                }
                            } else {
                                vm.loggedUserClientPe = null;
                                vm.currentCompany = null;
                            }
                        } else {
                            vm.loggedUser = null;
                            vm.loggedUserClientPe = null;
                            $state.go('accessdenied');
                        }
                    });
                    validateLines();
                }
            });
            vm.isTotalSet = JSON.parse(localStorage.getItem("isTotalSet"));
        }

        loadAll();

        function addProduct() {
            // SE "CNP" ESTÁ VAZIO
            if (!vm.products || !vm.products.selected || !vm.products.selected.cnp) {
                Notification.error({message: "Não indicou nenhum artigo", delay: ''});
                return;
            }

            // SE "Qtd" ESTÁ VAZIO OU NÃO NUMÉRICO OU É MENOR QUE ZERO
            if (!vm.products.selected.qtd) {
                Notification.error({message: "Não indicou a quantidade a devolver", delay: ''});
                return;
            } else {
                vm.products.selected.qtd = vm.products.selected.qtd.toString().replace(",", ".");
                if (!isNumeric(vm.products.selected.qtd)) {
                    Notification.error({message: "A quantidade a devolver que indicou não é um número válido", delay: ''});
                    return;
                } else if (Number(vm.products.selected.qtd) % 1 !== 0 || vm.products.selected.qtd < 1) {
                    Notification.error({message: "A quantidade a devolver tem de ser um numero inteiro e maior que zero", delay: ''});
                    return;
                }
            }

            // SE "Preço" ESTÁ VAZIO OU NÃO NUMÉRICO OU É MENOR QUE ZERO
            if (vm.isTotalSet) {
                if (!vm.products.selected.total) {
                    Notification.error({message: "Não indicou o preço líquido do produto a devolver", delay: ''});
                    return;
                } else if (vm.products.selected.total < 0) {
                    Notification.error({message: "O preço líquido do produto tem de ser maior que zero", delay: ''});
                    return;
                } else {
                    vm.products.selected.total = parseFloat(vm.products.selected.total.toString().replace(",", "."));
                    vm.products.selected.price = Math.round((vm.products.selected.total / vm.products.selected.qtd) * 1000) / 1000;
                }
            } else {
                if (!vm.products.selected.price) {
                    Notification.error({message: "Não indicou o preço unitário do produto a devolver", delay: ''});
                    return;
                } else if (vm.products.selected.price < 0) {
                    Notification.error({message: "O preço unitário do produto tem de ser maior que zero", delay: ''});
                    return;
                } else {
                    vm.products.selected.price = vm.products.selected.price.toString().replace(",", ".");
                    vm.products.selected.total = vm.products.selected.price * vm.products.selected.qtd;
                }
            }

            // SE "CNP" VALIDA SE EXISTE NO ARRAY DE CNP"s
            if ($rootScope.orderList.length > 0) {
                var keepGoing = true;
                angular.forEach($rootScope.orderList, function (obj, index) {
                    if (keepGoing) {
                        if (obj.cnp === vm.products.selected.cnp) {
                            $rootScope.orderList.splice(index, 1);
                            keepGoing = false;
                        }
                    }
                });

                if (!keepGoing) {
                    Notification.warning({message: "O produto indicado já existe nesta devolução. Os valores indicados como quantidade e preço unitário foram atualizados", delay: 5000});
                }
            }

            vm.products.selected.validPolicyPrice = vm.validPolicyPrice;
            $rootScope.orderList.push(angular.copy(vm.products.selected));
            $rootScope.updateTotalizers();
            vm.products.selected = null;
            var uiSelect = angular.element('#filterProduct').controller('uiSelect');
            uiSelect.focusser[0].focus();
        }

        vm.changeToggle = function () {
            vm.showAnimation = false;
            if (vm.products != null) {
                vm.products.selected = null;
            }
            localStorage.setItem("isTotalSet", vm.isTotalSet);
            vm.showAnimation = true;
            setTimeout(function () {
                vm.showAnimation = false;
                $scope.$apply();
            }, 3000);
        };

        vm.getOnTranslation = function () {
            return $translate.instant('pharmaPortalApp.pharmaReturn.placeholder.totalLiquidPrice');
        };
        vm.getOffTranslation = function () {
            return $translate.instant('pharmaPortalApp.pharmaReturn.placeholder.unitLiquidPrice');
        };

        $scope.$on('$destroy', function () {
            localStorage.removeItem("isTotalSet");
        });

        function isNumeric(n) {
            // Check if passed value is numeric
            n = n.toString().replace(/,/g, ".");
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        function exportToExcel() {
            $http.post("api/pharma-return/toExcel", $rootScope.orderList, {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, "Devoluções_Farmacias_" + dateTime + ".xlsx", true);
                Notification.success({message: "Devolução exportada com sucesso", delay: 5000});
            }, function errorCallback(response) {
                Notification.error({message: "Erro ao exportar devolução", delay: ''});
            });
        }

        vm.valueBeforeChanged = null;

        function toggleLineEditMode(returnProd) {
            if (vm.valueBeforeChanged == null || returnProd == vm.valueBeforeChanged) {

                if (angular.isDefined(returnProd.editMode) && returnProd.editMode == true) {
                    returnProd.editMode = false;
                    vm.valueBeforeChanged = null;
                } else {
                    returnProd.editMode = true;
                    vm.valueBeforeChanged = Object.assign({}, returnProd);
                }
            } else {
                angular.forEach($rootScope.orderList, function (value, key) {
                    value.editMode = false;
                });
                vm.valueBeforeChanged = null;

            }
            $rootScope.updateTotalizers();
        }

        function validateLines(returnProd, keyEvent) {
            if (returnProd) {
                if (keyEvent.type == "blur" || (keyEvent.type == "keypress" && keyEvent.which === 13) || keyEvent == 'onEnter') {
                    vm.hasErrors = false;

                    if (vm.valueBeforeChanged != null && returnProd.total !== vm.valueBeforeChanged.total) {
                        returnProd.total = parseFloat(returnProd.total);
                        returnProd.price = Math.round((returnProd.total / returnProd.qtd) * 1000) / 1000;
                    } else {
                        returnProd.total = returnProd.price * returnProd.qtd;
                    }

                    $rootScope.updateTotalizers();
                    angular.forEach($rootScope.orderList, function (value, key) {
                        isQtdInvalid(value);
                        isPriceInvalid(value);
                    });
                }
            } else {
                $rootScope.updateTotalizers();
                angular.forEach($rootScope.orderList, function (value, key) {
                    isQtdInvalid(value);
                    isPriceInvalid(value);
                });
            }
        }

        function isQtdInvalid(returnProd) {
            if (returnProd.qtd && returnProd.qtd >= 0 && parseInt(returnProd.qtd)) {
                returnProd.invalidQtd = false;
            } else {
                returnProd.invalidQtd = true;
                vm.hasErrors = true;
            }
        }

        function isPriceInvalid(returnProd) {
            if (returnProd.price && returnProd.price >= 0 && parseFloat(returnProd.price)) {
                returnProd.invalidPrice = false;
            } else {
                returnProd.invalidPrice = true;
                vm.hasErrors = true;
            }
        }

        $scope.onOpenClose = function (isOpen) {
            angular.element('.ui-select-choices-row').removeClass('active');
        }

        $scope.isOrderEmpty = function () {
            return $rootScope.orderList.length <= 0;
        }

        $scope.refreshSelectModel = function (query) {
            if (vm.lastQuery != query) {
                vm.lastQuery = query
                $http.get("api/common/_searchProductsForSelect/" + query).then(function (result) {
                    if (result.data.length > 500) {
                        Notification.warning({message: "O número de resultados é superior a 500 registos. Por questões de performance, refine a sua pesquisa", delay: 5000});
                        return;
                    } else {
                        vm.products = result.data;
                    }
                });
            }
        };

        if ($localStorage && $localStorage.returnOrder) {
            $rootScope.orderList = $localStorage.returnOrder;
        } else {
            $rootScope.orderList = [];
        }

        $scope.$watch($rootScope.orderList, function () {
            $localStorage.returnOrder = $rootScope.orderList;
        }, true);

        $rootScope.updateTotalizers = function () {
            $rootScope.totalizer = {
                qtd: 0,
                price: 0,
                docTotal: 0
            };
            angular.forEach($rootScope.orderList, function (value, key) {
                value.total = parseFloat(value.total);
                $rootScope.totalizer.qtd += value.qtd * 1;
                $rootScope.totalizer.price += value.total;
                $rootScope.totalizer.docTotal += value.total * (1 + value.txiva / 100);
            });
        }
        $rootScope.updateTotalizers();

        var canceler = $q.defer();
        $scope.getPriceFromPolicy = function ($item, $model, flag) {
            if (vm.portalSettings.priceFromPolicyForReturns && flag) {
                // PENDING HTTP CALLS CANCEL
                canceler.resolve();
                canceler = $q.defer();

                vm.validPolicyPrice = false;
                $item.labcode = $item.labcode != null ? $item.labcode : 0;
                $item.hash = vm.loggedUserClientPe + "" + $item.labcode + "" + $item.cnp;
                vm.requestBody = {
                    "policyType": "PharmaReturnsPriceCalculation",
                    "policyData": [{
                        "hierarchy": [vm.loggedUserClientPe, $item.labcode, $item.cnp]
                    }]
                };

                $http.post("api/policyExecuter/execute", vm.requestBody, {
                    timeout: canceler.promise
                }).then(function (result) {
                    vm.validPolicyPrice = true;

                    var curResult = $filter('filter')(result.data.output, {
                        hash: $item.hash
                    }, true);

                    vm.products.selected.price = curResult[0].result;
                    if (!curResult[0].result || curResult[0].result <= 0) {
                        vm.products.selected.price = 0;
                        vm.validPolicyPrice = false;
                    }
                });
            }
        };

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaReceptionValidateVatNumberController', PharmaReceptionValidateVatNumberController);

	PharmaReceptionValidateVatNumberController.$inject = ['Notification', '$uibModalInstance', '$http', '$state', '$filter', 'entity', 'PharmaReception'];

	function PharmaReceptionValidateVatNumberController(Notification, $uibModalInstance, $http, $state, $filter, entity, PharmaReception) {
		var vm = this;
		vm.vatNumber = null;
		
		vm.pharmaReception = entity;
		
		vm.clear = clear;
		vm.validateVatNumber = validateVatNumber;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function validateVatNumber() {
			if(vm.vatNumber !== null) {
				if(vm.pharmaReception.supplierNif == null) {
					Notification.error({message: "Não foi possível validar o fornecedor indicado. Verifique esta informação antes de avançar", delay: ''});
				} else {
					if(vm.vatNumber == vm.pharmaReception.supplierNif) {
						// Mensagem ao validar o contribuite: 
						Notification.success({message: "Número de contribuinte e fornecedor válidos", delay: 5000});
						vm.pharmaReception.vatValidated = vm.pharmaReception.supplierNif;
						PharmaReception.save(vm.pharmaReception);
						$uibModalInstance.close(true);
					} else {
						// Mensagem ao NÃO validar o contribuinte: 
						Notification.error({message: "Número de contribuinte não corresponde ao fornecedor indicado. Valide a informação antes de avançar", delay: ''});
					}
				}
			} else {
				Notification.error({message: "Tem de indicar um número de contribuinte", delay: ''});
			}
		}
	}
})();


(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaReceptionSubmitController', PharmaReceptionSubmitController);

    PharmaReceptionSubmitController.$inject = ['Notification', 'blockUI', '$uibModalInstance', '$translate', '$scope', '$state', '$http', '$filter', '$timeout', 'pharmaReception',
        'PharmaReception', 'PortalSettings', 'ModuleSettings', 'PharmaReceptionServiceByVat', 'PharmaReceptionInvoice', 'PharmaReceptionVatLine'];

    function PharmaReceptionSubmitController(Notification, blockUI, $uibModalInstance, $translate, $scope, $state, $http, $filter, $timeout, pharmaReception,
                                             PharmaReception, PortalSettings, ModuleSettings, PharmaReceptionServiceByVat, PharmaReceptionInvoice, PharmaReceptionVatLine) {
        var vm = this;

        vm.pharmaReceptionServiceByVat = PharmaReceptionServiceByVat.query();
        vm.portalSettings = PortalSettings.query();

        vm.noteDetails = {};

        vm.save = save;
        vm.loadAll = loadAll;
        vm.clear = clear;
        vm.getWarehouseFullDescription = getWarehouseFullDescription;
        vm.getSupplierFullDescription = getSupplierFullDescription;

        vm.confirmPharmaReceptionSubmit = confirmPharmaReceptionSubmit;
        vm.confirmReceptionPurchaseInvoiceSubmit = confirmReceptionPurchaseInvoiceSubmit;
        vm.checkIfNoteClosed = checkIfNoteClosed;
        vm.onSubmitInvoiceSuccess = onSubmitInvoiceSuccess;
        vm.spliceVatSummary = spliceVatSummary;
        vm.updateTotalizers = updateTotalizers;
        vm.pharmaReception = pharmaReception;
        vm.createReceptionNote = true;

        function save() {
            PharmaReception.save(vm.pharmaReception, autoSaveOk, autoSaveNok);
        }

		function autoSaveOk(result) {}
		function autoSaveNok(err) {}

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.receptionsModule) {
                    $state.go('accessdenied');
                } else {
					$http.get("api/common/_searchWarehousesForSelect").then(function(result) { vm.warehouses = result.data; });
					$http.get("api/common/_searchSuppliersForSelect").then(function(result) { vm.suppliers = result.data; });
					$http.get("api/common/_searchPurchaseTypesForSelect").then(function(result) { vm.purchaseTypes = result.data; });
                    if (vm.pharmaReception.pharmaReceptionInvoice == null) {
                        vm.pharmaReception.pharmaReceptionInvoice = {};
                        vm.pharmaReception.pharmaReceptionInvoice.invoiceAmount = 0;
                        vm.pharmaReception.pharmaReceptionInvoice.paymentDiscount = 0;
                        if (vm.pharmaReception.pharmaReceptionInvoice.invoiceDate != null) {
                            vm.pharmaReception.pharmaReceptionInvoice.invoiceDate = new Date(vm.pharmaReception.pharmaReceptionInvoice.invoiceDate);
                        }
                        $http.post("api/common/_getDefaultOrderTypeForUser", vm.pharmaReception.supplier).then(function (result) {
                            vm.pharmaReception.pharmaReceptionInvoice.invoicePurchaseType = result.data;
                        });
                    } else {
						if(vm.pharmaReception.pharmaReceptionInvoice.invoiceAmount == null) { vm.pharmaReception.pharmaReceptionInvoice.invoiceAmount = 0; }
						if(vm.pharmaReception.pharmaReceptionInvoice.paymentDiscount == null) { vm.pharmaReception.pharmaReceptionInvoice.paymentDiscount = 0; }

                        if (vm.pharmaReception.pharmaReceptionInvoice.invoiceDate != null) {
                            vm.pharmaReception.pharmaReceptionInvoice.invoiceDate = new Date(vm.pharmaReception.pharmaReceptionInvoice.invoiceDate);
                        }
                        if (vm.pharmaReception.pharmaReceptionInvoice.invoicePurchaseType == null) {
                            $http.post("api/common/_getDefaultOrderTypeForUser", vm.pharmaReception.supplier).then(function (result) {
                                vm.pharmaReception.pharmaReceptionInvoice.invoicePurchaseType = result.data;
                            });
                        }
                    }
                }
            });
        }
        vm.loadAll();

        $scope.saveInvoicePurchaseType = function ($item, $model) {
            vm.pharmaReception.pharmaReceptionInvoice.invoicePurchaseType = $model;
            save();
        }

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        // TODO this should be done atomically; done this way due to the lack of time
        function getWarehouseFullDescription() {
            if (!angular.isDefined(vm.pharmaReception.warehouseFullDescription)) {
                if (angular.isDefined(vm.warehouses)) {
                    var warehouse = $filter('filter')(vm.warehouses, {
                        code: vm.pharmaReception.warehouse
                    })[0];
                    vm.pharmaReception.warehouseFullDescription = vm.pharmaReception.warehouse + (warehouse != null ? ' - ' + warehouse.description : '');
                } else {
                    return vm.pharmaReception.warehouse;
                }
            }
            return vm.pharmaReception.warehouseFullDescription;
        }

        // TODO this should be done atomically; done this way due to the lack of time
        function getSupplierFullDescription() {
            if (!angular.isDefined(vm.pharmaReception.supplierFullDescription)) {
                if (angular.isDefined(vm.suppliers)) {
                    var supplier = $filter('filter')(vm.suppliers, {
                        code: vm.pharmaReception.supplier
                    })[0];
                    vm.pharmaReception.supplierFullDescription = vm.pharmaReception.supplier + (supplier != null ? ' - ' + supplier.description : '');
                } else {
                    return vm.pharmaReception.supplier;
                }
            }
            return vm.pharmaReception.supplierFullDescription;
        }

        function confirmPharmaReceptionSubmit() {
            blockUI.start($translate.instant('pharmaPortalApp.pharmaReception.message.submittingPharmaReception'));

            PharmaReception.submit({
                id: pharmaReception.id,
                createReceptionNote: vm.createReceptionNote
            }, onSubmitSuccess, onSubmitError);
        }

        function onSubmitSuccess(result) {
            blockUI.stop();
            $uibModalInstance.close(true);

            if (result.success) {
                Notification.success({message: result.message, delay: 5000});
                if (vm.totalizer.differencesAmount != 0) {
                    $state.go("pharma-reception.confirmDifferences", {id: vm.pharmaReception.id}, {reload: true});
                } else {
                    $state.go("pharma-reception", {}, {reload: true});
                }
            } else {
                Notification.error({message: result.message, delay: ''});
                $state.go("pharma-reception-detail", {id: vm.pharmaReception.id}, {reload: true});
            }
        }

        function onSubmitError(result) {
            blockUI.stop();
            $uibModalInstance.close(true);

            if (result.success) {
                Notification.success({message: result.message, delay: 5000});
            } else {
                Notification.error({message: result.message, delay: ''});
            }
        }

        function validateInvoiceForm() {
            var totalValidation = 0;
            var vatValidation = 0;

            angular.forEach(vm.totalizer.vatTable, function (value, key) {
                totalValidation = totalValidation + value.vatAmount + value.productsAmount - value.discountProductsAmount + value.servicesAmount - value.discountServicesAmount;
                vatValidation += value.vatAmount;
            });

            if (Number(vm.pharmaReception.pharmaReceptionInvoice.invoiceAmount.toFixed(2)) < Number(vatValidation.toFixed(2))) {
                Notification.error({message: $translate.instant('pharmaPortalApp.pharmaReception.message.error.highVat'), delay: ''});
                return false;
            } else if ((Number(vm.pharmaReception.pharmaReceptionInvoice.invoiceAmount) + Number(vm.pharmaReception.pharmaReceptionInvoice.paymentDiscount.toFixed(2))) != Number(totalValidation.toFixed(2))) {
                Notification.error({message: $translate.instant('pharmaPortalApp.pharmaReception.message.error.diffTotals'), delay: ''});
                return false;
            }
            return true;
        }

        function confirmReceptionPurchaseInvoiceSubmit() {
            // PASS LINES TO TOTALIZER AGAIN
            vm.totalizer.vatTable = [];
            angular.forEach(vm.pharmaReception.pharmaReceptionInvoice.pharmaReceptionVatLines, function (value, key) {
                var vatRateTotalizer = new PharmaReceptionVatLine();
                vatRateTotalizer.vatRate = value.vatRate;
                vatRateTotalizer.vatCode = value.vatCode;
                vatRateTotalizer.vatAmount = value.vatAmount != null ? value.vatAmount : 0;
                vatRateTotalizer.productsAmount = value.productsAmount != null ? value.productsAmount : 0;
                vatRateTotalizer.discountProductsAmount = value.discountProductsAmount != null ? value.discountProductsAmount : 0;
                vatRateTotalizer.servicesAmount = value.servicesAmount != null ? value.servicesAmount : 0;
                vatRateTotalizer.discountServicesAmount = value.discountServicesAmount != null ? value.discountServicesAmount : 0;
                vatRateTotalizer.differencesAmount = value.differencesAmount != null ? value.differencesAmount : 0;

                vm.totalizer.vatTable.push(vatRateTotalizer);
            });

            if (validateInvoiceForm()) {
                // GENERATE NOTE AND INVOICE
                if (pharmaReception.status === 'CREATED') {
                    blockUI.start($translate.instant('pharmaPortalApp.pharmaReception.message.submittingPharmaReception'));
                    PharmaReception.submit({
                        id: pharmaReception.id,
                        createReceptionNote: vm.createReceptionNote
                    }, onSuccessSubmitInvoice, onErrorSubmitInvoice);
                } else {
                    // GENERATE INVOICE ONLY
                    vm.checkIfNoteClosed(1);
                }
            }
        }

        function onSuccessSubmitInvoice(result) {
            blockUI.stop();

            if (result.success) {
                vm.checkIfNoteClosed(1);
                Notification.success({message: result.message, delay: ''});
            } else {
                Notification.error({message: result.message, delay: ''});
            }
        }

        function onErrorSubmitInvoice(result) {
            blockUI.stop();
            $uibModalInstance.close(true);

            if (result.success) {
                Notification.success({message: result.message, delay: 5000});
            } else {
                Notification.error({message: result.message, delay: ''});
            }
        }

        function checkIfNoteClosed(iteration) {
            var attemps = 5;
            var attempsInterval = 1000;
            if (vm.portalSettings.attemptsBeforeTimeout != null) {
                attemps = vm.portalSettings.attemptsBeforeTimeout;
            }

            if (vm.portalSettings.attemptsIntervalBeforeTimeout != null) {
                attempsInterval = vm.portalSettings.attemptsIntervalBeforeTimeout * 1000;
            }

            // CHECK IF NOTE EXISTS AND IS CLOSED IN QUANTITY SO GENERATE INVOICE ONLY
            vm.iterator = angular.isDefined(iteration) ? iteration : 0;

            vm.noteStatus = "";
            blockUI.start($translate.instant('pharmaPortalApp.pharmaReception.message.checkIfNoteIsClosed'));

            $http.get("api/common/checkIfNoteIsClosed/" + pharmaReception.id).then(function (result) {
                vm.noteStatus = result.data;
                vm.iterator++;

                if (vm.iterator <= attemps && vm.noteStatus !== "Q") {
                    $timeout(function () {
                        vm.checkIfNoteClosed(vm.iterator);
                    }, attempsInterval);
                } else {
                    if (vm.noteStatus === "Q") {
                        vm.iterator = attemps;
                        if (pharmaReception.status === "INVOICED") {
                            Notification.error({message: $translate.instant('pharmaPortalApp.pharmaReception.message.error.invoiceExists'), delay: ''});
                        } else {
                            onSubmitInvoiceSuccess({success: true});
                        }
                    } else if (vm.iterator >= attemps) {
                        if (vm.noteStatus === "V") {
                            Notification.error({message: $translate.instant('pharmaPortalApp.pharmaReception.message.error.noteClosedInValue'), delay: ''});
                        } else {
                            Notification.error({message: $translate.instant('pharmaPortalApp.pharmaReception.message.error.noteTimeout'), delay: ''});
                        }
                    }
                    blockUI.reset();
                }
            });
        }

        function onSubmitInvoiceSuccess(result) {
            $http.get("api/pharma-reception/" + pharmaReception.id + "/orderVatSummary").then(function (requestResult) {
                vm.noteDetails = requestResult.data;

                blockUI.stop();
                if (vm.spliceVatSummary()) {
                    if (!result || result.success) {
                        if (result.message) {
                            Notification.success({message: result.message, delay: 5000});
                        }

                        blockUI.start($translate.instant('pharmaPortalApp.pharmaReception.message.submittingPharmaReceptionInvoice'));

                        vm.totalizer.id = pharmaReception.id;

                        PharmaReception.submitInvoice({
                            params: vm.totalizer
                        }, function (result) {
                            blockUI.stop();
                            vm.hasErrors = false;
                            if (result.createSupplierInvoice11Reply.replyCode !== 'OK') {
                                vm.hasErrors = true;
                                vm.errorMessage = result.createSupplierInvoice11Reply.replyDescription;
                                if (result.errors !== undefined && result.errors.length > 0) {
                                    angular.forEach(result.errors, function (error) {
                                        if (vm.errorMessage !== undefined && error.errorDescription !== undefined) {
                                            vm.errorMessage += '<br>' + error.errorDescription;
                                        }
                                    });
                                }
                                vm.msgStr = $translate.instant('pharmaPortalApp.pharmaReception.message.error.submittingPharmaReceptionInvoice', {errorDescription: vm.errorMessage});
                                var decodedMsg = angular.element('<textarea />').html(vm.msgStr).text();
                                Notification.error({message: decodedMsg, delay: ''});
                                $uibModalInstance.close(true);
                                $state.go("pharma-reception-detail", { id : vm.pharmaReception.id }, { reload : true });
                            }

                            if (!vm.hasErrors) {
                                Notification.success({message: $translate.instant('pharmaPortalApp.pharmaReception.message.pharmaReceptionInvoiceSubmited'), delay: ''});
                                $uibModalInstance.close(true);
                                $state.go("pharma-reception", {}, {reload: true});
                            }
                        }, onSubmitError);
                    } else {
                        Notification.error({message: result.message, delay: ''});
                    }
                }
            }, function (requestResult) {
                Notification.error({message: $translate.instant('pharmaPortalApp.pharmaReception.message.error.noteVatList'), delay: ''});
            });
        }

        function spliceVatSummary() {
            var totals = {vatTable: [], diffTable: []};

            // GET ORDER VAT SUMMARY
            if (angular.isDefined(vm.noteDetails)) {
                angular.forEach(vm.noteDetails, function (value, key) {
//					var vatRateTotalizer = $filter("filter")(vm.totalizer.vatTable, {vatRate:(value.vatrate != null ? value.vatrate : 0), vatCode : value.vatcode});
                    var vatRateTotalizer = $filter("filter")(vm.totalizer.vatTable, {vatRate: (value.vatrate != null ? value.vatrate : 0)});

                    if (!angular.isDefined(vatRateTotalizer[0])) {
                        // vatcode: "BCL", vatrate: "6", vatamount: "1.944000000000", productamount: "36.000000", productdiscountamount: "3.600000"
                        vatRateTotalizer[0] = {
                            vatRate: value.vatrate,
                            vatCode: value.vatcode,
                            vatAmount: value.vatamount,
                            productsAmount: value.productamount,
                            productsDiscountAmount: value.productdiscountamount,
                            servicesAmount: 0,
                            servicesDiscountAmount: 0,
                            differencesAmount: 0
                        };
                    } else {
                        vatRateTotalizer[0].vatCode = value.vatcode;
                        vatRateTotalizer[0].differencesAmount = 0;
                    }
                    totals.vatTable.push(vatRateTotalizer[0]);
                });
            }

            // GET ORDER SERVICE SUMMARY
            angular.forEach(vm.pharmaReception.pharmaReceptionLines, function (value, key) {
                if (value.serviceLine) {
                    var vatRateTotalizer = $filter("filter")(vm.totalizer.vatTable, {vatRate: (value.vatRate != null ? value.vatRate : 0), vatCode: value.lot});

                    if (!angular.isDefined(vatRateTotalizer[0])) {
                        vatRateTotalizer[0] = {
                            vatRate: value.vatRate,
                            vatCode: value.lot,
                            vatAmount: 0,
                            productsAmount: 0,
                            productsDiscountAmount: 0,
                            servicesAmount: 0,
                            servicesDiscountAmount: 0,
                            differencesAmount: 0
                        };
                        totals.vatTable.push(vatRateTotalizer[0]);

                        var vatValue = value.unitPrice * (value.vatRate != null && angular.isNumber(value.vatRate) && !isNaN(value.vatRate) ? value.vatRate / 100 : 0);
                        vatRateTotalizer[0].servicesAmount += value.unitPrice;
                        vatRateTotalizer[0].vatAmount += vatValue;
                    }
                }
            });

            // CHECK DIFFERENCES AND CONVERT IT TO SERVICES IF NEEDED

            angular.forEach(vm.totalizer.vatTable, function (value, key) {
                if (value.differencesAmount !== 0) {
                    //PROCURA NOS SERVIÇOS DO SETTINGS POR BASE DE IVA
                    var serviceCodeByCurVat = $filter("filter")(vm.pharmaReceptionServiceByVat, {vatRate: value.vatRate});
                    if (!angular.isDefined(serviceCodeByCurVat[0])) {
                        Notification.error({message: $translate.instant('pharmaPortalApp.pharmaReception.message.error.diffVatService') + value.vatRate + " %", delay: ''});
                        return false;
                    } else {
                        //PROCURA NAS BASES DE IVA JÁ EXISTENTES NA FATURA POR VATCODE E VATRATE
                        var invoiceVats = $filter("filter")(totals.vatTable, {vatRate: serviceCodeByCurVat[0].vatRate, vatCode: serviceCodeByCurVat[0].vatCode});
                        if (!angular.isDefined(invoiceVats[0])) {
                            // CRIA NOVO
                            invoiceVats[0] = {
                                vatRate: serviceCodeByCurVat[0].vatRate,
                                vatCode: serviceCodeByCurVat[0].vatCode,
                                vatAmount: -1 * (value.differencesAmount * (Number(serviceCodeByCurVat[0].vatRate) / 100)),
                                productsAmount: 0,
                                productsDiscountAmount: 0,
                                servicesAmount: -1 * value.differencesAmount,
                                servicesDiscountAmount: 0
                            };
                            totals.vatTable.push(invoiceVats[0]);
                        } else {
                            // ADICIONA
                            invoiceVats[0].servicesAmount -= value.differencesAmount;
                            invoiceVats[0].vatAmount -= (value.differencesAmount * (Number(serviceCodeByCurVat[0].vatRate) / 100));
                        }

                        var diffLine = {
                            serviceCode: serviceCodeByCurVat[0].code,
                            vatCode: serviceCodeByCurVat[0].vatCode,
                            serviceAmount: -1 * value.differencesAmount,
                            discountAmount: 0,
                            discountPercentage: 0
                        }
                        totals.diffTable.push(diffLine);
                    }
                }
            });

            vm.totalizer.diffTable = totals.diffTable;
            vm.totalizer.vatTable = totals.vatTable;
            return true;
        }

        function updateTotalizers() {
            vm.totalizer = {differencesAmount: 0, vatTable: []};

            if (vm.pharmaReception.pharmaReceptionInvoice === null) {
                vm.pharmaReception.pharmaReceptionInvoice = {};
                vm.pharmaReception.pharmaReceptionInvoice.pharmaReceptionVatLines = [];
            }

            angular.forEach(vm.pharmaReception.pharmaReceptionLines, function (value, key) {

                var receivedQuantity = (value.receivedQuantity != null && angular.isNumber(value.receivedQuantity) && !isNaN(value.receivedQuantity) ? value.receivedQuantity : 0);
                var invoicedQuantity = (value.invoicedQuantity != null && angular.isNumber(value.invoicedQuantity) && !isNaN(value.invoicedQuantity) ? value.invoicedQuantity : 0);
                var bonusQuantity = (value.bonusQuantity != null && angular.isNumber(value.bonusQuantity) && !isNaN(value.bonusQuantity) ? value.bonusQuantity : 0);
                var unitPrice = (value.unitPrice != null && angular.isNumber(value.unitPrice) && !isNaN(value.unitPrice) ? value.unitPrice : 0);
                var discount1 = (value.discount1 != null && angular.isNumber(value.discount1) && !isNaN(value.discount1) ? value.discount1 : 0);
                var discount2 = (value.discount2 != null && angular.isNumber(value.discount2) && !isNaN(value.discount2) ? value.discount2 : 0);
                var unitPriceWithDiscount = unitPrice * (1 - (discount1 / 100)) * (1 - (discount2 / 100));

                var vatRateTotalizer = $filter("filter")(vm.pharmaReception.pharmaReceptionInvoice.pharmaReceptionVatLines, {vatRate: (value.vatRate != null ? value.vatRate : 0)});
                if (!angular.isDefined(vatRateTotalizer[0])) {
                    var vatRateTotalizer = new PharmaReceptionVatLine();
                    vatRateTotalizer.vatRate = value.vatRate;
                    vatRateTotalizer.vatCode = value.vatCode;
                    vatRateTotalizer.vatAmount = value.vatValue != null ? value.vatValue : 0;
                    vatRateTotalizer.productsAmount = value.productsAmount != null ? value.productsAmount : 0;
                    vatRateTotalizer.discountProductsAmount = value.discountProductsAmount != null ? value.discountProductsAmount : 0;
                    vatRateTotalizer.servicesAmount = value.servicesAmount != null ? value.servicesAmount : 0;
                    vatRateTotalizer.discountServicesAmount = value.discountServicesAmount != null ? value.discountServicesAmount : 0;
                    vatRateTotalizer.differencesAmount = (receivedQuantity - invoicedQuantity - bonusQuantity) * unitPriceWithDiscount;
                    vm.pharmaReception.pharmaReceptionInvoice.pharmaReceptionVatLines.push(vatRateTotalizer);

                    vm.totalizer.differencesAmount += (receivedQuantity - invoicedQuantity - bonusQuantity) * unitPriceWithDiscount;
                    vm.totalizer.vatTable.push(vatRateTotalizer);
                } else {
                    if (vatRateTotalizer[0].differencesAmount == null) {
                        vatRateTotalizer[0].differencesAmount = (receivedQuantity - invoicedQuantity - bonusQuantity) * unitPriceWithDiscount;
                    } else {
                        vatRateTotalizer[0].differencesAmount += (receivedQuantity - invoicedQuantity - bonusQuantity) * unitPriceWithDiscount;
                    }

                    vm.totalizer.differencesAmount += (receivedQuantity - invoicedQuantity - bonusQuantity) * unitPriceWithDiscount;
                    vm.totalizer.vatTable.push(vatRateTotalizer[0]);
                }

                var vatRateTotalizer = $filter("filter")(vm.totalizer.vatTable, {vatRate: (value.vatRate != null ? value.vatRate : 0)});
                if (!angular.isDefined(vatRateTotalizer[0])) {
                    vatRateTotalizer[0] = {
                        vatRate: (value.vatRate != null ? value.vatRate : 0),
                        vatCode: "",
                        vatValue: 0,
                        productsAmount: 0,
                        discountProductsAmount: 0,
                        servicesAmount: 0,
                        discountServicesAmount: 0,
                        differencesAmount: 0
                    };
                    vm.totalizer.vatTable.push(vatRateTotalizer[0]);
                }
            });
        }
        vm.updateTotalizers();

        vm.datePopup = {opened: false};
		vm.openDatePopup = function() { vm.datePopup.opened = true; };
        vm.dateOptions = {formatYear: 'yyyy', startingDay: 1, showWeeks: false, maxDate: new Date()};
		$scope.sorterFunc = function(vatRateTotalizer){ return parseInt(vatRateTotalizer.vatRate); };
    }
})();

(function() {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaReceptionInactiveController', PharmaReceptionInactiveController);

    PharmaReceptionInactiveController.$inject = [ '$uibModalInstance', '$rootScope', '$state', 'ModuleSettings' ];

    function PharmaReceptionInactiveController($uibModalInstance, $rootScope, $state, ModuleSettings) {
        var vm = this;

        vm.clear = clear;
        vm.confirmAddProducts = confirmAddProducts;
        vm.loadAll = loadAll;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmAddProducts() {
            $rootScope.searchProductsAction()
            $uibModalInstance.close(true);
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function(result) {
                vm.moduleSettings = result;

                /*if (!vm.moduleSettings.productsModule) {
                    $state.go('accessdenied');
                }*/
            });
        }
        loadAll();
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaReceptionNewController', PharmaReceptionNewController);

	PharmaReceptionNewController.$inject = [ 'Notification', '$scope', '$state', '$http', '$filter', 'PharmaReception', 'Principal', 'ModuleSettings', 'Company', '$rootScope' ];

	function PharmaReceptionNewController(Notification, $scope, $state, $http, $filter, PharmaReception, Principal, ModuleSettings, Company, $rootScope) {
		var vm = this;

		vm.loadAll = loadAll;
		vm.save = save;
		vm.isSaving = false;

        vm.checkCompanyWar = checkCompanyWar;
        vm.checkCompanySup = checkCompanySup;

		vm.pharmaReception = {
//			date : new Date(),
			orderType : 'DIR'
		};

		function onSaveSuccess(result) {
			vm.isSaving = false;
			$state.go("pharma-reception-detail", { id : result.id });
		}

		function onSaveError(result) {
			vm.isSaving = false;

			if (result.data.success) {
				Notification.success({ message : result.data.message, delay : 5000 });
			} else {
				Notification.error({ message : result.data.message, delay : '' });
			}
		}

		function save() {
			vm.isSaving = true;
			vm.pharmaReception.date.setHours(12); // trying to fix some timezone issues
			
			var curSupplier = $filter("filter")(vm.suppliers, { code : (vm.pharmaReception.supplier != null ? vm.pharmaReception.supplier : "") });
			if (angular.isDefined(curSupplier[0])){
				vm.pharmaReception.supplierNif = curSupplier[0].nif;  
			}
				
			PharmaReception.save(vm.pharmaReception, onSaveSuccess, onSaveError);
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.receptionsModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (account) {
							vm.account = account;
						} else {
							vm.account = null;
						}
					});
					$http.get("api/common/_searchWarehousesForSelect").then(function(result) {
						vm.warehouses = result.data;
						for (var i = 0; i < vm.warehouses.length; i++) {
							if (angular.isDefined(vm.account.company.pharmaWarehouse) && vm.warehouses[i].code == vm.account.company.pharmaWarehouse) {
								vm.pharmaReception.warehouse = vm.account.company.pharmaWarehouse;
								break;
							}
						}
					});
					$http.get("api/common/_searchSuppliersForSelect").then(function(result) {
						vm.suppliers = result.data;
					});
					$http.get("api/common/_searchOrderTypesForSelect").then(function(result) {
						vm.orderTypes = result.data;
					});
				}
			});
		}
		vm.loadAll();

		vm.datePopup = {
			opened : false
		};

		vm.openDatePopup = function() {
			vm.datePopup.opened = true;
		};

		vm.dateOptions = {
			formatYear : 'yyyy',
			startingDay : 1,
			showWeeks : false
		};

		function checkCompanyWar($item, $model) {
            Company.isInactive({"id":$item.code}, function (result) {
                if (result.regDate != null) {
                    result.regDate = result.regDate.substring(6,8) + "-" + result.regDate.substring(4,6) + "-" + result.regDate.substring(0,4);
                    result.regTime = result.regTime.substring(0,2) + ":" + result.regTime.substring(2,4) + ":" + result.regTime.substring(4,6);
                    result.company = $item.code + ' - ' + $item.description;
                    $rootScope.message = result;
                    for (var i = 0; i < vm.warehouses.length; i++) {
                        if (angular.isDefined(vm.account.company.pharmaWarehouse) && vm.warehouses[i].code == vm.account.company.pharmaWarehouse) {
                            vm.pharmaReception.warehouse = vm.account.company.pharmaWarehouse;
                            break;
                        }
                    }
                    $state.go("pharma-reception.inactive");
                }
            });
        }

        function checkCompanySup($item, $model) {
            Company.isInactive({"id":$item.code}, function (result) {
                if (result.regDate != null) {
                    result.regDate = result.regDate.substring(6,8) + "-" + result.regDate.substring(4,6) + "-" + result.regDate.substring(0,4);
                    result.regTime = result.regTime.substring(0,2) + ":" + result.regTime.substring(2,4) + ":" + result.regTime.substring(4,6);
                    result.company = $item.code + ' - ' + $item.description;
                    $rootScope.message = result;
                    vm.pharmaReception.supplier = null;
                    $state.go("pharma-reception.inactive");
                }
            });
        }
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaReceptionLineNewController', PharmaReceptionLineNewController);

	PharmaReceptionLineNewController.$inject = [ 'Notification', '$uibModalInstance', '$scope', '$state', '$timeout', '$http', 'pharmaReception', 'PharmaReceptionLine', 'PortalSettings', 'PharmaReceptionServiceList' ];

	function PharmaReceptionLineNewController(Notification, $uibModalInstance, $scope, $state, $timeout, $http, pharmaReception, PharmaReceptionLine, PortalSettings, PharmaReceptionServiceList) {
		var vm = this;
		
		vm.pharmaReception = pharmaReception;
		vm.portalSettings = PortalSettings.query();
		vm.clear = clear;
		vm.createPharmaReceptionLine = createPharmaReceptionLine;
		vm.createPharmaReceptionServiceLine = createPharmaReceptionServiceLine;
		vm.loadAll = loadAll;
		
		vm.isSaving = false;
		
		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function onSaveSuccess(result) {
			vm.isSaving = false;
			vm.pharmaReceptionLine = {};

			$scope.dialogForm.$setPristine();
			Notification.success({message: "Linha adicionada com sucesso", delay: 5000});
		    
			$state.go("pharma-reception-detail", {
				id : pharmaReception.id
			}, {
				reload : true
			});
			// $uibModalInstance.close(true);
		}

		function onSaveError(result) {
			vm.isSaving = false;
			
			if (result.data.success){
				Notification.success({message: result.data.message, delay: 5000});
			} else {
				Notification.error({message: result.data.message, delay: ''});
			}
		}

		function createPharmaReceptionLine() {
			vm.activeTab = 0;
			vm.isSaving = true;
			vm.pharmaReceptionLine.pharmaReceptionHeader = pharmaReception;
			vm.pharmaReceptionLine.cnp = vm.pharmaReceptionLine.product.cnp;
			vm.pharmaReceptionLine.description = vm.pharmaReceptionLine.product.fullName;
			vm.pharmaReceptionLine.vatRate = vm.pharmaReceptionLine.product.txiva;
			if (!angular.isDefined(vm.pharmaReceptionLine.invoicedQuantity)) {
				vm.pharmaReceptionLine.invoicedQuantity = vm.pharmaReceptionLine.receivedQuantity - (angular.isDefined(vm.pharmaReceptionLine.bonusQuantity) ? vm.pharmaReceptionLine.bonusQuantity : 0);
			}
			PharmaReceptionLine.save(vm.pharmaReceptionLine, onSaveSuccess, onSaveError);
		}
		
		function createPharmaReceptionServiceLine() {
			vm.activeTab = 1;
			vm.isSaving = true;
			vm.pharmaReceptionLine.pharmaReceptionHeader = pharmaReception;
			vm.pharmaReceptionLine.cnp = vm.pharmaReceptionLine.serviceType.code;
			vm.pharmaReceptionLine.description = vm.pharmaReceptionLine.serviceType.description;
			vm.pharmaReceptionLine.vatRate = vm.pharmaReceptionLine.serviceType.vatRate;
			vm.pharmaReceptionLine.invoicedQuantity = 0;
			vm.pharmaReceptionLine.receivedQuantity = 0;
			vm.pharmaReceptionLine.unitPrice = vm.pharmaReceptionLine.lineNetPrice;
			vm.pharmaReceptionLine.lot = vm.pharmaReceptionLine.serviceType.vatCode;
			vm.pharmaReceptionLine.serviceLine = true;
			PharmaReceptionLine.save(vm.pharmaReceptionLine, onSaveSuccess, onSaveError);
		}

		function loadAll() {
			$timeout( function(){
				if(pharmaReception.status === 'SUBMITTED') {
					vm.activeTab = 1;
				}

				$http.get("api/common/_searchQualityStatusesForSelect").then(function(result) {
					vm.qualityStatuses = [ { "code" : '', "description" : '' } ].concat(result.data);
				});
			
				if(vm.portalSettings.filterServicesToShow) {
					vm.serviceTypes = PharmaReceptionServiceList.query();
				} else {
					$http.get("api/common/_getServicesForSelect").then(function(result) {
						vm.serviceTypes = result.data;
					});
				}
			}, 500 );
		}
		loadAll();

		$scope.onOpenClose = function(isOpen) {
			angular.element('.ui-select-choices-row').removeClass('active');
		}

		$scope.refreshSelectModel = function(query) {
			$http.get("api/common/_searchProductsForSelect/" + query).then(function(result) {
				if (result.data.length > 500) {
					Notification.warning({message: "O número de resultados é superior a 500 registos. Por questões de performance, refine a sua pesquisa", delay: 5000});
					return;
				} else {
					vm.products = result.data;
				}
			});
		};
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaReceptionLineDeleteController', PharmaReceptionLineDeleteController);

	PharmaReceptionLineDeleteController.$inject = [ 'Notification', '$uibModalInstance', '$translate', '$state', 'pharmaReceptionLine', 'PharmaReceptionLine' ];

	function PharmaReceptionLineDeleteController(Notification, $uibModalInstance, $translate, $state, pharmaReceptionLine, PharmaReceptionLine) {
		var vm = this;

		vm.clear = clear;
		vm.confirmPharmaReceptionLineDelete = confirmPharmaReceptionLineDelete;
		vm.pharmaReceptionLine = pharmaReceptionLine;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function onDeleteSuccess(result) {
			$uibModalInstance.close(true);
			
			Notification.success({message: $translate.instant('pharmaPortalApp.pharmaReception.message.pharmaReceptionLineDeleted'), delay: 5000});
		}

		function onDeleteError(result) {
			$uibModalInstance.close(true);
			
			if (result.data.success){
				Notification.success({message: result.data.message, delay: 5000});
			} else {
				Notification.error({message: result.data.message, delay: ''});
			}
		}

		function confirmPharmaReceptionLineDelete() {
			PharmaReceptionLine.delete({id: pharmaReceptionLine.id}, onDeleteSuccess, onDeleteError);
		}
	}
})();
(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaReceptionDetailController', PharmaReceptionDetailController);

    PharmaReceptionDetailController.$inject = ['Notification', 'blockUI', '$scope', '$state', '$filter', '$http', '$window', '$translate', '$uibModal', 'ParseLinks', 'PharmaReception', 'Upload', 'entity', 'PortalSettings', 'ModuleSettings'];

    function PharmaReceptionDetailController(Notification, blockUI, $scope, $state, $filter, $http, $window, $translate, $uibModal, ParseLinks, PharmaReception, Upload, entity, PortalSettings, ModuleSettings) {
        var vm = this;

        vm.portalSettings = PortalSettings.query();
        vm.pharmaReception = entity;
        vm.working = false;
        vm.pharmaReception.date = new Date(vm.pharmaReception.date);

        vm.loadAll = loadAll;
        vm.submitPharmaReception = submitPharmaReception;
        vm.save = save;
        vm.backToReceptions = backToReceptions;
        vm.togglePharmaReceptionLineEditMode = togglePharmaReceptionLineEditMode;
        vm.onBlurFromLot = onBlurFromLot;
        vm.onBlurFromReceivedQuantity = onBlurFromReceivedQuantity;
        vm.onBlurFromInvoicedQuantity = onBlurFromInvoicedQuantity;
        vm.onBlurFromBonusQuantity = onBlurFromBonusQuantity;
        vm.getTemplate = getTemplate;
        vm.uploadFile = uploadFile;
        vm.exportToExcel = exportToExcel;
        vm.exportToLogitoolsExcel = exportToLogitoolsExcel;
        vm.updateTotalizers = updateTotalizers;

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.receptionsModule) {
                    $state.go('accessdenied');
                } else {
                    $http.get("api/common/_searchWarehousesForSelect").then(function (result) {
                        vm.warehouses = result.data;
                    });
                    $http.get("api/common/_searchSuppliersForSelect").then(function (result) {
                        vm.suppliers = result.data;
                    });
                    $http.get("api/common/_searchOrderTypesForSelect").then(function (result) {
                        vm.orderTypes = result.data;
                    });
                    $http.get("api/common/_searchQualityStatusesForSelect").then(function (result) {
                        vm.qualityStatuses = [{
                            "code": '',
                            "description": ''
                        }].concat(result.data);
                    });
                }
            });
        }

        loadAll();

        function submitPharmaReception() {
            if (isDataValidForSubmission()) {
                PharmaReception.save(vm.pharmaReception, validateVatNumber, onSaveError);
            }
        }

        function isDataValidForSubmission() {
            var errors = [];
            if (angular.isDefined(vm.pharmaReception.pharmaReceptionLines) && vm.pharmaReception.pharmaReceptionLines.length > 0) {
                for (var i = 0; i < vm.pharmaReception.pharmaReceptionLines.length; i++) {
                    var value = vm.pharmaReception.pharmaReceptionLines[i];
                    var receivedQuantity = (value.receivedQuantity != 'null' && angular.isNumber(value.receivedQuantity) && !isNaN(value.receivedQuantity) ? value.receivedQuantity : 0);
                    var invoicedQuantity = (value.invoicedQuantity != 'null' && angular.isNumber(value.invoicedQuantity) && !isNaN(value.invoicedQuantity) ? value.invoicedQuantity : 0);
                    var bonusQuantity = (value.bonusQuantity != 'null' && angular.isNumber(value.bonusQuantity) && !isNaN(value.bonusQuantity) ? value.bonusQuantity : 0);
                    // negative quantities
                    if (receivedQuantity < 0 || invoicedQuantity < 0 || bonusQuantity < 0) {
                        errors.push($translate.instant('pharmaPortalApp.pharmaReception.message.error.negativeQuantities', {cnp: value.cnp}));
                    }
                    var unitPrice = (value.unitPrice != 'null' && angular.isNumber(value.unitPrice) && !isNaN(value.unitPrice)) ? value.unitPrice : 0;
                    // negative price
                    if (unitPrice < 0) {
                        errors.push($translate.instant('pharmaPortalApp.pharmaReception.message.error.negativeUnitPrice', {cnp: value.cnp}));
                    }
                    // quantity without unit price
                    if (!(angular.isDefined(vm.portalSettings.receptionDefineNoteCreation) && vm.portalSettings.receptionDefineNoteCreation == true) && invoicedQuantity != 0 && unitPrice == 0) {
                        errors.push($translate.instant('pharmaPortalApp.pharmaReception.message.error.quantityWithoutUnitPrice', {cnp: value.cnp}));
                    }
                }
                if (errors.length > 0) {
                    var message = '';
                    for (var i = 0; i < errors.length; i++) {
                        if (i > 0) {
                            message += '<br>';
                        }
                        message += errors[i];
                    }
                    Notification.error({
                        message: $translate.instant('pharmaPortalApp.pharmaReception.message.error.submission') + '<br>' + message,
                        delay: ''
                    });
                    return false;
                }
                return true;
            } else {
                Notification.error({
                    message: $translate.instant('pharmaPortalApp.pharmaReception.message.error.submission') + $translate.instant('pharmaPortalApp.pharmaReception.message.error.noLines'),
                    delay: ''
                });
                return false;
            }
        }

        function validateVatNumber() {
            vm.working = false;
            if (vm.pharmaReception.vatValidated == vm.pharmaReception.supplierNif) {
                onSaveSuccessFromSubmit();
            } else {
                vm.updateTotalizers();
                $uibModal.open({
                    templateUrl: 'app/entities/pharma-reception/pharma-reception-validate-vat-number-dialog.html',
                    controller: 'PharmaReceptionValidateVatNumberController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PharmaReception', function (PharmaReception) {
                            return PharmaReception.get({
                                id: vm.pharmaReception.id
                            });
                        }]
                    }
                }).result.then(function () {
                    onSaveSuccessFromSubmit();
                });
            }
        }

        function onSaveSuccessFromSubmit() {
            vm.working = false;
            vm.updateTotalizers();
            $uibModal.open({
                templateUrl: 'app/entities/pharma-reception/pharma-reception-submit-dialog.html',
                controller: 'PharmaReceptionSubmitController',
                controllerAs: 'vm',
                size: vm.portalSettings.exportPurchaseInvoice ? 'lg modal-exl' : 'md',
                resolve: {
                    pharmaReception: ['PharmaReception', function (PharmaReception) {
                        return PharmaReception.get({
                            id: vm.pharmaReception.id
                        }).$promise;
                    }]
                }
            }).result.then(function () {
                // success callback implemented on own controller
            }, function () {
                $state.go('pharma-reception-detail', {
                    id: vm.pharmaReception.id
                }, {
                    reload: true
                });
            });
        }

        function save() {
            vm.working = true;
            if (vm.pharmaReception.date) {
                vm.pharmaReception.date.setHours(12); // trying to fix some timezone issues
            }

            var curSupplier = $filter("filter")(vm.suppliers, {code: (vm.pharmaReception.supplier != null ? vm.pharmaReception.supplier : "")});
            if (angular.isDefined(curSupplier) && angular.isDefined(curSupplier[0])) {
                vm.pharmaReception.supplierNif = curSupplier[0].nif;
            }

            PharmaReception.save(vm.pharmaReception, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.working = false;
            vm.updateTotalizers();
            $state.go("pharma-reception-detail", {
                id: result.id
            });
        }

        function onSaveError(result) {
            vm.working = false;
            if (result.data.success) {
                Notification.success({
                    message: result.data.message,
                    delay: 5000
                });
            } else {
                Notification.error({
                    message: result.data.message,
                    delay: ''
                });
            }
        }

        function backToReceptions() {
            $state.go("pharma-reception");
        }

        function togglePharmaReceptionLineEditMode(pharmaReceptionLine) {
            if (angular.isDefined(pharmaReceptionLine.editMode) && pharmaReceptionLine.editMode == true) {
                pharmaReceptionLine.editMode = false;
            } else {
                pharmaReceptionLine.editMode = true;
            }
            save();
        }

        function onBlurFromLot(pharmaReceptionLine) {
            if (angular.isDefined(pharmaReceptionLine.lot) && pharmaReceptionLine.lot != null) {
                pharmaReceptionLine.lot = pharmaReceptionLine.lot.toUpperCase();
            }
            save();
        }

        function onBlurFromReceivedQuantity(pharmaReceptionLine) {
            // check valid quantity
            if (pharmaReceptionLine.receivedQuantity == null) {
                pharmaReceptionLine.receivedQuantity = pharmaReceptionLine.oldReceivedQuantity;
                return;
            }
            if (pharmaReceptionLine.receivedQuantity < 0) {
                pharmaReceptionLine.errorOnReceivedQuantity = true;
            } else {
                pharmaReceptionLine.errorOnReceivedQuantity = false;
            }
            pharmaReceptionLine.oldReceivedQuantity = pharmaReceptionLine.receivedQuantity;
            save();
        }

        function onBlurFromInvoicedQuantity(pharmaReceptionLine) {
            if (!angular.isDefined(pharmaReceptionLine.invoicedQuantity) || pharmaReceptionLine.invoicedQuantity == null) {
                pharmaReceptionLine.invoicedQuantity = pharmaReceptionLine.receivedQuantity - (angular.isDefined(pharmaReceptionLine.bonusQuantity) ? pharmaReceptionLine.bonusQuantity : 0);
            }
            // check valid quantity
            if (pharmaReceptionLine.invoicedQuantity < 0) {
                pharmaReceptionLine.errorOnInvoicedQuantity = true;
            } else {
                pharmaReceptionLine.errorOnInvoicedQuantity = false;
            }
            save();
        }

        function onBlurFromBonusQuantity(pharmaReceptionLine) {
            // check valid quantity
            if (pharmaReceptionLine.bonusQuantity < 0) {
                pharmaReceptionLine.errorOnBonusQuantity = true;
            } else {
                pharmaReceptionLine.errorOnBonusQuantity = false;
            }
            save();
        }

        function getTemplate() {
            $window.open("api/pharma-reception/template");
        }

        function uploadFile(file) {
            vm.working = true;
            save();
            blockUI.start($translate.instant('pharmaPortalApp.pharmaReception.message.uploadingTemplate'));
            file.upload = Upload.upload({
                url: 'api/pharma-reception/upload',
                fields: {
                    pharmaReceptionHeaderId: vm.pharmaReception.id
                },
                file: file
            }).then(function (response) {
                file.result = response.data;
                if (response.data.success) {
                    Notification.success({
                        message: response.data.message,
                        delay: 5000
                    });
                } else {
                    Notification.error({
                        message: response.data.message,
                        delay: ''
                    });
                }

                $state.go("pharma-reception-detail", {id: vm.pharmaReception.id}, {reload: true});
                vm.working = false;
                blockUI.stop();
            }, function (response) {
                if (response.status == 200) {
                    if (response.data.success) {
                        Notification.success({
                            message: response.data.message,
                            delay: 5000
                        });
                    } else {
                        Notification.error({
                            message: response.data.message,
                            delay: ''
                        });
                    }
                } else {
                    Notification.error({
                        message: response.status + ': ' + response.data,
                        delay: ''
                    });
                }

                $state.go("pharma-reception-detail", {id: vm.pharmaReception.id}, {reload: true});
                vm.working = false;
                blockUI.stop();
            }, function (evt) {
                // Math.min is to fix IE which reports 200% sometimes
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
        }

        function exportToExcel() {
            save();
            $http.get("api/pharma-reception/" + vm.pharmaReception.id + "/toExcel", {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, "Recepção_" + vm.pharmaReception.id + "_" + dateTime + ".xlsx", true);
                Notification.success({
                    message: "Recepção exportada com sucesso",
                    delay: 5000
                });
            }, function errorCallback(response) {
                Notification.error({
                    message: "Erro ao exportar recepção",
                    delay: ''
                });
            });
        }

        function exportToLogitoolsExcel() {
            if (isDataValidForSubmission()) {
                save();
                $http.get("api/pharma-reception/" + vm.pharmaReception.id + "/toLogitoolsExcel", {
                    responseType: "arraybuffer"
                }).then(function successCallback(response) {
                    var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
                    var blob = new Blob([response.data], {
                        type: "application/vnd.ms-excel"
                    });
                    saveAs(blob, "Recepção_" + vm.pharmaReception.id + "_" + dateTime + ".xlsx", true);
                    Notification.success({
                        message: "Recepção exportada com sucesso",
                        delay: 5000
                    });
                }, function errorCallback(response) {
                    Notification.error({
                        message: "Erro ao exportar recepção",
                        delay: ''
                    });
                });
            } else {
                $("html, body").animate({scrollTop: 0});
            }
        }

        function updateTotalizers() {
            vm.totalizer = {
                receivedQuantity: 0,
                invoicedPlusBonusQuantity: 0,
                differences: 0,
                incidenceBase: 0,
                discount: 0,
                vatValue: 0,
                total: 0,
                vatTable: []
            };
            angular.forEach(vm.pharmaReception.pharmaReceptionLines, function (value, key) {
                var receivedQuantity = (value.receivedQuantity != null && angular.isNumber(value.receivedQuantity) && !isNaN(value.receivedQuantity) ? value.receivedQuantity : 0);
                var invoicedQuantity = (value.invoicedQuantity != null && angular.isNumber(value.invoicedQuantity) && !isNaN(value.invoicedQuantity) ? value.invoicedQuantity : 0);
                var bonusQuantity = (value.bonusQuantity != null && angular.isNumber(value.bonusQuantity) && !isNaN(value.bonusQuantity) ? value.bonusQuantity : 0);

                var unitPrice = (value.unitPrice != null && angular.isNumber(value.unitPrice) && !isNaN(value.unitPrice) ? value.unitPrice : 0);
                var lineTotalValue = ((invoicedQuantity - bonusQuantity) * unitPrice).toFixed(2);

                var discount1 = (value.discount1 != null && angular.isNumber(value.discount1) && !isNaN(value.discount1) ? value.discount1 : 0);
                var discount2 = (value.discount2 != null && angular.isNumber(value.discount2) && !isNaN(value.discount2) ? value.discount2 : 0);
                var unitPriceWithDiscount = (unitPrice * (1 - (discount1 / 100)) * (1 - (discount2 / 100))).toFixed(3);
                var lineTotalValueWithDiscount = ((invoicedQuantity - bonusQuantity) * unitPriceWithDiscount).toFixed(2);

                vm.totalizer.receivedQuantity += receivedQuantity * 1;
                vm.totalizer.invoicedPlusBonusQuantity += invoicedQuantity * 1 + bonusQuantity * 1;
                vm.totalizer.differences += ((receivedQuantity - invoicedQuantity - bonusQuantity) * unitPriceWithDiscount).toFixed(2);

                var vatRateTotalizer = $filter("filter")(vm.totalizer.vatTable, {vatRate: (value.vatRate != null ? value.vatRate : 0)});
                if (!angular.isDefined(vatRateTotalizer[0])) {
                    vatRateTotalizer[0] = {
                        vatRate: (value.vatRate != null ? value.vatRate : 0),
                        incidenceBase: 0,
                        discount: 0,
                        vatValue: 0,
                        total: 0,
                        differences: 0
                    };
                    vm.totalizer.vatTable.push(vatRateTotalizer[0]);
                }

                vatRateTotalizer[0].differences += ((receivedQuantity - invoicedQuantity - bonusQuantity) * unitPriceWithDiscount).toFixed(2);

                var incidenceBase = invoicedQuantity * unitPrice.toFixed(2);
                incidenceBase = Number(incidenceBase.toFixed(2));
                vatRateTotalizer[0].incidenceBase += incidenceBase;
                vatRateTotalizer[0].incidenceBase = Number(vatRateTotalizer[0].incidenceBase.toFixed(3));
                vm.totalizer.incidenceBase += incidenceBase;
                vm.totalizer.incidenceBase = Number(vm.totalizer.incidenceBase.toFixed(3));

                var discount = lineTotalValue - lineTotalValueWithDiscount;
                vatRateTotalizer[0].discount -= discount;
                vatRateTotalizer[0].discount  = Number(vatRateTotalizer[0].discount.toFixed(2));
                vm.totalizer.discount -= discount;
                vm.totalizer.discount = Number(vm.totalizer.discount.toFixed(3));

                var vatValue = (incidenceBase - discount) * (value.vatRate != null && angular.isNumber(value.vatRate) && !isNaN(value.vatRate) ? value.vatRate / 100 : 0);
                vatRateTotalizer[0].vatValue += Number(vatValue.toFixed(3));
                vm.totalizer.vatValue += vatValue;
                vm.totalizer.vatValue = Number(vm.totalizer.vatValue .toFixed(3));

                var total = incidenceBase - discount + vatValue;
                total = Number(total.toFixed(2));
                vatRateTotalizer[0].total += total;
                vatRateTotalizer[0].total  = Number(vatRateTotalizer[0].total.toFixed(2));
                vm.totalizer.total += total;
                vm.totalizer.total = Number(vm.totalizer.total.toFixed(2));
            });

            angular.forEach(vm.pharmaReception.pharmaReceptionLines, function (value, key) {
                if (value.serviceLine) {
                    // TOTALIZER BY VAT
                    var vatRateTotalizer = $filter("filter")(vm.totalizer.vatTable, {vatRate: (value.vatRate != null ? value.vatRate : 0)});
                    var vatValue = value.unitPrice * (value.vatRate != null && angular.isNumber(value.vatRate) && !isNaN(value.vatRate) ? value.vatRate / 100 : 0);
                    vatValue = Number(vatValue.toFixed(2));
                    vatRateTotalizer[0].vatValue += vatValue;
                    vatRateTotalizer[0].incidenceBase += value.unitPrice;
                    vatRateTotalizer[0].total += value.unitPrice + vatValue;
                    // TOTALIZER
                    vm.totalizer.vatValue += vatValue;
                    vm.totalizer.incidenceBase += value.unitPrice;
                    vm.totalizer.total += value.unitPrice + vatValue;
                }
            });
        }

        vm.updateTotalizers();

        // watch to implement auto-save
        $scope.$watch('[vm.pharmaReception.warehouse,vm.pharmaReception.supplier,vm.pharmaReception.orderType]', function () {
            save()
        }, true);

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };

        vm.datePopup = {opened: false};
        vm.openDatePopup = function () {
            vm.datePopup.opened = true;
        };
        vm.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            showWeeks: false
        };

        $scope.sorterFunc = function (vatRateTotalizer) {
            return parseInt(vatRateTotalizer.vatRate);
        };
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaReceptionDeleteController', PharmaReceptionDeleteController);

	PharmaReceptionDeleteController.$inject = ['Notification', '$uibModalInstance', '$translate', '$state', '$http', '$filter', 'pharmaReception', 'PharmaReception', 'ModuleSettings'];

	function PharmaReceptionDeleteController(Notification, $uibModalInstance, $translate, $state, $http, $filter, pharmaReception, PharmaReception, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmPharmaReceptionDelete = confirmPharmaReceptionDelete;
		vm.pharmaReception = pharmaReception;
		
		vm.loadAll = loadAll;
		vm.getWarehouseFullDescription = getWarehouseFullDescription;
		vm.getSupplierFullDescription = getSupplierFullDescription;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function onDeleteSuccess(result) {
			Notification.success({message: $translate.instant('pharmaPortalApp.pharmaReception.message.pharmaReceptionDeleted'), delay: 5000});
			$uibModalInstance.close(true);
		}

		function onDeleteError(result) {
			$uibModalInstance.close(true);
			
			if(result.data.success){
				Notification.success({message: result.data.message, delay: 5000});
			} else {
				Notification.error({message: result.data.message, delay: ''});
			}
		}

		function confirmPharmaReceptionDelete() {
			PharmaReception.delete({id: pharmaReception.id}, onDeleteSuccess, onDeleteError);
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.receptionsModule) {
					$state.go('accessdenied');
				} else {
					$http.get("api/common/_searchWarehousesForSelect").then(function(result) {
						vm.warehouses = result.data;
					});
					$http.get("api/common/_searchSuppliersForSelect").then(function(result) {
						vm.suppliers = result.data;
					});
				}
			});
		}
		vm.loadAll();

		function getWarehouseFullDescription(warehouseCode) {
			if (angular.isDefined(vm.warehouses)) {
				var warehouse = $filter('filter')(vm.warehouses, {
					code : warehouseCode
				})[0];
				return warehouseCode + (warehouse != null ? ' - ' + warehouse.description : '');
			} else {
				return warehouseCode;
			}
		}

		function getSupplierFullDescription(supplierCode) {
			if (angular.isDefined(vm.suppliers)) {
				var supplier = $filter('filter')(vm.suppliers, {
					code : supplierCode
				})[0];
				return supplierCode + (supplier != null ? ' - ' + supplier.description : '');
			} else {
				return supplierCode;
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaReceptionConfirmDifferencesController', PharmaReceptionConfirmDifferencesController);

	PharmaReceptionConfirmDifferencesController.$inject = ['Notification', '$uibModalInstance', '$http', '$state', '$filter', 'pharmaReception', 'PharmaReception'];

	function PharmaReceptionConfirmDifferencesController(Notification, $uibModalInstance, $http, $state, $filter, pharmaReception, PharmaReception) {
		var vm = this;

		vm.clear = clear;
		vm.close = close;
		vm.pharmaReception = pharmaReception;
		vm.exportToExcel = exportToExcel;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function close() {
			$uibModalInstance.close(true);
		}

		function exportToExcel() {
			$http.get("api/pharma-reception/" + vm.pharmaReception.id + "/toExcel", {
				responseType : "arraybuffer"
			}).then(function successCallback(response) {
				var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
				var blob = new Blob([ response.data ], {
					type : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				});
				saveAs(blob, "Recepção_" + vm.pharmaReception.id + "_" + dateTime + ".xlsx", true);
				Notification.success({message: "Recepção exportada com sucesso", delay: 5000});

				$uibModalInstance.close(true);
			}, function errorCallback(response) {
				Notification.error({message: "Erro ao exportar recepção", delay: ''});
				$uibModalInstance.close(true);
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('pharma-reception', {
			parent : 'entity',
			url : '/pharma-reception',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaReception.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-reception/pharma-reception.html',
					controller : 'PharmaReceptionController',
					controllerAs : 'vm'
				}
			},
			params : {
				page : {
					value : '1',
					squash : true
				},
				sort : {
					value : 'id,asc',
					squash : true
				}
			},
			resolve : {
				pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
					return {
						page : PaginationUtil.parsePage($stateParams.page),
						sort : $stateParams.sort,
						predicate : PaginationUtil.parsePredicate($stateParams.sort),
						ascending : PaginationUtil.parseAscending($stateParams.sort)
					};
				} ],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaReception');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-reception-detail', {
			parent : 'entity',
			url : '/pharma-reception/:id',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaReception.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-reception/pharma-reception-detail.html',
					controller : 'PharmaReceptionDetailController',
					controllerAs : 'vm',
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaReception');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'PharmaReception', function($stateParams, PharmaReception) {
					return PharmaReception.get({
						id : $stateParams.id
					}).$promise;
				} ]
			}
		}).state('pharma-reception.new', {
			parent : 'entity',
			url : '/pharma-reception/new',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaReception.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-reception/pharma-reception-new.html',
					controller : 'PharmaReceptionNewController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaReception');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-reception.delete', {
			parent : 'pharma-reception',
			url : '/{id}/delete',
			method : 'DELETE',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-reception/pharma-reception-delete-dialog.html',
					controller : 'PharmaReceptionDeleteController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						pharmaReception : [ 'PharmaReception', function(PharmaReception) {
							return PharmaReception.get({
								id : $stateParams.id
							});
						} ]
					}
				}).result.then(function() {
					$state.go('pharma-reception', null, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-reception.confirmDifferences', {
			parent : 'pharma-reception',
			url : '/{id}/confirmDifferences',
			method : 'POST',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-reception/pharma-reception-confirm-differences-dialog.html',
					controller : 'PharmaReceptionConfirmDifferencesController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						pharmaReception : [ '$stateParams', 'PharmaReception', function($stateParams, PharmaReception) {
							return PharmaReception.get({
								id : $stateParams.id
							}).$promise;
						} ]
					}
				}).result.then(function() {
					$state.go('pharma-reception', {}, {
						reload : true
					});
				}, function() {
					$state.go('pharma-reception', {}, {
						reload : true
					});
				});
			} ]
		}).state('pharma-reception-line', {
			parent : 'entity',
			url : '/pharma-reception-line',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaReception.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-reception/pharma-reception-line.html',
					controller : 'PharmaReceptionController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaReception');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-reception-line.new', {
			parent : 'pharma-reception-detail',
			url : '/new',
			method : 'POST',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-reception/pharma-reception-line-new-dialog.html',
					controller : 'PharmaReceptionLineNewController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						pharmaReception : [ 'PharmaReception', function(PharmaReception) {
							return PharmaReception.get({
								id : $stateParams.id
							});
						} ]
					}
				}).result.then(function() {
					$state.go('pharma-reception-line.new', {
						id : $stateParams.id
					}, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-reception-line.delete', {
			parent : 'pharma-reception-detail',
			url : '/delete/{lineId}',
			method : 'DELETE',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-reception/pharma-reception-line-delete-dialog.html',
					controller : 'PharmaReceptionLineDeleteController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						pharmaReceptionLine : [ 'PharmaReceptionLine', function(PharmaReceptionLine) {
							return PharmaReceptionLine.get({
								id : $stateParams.lineId
							});
						} ]
					}
				}).result.then(function() {
					$state.go('pharma-reception-detail', {
						id : $stateParams.id
					}, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-reception.inactive', {
            parent : 'pharma-reception.new',
            onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl : 'app/entities/pharma-reception/pharma-reception-new.inactive-dialog.html',
                    controller : 'PharmaReceptionInactiveController',
                    controllerAs : 'vm',
                    size : 'md'
                }).result.then(function() {
                    $state.go('pharma-reception.new', null, {
                        reload : true
                    });
                }, function() {
                    $state.go('^');
                });
            } ]
        });
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaReceptionController', PharmaReceptionController);

    PharmaReceptionController.$inject = ['Notification', '$scope', '$state', '$http', '$filter', 'PharmaReception', 'ParseLinks', 'paginationConstants', 'pagingParams', 'ModuleSettings'];

    function PharmaReceptionController(Notification, $scope, $state, $http, $filter, PharmaReception, ParseLinks, paginationConstants, pagingParams, ModuleSettings) {
        var vm = this;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.loadPage = loadPage;
        vm.getWarehouseFullDescription = getWarehouseFullDescription;
        vm.getSupplierFullDescription = getSupplierFullDescription;
        vm.getOrderTypeFullDescription = getOrderTypeFullDescription;

        loadAll();

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.receptionsModule) {
                    $state.go('accessdenied');
                } else {
                    PharmaReception.query({
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, onSuccess, onError);
                    $http.get("api/common/_searchWarehousesForSelect").then(function (result) {
                        vm.warehouses = result.data;
                    });

                    $http.get("api/common/_searchSuppliersForSelect").then(function (result) {
                        vm.suppliers = result.data;
                    });
                    $http.get("api/common/_searchOrderTypesForSelect").then(function (result) {
                        vm.orderTypes = result.data;
                    });
                }
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.pharmaReceptionHeaders = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }

        function getWarehouseFullDescription(warehouseCode) {
            if (angular.isDefined(vm.warehouses)) {
                var warehouse = $filter('filter')(vm.warehouses, {
                    code: warehouseCode
                })[0];
                return warehouseCode + (warehouse != null ? ' - ' + warehouse.description : '');
            } else {
                return warehouseCode;
            }
        }

        function getSupplierFullDescription(supplierCode) {
            if (angular.isDefined(vm.suppliers)) {
                var supplier = $filter('filter')(vm.suppliers, {
                    code: supplierCode
                })[0];
                return supplierCode + (supplier != null ? ' - ' + supplier.description : '');
            } else {
                return supplierCode;
            }
        }

        function getOrderTypeFullDescription(orderType) {
            if (angular.isDefined(vm.orderTypes)) {
                var orderTypeObject = $filter('filter')(vm.orderTypes, {
                    type: orderType
                })[0];
                return orderType + (orderTypeObject != null ? ' - ' + orderTypeObject.name : '');
            } else {
                return orderType;
            }
        }

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PurchaseSuccessController', PurchaseSuccessController);

	PurchaseSuccessController.$inject = [ '$uibModalInstance', '$state', 'Principal', 'ModuleSettings' ];

	function PurchaseSuccessController($uibModalInstance, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmAddProducts = confirmAddProducts;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmAddProducts() {
			$uibModalInstance.close(true);
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.purchasesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (!(account && account.company)) {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PurchaseSaveTemplateController', PurchaseSaveTemplateController);

	PurchaseSaveTemplateController.$inject = [ 'Notification', '$uibModalInstance', '$rootScope', '$http', '$localStorage', 'Company', '$state', 'Principal', 'ModuleSettings' ];

	function PurchaseSaveTemplateController(Notification, $uibModalInstance, $rootScope, $http, $localStorage, Company, $state, Principal, ModuleSettings) {
		var vm = this;
		vm.companies = Company.query({ size : 1000 });
		
		vm.orderDescription;
		vm.bodyRequest;

		vm.clear = clear;
		vm.confirmSaveTemplate = confirmSaveTemplate;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmSaveTemplate() {
			vm.bodyRequest = {
				"description" : vm.orderDescription,
				"orderProducts" : $rootScope.purchaseOrderList
			};

			$http.post("api/pharma-purchase/saveTemplate", vm.bodyRequest).then(function successCallback(response) {
				$rootScope.purchaseOrderList = [];
				$rootScope.purchaseTotals = {
					total : 0,
					totalPvf : 0,
					totalDesc : 0
				};
				$uibModalInstance.close(true);
				delete $localStorage.purchaseOrder;
				Notification.success({
					message : response.data,
					delay : 5000
				});
			}, function errorCallback(response) {
				$uibModalInstance.close(true);
				Notification.error({
					message : response.data,
					delay : ''
				});
			});
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.purchasesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (!(account && account.company)) {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PurchaseRemoveProductController', PurchaseRemoveProductController);

	PurchaseRemoveProductController.$inject = [ 'Notification', '$uibModalInstance', 'entity', '$rootScope', '$state', 'Principal', 'ModuleSettings', '$translate' ];

	function PurchaseRemoveProductController(Notification, $uibModalInstance, entity, $rootScope, $state, Principal, ModuleSettings, $translate) {
		var vm = this;

		vm.cnpToDel = entity.cnpToDel;
		vm.product = null;

		vm.clear = clear;
		vm.confirmRemoveProduct = confirmRemoveProduct;
		vm.filterItemFromArray = filterItemFromArray;
		vm.deleteFilteredItem = deleteFilteredItem;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmRemoveProduct() {
			deleteFilteredItem(vm.cnpToDel, $rootScope.purchaseOrderList);
			$rootScope.updatePurchaseTotals();
			$uibModalInstance.close(true);
			Notification.warning({
				message : $translate.instant('pharmaPortalApp.pharmaPurchase.messages.productRemoveSuccess'),
				delay : 5000
			});
		}

		function filterItemFromArray(cnpToDel, sourceArray) {
			vm.product = null;
			angular.forEach(sourceArray, function(obj, index) {
				if (obj.cnp === cnpToDel) {
					vm.product = obj;
					return;
				}
			});
		}

		function deleteFilteredItem(cnpToDel, sourceArray) {
			angular.forEach(sourceArray, function(obj, index) {
				if (obj.cnp === cnpToDel) {
					sourceArray.splice(index, 1);
					return;
				}
			});
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.purchasesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (account && account.company) {
							filterItemFromArray(vm.cnpToDel, $rootScope.purchaseOrderList);
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PurchaseConfirmOrderController', PurchaseConfirmOrderController);

    PurchaseConfirmOrderController.$inject = ['Notification', '$uibModalInstance', '$rootScope', '$http', '$localStorage', 'PortalSettings', '$state', 'Principal',
        'ModuleSettings'];

    function PurchaseConfirmOrderController(Notification, $uibModalInstance, $rootScope, $http, $localStorage, PortalSettings, $state, Principal, ModuleSettings) {
        var vm = this;

        vm.orderInfoValues = [];
        vm.orderReady = '';
        vm.orderDescription;
        vm.bodyRequest;
        vm.processing = false;

        vm.clear = clear;
        vm.confirmOrder = confirmOrder;
        vm.loadAll = loadAll;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function confirmOrder() {
            vm.processing = true;

            vm.bodyRequest = {
                "description": vm.orderDescription,
                "orderProducts": $rootScope.purchaseOrderList,
                "invoiceTypeCode": vm.portalSettings.invoiceTypeCode,
                "invoiceTypeDesc": vm.portalSettings.invoiceTypeDesc,
                "billingTypeRetainedProductsCode": vm.portalSettings.billingTypeRetainedProductsCode,
                "billingTypeRetainedProductsDesc": vm.portalSettings.billingTypeRetainedProductsDesc,
                "chargeShippingCosts": vm.portalSettings.chargeShippingCosts,
                "cecServiceTypeCode": vm.portalSettings.cecServiceTypeCode,
                "cecServiceTypeDesc": vm.portalSettings.cecServiceTypeDesc,
                "shippingCosts": vm.portalSettings.shippingCosts,
                "isRetainedProductsOrder": $rootScope.isRetainedProductsOrder,
                "purchaseTotal": $rootScope.purchaseTotals.total,
                "configEmail": vm.portalSettings.salesEmail
            };

            $http.post("/api/pharma-purchase/saveOrder", vm.bodyRequest).then(function successCallback(response) {
                if (response.data.success) {
                    $rootScope.purchaseOrderList = [];
                    $rootScope.purchaseTotals = {
                        total: 0,
                        totalPvf: 0,
                        totalDesc: 0
                    };
                    $uibModalInstance.close(true);
                    delete $localStorage.purchaseOrder;
                    vm.processing = false;
                    Notification.success({message: response.data.message, delay: 5000});
                } else {
                    $uibModalInstance.close(true);
                    vm.processing = false;
                    Notification.error({message: response.data.message, delay: ''});
                }
            }, function errorCallback(response) {
                $uibModalInstance.close(true);
                vm.processing = false;
                Notification.error({message: response.data, delay: ''});
            });
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.purchasesModule) {
                    $state.go('accessdenied');
                } else {
                    Principal.identity().then(function (account) {
                        if (account && account.company) {
                            vm.portalSettings = PortalSettings.query(function (settings) {
                                if (settings.hasMinOrderValue == true && settings.minOrderValue > $rootScope.purchaseTotals.total && $rootScope.purchaseTotals.total > 0) {
                                    vm.orderInfoValues.minValue = settings.minOrderValue;
                                    vm.orderInfoValues.curDiff = settings.minOrderValue - $rootScope.purchaseTotals.total;
                                    vm.orderReady = '1';
                                } else if (vm.portalSettings.allowZeroPriceOrders && $rootScope.purchaseTotals.total == 0) {
                                    vm.orderReady = '2';
                                } else if ($rootScope.purchaseTotals.total <= 0) {
                                    vm.orderReady = '3';
                                } else {
                                    vm.orderInfoValues = [];
                                    vm.orderReady = '0';
                                }
                            });
                        } else {
                            $state.go('accessdenied');
                        }
                    });
                }
            });
        }

        loadAll();
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PurchaseConfirmFullSearchController', PurchaseConfirmFullSearchController);

	PurchaseConfirmFullSearchController.$inject = [ '$uibModalInstance', '$rootScope', '$state', 'Principal', 'ModuleSettings' ];

	function PurchaseConfirmFullSearchController($uibModalInstance, $rootScope, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmAddProducts = confirmAddProducts;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmAddProducts() {
			$rootScope.searchProductsAction()
			$uibModalInstance.close(true);
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.purchasesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (account && account.company) {
							// DO NOTHING
						} else {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PurchaseClearOrderController', PurchaseClearOrderController);

	PurchaseClearOrderController.$inject = [ 'Notification', '$uibModalInstance', '$rootScope', '$localStorage', '$state', 'Principal', 'ModuleSettings', '$translate' ];

	function PurchaseClearOrderController(Notification, $uibModalInstance, $rootScope, $localStorage, $state, Principal, ModuleSettings, $translate) {
		var vm = this;

		vm.clear = clear;
		vm.confirmClearOrder = confirmClearOrder;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmClearOrder() {
			$rootScope.purchaseOrderList = [];
			$rootScope.purchaseTotals = {
				total : 0,
				totalPvf : 0,
				totalDesc : 0
			};
			$uibModalInstance.close(true);
			delete $localStorage.purchaseOrder;
			Notification.warning({
				message : $translate.instant('pharmaPortalApp.pharmaPurchase.messages.allProductRemoveSuccess'),
				delay : 5000
			});
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.purchasesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (!(account && account.company)) {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PurchaseAlertController', PurchaseAlertController);

	PurchaseAlertController.$inject = [ '$uibModalInstance', '$state', 'Principal', 'ModuleSettings' ];

	function PurchaseAlertController($uibModalInstance, $state, Principal, ModuleSettings) {
		var vm = this;

		vm.clear = clear;
		vm.confirmAlert = confirmAlert;
		vm.loadAll = loadAll;

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmAlert() {
			$uibModalInstance.close(true);
		}

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.purchasesModule) {
					$state.go('accessdenied');
				} else {
					Principal.identity().then(function(account) {
						if (!(account && account.company)) {
							$state.go('accessdenied');
						}
					});
				}
			});
		}
		loadAll();
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('pharma-purchase', {
			parent : 'entity',
			url : '/pharma-purchase',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_USER' ],
				pageTitle : 'pharmaPortalApp.pharmaPurchase.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-purchase/pharma-purchases.html',
					controller : 'PharmaPurchaseController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaPurchase');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-purchase.alert', {
			parent : 'pharma-purchase',
			url : '/alert',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-purchase/purchase-alert-dialog.html',
					controller : 'PurchaseAlertController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-purchase', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-purchase.success', {
			parent : 'pharma-purchase',
			url : '/success',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-purchase/purchase-success-dialog.html',
					controller : 'PurchaseSuccessController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-purchase', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-purchase.clearOrder', {
			parent : 'pharma-purchase',
			url : '/clear',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-purchase/purchase-clear-order-dialog.html',
					controller : 'PurchaseClearOrderController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-purchase', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-purchase.confirmOrder', {
			parent : 'pharma-purchase',
			url : '/confirm',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-purchase/purchase-confirm-order-dialog.html',
					controller : 'PurchaseConfirmOrderController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-purchase', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-purchase.removeProduct', {
			parent : 'pharma-purchase',
			url : '/removeProduct/{cnpToDel}',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-purchase/purchase-remove-product-dialog.html',
					controller : 'PurchaseRemoveProductController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : function() {
							return {
								cnpToDel : $stateParams.cnpToDel
							};
						}
					}
				}).result.then(function() {
					$state.go('pharma-purchase', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-purchase.fullSearch', {
			parent : 'pharma-purchase',
			url : '/fullSearch',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-purchase/purchase-confirm.fullsearch-dialog.html',
					controller : 'PurchaseConfirmFullSearchController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-purchase', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-purchase.saveTemplate', {
			parent : 'pharma-purchase',
			url : '/saveTemplate',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_PHARMA' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-purchase/purchase-save-template-dialog.html',
					controller : 'PurchaseSaveTemplateController',
					controllerAs : 'vm',
					size : 'md'
				}).result.then(function() {
					$state.go('pharma-purchase', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		});
	}

})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaPurchaseController', PharmaPurchaseController);

    PharmaPurchaseController.$inject = ['Notification', '$rootScope', '$scope', '$filter', '$state', '$http', '$q', '$localStorage', 'PortalSettings', 'ModuleSettings', 'Principal', '$translate'];

    function PharmaPurchaseController(Notification, $rootScope, $scope, $filter, $state, $http, $q, $localStorage, PortalSettings, ModuleSettings, Principal, $translate) {
        var vm = this;
        vm.portalSettings = PortalSettings.query();
        vm.isPharma = false;
        vm.ownWarehouse = false;

        vm.loadAll = loadAll;
        vm.isValidForOrder = isValidForOrder;
        vm.isNumeric = isNumeric;
        vm.addProduct = addProduct;
        vm.checkProductValidToOrder = checkProductValidToOrder;
        vm.addAllProducts = addAllProducts;
        vm.searchByLab = searchByLab;
        vm.clearSearchInTable = clearSearchInTable;
        vm.toggleLineEditMode = toggleLineEditMode;
        vm.validateLines = validateLines;

        vm.exportSearchToExcel = exportSearchToExcel;
        vm.orderToExcel = orderToExcel;
        vm.confirmOrderDialog = confirmOrderDialog;

        $scope.searchInTable = "";
        $scope.productsList = [];
        $scope.search = {
            searchQuery: "",
            showNoStock: false,
            ownWarehouse: false
        };
        $rootScope.purchaseTotals = {
            total: 0,
            totalPV: 0,
            totalDesc: 0
        };

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.purchasesModule) {
                    $state.go('accessdenied');
                } else {
                    Principal.identity().then(function (account) {
                        vm.isPharma = false;
                        vm.ownWarehouse = false;
                        vm.loggedUser = null;
                        vm.loggedUserClientPe = null;
                        vm.loggedUserClientType = "";
                        vm.loggedUserClientGroup = "";
                        if (account) {
                            if (account.authorities.indexOf("ROLE_PHARMA") != -1) {
                                vm.currentAccount = account;
                                vm.loggedUser = account.login;
                                if (account.company) {
                                    // 1) se tem ROLE PHARMA e tem company vai
                                    // para compras > Encomendar
                                    vm.loggedUserClientPe = account.clientPe;
                                    vm.loggedUserClientType = account.company.clientType;
                                    vm.loggedUserClientGroup = account.company.clientGroup;
                                    if (account.company.clientType == "F") {
                                        vm.isPharma = true;
                                    }
                                    if (account.company.pharmaWarehouse) {
                                        vm.ownWarehouse = account.company.pharmaWarehouse;
                                    }
                                    validateLines();
                                } else {
                                    // 2) se tem ROLE PHARMA e não tem company
                                    // vai para page not found
                                    $state.go('accessdenied');
                                }
                            } else {
                                if (account.authorities.indexOf("ROLE_INTRANET") != -1) {
                                    // 3) se tem intranet vai para produtos
                                    $state.go('portal-product');
                                } else {
                                    $state.go('accessdenied');
                                }
                            }
                        } else {
                            $state.go('accessdenied');
                        }
                    });
                }
            });
        }

        loadAll();

        function isValidForOrder(product) {
            if (vm.portalSettings.allowZeroPriceProducts == true) {
                return (!product.pvp == null || !product.warehousestock || !product.qtd || product.pvp < 0 || product.warehousestock <= 0 || product.qtd <= 0);
            } else {
                return (!product.pvp || !product.warehousestock || !product.qtd || product.pvp <= 0 || product.warehousestock <= 0 || product.qtd <= 0);
            }
        }

        function isNumeric(n) { // Check if passed value is numeric
            n = n.toString().replace(/,/g, ".");
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        function addProduct(product) {
            switch (checkProductValidToOrder(product, $rootScope.purchaseOrderList)) {
            case 0:
                // $rootScope.message = "Produto adicionado com sucesso";
                // $state.go("pharma-purchase.success");
                break;
            case 1:
                $rootScope.message = "O produto indicado já existia nesta encomenda. A quantidade a encomendar foi atualizada";
                $state.go("pharma-purchase.success");
                break;
            case 2:
                $rootScope.message = "O produto não tem um preço válido e maior que zero";
                $state.go("pharma-purchase.alert");
                break;
            case 3:
                $rootScope.message = "A quantidade a encomendar tem de ser um número válido e maior que zero";
                $state.go("pharma-purchase.alert");
                break;
            case 4:
                $rootScope.message = "Não existe stock disponível deste produto";
                $state.go("pharma-purchase.alert");
                break;
            case 5:
                $rootScope.message = "A quantidade a encomendar tem um valor superior ao stock disponível";
                $state.go("pharma-purchase.alert");
                break;
            }
        }

        function checkProductValidToOrder(product, listOrderProducts) {
            if (!(product.pvp && isNumeric(product.pvp) && product.pvp > 0)) {
                // SE "Preço" ESTÁ VAZIO OU NÃO É NUMÉRICO OU FOR NEGATIVO OU IGUAL A ZERO
                if (vm.portalSettings.allowZeroPriceProducts != true) {
                    // SE NÃO PERMITIR "Preço" IGUAL A ZERO
                    return 2;
                }
            } else if (!(product.qtd && isNumeric(product.qtd) && product.qtd > 0)) {
                // SE "Qtd" ESTÁ VAZIO OU NÃO É NUMÉRICO OU FOR NEGATIVO OU IGUAL A ZERO
                return 3;
            } else if (!(product.warehousestock && isNumeric(product.warehousestock) && product.warehousestock > 0)) {
                // SE "warehousestock" ESTÁ VAZIO OU NÃO É NUMÉRICO OU FOR NEGATIVO OU IGUAL A ZERO
                return 4;
            } else if (product.qtd > product.warehousestock) {
                // SE "QTD" FOR MAIOR QUE "STOCK"
                return 5;
            }

            if (listOrderProducts.length > 0) {
                // SE "CNP" VALIDA SE EXISTE NO ARRAY DE CNP"s
                var keepGoing = true;
                angular.forEach(listOrderProducts, function (obj, index) {
                    if (keepGoing) {
                        if (obj.cnp === product.cnp) {
                            if (product.qtd > 0) {
                                $rootScope.purchaseOrderList.splice(index, 1, angular.copy(product));
                            } else {
                                $rootScope.purchaseOrderList.splice(index, 1);
                            }
                            $rootScope.updatePurchaseTotals();
                            keepGoing = false;
                        }
                    }
                });
                if (!keepGoing) {
                    return 1;
                }
            }
            $rootScope.purchaseOrderList.push(angular.copy(product));
            $rootScope.updatePurchaseTotals();
            return 0;
        }

        function addAllProducts() {
            var error_flag = false;
            var exists_flag = false;
            var initialOrderSize = $rootScope.purchaseOrderList.length;
            var countWithError = 0;
            var countUpdated = 0;
            var countInserted = 0;

            var filteredList = $filter('filter')($scope.productsList, $scope.searchInTable);

            angular.forEach(filteredList, function (obj, index) {
                switch (checkProductValidToOrder(obj, $rootScope.purchaseOrderList)) {
                case 0:
                    countInserted = countInserted + 1;
                    break;
                case 1:
                    countUpdated = countUpdated + 1;
                    exists_flag = true;
                    break;
                case 2:
                case 3:
                case 4:
                case 5:
                    countWithError = countWithError + 1;
                    error_flag = true;
                    break;
                }
            });

            if (error_flag) {
                var str = "<b>Produtos adicionados:</b> " + countInserted + "<br/>";
                if (exists_flag) {
                    str += "<b>Produtos atualizados:</b> " + countUpdated + "<br/>";
                }
                str += "<b>Produtos sem preço válido, sem stock ou quantidade inválida:</b> " + countWithError + "<br/>";
                $rootScope.message = str;
                $state.go("pharma-purchase.alert");
            } else {
                if (exists_flag) {
                    var str = "<b>Produtos adicionados:</b> " + countInserted + "<br/>";
                    str += "<b>Produtos atualizados:</b> " + countUpdated + "<br/>";
                    $rootScope.message = str;
                    $state.go("pharma-purchase.success");
                }
            }
        }

        function searchByLab(lab) {
            $scope.search.searchQuery = lab;
            $scope.searchProducts();
        }

        function clearSearchInTable() {
            $scope.searchInTable = "";
        }

        function toggleLineEditMode(orderProdLine) {
            if (angular.isDefined(orderProdLine.editMode) && orderProdLine.editMode == true) {
                orderProdLine.editMode = false;
            } else {
                orderProdLine.editMode = true;
            }
            $rootScope.updatePurchaseTotals();
        }

        function validateLines(orderProd, keyEvent) {
            if (orderProd) {
                if (keyEvent.type == "blur" || (keyEvent.type == "keypress" && keyEvent.which === 13)) {
                    vm.hasErrors = false;
                    orderProd.editMode = false;
                    $rootScope.updatePurchaseTotals();
                    angular.forEach($rootScope.purchaseOrderList, function (value, key) {
                        isQtdInvalid(value);
                    });
                }
            } else {
                $rootScope.updatePurchaseTotals();
                angular.forEach($rootScope.purchaseOrderList, function (value, key) {
                    isQtdInvalid(value);
                });
            }
        }

        function isQtdInvalid(orderProd) {
            if (orderProd.qtd && orderProd.qtd >= 0 && parseInt(orderProd.qtd)) {
                orderProd.invalidQtd = false;
            } else {
                orderProd.invalidQtd = true;
                vm.hasErrors = true;
            }
        }

        $scope.searchProducts = function () {
            $scope.productsList = [];
            if ($scope.search && $scope.search.searchQuery && $scope.search.searchQuery.length > 2) {
                $rootScope.searchProductsAction();
            } else {
                // SE showNoStock então não permite
                if ($scope.search.showNoStock == true) {
                    $rootScope.message = "NOK";
                    $scope.productsList = [];
                    $state.go("pharma-purchase.fullSearch");
                } else {
                    // SE showNoStock = FALSE então ABRE DIALOG A CONFIRMAR
                    if ($scope.search.searchQuery == undefined) {
                        $scope.search.searchQuery = "";
                    }
                    $rootScope.message = "OK";
                    $state.go("pharma-purchase.fullSearch");
                }
            }
        };

        var canceler = $q.defer();
        $rootScope.searchProductsAction = function () {
            // PENDING HTTP CALLS CANCEL
            canceler.resolve();
            canceler = $q.defer();

            // DEFAULT QTD FROM SETTINGS
            vm.defaultQtd = 1;
            if (vm.portalSettings.defaultQtd != null) {
                vm.defaultQtd = vm.portalSettings.defaultQtd;
            }
            // HIDE NEGATIVE DISCOUNTS FROM SETTINGS
            vm.hideNegativeDiscounts = true;
            if (vm.portalSettings.showPvfOnNegativeDiscount) {
                vm.hideNegativeDiscounts = false;
            }

            // CHECK IF SEARCH IS OVER OWN WAREHOUSE OR POLICY GIVEN WAREHOUSE
            if ($scope.search.ownWarehouse) {
                $scope.search.customWarehouse = vm.ownWarehouse;
                searchForProducts();
            } else {
                getWarehouseForSearch();
            }
        }

        $rootScope.updatePurchaseTotals = function () {
            $rootScope.purchaseTotals = {
                total: 0,
                totalPV: 0,
                totalDesc: 0
            };

            angular.forEach($rootScope.purchaseOrderList, function (value, key) {
                $rootScope.purchaseTotals.total += (value.qtd * 1) * (value.pvp * 1);

                if (vm.isPharma) {
                    $rootScope.purchaseTotals.totalPV += (value.qtd * 1) * (value.pvfeur * 1);
                } else {
                    $rootScope.purchaseTotals.totalPV += (value.qtd * 1) * (value.pvaeur * 1);
                }
            });

            $rootScope.purchaseTotals.totalDesc = $rootScope.purchaseTotals.totalPV - $rootScope.purchaseTotals.total;

            if (vm.portalSettings.chargeShippingCosts == true && vm.portalSettings.hasMinOrderValue == true && vm.portalSettings.minOrderValue > $rootScope.purchaseTotals.total && $rootScope.purchaseTotals.total > 0) {
                $rootScope.purchaseTotals.total = $rootScope.purchaseTotals.total + vm.portalSettings.shippingCosts;
            }
        }
        $rootScope.updatePurchaseTotals();

        $scope.isOrderEmpty = function () {
            return $rootScope.purchaseOrderList.length <= 0;
        }

        $scope.isProductSearchEmpty = function () {
            return $scope.productsList.length <= 0;
        }

        $scope.isRetainedProductsOrder = function () {
            if ($rootScope.purchaseOrderList.length > 0) {
                var keepGoing = true;
                angular.forEach($rootScope.purchaseOrderList, function (value, key) {
                    if (keepGoing) {
                        if (value.originwarehouse) {
                            $scope.search.ownWarehouse = true;
                            keepGoing = false;
                        }
                    }
                });
                return true;
            } else {
                return false;
            }
        }

        if ($localStorage && $localStorage.purchaseOrder) {
            $rootScope.purchaseOrderList = $localStorage.purchaseOrder;
        } else {
            $rootScope.purchaseOrderList = [];
        }

        $scope.$watch($rootScope.purchaseOrderList, function () {
            $localStorage.purchaseOrder = $rootScope.purchaseOrderList;
        }, true);

        function dynamicSort(property) {
            var sortOrder = 1;
            if (property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
            }
            return function (a, b) {
                var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result * sortOrder;
            }
        }

        function exportSearchToExcel() {
            $http.post("api/pharma-purchase/searchToExcel/" + vm.isPharma, $scope.productsList, {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, "Produtos_Portal_" + dateTime + ".xlsx", true);
                Notification.success({
                    message: $translate.instant('pharmaPurchase.messages.exportExcel.success'),
                    delay: 5000
                });
            }, function errorCallback(response) {
                Notification.error({
                    message: $translate.instant('pharmaPurchase.messages.exportExcel.error'),
                    delay: ''
                });
            });
        }

        function orderToExcel() {
            $http.post("api/pharma-purchase/orderToExcel/" + vm.isPharma, $rootScope.purchaseOrderList, {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                saveAs(blob, "Portal_Encomenda_" + dateTime + ".xlsx", true);
                Notification.success({
                    message: $translate.instant('pharmaPurchase.messages.orderExcel.success'),
                    delay: 5000
                });
            }, function errorCallback(response) {
                Notification.error({
                    message: $translate.instant('pharmaPurchase.messages.orderExcel.error'),
                    delay: ''
                });
            });
        }

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };

        function getWarehouseForSearch() {
            // EXECUTAR POLITICA PARA OBTER ARMAZÉM A UTILIZAR E LISTA DE EXCLUSÕES
            var policyType = "PharmaOrdersStockSale";
            var policyData = [];
            policyData.push({
                "hierarchy": [vm.loggedUserClientType, vm.loggedUserClientGroup, vm.loggedUserClientPe]
            });
            var requestBody = {
                "policyType": policyType,
                "policyData": policyData
            };

            $http.post("api/policyExecuter/execute", requestBody).then(function (result) {
                var curResult = $filter('filter')(result.data.output, {
                    hash: vm.loggedUserClientType + '' + vm.loggedUserClientGroup + '' + vm.loggedUserClientPe
                }, true);

                if (curResult[0]) {
                    $scope.search.customWarehouse = curResult[0].result.warehouse
                    $scope.search.productStockQtdManipulation = curResult[0].result.productStockQtd
                    searchForProducts();
                }
            }, function (result) {
                Notification.warning({
                    message: "Error! Status = " + result.status + " Message = " + result,
                    delay: 5000
                });
            });
        }

        var canceler = $q.defer();

        function searchForProducts() {
            canceler.resolve();
            canceler = $q.defer();
            // PESQUISA "NORMAL"
            $scope.resultProductsList = [];
            $http.post("api/common/_searchFromDbPharmaProducts", $scope.search, {
                timeout: canceler.promise
            }).then(function (result) {
                $scope.resultProductsList = result.data;
            }).then(function () {
                $scope.productsList = [];
                vm.policyData = [];

                if ($scope.search.ownWarehouse) {
                    vm.policyName = "RetainedProductPriceSale";

                    $($scope.resultProductsList).each(function (index, prod) {
                        var prodLab = prod.forncode ? "CIL" + prod.forncode : prod.labcode ? prod.labcode : "99999";
                        vm.policyData.push({
                            "hierarchy": [vm.loggedUserClientPe, prodLab, prod.cnp],
                            "parameters": [$scope.search.customWarehouse]
                        });
                        prod.hash = vm.loggedUserClientPe + "" + prodLab + "" + prod.cnp;
                    });
                } else {
                    vm.policyName = "PharmaOrdersPriceSale";

                    $($scope.resultProductsList).each(function (index, prod) {
                        var prodLab = prod.forncode ? "CIL" + prod.forncode : prod.labcode ? prod.labcode : "99999";
                        vm.policyData.push({
                            "hierarchy": [vm.loggedUserClientType, vm.loggedUserClientPe, prodLab, prod.cnp]
                        });
                        prod.hash = vm.loggedUserClientType + "" + vm.loggedUserClientPe + "" + prodLab + "" + prod.cnp;
                    });
                }

                vm.requestBody = {
                    "policyType": vm.policyName,
                    "policyData": vm.policyData
                };

                $http.post("api/policyExecuter/execute", vm.requestBody, {
                    timeout: canceler.promise
                }).then(function (result) {
                    $($scope.resultProductsList).each(function (index, prod) {
                        //CHECK EXCEPTION LIST EXISTS AND IF PRODUCT IS ON THE EXCEPTION LIST (case exists)
                        if (angular.isDefined($scope.search.productStockQtdManipulation) && $scope.search.productStockQtdManipulation != null && $scope.search.productStockQtdManipulation.length > 0) {
                            var curProdSearch = $filter('filter')($scope.search.productStockQtdManipulation, {
                                productCnp: prod.cnp
                            }, true);

                            if (angular.isDefined(curProdSearch) && curProdSearch.length > 0 && prod.warehousestock > curProdSearch[0].qtd) {
                                prod.warehousestock = curProdSearch[0].qtd;
                            }
                        }
                        var curResult = $filter('filter')(result.data.output, {
                            hash: prod.hash
                        }, true);

                        if (vm.portalSettings.allowZeroPriceProducts == true) {
                            // 1. PREÇO
                            prod.pvp = curResult[0].result;
                            if (prod.pvp < 0) {
                                prod.warehousestock = 0;
                            }

                        } else {
                            // 1. PREÇO
                            prod.pvp = curResult[0].result;
                            if (prod.pvp <= 0) {
                                prod.warehousestock = 0;
                            }
                        }

                        // 2. DIF PREÇO
                        if (vm.isPharma) {
                            if (prod.pvfeur) {
                                if (prod.pvp == 0 || prod.pvfeur == 0) {
                                    prod.pvfdesc = 0;
                                } else {
                                    prod.pvfdesc = (1 - (prod.pvp / prod.pvfeur)) * 100;

                                    if (prod.pvfdesc < 0 && vm.hideNegativeDiscounts) {
                                        prod.pvfdesc = 0;
                                        prod.pvfeur = prod.pvp;
                                    }
                                }
                            } else {
                                prod.pvfeur = prod.pvp;
                                prod.pvfdesc = 0;
                                prod.qtd = vm.defaultQtd;
                            }
                        } else {
                            if (prod.pvaeur) {
                                if (prod.pvp == 0 || prod.pvaeur == 0) {
                                    prod.pvadesc = 0;
                                } else {
                                    prod.pvadesc = (1 - (prod.pvp / prod.pvaeur)) * 100;
                                    if (prod.pvadesc < 0 && vm.hideNegativeDiscounts) {
                                        prod.pvadesc = 0;
                                        prod.pvaeur = prod.pvp;
                                    }
                                }
                            } else {
                                prod.pvaeur = prod.pvp;
                                prod.pvadesc = 0;
                                prod.qtd = vm.defaultQtd;
                            }
                        }
                        // 3. SE ESTAMOS A TRATAR PRODUTOS RETIDOS ENTÃO
                        // ADICIONA AO PRODUTO O WAREHOUSE DE ORIGEM
                        if ($scope.search.ownWarehouse) {
                            prod.originwarehouse = vm.ownWarehouse;
                        }

                        // 4. STOCK
                        if (prod.warehousestock > 0) {
                            prod.qtd = vm.defaultQtd;
                            $scope.productsList.push(prod);
                        } else {
                            prod.qtd = 0;
                            prod.warehousestock = 0;
                            if ($scope.search && $scope.search.showNoStock) {
                                $scope.productsList.push(prod);
                            }
                        }

                        $scope.productsList.sort(dynamicSort("fullName"));
                    });

                }, function (result) {
                    Notification.warning({
                        message: "Error! Status = " + result.status + " Message = " + result,
                        delay: 5000
                    });
                });
            });
        }

        function confirmOrderDialog() {
            $rootScope.isRetainedProductsOrder = $scope.search.ownWarehouse;
            $state.go('pharma-purchase.confirmOrder');
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('UserQuestionController', UserQuestionController);

    UserQuestionController.$inject = ['$uibModalInstance', 'data'];

    function UserQuestionController($uibModalInstance, data) {
        var vm = this;

        vm.clear = clear;
        vm.close = close;
        vm.allSelected = data.allSelected;

        function clear(flag) {
            $uibModalInstance.dismiss(flag);
        }

        function close(flag) {
            $uibModalInstance.close(flag);
        }

    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaPickingTransportController', PharmaPickingTransportController);

    PharmaPickingTransportController.$inject = [ 'Notification', 'blockUI', '$uibModalInstance', '$translate', '$state', '$document', '$scope'];

	function PharmaPickingTransportController(Notification, blockUI, $uibModalInstance, $translate, $state, $document, $scope) {
		var vm = this;

		vm.clear = clear;

		vm.employeeNumber = null;
        var readEmployeeNumber = '';

		function clear(flag) {
			$uibModalInstance.dismiss(flag);
		}

        $($document).ready(function () {
            addInputListener();
        });

        function addInputListener() {
            window.addEventListener("keypress", myEventHandler, false);
        }

        $scope.$on("$destroy", function () {
            window.removeEventListener("keypress", myEventHandler, false);
        });

        $scope.numberFocused = function () {
            vm.numberFocus = true;
        };

        $scope.numberBlurred = function () {
            vm.numberFocus = false;
        };

        $scope.otherFocused = function () {
            vm.otherFocus = true;
        };

        $scope.otherBlurred = function () {
            vm.otherFocus = false;
        };

        function myEventHandler(e) {
            if (!vm.otherFocus && !vm.numberFocus) {
                var keyCode = e.keyCode;
                if (keyCode == 8) {
                    if (readEmployeeNumber.length > 0) {
                        readEmployeeNumber = readBarcode.substring(0, readBarcode.length - 1);
                    }
                    e.preventDefault();
                } else if (keyCode == 13) {
                    if (vm.employeeNumber !== readEmployeeNumber) {
                        $scope.$apply(function() {
                            vm.employeeNumber = readEmployeeNumber;
                        });
                    }
                    readEmployeeNumber = '';
                } else {
                    readEmployeeNumber = readEmployeeNumber + e.key;
                }
            }
        }

        vm.submit = function() {
            if(vm.employeeNumber && vm.employeeNumber != ''){
                $uibModalInstance.dismiss(vm.employeeNumber);
            }
        }

		function onSubmitSuccess(result) {
			$uibModalInstance.close(true);
			blockUI.stop();
            Notification.success({message: "Transportado com sucesso", delay: 5000});
		}

		function onSubmitError(result) {
			blockUI.stop();
			$uibModalInstance.close(true);
		}

	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaPickingSubmitOverQuantityController', PharmaPickingSubmitOverQuantityController);

	PharmaPickingSubmitOverQuantityController.$inject = [ 'Notification', '$rootScope','blockUI', '$uibModalInstance', '$translate', '$state', '$http', '$filter', 'pharmaPicking', 'PharmaPicking', 'PortalSettings', 'ModuleSettings', 'user' ];

	function PharmaPickingSubmitOverQuantityController(Notification, $rootScope,blockUI, $uibModalInstance, $translate, $state, $http, $filter, pharmaPicking, PharmaPicking, PortalSettings, ModuleSettings, user) {
		var vm = this;

		vm.portalSettings = PortalSettings.query();
		
		vm.loadAll = loadAll;

		vm.clear = clear;
		vm.confirmPharmaPickingSubmit = confirmPharmaPickingSubmit;
		vm.pharmaPicking = pharmaPicking;
		vm.user = user.user;
		vm.supplier = vm.pharmaPicking.supplierCode + " - " + vm.pharmaPicking.supplierName;

		vm.passwordInvalid = false;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.pickingModule) {
					$state.go('accessdenied');
				}
			});
		}
		vm.loadAll();


		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function onSubmitSuccess(result) {
			$uibModalInstance.close(true);
			blockUI.stop();
			if (result.success){
				Notification.success({message: result.message, delay: 5000});
				$state.go("pharma-picking", {}, {
					reload : true
				});
			} else {
				Notification.error({message: result.message, delay: ''});
				$state.go("pharma-picking-detail.edit", {
					id : vm.pharmaPicking.id
				}, {
					reload : true
				});
			}
		}

		function onSubmitError(result) {
			blockUI.stop();
			$uibModalInstance.close(true);

			if(result.success){
				Notification.success({message: result.message, delay: 5000});
			} else {
				Notification.error({message: result.message, delay: ''});
			}
		}

		function confirmPharmaPickingSubmit() {
			vm.passwordInvalid = false;
			if(vm.password != vm.portalSettings.pickingPassword){
				vm.passwordInvalid = true;
			}
			else{
				blockUI.start($translate.instant('pharmaPortalApp.pharmaPicking.message.submittingPharmaPicking'));

                vm.bodyRequest = {
                    "idPharmaPicking": pharmaPicking.id,
                    "userCloseConference": $rootScope.userCloseConference,
                    "supplierCode" : vm.pharmaPicking.supplierCode
                };

                $http.post("/api/pharma-picking/submit", vm.bodyRequest).then(function successCallback(response) {
                    onSubmitSuccess(response.data)
                }, function errorCallback(response) {
                    onSubmitError(response.data)
                });
			}
		}
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaPickingSubmitIncompleteController', PharmaPickingSubmitIncompleteController);

    PharmaPickingSubmitIncompleteController.$inject = ['Notification', '$uibModal', '$timeout', 'blockUI', '$uibModalInstance', '$translate', '$state', '$http', '$filter', 'pharmaPicking', 'PharmaPicking', 'PortalSettings', 'ModuleSettings', '$rootScope', '$scope', 'user', 'InvoiceAndClaim'];

    function PharmaPickingSubmitIncompleteController(Notification, $uibModal, $timeout, blockUI, $uibModalInstance, $translate, $state, $http, $filter, pharmaPicking, PharmaPicking, PortalSettings, ModuleSettings, $rootScope, $scope, user, InvoiceAndClaim) {
        var vm = this;

        vm.portalSettings = PortalSettings.query();

        vm.loadAll = loadAll;

        vm.clear = clear;
        vm.confirmPharmaPickingSubmit = confirmPharmaPickingSubmit;
        vm.pharmaPicking = pharmaPicking;
        vm.user = user.user;
        vm.supplier = vm.pharmaPicking.supplierCode + " - " + vm.pharmaPicking.supplierName;
        vm.allSelected = true;
        vm.passwordInvalid = false;
        vm.confirmedProducts = false;

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.pickingModule) {
                    $state.go('accessdenied');
                }
            });
        }

        vm.loadAll();

        function clear(flag) {
            $uibModalInstance.dismiss(flag);
        }

        function openConfirmModal(flag, missingProducts) {

            $uibModal.open({
                templateUrl: 'app/entities/pharma-picking/pharma-picking-confirm-products.html',
                controller: 'PharmaPickingConfirmProductsController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    confirmProducts: function () {
                        return flag;
                    },
                    missingProducts: function () {
                        return missingProducts;
                    },
                    pharmaPicking: function () {
                        return vm.pharmaPicking;
                    }
                }
            }).result.then(function () {
                vm.clear('close');
            }, function () {
                vm.clear('close');
            });
        }

        function confirmPharmaPickingSubmit(operation) {
            vm.passwordInvalid = false;
            if (vm.password != vm.portalSettings.pickingPassword) {
                vm.passwordInvalid = true;
            } else {
                confirmSubmit(operation);
            }
        }

        function loadProducts() {
            vm.products = $filter('filter')(vm.pharmaPicking.pharmaPickingLines, function (line) {
                return line.invoicedQuantity - line.receivedQuantity > 0;
            }, true);
            $scope.totalItems = vm.products.length;
            vm.page = 1;
            $scope.itemsPerPage = 7;

            $scope.$watch("vm.page", function () {
                setPagingData(vm.page);
            });

            $timeout(function () {
                selectProducts(true);
            });

        }

        loadProducts();

        vm.selectAll = function () {
            selectProducts(vm.allSelected);
        }

        function setPagingData(page) {
            var pagedData = vm.products.slice(
                (page - 1) * $scope.itemsPerPage,
                page * $scope.itemsPerPage
            );
            $scope.products = pagedData;
        }

        function selectProducts(flag) {
            for (var i = 0; i < $scope.products.length; i++) {
                $scope.products[i].selected = flag;
            }
            for (var i = 0; i < vm.products.length; i++) {
                vm.products[i].selected = flag;
            }
        }

        vm.selectProduct = function () {
            var products = $filter('filter')(vm.products, {selected: false});
            if (products.length != 0) {
                vm.allSelected = false;
            } else {
                vm.allSelected = true;
            }
        }

        function confirmSubmit(operation) {

            var products = $filter('filter')(vm.products, {selected: true});
            if (products.length == 0) {
                Notification.warning({message: "Deve selecionar pelo menos 1 produto", delay: 2000});
            } else if (vm.allSelected && !vm.confirmedProducts && operation != 'complaint') {
                vm.operation = operation;
                confirmProducts();
            } else {

                var received = $filter('filter')(vm.pharmaPicking.pharmaPickingLines, function (item) {
                    return item.receivedQuantity > 0;
                });
                if (received.length > 0) {
                    vm.showConfirmProducts = false;
                    $uibModal.open({
                        templateUrl: 'app/entities/pharma-picking/pharma-picking-keep-in-pharmacy-dialog.html',
                        controller: 'PharmaPickingKeepInPharmacyController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            pharmaPicking: vm.pharmaPicking,
                            complaint: operation == 'complaint',
                            user: {user: vm.user}
                        }
                    }).result.then(function () {
                        // success callback implemented on own controller
                        vm.products = $filter('filter')(vm.pharmaPicking.pharmaPickingLines, function (line) {
                            return line.invoicedQuantity - line.receivedQuantity > 0;
                        }, true);
                        products = $filter('filter')(vm.products, function (item) {
                            return item.selected == true || item.isSelectedSuggestion == true;
                        });
                        makeOperation(products, operation);
                    }, function (flag) {
                        // Back button
                        if (flag == 'goToPickingDetail') {
                            vm.clear('close');
                        }
                    });
                } else {
                    makeOperation(products, operation);
                }
            }

        }

        function makeOperation(products, operation) {
            var productsMissing = $filter('filter')(vm.products, {selected: false});
            switch (operation) {
                case 'complaint':
                    vm.pharmaPicking.changeState = true;

                    $uibModalInstance.dismiss('complaint');
                    break;
                default:
                    if (productsMissing.length > 0) {
                        vm.pharmaPicking.changeState = false;
                        openConfirmModal(false, productsMissing);
                    } else {
                        $uibModalInstance.close(true);
                        InvoiceAndClaim.invoice(vm.pharmaPicking, vm.products, vm.user);
                    }
                    break;
            }
        }

        function confirmProducts() {
            $uibModal.open({
                templateUrl: 'app/entities/pharma-picking/user-question.html',
                controller: 'UserQuestionController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    data: {allSelected: vm.allSelected}
                }
            }).result.then(function () {
                vm.confirmedProducts = true;
                vm.confirmPharmaPickingSubmit(vm.operation)
            }, function () {
            });
        }

    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaPickingSubmitCompleteController', PharmaPickingSubmitCompleteController);

	PharmaPickingSubmitCompleteController.$inject = [ 'Notification', '$rootScope','blockUI', '$uibModalInstance', '$uibModal', '$translate', '$state', '$http', '$filter', 'pharmaPicking', 'PharmaPicking', 'PortalSettings', 'ModuleSettings', 'user', 'InvoiceAndClaim'];

	function PharmaPickingSubmitCompleteController(Notification, $rootScope, blockUI, $uibModalInstance, $uibModal, $translate, $state, $http, $filter, pharmaPicking, PharmaPicking, PortalSettings, ModuleSettings, user, InvoiceAndClaim) {
		var vm = this;

		vm.portalSettings = PortalSettings.query();

		vm.loadAll = loadAll;

		vm.clear = clear;
		vm.confirmPharmaPickingSubmit = confirmPharmaPickingSubmit;
		vm.pharmaPicking = pharmaPicking;
		vm.user = user.user;
		vm.supplier = vm.pharmaPicking.supplierCode + " - " + vm.pharmaPicking.supplierName;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.pickingModule) {
					$state.go('accessdenied');
				}
			});
		}
		vm.loadAll();


		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function onSubmitSuccess(result) {
			$uibModalInstance.close(true);
			blockUI.stop();
			if (result.success){
				Notification.success({message: result.message, delay: 5000});
				$state.go("pharma-picking", {}, {
					reload : true
				});
			} else {
				Notification.error({message: result.message, delay: ''});
				$state.go("pharma-picking-detail.edit", {
					id : vm.pharmaPicking.id
				}, {
					reload : true
				});
			}
		}

		function onSubmitError(result) {
			blockUI.stop();
			$uibModalInstance.close(true);

			if(result.success){
				Notification.success({message: result.message, delay: 5000});
			} else {
				Notification.error({message: result.message, delay: ''});
			}
		}

		function confirmPharmaPickingSubmit() {

            var received = $filter('filter')(vm.pharmaPicking.pharmaPickingLines, function (item) {
                return item.receivedQuantity > 0;
            });
            if (received.length > 0) {
                $uibModal.open({
                    templateUrl: 'app/entities/pharma-picking/pharma-picking-keep-in-pharmacy-dialog.html',
                    controller: 'PharmaPickingKeepInPharmacyController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        pharmaPicking: vm.pharmaPicking,
                        complaint: false,
                        user: {user: vm.user}
                    }
                }).result.then(function () {
                    // success callback implemented on own controller
                    var products = $filter('filter')(vm.pharmaPicking.pharmaPickingLines, function (line) {
                        return line.invoicedQuantity - line.receivedQuantity > 0;
                    }, true);
                    submitToErp(products)

                }, function (flag) {
                    // Back button
                    if (flag == 'goToPickingDetail') {
                        vm.clear('close');
                    }
                });
            } else {
                var products = $filter('filter')(vm.pharmaPicking.pharmaPickingLines, function (line) {
                    return line.invoicedQuantity - line.receivedQuantity > 0;
                }, true);
                submitToErp(products)
            }
		}

        function submitToErp(products) {
            $uibModalInstance.close(true);
            InvoiceAndClaim.invoice(vm.pharmaPicking, products, vm.user);
        }

	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaPickingShowHistoryDetailController', PharmaPickingShowHistoryDetailController);

    PharmaPickingShowHistoryDetailController.$inject = ['$translate', 'blockUI', 'Notification', '$scope', '$state', '$http', '$filter', 'PharmaPicking', 'ParseLinks', 'paginationConstants', 'pagingParams',
        'ModuleSettings', '$localStorage'];

    function PharmaPickingShowHistoryDetailController($translate, blockUI, Notification, $scope, $state, $http, $filter, PharmaPicking, ParseLinks, paginationConstants, pagingParams, ModuleSettings, $localStorage) {
        var vm = this;

        vm.saveSearch = $state.params.saveSearch;
        vm.cnp = $state.params.cnp;

        if(!vm.cnp) {
            $state.go('pharma-picking-show-history');
        }

        if(!vm.saveSearch) {
            vm.saveSearch = JSON.parse(window.localStorage.getItem(vm.cnp));
        } else {
            window.localStorage.setItem(vm.cnp, JSON.stringify(vm.saveSearch));
        }
        vm.saveSearch.product = vm.cnp;
        vm.loadAll = loadAll;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.transition = transition;
        vm.back =back;
        loadAll();

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.pickingModule) {
                    $state.go('accessdenied');
                } else {
                    PharmaPicking.getPickingHeaderForProductHistory({
                        tableFilters: prepareFilters(),
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, onSuccess, onError);
                }
            });
        }

        vm.sort = function(){
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                saveSearch: vm.saveSearch,
                cnp: vm.cnp
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.pharmaPickingHeaders = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            if(error.status == 401){
                Notification.error({
                    message: "É necessário estar autenticado!",
                    delay: ''
                });
            } else {
                Notification.error({
                    message: error.data.message,
                    delay: ''
                });
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            PharmaPicking.getProductsForHistory({
                tableFilters: prepareFilters(),
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                return result;
            }

        }

        //Filters...
        function prepareFilters() {
            var filters = {};
            filters.cnp = textOrNull(vm.cnp);
            filters.company = textOrNull(vm.saveSearch.company.value);
            filters.year = textOrNull(vm.saveSearch.year);
            filters.month = textOrNull(vm.saveSearch.month);
            filters.product = textOrNull(vm.saveSearch.product);
            // filters.pharmacy = textOrNull(vm.saveSearch.pharmacy.value);
            return filters;
        }

        function textOrNull(field) {
            return field != '' ? field : null;
        }


        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };

        function back() {
            window.history.back();
        }

    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaPickingShowHistoryController', PharmaPickingShowHistoryController);

    PharmaPickingShowHistoryController.$inject = ['$translate', 'blockUI', 'Notification', '$scope', '$state', '$http', '$filter', 'PharmaPicking', 'ParseLinks', 'paginationConstants', 'pagingParams',
        'ModuleSettings', 'Principal', '$uibModal', '$localStorage'];

    function PharmaPickingShowHistoryController($translate, blockUI, Notification, $scope, $state, $http, $filter, PharmaPicking, ParseLinks, paginationConstants, pagingParams, ModuleSettings, Principal, $uibModal, $localStorage) {
        var vm = this;

        var date = new Date();

        vm.tableFilters = {
            company: {label: '&nbsp;', value: ''},
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            product: ''
        };

        vm.saveSearch = undefined;
        vm.saveSearchFunction = function (product) {
            vm.saveSearch.description = product.productDescription;
            vm.saveSearch.company = {
                value: product.pharmacyWarehouse, label: product.pharmacyWarehouse + " - " + product.pharmacyName
            };
            return vm.saveSearch;
        };
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = pagingParams.page;

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.loadPage = loadPage;
        vm.getWarehouseFullDescription = getWarehouseFullDescription;
        vm.getSupplierFullDescription = getSupplierFullDescription;
        vm.clearFilter = clearFilter;

        $scope.showSearch = false;

        loadAll();

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            Principal.identity().then(function (account) {
                if (account) {
                    vm.user = account.login;
                    vm.userData = account;
                    if (vm.userData.company && vm.userData.company.pharmaWarehouse != null) {
                        vm.tableFilters.company.value = vm.userData.company.pharmaWarehouse;
                        vm.tableFilters.company.label = vm.userData.company.pharmaWarehouse + ' - ' + vm.userData.company.name1;
                    }
                }
            });
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.pickingModule) {
                    $state.go('accessdenied');
                } else {
                    PharmaPicking.getProductsForHistory({
                        tableFilters: prepareFilters(),
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, onSuccess, onError);
                }
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            return result;
        }

        function onSuccess(data, headers) {
            vm.saveSearch = angular.copy(vm.tableFilters, vm.saveSearch);
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.pharmaPickingShowHistory = data;
        }

        function onError(error) {
            if (error.status == 401) {
                Notification.error({
                    message: "É necessário estar autenticado!",
                    delay: ''
                });
            } else {
                Notification.error({
                    message: error.data.message,
                    delay: ''
                });
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function getSuppliersFilter() {
            vm.supplierFilterPicklist = [{label: '&nbsp;', value: ''}];
            PharmaPicking.suppliersFilter({}, function (data) {
                for (var i = 0; i < data.length; i++) {
                    vm.supplierFilterPicklist.push({
                        label: data[i].supplierCode + ' - ' + data[i].supplierName,
                        value: data[i].supplierCode
                    });
                }
            }, function (err) {
            });
        }

        getSuppliersFilter();

        function getPharmaciesFilter() {
            vm.pharmaciesFilterPicklist = [{label: '&nbsp;', value: ''}];
            PharmaPicking.pharmaciesFilter({}, function (data) {
                for (var i = 0; i < data.length; i++) {
                    vm.pharmaciesFilterPicklist.push({
                        label: data[i].pharmacyWarehouse + ' - ' + data[i].pharmacyName,
                        value: data[i].pharmacyWarehouse
                    });
                }
            }, function (err) {
            });
        }

        getPharmaciesFilter();

        function filter() {
            PharmaPicking.getProductsForHistory({
                tableFilters: vm.tableFilters,
                page: pagingParams.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                return result;
            }

        }

        function clearFilter() {
            vm.tableFilters = {
                company: {label: '&nbsp;', value: ''},
                year: null,
                month: null,
                product: ''
            };
            transition();
        }

        vm.sort = function () {
            transition();
        };

        function transition() {
            PharmaPicking.getProductsForHistory({
                tableFilters: prepareFilters(),
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                return result;
            }

        }

        function getWarehouseFullDescription(warehouseCode) {
            if (angular.isDefined(vm.warehouses)) {
                var warehouse = $filter('filter')(vm.warehouses, {
                    code: warehouseCode
                })[0];
                return warehouseCode + (warehouse != null ? ' - ' + warehouse.description : '');
            } else {
                return warehouseCode;
            }
        }

        function getSupplierFullDescription(supplierCode) {
            if (angular.isDefined(vm.suppliers)) {
                var supplier = $filter('filter')(vm.suppliers, {
                    code: supplierCode
                })[0];
                return supplierCode + (supplier != null ? ' - ' + supplier.description : '');
            } else {
                return supplierCode;
            }
        }

        //Filters...
        function prepareFilters() {
            var filters = {};
            filters.company = textOrNull(vm.tableFilters.company.value);
            filters.year = textOrNull(vm.tableFilters.year);
            filters.month = textOrNull(vm.tableFilters.month);
            filters.product = textOrNull(vm.tableFilters.product);
            // filters.pharmacy = textOrNull(vm.tableFilters.pharmacy.value);
            return filters;
        }

        function textOrNull(field) {
            return field != '' ? field : null;
        }


        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaPickingNewController', PharmaPickingNewController);

    PharmaPickingNewController.$inject = ['Notification', '$scope', '$state', '$http', 'PharmaPicking', 'Principal', 'ModuleSettings', 'blockUI', '$translate', '$uibModal'];

    function PharmaPickingNewController(Notification, $scope, $state, $http, PharmaPicking, Principal, ModuleSettings, blockUI, $translate, $uibModal) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.save = save;
        vm.isSaving = false;

        vm.warehouseSelected = '';
        vm.filterLine = filterLine;

        vm.tableFilters = {
            supplier: {
                label: '&nbsp;',
                value: ''
            },
            initDate: null,
            endDate: null,
            receipt: '',
            pharmacy: {
                label: '&nbsp;',
                value: ''
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $state.go("pharma-picking-detail.edit", {
                id: result.id,
                open: true
            });
        }

        function onSaveError(result) {
            vm.isSaving = false;

            Notification.error({message: "Não foi possível efetuar a operação pretendida. Possivelmente a conferência já se encontra em processamento por outro utilizador", delay: '5000'});
            $state.reload();
        }

        function save(supplierCode, supplierReference) {
            vm.isSaving = true;
            var pharmaPickingAux = null;
            for (var i = 0; i < vm.lines.length; i++) {
                if (vm.lines[i].supplierCode == supplierCode && vm.lines[i].supplierReference == supplierReference) {
                    pharmaPickingAux = vm.lines[i];
                    break;
                }
            }
            PharmaPicking.save(pharmaPickingAux, onSaveSuccess, onSaveError);
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.isSaving = false;
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.pickingModule) {
                    $state.go('accessdenied');
                } else {
                    Principal.identity().then(function (account) {
                        if (account) {
                            vm.account = account;
                            if (vm.account.company == null || (vm.account.company.pharmaWarehouse == null && (vm.account.company.warehouse == null || vm.account.company.warehouse == 0))) {
                                $uibModal.open({
                                    templateUrl: 'app/entities/pharma-picking/pharma-picking-define-warehouse.html',
                                    controller: 'PharmaPickingDefineWarehouseController',
                                    controllerAs: 'vm',
                                    size: 'lg',
                                    backdrop: 'static',
                                    keyboard: false
                                }).result.then(function () {
                                }, function (flag) {
                                    if (flag != 'cancel') {
                                        vm.warehouseSelected = flag.code + ' - ' + flag.description
                                        vm.tableFilters.pharmacy.value = vm.warehouseSelected;
                                        vm.tableFilters.pharmacy.code = flag.code;
                                        getPharmaPickingHeadersFromErp();
                                    } else {
                                        //TODO if MC dont want do load all
                                        $state.go('pharma-picking');
                                    }
                                });
                            } else {
                                getPharmaPickingHeadersFromErp();
                            }
                        } else {
                            vm.account = null;
                        }
                    });
                }
            });
        }

        function getPharmaPickingHeadersFromErp() {
            blockUI.start($translate.instant('pharmaPortalApp.pharmaPicking.message.screenData.loading'));
            $http.get("api/_getPharmaPickingHeadersFromErp").then(function (result) {
                vm.lines = result.data;
                vm.supplierFilterPicklist = [{
                    label: '&nbsp;',
                    value: ''
                }];
                vm.supplierFilterPicklistAux = [];
                vm.pharmaciesFilterPicklist = [{
                    label: '&nbsp;',
                    value: ''
                }];
                vm.pharmaciesFilterPicklistAux = [];

                for (var i = 0; i < vm.lines.length; i++) {
                    var supplierStrAux = vm.lines[i].supplierCode + ' - ' + vm.lines[i].supplierName;
                    var pharmacyNameAux = vm.lines[i].pharmacyWarehouse + ' - ' + vm.lines[i].pharmacyName;

                    if (vm.supplierFilterPicklist.findIndex(function (x){ return x.label == supplierStrAux}) === -1) {
                        vm.supplierFilterPicklist.push({
                            label: supplierStrAux,
                            value: supplierStrAux
                        });
                    }

                    if (vm.pharmaciesFilterPicklist.findIndex(function (x){ return x.label == pharmacyNameAux}) === -1) {
                        vm.pharmaciesFilterPicklist.push({
                            label: pharmacyNameAux,
                            value: pharmacyNameAux
                        });
                    }
                }
                blockUI.stop();
            }, function () {
                blockUI.stop();
            });
        }

        vm.loadAll();

        vm.initDatePopup = {
            opened: false
        };
        vm.endDatePopup = {
            opened: false
        };

        vm.openInitDatePopup = function () {
            vm.initDatePopup.opened = true;
        };

        vm.openEndDatePopup = function () {
            vm.endDatePopup.opened = true;
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            showWeeks: false
        };

        function filterLine(line) {
            var supplierStrAux = line.supplierCode + ' - ' + line.supplierName;
            var docDate = new Date(line.documentDate);
            var pharmacyNameAux = line.pharmacyWarehouse; // + ' - ' + line.pharmacyName;

            var viewLine = true;
            if (vm.tableFilters.receipt != undefined && vm.tableFilters.receipt != '' && line.receipt.indexOf(vm.tableFilters.receipt) < 0) {
                viewLine = false;
            }
            if (vm.tableFilters.supplier != undefined && vm.tableFilters.supplier != null && vm.tableFilters.supplier.value != undefined && vm.tableFilters.supplier.value != '' && supplierStrAux != vm.tableFilters.supplier.value) {
                viewLine = false;
            }
            if (vm.tableFilters.initDate != undefined && vm.tableFilters.initDate != null && vm.tableFilters.initDate != '' && docDate < vm.tableFilters.initDate) {
                viewLine = false;
            }
            if (vm.tableFilters.endDate != undefined && vm.tableFilters.endDate != null && vm.tableFilters.endDate != '' && docDate > vm.tableFilters.endDate) {
                viewLine = false;
            }
            if (vm.tableFilters.pharmacy != undefined && vm.tableFilters.pharmacy != null && vm.tableFilters.pharmacy.code != undefined && vm.tableFilters.pharmacy.code != '' && pharmacyNameAux != vm.tableFilters.pharmacy.code) {
                viewLine = false;
            }

            return viewLine;
        }

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };
        $scope.showSearch = true;
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaPickingKeepInPharmacyController', PharmaPickingKeepInPharmacyController);

    PharmaPickingKeepInPharmacyController.$inject = ['Notification', '$uibModal', '$timeout', 'blockUI', '$uibModalInstance', '$translate', '$state', '$http', '$filter', 'pharmaPicking', 'complaint', 'PharmaPicking', 'PortalSettings', 'ModuleSettings', '$rootScope', '$scope', 'user'];

    function PharmaPickingKeepInPharmacyController(Notification, $uibModal, $timeout, blockUI, $uibModalInstance, $translate, $state, $http, $filter, pharmaPicking, complaint, PharmaPicking, PortalSettings, ModuleSettings, $rootScope, $scope, user) {
        var vm = this;

        vm.portalSettings = PortalSettings.query();

        vm.loadAll = loadAll;

        vm.clear = clear;
        vm.confirmPharmaPickingSubmit = confirmPharmaPickingSubmit;
        vm.pharmaPicking = pharmaPicking;
        vm.user = user.user;
        vm.complaint = complaint;
        vm.supplier = vm.pharmaPicking.supplierCode + " - " + vm.pharmaPicking.supplierName;
        vm.allSelected = true;
        vm.passwordInvalid = false;
        vm.showConfirmProducts = false;
        vm.confirmedProducts = false;

        vm.toggleLineEditMode = toggleLineEditMode;
        vm.checkSuggestionError = checkSuggestionError;
        vm.checkSuggestionQuantity = checkSuggestionQuantity;

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.pickingModule) {
                    $state.go('accessdenied');
                }
            });

            PharmaPicking.getImportFileByPharmacyWarehouse({pharmacyWarehouse: vm.pharmaPicking.pharmacyWarehouse},
                function (result) {
                    vm.importFiles = result;
                    vm.readProduct();
                }, function (e) {
                    vm.importFiles = [];
                    vm.readProduct();
                });
        }

        vm.loadAll();

        function checkSuggestionError() {
            var temp = $filter('filter')(vm.products, function (line) {
                if (!line.suggestion) {
                    return line;
                }
            }, true);
            return temp && vm.products && temp.length == vm.products.length;
        }

        function toggleLineEditMode(product) {
            if (angular.isDefined(product.editMode) && product.editMode == true) {
                product.editMode = false;
            } else {
                product.editMode = true;
                selectText(product.id);
            }
        }

        function selectText(id) {
            var input = document.getElementById(id);
            $timeout(function () {
                input.focus();
                input.select();
            }, 70);
        }

        function checkSuggestionQuantity() {
            var temp = $filter('filter')(vm.products, function (line) {
                // if(line.suggestion > line.receivedQuantity || line.suggestion < 0) {
                if (!line.suggestion) {
                    return line;
                }
            }, true);
        }

        vm.readProduct = function () {
            var temp = $filter('filter')(vm.pharmaPicking.pharmaPickingLines, function (line) {
                if (line.receivedQuantity && line.receivedQuantity != 0) {
                    for (var i = 0; i < vm.importFiles.length; i++) {
                        if (line.cnp == vm.importFiles[i].productCNP) {
                            var invoiced = 0;
                            if ((!vm.complaint && line.selected) || (vm.complaint && !line.selected)) {
                                invoiced = line.invoicedQuantity - line.receivedQuantity;
                            }
                            line.suggestion = Math.min(line.receivedQuantity, (vm.importFiles[i].quantity - vm.importFiles[i].soldQuantity - invoiced));
                            if (line.suggestion <= 0) {
                                line.suggestion = undefined;
                            }
                            break;
                        }
                    }

                    line.isSelectedSuggestion = false;

                    return line;
                }
            }, true);
            vm.products = $filter('orderBy')(temp, 'suggestion', true, function (item1, item2) {

                return (item1.value ? item1.value : 0) >= (item2.value ? item2.value : 0) ? 1 : -1;

            });

            $scope.totalItems = vm.products.length;
            vm.page = 1;
            $scope.itemsPerPage = 7;

            $scope.$watch("vm.page", function () {
                setPagingData(vm.page);
            });
            vm.selectProduct();
            // $timeout(function () {
            //     selectProducts(true);
            // });

        };

        function clear(flag) {
            $uibModalInstance.dismiss(flag);
        }

        function isValid() {
            var temp = $filter('filter')(vm.products, function (line) {
                if (line.isSelectedSuggestion === true) {
                    if (!line.suggestion || line.suggestion > line.receivedQuantity || line.suggestion < 0) {
                        return line;
                    }
                }
            }, true);
            return temp.length <= 0;
        }

        function confirmPharmaPickingSubmit() {
            if (!isValid()) {
                vm.invalidSuggestion = true;
            } else {
                vm.invalidSuggestion = false;
                var temp = $filter('filter')(vm.products, {isSelectedSuggestion: true}, true);
                angular.forEach(temp, function (item) {
                    item.receivedQuantity = item.receivedQuantity - (item.suggestion ? item.suggestion : 0)
                });
                vm.pharmaPicking.lastModifyingDate = new Date();
                if (vm.user == vm.pharmaPicking.lastModifyingUser) {
                    vm.pharmaPicking.lastModifyingUser = vm.user;
                    PharmaPicking.save(vm.pharmaPicking, function onSaveSuccess(result) {
                        $uibModalInstance.close('submit');
                    }, function onSaveError(result) {
                        if (result.data.success) {
                            Notification.success({message: result.data.message, delay: 5000});
                        } else {
                            Notification.error({message: result.data.message, delay: ''});
                        }
                        $state.go("pharma-picking-detail.edit", {
                            id: result.id
                        });
                    });
                } else {
                    Notification.error({message: "Utilizador sem permissões para efetuar operação!", delay: ''});
                }
            }
        }

        function setPagingData(page) {
            var pagedData = vm.products.slice(
                (page - 1) * $scope.itemsPerPage,
                page * $scope.itemsPerPage
            );
            $scope.products = pagedData;
        }

        function selectProducts(flag) {
            for (var i = 0; i < $scope.products.length; i++) {
                $scope.products[i].isSelectedSuggestion = flag;
            }
            for (var i = 0; i < vm.products.length; i++) {
                vm.products[i].isSelectedSuggestion = flag;
            }
        }

        vm.selectAll = function () {
            selectProducts(vm.allSelected);
        }

        vm.selectProduct = function () {
            var products = $filter('filter')(vm.products, {isSelectedSuggestion: false});
            if (products.length != 0) {
                vm.allSelected = false;
            } else {
                vm.allSelected = true;
            }
        }

        vm.changeConfirmProducts = function () {
            vm.showConfirmProducts = false;
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaPickingImportFilesController', PharmaPickingImportFilesController);

    PharmaPickingImportFilesController.$inject = ['$translate', 'blockUI', 'Notification', '$scope', '$state', '$http', '$filter', 'PharmaPicking', 'ParseLinks', 'paginationConstants', 'pagingParams',
        'ModuleSettings', 'Principal', '$uibModal', '$localStorage', 'Upload'];

    function PharmaPickingImportFilesController($translate, blockUI, Notification, $scope, $state, $http, $filter, PharmaPicking, ParseLinks, paginationConstants, pagingParams, ModuleSettings, Principal, $uibModal, $localStorage, Upload) {
        var vm = this;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = pagingParams.page;

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.loadPage = loadPage;
        vm.clearFilter = clearFilter;

        vm.uploadFile = uploadFile;
        vm.downloadFile = downloadFile;
        vm.exportFile = exportFile;

        vm.deleteLine = deleteLine;

        vm.importFile = {
            file: null,
            filename: null
        };

        vm.companylist = [];

        vm.datePopup = {
            opened: false
        };

        vm.openDatePopup = function () {
            vm.datePopup.opened = true;
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            showWeeks: false
        };

        vm.tableFilters = {
            company: {label: '&nbsp;', value: ''},
            product: '',
            initDate: null
        };

        function clearFilter() {

            vm.tableFilters = {
                company: {label: '&nbsp;', value: ''},
                product: '',
                initDate: null
            };
            transition();
        }
        function uploadFile() {

            blockUI.start($translate.instant('pharmaPortalApp.pharmaPickingImportFile.message.uploading'));
            if (vm.importFile && vm.importFile.file) {

                file.upload = Upload.upload({
                    url: '/api/pharma-picking-import-files/upload',
                    file: vm.importFile.file,
                    data: {name: vm.importFile.filename}
                }).then(function (response) {
                    blockUI.stop();
                    Notification.success({message: response.data.message, delay: ''});
                    vm.importFile = {
                        file: null,
                        filename: null
                    };

                    var temp = document.getElementById('filename');
                    if (temp) {
                        temp.value = '';
                    }

                    loadAll();
                }, function (response) {
                    blockUI.stop();
                    Notification.error({message: response.data.message, delay: ''});
                });
            } else {
                blockUI.stop();
                loadAll();
                Notification.error({
                    message: $translate.instant('pharmaPortalApp.pharmaPickingImportFile.message.importError'),
                    delay: ''
                });
            }
        }
        function changeFile() {

            vm.importFile.filename = vm.importFile.file != null ? vm.importFile.file.name : null;
        }
        function loadAll() {

            vm.moduleSettings = ModuleSettings.query();

            Principal.identity().then(function (account) {
                if (account) {
                    vm.user = account.login;
                    vm.userData = account;
                }
            });
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;
                if (!vm.moduleSettings.pickingModule) {

                    $state.go('accessdenied');
                } else {
                    PharmaPicking.getAllImportFiles({
                        tableFilters: prepareFilters(),
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, onSuccess, onError);
                }
            });
        }
        loadAll();

        function getCompaniesFilter() {
            vm.companylist = [{label: '&nbsp;', value: ''}];
            PharmaPicking.importFileCompaniesFilter({}, function (data) {
                for (var i = 0; i < data.length; i++) {
                    vm.companylist.push({
                        label: data[i].value,
                        value: data[i].key
                    });
                }
            }, function (err) {
            });
        }

        getCompaniesFilter();

        function downloadFile() {
            window.open('/api/pharma-picking-import-files/template');
        }

        function exportFile() {
            blockUI.start('A exportar linhas para Excel .......');
            $http.post("/api/pharma-picking-import-files/export-file", {},
                {responseType: "arraybuffer"})
                .then(function successCallback(response) {
                    blockUI.stop();
                    var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmmss");
                    var blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    });
                    saveAs(blob, dateTime + ".xlsx", true);
                    Notification.success({message: "ficheiro gerado com sucesso", delay: 5000});
                }, function errorCallback(response) {
                    blockUI.stop();
                    Notification.error({message: "Erro ao gerar ficheiro", delay: ''});
                });
        }

        function deleteLine(line) {
            PharmaPicking.deleteImportFile({id: line.id}, function (result) {
                Notification.success({message: 'Linha eliminada com sucesso.'})
                loadAll();
            }, onError);
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.importFiles = data;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        vm.sort = function () {
            $state.transitionTo($state.$current, {
                tableFilters: prepareFilters(),
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function transition() {
            PharmaPicking.getAllImportFiles({
                tableFilters: prepareFilters(),
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        //Filters...
        function prepareFilters() {
            var filters = {};
            filters.company = textOrNull(vm.tableFilters.company.value);
            filters.product = textOrNull(vm.tableFilters.product);


            filters.initDate = textOrNull(vm.tableFilters.initDate);
            if(filters.initDate != null) filters.initDate = new Date(Date.UTC(filters.initDate.getFullYear(),filters.initDate.getMonth(),filters.initDate.getDate(),23,59,59,0));
            return filters;
        }

        function textOrNull(field) {
            return field != '' ? field : null;
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaPickingDetailEditController', PharmaPickingDetailEditController);

    PharmaPickingDetailEditController.$inject = ['Notification', '$scope', '$state', '$http', '$translate', '$uibModal', '$timeout', 'PharmaPicking', 'entity', 'PortalSettings', 'ModuleSettings', 'Principal', '$rootScope', 'pagingParams'];

    function PharmaPickingDetailEditController(Notification, $scope, $state, $http, $translate, $uibModal, $timeout, PharmaPicking, entity, PortalSettings, ModuleSettings, Principal, $rootScope, pagingParams) {

        var vm = this;
        vm.portalSettings = PortalSettings.query();

        vm.pharmaPicking = entity;
        vm.pharmaPicking.documentDate = new Date(vm.pharmaPicking.documentDate);
        vm.pharmaPicking.dateCreated = new Date(vm.pharmaPicking.dateCreated);
        vm.pharmaPicking.lastModifyingDate = new Date(vm.pharmaPicking.lastModifyingDate);

        vm.header = {};
        angular.copy(vm.pharmaPicking, vm.header);
        vm.header.supplier = vm.pharmaPicking.supplierCode + " - " + vm.pharmaPicking.supplierName;
        vm.header.pharmacy = vm.pharmaPicking.pharmacyWarehouse + " - " + vm.pharmaPicking.pharmacyName;

        vm.locked = true;
        vm.working = false;

        vm.loadAll = loadAll;
        vm.save = save;

        vm.deleteRightTableLines = deleteRightTableLines;
        vm.deletePharmaPickingLine = deletePharmaPickingLine;
        vm.leftTableFilter = leftTableFilter;
        vm.rightTableFilter = rightTableFilter;
        vm.submitPharmaProduct = submitPharmaProduct;
        vm.submitPharmaPicking = submitPharmaPicking;

        vm.showInfo = showInfo;

        vm.products = [];

        var isOpen = pagingParams.open;
        if(isOpen == true){
            var status = 'OPEN';
        }

        vm.back = function(){
            if(isOpen == true && status != null && status == 'OPEN'){
                PharmaPicking.delete({id: vm.pharmaPicking.id, backButton: "yes"}, function(){}, function(){});
            }
            window.history.back();
        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;
                if (!vm.moduleSettings.pickingModule) {
                    $state.go('accessdenied');
                }
                else {
                    Principal.identity().then(function (account) {
                        if (account) {
                            vm.user = account.login;
                            vm.userGeneric = account.generic;
                            if (account.login != vm.pharmaPicking.lastModifyingUser || vm.pharmaPicking.status == 'CLOSED') {
                                vm.locked = true;
                            } else {
                                vm.locked = false;
                                focusProductInput();
                            }
                        } else {
                            $state.go('accessdenied');
                        }
                    });

                    if(vm.pharmaPicking.pharmaPickingLines == null || vm.pharmaPicking.pharmaPickingLines.length <= 0) {
                        $http.get("api/_getPharmaPickingLinesFromErp/" + vm.pharmaPicking.supplierCode + "/" + vm.pharmaPicking.supplierReference).then(function (result) {
                            vm.pharmaPicking.pharmaPickingLines = result.data;
                            save();
                        });
                    }

                    // if (vm.pharmaPicking.status == 'EXECUTING') {
                    //     $http.post('api/common/_searchProductsByCNP', vm.pharmaPicking.id).then(function (result) {
                    //         if (result.status === 200) {
                    //             vm.products = result.data;
                    //         } else {
                    //             Notification.error({message: $translate.instant(result.headers("X-pharmaPortalApp-alert")), delay: ''});
                    //         }
                    //     });
                    // }
                }
            });
        }
        vm.loadAll();

        //DELETES...
        function deletePharmaPickingLine(pharmaPickingLine) {
            if(isOpen == true && status != null && status == 'OPEN'){
                vm.updateStatus();
            }
            vm.working = true;

            pharmaPickingLine.receivedQuantity = 0;
            pharmaPickingLine.lastModifyingUser = vm.user;
            pharmaPickingLine.lastModifyingDate = new Date();

            Notification.warning({
                message: $translate.instant('pharmaPortalApp.pharmaPicking.detail.message.deleted', {description: pharmaPickingLine.description}),
                delay: 5000
            });
            save();
        }

        function deleteRightTableLines() {
            if(isOpen == true && status != null && status == 'OPEN'){
                vm.updateStatus();
            }
            vm.working = true;

            angular.forEach($scope.processedLines, function (value, key) {
                value.receivedQuantity = 0;
                value.lastModifyingUser = vm.user;
                value.lastModifyingDate = new Date();
            });
            Notification.warning({
                message: $translate.instant('pharmaPortalApp.pharmaPicking.detail.message.deletedAll'),
                delay: 5000
            });
            save();
        }


        //FILTERS...
        function leftTableFilter(line) {
            if (line.invoicedQuantity - line.receivedQuantity > 0) {
                return true;
            }
            return false;
        }

        function rightTableFilter(line) {
            if (line.receivedQuantity > 0) {
                return true;
            }
            return false;
        }

        function overQuantityItems() {
            var items = 0;
            angular.forEach($scope.processedLines, function (value, key) {
                if (value.receivedQuantity > value.invoicedQuantity) {
                    items++;
                }
            });
            return items;
        }

        vm.updateStatus = function(){
            status = "EXECUTING";
        }

        //SUBMITS...
        function submitPharmaProduct() {
            if(isOpen == true && status != null && status == 'OPEN'){
                vm.updateStatus();
            }
            var product = {
                internalcode: "",
                itempackage: "",
                greatfamily: "",
                model: ""
            };
            var i = 0;

            for (i = 0; i < vm.pharmaPicking.pharmaPickingLines.length; i++) {

                if ( vm.pharmaPicking.pharmaPickingLines[i].barcode == vm.form.product) {
                    product =  vm.pharmaPicking.pharmaPickingLines[i];
                    break;
                }
                // if (vm.products[i].barcode == vm.form.product) {
                //     product = vm.products[i];
                //     break;
                // }
            }

            for (i = 0; i < vm.pharmaPicking.pharmaPickingLines.length; i++) {
                if (vm.pharmaPicking.pharmaPickingLines[i].cnp == vm.form.product || (
                    product.internalcode == vm.pharmaPicking.pharmaPickingLines[i].internalCode &&
                    product.itempackage == vm.pharmaPicking.pharmaPickingLines[i].itemPackage &&
                    product.greatfamily == vm.pharmaPicking.pharmaPickingLines[i].greatFamily &&
                    product.model == vm.pharmaPicking.pharmaPickingLines[i].model
                )) {


                    vm.pharmaPicking.pharmaPickingLines[i].lastModifyingUser = vm.user;
                    vm.pharmaPicking.pharmaPickingLines[i].lastModifyingDate = new Date();

                    if (vm.form.quantity != undefined) {
                        vm.pharmaPicking.pharmaPickingLines[i].receivedQuantity += parseInt(vm.form.quantity);
                        vm.message = {
                            message: $translate.instant('pharmaPortalApp.pharmaPicking.detail.message.addedProduct', {
                                description: vm.pharmaPicking.pharmaPickingLines[i].description,
                                number: vm.form.quantity
                            }), delay: 5000
                        };
                    }
                    else {
                        vm.message = {
                            message: $translate.instant('pharmaPortalApp.pharmaPicking.detail.message.addedProduct', {
                                description: vm.pharmaPicking.pharmaPickingLines[i].description,
                                number: 1
                            }), delay: 5000
                        };
                        vm.pharmaPicking.pharmaPickingLines[i].receivedQuantity++;
                    }


                    vm.form.product = undefined;
                    vm.form.quantity = undefined;

                    save();

                    focusProductInput();

                    return;
                }
            }
            var msg = $translate.instant('pharmaPortalApp.pharmaPicking.detail.message.error.submission');
            msg += "<br>" + $translate.instant('pharmaPortalApp.pharmaPicking.detail.message.error.productNotFound', {description: vm.form.product});
            Notification.error({message: msg, delay: 5000});
            vm.form.product = undefined;
            vm.form.quantity = undefined;
            focusProductInput();
        }

        function submitPharmaPicking() {
            //TODO saved on rootScope check if is needed
            if (vm.user == vm.pharmaPicking.lastModifyingUser && vm.pharmaPicking.status != 'CLOSED') {
                vm.working = false;
                if (!vm.userGeneric) {
                    $rootScope.userCloseConference = vm.user;
                    openLastModal();
                } else {
                    $uibModal.open({
                        templateUrl: 'app/entities/pharma-picking/pharma-close-conference-dialog.html',
                        controller: 'PharmaCloseConferenceController',
                        controllerAs: 'vm',
                        size: 'md',
                        backdrop: 'static',
                        keyboard: false
                    }).result.then(function () {
                        // success callback implemented on own controller
                    }, function (flag) {
                        if (flag != "cancel" && flag != null) {
                            $rootScope.userCloseConference = flag;
                            openLastModal();
                        }
                    });
                }

            }
        }

        function openLastModal() {
            var templateUrl;
            var controller;

            if ($scope.pendingLines.length > 0) {
                templateUrl = 'app/entities/pharma-picking/pharma-picking-submit-incomplete-dialog.html';
                controller = 'PharmaPickingSubmitIncompleteController';
            }
            else if (overQuantityItems() > 0) {
                templateUrl = 'app/entities/pharma-picking/pharma-picking-submit-overquantity-dialog.html';
                controller = 'PharmaPickingSubmitOverQuantityController';
            }
            else {
                templateUrl = 'app/entities/pharma-picking/pharma-picking-submit-complete-dialog.html';
                controller = 'PharmaPickingSubmitCompleteController';
            }

            $uibModal.open({
                templateUrl: templateUrl,
                controller: controller,
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    pharmaPicking: vm.pharmaPicking,
                    user: {user: vm.user}
                    // pharmaPicking: ['PharmaPicking', function (PharmaPicking) {
                    //     return PharmaPicking.get({
                    //         id: vm.pharmaPicking.id
                    //     }).$promise;
                    // }]
                }
            }).result.then(function () {
                // success callback implemented on own controller
            }, function (flag) {
                if (flag === "complaint") {
                    $state.go("pharma-supplier-complaint", {pharmaPicking : vm.pharmaPicking});
                }
            });

        }

        //Saves...
        function save() {
            vm.working = true;
            vm.pharmaPicking.lastModifyingDate = new Date();

            if (vm.user == vm.pharmaPicking.lastModifyingUser && vm.pharmaPicking.status != 'CLOSED') {
                vm.pharmaPicking.lastModifyingUser = vm.user;
                PharmaPicking.save(vm.pharmaPicking, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            vm.working = false;
            if (vm.message != undefined) {
                Notification.success(vm.message);
            }
            vm.message = undefined;
            $state.go("pharma-picking-detail.edit", {
                id: result.id
            }, {
                reload: false
            });
        }

        function onSaveError(result) {
            vm.working = false;
            if (result.data.success) {
                Notification.success({message: result.data.message, delay: 5000});
            } else {
                Notification.error({message: result.data.message, delay: ''});
            }
            $state.go("pharma-picking-detail.edit", {
                id: result.id
            });
        }


        //UI Stuff...
        function focusProductInput() {
            $timeout(function () {
                angular.element("#product").focus();
            });
        }

        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };

        function showInfo() {
            $uibModal.open({
                templateUrl: 'app/entities/pharma-picking/invoiced-and-claimed-dialog.html',
                controller: 'InvoicedAndClaimedDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    pharmaPicking: vm.pharmaPicking
                }
            }).result.then(function () {
            }, function (flag) {
            });
        }

    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaPickingDetailController', PharmaPickingDetailController);

	PharmaPickingDetailController.$inject = [ 'Notification', 'blockUI', '$scope', '$state', '$http', '$window', '$translate', '$uibModal', '$timeout', 'PharmaPicking',
			'entity', 'PortalSettings', 'ModuleSettings', 'Principal'];

	function PharmaPickingDetailController(Notification, blockUI, $scope, $state, $http, $window, $translate, $uibModal, $timeout, PharmaPicking, entity, PortalSettings, ModuleSettings, Principal) {
		var vm = this;
		vm.portalSettings = PortalSettings.query();

		vm.pharmaPicking = entity;
		vm.pharmaPicking.documentDate = new Date(vm.pharmaPicking.documentDate);
		vm.pharmaPicking.dateCreated = new Date(vm.pharmaPicking.dateCreated);
		vm.pharmaPicking.lastModifyingDate = new Date(vm.pharmaPicking.lastModifyingDate);

		vm.header = {};
		angular.copy(vm.pharmaPicking, vm.header);
		vm.header.supplier = vm.pharmaPicking.supplierCode + " - " + vm.pharmaPicking.supplierName;
		vm.header.pharmacy = vm.pharmaPicking.pharmacyWarehouse + " - " + vm.pharmaPicking.pharmacyName;

		vm.locked = true;
		vm.working = false;

		vm.loadAll = loadAll;
		vm.save = dummyFunction;

		vm.deleteRightTableLines = dummyFunction;
		vm.deletePharmaPickingLine = dummyFunction;
		vm.leftTableFilter = leftTableFilter;
		vm.rightTableFilter = rightTableFilter;
		vm.submitPharmaProduct = dummyFunction;
		vm.submitPharmaPicking = dummyFunction;

        vm.showInfo = showInfo;

		vm.products = [];

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;
				if (!vm.moduleSettings.pickingModule) {
					$state.go('accessdenied');
				}
				else {
					Principal.identity().then(function(account) {
						if (!account) {
							$state.go('accessdenied');
						}
					});

				}
			});
		}
		vm.loadAll();

        vm.back = function(){
            window.history.back();
        }

		//shared view - dummy function not to break everything
		function dummyFunction(){
			vm.working = true;
		}

		//Filters...
		function leftTableFilter(line){
			if(line.invoicedQuantity-line.receivedQuantity > 0){
				return true;
			}
			return false;
		}

		function rightTableFilter(line){
			if(line.receivedQuantity > 0){
				return true;
			}
			return false;
		}


		$scope.floatTheadOptions = {
			position : 'absolute',
			responsiveContainer : function($table) {
				return $table.closest(".table-responsive");
			}
		};

        function showInfo() {
            $uibModal.open({
                templateUrl: 'app/entities/pharma-picking/invoiced-and-claimed-dialog.html',
                controller: 'InvoicedAndClaimedDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    pharmaPicking: vm.pharmaPicking
                }
            }).result.then(function () {
            }, function (flag) {
            });
        }

	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaPickingDeleteController', PharmaPickingDeleteController);

    PharmaPickingDeleteController.$inject = ['Notification', '$uibModalInstance', '$translate', '$state', '$http', '$filter', 'pharmaPicking', 'PharmaPicking', 'ModuleSettings', 'Principal'];

    function PharmaPickingDeleteController(Notification, $uibModalInstance, $translate, $state, $http, $filter, pharmaPicking, PharmaPicking, ModuleSettings, Principal) {
        var vm = this;

        vm.clear = clear;
        vm.confirmPharmaPickingDelete = confirmPharmaPickingDelete;
        vm.pharmaPicking = pharmaPicking;

        vm.loadAll = loadAll;
        vm.getWarehouseFullDescription = getWarehouseFullDescription;
        vm.getSupplierFullDescription = getSupplierFullDescription;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function onDeleteSuccess(result) {
            Notification.success({message: $translate.instant('pharmaPortalApp.pharmaPicking.message.pharmaPickingDeleted'), delay: 5000});
            $uibModalInstance.close(true);
        }

        function onDeleteError(result) {
            $uibModalInstance.close(true);
            Notification.error({message: result.data.message, delay: ''});
        }

        function confirmPharmaPickingDelete() {
            Principal.identity().then(function (account) {
                if (account) {
                    vm.user = account.login;
                    vm.role = $filter('filter')(account.authorities, "ROLE_ADMIN");
                    vm.status = vm.pharmaPicking.status;
                    PharmaPicking.delete({id: pharmaPicking.id}, onDeleteSuccess, onDeleteError);
                    // if (vm.status == "CLOSED" && (vm.role.length) > 0) {
                    //     PharmaPicking.delete({id: pharmaPicking.id}, onDeleteSuccess, onDeleteError);
                    // } else {
                    //     if (account.company == vm.pharmaPicking.lastModifyingUser || (vm.role.length) > 0) {
                    //         PharmaPicking.delete({id: pharmaPicking.id}, onDeleteSuccess, onDeleteError);
                    //     } else {
                    //         Notification.error({message: $translate.instant('pharmaPortalApp.pharmaPicking.detail.message.wrongUser', {description: pharmaPicking.lastModifyingUser}), delay: 5000});
                    //         vm.hide = true;
                    //     }
                    // }
                }
            });

        }

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.pickingModule) {
                    $state.go('accessdenied');
                } else {
                    $http.get("api/common/_searchWarehousesForSelect").then(function (result) {
                        vm.warehouses = result.data;
                    });
                    $http.get("api/common/_searchSuppliersForSelect").then(function (result) {
                        vm.suppliers = result.data;
                    });
                }
            });
        }

        vm.loadAll();

        function getWarehouseFullDescription(warehouseCode) {
            if (angular.isDefined(vm.warehouses)) {
                var warehouse = $filter('filter')(vm.warehouses, {
                    code: warehouseCode
                })[0];
                return warehouseCode + (warehouse != null ? ' - ' + warehouse.description : '');
            } else {
                return warehouseCode;
            }
        }

        function getSupplierFullDescription(supplierCode) {
            if (angular.isDefined(vm.suppliers)) {
                var supplier = $filter('filter')(vm.suppliers, {
                    code: supplierCode
                })[0];
                return supplierCode + (supplier != null ? ' - ' + supplier.description : '');
            } else {
                return supplierCode;
            }
        }

        function checkUser() {}
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaPickingDefineWarehouseController', PharmaPickingDefineWarehouseController);

    PharmaPickingDefineWarehouseController.$inject = [ 'Notification', 'blockUI', '$uibModalInstance', '$translate', '$state', '$document', '$scope', '$http'];

	function PharmaPickingDefineWarehouseController(Notification, blockUI, $uibModalInstance, $translate, $state, $document, $scope, $http) {
		var vm = this;

		vm.clear = clear;

        vm.warehouseSelected = {};
        vm.warehouseSales = {};

		function clear(flag) {
			$uibModalInstance.dismiss(flag);
		}

		function loadAll(){
            $http.get("api/common/_searchWarehousesForSelectPharma").then(function (result) {
                $scope.warehouses = result.data;
            });
        }

        loadAll();

       vm.submit = function() {
            if (angular.isDefined(vm.warehouseSales)) {
                vm.warehouseSelected.warehouseSalesCode = vm.warehouseSales.code;
                vm.warehouseSelected.warehouseSalesDesc = vm.warehouseSales.description;
            }
           clear(vm.warehouseSales);
        }

	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaPickingDefinePharmacyController', PharmaPickingDefinePharmacyController);

    PharmaPickingDefinePharmacyController.$inject = [ 'Notification', 'blockUI', '$uibModalInstance', '$translate', '$state', '$document', '$scope', '$http'];

	function PharmaPickingDefinePharmacyController(Notification, blockUI, $uibModalInstance, $translate, $state, $document, $scope, $http) {
		var vm = this;

		vm.clear = clear;

        vm.warehouseSelected = {};

		function clear(flag) {
			$uibModalInstance.dismiss(flag);
		}

		function loadAll(){
            $http.get("api/companies/withPharmacyWarehouse").then(function (result) {
                $scope.warehouses = result.data;
            });
        }

        loadAll();

       vm.submit = function() {
            if (angular.isDefined(vm.settings.warehouseSales)) {
                vm.warehouseSelected.warehouseSalesCode = vm.settings.warehouseSales.code;
                vm.warehouseSelected.warehouseSalesDesc = vm.settings.warehouseSales.description;
            }
           clear(vm.settings.warehouseSales);
        }

	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaPickingConfirmProductsController', PharmaPickingConfirmProductsController);

    PharmaPickingConfirmProductsController.$inject = [ 'Notification', 'blockUI', '$uibModalInstance', 'confirmProducts', 'missingProducts', 'pharmaPicking', '$scope', '$state'];

	function PharmaPickingConfirmProductsController(Notification, blockUI, $uibModalInstance, confirmProducts, missingProducts, pharmaPicking, $scope, $state) {
		var vm = this;

		vm.clear = clear;

		function clear(flag) {
			$uibModalInstance.dismiss(flag);
            $state.go('pharma-supplier-complaint', {
                 pharmaPicking : vm.pharmaPicking
                //id : vm.pharmaPicking.id
            });
		}

		vm.products = missingProducts;
		vm.confirmProducts = confirmProducts;
		vm.pharmaPicking = pharmaPicking;

        $scope.totalItems = vm.products.length;
        vm.page = 1;
        $scope.itemsPerPage = 7;

        $scope.$watch("vm.page", function () {
            setPagingData(vm.page);
        });

        function setPagingData(page) {
            var pagedData = vm.products.slice(
                (page - 1) * $scope.itemsPerPage,
                page * $scope.itemsPerPage
            );
            $scope.products = pagedData;
        }

	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('pharma-picking', {
			parent : 'entity',
			url : '/pharma-picking',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaPicking.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-picking/pharma-picking.html',
					controller : 'PharmaPickingController',
					controllerAs : 'vm'
				}
			},
			params : {
				page : {
					value : '1',
					squash : true
				},
				sort : {
					value : 'dateCreated,desc',
					squash : true
				}
			},
			resolve : {
				pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
					return {
						page : PaginationUtil.parsePage($stateParams.page),
						sort : $stateParams.sort,
						predicate : PaginationUtil.parsePredicate($stateParams.sort),
						ascending : PaginationUtil.parseAscending($stateParams.sort)
					};
				} ],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaPicking');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-picking.new', {
			parent : 'entity',
			url : '/pharma-picking/new',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaPicking.new.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-picking/pharma-picking-new.html',
					controller : 'PharmaPickingNewController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaPicking');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-picking-delete', {
			parent : 'pharma-picking',
			url : '/{id}/delete',
			method : 'DELETE',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-picking/pharma-picking-delete-dialog.html',
					controller : 'PharmaPickingDeleteController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						pharmaPicking : [ 'PharmaPicking', function(PharmaPicking) {
							return PharmaPicking.get({
								id : $stateParams.id
							});
						} ]
					}
				}).result.then(function() {
					$state.go('pharma-picking', null, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-picking-detail', {
			parent : 'entity',
			url : '/pharma-picking/:id',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaPicking.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-picking/pharma-picking-detail.html',
					controller : 'PharmaPickingDetailController',
					controllerAs : 'vm',
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaPickingImportFile');
                    $translatePartialLoader.addPart('pharmaPicking');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'PharmaPicking', function($stateParams, PharmaPicking) {
					return PharmaPicking.get({
						id : $stateParams.id
					}).$promise;
				} ]
			}
		}).state('pharma-picking-detail.edit', {
			parent : 'entity',
			url : '/pharma-picking/:id/edit',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaPicking.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-picking/pharma-picking-detail.html',
					controller : 'PharmaPickingDetailEditController',
					controllerAs : 'vm',
				}
			},
            params: {
                open: null
            },
			resolve : {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        open: $stateParams.open
                    };
                }],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaPickingImportFile');
                    $translatePartialLoader.addPart('pharmaPicking');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'PharmaPicking', function($stateParams, PharmaPicking) {
					return PharmaPicking.get({
						id : $stateParams.id
					}).$promise;
				} ]
			}
		}).state('pharma-picking-import-files', {
            parent : 'entity',
            url : '/pharma-picking-import-files',
            data : {
                authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
                pageTitle : 'pharmaPortalApp.pharmaPickingImportFile.home.title'
            },
            views : {
                'content@' : {
                    templateUrl : 'app/entities/pharma-picking/pharma-picking-import-files.html',
                    controller : 'PharmaPickingImportFilesController',
                    controllerAs : 'vm',
                }
            },
            params : {
                page : {
                    value : '1',
                    squash : true
                },
                sort : {
                    value : 'company,asc',
                    squash : true
                }
            },
            resolve : {
                pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        page : PaginationUtil.parsePage($stateParams.page),
                        sort : $stateParams.sort,
                        predicate : PaginationUtil.parsePredicate($stateParams.sort),
                        ascending : PaginationUtil.parseAscending($stateParams.sort)
                    };
                } ],
                translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaPicking');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('pharmaPickingImportFile');
                    return $translate.refresh();
                } ]
            }
        }).state('pharma-picking-show-history', {
            parent : 'entity',
            url : '/pharma-picking-show-history',
            data : {
                authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
                pageTitle : 'pharmaPortalApp.pharmaPickingShowHistory.home.title'
            },
            views : {
                'content@' : {
                    templateUrl : 'app/entities/pharma-picking/pharma-picking-show-history.html',
                    controller : 'PharmaPickingShowHistoryController',
                    controllerAs : 'vm',
                }
            },
            params : {
                page : {
                    value : '1',
                    squash : true
                },
                sort : {
                    value : 'id,asc',
                    squash : true
                }
            },
            resolve : {
                pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        page : PaginationUtil.parsePage($stateParams.page),
                        sort : $stateParams.sort,
                        predicate : PaginationUtil.parsePredicate($stateParams.sort),
                        ascending : PaginationUtil.parseAscending($stateParams.sort)
                    };
                } ],
                translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaPicking');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('pharmaPickingShowHistory');
                    return $translate.refresh();
                } ]
            }
        }).state('pharma-picking-show-history-detail', {
            parent : 'entity',
            url : '/pharma-picking-show-history-detail/:cnp',
            data : {
                authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
                pageTitle : 'pharmaPortalApp.pharmaPickingShowHistory.detail.title'
            },
            params : {
                saveSearch: null,
                page : {
                    value : '1',
                    squash : true
                },
                sort : {
                    value : 'pharmaPickingHeader.dateCreated,desc',
                    squash : true
                }
            },
            views : {
                'content@' : {
                    templateUrl : 'app/entities/pharma-picking/pharma-picking-show-history-detail.html',
                    controller : 'PharmaPickingShowHistoryDetailController',
                    controllerAs : 'vm',
                }
            },
            resolve : {
                pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        page : PaginationUtil.parsePage($stateParams.page),
                        sort : $stateParams.sort,
                        predicate : PaginationUtil.parsePredicate($stateParams.sort),
                        ascending : PaginationUtil.parseAscending($stateParams.sort),
                        saveSearch: $stateParams.saveSearch
                    };
                } ],
                translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaPicking');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('pharmaPickingShowHistory');
                    return $translate.refresh();
                } ]
            }
        })
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaPickingController', PharmaPickingController);

    PharmaPickingController.$inject = ['$translate', 'blockUI', 'Notification', '$scope', '$state', '$http', '$filter', 'PharmaPicking', 'ParseLinks', 'paginationConstants', 'pagingParams',
        'ModuleSettings', 'Principal', '$uibModal', '$localStorage'];

    function PharmaPickingController($translate, blockUI, Notification, $scope, $state, $http, $filter, PharmaPicking, ParseLinks, paginationConstants, pagingParams, ModuleSettings, Principal, $uibModal, $localStorage) {
        var vm = this;
        vm.tableFilters = {
            supplier: {label: '&nbsp;', value: ''},
            initDate: null,
            endDate: null,
            receipt: '',
            pharmacy: {label: '&nbsp;', value: ''},
            user: {label: '&nbsp;', value: ''},
            status: {label: 'EXECUTING', value: 'EXECUTING'}
        };

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.haveItemsToTransport = 0;

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.loadPage = loadPage;
        vm.getWarehouseFullDescription = getWarehouseFullDescription;
        vm.getSupplierFullDescription = getSupplierFullDescription;

        vm.clearFilter = clearFilter;

        vm.generatePdf = generatePdf;
        vm.transportAction = transportAction;

        function transportAction(id) {
            $uibModal.open({
                templateUrl: 'app/entities/pharma-picking/pharma-picking-transport-dialog.html',
                controller: 'PharmaPickingTransportController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false
            }).result.then(function () {
            }, function (flag) {
                if (flag != null && flag != "cancel") {
                    checkIfUserHasCompany(flag, id);
                }
            });
        }

        function checkIfUserHasCompany(name, id) {
            if (vm.userData.company && vm.userData.company.pharmaWarehouse != null) {
                sendToERP(name, id)
            } else {
                $uibModal.open({
                    templateUrl: 'app/entities/pharma-picking/pharma-picking-define-pharmacy.html',
                    controller: 'PharmaPickingDefinePharmacyController',
                    controllerAs: 'vm',
                    size: 'md',
                    backdrop: 'static',
                    keyboard: false
                }).result.then(function () {
                }, function (flag) {
                    if (flag != 'cancel') {
                        sendToERP(name, id, flag);
                    }
                });
            }
        }

        function sendToERP(name, id, flag) {
            blockUI.start($translate.instant('pharmaPortalApp.pharmaPicking.message.submitToErp'));
            var company;
            if (flag == null) {
                company = vm.userData.company;

            } else {
                company = flag;
            }

            vm.bodyRequest = {
                "user": name,
                "pharmaWarehouse": company.pharmaWarehouse
            };

            $http.post("api/pharma-picking/submitTransport", vm.bodyRequest).then(function successCallback(result) {
                blockUI.stop();
                if (result.data.success){
                    Notification.success({message: result.data.message, delay: 5000});
                } else {
                    Notification.error({message: result.data.message, delay: ''});
                }
                $state.go("pharma-picking", {}, {
                    reload : true
                });
            }, function errorCallback(result) {
                blockUI.stop();
                Notification.error({
                    message: result.data.message,
                    delay: ''
                });
            });
        }

        loadAll();

        function loadAll() {
            vm.tableFilters.status.value = $localStorage.statusValue ? $localStorage.statusValue : null;
            vm.tableFilters.status.label = $localStorage.statusLabel ? $localStorage.statusLabel : null;

            vm.moduleSettings = ModuleSettings.query();
            Principal.identity().then(function (account) {
                if (account) {
                    vm.user = account.login;
                    vm.userData = account;
                    vm.noPharmacy = account.company == null;
                }
            });
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.pickingModule) {
                    $state.go('accessdenied');
                } else {
                    PharmaPicking.query({
                        tableFilters: prepareFilters(),
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort()
                    }, onSuccess, onError);

                    $http.get("api/_searchPickingStatusForSelect").then(function (result) {
                        vm.pickingStatus = [{label: '&nbsp;', value: ''}];
                        vm.pickingStatusAux = [];
                        for (var i = 0; i < result.data.length; i++) {
                            var statusStrAux = result.data[i];
                            if (!vm.pickingStatusAux.includes(statusStrAux)) {
                                vm.pickingStatus.push({label: statusStrAux, value: statusStrAux});
                                vm.pickingStatusAux.push(statusStrAux);
                            }
                        }
                    });
                }
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.pharmaPickingHeaders = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        vm.datePopup1 = {
            opened: false
        };

        vm.datePopup2 = {
            opened: false
        };

        vm.openDatePopup = function (i) {
            if (i == 1)
                vm.datePopup1.opened = true;
            else
                vm.datePopup2.opened = true;
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            showWeeks: false
        };

        function getSuppliersFilter() {
            vm.supplierFilterPicklist = [{label: '&nbsp;', value: ''}];
            PharmaPicking.suppliersFilter({}, function (data) {
                for (var i = 0; i < data.length; i++) {
                    vm.supplierFilterPicklist.push({
                        label: data[i].supplierCode + ' - ' + data[i].supplierName,
                        value: data[i].supplierCode
                    });
                }
            }, function (err) {
            });
        }
        getSuppliersFilter();

        function getPharmaciesFilter() {
            vm.pharmaciesFilterPicklist = [{label: '&nbsp;', value: ''}];
            PharmaPicking.pharmaciesFilter({}, function (data) {
                for (var i = 0; i < data.length; i++) {
                    vm.pharmaciesFilterPicklist.push({
                        label: data[i].pharmacyWarehouse + ' - ' + data[i].pharmacyName,
                        value: data[i].pharmacyWarehouse
                    });
                }
            }, function (err) {
            });
        }
        getPharmaciesFilter();

        function getUserFilter() {
            vm.userFilterPicklist = [{label: '&nbsp;', value: ''}];
            PharmaPicking.usersFilter({}, function (data) {
                for (var i = 0; i < data.length; i++) {
                    vm.userFilterPicklist.push({
                        label: data[i],
                        value: data[i]
                    });
                }
            }, function (err) {
            });
        }
        getUserFilter();

        function haveItemsToTransport() {
            PharmaPicking.haveItemsToTransport({}, function (data) {
                vm.haveItemsToTransport = data.body;
            }, function (err) {
            });
        }

        haveItemsToTransport();

        function filter() {
            PharmaPicking.query({
                tableFilters: vm.tableFilters,
                page: pagingParams.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.pharmaPickingHeaders = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                Notification.error({
                    message: error.data.message,
                    delay: ''
                });
            }
        }

        function clearFilter() {
            vm.tableFilters = {
                supplier: {label: '&nbsp;', value: ''},
                initDate: null,
                endDate: null,
                receipt: '',
                pharmacy: {label: '&nbsp;', value: ''},
                user: {label: '&nbsp;', value: ''},
                status: {label: 'EXECUTING', value: 'EXECUTING'}
            };

            transition();
        }

        vm.sort = function(){
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function transition() {
            /*$state.transitionTo($state.$current, {
                page : vm.page,
                sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                tableFilters: vm.tableFilters
            });*/
            $localStorage.statusValue = vm.tableFilters.status.value;
            $localStorage.statusLabel = vm.tableFilters.status.label;

            PharmaPicking.query({
                tableFilters: prepareFilters(),
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.pharmaPickingHeaders = data;
            }

            function onError(error) {
                Notification.error({
                    message: error.data.message,
                    delay: ''
                });
            }
        }

        function getWarehouseFullDescription(warehouseCode) {
            if (angular.isDefined(vm.warehouses)) {
                var warehouse = $filter('filter')(vm.warehouses, {
                    code: warehouseCode
                })[0];
                return warehouseCode + (warehouse != null ? ' - ' + warehouse.description : '');
            } else {
                return warehouseCode;
            }
        }

        function getSupplierFullDescription(supplierCode) {
            if (angular.isDefined(vm.suppliers)) {
                var supplier = $filter('filter')(vm.suppliers, {
                    code: supplierCode
                })[0];
                return supplierCode + (supplier != null ? ' - ' + supplier.description : '');
            } else {
                return supplierCode;
            }
        }

        function generatePdf(lineID) {
            $http.get("api/pharma-picking/" + lineID + "/print", {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
                var blob = new Blob([response.data], {
                    type: "application/pdf"
                });
                saveAs(blob, "Picking_" + lineID + "_" + dateTime + ".pdf", true);
                Notification.success({message: "Report gerado com sucesso", delay: 5000});
            }, function errorCallback(response) {
                Notification.error({message: "Erro ao gerar report", delay: ''});
            });
        }

        //Filters...
        function prepareFilters() {
            var filters = {};
            filters.supplier = textOrNull(vm.tableFilters.supplier.value);
            filters.initDate = textOrNull(vm.tableFilters.initDate);
            filters.endDate = textOrNull(vm.tableFilters.endDate);
            filters.receipt = textOrNull(vm.tableFilters.receipt);
            filters.pharmacy = textOrNull(vm.tableFilters.pharmacy.value);
            filters.user = textOrNull(vm.tableFilters.user.value);
            filters.status = textOrNull(vm.tableFilters.status.value);

            return filters;
        }

        function textOrNull(field) {
            return field != '' ? field : null;
        }


        $scope.floatTheadOptions = {
            position: 'absolute',
            responsiveContainer: function ($table) {
                return $table.closest(".table-responsive");
            }
        };
        $scope.showSearch = true;
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaCloseConferenceController', PharmaCloseConferenceController);

    PharmaCloseConferenceController.$inject = [ 'Notification', 'blockUI', '$uibModalInstance', '$translate', '$state'];

	function PharmaCloseConferenceController(Notification, blockUI, $uibModalInstance, $translate, $state) {
		var vm = this;

		vm.clear = clear;

		vm.userName = null;


		function clear(flag) {
			$uibModalInstance.dismiss(flag);
		}

		function onSubmitSuccess(result) {
			$uibModalInstance.close(true);
			blockUI.stop();
			if (result.success){
				Notification.success({message: result.message, delay: 5000});
				$state.go("pharma-picking", {}, {
					reload : true
				});
			} else {
				Notification.error({message: result.message, delay: ''});
				$state.go("pharma-picking-detail.edit", {
					id : vm.pharmaPicking.id
				}, {
					reload : true
				});
			}
		}

		function onSubmitError(result) {
			blockUI.stop();
			$uibModalInstance.close(true);

			if(result.success){
				Notification.success({message: result.message, delay: 5000});
			} else {
				Notification.error({message: result.message, delay: ''});
			}
		}

	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('InvoicedAndClaimedDialogController', InvoicedAndClaimedDialogController);

    InvoicedAndClaimedDialogController.$inject = ['$uibModalInstance', 'pharmaPicking', '$filter'];

    function InvoicedAndClaimedDialogController($uibModalInstance, pharmaPicking, $filter) {
        var vm = this;

        vm.clear = clear;
        vm.close = close;

        vm.pharmaPicking = angular.copy(pharmaPicking);

        vm.pharmaPicking.pharmaPickingLines = $filter('filter')(vm.pharmaPicking.pharmaPickingLines, function (line) {
            var i = line.invoicedQuantity ? line.invoicedQuantity : 0;
            var r = line.receivedQuantity ? line.receivedQuantity : 0;
            return i - r > 0;
        }, true);

        function clear(flag) {
            $uibModalInstance.dismiss(flag);
        }

        function close(flag) {
            $uibModalInstance.close(flag);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .service('InvoiceAndClaim', InvoiceAndClaim);

    InvoiceAndClaim.$inject = ['$state', '$uibModal', '$translate', 'Notification', '$http', 'blockUI', '$rootScope', '$filter', '$sce', '$localStorage', 'PharmaPicking'];

    function InvoiceAndClaim($state, $uibModal, $translate, Notification, $http, blockUI, $rootScope, $filter, $sce, $localStorage, PharmaPicking) {

        this.currentPharmaPicking = {};
        this.user = null;
        this.products = null;
        this.claim = null;

        this.invoiceAndClaim = function (currentPharmaPicking, products, user) {
            this.currentPharmaPicking = angular.copy(currentPharmaPicking);
            this.products = angular.copy(products);
            this.user = angular.copy(user);
            this.claim = true;
            this.submitToErp();
        }

        this.invoice = function (currentPharmaPicking, products, user) {
            this.currentPharmaPicking = angular.copy(currentPharmaPicking);
            this.products = angular.copy(products);
            this.user = angular.copy(user);
            this.claim = false;
            this.submitToErp();
        };

        this.onSaveSuccess = function() {
            var bodyRequest = {
                "idPharmaPicking": this.currentPharmaPicking.id,
                "userCloseConference": $rootScope.userCloseConference,
                "listMissingProducts": this.products,
                "supplierCode": this.currentPharmaPicking.supplierCode
            };

            blockUI.start($translate.instant('pharmaPortalApp.pharmaPicking.message.submittingPharmaPicking'));
            var self = this;
            $http.post("/api/pharma-picking/submit", bodyRequest).then(function successCallback(response) {
                self.onSubmitSuccess(response.data)
            }, function errorCallback(response) {
                self.onSubmitError(response.data)
            });
        }

        this.onSaveError = function(result) {
            if (result.data.success) {
                this.onSaveSuccess();
            } else {
                Notification.error({message: result.data.message, delay: ''});
            }
        }

        this.submitToErp = function() {
            var curPP = this.currentPharmaPicking;
            if (this.user == curPP.lastModifyingUser && curPP.status != 'CLOSED') {
                var self = this;
                PharmaPicking.save(curPP, function (result) {
                    self.onSaveSuccess();
                }, function (result) {
                    self.onSaveError(result);
                });
            } else {
                Notification.error({message: "Não possui autorização para realizar a operação!", delay: ''});
            }
        }

        this.onSubmitSuccess = function(result) {
            blockUI.stop();
            if (result.success) {
                Notification.success({message: result.message, delay: 5000});
                if (this.claim) {
                    this.requestPdf();
                } else {
                    $state.go("pharma-picking", {}, {
                        reload: true
                    });
                }
            } else {
                Notification.error({message: result.message, delay: ''});
                $state.go("pharma-picking-detail.edit", {
                    id: this.currentPharmaPicking.id
                }, {
                    reload: true
                });
            }
        }

        this.onSubmitError = function(result) {
            blockUI.stop();
            if (result.success) {
                Notification.success({message: result.message, delay: 5000});
            } else {
                Notification.error({message: result.message, delay: ''});
            }
        }

        this.requestPdf = function() {
            blockUI.start($translate.instant('pharmaPortalApp.pharmaSupplierComplaint.generatingPDF'));
            var self = this;
            $http.post("/api/pharma-supplier-complaint/generatePDF",
                this.currentPharmaPicking,
                {responseType: "arraybuffer"})
                .then(function successCallback(response) {
                    blockUI.stop();
                    var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");
                    var blob = new Blob([response.data], {
                        type: "application/pdf"
                    });
                    var fileURL = URL.createObjectURL(blob);
                    window.open($sce.trustAsResourceUrl(fileURL), '_blank');
                    saveAs(blob, "Complaint_" + self.currentPharmaPicking.id + "_" + dateTime + ".pdf", true);
                    Notification.success({message: "Report gerado com sucesso", delay: 5000});
                    self.resetLocalStorage();

                    $state.go("pharma-picking", {}, {
                        reload: true
                    });
                }, function errorCallback(response) {
                    blockUI.stop();
                    Notification.error({message: "Erro ao gerar report", delay: ''});
                });
        }

        this.resetLocalStorage = function() {
            $localStorage.pharmaPicking = null;
            $localStorage.changeState = null;
        }

    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PsychotropicsRequisitionsDetailController', PsychotropicsRequisitionsDetailController);

    PsychotropicsRequisitionsDetailController.$inject = ['$scope', 'pagingParams', '$state', 'paginationConstants', 'PsychotropicsRequisitions', 'ParseLinks'];

    function PsychotropicsRequisitionsDetailController($scope, pagingParams, $state, paginationConstants, PsychotropicsRequisitions, ParseLinks) {
        var vm = this;
        vm.requisition = pagingParams.requisition;
        vm.back = pagingParams.back;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        $scope.showSearch = false;

        vm.tableFilters = {
            invoice: null,
            quantitySent: null,
            description: null,
            cnp: null
        };

        if (pagingParams.requisition == null) {
            vm.requisition = JSON.parse(localStorage.getItem("requisition"));
        } else {
            vm.requisition = pagingParams.requisition;
            localStorage.setItem("requisition", JSON.stringify(vm.requisition));
        }

        vm.loadAllFilters = function () {
            PsychotropicsRequisitions.getAllFilterLines({
                idRequisition: vm.requisition.id
            }, onSuccessFilters, onError);
        };

        function onSuccessFilters(result) {
            vm.filters = result;
        }

        vm.loadAllFilters();

        vm.loadAll = function () {
            PsychotropicsRequisitions.getAllRequisitionLines({
                page: pagingParams.page - 1,
                tableFilters: JSON.stringify(vm.tableFilters),
                idRequisition: vm.requisition.id,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

        };

        vm.clearFilter = function () {
            vm.tableFilters = {
                invoice: null,
                quantitySent: null,
                description: null,
                cnp: null
            };
            vm.loadAll();

        };

        vm.loadAll();

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        }


        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.infarmedRequisitionLines = data;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                idRequisition: vm.requisition.id,
                tableFilters: JSON.stringify(vm.tableFilters),
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.transition();
        }

    }
})
();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('psychotropics', {
            parent: 'entity',
            url: '/psychotropics',
            data: {
                authorities: ['ROLE_INFARMED'],
                pageTitle: 'pharmaPortalApp.psychotropics.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pharma-infarmed/psychotropicsRequisitions.html',
                    controller: 'PsychotropicsRequisitionsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        page : PaginationUtil.parsePage($stateParams.page),
                        sort : $stateParams.sort,
                        predicate : PaginationUtil.parsePredicate($stateParams.sort),
                        ascending : PaginationUtil.parseAscending($stateParams.sort)
                    };
                } ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('psychotropics');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('psychotropics.detail', {
            parent: 'entity',
            url: '/psychotropics/detail',
            data: {
                authorities: ['ROLE_INFARMED'],
                pageTitle: 'pharmaPortalApp.psychotropics.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pharma-infarmed/psychotropicsRequisitions-detail.html',
                    controller: 'PsychotropicsRequisitionsDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                requisition: null,
                back: null,
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        page : PaginationUtil.parsePage($stateParams.page),
                        sort : $stateParams.sort,
                        requisition : $stateParams.requisition,
                        back : $stateParams.back,
                        predicate : PaginationUtil.parsePredicate($stateParams.sort),
                        ascending : PaginationUtil.parseAscending($stateParams.sort)
                    };
                } ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('psychotropics');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PsychotropicsRequisitionsController', PsychotropicsRequisitionsController);

    PsychotropicsRequisitionsController.$inject = ['$timeout', 'DataUtils', 'Principal', 'blockUI', '$http', '$filter', '$scope', '$translate', 'Notification', 'pagingParams', 'paginationConstants', 'PsychotropicsRequisitions', 'ParseLinks', '$uibModal', '$state'];

    function PsychotropicsRequisitionsController($timeout, DataUtils, Principal, blockUI, $http, $filter, $scope, $translate, Notification, pagingParams, paginationConstants, PsychotropicsRequisitions, ParseLinks, $uibModal, $state) {
        var vm = this;
        $scope.showSearch = true
        vm.loadAll = loadAll;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.selectAll = false;

        vm.selectedYear = null;
        vm.selectedMonth = null;

        vm.status = ['CREATED', 'AVAILABLE', 'VALIDATED'];//, 'DELETED'
        vm.usersResponsible = [];
        vm.tableFilters = {
            numberRequisition: null,
            date: null,
            search: null,
            cnp: null,
            taxNumber: null,
            table: null,
            responsible: null,
            type: null,
            status: 'AVAILABLE'
        };

        vm.generateInitialTree = function () {
            $timeout(function () {
                if (vm.account.company != null) {
                    vm.tableFilters.taxNumber = vm.account.company.nif;
                }
                PsychotropicsRequisitions.queryAllYearsToTree({tableFilters: vm.tableFilters}, function (result) {
                    $scope.data = result;
                });
            }, 100);
        };

        vm.getAllMonthsToTree = function (node) {
            PsychotropicsRequisitions.queryAllMonthsToTree({
                year: node.label,
                tableFilters: vm.tableFilters
            }, function (result) {
                node.children = result;
            });
        };

        vm.getAllEntitiesToTree = function (node) {
            PsychotropicsRequisitions.queryAllEntitiesToTree({
                jsonHashMap: JSON.stringify(node.parents),
                tableFilters: vm.tableFilters
            }, function (result) {
                node.children = result;
            });
        };

        vm.getAllTypesToTree = function (node) {
            PsychotropicsRequisitions.getAllTypesToTree({
                jsonHashMap: JSON.stringify(node.parents),
                tableFilters: vm.tableFilters
            }, function (result) {
                node.children = result;
            });
        };

        vm.getAllTablesToTree = function (node) {
            PsychotropicsRequisitions.getAllTablesToTree({
                jsonHashMap: JSON.stringify(node.parents),
                tableFilters: vm.tableFilters
            }, function (result) {
                node.children = result;
            });
        };

        vm.selectedOption = function () {
            vm.resetDataFilter();

            if (vm.tableFilters.cnp != null) {
                vm.beforeChangeProduct = vm.tableFilters.cnp;
                vm.tableFilters.cnp = vm.tableFilters.cnp.cnp;
            }
            vm.generateInitialTree();
            vm.saveFilterToLocalStorage();
            PsychotropicsRequisitions.queryAllFilters({
                tableFilters: vm.tableFilters,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        };

        vm.resetDataFilter = function () {
            vm.tableFilters.numberRequisition = null;
            vm.tableFilters.date = null;
            vm.tableFilters.search = null;
            vm.tableFilters.type = null;
            vm.tableFilters.table = null;
            vm.tableFilters.taxNumber = null;
            vm.selectedYear = null;
            vm.selectedMonth = null;
            vm.actualStatus = vm.tableFilters.status;
        }

        vm.applyFiltersTree = function (node) {
            vm.resetDataFilter();
            if (node.parents == null || node.parents.length === 0) {
                return;
            }
            loadAll();
            vm.tableFilters.search = node.parents["searchBy"];
            vm.tableFilters.taxNumber = node.parents["taxNumber"];

            if (node.level === 3) {
                vm.tableFilters.type = node.label;
            }

            if (node.level === 4) {
                vm.tableFilters.table = node.label;
            }

            PsychotropicsRequisitions.queryAllFilters({
                tableFilters: vm.tableFilters,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        };


        vm.getNextTreeLevel = function (value, node) {
            if (!value || node.children.length !== 0) {
                return;
            }
            if (vm.account.company != null && node.parents != null) {
                vm.tableFilters.taxNumber = vm.account.company.nif;
            }
            switch (node.level) {
                case 0:
                    vm.getAllMonthsToTree(node);
                    break;
                case 1:
                    vm.getAllEntitiesToTree(node);
                    break;
                case 2:
                    vm.getAllTypesToTree(node);
                    break;
                case 3:
                    vm.getAllTablesToTree(node);
                    break;
            }
        }
        getAccount();

        function loadAll() {
            vm.beforeChange = null;
            vm.beforeChangeProduct = null;
            if (localStorage.getItem("filterMainPage") != null) {
                vm.tableFilters = JSON.parse(localStorage.getItem("filterMainPage"))
            }

            if (vm.selectedYear != null && vm.selectedMonth != null) {
                vm.tableFilters.search = vm.selectedMonth.id + "" + vm.selectedYear
            }
            if (vm.tableFilters.taxNumber != null) {
                vm.beforeChange = vm.tableFilters.taxNumber;
                vm.tableFilters.taxNumber = vm.tableFilters.taxNumber.taxNumber;
            }
            if (vm.tableFilters.cnp != null) {
                vm.beforeChangeProduct = vm.tableFilters.cnp;
                vm.tableFilters.cnp = vm.tableFilters.cnp.cnp;
            }

            vm.actualStatus = vm.tableFilters.status;
            PsychotropicsRequisitions.queryAllFilters({
                tableFilters: vm.tableFilters,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            vm.generateInitialTree();

        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.psychotropicsHeaders = data;
            vm.page = pagingParams.page;
            vm.tableFilters.taxNumber = vm.beforeChange;
            vm.tableFilters.cnp = vm.beforeChangeProduct;
            vm.beforeChangeProduct = null;
            vm.beforeChange = null;
            addUsersfilter();
        }

        function addUsersfilter() {
            var pageUsers = vm.psychotropicsHeaders.reduce(function (sum, header) {
                if (sum.indexOf(header.responsible) < 0) sum.push(header.responsible);
                return sum;
            }, []);
            if (vm.usersResponsible.length === 0) {
                vm.usersResponsible = pageUsers;
            } else {
                vm.usersResponsible = vm.usersResponsible.concat(pageUsers).unique();
            }
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }


        loadAll();

        vm.deleteRequisition = function (id, status) {
            PsychotropicsRequisitions.deleteRequisition({id: id, status: status}, function () {
                vm.loadAll();
                showSuccess("pharmaPortalApp.psychotropics.success.deleted");
            }, function () {
                showError("pharmaPortalApp.psychotropics.error.deleteRequisition")
            });
        };

        function showSuccess(message) {
            Notification.success({
                message: $translate.instant(message),
                delay: ''
            });
        }

        vm.clearFilter = function () {
            vm.tableFilters = {
                numberRequisition: null,
                date: null,
                search: null,
                cnp: null,
                type: null,
                taxNumber: null,
                table: null,
                responsible: null,
                status: null
            };
            vm.selectedYear = null;
            vm.selectedMonth = null;
            vm.saveFilterToLocalStorage();
            loadAll();
        };

        function showWarning(message) {
            Notification.warning({
                message: $translate.instant(message),
                delay: ''
            });
        }

        function showError(message) {
            Notification.error({
                message: $translate.instant(message),
                delay: ''
            });
        }

        Array.prototype.unique = function () {
            var a = this.concat();
            for (var i = 0; i < a.length; ++i) {
                for (var j = i + 1; j < a.length; ++j) {
                    if (a[i] === a[j])
                        a.splice(j--, 1);
                }
            }

            return a;
        };

        vm.saveFilterToLocalStorage = function () {
            localStorage.setItem("filterMainPage", JSON.stringify(vm.tableFilters));
        };

        vm.openChooseModal = function () {
            $uibModal.open({
                templateUrl: 'app/entities/pharma-infarmed/choose-psychotropics-date.html',
                controller: 'ChoosePsychotropicsDate',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    pagingParams: function () {
                        return pagingParams;
                    },
                    paginationConstants: function () {
                        return paginationConstants;
                    },
                    allowValidations: function () {
                        return vm.allowAvailable;
                    }
                }
            }).result.then(function () {
                // success callback implemented on own controller
            }, function (flag) {
                loadAll();
            });
        };

        vm.validateRequisition = function (found) {
            if (vm.account.professionalWalletNumber === undefined || vm.account.professionalWalletNumber == null) {
                showWarning('pharmaPortalApp.psychotropics.warning.professionalWalletNumber');
            } else {

                PsychotropicsRequisitions.validateRequisition(found, function () {
                    showSuccess("pharmaPortalApp.psychotropics.success.validation");
                    vm.loadAll();
                }, function () {
                    showError("pharmaPortalApp.psychotropics.error.validationRequisitions")
                });
            }
        };

        vm.checkIfIsAllLinesSelected = function () {
            var found = $filter('filter')(vm.psychotropicsHeaders, function (value) {
                return value.selected === undefined || value.selected === false
            }, true);
            vm.selectAll = found.length === 0;
        };

        vm.disableButtons = true;

        vm.selectLine = function () {

            var found = $filter('filter')(vm.psychotropicsHeaders, function (value) {
                return value.selected !== undefined && value.selected === true
            }, true);
            $timeout(function () {
                $scope.$apply(function () {
                    vm.disableButtons = found.length === 0;
                })
            })

        };

        vm.selectAllPage = function (flag) {
            vm.disableButtons = !flag;
            angular.forEach(vm.psychotropicsHeaders, function (value) {
                value.selected = flag;
            });
        };

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                if (account && account.authorities.length) {
                    // $state.go('product-erp-integration');
                } else {
                    $state.go('home.fl');
                }
                if (vm.account.responsibleValidator === true && vm.account.professionalWalletNumber !== undefined && vm.account.professionalWalletNumber !== null && vm.account.company != null) {
                    vm.allowValidations = true;
                }
                if (vm.account.responsibleValidator === true && vm.account.professionalWalletNumber !== undefined && vm.account.professionalWalletNumber !== null && vm.account.company == null) {
                    vm.allowAvailable = true;
                    vm.allowCreate = true;
                }
                if (vm.account.company == null) {
                    vm.allowCreate = true;
                }
            }).catch(function () {
                vm.isAuthenticated = null;
                $state.go('home.fl');
            });
        }

        vm.validateAll = function () {
            if (vm.account.professionalWalletNumber === undefined || vm.account.professionalWalletNumber == null) {
                showWarning('pharmaPortalApp.psychotropics.warning.professionalWalletNumber');
            } else {
                var found = $filter('filter')(vm.psychotropicsHeaders, {selected: true}, true);
                if (found.length === 0) {
                    showWarning('pharmaPortalApp.psychotropics.warning.selectAtLeastOne');
                } else {
                    PsychotropicsRequisitions.validateListRequisitions(found, function () {
                        showSuccess("pharmaPortalApp.psychotropics.success.validation");
                        vm.selectAll = false;
                        vm.loadAll();
                    }, function () {
                        showError("pharmaPortalApp.psychotropics.error.validationRequisitions")
                    });
                }
            }
        };

        $scope.refreshSelectModel = function (query) {
            if (vm.lastQuery != query) {
                vm.lastQuery = query;
                PsychotropicsRequisitions.getAllFiltersData({search: query}, function (result) {
                    vm.products = result.productsFilter;
                });
            }
        };

        vm.onOpenClose = function () {
            angular.element('.ui-select-choices-row').removeClass('active');
        };

        vm.generateAll = function () {
            var found = $filter('filter')(vm.psychotropicsHeaders, {selected: true}, true);
            if (found.length === 0) {
                showWarning('pharmaPortalApp.psychotropics.warning.selectAtLeastOne');
            } else {
                vm.generateReports(found);
            }
        };
        vm.availableAll = function () {
            var found = $filter('filter')(vm.psychotropicsHeaders, {selected: true}, true);
            if (found.length === 0) {
                showWarning('pharmaPortalApp.psychotropics.warning.selectAtLeastOne');
            } else {
                PsychotropicsRequisitions.availableListRequisitions(found, function () {
                    vm.loadAll();
                    showSuccess("pharmaPortalApp.psychotropics.success.available");
                }, function () {
                    showError("pharmaPortalApp.psychotropics.error.availableRequisitions")
                });
            }
        };


        vm.generateReports = function (listFound) {
            $uibModal.open({
                templateUrl: 'app/entities/pharma-infarmed/choose-psychotropics-reports-number.html',
                controller: 'ChoosePsychotropicsReportsNumber',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            }).result.then(function () {
                // success callback implemented on own controller
            }, function (flag) {
                if (flag != 'cancel') {
                    blockUI.start($translate.instant('pharmaPortalApp.psychotropics.loading'));
                    $http.post("/api/psychotropics-requisitions/generatePDF-all",
                        JSON.stringify({"via": flag, "list": listFound}),
                        {responseType: "arraybuffer"})
                        .then(function successCallback(response) {
                            blockUI.stop();
                            var dateTime = $filter("date")(new Date(), "ddMMyyyy_HHmm");

                            response.filename = "Requisitions" + "_" + dateTime + ".zip"
                            DataUtils.viewServerFile(response);
                            showSuccess('pharmaPortalApp.psychotropics.successReports');

                        }, function errorCallback(response) {
                            blockUI.stop();
                            Notification.error({message: "Erro ao gerar report", delay: ''});
                        });
                }
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            vm.willChangePage = true;
            if (localStorage.getItem("filterMainPage") != null) {
                vm.tableFilters = JSON.parse(localStorage.getItem("filterMainPage"))
            }
            vm.removeLocalStorage = true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                tableFilters: vm.tableFilters,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.transition();
        }

        vm.generatePdf = function (requisition) {
            vm.generateReports([requisition]);
        };

        vm.getPeriodTolabel = function (searchBy) {
            if (searchBy == null) {
                return '';
            }

            var month;
            var year;
            if (searchBy.length === 6) {
                month = searchBy.substring(0, 2);
                year = searchBy.substring(2, searchBy.length);
            } else {
                month = searchBy.substring(0, 1);
                year = searchBy.substring(1, searchBy.length);
            }

            return searchArrayByKey(parseInt(month), vm.months).label + " " + year;

        };

        vm.getTablesFromLines = function (psychotropicsHeader) {
            var list = [];
            psychotropicsHeader.infarmedRequisitionLines.forEach(function (element) {
                if (!list.includes(element.typeTab)) {
                    list.push(element.typeTab);
                }
            });

            return list;
        };

        var actualYear = new Date().getFullYear();
        var actualMonth = new Date().getMonth();
        vm.years = [actualYear - 1, actualYear];

        function searchArrayByKey(nameKey, myArray) {
            for (var i = 0; i < myArray.length; i++) {
                if (myArray[i].id === nameKey) {
                    return myArray[i];
                }
            }
        }

        vm.months = [
            {
                id: 0,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.January')
            },
            {
                id: 1,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.February')
            },
            {
                id: 2,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.March')
            },
            {
                id: 3,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.April')
            },
            {
                id: 4,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.May')
            },
            {
                id: 5,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.June')
            },
            {
                id: 6,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.July')
            },
            {
                id: 7,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.August')
            },
            {
                id: 8,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.September')
            },
            {
                id: 9,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.October')
            },
            {
                id: 10,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.November')
            },
            {
                id: 11,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.December')
            }
        ]
        vm.monthsToShow = vm.months;

        vm.yearSelected = function (yearSelected) {
            if (vm.selectedYear != null && actualYear == yearSelected) {
                vm.monthsToShow = $filter('filter')(vm.months, function (value) {
                    return value.id <= actualMonth
                });
            } else {
                vm.monthsToShow = vm.months;
            }
            vm.selectedMonth = null;
            return vm.monthsToShow;
        };

        vm.removeLocalStorage = null;

        $scope.$on('$destroy', function () {
            if (!vm.removeLocalStorage) {
                localStorage.removeItem("filterMainPage");
            }
        });

        vm.availableRequisition = function (found) {
            PsychotropicsRequisitions.availableRequisition(found, function () {
                showSuccess("pharmaPortalApp.psychotropics.success.available");
                vm.loadAll();
            }, function () {
                showError("pharmaPortalApp.psychotropics.error.availableRequisitions")
            });
        };

    }
})();


(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ChoosePsychotropicsReportsNumber', ChoosePsychotropicsReportsNumber);

    ChoosePsychotropicsReportsNumber.$inject = ['$uibModalInstance', '$scope'];

    function ChoosePsychotropicsReportsNumber($uibModalInstance, $scope) {
        var vm = this;

        vm.selectedCopies = '1';

        $scope.onChange = function(){
            document.getElementById('print').focus();
        };

        vm.clear = function (number) {
            $uibModalInstance.dismiss(number);
        };

    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ChoosePsychotropicsDate', ChoosePsychotropicsDate);

    ChoosePsychotropicsDate.$inject = ['$scope', '$timeout', 'pagingParams', 'allowValidations', 'paginationConstants', '$filter', '$uibModalInstance', '$translate', 'Notification', 'PsychotropicsRequisitions',
        'blockUI', '$state', 'Principal', 'ParseLinks'];

    function ChoosePsychotropicsDate($scope, $timeout, pagingParams, allowValidations, paginationConstants, $filter, $uibModalInstance, $translate, Notification, PsychotropicsRequisitions,
                                     blockUI, $state, Principal, ParseLinks) {
        var vm = this;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.selectAll = false;
        vm.allowValidations = allowValidations;

        vm.getAllDataFromDataBase = function () {
            $timeout(function () {
                blockUI.start($translate.instant('pharmaPortalApp.psychotropics.loading'));
                PsychotropicsRequisitions.queryWithFilters({
                    month: vm.selectedMonth.id, year: vm.selectedYear, user: vm.loggedUser,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            })
            vm.generateInitialTree();
        };

        function getAllDataFromErp() {
            $timeout(function () {
                blockUI.start($translate.instant('pharmaPortalApp.psychotropics.loading'));
                PsychotropicsRequisitions.query({
                    month: vm.selectedMonth.id, year: vm.selectedYear, user: vm.loggedUser,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            })
            vm.generateInitialTree();

        }

        function onSuccess(data, headers) {
            blockUI.stop();
            vm.showLastPage = true;
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.newRequisitionsPsychotropics = data;
            vm.page = pagingParams.page;
        }

        function getLoggedUser() {
            Principal.identity().then(function (account) {
                if (account) {
                    vm.loggedUser = account.login;
                    vm.account = account;
                } else {
                    $state.go('accessdenied');
                }
            });
        }

        getLoggedUser();

        function onError(error) {
            blockUI.stop();
            Notification.error({message: error.data.message, delay: ''});
        }

        vm.showLastPage = false;
        vm.clear = function (month, year) {
            $uibModalInstance.dismiss(month + "/" + year);
        };

        var actualYear = new Date().getFullYear();
        var actualMonth = new Date().getMonth();
        vm.years = [actualYear - 1, actualYear];
        vm.months = [
            {
                id: 0,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.January')
            },
            {
                id: 1,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.February')
            },
            {
                id: 2,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.March')
            },
            {
                id: 3,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.April')
            },
            {
                id: 4,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.May')
            },
            {
                id: 5,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.June')
            },
            {
                id: 6,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.July')
            },
            {
                id: 7,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.August')
            },
            {
                id: 8,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.September')
            },
            {
                id: 9,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.October')
            },
            {
                id: 10,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.November')
            },
            {
                id: 11,
                label: $translate.instant('pharmaPortalApp.psychotropics.months.December')
            }
        ]
        vm.monthsToShow = vm.months;

        vm.getAllRequisitions = function () {
            getAllDataFromErp();
        };
        vm.yearSelected = function (yearSelected) {
            if (vm.selectedYear != null && actualYear == yearSelected) {
                vm.monthsToShow = $filter('filter')(vm.months, function (value) {
                    return value.id <= actualMonth
                });
            } else {
                vm.monthsToShow = vm.months;
            }
            vm.selectedMonth = null;
            return vm.monthsToShow;
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            getAllDataFromErp();
        }

        vm.getTablesFromLines = function (psychotropicsHeader) {
            var list = [];
            psychotropicsHeader.infarmedRequisitionLines.forEach(function(element) {
                if(!list.includes(element.typeTab)){
                    list.push(element.typeTab);
                }
            });

            return list;
        };

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.transition();
        }

        vm.selectAllPage = function (flag) {
            vm.disableButtons = !flag;
            angular.forEach(vm.newRequisitionsPsychotropics, function (value) {
                value.selected = flag;
            });
        };

        vm.checkIfIsAllLinesSelected = function () {
            var found = $filter('filter')(vm.newRequisitionsPsychotropics, function (value) {
                return value.selected === undefined || value.selected === false
            }, true);
            vm.selectAll = found.length === 0;
        };

        vm.disableButtons = true;
        vm.selectLine = function () {
            var found = $filter('filter')(vm.newRequisitionsPsychotropics, function (value) {
                return value.selected !== undefined && value.selected === true
            }, true);
            $timeout(function () {
                $scope.$apply(function () {
                    vm.disableButtons = found.length === 0;
                })
            })
        };

        vm.availableAll = function () {
            var found = $filter('filter')(vm.newRequisitionsPsychotropics, {selected: true}, true);
            if (found.length === 0) {
                showWarning('pharmaPortalApp.psychotropics.warning.selectAtLeastOne');
            } else {
                PsychotropicsRequisitions.availableListRequisitions(found, function () {
                    vm.getAllDataFromDataBase();
                    showSuccess("pharmaPortalApp.psychotropics.success.available");
                    vm.selectAll = false;
                }, function () {
                    showError("pharmaPortalApp.psychotropics.error.availableRequisitions")
                });
            }
        };

        vm.availableRequisition = function (found) {
            PsychotropicsRequisitions.availableRequisition(found, function () {
                vm.getAllDataFromDataBase();
                showSuccess("pharmaPortalApp.psychotropics.success.available");
            }, function () {
                showError("pharmaPortalApp.psychotropics.error.availableRequisitions")
            });
        };

        function showError(message) {
            Notification.error({
                message: $translate.instant(message),
                delay: ''
            });
        }

        vm.cancelRequisition = function (id) {
            PsychotropicsRequisitions.cancelRequisition(id, function () {
                vm.generateInitialTree();
            });
            transition();
        };

        vm.deleteRequisition = function (id) {
            PsychotropicsRequisitions.deleteRequisition({id: id}, function () {
                showSuccess("pharmaPortalApp.psychotropics.success.deleted");
            }, function () {
                showError("pharmaPortalApp.psychotropics.error.deleteRequisition")
            });
        };

        vm.cancelAll = function () {
            var list = [];
            angular.forEach(vm.newRequisitionsPsychotropics, function (value) {
                list.push(value.id);
            });
            PsychotropicsRequisitions.deleteAllRequisition(JSON.stringify(list), function () {
                vm.clear('cancel', '');
                vm.generateInitialTree();
            }, function () {
                showError("pharmaPortalApp.psychotropics.error.deleteRequisition")
            });
        };


        function showSuccess(message) {
            Notification.success({
                message: $translate.instant(message),
                delay: ''
            });
        }

        function showWarning(message) {
            Notification.warning({
                message: $translate.instant(message),
                delay: ''
            });
        }

        vm.tableFilters = {
            numberRequisition: null,
            date: null,
            search: null,
            cnp: null,
            taxNumber: null,
            responsible: null,
            table: null,
            type: null,
            status: 'CREATED'
        };

        vm.resetDataFilter = function () {
            vm.tableFilters.numberRequisition = null;
            vm.tableFilters.date = null;
            vm.tableFilters.search = null;
            vm.tableFilters.type = null;
            vm.tableFilters.table = null;
            vm.tableFilters.taxNumber = null;
        }



        vm.getAllTypesToTree = function (node) {
            PsychotropicsRequisitions.getAllTypesToTree({
                jsonHashMap: JSON.stringify(node.parents),
                tableFilters: vm.tableFilters
            }, function (result) {
                node.children = result;
            });
        };

        vm.getAllTablesToTree = function (node) {
            PsychotropicsRequisitions.getAllTablesToTree({
                jsonHashMap: JSON.stringify(node.parents),
                tableFilters: vm.tableFilters
            }, function (result) {
                node.children = result;
            });
        };

        vm.getAllEntitiesToTree = function (node) {
            PsychotropicsRequisitions.queryAllEntitiesToTree({
                jsonHashMap: JSON.stringify(node.parents),
                tableFilters: vm.tableFilters
            }, function (result) {
                node.children = result;
            });
        };


        vm.applyFiltersTree = function (node) {
            vm.resetDataFilter();
            if (node.parents == null) {
                return;
            }

            vm.tableFilters.status = 'CREATED';
            vm.tableFilters.search = vm.selectedMonth.id + "" + vm.selectedYear;
            vm.tableFilters.taxNumber = node.parents["taxNumber"];

            if (node.level === 3) {
                vm.tableFilters.type = node.label;
            }

            if (node.level === 4) {
                vm.tableFilters.table = node.label;
            }

            PsychotropicsRequisitions.queryAllFilters({
                tableFilters: vm.tableFilters,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        };

        vm.getNextTreeLevel = function (value, node) {
            if (!value || node.children.length !== 0) {
                return;
            }

            switch (node.level) {
                case 1:
                    vm.getAllEntitiesToTree(node);
                    break;
                case 2:
                    vm.getAllTypesToTree(node);
                    break;
                case 3:
                    vm.getAllTablesToTree(node);
                    break;
            }
        }

        vm.generateInitialTree = function () {
            var tax = null;
            if( vm.account.company != null && node.parents != null ){
                tax  = vm.account.company.nif;
            }

            PsychotropicsRequisitions.queryMonthAndYearToTree({
                month: vm.selectedMonth.id,
                year: vm.selectedYear,
                tax: tax
            }, function (result) {
                $scope.data = result;
            });
        };
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pharma-fault-settings', {
            parent: 'entity',
            url: '/pharma-fault-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.pharmaFaultSettings.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pharma-fault-settings/pharma-fault-settings.html',
                    controller: 'PharmaFaultSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaFaultSettings');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PharmaFaultSettings', function ($stateParams, PharmaFaultSettings) {
                    return PharmaFaultSettings.get({id: $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pharma-fault-settings',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .controller('PharmaFaultSettingsController', PharmaFaultSettingsController);

    PharmaFaultSettingsController.$inject = ['Notification', '$translate', '$scope', 'entity', 'PharmaFaultSettings'];

    function PharmaFaultSettingsController(Notification, $translate, $scope, entity, PharmaFaultSettings) {
        var vm = this;

        vm.pharmaFaultSettings = entity;
        vm.save = save;

        function save () {
            vm.isSaving = true;
            if (vm.pharmaFaultSettings.id !== null) {
                PharmaFaultSettings.update(vm.pharmaFaultSettings, onSaveSuccess, onSaveError);
            } else {
                PharmaFaultSettings.save(vm.pharmaFaultSettings, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('pharmaPortalApp:pharmaFaultSettingsUpdate', result);
            vm.isSaving = false;
            Notification.success({
                message : $translate.instant('pharmaPortalApp.pharmaFaultSettings.updated'),
                delay : 5000
            });
        }

        function onSaveError () {
            vm.isSaving = false;
            Notification.error({
                message : $translate.instant('pharmaPortalApp.pharmaFaultSettings.error'),
                delay : ''
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .controller('PharmaFaultReportLineHistoryController', PharmaFaultReportLineHistoryController);

    PharmaFaultReportLineHistoryController.$inject = ['$uibModalInstance', 'entity'];

    function PharmaFaultReportLineHistoryController($uibModalInstance, entity) {
        var vm = this;

        vm.lineErrors = entity.pharmaRepLineErrors;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .controller('PharmaFaultReportHeaderHistoryController', PharmaFaultReportHeaderHistoryController);

    PharmaFaultReportHeaderHistoryController.$inject = ['$uibModalInstance', 'entity'];

    function PharmaFaultReportHeaderHistoryController($uibModalInstance, entity) {
        var vm = this;

        vm.headerErrors = entity.pharmaRepHeaderErrors;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .controller('PharmaFaultReportHeaderDetailController', PharmaFaultReportHeaderDetailController);

    PharmaFaultReportHeaderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PharmaFaultReportHeader', 'PharmaFaultReportLine', 'PharmaRepHeaderError'];

    function PharmaFaultReportHeaderDetailController($scope, $rootScope, $stateParams, previousState, entity, PharmaFaultReportHeader, PharmaFaultReportLine, PharmaRepHeaderError) {
        var vm = this;

        vm.pharmaFaultReportHeader = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('pharmaPortalApp:pharmaFaultReportHeaderUpdate', function(event, result) {
            vm.pharmaFaultReportHeader = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .controller('PharmaFaultReportHeaderDeleteController',PharmaFaultReportHeaderDeleteController);

    PharmaFaultReportHeaderDeleteController.$inject = ['$uibModalInstance', 'entity', 'PharmaFaultReportHeader'];

    function PharmaFaultReportHeaderDeleteController($uibModalInstance, entity, PharmaFaultReportHeader) {
        var vm = this;

        vm.pharmaFaultReportHeader = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PharmaFaultReportHeader.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pharma-fault-report-header', {
            parent: 'entity',
            url: '/pharma-fault-report-header?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.pharmaFaultReportHeader.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pharma-fault-report-header/pharma-fault-report-headers.html',
                    controller: 'PharmaFaultReportHeaderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaFaultReportHeader');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pharma-fault-report-header-detail', {
            parent: 'entity',
            url: '/pharma-fault-report-header/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.pharmaFaultReportHeader.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pharma-fault-report-header/pharma-fault-report-header-detail.html',
                    controller: 'PharmaFaultReportHeaderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaFaultReportHeader');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PharmaFaultReportHeader', function($stateParams, PharmaFaultReportHeader) {
                    return PharmaFaultReportHeader.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pharma-fault-report-header',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pharma-fault-report-header.delete', {
            parent: 'pharma-fault-report-header',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pharma-fault-report-header/pharma-fault-report-header-delete-dialog.html',
                    controller: 'PharmaFaultReportHeaderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PharmaFaultReportHeader', function(PharmaFaultReportHeader) {
                            return PharmaFaultReportHeader.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pharma-fault-report-header', null, { reload: 'pharma-fault-report-header' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pharma-fault-report-header.history', {
            parent: 'pharma-fault-report-header',
            url: '/{id}/history',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pharma-fault-report-header/pharma-fault-report-header-history-dialog.html',
                    controller: 'PharmaFaultReportHeaderHistoryController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['PharmaFaultReportHeader', function(PharmaFaultReportHeader) {
                            return PharmaFaultReportHeader.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pharma-fault-report-header', null, { reload: 'pharma-fault-report-header' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pharma-fault-report-line-history', {
            parent: 'pharma-fault-report-header',
            url: '/{id}/lineHistory',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pharma-fault-report-header/pharma-fault-report-line-history-dialog.html',
                    controller: 'PharmaFaultReportLineHistoryController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['PharmaFaultReportLine', function(PharmaFaultReportLine) {
                            return PharmaFaultReportLine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pharma-fault-report-header', null, { reload: 'pharma-fault-report-header' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('pharmaPortalApp')
        .factory('PharmaFaultReportHeader', PharmaFaultReportHeader);

    PharmaFaultReportHeader.$inject = ['$resource', 'DateUtils'];

    function PharmaFaultReportHeader ($resource, DateUtils) {
        var resourceUrl =  'api/pharma-fault-report-headers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.reportDate = DateUtils.convertLocalDateFromServer(data.reportDate);
                        data.orderDate = DateUtils.convertLocalDateFromServer(data.orderDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.reportDate = DateUtils.convertLocalDateToServer(copy.reportDate);
                    copy.orderDate = DateUtils.convertLocalDateToServer(copy.orderDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.reportDate = DateUtils.convertLocalDateToServer(copy.reportDate);
                    copy.orderDate = DateUtils.convertLocalDateToServer(copy.orderDate);
                    return angular.toJson(copy);
                }
            },
            'resync': {
                method:'GET',
                url:  'api/pharma-fault-report-headers/resync'
            },
            'resend': {
                method:'GET',
                url:  'api/pharma-fault-report-headers/resend'
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .controller('PharmaFaultReportHeaderController', PharmaFaultReportHeaderController);

    PharmaFaultReportHeaderController.$inject = ['Notification', 'blockUI', '$translate', '$scope', '$state', '$http', '$timeout', 'PharmaFaultReportHeader', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PharmaFaultReportHeaderController(Notification, blockUI, $translate, $scope, $state, $http, $timeout, PharmaFaultReportHeader, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.resync = resync;
        vm.resend = resend;

        loadAll();

        function loadAll() {
            PharmaFaultReportHeader.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.pharmaFaultReportHeaders = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        vm.expandCollapse = function (item) {
            var expandCurrent = angular.isUndefined(item.expanded) || item.expanded == false;
            angular.forEach(vm.pharmaFaultReportHeaders, function (value) {
                value.expanded = item.id == value.id;
            });
            item.expanded = expandCurrent;
        }

        function resync() {
            blockUI.start($translate.instant('pharmaPortalApp.pharmaFaultReportHeader.loading'));
            $http.get('/api/pharma-fault-report-headers/resync').then(function (result) {
                Notification.success({
                    message: $translate.instant('pharmaPortalApp.pharmaFaultReportHeader.message.success', {lines: result.data}),
                    delay: 5000
                });
                $timeout(function () {
                    blockUI.stop();
                }, 250);
                $state.go('pharma-fault-report-header', null, {
                    reload : true
                });
            }, function (error) {
                Notification.error({message: $translate.instant('pharmaPortalApp.pharmaFaultReportHeader.message.error'), delay: 5000});
                $timeout(function () {
                    blockUI.stop();
                }, 250);
            });
        }

        function resend() {
            blockUI.start($translate.instant('pharmaPortalApp.pharmaFaultReportHeader.message.resending'));
            $http.get('/api/pharma-fault-report-headers/resend').then(function (result) {
                Notification.success({
                    message: $translate.instant('pharmaPortalApp.pharmaFaultReportHeader.message.resending.success'),
                    delay: 5000
                });
                $timeout(function () {
                    blockUI.stop();
                }, 250);
                $state.go('pharma-fault-report-header', null, {
                    reload : true
                });
            }, function (error) {
                Notification.error({message: $translate.instant('pharmaPortalApp.pharmaFaultReportHeader.message.resending.error'), delay: 5000});
                $timeout(function () {
                    blockUI.stop();
                }, 250);
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaDashboardTableDialogController', PharmaDashboardTableDialogController);

    PharmaDashboardTableDialogController.$inject = ['$uibModalInstance', 'tableType', 'tableFilter', 'PharmaDashboard', '$scope'];

    function PharmaDashboardTableDialogController($uibModalInstance, tableType, tableFilter, PharmaDashboard, $scope) {
        var vm = this;

        vm.tableType = tableType;
        vm.filter = tableFilter;
        vm.allUsers = {};
        vm.cancel = cancel;

        function cancel() {
            vm.tableType = {};
            vm.filter = {};
            $uibModalInstance.dismiss('cancel');
        }

        switch (vm.tableType) {
            case 'global':
                vm.filter.campaignType = null;
                if (vm.filter.pharmacyCode == null) {
                    PharmaDashboard.queryAllSelloutPharmacySalesman(vm.filter, function (result) {
                        vm.popupSalesman = result;
                    }, function (error) {
                    });
                } else {
                    PharmaDashboard.queryAllSelloutPharmacySalesmanAndPharmacy(vm.filter, function (result) {
                        vm.popupSalesman = result;
                    }, function (error) {
                    });
                }
                break;
            case 'challenge':
                vm.filter.campaignType = "CHALLENGE";
                if (vm.filter.campaignCode != null && vm.filter.pharmacyCode != null) {
                    PharmaDashboard.queryTopAllSalesmanByPharmacyAndCampaignOrderByValueList(vm.filter, function (resultP) {
                        vm.popupSalesman = resultP;
                    }, function (error) {
                    });
                } else if (vm.filter.campaignCode != null && vm.filter.pharmacyCode == null) {
                    PharmaDashboard.queryTopAllSalesmanByCampaignOrderByValueList(vm.filter, function (resultP) {
                        vm.popupSalesman = resultP;
                    }, function (error) {
                    });
                } else if (vm.filter.campaignCode == null && vm.filter.pharmacyCode != null) {
                    if (vm.filter.campaignType != null) {
                        PharmaDashboard.queryTopAllSalesmanByCampaignTypeAndPharmacyOrderByValueList(vm.filter, function (result) {
                            vm.popupSalesman = result;
                        }, function (error) {
                        });
                    } else {
                        vm.filter.campaignType = "CHALLENGE";
                        PharmaDashboard.queryTopAllSalesmanByCampaignTypeAndPharmacyOrderByValueList(vm.filter, function (resultP) {
                            vm.popupSalesman = resultP;
                        }, function (error) {
                        });
                        vm.filter.campaignType = tableFilter.campaignType != null ? tableFilter.campaignType : null;
                    }
                } else {
                    if (vm.filter.campaignType != null) {
                        PharmaDashboard.queryTopAllSalesmanByCampaignTypeOrderByValueList(vm.filter, function (result) {
                            vm.popupSalesman = result;
                        }, function (error) {
                        });
                    } else {
                        vm.filter.campaignType = "CHALLENGE";
                        PharmaDashboard.queryTopAllSalesmanByCampaignTypeOrderByValueList(vm.filter, function (resultP) {
                            vm.popupSalesman = resultP;
                        }, function (error) {
                        });
                        vm.filter.campaignType = tableFilter.campaignType != null ? tableFilter.campaignType : null;
                    }
                }
                break;
            case 'promotion':
                vm.filter.campaignType = "PROMOTION";
                if (vm.filter.campaignCode != null && vm.filter.pharmacyCode != null) {
                    PharmaDashboard.queryTopAllSalesmanByPharmacyAndCampaignOrderByQuantityList(vm.filter, function (resultP) {
                        vm.popupSalesman = resultP;
                    }, function (error) {
                    });
                } else if (vm.filter.campaignCode != null && vm.filter.pharmacyCode == null) {
                    PharmaDashboard.queryTopAllSalesmanByCampaignOrderByQuantityList(vm.filter, function (resultP) {
                        vm.popupSalesman = resultP;
                    }, function (error) {
                    });
                } else if (vm.filter.campaignCode == null && vm.filter.pharmacyCode != null) {
                    if (vm.filter.campaignType != null) {
                        PharmaDashboard.queryTopAllSalesmanByCampaignTypeAndPharmacyOrderByQuantityList(vm.filter, function (result) {
                            vm.popupSalesman = result;
                        }, function (error) {
                        });
                    } else {
                        vm.filter.campaignType = "PROMOTION";
                        PharmaDashboard.queryTopAllSalesmanByCampaignTypeAndPharmacyOrderByQuantityList(vm.filter, function (resultP) {
                            vm.popupSalesman = resultP;
                        }, function (error) {
                        });
                        vm.filter.campaignType = tableFilter.campaignType != null ? tableFilter.campaignType : null;
                    }
                } else {
                    if (vm.filter.campaignType != null) {
                        PharmaDashboard.queryTopAllSalesmanByCampaignTypeOrderByQuantityList(vm.filter, function (result) {
                            vm.popupSalesman = result;
                        }, function (error) {
                        });
                    } else {
                        vm.filter.campaignType = "PROMOTION";
                        PharmaDashboard.queryTopAllSalesmanByCampaignTypeOrderByQuantityList(vm.filter, function (resultP) {
                            vm.popupSalesman = resultP;
                        }, function (error) {
                        });
                        vm.filter.campaignType = tableFilter.campaignType != null ? tableFilter.campaignType : null;
                    }
                }
                break;
        }

        function loadUsers() {
            PharmaDashboard.getPortalUsers(function (result) {
                vm.allUsers = result;
            }, function (error) {
            });
        }

        loadUsers();

        $scope.loadPhotos = function (salesmanDes) {
            for (var i = 0; i < vm.allUsers.length; i++) {
                if (vm.allUsers[i].indicatorsName == salesmanDes) {
                    vm.tableUser = vm.allUsers[i];

                    if (vm.tableUser && vm.tableUser.thumbnailContentType) {
                        return vm.tableUser;
                    } else {
                        return null;
                    }
                }
            }
            return null;
        };
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pharma-dashboard', {
            parent: 'entity',
            url: '/pharma-dashboard',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.pharmaDashboard.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pharma-dashboard/pharma-dashboard.html',
                    controller: 'PharmaDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaDashboard');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaDashboardController', PharmaDashboardController);

    PharmaDashboardController.$inject = ['$scope', 'Notification', '$state', 'Company', 'Campaign', 'PharmaDashboard', 'ModuleSettings', '$translate', '$http', '$timeout', '$filter', 'Principal', '$uibModal', '$interval', '$q'];

    function PharmaDashboardController($scope, Notification, $state, Company, Campaign, PharmaDashboard, ModuleSettings, $translate, $http, $timeout, $filter, Principal, $uibModal, $interval, $q) {
        var vm = this;
        vm.campaigns = [];
        vm.companies = Company.findByPharmacyClientAndSelloutNickname();
        PharmaDashboard.getCampaignTypes(function (result) {
            vm.campaignTypes = result;
        }, function (error) {
        });

        vm.filterDashboard = filterDashboard;
        vm.clearFilter = clearFilter;
        vm.changeFilter = changeFilter;

        vm.filteredCampaigns = [];
        vm.filteredPharmacies = [];
        vm.quantityTableUser = null;
        vm.valueTableUser = null;
        vm.valueUsers = [];
        vm.quantityUsers = [];
        vm.salesmanValueNames = [];
        vm.salesmanQuantityNames = [];
        vm.allUsers = [];
        vm.showFilter = false;
        vm.popup = "";
        vm.popupSalesman = [];
        vm.fullFilterRequest = {};

        vm.isSM = false;
        vm.isMD = false;

        $scope.loadCampaigns = function () {
            var x = 0;
            vm.filteredCampaigns = [];

            var periodForCamp = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null
            };

            Campaign.activeByDashboardPeriod(periodForCamp, function (result) {
                vm.campaigns = result;
                PharmaDashboard.getCampaignsByPeriod(periodForCamp, function (result2) {
                    var loopPromises = [];
                    angular.forEach(result2, function (x, y) {
                        var exists = false;
                        for (var i = 0; i < vm.campaigns.length; i++) {
                            if (vm.campaigns[i].id === x) {
                                exists = true;
                            }
                        }
                        if (!exists) {
                            var updateCampaign = Campaign.getById({id: x}).$promise;
                            loopPromises.push(updateCampaign);
                            updateCampaign.then(function (result) {
                                if (result[0] != null) {
                                    vm.campaigns.push(result[0]);
                                }
                            });
                        }
                    });
                    $q.all(loopPromises).then(function () {
                        if (vm.filter.campaignType == null) {
                            vm.filter.campaign = null;
                        }
                        for (var i = 0; i < vm.campaigns.length; i++) {
                            if (vm.campaigns[i].campaignType === vm.filter.campaignType) {
                                vm.filteredCampaigns[x] = vm.campaigns[i];
                                x++;
                            }
                        }
                    });
                });

            }, function (error) {
            });

        };

        function loadUsers() {
            PharmaDashboard.getPortalUsers(function (result) {
                vm.allUsers = result;
            }, function (error) {
            });
        }

        loadUsers();

        $scope.loadPharmacies = function () {
            vm.filteredPharmacies = [];

            var filterCampaignPharmacies = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null
            };

            PharmaDashboard.queryPharmacyByCampaignOrderByValue(filterCampaignPharmacies, function (resultP) {
                vm.filteredPharmacies = resultP;
            }, function (error) {
            });

        };

        vm.filter = [{
            period: null,
            periodType: null,
            campaignType: null,
            campaign: null,
            company: null,
            salesman: null
        }];

        function clearFilter() {
            vm.filter = [{
                period: null,
                periodType: null,
                campaignType: null,
                campaign: null,
                company: null,
                salesman: null
            }];
            vm.salesman = {};
            vm.lastSalesman = {};
            vm.pharmacy = {};
            vm.lastPharmacy = {};
            vm.salesmanValue = [];
            vm.selloutTop = [];
            vm.salesmanQuantity = [];
            vm.topPharmacies = [];
            loadAll();
        }

        function queryPeriod() {
            PharmaDashboard.getPeriodFromInd(function (result) {
                vm.periods = result;
                if (vm.filter.period == null) {
                    vm.filter.period = result[1];
                }
                queryPeriodType();
            }, function (error) {
            });
        }

        function queryPeriodType() {
            PharmaDashboard.getPeriodTypeFromInd(function (result2) {
                vm.periodTypes = result2;
                if (vm.filter.periodType == null) {
                    vm.filter.periodType = result2[0];
                }
            }, function (error) {
            });
        }

        function loadAll() {
            vm.screenWidth = window.innerWidth;
            vm.isSM = false;
            vm.isMD = false;

            if (vm.screenWidth < 1100) {
                vm.isSM = true;
            } else if (vm.screenWidth < 1400) {
                vm.isMD = true;
            }

            Principal.identity().then(function (account) {
                vm.loggedUser = account;
                vm.filter.company = vm.loggedUser.company;
                vm.isFullyAuthenticated = account.authorities.length > 0; // TRUE
                vm.isAuthorized = false;
                for (var i = 0; i < account.authorities.length; i++) {
                    if (account.authorities[i] == "ROLE_PHARMA_ADMIN") {
                        vm.isAuthorized = true;
                    }
                }
            });
            queryPeriod();

            $timeout(function () {
                vm.filteredSalesman = [];
                vm.filter.salesman = null;

                var filterPharmacySalesman = {
                    year: vm.filter.period != null ? vm.filter.period.year : null,
                    month: vm.filter.period != null ? vm.filter.period.month : null,
                    periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                    pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
                };

                PharmaDashboard.queryPharmacySalesman(filterPharmacySalesman, function (result) {
                    vm.filteredSalesman = result;
                }, function (error) {
                });
            }, 1000);

            $timeout(function () {
                filterDashboard()
            }, 1000);
        }

        loadAll();

        $scope.loadSalesman = function () {
            vm.salesman = {};
            vm.lastSalesman = {};
            vm.pharmacy = {};
            vm.lastPharmacy = {};
            vm.filter.salesman = null;

            var filterPharmacySalesman = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
            };

            PharmaDashboard.queryPharmacySalesman(filterPharmacySalesman, function (result) {
                vm.filteredSalesman = result;
            }, function (error) {
            });
        };

        function changeFilter() {
            vm.showFilter = !vm.showFilter;
        }

        function filterDashboard() {
            vm.salesman = {};
            vm.lastSalesman = {};
            vm.pharmacy = {};
            vm.lastPharmacy = {};
            vm.salesmanValue = [];
            vm.selloutTop = [];
            vm.salesmanQuantity = [];
            vm.topPharmacies = [];
            if (vm.filter.company == null && vm.filter.period == null && vm.filter.campaign == null && vm.filter.periodType == null && vm.filter.salesman == null) {
                return vm.clearFilter();
            }

            vm.fullFilterRequest = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null,
                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
            };
            var filterRequestNoCampaign = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
            };
            var filterRequestNoSalesman = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null,
                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
            };
            var filterRequestNoSalesmanNoPharmacy = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null
            };
            var filterRequestCampaignTypeNoPharmacy = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null
            };
            var filterRequestCampaignTypeAndPharmacy = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
            };
            var filterRequestCampaignTypeAndPharmacyAndSalesman = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
            };
            var filterRequestNoSalesmanNoCampaign = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
            };
            var filterRequestNoSalesmanNoCampaignNoPharmacy = {
                year: vm.filter.period != null ? vm.filter.period.year : null,
                month: vm.filter.period != null ? vm.filter.period.month : null,
                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null
            };
            if (vm.filter.company == null) {
                PharmaDashboard.querySelloutPharmacySalesman(filterRequestNoSalesmanNoCampaignNoPharmacy, function (result) {
                    vm.selloutTop = result;
                }, function (error) {
                });
            } else {
                PharmaDashboard.querySelloutPharmacySalesmanAndPharmacy(filterRequestNoSalesmanNoCampaign, function (result) {
                    vm.selloutTop = result;
                }, function (error) {
                });
            }

            if (vm.filter.campaign != null && vm.filter.company != null) {
                PharmaDashboard
                    .queryTopSalesmanByPharmacyAndCampaignOrderByValueList(filterRequestNoSalesman, function (resultP) {
                        vm.salesmanValue = resultP;
                    }, function (error) {
                    });

                PharmaDashboard
                    .queryTopSalesmanByPharmacyAndCampaignOrderByQuantityList(filterRequestNoSalesman, function (resultP) {
                        vm.salesmanQuantity = resultP;
                    }, function (error) {
                    });

            } else if (vm.filter.campaign != null && vm.filter.company == null) {
                PharmaDashboard.queryTopSalesmanByCampaignOrderByValueList(filterRequestNoSalesmanNoPharmacy, function (resultP) {
                    vm.salesmanValue = resultP;
                }, function (error) {
                });

                PharmaDashboard.queryTopSalesmanByCampaignOrderByQuantityList(filterRequestNoSalesmanNoPharmacy, function (resultP) {
                    vm.salesmanQuantity = resultP;
                }, function (error) {
                });

            } else if (vm.filter.campaign == null && vm.filter.company != null) {
                if (vm.filter.campaignType != null) {
                    PharmaDashboard.queryTopSalesmanByCampaignTypeAndPharmacyOrderByQuantityList(filterRequestCampaignTypeAndPharmacy, function (result) {
                        vm.salesmanQuantity = result;
                    }, function (error) {
                    });

                    PharmaDashboard.queryTopSalesmanByCampaignTypeAndPharmacyOrderByValueList(filterRequestCampaignTypeAndPharmacy, function (result) {
                        vm.salesmanValue = result;
                    }, function (error) {
                    });
                } else {
                    filterRequestCampaignTypeAndPharmacy.campaignType = "CHALLENGE";
                    PharmaDashboard.queryTopSalesmanByCampaignTypeAndPharmacyOrderByValueList(filterRequestCampaignTypeAndPharmacy, function (resultP) {
                        vm.salesmanValue = resultP;
                    }, function (error) {
                    });
                    filterRequestCampaignTypeAndPharmacy.campaignType = "PROMOTION";
                    PharmaDashboard.queryTopSalesmanByCampaignTypeAndPharmacyOrderByQuantityList(filterRequestCampaignTypeAndPharmacy, function (resultP) {
                        vm.salesmanQuantity = resultP;
                    }, function (error) {
                    });
                    filterRequestCampaignTypeAndPharmacy.campaignType = vm.filter.campaignType != null ? vm.filter.campaignType : null;
                }

            } else {
                if (vm.filter.campaignType != null) {
                    PharmaDashboard.queryTopSalesmanByCampaignTypeOrderByValueList(filterRequestCampaignTypeNoPharmacy, function (result) {
                        vm.salesmanValue = result;
                    }, function (error) {
                    });

                    PharmaDashboard.queryTopSalesmanByCampaignTypeOrderByQuantityList(filterRequestCampaignTypeNoPharmacy, function (result) {
                        vm.salesmanQuantity = result;
                    }, function (error) {
                    });
                } else {
                    filterRequestCampaignTypeNoPharmacy.campaignType = "CHALLENGE";
                    PharmaDashboard.queryTopSalesmanByCampaignTypeOrderByValueList(filterRequestCampaignTypeNoPharmacy, function (resultP) {
                        vm.salesmanValue = resultP;
                    }, function (error) {
                    });

                    filterRequestCampaignTypeNoPharmacy.campaignType = "PROMOTION";
                    PharmaDashboard.queryTopSalesmanByCampaignTypeOrderByQuantityList(filterRequestCampaignTypeNoPharmacy, function (resultP) {
                        vm.salesmanQuantity = resultP;
                    }, function (error) {
                    });

                    filterRequestCampaignTypeNoPharmacy.campaignType = vm.filter.campaignType != null ? vm.filter.campaignType : null;
                }
            }

            if (vm.filter.campaign != null) {
                PharmaDashboard.queryPharmacyByCampaignOrderByValue(filterRequestNoSalesmanNoPharmacy, function (resultP) {
                    vm.topPharmacies = resultP;
                    vm.maxPharmValue = resultP[0].meanValue;
                }, function (error) {
                });
            } else {
                if (vm.filter.campaignType != null) {
                    PharmaDashboard.queryPharmacyByCampaignTypeOrderByValue(filterRequestCampaignTypeNoPharmacy, function (result) {
                        vm.topPharmacies = result;
                        vm.maxPharmValue = result[0].meanValue;
                    }, function (error) {

                    })
                } else {
                    PharmaDashboard.querySelloutPharmacy(filterRequestNoSalesmanNoCampaignNoPharmacy, function (resultP) {
                        vm.topPharmacies = resultP;
                        vm.maxPharmValue = resultP[0].meanValue;
                    }, function (error) {
                    });
                }
            }

            if (vm.filter.campaign != null && vm.filter.company != null && vm.filter.salesman != null) {
                PharmaDashboard.querySalesmanByPharmacyAndCampaign(vm.fullFilterRequest, function (result) {
                    vm.salesman = result[0];
                    if (vm.filter.periodType.periodType == "FORTNIGHT2") {
                        vm.lastPeriodMonth = vm.filter.period.month;
                        vm.lastPeriodType = "FORTNIGHT1";

                        var lastPeriodFullFilter = {
                            year: vm.filter.period != null ? vm.filter.period.year : null,
                            month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                            periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                            campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                            campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null,
                            pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                            salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
                        };
                    } else if (vm.filter.periodType.periodType == "FORTNIGHT1") {
                        if (vm.filter.period.month == 1) {
                            vm.lastPeriodMonth = 12;
                            vm.lastYear = vm.filter.period.year - 1;
                        } else {
                            vm.lastPeriodMonth = vm.filter.period.month - 1;
                            vm.lastYear = vm.filter.period.year;
                        }

                        vm.lastPeriodType = "FORTNIGHT2";

                        var lastPeriodFullFilter = {
                            year: vm.lastYear != null ? vm.lastYear : null,
                            month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                            periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                            campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                            campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null,
                            pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                            salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
                        };
                    } else {
                        if (vm.filter.period.month - vm.filter.periodType.monthProportion < 1) {
                            vm.lastPeriodMonth = 13 - vm.filter.periodType.monthProportion;
                            vm.lastYear = vm.filter.period.year - 1;
                        } else {
                            vm.lastPeriodMonth = vm.filter.period.month - vm.filter.periodType.monthProportion;
                            vm.lastYear = vm.filter.period.year;
                        }

                        var lastPeriodFullFilter = {
                            year: vm.lastYear != null ? vm.lastYear : null,
                            month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                            periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                            campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                            campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null,
                            pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                            salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
                        };
                    }

                    PharmaDashboard.querySalesmanByPharmacyAndCampaign(lastPeriodFullFilter, function (result) {
                        vm.lastSalesman = result[0];
                    }, function (error) {
                    });
                }, function (error) {
                });
            } else if (vm.filter.campaign == null && vm.filter.company != null && vm.filter.salesman != null) {

                if (vm.filter.campaignType != null) {
                    PharmaDashboard.querySalesmanByPharmacyAndCampaignType(filterRequestCampaignTypeAndPharmacyAndSalesman, function (result) {
                        vm.salesman = result[0];
                        if (vm.filter.periodType.periodType == "FORTNIGHT2") {
                            vm.lastPeriodMonth = vm.filter.period.month;
                            vm.lastPeriodType = "FORTNIGHT1";

                            var lastPeriodfilterRequestCampaignTypeAndPharmacyAndSalesman = {
                                year: vm.filter.period != null ? vm.filter.period.year : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                                salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
                            };
                        } else if (vm.filter.periodType.periodType == "FORTNIGHT1") {
                            if (vm.filter.period.month == 1) {
                                vm.lastPeriodMonth = 12;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - 1;
                                vm.lastYear = vm.filter.period.year;
                            }

                            vm.lastPeriodType = "FORTNIGHT2";

                            var lastPeriodfilterRequestCampaignTypeAndPharmacyAndSalesman = {
                                year: vm.lastYear != null ? vm.lastYear : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                                salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
                            };
                        } else {
                            if (vm.filter.period.month - vm.filter.periodType.monthProportion < 1) {
                                vm.lastPeriodMonth = 13 - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year;
                            }

                            var lastPeriodfilterRequestCampaignTypeAndPharmacyAndSalesman = {
                                year: vm.lastYear != null ? vm.lastYear : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                                salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
                            };
                        }

                        PharmaDashboard.querySalesmanByPharmacy(lastPeriodfilterRequestCampaignTypeAndPharmacyAndSalesman, function (result) {
                            vm.lastSalesman = result[0];
                        }, function (error) {
                        });
                    }, function (error) {
                    });
                } else {
                    PharmaDashboard.querySalesmanByPharmacy(filterRequestNoCampaign, function (result) {
                        vm.salesman = result[0];
                        if (vm.filter.periodType.periodType == "FORTNIGHT2") {
                            vm.lastPeriodMonth = vm.filter.period.month;
                            vm.lastPeriodType = "FORTNIGHT1";

                            var lastPeriodfilterRequestNoCampaign = {
                                year: vm.filter.period != null ? vm.filter.period.year : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                                salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
                            };

                        } else if (vm.filter.periodType.periodType == "FORTNIGHT1") {
                            if (vm.filter.period.month == 1) {
                                vm.lastPeriodMonth = 12;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - 1;
                                vm.lastYear = vm.filter.period.year;
                            }

                            vm.lastPeriodType = "FORTNIGHT2";

                            var lastPeriodfilterRequestNoCampaign = {
                                year: vm.lastYear != null ? vm.lastYear : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                                salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
                            };
                        } else {
                            if (vm.filter.period.month - vm.filter.periodType.monthProportion < 1) {
                                vm.lastPeriodMonth = 13 - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year;
                            }

                            var lastPeriodfilterRequestNoCampaign = {
                                year: vm.lastYear != null ? vm.lastYear : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null,
                                salesmanCode: vm.filter.salesman != null ? vm.filter.salesman.salesmanDescription : null
                            };
                        }

                        PharmaDashboard.querySalesmanByPharmacy(lastPeriodfilterRequestNoCampaign, function (result) {
                            vm.lastSalesman = result[0];
                        }, function (error) {
                        });

                    }, function (error) {
                    });
                }
            }

            if (vm.filter.campaign != null && vm.filter.company != null) {
                PharmaDashboard
                    .queryPharmacyByCampaign(filterRequestNoSalesman, function (result) {
                        vm.pharmacy = result[0];
                        if (vm.filter.salesman == null) {
                            setSalesmanValues();
                        }
                        if (vm.filter.periodType.periodType == "FORTNIGHT2") {
                            vm.lastPeriodMonth = vm.filter.period.month;
                            vm.lastPeriodType = "FORTNIGHT1";

                            var lastPeriodPharmFilter = {
                                year: vm.filter.period != null ? vm.filter.period.year : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                                campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
                            };

                        } else if (vm.filter.periodType.periodType == "FORTNIGHT1") {
                            if (vm.filter.period.month == 1) {
                                vm.lastPeriodMonth = 12;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - 1;
                                vm.lastYear = vm.filter.period.year;
                            }

                            vm.lastPeriodType = "FORTNIGHT2";

                            var lastPeriodPharmFilter = {
                                year: vm.lastYear != null ? vm.lastYear : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                                campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
                            };
                        } else {
                            if (vm.filter.period.month - vm.filter.periodType.monthProportion < 1) {
                                vm.lastPeriodMonth = 13 - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year;
                            }

                            var lastPeriodPharmFilter = {
                                year: vm.lastYear != null ? vm.lastYear : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                                campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                                campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
                            };
                        }
                        PharmaDashboard.queryPharmacyByCampaign(lastPeriodPharmFilter, function (result) {
                            vm.lastPharmacy = result[0];
                            if (vm.filter.salesman == null) {
                                setSalesmanValues();
                            }
                        }, function (error) {
                        });
                    }, function (error) {
                    });

            } else if (vm.filter.campaign == null && vm.filter.company != null) {
                if (vm.filter.campaignType != null) {
                    PharmaDashboard.queryPharmacyByCampaignType(filterRequestCampaignTypeAndPharmacy, function (result) {
                        vm.pharmacy = result[0];
                        if (vm.filter.salesman == null) {
                            setSalesmanValues();
                        }
                        if (vm.filter.periodType.periodType == "FORTNIGHT2") {
                            vm.lastPeriodMonth = vm.filter.period.month;
                            vm.lastPeriodType = "FORTNIGHT1";

                            var lastPeriodPharmacyByCampaignType = {
                                year: vm.filter.period != null ? vm.filter.period.year : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
                            };
                        } else if (vm.filter.periodType.periodType == "FORTNIGHT1") {
                            if (vm.filter.period.month == 1) {
                                vm.lastPeriodMonth = 12;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - 1;
                                vm.lastYear = vm.filter.period.year;
                            }

                            vm.lastPeriodType = "FORTNIGHT2";

                            var lastPeriodPharmacyByCampaignType = {
                                year: vm.lastYear != null ? vm.lastYear : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
                            };
                        } else {
                            if (vm.filter.period.month - vm.filter.periodType.monthProportion < 1) {
                                vm.lastPeriodMonth = 13 - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year;
                            }

                            var lastPeriodPharmacyByCampaignType = {
                                year: vm.lastYear != null ? vm.lastYear : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
                            };
                        }

                        PharmaDashboard.queryPharmacyByCampaignType(lastPeriodPharmacyByCampaignType, function (result) {
                            vm.lastPharmacy = result[0];
                            if (vm.filter.salesman == null) {
                                setSalesmanValues();
                            }
                        }, function (error) {
                        });
                    }, function (error) {
                    });
                } else {
                    PharmaDashboard.queryPharmacyByPeriod(filterRequestNoSalesmanNoCampaign, function (result) {
                        vm.pharmacy = result[0];
                        if (vm.filter.salesman == null) {
                            setSalesmanValues();
                        }

                        if (vm.filter.periodType.periodType == "FORTNIGHT2") {
                            vm.lastPeriodMonth = vm.filter.period.month;
                            vm.lastPeriodType = "FORTNIGHT1";

                            var lastPeriodPharmFilter = {
                                year: vm.filter.period != null ? vm.filter.period.year : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
                            };

                        } else if (vm.filter.periodType.periodType == "FORTNIGHT1") {
                            if (vm.filter.period.month == 1) {
                                vm.lastPeriodMonth = 12;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - 1;
                                vm.lastYear = vm.filter.period.year;
                            }

                            vm.lastPeriodType = "FORTNIGHT2";

                            var lastPeriodPharmFilter = {
                                year: vm.lastYear != null ? vm.lastYear : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
                            };
                        } else {
                            if (vm.filter.period.month - vm.filter.periodType.monthProportion < 1) {
                                vm.lastPeriodMonth = 13 - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year;
                            }

                            var lastPeriodPharmFilter = {
                                year: vm.lastYear != null ? vm.lastYear : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                                pharmacyCode: vm.filter.company != null ? vm.filter.company.client : null
                            };
                        }

                        PharmaDashboard.queryPharmacyByPeriod(lastPeriodPharmFilter, function (result) {
                            vm.lastPharmacy = result[0];
                            if (vm.filter.salesman == null) {
                                setSalesmanValues();
                            }
                        }, function (error) {
                        });
                    }, function (error) {
                    });
                }
            } else if (vm.filter.company == null) {
                if (vm.filter.campaignType != null) {
                    if (vm.filter.campaign != null) {
                        PharmaDashboard.queryPharmacyByCampaignNoPharmacy(filterRequestNoSalesmanNoPharmacy, function (result) {
                            vm.pharmacy = result[0];
                            if (vm.filter.salesman == null) {
                                setSalesmanValues();
                            }

                            if (vm.filter.periodType.periodType == "FORTNIGHT2") {
                                vm.lastPeriodMonth = vm.filter.period.month;
                                vm.lastPeriodType = "FORTNIGHT1";

                                var lastPeriodByCampaign = {
                                    year: vm.filter.period != null ? vm.filter.period.year : null,
                                    month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                    periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                    campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                                    campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null
                                };

                            } else if (vm.filter.periodType.periodType == "FORTNIGHT1") {
                                if (vm.filter.period.month == 1) {
                                    vm.lastPeriodMonth = 12;
                                    vm.lastYear = vm.filter.period.year - 1;
                                } else {
                                    vm.lastPeriodMonth = vm.filter.period.month - 1;
                                    vm.lastYear = vm.filter.period.year;
                                }

                                vm.lastPeriodType = "FORTNIGHT2";

                                var lastPeriodByCampaign = {
                                    year: vm.filter.period != null ? vm.filter.period.year : null,
                                    month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                    periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                    campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                                    campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null
                                };

                            } else {
                                if (vm.filter.period.month - vm.filter.periodType.monthProportion < 1) {
                                    vm.lastPeriodMonth = 13 - vm.filter.periodType.monthProportion;
                                    vm.lastYear = vm.filter.period.year - 1;
                                } else {
                                    vm.lastPeriodMonth = vm.filter.period.month - vm.filter.periodType.monthProportion;
                                    vm.lastYear = vm.filter.period.year;
                                }

                                var lastPeriodByCampaign = {
                                    year: vm.filter.period != null ? vm.filter.period.year : null,
                                    month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                    periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                                    campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null,
                                    campaignCode: vm.filter.campaign != null ? vm.filter.campaign.id : null
                                };
                            }

                            PharmaDashboard.queryPharmacyByCampaignTypeNoPharmacy(lastPeriodByCampaign, function (result) {
                                vm.lastPharmacy = result[0];
                                if (vm.filter.salesman == null) {
                                    setSalesmanValues();
                                }
                            }, function (error) {
                            });
                        }, function (error) {
                        });
                    } else {
                        PharmaDashboard.queryPharmacyByCampaignTypeNoPharmacy(filterRequestCampaignTypeNoPharmacy, function (result) {
                            vm.pharmacy = result[0];
                            if (vm.filter.salesman == null) {
                                setSalesmanValues();
                            }

                            if (vm.filter.periodType.periodType == "FORTNIGHT2") {
                                vm.lastPeriodMonth = vm.filter.period.month;
                                vm.lastPeriodType = "FORTNIGHT1";

                                var lastPeriodByCampaignType = {
                                    year: vm.filter.period != null ? vm.filter.period.year : null,
                                    month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                    periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                    campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null
                                };

                            } else if (vm.filter.periodType.periodType == "FORTNIGHT1") {
                                if (vm.filter.period.month == 1) {
                                    vm.lastPeriodMonth = 12;
                                    vm.lastYear = vm.filter.period.year - 1;
                                } else {
                                    vm.lastPeriodMonth = vm.filter.period.month - 1;
                                    vm.lastYear = vm.filter.period.year;
                                }

                                vm.lastPeriodType = "FORTNIGHT2";

                                var lastPeriodByCampaignType = {
                                    year: vm.filter.period != null ? vm.filter.period.year : null,
                                    month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                    periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null,
                                    campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null
                                };

                            } else {
                                if (vm.filter.period.month - vm.filter.periodType.monthProportion < 1) {
                                    vm.lastPeriodMonth = 13 - vm.filter.periodType.monthProportion;
                                    vm.lastYear = vm.filter.period.year - 1;
                                } else {
                                    vm.lastPeriodMonth = vm.filter.period.month - vm.filter.periodType.monthProportion;
                                    vm.lastYear = vm.filter.period.year;
                                }

                                var lastPeriodByCampaignType = {
                                    year: vm.filter.period != null ? vm.filter.period.year : null,
                                    month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                    periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null,
                                    campaignType: vm.filter.campaignType != null ? vm.filter.campaignType : null
                                };
                            }

                            PharmaDashboard.queryPharmacyByCampaignTypeNoPharmacy(lastPeriodByCampaignType, function (result) {
                                vm.lastPharmacy = result[0];
                                if (vm.filter.salesman == null) {
                                    setSalesmanValues();
                                }
                            }, function (error) {
                            });
                        }, function (error) {
                        });
                    }
                } else {
                    PharmaDashboard.queryPharmacyByTimeNoPharmacy(filterRequestNoSalesmanNoCampaignNoPharmacy, function (result) {
                        vm.pharmacy = result[0];
                        if (vm.filter.salesman == null) {
                            setSalesmanValues();
                        }

                        if (vm.filter.periodType.periodType == "FORTNIGHT2") {
                            vm.lastPeriodMonth = vm.filter.period.month;
                            vm.lastPeriodType = "FORTNIGHT1";

                            var lastPeriodPharmFilterNoPharmacy = {
                                year: vm.filter.period != null ? vm.filter.period.year : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null
                            };

                        } else if (vm.filter.periodType.periodType == "FORTNIGHT1") {
                            if (vm.filter.period.month == 1) {
                                vm.lastPeriodMonth = 12;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - 1;
                                vm.lastYear = vm.filter.period.year;
                            }

                            vm.lastPeriodType = "FORTNIGHT2";

                            var lastPeriodPharmFilterNoPharmacy = {
                                year: vm.filter.period != null ? vm.filter.period.year : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.lastPeriodType != null ? vm.lastPeriodType : null
                            };

                        } else {
                            if (vm.filter.period.month - vm.filter.periodType.monthProportion < 1) {
                                vm.lastPeriodMonth = 13 - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year - 1;
                            } else {
                                vm.lastPeriodMonth = vm.filter.period.month - vm.filter.periodType.monthProportion;
                                vm.lastYear = vm.filter.period.year;
                            }

                            var lastPeriodPharmFilterNoPharmacy = {
                                year: vm.filter.period != null ? vm.filter.period.year : null,
                                month: vm.lastPeriodMonth != null ? vm.lastPeriodMonth : null,
                                periodType: vm.filter.periodType != null ? vm.filter.periodType.periodType : null
                            };
                        }

                        PharmaDashboard.queryPharmacyByTimeNoPharmacy(lastPeriodPharmFilterNoPharmacy, function (result) {
                            vm.lastPharmacy = result[0];
                            if (vm.filter.salesman == null) {
                                setSalesmanValues();
                            }
                        }, function (error) {
                        });
                    }, function (error) {
                    });
                }
            }

            $timeout(function () {
                vm.panelHeight = document.getElementById('pharmValuePanel').clientHeight;
                if (vm.panelHeight < 150) {
                    vm.panelHeight = 150;
                }
                vm.salesmanValuePanel = document.getElementById("salesmanValuePanel");
                vm.salesmanValuePanel.style.height = vm.panelHeight + 'px';
                vm.salesmanQuantityPanel = document.getElementById("salesmanQuantityPanel");
                vm.salesmanQuantityPanel.style.height = vm.panelHeight + 'px';
                vm.pharmValuePanel = document.getElementById('pharmValuePanel');
                vm.pharmValuePanel.style.height = vm.panelHeight + 'px';
                vm.pharmQuantityPanel = document.getElementById('pharmQuantityPanel');
                vm.pharmQuantityPanel.style.height = vm.panelHeight + 'px';
            }, 1250);
        }

        function setSalesmanValues() {
            vm.salesman.salesmanDescription = "Média " + vm.pharmacy.pharmacyDescription;
            vm.salesman.value = vm.pharmacy.meanValue;
            vm.salesman.quantity = vm.pharmacy.meanQuantity;
            vm.salesman.targetValue = vm.pharmacy.meanTargetValue;
            vm.salesman.targetQuantity = vm.pharmacy.meanTargetQuantity;

            vm.lastSalesman.salesmanDescription = "Média " + vm.lastPharmacy.pharmacyDescription;
            vm.lastSalesman.value = vm.lastPharmacy.meanValue;
            vm.lastSalesman.quantity = vm.lastPharmacy.meanQuantity;
            vm.lastSalesman.targetValue = vm.lastPharmacy.meanTargetValue;
            vm.lastSalesman.targetQuantity = vm.lastPharmacy.meanTargetQuantity;
        }

        $scope.loadPhotos = function (salesmanDes) {
            for (var i = 0; i < vm.allUsers.length; i++) {
                if (vm.allUsers[i].indicatorsName == salesmanDes) {
                    vm.tableUser = vm.allUsers[i];

                    if (vm.tableUser && vm.tableUser.thumbnailContentType) {
                        return vm.tableUser;
                    } else {
                        return null;
                    }
                }
            }
            return null;
        };

        $interval(function () {
            filterDashboard()
        }, 3600000);

        vm.openPopup = function (item) {
            $uibModal.open({
                templateUrl: 'app/entities/pharma-dashboard/pharma-dashboard-table-dialog.html',
                controller: 'PharmaDashboardTableDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    tableType: function () {
                        return item;
                    },
                    tableFilter: function () {
                        return vm.fullFilterRequest;
                    }
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaCovidDialogController', PharmaCovidDialogController);

    PharmaCovidDialogController.$inject = ['Notification', '$translate', '$uibModalInstance', 'startDate', 'endDate'];

    function PharmaCovidDialogController(Notification, $translate, $uibModalInstance, startDate, endDate) {
        var vm = this;
        vm.startDate = startDate;
        vm.endDate = endDate;

        vm.proceed = proceed;
        vm.clear = clear;

        function proceed() {
            if (vm.startDate == null || vm.endDate == null) {
                Notification.error({message: $translate.instant("pharmaPortalApp.pharmaCovid.form.emptyFields")});
            } else if (vm.startDate > vm.endDate) {
                Notification.error({message: $translate.instant("pharmaPortalApp.pharmaCovid.form.invalidInterval")});
            } else {
                $uibModalInstance.close({startDate: vm.startDate, endDate: vm.endDate});
            }
        }

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        vm.openDatePopup = function (i) {
            if (i == 1) { vm.datePopup1.opened = true; }
            else { vm.datePopup2.opened = true; }
        };

        vm.dateOptions = {formatYear: 'yyyy', startingDay: 1, showWeeks: false};
        vm.datePopup1 = {opened: false};
        vm.datePopup2 = {opened: false};
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('PharmaCovidDetailController', PharmaCovidDetailController);

    PharmaCovidDetailController.$inject = ['Notification', 'blockUI', '$http', '$translate', '$timeout', '$uibModal', 'PharmaCovid'];

    function PharmaCovidDetailController(Notification, blockUI, $http, $translate, $timeout, $uibModal, PharmaCovid) {
        var vm = this;
        vm.startDate = null;
        vm.endDate = null;

        vm.exportCSV = exportCSV;
        vm.intervalModal = intervalModal;
        vm.covidList = [];

        vm.loadAll = function () {
            if (vm.startDate == null || vm.endDate == null) {
                vm.intervalModal();
            }
        };
        vm.loadAll();

        function exportCSV() {
            $http.post("api/pharma-covid/toCsv", vm.covidList, {
                responseType: "arraybuffer"
            }).then(function successCallback(response) {
                var frmStartDate = moment(vm.startDate).format('YYYYMMDD');
                var frmEndDate = moment(vm.endDate).format('YYYYMMDD');

                var blob = new Blob([response.data], {
                    type: "text/csv"
                });
                saveAs(blob, "ReportCovid-" + frmStartDate + "-" + frmEndDate + ".csv");
                Notification.success({
                    message: "Relatório exportado com sucesso",
                    delay: 5000
                });
            }, function errorCallback() {
                Notification.error({
                    message: "Erro ao exportar relatório",
                    delay: ''
                });
            });
        }

        function intervalModal() {
            $uibModal.open({
                templateUrl: 'app/entities/pharma-covid/pharma-covid-dialog.html',
                controller: 'PharmaCovidDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    startDate: vm.startDate,
                    endDate: vm.endDate,
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pharmaCovid');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function (response) {
                blockUI.start($translate.instant('pharmaPortalApp.pharmaCovid.loading'));
                vm.startDate = response.startDate;
                vm.endDate = response.endDate;
                vm.covidList = PharmaCovid.query({startDate: moment(response.startDate).format('YYYYMMDD'), endDate: moment(response.endDate).format('YYYYMMDD')});

                vm.covidList.$promise.then(function () {
                    $timeout(function () {
                        blockUI.stop();
                    }, 250);
                }, function () {
                    $timeout(function () {
                        blockUI.stop();
                    }, 250);
                });
            }, function (error) {
                blockUI.stop();
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pharma-covid', {
            parent: 'entity',
            url: '/pharma-covid',
            data: {
                authorities: ['ROLE_INFARMED'],
                pageTitle: 'pharmaPortalApp.pharmaCovid.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pharma-covid/pharma-covid-detail.html',
                    controller: 'PharmaCovidDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaCovid');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaBalanceReportController', PharmaBalanceReportController);

	PharmaBalanceReportController.$inject = [ 'Notification', 'blockUI', 'period', '$uibModalInstance', '$scope', '$state', '$http', 'PortalSettings', '$translate', '$filter', '$timeout'];

	function PharmaBalanceReportController(Notification, blockUI, period, $uibModalInstance, $scope, $state, $http, PortalSettings, $translate, $filter, $timeout) {
		var vm = this;

		vm.settings = PortalSettings.query();
		
		vm.clear = clear;
		vm.prevCompany = prevCompany;
		vm.nextCompany = nextCompany;
		vm.loadAll = loadAll;
		vm.getScreenData = getScreenData;
		vm.exportToPdf = exportToPdf;
		vm.pdfTableArray = pdfTableArray;

		vm.curPharmacy = {};
		$scope.detailedProductInfoDialog = [];
		vm.detailedProductInfoList = [];
		$scope.pdfTableStructure = [];

		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function prevCompany() {
			var curIdx = vm.curPharmacy.selectedIndex;
			curIdx = curIdx - 1;
			if (curIdx < 0) {
				curIdx = $scope.pharmaciesSelector.length - 1;
			}
			vm.curPharmacy = $scope.pharmaciesSelector[curIdx]
			vm.curPharmacy.selectedIndex = curIdx;
			
			vm.getScreenData(vm.curPharmacy);
		}
		
		function nextCompany() {
			var curIdx = vm.curPharmacy.selectedIndex;
			curIdx = curIdx + 1;
			if (curIdx == $scope.pharmaciesSelector.length) {
				curIdx = 0;
			}
			vm.curPharmacy = $scope.pharmaciesSelector[curIdx]
			vm.curPharmacy.selectedIndex = curIdx;
			
			vm.getScreenData(vm.curPharmacy);
		}

		vm.loadAll();
		function loadAll() {
			// GET DISTINCT COMPANIES FOR PERIOD
			$http.get("api/pharma-balance/getDistinctCompanyForPeriod/" + period.period).then(function(result) {
				$scope.pharmaciesSelector = result.data;
				vm.curPharmacy = $scope.pharmaciesSelector[$scope.pharmaciesSelector.length - 1];
				vm.curPharmacy.selectedIndex = $scope.pharmaciesSelector.length - 1;
				vm.getScreenData(vm.curPharmacy);
			});
		}

		function getScreenData(curPharmacy) {
			blockUI.start($translate.instant('pharmaPortalApp.pharmaBalance.message.screenData.loading'));
			
			$scope.detailedProductInfoDialog = [];
			
			var myFilter = [];
			if (vm.curPharmacy.warehouse === '999') {
				myFilter.push('999');
			} else {
				myFilter.push(vm.curPharmacy.pharmaWarehouse);
			}

			// GET PHARMACY INFO FOR PERIOD
			$http.get("api/pharma-balance/getDetailedProductInfoByPeriod/" + period.period, {
				params : { pharmacies : myFilter, products : [] }
			}).then(function(result) {
				vm.detailedProductInfoList = result.data;
				
				vm.pdfTableArray();
				$scope.loadMoreItems();
				blockUI.stop();
			}, function(result) {
				blockUI.stop();
			});
		}

		$scope.loadMoreItems = function() {
			var i = 0;
			if(vm.detailedProductInfoList.length > 0) {
				angular.forEach(vm.detailedProductInfoList, function(value, key) {
					if (i < 15) {
						$scope.detailedProductInfoDialog.push(value);
						vm.detailedProductInfoList = vm.detailedProductInfoList.slice(1,vm.detailedProductInfoList.length);
					}
					i++;
				});
			}
			jQuery(".table-dialog .jh-table").floatThead('reflow');
		};
		
		function exportToPdf() {
			blockUI.start($translate.instant('pharmaPortalApp.pharmaBalance.message.screenData.generatingPdf'));
			
			$timeout(function() {
				var docDefinition = {
					pageSize : 'A4', // a string or { width: number, height: number }
					pageOrientation : 'landscape', // by default we use portrait, you can change it to landscape if you wish
					pageMargins : [ 20, 25, 20, 25 ], // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
					defaultStyle : {
						columnGap : 15
					},
					footer : function(currentPage, pageCount) {
						if (currentPage != 1) {
							return {
								columns : [ {
									width : '*',
									text : 'Relatório de movimentos da farmácia ' + vm.curPharmacy.naming + ' no período ' + period.period,
									alignment : 'left', fontSize : 8, margin : [ 20, 5, 0, 0 ]
								}, {
									width : 200,
									text : 'Pág. ' + currentPage.toString() + ' de ' + pageCount,
									alignment : 'right', fontSize : 8, margin : [ 0, 5, 20, 0 ]
								} ]
							};
						} else {
							return { text : '' };
						}
					},
					styles : {
						tableHeader : {
							alignment : 'center', fontSize : 8, bold : true
						},
						content : {
							fontSize : 8
						}
					},
					content : [ {
						columns : [ {
							width : 200,
							image : 'data:' + vm.settings.logoContentType + ';base64,' + vm.settings.logo
						}, {
							width : '*',
							text : ''
						}, {
							width : 200,
							stack : [ vm.curPharmacy.naming, vm.curPharmacy.address, vm.curPharmacy.zipCode + '-' + vm.curPharmacy.zipLocal, 'NIF: ' + vm.curPharmacy.nif, ]
						} ]
					}, {
						text : 'Relatório de Movimentos no período ' + period.period,
						fontSize : 12,
						margin : [ 0, 10, 0, 10 ]
					}, {
						style : 'content',
						table : {
							widths : [ 175, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35, 35 ],
							headerRows : 2,
							keepWithHeaderRows : 2,
							body : $scope.pdfTableStructure
						}
					} ]
				};
			
				pdfMake.createPdf(docDefinition).download('Report_F' + vm.curPharmacy.client + '_P' + period.period + '.pdf', function() {
					$scope.$apply(function() {
						blockUI.stop();
					});
				});
			}, 500);
		}
		
		function pdfTableArray() {
			$scope.pdfTableStructure = [];
			$scope.pdfTableStructure.push([ {},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.previousPeriodBalance'), style : 'tableHeader', colSpan : 2}, {},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.purchases'), style : 'tableHeader', colSpan : 2}, {},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.initialAndPurchases'), style : 'tableHeader', colSpan : 3}, {}, {},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.sales'), style : 'tableHeader',	colSpan : 2}, {},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.adjustment'), style : 'tableHeader', colSpan : 2}, {},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.nextPeriodBalance'), style : 'tableHeader', colSpan : 3}, {}, {}
			]);

			$scope.pdfTableStructure.push([
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.form.product'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.units'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.price'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.units'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.price'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.units'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.price'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.total'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.units'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.price'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.diff'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.total'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.units'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.price'), style : 'tableHeader'},
				{text : $translate.instant('pharmaPortalApp.pharmaBalance.table.total'), style : 'tableHeader'}
			]);

			angular.forEach(vm.detailedProductInfoList, function(value, key) {
				if(value.productCnp != "999999999"){
					return $scope.pdfTableStructure.push([
						{text : value.productCnp + ' - ' + value.productDesc},
						{text : value.previousBalanceQuantity, alignment : 'right'},
						{text : $filter('currency')(value.previousBalanceUnit, "€", 2), alignment : 'right'},
						{text : value.purchasesQuantity, alignment : 'right'},
						{text : $filter('currency')(value.purchasesUnit, "€", 2), alignment : 'right'},
						{text : value.initialBalanceQuantity, alignment : 'right'},
						{text : $filter('currency')(value.initialBalanceUnit, "€", 2), alignment : 'right'},
						{text : $filter('currency')(value.initialBalanceTotal, "€", 2), alignment : 'right'},
						{text : value.salesQuantity, alignment : 'right'},
						{text : $filter('currency')(value.salesUnit, "€", 2), alignment : 'right'},
						{text : $filter('currency')(value.adjustmentBalance, "€", 2), alignment : 'right'},
						{text : $filter('currency')(value.adjustmentTotal, "€", 2), alignment : 'right'},
						{text : value.remainBalanceQuantity, alignment : 'right'},
						{text : $filter('currency')(value.remainBalanceUnit, "€", 2), alignment : 'right'},
						{text : $filter('currency')(value.remainBalanceTotal, "€", 2), alignment : 'right'}
					]);
				} else {
					return $scope.pdfTableStructure.push([
						{text : 'TOTAIS', alignment : 'right'},
						{text : value.previousBalanceQuantity, alignment : 'right'},
						{text : $filter('currency')(0, "€", 2), alignment : 'right'},
						{text : value.purchasesQuantity, alignment : 'right'},
						{text : $filter('currency')(value.purchasesUnit, "€", 2), alignment : 'right'},
						{text : value.initialBalanceQuantity, alignment : 'right'},
						{text : $filter('currency')(0, "€", 2), alignment : 'right'},
						{text : $filter('currency')(value.initialBalanceTotal, "€", 2), alignment : 'right'},
						{text : value.salesQuantity, alignment : 'right'},
						{text : $filter('currency')(value.salesUnit, "€", 2), alignment : 'right'},
						{text : $filter('currency')(value.adjustmentBalance, "€", 2), alignment : 'right'},
						{text : $filter('currency')(value.adjustmentTotal, "€", 2), alignment : 'right'},
						{text : value.remainBalanceQuantity, alignment : 'right'},
						{text : $filter('currency')(0, "€", 2), alignment : 'right'},
						{text : $filter('currency')(value.remainBalanceTotal, "€", 2), alignment : 'right'}
					]);
				}
			});
			return $scope.pdfTableStructure;
		}
		
		$scope.floatTheadOptions5 = {
			position : 'absolute',
			scrollContainer : function($table) {
				return $table.closest(".table-responsive5");
			}
		};
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaBalanceConfirmController', PharmaBalanceConfirmController);

	PharmaBalanceConfirmController.$inject = [ 'Notification', 'blockUI', '$uibModalInstance', '$http', '$translate', '$filter', 'period' ];

	function PharmaBalanceConfirmController(Notification, blockUI, $uibModalInstance, $http, $translate, $filter, period) {
		var vm = this;

		vm.currentPeriod = period.period;
		vm.orderDate = new Date();
		
		vm.clear = clear;
		vm.confirmCloseMonth = confirmCloseMonth;
		
		function clear() {
			$uibModalInstance.dismiss("cancel");
		}

		function confirmCloseMonth() {
			var suggestedDate = new Date(vm.currentPeriod);
			suggestedDate = new Date(suggestedDate.getFullYear(), suggestedDate.getMonth() + 1, 0);
			
			var period = $filter('date')(vm.currentPeriod, "yyyy'-'MM");
			
			if(vm.orderDate >= suggestedDate) {
				$http.get("api/pharma-balance/closeMonth/" + period, {
					params : { orderDate : vm.orderDate }
				}).then(function(result) {
					Notification.success({message : $translate.instant('pharmaPortalApp.pharmaBalance.message.closeMonth.success'), delay : 5000});
					blockUI.stop();
					$uibModalInstance.close(period);
				}, function(result) {
					Notification.error({message : $translate.instant('pharmaPortalApp.pharmaBalance.message.closeMonth.error'), delay : ''});
					blockUI.stop();
					$uibModalInstance.dismiss("cancel");
				});
			} else {
				Notification.error({message : $translate.instant('pharmaPortalApp.pharmaBalance.message.closeMonth.badDate'), delay : ''});
			}
		}
		
		vm.datePopup = { opened : false };
		vm.openDatePopup = function() { vm.datePopup.opened = true; };
		vm.dateOptions = { formatYear : 'yyyy', startingDay : 1, showWeeks : false };
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('pharma-balance', {
			parent : 'entity',
			url : '/pharma-balance',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ],
				pageTitle : 'pharmaPortalApp.pharmaBalance.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/pharma-balance/pharma-balances.html',
					controller : 'PharmaBalanceController',
					controllerAs : 'vm'
				}
			},
			params : {
				workingPeriod : null
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('pharmaBalance');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('pharma-balance.report', {
			parent : 'pharma-balance',
			url : '/report/{period}',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-balance/pharma-balance-report-dialog.html',
					controller : 'PharmaBalanceReportController',
					controllerAs : 'vm',
					size : 'lg modal-exl',
					resolve : {
						period : function() {
							return {
								period : $stateParams.period
							};
						}
					}
				}).result.then(function() {
					$state.go('pharma-balance', null, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('pharma-balance.closeMonth', {
			parent : 'pharma-balance',
			url : '/closeMonth/{period}',
			data : {
				authorities : [ 'ROLE_ADMIN', 'ROLE_INTRANET' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/pharma-balance/pharma-balance-confirm-dialog.html',
					controller : 'PharmaBalanceConfirmController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						period : function() {
							return {
								period : $stateParams.period
							};
						}
					}
				}).result.then(function() {
					$state.go('pharma-balance', {workingPeriod : $stateParams.period}, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		});
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PharmaBalanceController', PharmaBalanceController);

	PharmaBalanceController.$inject = [ 'Notification', 'blockUI', '$q', '$translate', '$stateParams', '$state', '$timeout', '$scope', '$http', '$filter', 'ModuleSettings', 'ProductCurrentAccountLock' ];

	function PharmaBalanceController(Notification, blockUI, $q, $translate, $stateParams, $state, $timeout, $scope, $http, $filter, ModuleSettings, ProductCurrentAccountLock) {
		var vm = this;
		vm.productCurrentAccountLocks = ProductCurrentAccountLock.query();
		vm.currentPeriod = $stateParams.workingPeriod;
		vm.curPeriod = new Date();
		
		vm.loadAll = loadAll;
		vm.isMonthClosed = isMonthClosed;
		vm.getFirstOpenPeriod = getFirstOpenPeriod;
		vm.prepareFilter = prepareFilter;
		vm.getTab1Content = getTab1Content;
		vm.getTab2Content = getTab2Content;
		vm.getTab3Content = getTab3Content;
		
		vm.closeMonth = closeMonth;
		vm.prevPeriod = prevPeriod;
		vm.nextPeriod = nextPeriod;
		vm.doFilter = doFilter;
		
		vm.prodFilter = "0";
		vm.currentTab = 1;
		vm.monthIsLock = false;
		vm.lastQuery = "";
		vm.products = [];
		vm.filter = [];
		vm.filter.pharmacies = [];	
		vm.filter.products = [];
		vm.curPharmaciesSelector = [];
		vm.curProductsSelector = [];
		
		$scope.detailedProductInfo = [];
		vm.detailedProductInfoList = [];
		
		vm.loadAll();

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.balanceModule) {
					$state.go('accessdenied');
				} else {
					vm.getFirstOpenPeriod();

					$http.get("api/pharma-balance/getDistinctCompany").then(function(result) {
						vm.curPharmaciesSelector = result.data;
					});
					
					$http.get("api/pharma-balance/getDistinctProduct").then(function(result) {
						angular.forEach(result.data, function(value, key) {
							vm.curProductsSelector.push({'cnp' : value[0], 'desc' : value[1]});
						});
					});
				}
			});
		}
		
		function isMonthClosed() {
			var period = $filter('date')(vm.currentPeriod, "yyyy'-'MM");
			if(vm.productCurrentAccountLocks != null && vm.productCurrentAccountLocks.period >= period) { vm.monthIsLock = true; }
			else { vm.monthIsLock = false; }
		}
		
		function getFirstOpenPeriod() {
			if($stateParams.workingPeriod != null) {
				vm.curPeriod = $stateParams.workingPeriod;
				vm.currentPeriod = new Date(vm.curPeriod);
			} else {
				if(vm.productCurrentAccountLocks.id != null){
					var period2 = new Date(vm.productCurrentAccountLocks.period);
					period2.setMonth(period2.getMonth() + 1);
					vm.currentPeriod = period2;
				} else {
					vm.currentPeriod = new Date();
				}
				vm.curPeriod = $filter('date')(vm.currentPeriod, "yyyy'-'MM");
			}
			
		    var q1 = vm.prepareFilter();
		    var q2 = vm.isMonthClosed();
			
			$q.all([q1, q2]).then(function () {
				if(vm.currentTab == 1) {
					vm.getTab1Content();
				} else if(vm.currentTab == 2) {
					vm.getTab2Content();
				} else {
					vm.getTab3Content();
				}
			});


			return true;
		}
		
		function prepareFilter(){
			vm.myFilter = [];
			vm.myFilter.pharmacies = [];
			vm.myFilter.products = [];
			
			angular.forEach(vm.filter.pharmacies, function(value, key) {
				if(value.warehouse === '999') { vm.myFilter.pharmacies.push('999'); } 
				else { vm.myFilter.pharmacies.push(value.pharmaWarehouse); }
			});
			
			angular.forEach(vm.filter.products, function(value, key) {
				vm.myFilter.products.push(value.cnp);
			});
		}
		
		function getTab1Content(){
			vm.currentTab = 1;
			blockUI.start($translate.instant('pharmaPortalApp.pharmaBalance.message.screenData.loading'));
			vm.prepareFilter();

			$http.get("api/pharma-balance/getGlobalInfoByPeriod/" + $filter('date')(vm.currentPeriod, "yyyy'-'MM"), {
				params: {pharmacies: vm.myFilter.pharmacies, products : vm.myFilter.products }
			}).then(function(result) {
				// LABELS DOS PERIODOS
				$scope.chartConfig.xAxis.categories = result.data["xAxisLabels"];
				// SERIES DO GRÁFICO
				$scope.chartSeries = [
					{ name: "Saídas", data: result.data["xAxisData"]["salesSerie"] },
					{ name: "Custo Vendas", data: result.data["xAxisData"]["salesCostSerie"] },
					{ name: "Acerto", data: result.data["xAxisData"]["adjustmentsSerie"] },
					{ name: "Margem", data: result.data["xAxisData"]["marginSerie"] },
					{ name: "Rácio Vendas/Total Stock", data: result.data["xAxisData"]["ratioSerie"] }
				];
				$scope.chartConfig.series = $scope.chartSeries;
				$scope.globalValues = result.data["treeGlobalMap"];
				blockUI.stop();
			}, function(result) {
				blockUI.stop();
			});
		}
		
		function getTab2Content() {
			vm.currentTab = 2;
			blockUI.start($translate.instant('pharmaPortalApp.pharmaBalance.message.screenData.loading'));
			vm.prepareFilter();
			
			$http.get("api/pharma-balance/getDetailedPharmacyInfoByPeriod/" + $filter('date')(vm.currentPeriod, "yyyy'-'MM"), {
				params: {pharmacies: vm.myFilter.pharmacies, products : vm.myFilter.products }
			}).then(function(result) {
				$scope.detailedPharmacyInfo = result.data;
				blockUI.stop();
			}, function(result) {
				blockUI.stop();
			});
		}
		
		function getTab3Content() {
			vm.currentTab = 3;
			blockUI.start($translate.instant('pharmaPortalApp.pharmaBalance.message.screenData.loading'));
			vm.prepareFilter();

			$scope.detailedProductInfo = [];
			
			$http.get("api/pharma-balance/getDetailedProductInfoByPeriod/" + $filter('date')(vm.currentPeriod, "yyyy'-'MM"), {
				params: {pharmacies: vm.myFilter.pharmacies, products : vm.myFilter.products, movementType : vm.prodFilter }
			}).then(function(result) {
				vm.detailedProductInfoList = result.data;
				$scope.loadMore();
				jQuery(".productsTable.jh-table").floatThead('reflow');
				blockUI.stop();
			}, function(result) {
				blockUI.stop();
			});
		}
		
		$scope.loadMore = function() {
			var i = 0;
			if(vm.detailedProductInfoList.length > 0) {
				
				angular.forEach(vm.detailedProductInfoList, function(value, key) {
					if (i < 15) {
						$scope.detailedProductInfo.push(value);
//						vm.detailedProductInfoList.splice(0,1);
						vm.detailedProductInfoList = vm.detailedProductInfoList.slice(1,vm.detailedProductInfoList.length);
					}
					i++;
				});
			}
		};

		function closeMonth() {
			blockUI.start($translate.instant('pharmaPortalApp.pharmaBalance.message.closeMonth.loading'));
			
			var period = $filter('date')(vm.currentPeriod, "yyyy'-'MM");
			$http.get("api/basic/product-current-account/calculate/?period=" + period).then(function(result) {
				Notification.success({message: $translate.instant('pharmaPortalApp.pharmaBalance.message.closeMonth.success'), delay: 5000});
				blockUI.stop();
			}, function(result) {
				Notification.error({message: $translate.instant('pharmaPortalApp.pharmaBalance.message.closeMonth.error'), delay: ''});
				blockUI.stop();
			});
		}
		
		function prevPeriod() {
			vm.currentPeriod.setMonth(vm.currentPeriod.getMonth() - 1);
			vm.curPeriod = $filter('date')(vm.currentPeriod, "yyyy'-'MM");
			vm.isMonthClosed();
			
			if(vm.currentTab == 1) {
				vm.getTab1Content();
			} else if(vm.currentTab == 2) {
				vm.getTab2Content();
			} else {
				vm.getTab3Content();
			}
		}

		function nextPeriod(){
			vm.currentPeriod.setMonth(vm.currentPeriod.getMonth() + 1);
			vm.curPeriod = $filter('date')(vm.currentPeriod, "yyyy'-'MM");
			vm.isMonthClosed();
			
			if(vm.currentTab == 1) {
				vm.getTab1Content();
			} else if(vm.currentTab == 2) {
				vm.getTab2Content();
			} else {
				vm.getTab3Content();
			}
		}
		
		function doFilter($item, $model) {
			if(vm.currentTab == 1) {
				vm.getTab1Content();
			} else if(vm.currentTab == 2) {
				vm.getTab2Content();
			} else {
				vm.getTab3Content();
			}
		}
		
		$scope.refreshSelectModel = function(query) {
			if (vm.lastQuery != query) {
				vm.lastQuery = query
				
				if (vm.products.length > 250) {
					Notification.warning({message: "O número de resultados é superior a 250 registos. Por questões de performance, refine a sua pesquisa", delay: 5000});
					return;
				} else {
					var cnps= $filter('filter')(vm.curProductsSelector, {cnp: query})
					var descs = $filter('filter')(vm.curProductsSelector, {desc: query})
					angular.extend(vm.products, cnps);
					angular.extend(vm.products, descs);
				}
			}
		};
		
		$scope.chartConfig = {
			credits: { enabled: false },
			chart : { type : 'column' },
			title : { text : '' },
			subtitle: { text: '' },
			xAxis: { categories: [] },
			yAxis : { title: { text: '' } },
		    series : null,
		    legend : { borderColor: 'rgb(204, 214, 235)', borderWidth: 1, backgroundColor: '#f2f2f2' }
		}
		
		$scope.floatTheadOptions1 = {position : 'absolute', responsiveContainer : function($table) {return $table.closest(".table-responsive1");}};
		$scope.floatTheadOptions2 = {position : 'absolute', responsiveContainer : function($table) {return $table.closest(".table-responsive2");}};
		$scope.floatTheadOptions3 = {position : 'absolute', responsiveContainer : function($table) {return $table.closest(".table-responsive3");}};
		$scope.floatTheadOptions4 = {position : 'absolute', responsiveContainer : function($table) {return $table.closest(".table-responsive4");}};
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('entity', {
			abstract : true,
			parent : 'app'
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('CompanyDialogController', CompanyDialogController);

	CompanyDialogController.$inject = [ 'Notification', '$uibModalInstance', '$timeout', '$translate', 'entity', 'Company'];

	function CompanyDialogController(Notification, $uibModalInstance, $timeout, $translate, entity, Company) {
		var vm = this;

		vm.company = entity;

        vm.param = {
            companyId:vm.company.id
        };

        vm.schedule = {
            workingDayDisabled: false,
            saturdayDisabled: false,
            sundayDisabled: false,
            holidayDisabled: false
        };

		vm.clear = clear;
		vm.save = save;

        Company.getCompanySchedule(vm.param, function (result) {
            if (result.workingDayDisabled != null) {
                vm.schedule=result;
            }
        }, function (error) {
        });

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			vm.isSaving = true;
			if (vm.company.id !== null) {
			    if (vm.schedule.company == null) {
			        vm.schedule.company = vm.company;
                }
				Company.update(vm.company, onSaveSuccess, onSaveError);
				Company.saveCompanySchedule(JSON.stringify(vm.schedule), onSaveSuccess, onSaveError);
			} else {
				Notification.error({
					message : $translate.instant('pharmaPortalApp.company.message.errorUpdating'),
					delay : ''
				});
			}
		}

		function onSaveSuccess(result) {
			vm.isSaving = false;
			Notification.success({
				message : $translate.instant('pharmaPortalApp.company.message.updated'),
				delay : 5000
			});
			$uibModalInstance.close(result);
		}

		function onSaveError() {
			vm.isSaving = false;
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('CompanyDetailController', CompanyDetailController);

	CompanyDetailController.$inject = [ 'previousState', 'entity', 'Company' ];

	function CompanyDetailController(previousState, entity, Company) {
		var vm = this;

        vm.schedule = {};
		vm.company = entity;
		vm.previousState = previousState.name;
		vm.param = {
		    companyId:vm.company.id
        };

        Company.getCompanySchedule(vm.param, function (result) {
            vm.schedule=result;
        }, function (error) {
        });
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('company', {
			parent : 'entity',
			url : '/company?page&sort&search',
			data : {
				authorities : [ 'ROLE_ADMIN' ],
				pageTitle : 'pharmaPortalApp.company.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/company/companies.html',
					controller : 'CompanyController',
					controllerAs : 'vm'
				}
			},
			params : {
				page : {
					value : '1',
					squash : true
				},
				sort : {
					value : 'id,asc',
					squash : true
				},
				search : null
			},
			resolve : {
				pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
					return {
						page : PaginationUtil.parsePage($stateParams.page),
						sort : $stateParams.sort,
						predicate : PaginationUtil.parsePredicate($stateParams.sort),
						ascending : PaginationUtil.parseAscending($stateParams.sort),
						search : $stateParams.search
					};
				} ],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('company');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('company-detail', {
			parent : 'entity',
			url : '/company/{id}',
			data : {
				authorities : [ 'ROLE_ADMIN' ],
				pageTitle : 'pharmaPortalApp.company.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/company/company-detail.html',
					controller : 'CompanyDetailController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('company');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'Company', function($stateParams, Company) {
					return Company.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'company',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		}).state('company.edit', {
			parent : 'company',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/company/company-dialog.html',
					controller : 'CompanyDialogController',
					controllerAs : 'vm',
					backdrop : 'static',
					size : 'md',
					resolve : {
						entity : [ 'Company', function(Company) {
							return Company.get({
								id : $stateParams.id
							}).$promise;
						} ]
					}
				}).result.then(function() {
					$state.go('company', {}, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('company-detail.edit', {
			parent : 'company-detail',
			url : '/detail/edit',
			data : {
				authorities : [ 'ROLE_USER' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/company/company-dialog.html',
					controller : 'CompanyDialogController',
					controllerAs : 'vm',
					backdrop : 'static',
					size : 'md',
					resolve : {
						entity : [ 'Company', function(Company) {
							return Company.get({
								id : $stateParams.id
							}).$promise;
						} ]
					}
				}).result.then(function() {
					$state.go('^', {}, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		});
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('CompanyController', CompanyController);

	CompanyController.$inject = [ 'Notification', '$state', 'Company', 'ParseLinks', 'paginationConstants', 'pagingParams', '$http', '$translate' ];

	function CompanyController(Notification, $state, Company, ParseLinks, paginationConstants, pagingParams, $http, $translate) {
		var vm = this;

		vm.loadPage = loadPage;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
		vm.synch = synch;

		vm.clear = clear;
		vm.search = search;
		vm.loadAll = loadAll;
		vm.searchQuery = pagingParams.search;
		vm.currentSearch = pagingParams.search;

		loadAll();

		function loadAll() {
			Company.query({
				query : vm.searchQuery ? vm.searchQuery : "",
				page : pagingParams.page - 1,
				size : vm.itemsPerPage
			}, onSuccess, onError);
			function onSuccess(data, headers) {
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				vm.companies = data;
				angular.forEach(vm.companies, function (item) {
                    item.client = parseInt(item.client, 10);
                    if(item.pharmaWarehouse) {
                        item.pharmaWarehouse = parseInt(item.pharmaWarehouse, 10);
                    }
                    if(item.warehouse) {
                        item.warehouse = parseInt(item.warehouse, 10);
                    }
                });
				vm.page = pagingParams.page;
				vm.searchQuery = pagingParams.search;
			}
			function onError(error) {
				Notification.error({
					message : error.data.message,
					delay : ''
				});
			}
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page : vm.page,
				search : vm.currentSearch
			});
		}

		function search() {
			if (!vm.searchQuery) {
				return vm.clear();
			}
			vm.links = null;
			vm.page = 1;
			vm.currentSearch = vm.searchQuery;
			vm.searchQuery = vm.searchQuery;
			vm.transition();
		}

		function clear() {
			vm.links = null;
			vm.page = 1;
			vm.currentSearch = null;
			vm.transition();
		}

		function synch() {
			$http.get('api/companies/synch').then(function(result) {
				if (result.status === 200) {
					Notification.success({ message : $translate.instant(result.headers("X-pharmaPortalApp-alert")), delay : 5000 });
				} else {
					Notification.error({ message : $translate.instant(result.headers("X-pharmaPortalApp-alert")), delay : '' });
				}
				vm.clear();
				loadAll();
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('CampaignProductNewDialogController', CampaignProductNewDialogController);

	CampaignProductNewDialogController.$inject = ['Notification', '$uibModalInstance', '$stateParams', 'entity', 'Campaign', 'CampaignProduct', '$translate', '$state', 'ModuleSettings' ];

	function CampaignProductNewDialogController(Notification, $uibModalInstance, $stateParams, entity, Campaign, CampaignProduct, $translate, $state, ModuleSettings) {
		var vm = this;

		vm.campaign = Campaign.get({ id : $stateParams.id });
		vm.campaignProduct = entity;

		vm.clear = clear;
		vm.save = save;
		vm.validateCampaignProduct = validateCampaignProduct;
		vm.loadAll = loadAll;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;
				
				if (!vm.moduleSettings.campaignsModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
		
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			if (validateCampaignProduct()) {
				vm.isSaving = true;
				if (vm.campaignProduct.id !== null) {
					CampaignProduct.update(vm.campaignProduct, onSaveSuccess, onSaveError);
				} else {
					vm.campaignProduct.campaign = vm.campaign;
					CampaignProduct.save(vm.campaignProduct, onSaveSuccess, onSaveError);
				}
			}
		}

		function onSaveSuccess(result) {
			vm.isSaving = false;
			Notification.success({ message : $translate.instant("pharmaPortalApp.campaignProduct.created"), delay : 5000 });
			$state.go("campaign.edit", { id : vm.campaign.id }, { reload : true });
			$uibModalInstance.close(result);
		}

		function onSaveError() {
			vm.isSaving = false;
			Notification.error({ message : $translate.instant("pharmaPortalApp.campaignProduct.error.create"), delay : '' });
		}

		function validateCampaignProduct() {
			var errors = [];
			// CNP
			if (vm.campaignProduct.cnp === null || vm.campaignProduct.cnp === '') {
				errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.empty.cnp'));
			}
			// DESCRIPTION
			if (vm.campaignProduct.description === null || vm.campaignProduct.description === '') {
				errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.empty.description'));
			}

			if (vm.campaign.campaignType === 'CHALLENGE') {
				// TARGET AMOUNT
				if (vm.campaignProduct.targetAmount === null || vm.campaignProduct.targetAmount === '') {
					errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.empty.targetAmount'));
				} else {
					if (!angular.isNumber(vm.campaignProduct.targetAmount) || isNaN(vm.campaignProduct.targetAmount)) {
						errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.numeric.targetAmount'));
					} else if (vm.campaignProduct.targetAmount <= 0) {
						errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.belowZero.targetAmount'));
					}
				}
				// REFERENCE PRICE
				if (vm.campaignProduct.referencePrice === null || vm.campaignProduct.referencePrice === '') {
					errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.empty.referencePrice'));
				} else {
					if (!angular.isNumber(vm.campaignProduct.referencePrice) || isNaN(vm.campaignProduct.referencePrice)) {
						errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.numeric.referencePrice'));
					} else if (vm.campaignProduct.referencePrice <= 0) {
						errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.belowZero.referencePrice'));
					}
				}
			} else {
				// TARGET AMOUNT
				if (vm.campaignProduct.targetAmount !== null && vm.campaignProduct.targetAmount !== '' && !isNaN(vm.campaignProduct.targetAmount)) {
					if (!angular.isNumber(vm.campaignProduct.targetAmount) || isNaN(vm.campaignProduct.targetAmount)) {
						errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.numeric.targetAmount'));
					} else if (vm.campaignProduct.targetAmount <= 0) {
						errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.belowZero.targetAmount'));
					}
				} else {
					vm.campaignProduct.targetAmount = null;
				}
				// REFERENCE PRICE
				if (vm.campaignProduct.referencePrice !== null && vm.campaignProduct.referencePrice !== '' && !isNaN(vm.campaignProduct.referencePrice)) {
					if (!angular.isNumber(vm.campaignProduct.referencePrice) || isNaN(vm.campaignProduct.referencePrice)) {
						errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.numeric.referencePrice'));
					} else if (vm.campaignProduct.referencePrice <= 0) {
						errors.push($translate.instant('pharmaPortalApp.campaignProduct.error.belowZero.referencePrice'));
					}
				} else {
					vm.campaignProduct.referencePrice = null;
				}
			}

			if (errors.length > 0) {
				var message = '';
				for (var i = 0; i < errors.length; i++) {
					if (i > 0) {
						message += '<br>';
					}
					message += errors[i];
				}
				Notification.error({
					message : $translate.instant('pharmaPortalApp.campaignProduct.error.topMessage') + '<br>' + message,
					delay : ''
				});
				return false;
			}
			return true;
		}

		vm.brandTypes = [ {
			value : 'GOLD',
			label : $translate.instant('pharmaPortalApp.brandType.GOLD')
		}, {
			value : 'SILVER',
			label : $translate.instant('pharmaPortalApp.brandType.SILVER')
		} ];
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('CampaignProductDeleteDialogController', CampaignProductDeleteDialogController);

	CampaignProductDeleteDialogController.$inject = ['Notification', '$uibModalInstance', 'entity', 'CampaignProduct', '$translate', 'ModuleSettings' ];

	function CampaignProductDeleteDialogController(Notification, $uibModalInstance, entity, CampaignProduct, $translate, ModuleSettings) {
		var vm = this;

		vm.campaignProduct = entity;

		vm.clear = clear;
		vm.confirmDelete = confirmDelete;
		vm.loadAll = loadAll;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;
				
				if (!vm.moduleSettings.campaignsModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
		
		function clear () {
			$uibModalInstance.dismiss('cancel');
		}

		function onDeleteSuccess(result) {
			Notification.success({message: $translate.instant('pharmaPortalApp.campaignProduct.deleted'), delay: 5000});
			$uibModalInstance.close(true);
		}

		function onDeleteError(result) {
			Notification.error({message: result.data.message, delay: ''});
			$uibModalInstance.close(true);
		}

		function confirmDelete(id) {
			CampaignProduct.delete({id: vm.campaignProduct.id}, onDeleteSuccess, onDeleteError);
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('CampaignProductClearListDialogController', CampaignProductClearListDialogController);

	CampaignProductClearListDialogController.$inject = [ 'Notification', '$uibModalInstance', 'entity', 'Campaign', '$translate', '$state', 'ModuleSettings' ];

	function CampaignProductClearListDialogController(Notification, $uibModalInstance, entity, Campaign, $translate, $state, ModuleSettings) {
		var vm = this;

		vm.campaign = entity;

		vm.clear = clear;
		vm.confirmDelete = confirmDelete;
		vm.loadAll = loadAll;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;
				
				if (!vm.moduleSettings.campaignsModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
		
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmDelete(id) {
			vm.campaign.products = [];
			Campaign.update(vm.campaign, onSaveSuccess, onSaveError);
		}

		function onSaveSuccess(result) {
			Notification.success({
				message : $translate.instant("pharmaPortalApp.campaignProduct.deleteAll.message.success"),
				delay : 5000
			});
			$uibModalInstance.close('true');
		}

		function onSaveError() {
			Notification.error({
				message : $translate.instant("pharmaPortalApp.campaignProduct.deleteAll.message.error"),
				delay : ''
			});
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('CampaignNewDialogController', CampaignNewDialogController);

	CampaignNewDialogController.$inject = [ 'Notification', '$uibModalInstance', '$stateParams', 'entity', 'Campaign', 'Company', '$translate', '$state', 'moment', '$scope', 'ModuleSettings' ];

	function CampaignNewDialogController(Notification, $uibModalInstance, $stateParams, entity, Campaign, Company, $translate, $state, moment, $scope, ModuleSettings) {
		var vm = this;

		vm.campaign = entity;
		vm.companies = Company.getAllNotEmpty({ size : 1000 });

		vm.clear = clear;
		vm.save = save;
		vm.validateCampaign = validateCampaign;
		vm.loadAll = loadAll;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.campaignsModule) {
					$state.go('accessdenied');
				}
			});
			vm.campaign.companies = vm.companies;
		}
		loadAll();

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			if (validateCampaign()) {
				vm.isSaving = true;
				if (vm.campaign.id !== null) {
					Campaign.update(vm.campaign, onSaveSuccess, onSaveError);
				} else {
					Campaign.save(vm.campaign, onSaveSuccess, onSaveError);
				}
			}
		}

		function onSaveSuccess(result) {
			Notification.success({
				message : $translate.instant("pharmaPortalApp.campaign.created"),
				delay : 5000
			});
			vm.isSaving = false;
			$uibModalInstance.close(result);
		}

		function onSaveError() {
			vm.isSaving = false;
			Notification.error({
				message : $translate.instant("pharmaPortalApp.campaign.error.create"),
				delay : ''
			});
		}

		function validateCampaign() {
			var errors = [];
			// NAME
			if (vm.campaign.name == null || vm.campaign.name == '') {
				errors.push($translate.instant('pharmaPortalApp.campaign.error.empty.name'));
			}
			// CAMPAIGN TYPE
			if (vm.campaign.campaignType == null || vm.campaign.campaignType == '') {
				errors.push($translate.instant('pharmaPortalApp.campaign.error.empty.campaignType'));
			}
			// CAMPAIGN STATUS
			if (vm.campaign.campaignStatus === null || vm.campaign.campaignStatus === '') {
				errors.push($translate.instant('pharmaPortalApp.campaign.error.empty.campaignStatus'));
			}
			// START DATE - END DATE
			if (vm.campaign.startDate == null || vm.campaign.startDate == '' || vm.campaign.endDate == null || vm.campaign.endDate == '') {
				errors.push($translate.instant('pharmaPortalApp.campaign.error.empty.dates'));
			} else {
				var checkDiff = true;
				// TODO: UNCHECK THIS DATE VALIDATION
				// if (moment().diff(vm.campaign.startDate, 'days') > 0) {
				// errors.push($translate.instant('pharmaPortalApp.campaign.error.dates.oldStartDate'));
				// checkDiff = false;
				// }
				// if (moment().diff(vm.campaign.endDate, 'days') > 0) {
				// errors.push($translate.instant('pharmaPortalApp.campaign.error.dates.oldEndDate'));
				// checkDiff = false;
				// }
				if (checkDiff && moment(vm.campaign.startDate).diff(vm.campaign.endDate, 'days') > 0) {
					errors.push($translate.instant('pharmaPortalApp.campaign.error.dates.endBeforeStart'));
				}
			}
			// COMPANIES
			if (vm.campaign.companies == null || vm.campaign.companies.length <= 0) {
				errors.push($translate.instant('pharmaPortalApp.campaign.error.empty.companies'));
			}

			if (errors.length > 0) {
				var message = '';
				for (var i = 0; i < errors.length; i++) {
					if (i > 0) {
						message += '<br>';
					}
					message += errors[i];
				}
				Notification.error({
					message : $translate.instant('pharmaPortalApp.campaign.error.topMessage') + '<br>' + message,
					delay : ''
				});
				return false;
			}
			return true;
		}

		vm.statusItems = [ {
			value : true,
			label : $translate.instant('pharmaPortalApp.campaign.status.active'),
		}, {
			value : false,
			label : $translate.instant('pharmaPortalApp.campaign.status.inactive'),
		} ];

		vm.campaignTypes = [ {
			value : 'CHALLENGE',
			label : $translate.instant('pharmaPortalApp.campaignType.CHALLENGE'),
		}, {
			value : 'PROMOTION',
			label : $translate.instant('pharmaPortalApp.campaignType.PROMOTION'),
		} ];

		vm.datePopup = {
			start : {
				opened : false
			},
			end : {
				opened : false
			}
		};
		vm.openDatePopup = function(inputCalendar) {
			if (inputCalendar == 'start') {
				vm.datePopup.start.opened = true;
			} else {
				vm.datePopup.end.opened = true;
			}
		};

		vm.dateOptions = {
			formatYear : 'yyyy',
			startingDay : 1,
			showWeeks : false
		};
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('CampaignEditController', CampaignEditController);

    CampaignEditController.$inject = ['Notification', 'blockUI', 'entity', 'Campaign', 'Company', 'CampaignProduct', '$translate', '$window', 'Upload', 'moment', '$state', '$scope', '$filter', 'ModuleSettings'];

    function CampaignEditController(Notification, blockUI, entity, Campaign, Company, CampaignProduct, $translate, $window, Upload, moment, $state, $scope, $filter, ModuleSettings) {
        var vm = this;

        vm.campaign = entity;
        vm.campaign.startDate = new Date(vm.campaign.startDate);
        vm.campaign.endDate = new Date(vm.campaign.endDate);
        vm.companies = Company.query({size: 1000});

        vm.loadAll = loadAll;
        vm.uploadFile = uploadFile;
        vm.getTemplate = getTemplate;

        vm.cloneCampaignProduct = cloneCampaignProduct;
        vm.save = save;
        vm.saveCampaign = saveCampaign;
        vm.validateCampaign = validateCampaign;
        vm.toggleLineEditMode = toggleLineEditMode;
        vm.flatListToTreeViewData = flatListToTreeViewData;

        loadAll();

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.campaignsModule) {
                    $state.go('accessdenied');
                } else {
                    $scope.productContainerList = {};
                    $scope.productContainerList.items = [];

                    if (vm.campaign.campaignType === 'CHALLENGE') {
                        $scope.productContainerList.items = vm.campaign.products;
                    } else {
                        $scope.campaignProductList = [];
                        $scope.campaignProductList = vm.flatListToTreeViewData(vm.campaign.products);

                        angular.forEach(vm.campaign.products, function (prod) {
                            if (prod.promoLine || prod.promoRef == null) {
                                $scope.productContainerList.items.push(prod);
                            }
                        });
                        $scope.productContainerList.dragging = false;
                        $scope.campaignProductList.sort(function (a, b) {
                            var textA = a.description.toUpperCase();
                            var textB = b.description.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                        setMenuOptions();
                    }
                }
            });

        }

        function uploadFile(file) {
            blockUI.start($translate.instant('pharmaPortalApp.campaignProduct.message.uploadingTemplate'));
            file.upload = Upload.upload({
                url: '/api/campaigns/upload',
                fields: {campaignId: vm.campaign.id},
                file: file
            }).then(function (response) {
                file.result = response.data;
                blockUI.stop();

                if (response.data.success) {
                    Notification.success({message: response.data.message, delay: 5000});
                } else {
                    Notification.error({message: response.data.message, delay: ''});
                }

                $state.go("campaign.edit", {id: vm.campaign.id}, {reload: true});
            }, function (response) {
                blockUI.stop();

                if (response.data.success) {
                    Notification.success({message: response.data.message, delay: 5000});
                } else {
                    Notification.error({message: response.data.message, delay: ''});
                }

                $state.go("campaign.edit", {id: vm.campaign.id}, {reload: true});
            }, function (evt) {
                // Math.min is to fix IE which reports 200% sometimes
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
            });
        }

        function getTemplate() {
            $window.open("/api/campaigns/template");
        }

        function cloneCampaignProduct(product) {
            if (product.promoLine) {
                Notification.error({message: $translate.instant('pharmaPortalApp.campaign.error.promoLineClone'), delay: ''});
            } else {
                vm.newProduct = {};
                angular.copy(product, vm.newProduct);
                vm.newProduct.id = null;
                vm.newProduct.campaign = vm.campaign;
                CampaignProduct.save(vm.newProduct, onSaveSuccess, onSaveError);
            }
        }

        vm.statusItems = [{
            value: true,
            label: $translate.instant('pharmaPortalApp.campaign.status.active')
        }, {
            value: false,
            label: $translate.instant('pharmaPortalApp.campaign.status.inactive')
        }];

        vm.campaignTypes = [{
            value: 'CHALLENGE',
            label: $translate.instant('pharmaPortalApp.campaignType.CHALLENGE')
        }, {
            value: 'PROMOTION',
            label: $translate.instant('pharmaPortalApp.campaignType.PROMOTION')
        }];

        vm.brandTypes = [{
            value: 'GOLD',
            label: $translate.instant('pharmaPortalApp.brandType.GOLD')
        }, {
            value: 'SILVER',
            label: $translate.instant('pharmaPortalApp.brandType.SILVER')
        }];

        vm.datePopup = {
            start: {opened: false},
            end: {opened: false}
        };

        vm.openDatePopup = function (inputCalendar) {
            if (inputCalendar == 'start') {
                vm.datePopup.start.opened = true;
            } else {
                vm.datePopup.end.opened = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            showWeeks: false
        };


        function saveCampaign(isButtonAction) {
            if (validateCampaign()) {
                vm.isSaving = true;

                if (vm.campaign.campaignType === 'CHALLENGE') {
                    // SE FOR DESAFIO LIMPA AS PROMOLINE E PROMOREF TODAS
                    angular.forEach(vm.campaign.products, function (product) {
                        product.promoLine = null;
                        product.promoRef = null;
                        product.promoRefId = null;
                        product.brandType = null;
                    });
                } else {
                    // SE FOR PROMOÇÃO MAPEAR LISTA DND PARA BD
                    $scope.tempProd = [];

                    if ($scope.campaignProductList) {
                        angular.forEach($scope.campaignProductList, function (model) {
                            angular.forEach(model.items, function (myItem) {
                                myItem.promoRef = model.cnp;
                                myItem.promoRefId = model.id;
                                myItem.promoLine = false;
                                $scope.tempProd.push(myItem);
                            });
                        });
                    }

                    vm.campaign.products = $scope.tempProd;

                    if ($scope.productContainerList) {
                        angular.forEach($scope.productContainerList.items, function (product) {
                            if (product.promoRef == null || product.promoLine == true) {
                                vm.campaign.products.push(product);
                            }
                        });
                    }

                }

                if (vm.campaign.id !== null) {
                    if (isButtonAction) {
                        Campaign.update(vm.campaign, function (res) {
                            vm.isSaving = false;
                            Notification.success({message: $translate.instant("pharmaPortalApp.campaign.updated"), delay: 5000});
                            $state.go("campaign");
                        }, onSaveError);
                    } else {
                        Campaign.update(vm.campaign, onAutoSaveSuccess, onAutoSaveError);
                    }
                } else {
                    Campaign.save(vm.campaign, onSaveSuccess, onSaveError);
                }
            }
        }

        function onAutoSaveSuccess(result) {
            Notification.success({
                message: $translate.instant("pharmaPortalApp.campaign.updated"),
                delay: 5000
            });
            vm.isSaving = false;
        }

        function onAutoSaveError(result) {
            vm.isSaving = false;
            Notification.error({
                message: $translate.instant("pharmaPortalApp.campaign.error.create"),
                delay: ''
            });
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            Notification.success({message: $translate.instant("pharmaPortalApp.campaign.updated"), delay: 5000});
            $state.go("campaign.edit", {
                id: vm.campaign.id
            }, {
                reload: 'campaign'
            });
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function validateCampaign() {
            var errors = [];
            // NAME
            if (vm.campaign.name == null || vm.campaign.name == '') {
                errors.push($translate.instant('pharmaPortalApp.campaign.error.empty.name'));
            }
            // CAMPAIGN TYPE
            if (vm.campaign.campaignType == null || vm.campaign.campaignType == '') {
                errors.push($translate.instant('pharmaPortalApp.campaign.error.empty.campaignType'));
            }
            // CAMPAIGN STATUS
            if (vm.campaign.campaignStatus === null || vm.campaign.campaignStatus === '') {
                errors.push($translate.instant('pharmaPortalApp.campaign.error.empty.campaignStatus'));
            }
            // START DATE - END DATE
            if (vm.campaign.startDate == null || vm.campaign.startDate == '' || vm.campaign.endDate == null || vm.campaign.endDate == '') {
                errors.push($translate.instant('pharmaPortalApp.campaign.error.empty.dates'));
            } else {
                var checkDiff = true;
                // TODO: UNCHECK THIS DATE VALIDATION
//				if (moment().diff(vm.campaign.startDate, 'days') > 0) {
//					errors.push($translate.instant('pharmaPortalApp.campaign.error.dates.oldStartDate'));
//					checkDiff = false;
//				}
//				if (moment().diff(vm.campaign.endDate, 'days') > 0) {
//					errors.push($translate.instant('pharmaPortalApp.campaign.error.dates.oldEndDate'));
//					checkDiff = false;
//				}
                if (checkDiff && moment(vm.campaign.startDate).diff(vm.campaign.endDate, 'days') > 0) {
                    errors.push($translate.instant('pharmaPortalApp.campaign.error.dates.endBeforeStart'));
                }
            }
            // COMPANIES
            if (vm.campaign.companies == null || vm.campaign.companies.length <= 0) {
                errors.push($translate.instant('pharmaPortalApp.campaign.error.empty.companies'));
            }

            if (errors.length > 0) {
                var message = '';
                for (var i = 0; i < errors.length; i++) {
                    if (i > 0) {
                        message += '<br>';
                    }
                    message += errors[i];
                }
                Notification.error({message: $translate.instant('pharmaPortalApp.campaign.error.topMessage') + '<br>' + message, delay: ''});
                return false;
            }
            return true;
        }

        function toggleLineEditMode(campaignProduct) {
            if (angular.isDefined(campaignProduct.editMode) && campaignProduct.editMode == true) {
                campaignProduct.editMode = false;
            } else {
                campaignProduct.editMode = true;
            }
//			save();
        }


        $scope.onSelectItem = function (list, item, event) {
            if (angular.element(event.srcElement).hasClass("dragHandle") || event.target.nodeName == "TD") {
                if (item.promoLine) {
                    Notification.warning({message: "Artigos de promoção não podem ser movidos", delay: ''});
                } else {
                    item.selected = !item.selected;

                    var found = $filter('filter')(list, {cnp: item.cnp, selected: true}, true);
                    if (found.length > 1) {
                        item.selected = !item.selected
                        Notification.warning({message: "Não pode selecionar 2 artigos com o mesmo CNP", delay: ''});
                    } else {
                        // SELECIONADO / ADICIONADO COM SUCESSO
                    }
                }
            }
        };

        /**
         * dnd-dragging determines what data gets serialized and send to the receiver
         * of the drop. While we usually just send a single object, we send the array
         * of all selected items here.
         */
        $scope.getSelectedItemsIncluding = function (list, item) {
            item.selected = true;
            return list.items.filter(function (item) {
                return item.selected;
            });
        };

        /**
         * We set the list into dragging state, meaning the items that are being
         * dragged are hidden. We also use the HTML5 API directly to set a custom
         * image, since otherwise only the one item that the user actually dragged
         * would be shown as drag image.
         */
        $scope.onDragstart = function (list, event) {
            list.dragging = true;
            if (event.dataTransfer.setDragImage) {
                var img = new Image();
                img.src = 'content/images/copy_black.png';
                event.dataTransfer.setDragImage(img, 0, 0);
            }
        };

        /**
         * In the dnd-drop callback, we now have to handle the data array that we
         * sent above. We handle the insertion into the list ourselves. By returning
         * true, the dnd-list directive won't do the insertion itself.
         */
        $scope.onDrop = function (list, items, index) {
            var validItems = [];
            angular.forEach(items, function (curItem) {
                var found = $filter('filter')(list.items, {cnp: curItem.cnp}, true);
                if (found.length > 0) {
                    curItem.selected = !curItem.selected;
                    $scope.productContainerList.items.push(curItem);
                    Notification.warning({message: "Não é permitido ter mais do que 1 artigo com o mesmo CNP na mesma promoção. Estes não serão adicionados", delay: ''});
                } else {
                    // SELECIONADO / ADICIONADO COM SUCESSO
                    curItem.selected = false;
                    validItems.push(curItem);
                }
            });

            list.items = list.items.slice(0, index)
                .concat(validItems)
                .concat(list.items.slice(index));
            return true;
        }

        $scope.onDragEnd = function (productContainerList) {
            productContainerList.dragging = false
            saveCampaign();
        };
        /**
         * Last but not least, we have to remove the previously dragged items in the
         * dnd-moved callback.
         */
        $scope.onMoved = function (list) {
            list.items = list.items.filter(function (item) {
                return !item.selected;
            });
        };


        /**
         * ADD ITEM TO PRODUCT LIST
         * REMOVE ITEM FROM CONTAINER
         */
        $scope.dropItem = function (list, item) {
            // DEVOLVE ITEM À TABELA
            item.promoRef = null;
            item.promoRefId = null;
            $scope.productContainerList.items.push(item);
            // REMOVE ITEM DO CONTAINER
            var index = list.items.indexOf(item);
            list.items.splice(index, 1);
            saveCampaign();
        };

        function save() {
            if (validateCampaign()) {
                vm.isSaving = true;

                if (vm.campaign.campaignType !== 'CHALLENGE') {
                    $scope.promoLineCNP = [];
                    angular.forEach(vm.campaign.products, function (prod) {
                        if (prod.promoLine) {
                            $scope.promoLineCNP.push(prod.cnp);
                        } else {
                            prod.brandType = null;
                        }
                    });

                    angular.forEach(vm.campaign.products, function (prod) {
                        if (prod.promoRef != null && $scope.promoLineCNP.indexOf(prod.promoRef) < 0) {
                            prod.promoRef = null;
                            prod.promoRefId = null;
                        }
                    });
                }

                if (vm.campaign.id !== null) {
                    Campaign.update(vm.campaign, onSaveSuccess, onSaveError);
                } else {
                    Campaign.save(vm.campaign, onSaveSuccess, onSaveError);
                }
            }
        }

        // FLAT LIST TO TREE VIEW DATA
        function flatListToTreeViewData(dataList) {
            var tree = [], mappedArr = {}, arrElem, mappedElem;

            for (var i = 0, len = dataList.length; i < len; i++) {
                arrElem = dataList[i];
                mappedArr[arrElem.id] = arrElem;
                mappedArr[arrElem.id]['items'] = [];
            }

            for (var id in mappedArr) {
                if (mappedArr.hasOwnProperty(id)) {
                    mappedElem = mappedArr[id];
                    // ARRAY OF CHILDREN.
                    if (mappedElem.promoRefId) {
                        mappedArr[mappedElem['promoRefId']]['items'].push(mappedElem);
                    } else if (mappedElem.promoLine) {
                        tree.push(mappedElem);
                    }
                }
            }
            return tree;
        }

        vm.searchInTable = "";
        vm.selectTab = 0;
        vm.clearSearchInTable = clearSearchInTable;
        vm.selectAllValid = selectAllValid;
        vm.unselectAll = unselectAll;
        vm.onTabSelect = onTabSelect;

        function clearSearchInTable() {
            vm.searchInTable = "";
        };

        function unselectAll() {
            // UNSELECT ALL
            angular.forEach($scope.productContainerList.items, function (product) {
                product.selected = false;
            });
        }

        function selectAllValid() {
            vm.unselectAll();

            // GET ALREADY ALREADY ASSOCIATED LIST
            var curAddedProducts = [];
            var curAddedProducts = $scope.campaignProductList[vm.selectTab].items;
            var curAddedCnp = curAddedProducts.map(function (obj) {
                return obj.cnp;
            });

            // SELECT ONLY VALID TO DROP
            angular.forEach($filter('filter')($scope.productContainerList.items, vm.searchInTable), function (product) {
                if (!product.promoLine && curAddedCnp.indexOf(product.cnp) < 0) {
                    product.selected = true;
                    curAddedCnp.push(product.cnp);
                }
            });
        };

        function onTabSelect(index) {
            vm.selectTab = index;
        };

        function setMenuOptions() {
            var campaignDesc = [];
            var x = 0;
            angular.forEach($scope.campaignProductList, function (item) {
                var newItem = {
                    tab: x,
                    text: item.cnp + " - " + item.description,
                    click: function ($itemScope, $event, modelValue, text, $li) {
                        if (!$itemScope.product.promoLine) {
                            var list = [];
                            $itemScope.product.selected = true;
                            list = $scope.productContainerList.items.filter(function (item) {
                                return item.selected;
                            });
                            angular.forEach(list, function (item) {
                                // DEVOLVE ITEM À TABELA
                                item.promoRef = null;
                                item.promoRefId = null;
                                $scope.campaignProductList[newItem.tab].items.push(item);
                                // REMOVE ITEM DO CONTAINER
                                var index = $scope.productContainerList.items.indexOf(item);
                                $scope.productContainerList.items.splice(index, 1);
                                saveCampaign();
                                item.selected = false;
                            });
                            onTabSelect(newItem.tab);
                        }else{
                            Notification.warning({message: "Artigos de promoção não podem ser movidos", delay: 5000});
                        }
                    }
                };
                campaignDesc.push(newItem);
                x++;
            });
            $scope.menuOptions = [
                ['Adicionar a...',
                    campaignDesc
                ]
            ];
        }

        $scope.menuOptions2 = [
            {
                text: 'Remover',
                click: function ($itemScope, $event, modelValue, text, $li) {
                    var list = [];
                    $itemScope.item.selected = true;
                    list = $scope.campaignProductList[vm.selectTab].items.filter(function (item) {
                        return item.selected;
                    });
                    angular.forEach(list, function (item) {
                        // DEVOLVE ITEM À TABELA
                        item.promoRef = null;
                        item.promoRefId = null;
                        $scope.productContainerList.items.push(item);
                        // REMOVE ITEM DO CONTAINER
                        var index = $scope.campaignProductList[vm.selectTab].items.indexOf(item);
                        $scope.campaignProductList[vm.selectTab].items.splice(index, 1);
                        saveCampaign();
                    });
                    unselectAll();
                }
            }
        ];
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('CampaignDetailDialogController', CampaignDetailDialogController);

	CampaignDetailDialogController.$inject = [ '$uibModalInstance', 'entity', 'Campaign', 'ModuleSettings' ];

	function CampaignDetailDialogController($uibModalInstance, entity, Campaign, ModuleSettings) {
		var vm = this;

		vm.campaign = entity;
		
		vm.clear = clear;
		vm.loadAll = loadAll;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;
				
				if (!vm.moduleSettings.campaignsModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
		
		function clear() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('CampaignDeleteController',CampaignDeleteController);

	CampaignDeleteController.$inject = ['Notification', '$uibModalInstance', 'Campaign', '$translate', 'ModuleSettings', 'campaignId' ];

	function CampaignDeleteController(Notification, $uibModalInstance, Campaign, $translate, ModuleSettings, campaignId) {
		var vm = this;


		vm.campaignId = campaignId;

		vm.clear = clear;
		vm.confirmDelete = confirmDelete;
		vm.loadAll = loadAll;

		function loadAll() {
			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.campaignsModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();

		function clear () {
			$uibModalInstance.dismiss('cancel');
		}

		function confirmDelete (id) {
			Campaign.delete({id: id}, function () {
				Notification.success({message: $translate.instant('pharmaPortalApp.campaign.deleted'), delay: 5000});
				$uibModalInstance.close(true);
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('campaign', {
			parent : 'entity',
			url : '/campaign?page&sort&search',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'pharmaPortalApp.campaign.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/campaign/campaigns.html',
					controller : 'CampaignController',
					controllerAs : 'vm'
				}
			},
			params : {
				page : {
					value : '1',
					squash : true
				},
				sort : {
					value : 'startDate,desc',
					squash : true
				}
			},
			resolve : {
				pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
					return {
						page : PaginationUtil.parsePage($stateParams.page),
						sort : $stateParams.sort,
						predicate : PaginationUtil.parsePredicate($stateParams.sort),
						ascending : PaginationUtil.parseAscending($stateParams.sort)
					};
				} ],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('campaign');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('campaign-detail', {
			parent : 'campaign',
			url : '/{id}',
			data : {
				authorities : [ 'ROLE_USER' ],
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/campaign/campaign-detail-dialog.html',
					controller : 'CampaignDetailDialogController',
					controllerAs : 'vm',
					backdrop : 'static',
					size : 'lg',
					resolve : {
						entity : [ 'Campaign', function(Campaign) {
							return Campaign.get({
								id : $stateParams.id
							}).$promise;
						} ]
					}
				}).result.then(function() {
					$state.go('campaign', {}, {
						reload : false
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('campaign.new', {
			parent : 'campaign',
			url : '/campaign/new',
			data : {
				authorities : [ 'ROLE_USER' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/campaign/campaign-new-dialog.html',
					controller : 'CampaignNewDialogController',
					controllerAs : 'vm',
					backdrop : 'static',
					size : 'lg',
					resolve : {
						entity : function() {
							return {
								id : null,
								name : null,
								campaignType : null,
								startDate : null,
								endDate : null,
								campaignStatus : null,
								companies : null,
								products : null
							};
						}
					}
				}).result.then(function(result) {
					$state.go('campaign.edit', {
						id : result.id
					}, {
						reload : false
					});
				}, function() {
					$state.go('campaign');
				});
			} ]
		}).state('campaign.edit', {
			parent : 'campaign',
			url : '/{id}/edit',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'pharmaPortalApp.campaign.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/campaign/campaign-edit.html',
					controller : 'CampaignEditController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('campaign');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ],
				entity : [ '$stateParams', 'Campaign', function($stateParams, Campaign) {
					return Campaign.get({
						id : $stateParams.id
					}).$promise;
				} ],
				previousState : [ "$state", function($state) {
					var currentStateData = {
						name : $state.current.name || 'campaign',
						params : $state.params,
						url : $state.href($state.current.name, $state.params)
					};
					return currentStateData;
				} ]
			}
		}).state('campaign.delete', {
			parent : 'campaign',
			url : '/{id}/delete',
			data : {
				authorities : [ 'ROLE_USER' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/campaign/campaign-delete-dialog.html',
					controller : 'CampaignDeleteController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : [ 'Campaign', function(Campaign) {
							return Campaign.get({
								id : $stateParams.id
							}).$promise;
						} ]
					}
				}).result.then(function() {
					$state.go('campaign', null, {
						reload : 'campaign'
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('campaign-product-delete', {
			parent : 'campaign.edit',
			url : '/campaign-products/{prodId}',
			method : 'DELETE',
			data : {
				authorities : [ 'ROLE_USER' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/campaign/campaign-product-delete-dialog.html',
					controller : 'CampaignProductDeleteDialogController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : [ 'CampaignProduct', function(CampaignProduct) {
							return CampaignProduct.get({
								id : $stateParams.prodId
							});
						} ]
					}
				}).result.then(function() {
					$state.go('campaign.edit', {
						id : $stateParams.id
					}, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('campaign-product-new', {
			parent : 'campaign.edit',
			url : '/new',
			data : {
				authorities : [ 'ROLE_USER' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/campaign/campaign-product-new-dialog.html',
					controller : 'CampaignProductNewDialogController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : function() {
							return {
								id : null,
								society : null,
								cnp : null,
								description : null,
								targetAmount : null,
								referencePrice : null,
								campaign : null,
								promoRef : null,
								promoLine : null
							};
						}
					}
				}).result.then(function() {
					$state.go('campaign-product-new', {
						id : $stateParams.id
					}, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('campaign-product-clear-list', {
			parent : 'campaign.edit',
			url : '/campaign-products-clear-list',
			data : {
				authorities : [ 'ROLE_USER' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/entities/campaign/campaign-product-clear-list-dialog.html',
					controller : 'CampaignProductClearListDialogController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : [ 'Campaign', function(Campaign) {
							return Campaign.get({
								id : $stateParams.id
							});
						} ]
					}
				}).result.then(function() {
					$state.go('campaign.edit', {
						id : $stateParams.id
					}, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		});
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('CampaignController', CampaignController);

    CampaignController.$inject = ['Notification', '$state', 'Campaign', 'ParseLinks', 'paginationConstants', 'pagingParams', 'Company', '$translate', '$http', 'ModuleSettings', '$uibModal', '$scope'];

    function CampaignController(Notification, $state, Campaign, ParseLinks, paginationConstants, pagingParams, Company, $translate, $http, ModuleSettings, $uibModal, $scope) {
        var vm = this;

        vm.campaigns = Campaign.query();
        vm.companies = Company.query({size: 1000});

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.deleteCampaign = "";

        vm.cloneCampaign = cloneCampaign;
        vm.setActive = setActive;
        vm.clearFilter = clearFilter;
        vm.filterCampaigns = filterCampaigns;
        vm.filter = [{
            startDate: null,
            endDate: null,
            campaignStatus: null,
            name: null,
            company: null
        }];

        loadAll();

        function loadAll() {
            vm.moduleSettings = ModuleSettings.query();
            vm.moduleSettings.$promise.then(function (result) {
                vm.moduleSettings = result;

                if (!vm.moduleSettings.campaignsModule) {
                    $state.go('accessdenied');
                } else {
                    Campaign.query({
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                    }, onSuccess, onError);

                }
            });
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'startDate') {
                result.push('startDate');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.campaigns = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            Notification.error({
                message: error.data.message,
                delay: ''
            });
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }

        function cloneCampaign(id) {
            $http.get('api/campaigns/clone/' + id).then(function (result) {
                if (result.status === 200) {
                    $state.go('campaign.edit', {
                        id: result.data.id
                    }, {
                        reload: false
                    });
                    Notification.success({
                        message: $translate.instant("pharmaPortalApp.campaign.cloned"),
                        delay: 5000
                    });
                } else {
                    Notification.error({
                        message: $translate.instant(result.headers("X-pharmaPortalApp-alert")),
                        delay: ''
                    });
                }
            });
        }

        function setActive(campaign, isActivated) {
            campaign.campaignStatus = isActivated;
            Campaign.update(campaign, function () {
                loadAll();
            });
        }

        function clearFilter() {
            loadAll();
            vm.filter = [{
                startDate: null,
                endDate: null,
                campaignStatus: null,
                name: null,
                company: null
            }];
        }

        function filterCampaigns() {
            if (vm.filter.campaignStatus == null && vm.filter.company == null && vm.filter.endDate == null && vm.filter.name == null && vm.filter.startDate == null) {
                return vm.clearFilter();
            }

            var filterRequest = {};
            filterRequest.startDate = vm.filter.startDate != null ? vm.filter.startDate : null;
            filterRequest.endDate = vm.filter.endDate != null ? vm.filter.endDate : null;
            filterRequest.campaignStatus = vm.filter.campaignStatus != null ? vm.filter.campaignStatus : null;
            filterRequest.name = vm.filter.name != null ? vm.filter.name.name : null;
            filterRequest.companyId = vm.filter.company != null ? vm.filter.company.id : null;

            $http.post('api/campaigns/searchFilter', filterRequest).then(function (result) {
                if (result.status === 200) {
                    vm.campaigns = result.data;
                    vm.links = ParseLinks.parse(result.headers('link'));
                    vm.totalItems = result.headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                } else {
                    Notification.error({
                        message: $translate.instant(result.headers("X-pharmaPortalApp-alert")),
                        delay: ''
                    });
                }
            });
        }

        vm.statusItems = [{
            value: true,
            label: $translate.instant('pharmaPortalApp.campaign.status.active')
        }, {
            value: false,
            label: $translate.instant('pharmaPortalApp.campaign.status.inactive')
        }];

        vm.datePopup = {
            start: {
                opened: false
            },
            end: {
                opened: false
            }
        };

        vm.openDatePopup = function (inputCalendar) {
            if (inputCalendar == 'start') {
                vm.datePopup.start.opened = true;
            } else {
                vm.datePopup.end.opened = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            showWeeks: false
        };

        vm.deleteCampaign = function (item) {
            $uibModal.open({
                templateUrl: 'app/entities/campaign/campaign-delete-dialog.html',
                controller: 'CampaignDeleteController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    campaignId: function () {
                        return item;
                    }
                }
            }).result.then(function () {
                // called when you close the modal
                // do your stuff
                filterCampaigns();
            }, function () {
                // called when you dismiss modal by clicking anywhere outside modal
                // do your stuff
            });

        };

    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('as400-messages', {
                parent: 'entity',
                url: '/as400-messages',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'pharmaPortalApp.as400Messages.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/as400-messages/as400-messages.html',
                        controller: 'AS400MessagesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('as400Messages');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('AS400MessagesController', AS400MessagesController);

    AS400MessagesController.$inject = ['$state', 'AS400Messages'];

    function AS400MessagesController($state, AS400Messages) {

        var vm = this;

        vm.messages = AS400Messages.query();
        vm.filter = {
            username: ""
        };
        vm.clearFilter = clearFilter;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            AS400Messages.getMessages(vm.filter, function (result) {
                vm.messages = result;
            });
        }

        function clearFilter() {
            vm.filter = {
                username: ""
            };
            loadAll();
        }
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ThemeSettingsController', ThemeSettingsController);

	ThemeSettingsController.$inject = [ 'Notification', '$scope', '$translate', 'DataUtils', 'PortalSettings' ];

	function ThemeSettingsController(Notification, $scope, $translate, DataUtils, PortalSettings) {
		var vm = this;

		vm.save = save;
		vm.loadAll = loadAll;

		vm.setLogo = function($file, settings) {
			if ($file && $file.$error === 'pattern') {
				return;
			}
			if ($file) {
				DataUtils.toBase64($file, function(base64Data) {
					$scope.$apply(function() {
						vm.settings.logo = base64Data;
						vm.settings.logoContentType = $file.type;
					});
				});
			}
		};

		function save() {
			try {
				PortalSettings.update(vm.settings, function(httpResponse) {
					Notification.success({message : $translate.instant('pharmaPortalApp.themeSettings.messages.success'), delay : 5000});
				});
			} catch (err) {
				Notification.error({message : $translate.instant('pharmaPortalApp.themeSettings.messages.error'), delay : ''});
			}
		}

		function loadAll() {
			vm.settings = PortalSettings.query();
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PolicySettingsController', PolicySettingsController);

	PolicySettingsController.$inject = ['Notification', '$translate', '$http', 'PolicySettings', '$timeout'];

	function PolicySettingsController(Notification, $translate, $http, PolicySettings, $timeout) {
		var vm = this;

		vm.settings = PolicySettings.query();
		
		vm.save = save;
		vm.loadAll = loadAll;
	
		function save() {
			try {
				vm.settings.activePolicyImplementations = vm.treeInstance.jstree(true).get_selected().toString();
				PolicySettings.save(vm.settings, function(httpResponse) {
					Notification.success({message: $translate.instant('pharmaPortalApp.policySettings.messages.success'), delay: 5000});
				});
			} catch (err) {
				Notification.error({message: $translate.instant('pharmaPortalApp.policySettings.messages.error'), delay: ''});
			}
		}

		function loadAll() {
			vm.treeData = [];
			$timeout(function(){	
				$http.get("api/policy-builder/interfaces").then(function(result) {
					angular.forEach(result.data, function(v, k) {
						vm.treeData.push({ id : v, parent : '#', text : $translate.instant(v), state: { opened: false} });
						
						$http.get("api/policy-builder/implementations/" + v).then(function(result) {
							for (var i = 0; i < result.data.length; i++) {
								vm.treeData.push({ id : result.data[i], parent : v, text : $translate.instant(result.data[i]), state: { opened: false} });
							}
						});
					});
				});
			}, 100);

			$timeout(function(){
				vm.treeConfig = {
					core : {
						multiple : true,
						animation: true,
						error : function(error) {
							console.log('treeCtrl: error from js tree - ' + angular.toJson(error));
						},
						themes : {
							dots : false,
							stripes : true
						},
						dblclick_toggle : true,
						check_callback : true,
						worker : true
					},
					version : 1,
					plugins : ['checkbox']
				};
			}, 1500);
			
			$timeout(function(){
				vm.current_settings = vm.settings.activePolicyImplementations;
				if(vm.current_settings && vm.current_settings.length > 0) {
					angular.forEach(vm.current_settings.split(','), function(v, k) {
						vm.treeInstance.jstree("select_node", "#"+v)
					});
				}
			}, 2000);
		}
		loadAll();
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ModuleSettingsController', ModuleSettingsController);

	ModuleSettingsController.$inject = ['Notification', '$state', '$translate', 'ModuleSettings'];

	function ModuleSettingsController(Notification, $state, $translate, ModuleSettings) {
		var vm = this;

		vm.save = save;
		vm.loadAll = loadAll;

		function save() {
			try {
				ModuleSettings.save(vm.settings, function(httpResponse) {
					Notification.success({message: $translate.instant('pharmaPortalApp.moduleSettings.messages.success'), delay: 5000});
				});
			} catch (err) {
				Notification.error({message: $translate.instant('pharmaPortalApp.moduleSettings.messages.error'), delay: ''});
			}
		}

		function loadAll() {
			vm.settings = ModuleSettings.query();
		}
		loadAll();
	}
})();


(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('ExternalSyncsController', ExternalSyncsController);

    ExternalSyncsController.$inject = ['Notification', '$state', '$filter', '$scope', 'AdminSettings', '$translate'];

    function ExternalSyncsController(Notification, $state, $filter, $scope, AdminSettings, $translate) {

        $scope.syncProducts = function () {
            AdminSettings.syncProductsServ();
            Notification.info({message: $translate.instant('pharmaPortalApp.externalSyncs.syncNotif'), delay: 5000});
        };
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('admin-settings', {
			parent : 'entity',
			url : '/admin-settings',
			data : {
				authorities : [ 'ROLE_SUPER_ADMIN' ],
				pageTitle : 'pharmaPolicyApp.adminSettings.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/admin-settings/admin-settings.html',
					controller : 'AdminSettingsController',
					controllerAs : 'vm'
				},
				'module-settings-view@admin-settings' : {
					templateUrl : 'app/entities/admin-settings/module-settings.html',
					controller : 'ModuleSettingsController',
					controllerAs : 'vm'
				},
				'policy-settings-view@admin-settings' : {
					templateUrl : 'app/entities/admin-settings/policy-settings.html',
					controller : 'PolicySettingsController',
					controllerAs : 'vm'
				},
				'theme-settings-view@admin-settings' : {
					templateUrl : 'app/entities/admin-settings/theme-settings.html',
					controller : 'ThemeSettingsController',
					controllerAs : 'vm'
				},
                'external-syncs-view@admin-settings':{
                    templateUrl : 'app/entities/admin-settings/external-syncs.html',
                    controller : 'ExternalSyncsController',
                    controllerAs : 'vm'
                }
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('adminSettings');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('module-settings', {
			parent : 'entity',
			url : '/module-settings',
			data : {
				authorities : [ 'ROLE_SUPER_ADMIN' ],
				pageTitle : 'pharmaPortalApp.moduleSettings.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/admin-settings/module-settings.html',
					controller : 'ModuleSettingsController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('adminSettings');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('policy-settings', {
			parent : 'entity',
			url : '/policy-settings',
			data : {
				authorities : [ 'ROLE_SUPER_ADMIN' ],
				pageTitle : 'pharmaPortalApp.policySettings.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/admin-settings/policy-settings.html',
					controller : 'PolicySettingsController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('adminSettings');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('theme-settings', {
			parent : 'entity',
			url : '/theme-settings',
			data : {
				authorities : [ 'ROLE_SUPER_ADMIN' ],
				pageTitle : 'pharmaPortalApp.themeSettings.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/entities/admin-settings/theme-settings.html',
					controller : 'ThemeSettingsController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('adminSettings');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				} ]
			}
		}).state('external-syncs',{
		    parent : 'entity',
            url : '/external-syncs',
            data : {
		        authorities : [ 'ROLE_SUPER_ADMIN' ],
                pageTitle : 'pharmaPortalApp.externalSyncs.home.title'
            },
            views : {
		        'content@' : {
                    templateUrl : 'app/entities/admin-settings/external-syncs.html',
                    controller : 'ExternalSyncsController',
                    controllerAs : 'vm'
                }
            },
            resolve : {
                translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('adminSettings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                } ]
            }
        });
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('AdminSettingsController', AdminSettingsController);

	AdminSettingsController.$inject = [ '$scope' ];

	function AdminSettingsController($scope) {
		var vm = this;
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').filter('words', words);

	function words() {
		return wordsFilter;

		function wordsFilter(input, words) {
			if (isNaN(words)) {
				return input;
			}
			if (words <= 0) {
				return '';
			}
			if (input) {
				var inputWords = input.split(/\s+/);
				if (inputWords.length > words) {
					input = inputWords.slice(0, words).join(' ') + '...';
				}
			}
			return input;
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').filter('characters', characters);

	function characters() {
		return charactersFilter;

		function charactersFilter(input, chars, breakOnWord) {
			if (isNaN(chars)) {
				return input;
			}
			if (chars <= 0) {
				return '';
			}
			if (input && input.length > chars) {
				input = input.substring(0, chars);

				if (!breakOnWord) {
					var lastspace = input.lastIndexOf(' ');
					// Get last space
					if (lastspace !== -1) {
						input = input.substr(0, lastspace);
					}
				} else {
					while (input.charAt(input.length - 1) === ' ') {
						input = input.substr(0, input.length - 1);
					}
				}
				return input + '...';
			}
			return input;
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('tableHoverHighlight', tableHoverHighlight);

	function tableHoverHighlight() {
		var directive = {
			restrict : 'A',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element) {
			var highlightClass = "success";
			// DELEGATE ON TD:HOVER THE ADD AND REMOVE OF CLASS 'hover'
			$(element).delegate('td', 'mouseover mouseleave', function(e) {
				if (e.type == 'mouseover') {
					var curIdx = $(this).index() + 1;
					$(this).parent().addClass(highlightClass);
					$(element).find('tbody td:nth-child(' + (curIdx) + ')').addClass(highlightClass);
					$(element).find('thead th:nth-child(' + (curIdx) + ')').addClass(highlightClass);
					$(element).find('thead tr.topHeader th').removeClass(highlightClass);

					var j = 0;
					for (var i = 1; i <= $(this).index(); i++) {
						var elm = $(element).find('tr.topHeader th:nth-child(' + i + ')');

						if (elm.attr("colspan")) {
							curIdx -= parseInt(elm.attr("colspan"));
						} else {
							curIdx -= 1;
						}
						if (curIdx > 0) {
							j++;
						}
					}
					$(element).find('tr.topHeader th:nth-child(' + (j + 1) + ')').addClass(highlightClass);

					// HOVER ONLY IF HAS FLOAT THEAD
					var elm2 = $(element).parent().find('.floatThead-container .floatThead-table thead');
					if ($(elm2).length) {
						var curIdx2 = $(this).index() + 1;
						$(elm2).find('tr th:nth-child(' + (curIdx2) + ')').addClass(highlightClass);
						$(elm2).find('tr.topHeader th').removeClass(highlightClass);

						var k = 0;
						for (var i = 1; i <= $(this).index(); i++) {
							var el = $(elm2).find('tr.topHeader th:nth-child(' + i + ')');

							if (el.attr("colspan")) {
								curIdx2 -= parseInt(el.attr("colspan"));
							} else {
								curIdx2 -= 1;
							}
							if (curIdx2 > 0) {
								k++;
							}
						}
						$(elm2).find('tr.topHeader th:nth-child(' + (k + 1) + ')').addClass(highlightClass);
					}
				} else {
					$(element).find('td:nth-child(' + ($(this).index() + 1) + ')').removeClass(highlightClass);
					$(element).find('tr, th').removeClass(highlightClass);
					// UN-HOVER ONLY IF HAS FLOAT THEAD
					var elm2 = $(element).parent().find('.floatThead-container .floatThead-table thead');
					if ($(elm2).length) {
						$(elm2).find('th').removeClass(highlightClass);
					}
				}
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('jhSortBy', jhSortBy);

	function jhSortBy() {
		var directive = {
			restrict : 'A',
			scope : false,
			require : '^jhSort',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs, parentCtrl) {
			element.bind('click', function() {
				parentCtrl.sort(attrs.jhSortBy);
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('jhSort', jhSort);

	function jhSort() {
		var directive = {
			restrict : 'A',
			scope : {
				predicate : '=jhSort',
				ascending : '=',
				callback : '&'
			},
			controller : SortController,
			controllerAs : 'vm',
			bindToController : true
		};

		return directive;
	}

	SortController.$inject = [ '$scope', '$element' ];

	function SortController($scope, $element) {
		var vm = this;

		vm.applyClass = applyClass;
		vm.resetClasses = resetClasses;
		vm.sort = sort;
		vm.triggerApply = triggerApply;

		$scope.$watchGroup([ 'vm.predicate', 'vm.ascending' ], vm.triggerApply);
		vm.triggerApply();

		function applyClass(element) {
			var thisIcon = element.find('i.fa'), sortIcon = 'fa-sort', sortAsc = 'fa-sort-alpha-desc', sortDesc = 'fa-sort-alpha-asc', remove = sortIcon + ' ' + sortDesc, add = sortAsc;
			if (!vm.ascending) {
				remove = sortIcon + ' ' + sortAsc;
				add = sortDesc;
			}
			vm.resetClasses();
			thisIcon.removeClass(remove);
			thisIcon.addClass(add);
		}

		function resetClasses() {
			var allThIcons = $element.find('i.fa'), sortIcon = 'fa-sort', sortAsc = 'fa-sort-alpha-desc', sortDesc = 'fa-sort-alpha-asc';
			allThIcons.removeClass(sortAsc + ' ' + sortDesc);
			allThIcons.addClass(sortIcon);
		}

		function sort(field) {
			if (field !== vm.predicate) {
				vm.ascending = true;
			} else {
				vm.ascending = !vm.ascending;
			}
			vm.predicate = field;
			$scope.$apply();
			vm.callback();
		}

		function triggerApply(values) {
			vm.resetClasses();
			if (values && values[0] !== '_score') {
				vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('price', price);

	price.$inject = [ '$filter' ];

	function price($filter) {
		var directive = {
			restrict : 'A',
			require : 'ngModel',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs, ngModelController) {
			ngModelController.$parsers.push(function(data) {
				// convert data from view format to model format

				data = $filter('comma2decimal')(data);

				return data;
			});

			ngModelController.$formatters.push(function(data) {
				// convert data from model format to view format

				data = $filter('decimal2comma')(data);

				return data;
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').filter('prefixTranslate', prefixTranslate);

	prefixTranslate.$inject = [ '$filter' ];

	function prefixTranslate($filter) {
		return prefixTranslateFilter;

		function prefixTranslateFilter(input, param, prefix) {
			if (!param) {
				return input;
			}

			var searchVal = param.toLowerCase();
			var result = [];
			angular.forEach(input, function(value) {
				var translated = "";
				if (prefix) {
					translated = $filter('translate')(prefix + value);
				} else {
					translated = $filter('translate')(value);
				}
				if (translated.toLowerCase().indexOf(searchVal) !== -1) {
					result.push(value);
				}
			});
			return result;

			if (input !== null) {
				input = input.toLowerCase();
				input = input.substring(0, 1).toUpperCase() + input.substring(1);
			}
			return input;
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('ParseLinks', ParseLinks);

	function ParseLinks() {

		var service = {
			parse : parse
		};

		return service;

		function parse(header) {
			if (header.length === 0) {
				throw new Error('input must not be of zero length');
			}

			// Split parts by comma
			var parts = header.split(',');
			var links = {};
			// Parse each part into a named link
			angular.forEach(parts, function(p) {
				var section = p.split('>;');
				if (section.length !== 2) {
					throw new Error('section could not be split on ">;"');
				}
				var url = section[0].replace(/<(.*)/, '$1').trim();
				var queryString = {};
				url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function($0, $1, $2, $3) {
					queryString[$1] = $3;
				});
				var page = queryString.page;
				if (angular.isString(page)) {
					page = parseInt(page);
				}
				var name = section[1].replace(/rel="(.*)"/, '$1').trim();
				links[name] = page;
			});
			return links;
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').filter('parseDate', parseDate);

	parseDate.$inject = [ '$filter' ];

	function parseDate($filter) {
		return parseDateFilter;

		function parseDateFilter(input, param, prefix) {
			if (!param || param.endsWith("yyyy")) {
				var pattern = /(\d{2})(\d{2})(\d{4})/;
				var dt = new Date(input.replace(pattern, '$3-$2-$1'));
				return dt;
			} else {
				var pattern = /(\d{4})(\d{2})(\d{2})/;
				var dt = new Date(input.replace(pattern, '$1-$2-$3'));
				return dt;
			}
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('PaginationUtil', PaginationUtil);

	function PaginationUtil() {

		var service = {
			parseAscending : parseAscending,
			parsePage : parsePage,
			parsePredicate : parsePredicate
		};

		return service;

		function parseAscending(sort) {
			var sortArray = sort.split(',');
			if (sortArray.length > 1) {
				return sort.split(',').slice(-1)[0] === 'asc';
			} else {
				// default to true if no sort defined
				return true;
			}
		}

		// query params are strings, and need to be parsed
		function parsePage(page) {
			return parseInt(page);
		}

		// sort can be in the format `id,asc` or `id`
		function parsePredicate(sort) {
			var sortArray = sort.split(',');
			if (sortArray.length > 1) {
				sortArray.pop();
			}
			return sortArray.join(',');
		}
	}
})();

(function() {
	'use strict';

	var jhiItemCount = {
		template : '<div class="info">{{"global.itemCount.showing" | translate}} '
				+ '{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? ($ctrl.queryCount == 0 ? "0" : "1") : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} '
				+ '{{"global.itemCount.until" | translate}} {{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} '
				+ '{{"global.itemCount.of" | translate}} {{$ctrl.queryCount}} {{"global.itemCount.item" | translate}}</div>',
		bindings : {
			page : '<',
			queryCount : '<total',
			itemsPerPage : '<'
		}
	};

	angular.module('pharmaPortalApp').component('jhiItemCount', jhiItemCount);
})();
(function() {
	'use strict';

	angular
	.module('pharmaPortalApp')
	.filter('decimal2comma', decimal2comma);

	function decimal2comma() {
		return decimal2commaFilter;

		function decimal2commaFilter(input) {
			var ret = (input) ? input.toString().replace(".", ",") : null;
			if (ret) {
				var decArr = ret.split(",");
				if (decArr.length > 1) {
					var dec = decArr[1].length;
					if (dec === 1) {
						ret += "0";
					}
				}//this is to show prices like 12,20 and not 12,2
			}
			return ret;
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('DateUtils', DateUtils);

	DateUtils.$inject = [ '$filter' ];

	function DateUtils($filter) {

		var service = {
			convertDateTimeFromServer : convertDateTimeFromServer,
			convertLocalDateFromServer : convertLocalDateFromServer,
			convertLocalDateToServer : convertLocalDateToServer,
			dateformat : dateformat
		};

		return service;

		function convertDateTimeFromServer(date) {
			if (date) {
				return new Date(date);
			} else {
				return null;
			}
		}

		function convertLocalDateFromServer(date) {
			if (date) {
				var dateString = date.split('-');
				return new Date(dateString[0], dateString[1] - 1, dateString[2]);
			}
			return null;
		}

		function convertLocalDateToServer(date) {
			if (date) {
				return $filter('date')(date, 'yyyy-MM-dd');
			} else {
				return null;
			}
		}

		function dateformat() {
			return 'yyyy-MM-dd';
		}
	}

})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils($window) {

        var service = {
            abbreviate: abbreviate,
            viewServerFile: viewServerFile,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate(text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function viewServerFile(result) {
            var url = URL.createObjectURL(new Blob([result.data]));
            var link = document.createElement('a');
            link.href = url;
            link.style = 'visibility:hidden';
            link.download = result.filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        function byteSize(base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile(type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64(file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
	'use strict';

	angular
	.module('pharmaPortalApp')
	.filter('comma2decimal', comma2decimal);

	function comma2decimal() {
		return comma2decimalFilter;

		function comma2decimalFilter(input) {
			var ret = (input) ? input.toString().trim().replace(",", ".") : null;
			if(isNaN(ret)) {
			    return input;
            }
            return parseFloat(ret);
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').filter('capitalize', capitalize);

	function capitalize() {
		return capitalizeFilter;

		function capitalizeFilter(input) {
			if (input !== null) {
				input = input.toLowerCase();
				input = input.substring(0, 1).toUpperCase() + input.substring(1);
			}
			return input;
		}
	}
})();

(function() {
	/* jshint bitwise: false */
	'use strict';

	angular.module('pharmaPortalApp').factory('Base64', Base64);

	function Base64() {
		var keyStr = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' + 'wxyz0123456789+/' + '=';

		var service = {
			decode : decode,
			encode : encode
		};

		return service;

		function encode(input) {
			var output = '', chr1, chr2, chr3, enc1, enc2, enc3, enc4, i = 0;

			while (i < input.length) {
				chr1 = input.charCodeAt(i++);
				chr2 = input.charCodeAt(i++);
				chr3 = input.charCodeAt(i++);

				enc1 = chr1 >> 2;
				enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
				enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
				enc4 = chr3 & 63;

				if (isNaN(chr2)) {
					enc3 = enc4 = 64;
				} else if (isNaN(chr3)) {
					enc4 = 64;
				}

				output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
			}

			return output;
		}

		function decode(input) {
			var output = '', chr1, chr2, chr3, enc1, enc2, enc3, enc4, i = 0;

			// remove all characters that are not A-Z, a-z, 0-9, +, /, or =
			input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

			while (i < input.length) {
				enc1 = keyStr.indexOf(input.charAt(i++));
				enc2 = keyStr.indexOf(input.charAt(i++));
				enc3 = keyStr.indexOf(input.charAt(i++));
				enc4 = keyStr.indexOf(input.charAt(i++));

				chr1 = (enc1 << 2) | (enc2 >> 4);
				chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
				chr3 = ((enc3 & 3) << 6) | enc4;

				output = output + String.fromCharCode(chr1);

				if (enc3 !== 64) {
					output = output + String.fromCharCode(chr2);
				}
				if (enc4 !== 64) {
					output = output + String.fromCharCode(chr3);
				}
			}

			return output;
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('login', {
			parent : 'app',
			url : '/',
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/components/login/login.html',
					controller : 'LoginController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				mainTranslatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('login');
					return $translate.refresh();
				} ]
			}
		});
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('LoginService', LoginService);

	LoginService.$inject = [ '$uibModal', '$state' ];

	function LoginService($uibModal, $state) {
		var service = {
			open : open
		};

		var modalInstance = null;
		var resetModal = function() {
			modalInstance = null;
		};

		return service;

		function open() {
			//	$state.go('home');
			//	if (modalInstance !== null) return;
			//
			//	modalInstance = $uibModal.open({
			//		animation: true,
			//		templateUrl: 'app/components/login/login.html',
			//		controller: 'LoginController',
			//		controllerAs: 'vm',
			//		resolve: {
			//			translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
			//				$translatePartialLoader.addPart('login');
			//				return $translate.refresh();
			//			}]
			//		}
			//	});
			//
			//	modalInstance.result.then(
			//		resetModal,
			//		resetModal
			//	);
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('LoginController', LoginController);

	LoginController.$inject = ['$uibModalInstance', '$rootScope', '$state', '$timeout', 'Auth'];

	function LoginController ($uibModalInstance, $rootScope, $state, $timeout, Auth) {
		var vm = this;

		vm.authenticationError = false;
		vm.cancel = cancel;
		vm.credentials = {};
		vm.login = login;
		vm.password = null;
		vm.rememberMe = true;
		vm.requestResetPassword = requestResetPassword;
		vm.username = null;

		$timeout(function (){angular.element('#username').focus();});

		function cancel () {
			vm.credentials = {
					username: null,
					password: null,
					rememberMe: true
			};
			vm.authenticationError = false;
			$uibModalInstance.dismiss('cancel');
		}

		function login (event) {
			event.preventDefault();
			Auth.login({
				username: vm.username,
				password: vm.password,
				rememberMe: vm.rememberMe
			}).then(function () {
				vm.authenticationError = false;
				$uibModalInstance.close();
				if ($state.current.name === 'activate' || $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
					$state.go('home');
				}

				$rootScope.$broadcast('authenticationSuccess');

				// previousState was set in the authExpiredInterceptor before
				// being redirected to login modal.
				// since login is successful, go to stored previousState and
				// clear previousState
				if (Auth.getPreviousState()) {
					var previousState = Auth.getPreviousState();
					Auth.resetPreviousState();
					$state.go(previousState.name, previousState.params);
				}
			}).catch(function () {
				vm.authenticationError = true;
			});
		}

		function requestResetPassword () {
			$uibModalInstance.dismiss('cancel');
			$state.go('requestReset');
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('JhiLanguageService', JhiLanguageService);

	JhiLanguageService.$inject = [ '$q', '$http', '$translate', 'LANGUAGES' ];

	function JhiLanguageService($q, $http, $translate, LANGUAGES) {
		var service = {
			getAll : getAll,
			getCurrent : getCurrent
		};

		return service;

		function getAll() {
			var deferred = $q.defer();
			deferred.resolve(LANGUAGES);
			return deferred.promise;
		}

		function getCurrent() {
			var deferred = $q.defer();
			var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

			deferred.resolve(language);

			return deferred.promise;
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').filter('findLanguageFromKey', findLanguageFromKey);

	function findLanguageFromKey() {
		return findLanguageFromKeyFilter;

		function findLanguageFromKeyFilter(lang) {
			return {
				'ca' : 'Català',
				'cs' : 'Český',
				'da' : 'Dansk',
				'de' : 'Deutsch',
				'el' : 'Ελληνικά',
				'en' : 'English',
				'es' : 'Español',
				'et' : 'Eesti',
				'fr' : 'Français',
				'gl' : 'Galego',
				'hu' : 'Magyar',
				'hi' : 'हिंदी',
				'it' : 'Italiano',
				'ja' : '日本語',
				'ko' : '한국어',
				'mr' : 'मराठी',
				'nl' : 'Nederlands',
				'pl' : 'Polski',
				'pt-br' : 'Português (Brasil)',
				'pt-pt' : 'Português',
				'ro' : 'Română',
				'ru' : 'Русский',
				'sk' : 'Slovenský',
				'sr' : 'Srpski',
				'sv' : 'Svenska',
				'ta' : 'தமிழ்',
				'tr' : 'Türkçe',
				'vi' : 'Tiếng Việt',
				'zh-cn' : '中文（简体）',
				'zh-tw' : '繁體中文'
			}[lang];
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('JhiLanguageController', JhiLanguageController);

	JhiLanguageController.$inject = [ '$translate', 'JhiLanguageService', 'tmhDynamicLocale' ];

	function JhiLanguageController($translate, JhiLanguageService, tmhDynamicLocale) {
		var vm = this;

		vm.changeLanguage = changeLanguage;
		vm.languages = null;

		JhiLanguageService.getAll().then(function(languages) {
			vm.languages = languages;
		});

		function changeLanguage(languageKey) {
			$translate.use(languageKey);
			tmhDynamicLocale.set(languageKey);
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp')

	/*
	 * Languages codes are ISO_639-1 codes, see
	 * http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes They are written in
	 * English to avoid character encoding issues (not a perfect solution)
	 */
	.constant('LANGUAGES', [ 'pt-pt'
	// jhipster-needle-i18n-language-constant - JHipster will add/remove
	// languages in this array
	]);
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('showValidation', showValidation);

	function showValidation() {
		var directive = {
			restrict : 'A',
			require : 'form',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs, formCtrl) {
			element.find('.form-group').each(function() {
				var $formGroup = angular.element(this);
				var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

				if ($inputs.length > 0) {
					$inputs.each(function() {
						var $input = angular.element(this);
						var inputName = $input.attr('name');
						scope.$watch(function() {
							return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
						}, function(isInvalid) {
							$formGroup.toggleClass('has-error', isInvalid);
						});
					});
				}
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').constant('paginationConstants', {
		'itemsPerPage' : 20
	});
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('onEnter', onEnter);

	function onEnter() {
		var directive = {
			restrict : 'A',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			element.bind("keydown keypress", function(event) {
				if (event.which === 13) {
					scope.$apply(function() {
						scope.$eval(attrs.onEnter);
					});

					event.preventDefault();
				}
			});
		}
		;
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('minbytes', minbytes);

	function minbytes() {
		var directive = {
			restrict : 'A',
			require : '?ngModel',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs, ngModel) {
			if (!ngModel) {
				return;
			}

			ngModel.$validators.minbytes = function(modelValue) {
				return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
			};
		}

		function endsWith(suffix, str) {
			return str.indexOf(suffix, str.length - suffix.length) !== -1;
		}

		function paddingSize(base64String) {
			if (endsWith('==', base64String)) {
				return 2;
			}
			if (endsWith('=', base64String)) {
				return 1;
			}
			return 0;
		}

		function numberOfBytes(base64String) {
			return base64String.length / 4 * 3 - paddingSize(base64String);
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('maxbytes', maxbytes);

	function maxbytes() {
		var directive = {
			restrict : 'A',
			require : '?ngModel',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs, ngModel) {
			if (!ngModel) {
				return;
			}

			ngModel.$validators.maxbytes = function(modelValue) {
				return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
			};
		}

		function endsWith(suffix, str) {
			return str.indexOf(suffix, str.length - suffix.length) !== -1;
		}

		function paddingSize(base64String) {
			if (endsWith('==', base64String)) {
				return 2;
			}
			if (endsWith('=', base64String)) {
				return 1;
			}
			return 0;
		}

		function numberOfBytes(base64String) {
			return base64String.length / 4 * 3 - paddingSize(base64String);
		}
	}

})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('fixSelectedItem', fixSelectedItem);

	function fixSelectedItem() {
		var directive = {
			restrict : 'A',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element) {
			var choices;
			var currentSelectedText;
			var choiceText;
			/*
			 * WATCHES FOR THE CHOICES LIST LENGTH WHICH CHANGES WHEN THE LIST
			 * IS OPEN
			 */
			scope.$watch(function() {
				return element.find('.ui-select-choices-row').length;
			}, function() {
				choices = element.find('.ui-select-choices-row');
				element.find(".ui-select-choices-group div").removeClass("active");
				if (choices.length > 0) {
					currentSelectedText = element.find('.ui-select-match .ui-select-match-text').text();
					choices.each(function($index) {
						choiceText = $(this).find('.ui-select-choices-row-inner > span').text();
						if (choiceText == currentSelectedText) {
							choices.eq($index).addClass('selected');
							choices.eq($index).addClass('active');
						}
					});
				}
				/* END WATCH */
			});
		}
	}
})();
(function () {
    'use strict';

    angular.module('pharmaPortalApp').directive('autoFocus', autoFocus);

    function autoFocus() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc($scope, $element) {
            $timeout(function () {
                $element[0].focus();
            }, 0);
        };
    }
})();

(function() {
	'use strict';

	var jhiAlertError = {
		template : '<div class="alerts" ng-cloak="">' + '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">'
				+ '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' + '</div>' + '</div>',
		controller : jhiAlertErrorController
	};

	angular.module('pharmaPortalApp').component('jhiAlertError', jhiAlertError);

	jhiAlertErrorController.$inject = [ '$scope', 'AlertService', '$rootScope', '$translate' ];

	function jhiAlertErrorController($scope, AlertService, $rootScope, $translate) {
		var vm = this;

		vm.alerts = [];

		function addErrorAlert(message, key, data) {
			key = key ? key : message;
			vm.alerts.push(AlertService.add({
				type : 'danger',
				msg : key,
				params : data,
				timeout : 5000,
				toast : AlertService.isToast(),
				scoped : true
			}, vm.alerts));
		}

		var cleanHttpErrorListener = $rootScope.$on('pharmaPortalApp.httpError', function(event, httpResponse) {
			var i;
			event.stopPropagation();
			switch (httpResponse.status) {
			// connection refused, server not reachable
			case 0:
				addErrorAlert('Server not reachable', 'error.server.not.reachable');
				break;

			case 400:
				var headers = Object.keys(httpResponse.headers()).filter(function(header) {
					return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
				}).sort();
				var errorHeader = httpResponse.headers(headers[0]);
				var entityKey = httpResponse.headers(headers[1]);
				if (errorHeader) {
					var entityName = $translate.instant('global.menu.entities.' + entityKey);
					addErrorAlert(errorHeader, errorHeader, {
						entityName : entityName
					});
				} else if (httpResponse.data && httpResponse.data.fieldErrors) {
					for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
						var fieldError = httpResponse.data.fieldErrors[i];
						// convert 'something[14].other[4].id' to
						// 'something[].other[].id' so translations can be
						// written to it
						var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
						var fieldName = $translate.instant('pharmaPortalApp.' + fieldError.objectName + '.' + convertedField);
						addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {
							fieldName : fieldName
						});
					}
				} else if (httpResponse.data && httpResponse.data.message) {
					addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
				} else {
					addErrorAlert(httpResponse.data);
				}
				break;

			case 404:
				addErrorAlert('Not found', 'error.url.not.found');
				break;

			default:
				if (httpResponse.data && httpResponse.data.message) {
					addErrorAlert(httpResponse.data.message);
				} else {
					addErrorAlert(angular.toJson(httpResponse));
				}
			}
		});

		$scope.$on('$destroy', function() {
			if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
				cleanHttpErrorListener();
				vm.alerts = [];
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').provider('AlertService', AlertService);

	function AlertService() {
		this.toast = false;
		/* jshint validthis: true */
		this.$get = getService;

		this.showAsToast = function(isToast) {
			this.toast = isToast;
		};

		getService.$inject = [ '$timeout', '$sce', '$translate' ];

		function getService($timeout, $sce, $translate) {
			var toast = this.toast, alertId = 0, // unique id for each alert.
													// Starts from 0.
			alerts = [], timeout = 5000; // default timeout

			return {
				factory : factory,
				isToast : isToast,
				add : addAlert,
				closeAlert : closeAlert,
				closeAlertByIndex : closeAlertByIndex,
				clear : clear,
				get : get,
				success : success,
				error : error,
				info : info,
				warning : warning
			};

			function isToast() {
				return toast;
			}

			function clear() {
				alerts = [];
			}

			function get() {
				return alerts;
			}

			function success(msg, params, position) {
				return this.add({
					type : 'success',
					msg : msg,
					params : params,
					timeout : timeout,
					toast : toast,
					position : position
				});
			}

			function error(msg, params, position) {
				return this.add({
					type : 'danger',
					msg : msg,
					params : params,
					timeout : timeout,
					toast : toast,
					position : position
				});
			}

			function warning(msg, params, position) {
				return this.add({
					type : 'warning',
					msg : msg,
					params : params,
					timeout : timeout,
					toast : toast,
					position : position
				});
			}

			function info(msg, params, position) {
				return this.add({
					type : 'info',
					msg : msg,
					params : params,
					timeout : timeout,
					toast : toast,
					position : position
				});
			}

			function factory(alertOptions) {
				var alert = {
					type : alertOptions.type,
					msg : $sce.trustAsHtml(alertOptions.msg),
					id : alertOptions.alertId,
					timeout : alertOptions.timeout,
					toast : alertOptions.toast,
					position : alertOptions.position ? alertOptions.position : 'top right',
					scoped : alertOptions.scoped,
					close : function(alerts) {
						return closeAlert(this.id, alerts);
					}
				};
				if (!alert.scoped) {
					alerts.push(alert);
				}
				return alert;
			}

			function addAlert(alertOptions, extAlerts) {
				alertOptions.alertId = alertId++;
				alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
				var that = this;
				var alert = this.factory(alertOptions);
				if (alertOptions.timeout && alertOptions.timeout > 0) {
					$timeout(function() {
						that.closeAlert(alertOptions.alertId, extAlerts);
					}, alertOptions.timeout);
				}
				return alert;
			}

			function closeAlert(id, extAlerts) {
				var thisAlerts = extAlerts ? extAlerts : alerts;
				return closeAlertByIndex(thisAlerts.map(function(e) {
					return e.id;
				}).indexOf(id), thisAlerts);
			}

			function closeAlertByIndex(index, thisAlerts) {
				return thisAlerts.splice(index, 1);
			}
		}
	}
})();

(function() {
	'use strict';

	var jhiAlert = {
		template : '<div class="alerts" ng-cloak="">' + '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">'
				+ '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' + '</div>' + '</div>',
		controller : jhiAlertController
	};

	angular.module('pharmaPortalApp').component('jhiAlert', jhiAlert);

	jhiAlertController.$inject = [ '$scope', 'AlertService' ];

	function jhiAlertController($scope, AlertService) {
		var vm = this;

		vm.alerts = AlertService.get();
		$scope.$on('$destroy', function() {
			vm.alerts = [];
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('notificationInterceptor', notificationInterceptor);

	notificationInterceptor.$inject = [ '$q', 'AlertService' ];

	function notificationInterceptor($q, AlertService) {
		var service = {
			response : response
		};

		return service;

		function response(response) {
			var headers = Object.keys(response.headers()).filter(function(header) {
				return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
			}).sort();
			var alertKey = response.headers(headers[0]);
			if (angular.isString(alertKey)) {
				AlertService.success(alertKey, {
					param : response.headers(headers[1])
				});
			}
			return response;
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('errorHandlerInterceptor', errorHandlerInterceptor);

	errorHandlerInterceptor.$inject = [ '$q', '$rootScope' ];

	function errorHandlerInterceptor($q, $rootScope) {
		var service = {
			responseError : responseError
		};

		return service;

		function responseError(response) {
			if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0)))) {
				$rootScope.$emit('pharmaPortalApp.httpError', response);
			}
			return $q.reject(response);
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('authExpiredInterceptor', authExpiredInterceptor);

	authExpiredInterceptor.$inject = [ '$rootScope', '$q', '$injector' ];

	function authExpiredInterceptor($rootScope, $q, $injector) {
		var service = {
			responseError : responseError
		};

		return service;

		function responseError(response) {
			// If we have an unauthorized request we redirect to the login page
			// Don't do this check on the account API to avoid infinite loop
			if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
				var Auth = $injector.get('Auth');
				var to = $rootScope.toState;
				var params = $rootScope.toStateParams;
				Auth.logout();
				if (to.name !== 'accessdenied') {
					Auth.storePreviousState(to.name, params);
				}
				var LoginService = $injector.get('LoginService');
				LoginService.open();
			}
			return $q.reject(response);
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('translationHandler', translationHandler);

	translationHandler.$inject = [ '$rootScope', '$window', '$state', '$translate' ];

	function translationHandler($rootScope, $window, $state, $translate) {
		return {
			initialize : initialize,
			updateTitle : updateTitle
		};

		function initialize() {
			// if the current translation changes, update the window title
			var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
				updateTitle();
			});

			$rootScope.$on('$destroy', function() {
				if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
					translateChangeSuccess();
				}
			});
		}

		// update the window title using params in the following
		// precedence
		// 1. titleKey parameter
		// 2. $state.$current.data.pageTitle (current state page title)
		// 3. 'global.title'
		function updateTitle(titleKey) {
			if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
				titleKey = $state.$current.data.pageTitle;
			}
			$translate(titleKey || 'global.title').then(function(title) {
				$window.document.title = title;
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('stateHandler', stateHandler);

	stateHandler.$inject = [ '$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window', 'Auth', 'Principal', 'VERSION' ];

	function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window, Auth, Principal, VERSION) {
		return {
			initialize : initialize
		};

		function initialize() {
			$rootScope.VERSION = VERSION;

			var stateChangeStart = $rootScope.$on('$stateChangeStart', function(event, toState, toStateParams, fromState) {
				$rootScope.toState = toState;
				$rootScope.toStateParams = toStateParams;
				$rootScope.fromState = fromState;

				// Redirect to a state with an external URL
				// (http://stackoverflow.com/a/30221248/1098564)
				if (toState.external) {
					event.preventDefault();
					$window.open(toState.url, '_self');
				}

				if (Principal.isIdentityResolved()) {
					Auth.authorize();
				}

				// Update the language
				JhiLanguageService.getCurrent().then(function(language) {
					$translate.use(language);
				});
			});

			var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
				var titleKey = 'global.title';

				// Set the page title key to the one configured in state or use
				// default one
				if (toState.data.pageTitle) {
					titleKey = toState.data.pageTitle;
				}
				translationHandler.updateTitle(titleKey);
			});

			$rootScope.$on('$destroy', function() {
				if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
					stateChangeStart();
				}
				if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
					stateChangeSuccess();
				}
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(paginationConfig);

	paginationConfig.$inject = [ 'uibPaginationConfig', 'paginationConstants' ];

	function paginationConfig(uibPaginationConfig, paginationConstants) {
		uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
		uibPaginationConfig.maxSize = 5;
		uibPaginationConfig.boundaryLinks = true;
		uibPaginationConfig.firstText = '«';
		uibPaginationConfig.previousText = '‹';
		uibPaginationConfig.nextText = '›';
		uibPaginationConfig.lastText = '»';
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(pagerConfig);

	pagerConfig.$inject = [ 'uibPagerConfig', 'paginationConstants' ];

	function pagerConfig(uibPagerConfig, paginationConstants) {
		uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
		uibPagerConfig.previousText = '«';
		uibPagerConfig.nextText = '»';
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('translationStorageProvider', translationStorageProvider);

	translationStorageProvider.$inject = [ '$cookies', '$log', 'LANGUAGES' ];

	function translationStorageProvider($cookies, $log, LANGUAGES) {
		return {
			get : get,
			put : put
		};

		function get(name) {
			if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
				$log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "pt-pt"');
				$cookies.putObject(name, 'pt-pt');
			}
			return $cookies.getObject(name);
		}

		function put(name, value) {
			$cookies.putObject(name, value);
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(translationConfig);

	translationConfig.$inject = [ '$translateProvider', 'tmhDynamicLocaleProvider' ];

	function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
		// Initialize angular-translate
		$translateProvider.useLoader('$translatePartialLoader', {
			urlTemplate : 'i18n/{lang}/{part}.json'
		});

		$translateProvider.preferredLanguage('pt-pt');
		$translateProvider.useStorage('translationStorageProvider');
		$translateProvider.useSanitizeValueStrategy('escaped');
		$translateProvider.addInterpolation('$translateMessageFormatInterpolation');

		tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
		tmhDynamicLocaleProvider.useCookieStorage();
		tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(localStorageConfig);

	localStorageConfig.$inject = [ '$localStorageProvider', '$sessionStorageProvider' ];

	function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
		$localStorageProvider.setKeyPrefix('jhi-');
		$sessionStorageProvider.setKeyPrefix('jhi-');
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(httpConfig);

	httpConfig.$inject = [ '$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider' ];

	function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
		// Cache everything except rest api requests
		httpRequestInterceptorCacheBusterProvider.setMatchlist([ /.*api.*/, /.*protected.*/ ], true);

		$urlRouterProvider.otherwise('/');

		$httpProvider.interceptors.push('errorHandlerInterceptor');
		$httpProvider.interceptors.push('authExpiredInterceptor');
		$httpProvider.interceptors.push('notificationInterceptor');
		// jhipster-needle-angularjs-add-interceptor JHipster will add new
		// application http interceptor here

		$urlMatcherFactoryProvider.type('boolean', {
			name : 'boolean',
			decode : function(val) {
				return val === true || val === 'true';
			},
			encode : function(val) {
				return val ? 1 : 0;
			},
			equals : function(a, b) {
				return this.is(a) && a === b;
			},
			is : function(val) {
				return [ true, false, 0, 1 ].indexOf(val) >= 0;
			},
			pattern : /bool|true|0|1/
		});
	}
})();

(function() {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .config(html5ModeConfig);

    html5ModeConfig.$inject = ['$locationProvider'];

    function html5ModeConfig($locationProvider) {
        $locationProvider.html5Mode({ enabled: true, requireBase: true });
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(compileServiceConfig);

	compileServiceConfig.$inject = [ '$compileProvider', 'DEBUG_INFO_ENABLED' ];

	function compileServiceConfig($compileProvider, DEBUG_INFO_ENABLED) {
		// disable debug data on prod profile to improve performance
		$compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

		/*
		 * If you wish to debug an application with this information then you
		 * should open up a debug console in the browser then call this method
		 * directly in this console:
		 * 
		 * angular.reloadWithDebugInfo();
		 */
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(alertServiceConfig);

	alertServiceConfig.$inject = [ 'AlertServiceProvider' ];

	function alertServiceConfig(AlertServiceProvider) {
		// set below to true to make alerts look like toast
		AlertServiceProvider.showAsToast(false);
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('app', {
			abstract: true,
			views: {
				'navbar@': {
					templateUrl: 'app/layouts/navbar/navbar.html',
					controller: 'NavbarController',
					controllerAs: 'vm'
				},
				'sidenav@': {
					templateUrl: 'app/layouts/sidenav/sidenav.html',
					controller: 'SidenavController',
					controllerAs: 'vm'
				},
				'footer@': {
					templateUrl: 'app/layouts/footer/footer.html',
					controller: 'FooterController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				authorize: ['Auth',
					function (Auth) {
					return Auth.authorize();
				}
				],
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('global');
				}]
			}
		});
	}
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('pharmaPortalApp')
        .constant('VERSION', "1.0.7")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['Principal', 'Notification', '$uibModalInstance', '$stateParams', '$translate', 'entity', 'User', 'Company', 'JhiLanguageService', '$scope', '$timeout', 'DataUtils'];

    function UserManagementDialogController(Principal, Notification, $uibModalInstance, $stateParams, $translate, entity, User, Company, JhiLanguageService, $scope, $timeout, DataUtils) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_PHARMA_ADMIN', 'ROLE_PHARMA', 'ROLE_INTRANET', 'ROLE_COMERCIAL', 'ROLE_ADMIN', 'ROLE_PRODUCT_IMPORT', 'ROLE_INFARMED'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;
        if (vm.user.generic == null) {
            vm.user.generic = false;
        }

        vm.companies = Company.query({size: 1000});

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        vm.setThumbnail = function ($file, account) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        account.thumbnail = base64Data;
                        account.thumbnailContentType = $file.type;
                    });
                });
            }
        };

        vm.setSignatureThumbnail = function ($file, account) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        account.signatureThumbnail = base64Data;
                        account.signatureThumbnailContentType = $file.type;
                    });
                });
            }
        };

        vm.validateResponsiveAndWallet = function(){
            vm.user.allowDigitalSignature = false;
            vm.user.technicalDirectorName = null;
            vm.user.professionalWalletNumber = null;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(response) {
            $scope.$emit('updateNavbar');
            vm.isSaving = false;
            $uibModalInstance.close(response);
            Notification.success({
                message: $translate.instant('userManagement.updated', {param: response.login}),
                delay: 5000
            });
        }

        function onSaveError(response) {
            vm.isSaving = false;
            Notification.error({message: $translate.instant(response.headers('x-pharmaportalapp-error')), delay: ''});
        }

        function save() {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                vm.response = User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.response = User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('pharmaPortalApp').controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = [ '$stateParams', 'User' ];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        User.get({
            login : $stateParams.login
        }, function(result) {
            vm.user = result;
            var name = vm.user.firstName + ' ' + vm.user.lastName;
            var initials = name.match(/\b\w/g) || [];
            vm.nameInitials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
        });
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('UserManagementDeleteController', UserManagementDeleteController);

	UserManagementDeleteController.$inject = ['Notification', '$uibModalInstance', '$translate', 'entity', 'User'];

	function UserManagementDeleteController (Notification, $uibModalInstance, $translate, entity, User) {
		var vm = this;

		vm.user = entity;
		vm.clear = clear;
		vm.confirmDelete = confirmDelete;

		function clear () {
			$uibModalInstance.dismiss('cancel');
		}

        function confirmDelete (login) {
			User.delete({login: login}, function (response) {
				$uibModalInstance.close(true);
                Notification.success({message: $translate.instant('userManagement.deleted', {param:login}), delay: 5000});
            }, function (err) {
                $uibModalInstance.close(true);
                Notification.error({message: $translate.instant('userManagement.deletedError', {param:login}), delay: 5000});
            });

        }
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('user-management', {
			parent : 'admin',
			url : '/user-management?page&sort',
			data : {
				authorities : [ 'ROLE_ADMIN' ],
				pageTitle : 'userManagement.home.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/admin/user-management/user-management.html',
					controller : 'UserManagementController',
					controllerAs : 'vm'
				}
			},
			params : {
				page : {
					value : '1',
					squash : true
				},
				sort : {
					value : 'id,asc',
					squash : true
				}
			},
			resolve : {
				pagingParams : [ '$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
					return {
						page : PaginationUtil.parsePage($stateParams.page),
						sort : $stateParams.sort,
						predicate : PaginationUtil.parsePredicate($stateParams.sort),
						ascending : PaginationUtil.parseAscending($stateParams.sort)
					};
				} ],
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('user-management');
					return $translate.refresh();
				} ]

			}
		}).state('user-management-detail', {
			parent : 'admin',
			url : '/user/:login',
			data : {
				authorities : [ 'ROLE_ADMIN' ],
				pageTitle : 'user-management.detail.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/admin/user-management/user-management-detail.html',
					controller : 'UserManagementDetailController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('user-management');
					return $translate.refresh();
				} ]
			}
		}).state('user-management.new', {
			parent : 'user-management',
			url : '/new',
			data : {
				authorities : [ 'ROLE_ADMIN' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/admin/user-management/user-management-dialog.html',
					controller : 'UserManagementDialogController',
					controllerAs : 'vm',
					backdrop : 'static',
					size : 'lg',
					resolve : {
						entity : function() {
							return {
								id : null,
								login : null,
								firstName : null,
								lastName : null,
								email : null,
								activated : true,
								langKey : null,
								createdBy : null,
								createdDate : null,
								lastModifiedBy : null,
								lastModifiedDate : null,
								resetDate : null,
								resetKey : null,
								authorities : null,
                                generic : null
							};
						}
					}
				}).result.then(function() {
					$state.go('user-management', null, {
						reload : true
					});
				}, function() {
					$state.go('user-management');
				});
			} ]
		}).state('user-management.edit', {
			parent : 'user-management',
			url : '/{login}/edit',
			data : {
				authorities : [ 'ROLE_ADMIN' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/admin/user-management/user-management-dialog.html',
					controller : 'UserManagementDialogController',
					controllerAs : 'vm',
					backdrop : 'static',
					size : 'lg',
					resolve : {
						entity : [ 'User', function(User) {
							return User.get({
								login : $stateParams.login
							});
						} ]
					}
				}).result.then(function() {
					$state.go('user-management', null, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		}).state('user-management.delete', {
			parent : 'user-management',
			url : '/{login}/delete',
			data : {
				authorities : [ 'ROLE_ADMIN' ]
			},
			onEnter : [ '$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
				$uibModal.open({
					templateUrl : 'app/admin/user-management/user-management-delete-dialog.html',
					controller : 'UserManagementDeleteController',
					controllerAs : 'vm',
					size : 'md',
					resolve : {
						entity : [ 'User', function(User) {
							return User.get({
								login : $stateParams.login
							});
						} ]
					}
				}).result.then(function() {
					$state.go('user-management', null, {
						reload : true
					});
				}, function() {
					$state.go('^');
				});
			} ]
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('UserManagementController', UserManagementController);

	UserManagementController.$inject = [ 'Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', '$scope' ];

	function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, $scope) {
		var vm = this;

		vm.authorities = [ 'ROLE_USER', 'ROLE_PHARMA_ADMIN', 'ROLE_PHARMA', 'ROLE_INTRANET', 'ROLE_COMERCIAL', 'ROLE_ADMIN', 'ROLE_PRODUCT_IMPORT' , 'ROLE_INFARMED'];
		vm.currentAccount = null;
		vm.languages = null;

		vm.setActive = setActive;
		vm.users = [];

		vm.loadPage = loadPage;
		vm.predicate = pagingParams.predicate;
		vm.reverse = pagingParams.ascending;
		vm.transition = transition;
		vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clearSearchInTable = clearSearchInTable;
        $scope.searchInTable = "";
		vm.loadAll = loadAll;


		vm.loadAll();

		function loadAll() {
			User.query({
				page : pagingParams.page - 1,
				size : vm.itemsPerPage,
				sort : sort()
			}, onSuccess, onError);
			function sort() {
				var result = [ vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc') ];
				if (vm.predicate !== 'id') {
					result.push('id');
				}
				return result;
			}
			function onSuccess(data, headers) {
				// hide anonymous user from user management: it's a required
				// user for Spring Security
				var hiddenUsersSize = 0;
				for ( var i in data) {
					if (data[i]['login'] === 'anonymoususer') {
						data.splice(i, 1);
						hiddenUsersSize++;
					}
				}
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
				vm.queryCount = vm.totalItems;
				vm.users = data;
				vm.page = pagingParams.page;
			}
			function onError(error) {
				AlertService.error(error.data.message);
			}
		}

		function loadPage(page) {
			vm.page = page;
			vm.transition();
		}

		function transition() {
			$state.transitionTo($state.$current, {
				page : vm.page,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
			});
		}

		JhiLanguageService.getAll().then(function(languages) {
			vm.languages = languages;
		});
		Principal.identity().then(function(account) {
			vm.currentAccount = account;
		});

		function setActive(user, isActivated) {
			user.activated = isActivated;
			User.update(user, function() {
				vm.loadAll();
			});
		}

        function clearSearchInTable() {
            $scope.searchInTable = "";
        }
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('jhi-metrics', {
			parent : 'admin',
			url : '/appmetrics',
			data : {
				authorities : [ 'ROLE_ADMIN' ],
				pageTitle : 'metrics.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/admin/metrics/metrics.html',
					controller : 'JhiMetricsMonitoringController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('metrics');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('JhiMetricsService', JhiMetricsService);

	JhiMetricsService.$inject = [ '$rootScope', '$http' ];

	function JhiMetricsService($rootScope, $http) {
		var service = {
			getMetrics : getMetrics,
			threadDump : threadDump
		};

		return service;

		function getMetrics() {
			return $http.get('management/metrics').then(function(response) {
				return response.data;
			});
		}

		function threadDump() {
			return $http.get('management/dump').then(function(response) {
				return response.data;
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

	JhiMetricsMonitoringModalController.$inject = [ '$uibModalInstance', 'threadDump' ];

	function JhiMetricsMonitoringModalController($uibModalInstance, threadDump) {
		var vm = this;

		vm.cancel = cancel;
		vm.getLabelClass = getLabelClass;
		vm.threadDump = threadDump;
		vm.threadDumpAll = 0;
		vm.threadDumpBlocked = 0;
		vm.threadDumpRunnable = 0;
		vm.threadDumpTimedWaiting = 0;
		vm.threadDumpWaiting = 0;

		angular.forEach(threadDump, function(value) {
			if (value.threadState === 'RUNNABLE') {
				vm.threadDumpRunnable += 1;
			} else if (value.threadState === 'WAITING') {
				vm.threadDumpWaiting += 1;
			} else if (value.threadState === 'TIMED_WAITING') {
				vm.threadDumpTimedWaiting += 1;
			} else if (value.threadState === 'BLOCKED') {
				vm.threadDumpBlocked += 1;
			}
		});

		vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting + vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}

		function getLabelClass(threadState) {
			if (threadState === 'RUNNABLE') {
				return 'label-success';
			} else if (threadState === 'WAITING') {
				return 'label-info';
			} else if (threadState === 'TIMED_WAITING') {
				return 'label-warning';
			} else if (threadState === 'BLOCKED') {
				return 'label-danger';
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

	JhiMetricsMonitoringController.$inject = [ '$scope', 'JhiMetricsService', '$uibModal' ];

	function JhiMetricsMonitoringController($scope, JhiMetricsService, $uibModal) {
		var vm = this;

		vm.cachesStats = {};
		vm.metrics = {};
		vm.refresh = refresh;
		vm.refreshThreadDumpData = refreshThreadDumpData;
		vm.servicesStats = {};
		vm.updatingMetrics = true;

		vm.refresh();

		$scope.$watch('vm.metrics', function(newValue) {
			vm.servicesStats = {};
			angular.forEach(newValue.timers, function(value, key) {
				if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
					vm.servicesStats[key] = value;
				}
			});

			vm.cachesStats = {};
			angular.forEach(newValue.gauges, function(value, key) {
				if (key.indexOf('jcache.statistics') !== -1) {
					// remove gets or puts
					var index = key.lastIndexOf('.');
					var newKey = key.substr(0, index);

					// Keep the name of the domain
					vm.cachesStats[newKey] = {
						'name' : newKey.substr(18),
						'value' : value
					};
				}
			});
		});

		function refresh() {
			vm.updatingMetrics = true;
			JhiMetricsService.getMetrics().then(function(promise) {
				vm.metrics = promise;
				vm.updatingMetrics = false;
			}, function(promise) {
				vm.metrics = promise.data;
				vm.updatingMetrics = false;
			});
		}

		function refreshThreadDumpData() {
			JhiMetricsService.threadDump().then(function(data) {
				$uibModal.open({
					templateUrl : 'app/admin/metrics/metrics.modal.html',
					controller : 'JhiMetricsMonitoringModalController',
					controllerAs : 'vm',
					size : 'lg',
					resolve : {
						threadDump : function() {
							return data;
						}

					}
				});
			});
		}

	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('logs', {
			parent : 'admin',
			url : '/logs',
			data : {
				authorities : [ 'ROLE_ADMIN' ],
				pageTitle : 'logs.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/admin/logs/logs.html',
					controller : 'LogsController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('logs');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('LogsService', LogsService);

	LogsService.$inject = [ '$resource' ];

	function LogsService($resource) {
		var service = $resource('management/logs', {}, {
			'findAll' : {
				method : 'GET',
				isArray : true
			},
			'changeLevel' : {
				method : 'PUT'
			}
		});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('LogsController', LogsController);

	LogsController.$inject = [ 'LogsService' ];

	function LogsController(LogsService) {
		var vm = this;

		vm.changeLevel = changeLevel;
		vm.loggers = LogsService.findAll();

		function changeLevel(name, level) {
			LogsService.changeLevel({
				name : name,
				level : level
			}, function() {
				vm.loggers = LogsService.findAll();
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('jhi-health', {
			parent : 'admin',
			url : '/apphealth',
			data : {
				authorities : [ 'ROLE_ADMIN' ],
				pageTitle : 'health.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/admin/health/health.html',
					controller : 'JhiHealthCheckController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('health');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('JhiHealthService', JhiHealthService);

	JhiHealthService.$inject = [ '$rootScope', '$http' ];

	function JhiHealthService($rootScope, $http) {
		var separator = '.';
		var service = {
			checkHealth : checkHealth,
			transformHealthData : transformHealthData,
			getBaseName : getBaseName,
			getSubSystemName : getSubSystemName
		};

		return service;

		function checkHealth() {
			return $http.get('management/health').then(function(response) {
				return response.data;
			});
		}

		function transformHealthData(data) {
			var response = [];
			flattenHealthData(response, null, data);
			return response;
		}

		function getBaseName(name) {
			if (name) {
				var split = name.split('.');
				return split[0];
			}
		}

		function getSubSystemName(name) {
			if (name) {
				var split = name.split('.');
				split.splice(0, 1);
				var remainder = split.join('.');
				return remainder ? ' - ' + remainder : '';
			}
		}

		/* private methods */
		function flattenHealthData(result, path, data) {
			angular.forEach(data, function(value, key) {
				if (isHealthObject(value)) {
					if (hasSubSystem(value)) {
						addHealthObject(result, false, value, getModuleName(path, key));
						flattenHealthData(result, getModuleName(path, key), value);
					} else {
						addHealthObject(result, true, value, getModuleName(path, key));
					}
				}
			});
			return result;
		}

		function addHealthObject(result, isLeaf, healthObject, name) {

			var healthData = {
				'name' : name
			};
			var details = {};
			var hasDetails = false;

			angular.forEach(healthObject, function(value, key) {
				if (key === 'status' || key === 'error') {
					healthData[key] = value;
				} else {
					if (!isHealthObject(value)) {
						details[key] = value;
						hasDetails = true;
					}
				}
			});

			// Add the of the details
			if (hasDetails) {
				angular.extend(healthData, {
					'details' : details
				});
			}

			// Only add nodes if they provide additional information
			if (isLeaf || hasDetails || healthData.error) {
				result.push(healthData);
			}
			return healthData;
		}

		function getModuleName(path, name) {
			var result;
			if (path && name) {
				result = path + separator + name;
			} else if (path) {
				result = path;
			} else if (name) {
				result = name;
			} else {
				result = '';
			}
			return result;
		}

		function hasSubSystem(healthObject) {
			var result = false;
			angular.forEach(healthObject, function(value) {
				if (value && value.status) {
					result = true;
				}
			});
			return result;
		}

		function isHealthObject(healthObject) {
			var result = false;
			angular.forEach(healthObject, function(value, key) {
				if (key === 'status') {
					result = true;
				}
			});
			return result;
		}

	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('HealthModalController', HealthModalController);

	HealthModalController.$inject = [ '$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName' ];

	function HealthModalController($uibModalInstance, currentHealth, baseName, subSystemName) {
		var vm = this;

		vm.cancel = cancel;
		vm.currentHealth = currentHealth;
		vm.baseName = baseName;
		vm.subSystemName = subSystemName;

		function cancel() {
			$uibModalInstance.dismiss('cancel');
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('JhiHealthCheckController', JhiHealthCheckController);

	JhiHealthCheckController.$inject = [ 'JhiHealthService', '$uibModal' ];

	function JhiHealthCheckController(JhiHealthService, $uibModal) {
		var vm = this;

		vm.updatingHealth = true;
		vm.getLabelClass = getLabelClass;
		vm.refresh = refresh;
		vm.showHealth = showHealth;
		vm.baseName = JhiHealthService.getBaseName;
		vm.subSystemName = JhiHealthService.getSubSystemName;

		vm.refresh();

		function getLabelClass(statusState) {
			if (statusState === 'UP') {
				return 'label-success';
			} else {
				return 'label-danger';
			}
		}

		function refresh() {
			vm.updatingHealth = true;
			JhiHealthService.checkHealth().then(function(response) {
				vm.healthData = JhiHealthService.transformHealthData(response);
				vm.updatingHealth = false;
			}, function(response) {
				vm.healthData = JhiHealthService.transformHealthData(response.data);
				vm.updatingHealth = false;
			});
		}

		function showHealth(health) {
			$uibModal.open({
				templateUrl : 'app/admin/health/health.modal.html',
				controller : 'HealthModalController',
				controllerAs : 'vm',
				size : 'lg',
				resolve : {
					currentHealth : function() {
						return health;
					},
					baseName : function() {
						return vm.baseName;
					},
					subSystemName : function() {
						return vm.subSystemName;
					}

				}
			});
		}

	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('jhi-configuration', {
			parent : 'admin',
			url : '/configuration',
			data : {
				authorities : [ 'ROLE_ADMIN' ],
				pageTitle : 'configuration.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/admin/configuration/configuration.html',
					controller : 'JhiConfigurationController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('configuration');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('JhiConfigurationService', JhiConfigurationService);

	JhiConfigurationService.$inject = [ '$filter', '$http' ];

	function JhiConfigurationService($filter, $http) {
		var service = {
			get : get,
			getEnv : getEnv
		};

		return service;

		function get() {
			return $http.get('management/configprops').then(getConfigPropsComplete);

			function getConfigPropsComplete(response) {
				var properties = [];
				angular.forEach(response.data, function(data) {
					properties.push(data);
				});
				var orderBy = $filter('orderBy');
				return orderBy(properties, 'prefix');
			}
		}

		function getEnv() {
			return $http.get('management/env').then(getEnvComplete);

			function getEnvComplete(response) {
				var properties = {};
				angular.forEach(response.data, function(val, key) {
					var vals = [];
					angular.forEach(val, function(v, k) {
						vals.push({
							key : k,
							val : v
						});
					});
					properties[key] = vals;
				});
				return properties;
			}
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('JhiConfigurationController', JhiConfigurationController);

	JhiConfigurationController.$inject = [ '$filter', 'JhiConfigurationService' ];

	function JhiConfigurationController(filter, JhiConfigurationService) {
		var vm = this;

		vm.allConfiguration = null;
		vm.configuration = null;

		JhiConfigurationService.get().then(function(configuration) {
			vm.configuration = configuration;
		});
		JhiConfigurationService.getEnv().then(function(configuration) {
			vm.allConfiguration = configuration;
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('audits', {
			parent : 'admin',
			url : '/audits',
			data : {
				authorities : [ 'ROLE_ADMIN' ],
				pageTitle : 'audits.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/admin/audits/audits.html',
					controller : 'AuditsController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('audits');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').factory('AuditsService', AuditsService);

	AuditsService.$inject = [ '$resource' ];

	function AuditsService($resource) {
		var service = $resource('management/audits/:id', {}, {
			'get' : {
				method : 'GET',
				isArray : true
			},
			'query' : {
				method : 'GET',
				isArray : true,
				params : {
					fromDate : null,
					toDate : null
				}
			}
		});

		return service;
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('AuditsController', AuditsController);

	AuditsController.$inject = [ '$filter', 'AuditsService', 'ParseLinks' ];

	function AuditsController($filter, AuditsService, ParseLinks) {
		var vm = this;

		vm.audits = null;
		vm.fromDate = null;
		vm.links = null;
		vm.loadPage = loadPage;
		vm.onChangeDate = onChangeDate;
		vm.page = 1;
		vm.previousMonth = previousMonth;
		vm.toDate = null;
		vm.today = today;
		vm.totalItems = null;

		vm.today();
		vm.previousMonth();
		vm.onChangeDate();

		function onChangeDate() {
			var dateFormat = 'yyyy-MM-dd';
			var fromDate = $filter('date')(vm.fromDate, dateFormat);
			var toDate = $filter('date')(vm.toDate, dateFormat);

			AuditsService.query({
				page : vm.page - 1,
				size : 20,
				fromDate : fromDate,
				toDate : toDate
			}, function(result, headers) {
				vm.audits = result;
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
			});
		}

		vm.initialDatePopup = {
			opened : false
		};
		vm.openInitialDatePopup = function() {
			vm.initialDatePopup.opened = true;
		};

		vm.finalDatePopup = {
			opened : false
		};
		vm.openFinalDatePopup = function() {
			vm.finalDatePopup.opened = true;
		};

		vm.dateOptions = {
			formatYear : 'yyyy',
			startingDay : 1,
			showWeeks : false
		};

		// Date picker configuration
		function today() {
			// Today + 1 day - needed if the current day must be included
			var today = new Date();
			vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
		}

		function previousMonth() {
			var fromDate = new Date();
			if (fromDate.getMonth() === 0) {
				fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
			} else {
				fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
			}

			vm.fromDate = fromDate;
		}

		function loadPage(page) {
			vm.page = page;
			vm.onChangeDate();
		}
	}
})();

(function () {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig ($stateProvider) {
		$stateProvider.state('admin', {
			abstract: true,
			parent: 'app'
		});
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('settings', {
			parent : 'account',
			url : '/settings',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'global.menu.account.settings'
			},
			views : {
				'content@' : {
					templateUrl : 'app/account/settings/settings.html',
					controller : 'SettingsController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('account');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function () {
    'use strict';

    angular.module('pharmaPortalApp').controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Notification', 'Principal', 'Auth', 'JhiLanguageService', '$translate', '$scope', '$timeout', 'DataUtils'];

    function SettingsController(Notification, Principal, Auth, JhiLanguageService, $translate, $scope, $timeout, DataUtils) {

        var vm = this;

        vm.save = save;
        vm.settingsAccount = null;

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        /**
         * Store the "settings account" in a separate variable, and not in the shared
         * "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login,
                thumbnail: account.thumbnail,
                thumbnailContentType: account.thumbnailContentType
            };
        };

        Principal.identity().then(function (account) {
            vm.settingsAccount = copyAccount(account);
            var name = vm.settingsAccount.firstName + ' ' + vm.settingsAccount.lastName;
            var initials = name.match(/\b\w/g) || [];
            vm.nameInitials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
        });

        vm.setThumbnail = function ($file, account) {
            if ($file && $file.$error === 'pattern') {return;}

            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        account.thumbnail = base64Data;
                        account.thumbnailContentType = $file.type;
                    });
                });
            }
        };

        function save() {
            Auth.updateAccount(vm.settingsAccount).then(function (response) {
                Principal.identity(true).then(function (account) {
                    vm.settingsAccount = copyAccount(account);
                    $scope.$emit('updateNavbar');
                });

                JhiLanguageService.getCurrent().then(function (current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
                Notification.success({message: $translate.instant('settings.messages.success'), delay: 5000});
            }).catch(function (response) {
                Notification.error({message: $translate.instant(response.headers('x-pharmaportalapp-error')), delay: ''});
            });
        }
    }
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('sessions', {
			parent : 'account',
			url : '/sessions',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'global.menu.account.sessions'
			},
			views : {
				'content@' : {
					templateUrl : 'app/account/sessions/sessions.html',
					controller : 'SessionsController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('account');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('SessionsController', SessionsController);

	SessionsController.$inject = ['Sessions', 'Principal'];

	function SessionsController (Sessions, Principal) {
		var vm = this;

		vm.account = null;
		vm.error = null;
		vm.invalidate = invalidate;
		vm.sessions = Sessions.getAll();
		vm.success = null;

		Principal.identity().then(function(account) {
			vm.account = account;
		});

		function invalidate (series) {
			Sessions.delete({series: encodeURIComponent(series)},
					function () {
				vm.error = null;
				vm.success = 'OK';
				vm.sessions = Sessions.getAll();
			},
			function () {
				vm.success = null;
				vm.error = 'ERROR';
			});
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('requestReset', {
			parent : 'account',
			url : '/reset/request',
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/account/reset/request/reset.request.html',
					controller : 'RequestResetController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('account');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('RequestResetController', RequestResetController);

	RequestResetController.$inject = ['$timeout', 'Auth'];

	function RequestResetController ($timeout, Auth) {
		var vm = this;

		vm.error = null;
		vm.errorEmailNotExists = null;
		vm.requestReset = requestReset;
		vm.resetAccount = {};
		vm.success = null;

		$timeout(function (){angular.element('#email').focus();});

		function requestReset () {
			vm.error = null;
			vm.errorEmailNotExists = null;

			Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
				vm.success = 'OK';
			}).catch(function (response) {
				vm.success = null;
				if (response.status === 400 && response.data === 'e-mail address not registered') {
					vm.errorEmailNotExists = 'ERROR';
				} else {
					vm.error = 'ERROR';
				}
			});
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('finishReset', {
			parent : 'account',
			url : '/reset/finish?key',
			data : {
				authorities : []
			},
			views : {
				'content@' : {
					templateUrl : 'app/account/reset/finish/reset.finish.html',
					controller : 'ResetFinishController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('account');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ResetFinishController', ResetFinishController);

	ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

	function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
		var vm = this;

		vm.keyMissing = angular.isUndefined($stateParams.key);
		vm.confirmPassword = null;
		vm.doNotMatch = null;
		vm.error = null;
		vm.finishReset = finishReset;
		vm.login = LoginService.open;
		vm.resetAccount = {};
		vm.success = null;

		$timeout(function (){angular.element('#password').focus();});

		function finishReset() {
			vm.doNotMatch = null;
			vm.error = null;
			if (vm.resetAccount.password !== vm.confirmPassword) {
				vm.doNotMatch = 'ERROR';
			} else {
				Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
					vm.success = 'OK';
				}).catch(function () {
					vm.success = null;
					vm.error = 'ERROR';
				});
			}
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').directive('passwordStrengthBar', passwordStrengthBar);

	function passwordStrengthBar() {
		var directive = {
			replace : true,
			restrict : 'E',
			template : '<div id="strength">' + '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' + '<ul id="strengthBar">'
					+ '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' + '</ul>' + '</div>',
			scope : {
				passwordToCheck : '='
			},
			link : linkFunc
		};

		return directive;

		/* private helper methods*/

		function linkFunc(scope, iElement) {
			var strength = {
				colors : [ '#F00', '#F90', '#FF0', '#9F0', '#0F0' ],
				mesureStrength : function(p) {

					var _force = 0;
					var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

					var _lowerLetters = /[a-z]+/.test(p);
					var _upperLetters = /[A-Z]+/.test(p);
					var _numbers = /[0-9]+/.test(p);
					var _symbols = _regex.test(p);

					var _flags = [ _lowerLetters, _upperLetters, _numbers, _symbols ];
					var _passedMatches = $.grep(_flags, function(el) {
						return el === true;
					}).length;

					_force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
					_force += _passedMatches * 10;

					// penalty (short password)
					_force = (p.length <= 6) ? Math.min(_force, 10) : _force;

					// penalty (poor variety of characters)
					_force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
					_force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
					_force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

					return _force;

				},
				getColor : function(s) {

					var idx;
					if (s <= 10) {
						idx = 0;
					} else if (s <= 20) {
						idx = 1;
					} else if (s <= 30) {
						idx = 2;
					} else if (s <= 40) {
						idx = 3;
					} else {
						idx = 4;
					}

					return {
						idx : idx + 1,
						col : this.colors[idx]
					};
				}
			};
			scope.$watch('passwordToCheck', function(password) {
				if (password) {
					var c = strength.getColor(strength.mesureStrength(password));
					iElement.removeClass('ng-hide');
					iElement.find('ul').children('li').css({
						'background-color' : '#DDD'
					}).slice(0, c.idx).css({
						'background-color' : c.col
					});
				}
			});
		}
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('password', {
			parent : 'account',
			url : '/password',
			data : {
				authorities : [ 'ROLE_USER' ],
				pageTitle : 'global.menu.account.password'
			},
			views : {
				'content@' : {
					templateUrl : 'app/account/password/password.html',
					controller : 'PasswordController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('account');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('PasswordController', PasswordController);

	PasswordController.$inject = ['Auth', 'Principal'];

	function PasswordController (Auth, Principal) {
		var vm = this;

		vm.changePassword = changePassword;
		vm.doNotMatch = null;
		vm.error = null;
		vm.success = null;

		Principal.identity().then(function(account) {
			vm.account = account;
		});

		function changePassword () {
			if (vm.password !== vm.confirmPassword) {
				vm.error = null;
				vm.success = null;
				vm.doNotMatch = 'ERROR';
			} else {
				vm.doNotMatch = null;
				Auth.changePassword(vm.password).then(function () {
					vm.error = null;
					vm.success = 'OK';
				}).catch(function () {
					vm.success = null;
					vm.error = 'ERROR';
				});
			}
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider' ];

	function stateConfig($stateProvider) {
		$stateProvider.state('activate', {
			parent : 'account',
			url : '/activate?key',
			data : {
				authorities : [],
				pageTitle : 'activate.title'
			},
			views : {
				'content@' : {
					templateUrl : 'app/account/activate/activate.html',
					controller : 'ActivationController',
					controllerAs : 'vm'
				}
			},
			resolve : {
				translatePartialLoader : [ '$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('account');
					return $translate.refresh();
				} ]
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ActivationController', ActivationController);

	ActivationController.$inject = ['$stateParams', 'Auth', '$state'];

	function ActivationController ($stateParams, Auth, $state) {
		var vm = this;
		
		vm.login = login;
		
		Auth.activateAccount({key: $stateParams.key}).then(function () {
			vm.error = null;
			vm.success = 'OK';
		}).catch(function () {
			vm.success = null;
			vm.error = 'ERROR';
		});
		
		function login() {
			$state.go('home');
		}
	}
})();
(function() {
	'use strict';

	angular.module('pharmaPortalApp').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('account', {
			abstract: true,
			parent: 'app'
		});
	}
})();(function(){angular.module('pharmaPortalApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home-fl.html','<div class="container" ng-if="environment != \'IO\' && environment != \'MZ\'"><br><br><br><br><div class="row text-center"><div class="row text-center"><img ng-if="vm.settings.logo" data-ng-src="{{\'data:\' + vm.settings.logoContentType + \';base64,\' + vm.settings.logo}}" alt="{{vm.settings.logoDescription}}" title="{{vm.settings.logoDescription}}"></div></div><div ng-hide="vm.isAuthenticated()"><div class="row text-center"><br><p data-translate="login.title">Sign in</p></div><div class="row text-center"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-offset-4 col-md-4"><form id="loginform" class="form" role="form" ng-submit="vm.login($event)"><div class="form-group input-group"><span class="input-group-addon"><i class="fa fa-user"></i> </span><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username" value="" autocomplete="off"></div><div class="form-group input-group"><span class="input-group-addon"><i class="fa fa-lock"></i> </span><input type="password" class="form-control" id="password" placeholder="{{\'global.form.password.placeholder\' | translate}}" ng-model="vm.password" value="" autocomplete="off"></div><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe"> <span data-translate="login.form.rememberme">Remember me</span></label><button type="submit" class="btn btn-success btn-block"><i class="fa fa-sign-in"></i> <span data-translate="login.form.button">Sign in</span></button><div class="row text-right"><button type="button" class="btn btn-link" ng-click="vm.requestResetPassword()"><span data-translate="login.password.forgot">Did you forget your password?</span></button></div></form></div></div><div ng-show="vm.isAuthenticated()"><br><div class="btn-group btn-group-justified" role="group"><div class="btn-group" role="group"><button class="btn btn-danger btn-block" ng-click="vm.logout()"><i class="fa fa-sign-out"></i>&nbsp;<span data-translate="global.menu.account.logout">Sign out</span></button></div><div class="btn-group" role="group"><button class="btn btn-success btn-block" ng-click="vm.goHome()"><i class="fa fa-shopping-cart"></i>&nbsp;<span data-translate="global.menu.entities.intranet">Intranet</span></button></div></div></div></div>');
$templateCache.put('app/home/home-io-login.html','<div class="container"><br><br><br><br><div class="row text-center"><div class="row text-center"><img ng-if="vm.settings.logo" data-ng-src="{{\'data:\' + vm.settings.logoContentType + \';base64,\' + vm.settings.logo}}" alt="{{vm.settings.logoDescription}}" title="{{vm.settings.logoDescription}}"></div></div><div ng-hide="vm.isAuthenticated()"><div class="row text-center"><br><p data-translate="login.title">Sign in</p></div><div class="row text-center"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-offset-4 col-md-4"><form id="loginform" class="form" role="form" ng-submit="vm.login($event)"><div class="form-group input-group"><span class="input-group-addon"><i class="fa fa-user"></i> </span><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username" value="" autocomplete="off"></div><div class="form-group input-group"><span class="input-group-addon"><i class="fa fa-lock"></i> </span><input type="password" class="form-control" id="password" placeholder="{{\'global.form.password.placeholder\' | translate}}" ng-model="vm.password" value="" autocomplete="off"></div><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe"> <span data-translate="login.form.rememberme">Remember me</span></label><button type="submit" class="btn btn-success btn-block"><i class="fa fa-sign-in"></i> <span data-translate="login.form.button">Sign in</span></button><div class="row text-right"><button type="button" class="btn btn-link" ng-click="vm.requestResetPassword()"><span data-translate="login.password.forgot">Did you forget your password?</span></button></div></form></div></div><div ng-show="vm.isAuthenticated()"><br><div class="btn-group btn-group-justified" role="group"><div class="btn-group" role="group"><button class="btn btn-danger btn-block" ng-click="vm.logout()"><i class="fa fa-sign-out"></i>&nbsp;<span data-translate="global.menu.account.logout">Sign out</span></button></div><div class="btn-group" role="group"><button class="btn btn-success btn-block" ng-click="vm.goHome()"><i class="fa fa-shopping-cart"></i>&nbsp;<span data-translate="global.menu.entities.intranet">Intranet</span></button></div></div></div></div>');
$templateCache.put('app/home/home-io.html','<div class="row website" ng-if="environment == \'IO\'"><!-- FIRST SECTION =================================================================================== --><section id="first_section"><div class="container"><br><br><br><h4>Bem-vindo \xE0 InOut Farma! Identifique-se e ser\xE1 encaminhado para a sua \xE1rea reservada.</h4><br><br><div class="main-circle wow fadeInDown col-md-3 col-sm-6 col-xs-12" data-wow-delay="0.3s" ng-mouseenter="showLabel($event)" ng-mouseleave="hideLabel($event)"><a class="opt1" ng-click="toggleDropdown($event)"></a><div class="main-labels fade popin"><h4>Farm\xE1cias</h4></div></div><div class="main-circle wow fadeInDown col-md-3 col-sm-6 col-xs-12" data-wow-delay="0.6s" ng-mouseenter="showLabel($event)" ng-mouseleave="hideLabel($event)"><a class="opt2" ng-click="toggleDropdown($event)"></a><div class="main-labels fade popin"><h4>Grossistas</h4></div></div><div class="main-circle wow fadeInDown col-md-3 col-sm-6 col-xs-12" data-wow-delay="0.9s" ng-mouseenter="showLabel($event)" ng-mouseleave="hideLabel($event)"><a class="opt3" ng-click="toggleDropdown($event)"></a><div class="main-labels fade popin"><h4>Laborat\xF3rios</h4></div></div><div class="main-circle wow fadeInDown col-md-3 col-sm-6 col-xs-12" data-wow-delay="1.2s" ng-mouseenter="showLabel($event)" ng-mouseleave="hideLabel($event)"><a class="opt4" ng-click="toggleDropdown($event)"></a><div class="main-labels fade popin"><h4>Outros</h4></div></div></div></section><!-- ABOUT US SECTION =================================================================================== --><section id="aboutUs"><div class="container"><h1>Sobre N\xF3s</h1><div class="aboutus_section"><div class="row"><div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pull-right text-center"><img ng-src="content/images/about_img.jpg" style="max-width:450px" class="wow bounceInLeft img-circle" data-wow-delay="0.3s"></div><div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 pull-left"><div class="wow bounceInLeft" data-wow-delay="0.1s"><h3>Bem-vindo ao site da INOUT FARMA.</h3><br><p>A INOUT FARMA tem como principal atividade o com\xE9rcio por grosso de produtos farmac\xEAuticos.</p><br><p>Como empresa moderna, disponibilizamos online todas as informa\xE7\xF5es respeitantes \xE0 nossa oferta de produtos e servi\xE7os.</p><br><p>Se mant\xE9m uma rela\xE7\xE3o comercial com a INOUT FARMA, identifique-se <a ng-click="toggleDropdown($event)">aqui</a> e navegue nos conte\xFAdos direccionados especialmente para si!</p><br><p>Conhe\xE7a tamb\xE9m a nossa pol\xEDtica de qualidade <a href="content/files/Politica_Qualidade_InOut_Farma.pdf" target="_blank">aqui</a>.</p><br></div></div></div></div><ui-carousel class="infinity-carousel animated wow bounceIn" data-wow-delay="0.3s" slides="vm.slides" slides-to-show="3" slides-to-scroll="1" initial-slide="1" autoplay="true" autoplay-speed="5000" dots="true"><carousel-item><div class="img-wrap"><img ng-src="{{item.image}}"></div><span class="text">{{item.text}}</span></carousel-item><carousel-prev><button class="nav prev"><i class="fa fa-chevron-left fa-4x"></i></button></carousel-prev><carousel-next><button class="nav next"><i class="fa fa-chevron-right fa-4x"></i></button></carousel-next></ui-carousel><div class="aboutus_bottom"><span>Ainda n\xE3o \xE9 nosso cliente ou deseja obter mais informa\xE7\xF5es?</span> <a href="#contact" du-smooth-scroll class="contact_btn">Contacte-nos</a></div></div></section><!-- PARTNER SECTION =================================================================================== --><section id="partners"><div class="container"><h1>Parceiros</h1><div id="partner-circles" class="row clearfix"><div class="partner-circle wow fadeInDown col-md-3 col-sm-6 col-xs-12" data-wow-delay="0.3s" ng-mouseenter="showLabel($event)" ng-mouseleave="hideLabel($event)"><span class="opt1"></span><div class="partner-labels fade popin animated"><h4>Farm\xE1cias</h4><p>As farm\xE1cias s\xE3o o centro da nossa actividade. Existimos porque elas existem!</p></div></div><div class="partner-circle wow fadeInDown col-md-3 col-sm-6 col-xs-12" data-wow-delay="0.6s" ng-mouseenter="showLabel($event)" ng-mouseleave="hideLabel($event)"><span class="opt2"></span><div class="partner-labels fade popin"><h4>Grossistas</h4><p>Os grossistas e distribuidores garantem uma optimiza\xE7\xE3o de recursos o que nos permite chegar mais longe!</p></div></div><div class="partner-circle wow fadeInDown col-md-3 col-sm-6 col-xs-12" data-wow-delay="0.9s" ng-mouseenter="showLabel($event)" ng-mouseleave="hideLabel($event)"><span class="opt3"></span><div class="partner-labels fade popin"><h4>Laborat\xF3rio</h4><p>Fazemos a ponte entre a ind\xFAstria e as farm\xE1cias numa \xF3ptica de incremento de sellout!</p></div></div><div class="partner-circle wow fadeInDown col-md-3 col-sm-6 col-xs-12" data-wow-delay="1.2s" ng-mouseenter="showLabel($event)" ng-mouseleave="hideLabel($event)"><span class="opt4"></span><div class="partner-labels fade popin"><h4>Outros</h4><p>Incorporamos no mercado farmac\xEAutico o que melhor se faz nas outras ind\xFAstrias!</p></div></div></div></div></section><!-- CONTACT SECTION =================================================================================== --><section id="contact"><div class="container"><div class="contact_section"><h1>Contactos</h1><div class="row"><div class="col-lg-12 wow fadeInLeft" data-wow-delay="0.3s"><div id="map-canvas" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyCiDLfOX4zuEFVOhWxCKWrk9HEzSaiA2LY"><ng-map center="38.823436, -9.359947" zoom="17" map-type-id="SATELLITE" scrollwheel="false"><marker position="38.823436, -9.359947" title="INOUT Farma"></marker></ng-map></div><br></div></div><div class="row"><div class="col-lg-4 wow fadeInLeft" data-wow-delay="0.6s"><div class="contact_info"><div class="detail"><h4>INOUT FARMA - Sede Social</h4><p>Estrada Nacional 9, Km 17, Armaz\xE9m 1, Ral Sintra,<br>2710-039 Sintra</p><p><i class="fa fa-map-marker"></i> Lat. 38.823436, Long. -9.359947</p></div><div class="detail"><br><h4>INOUT FARMA - Armaz\xE9m</h4><p>Estrada Nacional 9, Km 17, Armaz\xE9m 1, Ral Sintra,<br>2710-039 Sintra</p><p><i class="fa fa-map-marker"></i> Lat. 38.823436, Long. -9.359947</p></div><div class="detail"><br><p><i class="fa fa-phone"></i> +351 217 160 320</p></div><div class="detail"><p><i class="fa fa-fax"></i> +351 210 435 597</p></div><div class="detail"><p><i class="fa fa-envelope-o"></i> <a href="mailto:geral@inoutfarma.pt">geral@inoutfarma.pt</a></p></div></div><div class="clearfix"></div></div><div class="col-lg-8 wow fadeInRight" data-wow-delay="0.9s"><div class="form"><h4>Utilize o formul\xE1rio que se segue para entrar em contacto connosco</h4><form><div class="form-group"><input class="input-text form-control" type="text" id="name" name="name" placeholder="{{\'global.form.name.placeholder\' | translate}}" ng-model="user.name" required></div><div class="form-group"><input class="input-text form-control" type="text" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="user.email" required></div><div class="form-group"><input class="input-text form-control" type="text" id="subjectMessage" name="subjectMessage" placeholder="{{\'global.form.subject.placeholder\' | translate}}" ng-model="user.subjectMessage" required></div><div class="form-group"><textarea class="input-text form-control text-area" id="message" name="message" placeholder="{{\'global.form.message.placeholder\' | translate}}" cols="0" rows="0" ng-model="user.message" required></textarea></div><button id="sendFormButton" class="input-btn" ng-click="sendEmail()">enviar mensagem</button></form></div></div></div></div></div></section></div>');
$templateCache.put('app/home/home-mz.html','<div class="container" ng-if="environment == \'MZ\'"><br><br><br><br><div class="row text-center"><div class="row text-center"><img ng-if="vm.settings.logo" data-ng-src="{{\'data:\' + vm.settings.logoContentType + \';base64,\' + vm.settings.logo}}" alt="{{vm.settings.logoDescription}}" title="{{vm.settings.logoDescription}}"></div></div><div ng-hide="vm.isAuthenticated()"><div class="row text-center"><br><p data-translate="login.title">Sign in</p></div><div class="row text-center"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-offset-4 col-md-4"><form id="loginform" class="form" role="form" ng-submit="vm.login($event)"><div class="form-group input-group"><span class="input-group-addon"><i class="fa fa-user"></i> </span><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username" value="" autocomplete="off"></div><div class="form-group input-group"><span class="input-group-addon"><i class="fa fa-lock"></i> </span><input type="password" class="form-control" id="password" placeholder="{{\'global.form.password.placeholder\' | translate}}" ng-model="vm.password" value="" autocomplete="off"></div><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe"> <span data-translate="login.form.rememberme">Remember me</span></label><button type="submit" class="btn btn-success btn-block"><i class="fa fa-sign-in"></i> <span data-translate="login.form.button">Sign in</span></button><div class="row text-right"><button type="button" class="btn btn-link" ng-click="vm.requestResetPassword()"><span data-translate="login.password.forgot">Did you forget your password?</span></button></div></form></div></div><div ng-show="vm.isAuthenticated()"><br><div class="btn-group btn-group-justified" role="group"><div class="btn-group" role="group"><button class="btn btn-danger btn-block" ng-click="vm.logout()"><i class="fa fa-sign-out"></i>&nbsp;<span data-translate="global.menu.account.logout">Sign out</span></button></div><div class="btn-group" role="group"><button class="btn btn-success btn-block" ng-click="vm.goHome()"><i class="fa fa-shopping-cart"></i>&nbsp;<span data-translate="global.menu.entities.intranet">Intranet</span></button></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div class="container"><div class="col-md-8 col-md-offset-2"><div class="panel panel-default margin-top-20"><div class="panel-heading"><span class="panel-title pull-left" data-translate="activate.title">Activation</span> <span class="clearfix"></span></div><div class="panel-body"><any ng-show="vm.success"><div class="alert alert-success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated</strong></div><span data-translate="activate.messages.success2" translate-compile>Please sign in <a class="alert-link" href="" ng-click="vm.login()">here</a></span></any><any ng-show="vm.error"><div class="alert alert-danger" data-translate="activate.messages.error"><strong>Your user could not be activated</strong></div><span data-translate="activate.messages.error2">Please contact system administrator to activate your account</span></any></div><div class="panel-footer"><div class="text-right"><button type="button" ui-sref="home" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="button" ui-sref="home" class="btn btn-success btn-sm"><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok"> OK</span></button></div></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div class="container"><div class="col-md-8 col-md-offset-2"><form name="form" role="form" ng-submit="vm.changePassword()" class="form-horizontal" show-validation novalidate><div class="panel panel-default margin-top-20"><div class="panel-heading"><span class="panel-title pull-left" data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</span> <span class="clearfix"></span></div><div class="panel-body"><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="form-group"><label class="col-sm-3 control-label" for="password" data-translate="global.form.newpassword">New password</label><div class="col-sm-9"><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-sm-3 control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><div class="col-sm-9"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div><div class="col-sm-12"><password-strength-bar password-to-check="vm.password"></password-strength-bar></div></div><div class="panel-footer"><div class="text-right"><button type="button" ui-sref="home" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="submit" ng-disabled="form.$invalid" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;<span data-translate="password.form.button">Save</span></button></div></div></div></form></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</span> <span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="ipAddress"><span data-translate="sessions.table.ipaddress">IP Address</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="userAgent"><span data-translate="sessions.table.useragent">User agent</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="tokenDate"><span data-translate="sessions.table.date">Date</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="session in vm.sessions | filter:filter | orderBy:predicate:reverse"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-danger btn-xs" ng-click="vm.invalidate(session.series)"><i class="fa fa-close"></i>&nbsp;<span data-translate="sessions.table.button">Invalidate</span></button></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div class="container"><div class="col-md-8 col-md-offset-2"><form name="form" role="form" ng-submit="vm.save()" class="form-horizontal" show-validation novalidate><div class="panel panel-default margin-top-20"><div class="panel-heading"><span class="panel-title pull-left" data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</span> <span class="clearfix"></span></div><div class="panel-body"><div class="form-group"><label class="col-sm-2 control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><div class="col-sm-10"><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><div class="col-sm-10"><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="email" data-translate="global.form.email">E-mail</label><div class="col-sm-10"><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div></div><div class="form-group" ngf-drop ngf-change="vm.setThumbnail($file, vm.settingsAccount)" ngf-pattern="\'image/*\'"><label class="col-sm-2 control-label" data-translate="settings.form.avatar">Avatar</label><div class="col-sm-10"><div><span ng-if="!vm.settingsAccount.thumbnail"><ng-avatar initials="{{vm.nameInitials}}" bind="true" auto-color="true" corner-radius="5" width="100"></ng-avatar></span><img ng-if="vm.settingsAccount.thumbnail" ng-src="{{\'data:\' + vm.settingsAccount.thumbnailContentType + \';base64,\' + vm.settingsAccount.thumbnail}}" style="max-height: 100px; max-width: 100px; border-radius: 5px"><div class="help-block clearfix"><button type="button" id="field_thumbnail_button" ngf-select class="btn btn-warning btn-xs" ngf-change="vm.setThumbnail($file, vm.settingsAccount)" accept="image/*"><i class="fa fa-picture-o"></i>&nbsp;<span data-translate="entity.action.addimage">Add image</span></button> <button type="button" ng-if="vm.settingsAccount.thumbnail" class="btn btn-danger btn-xs" ng-click="vm.settingsAccount.thumbnail = null; vm.settingsAccount.thumbnailContentType = null;"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button> <span ng-if="vm.settingsAccount.thumbnail">{{vm.settingsAccount.thumbnailContentType}}, {{vm.byteSize(vm.settingsAccount.thumbnail)}}</span></div></div><input type="hidden" name="thumbnail" id="field_thumbnail" ng-model="vm.settingsAccount.thumbnail"> <input type="hidden" name="thumbnailContentType" id="field_thumbnailContentType" ng-model="vm.settingsAccount.thumbnailContentType"> <input type="hidden" id="langKey" name="langKey" value="pt-pt" ng-model="vm.settingsAccount.langKey"></div></div></div><div class="panel-footer"><div class="text-right"><button type="button" ui-sref="home" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="submit" ng-disabled="form.$invalid" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;<span data-translate="settings.form.button">Save</span></button></div></div></div></form></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="audits.title">Audits</span><form class="form-inline pull-right"><label for="filter" data-translate="audits.filter.title">Filter (by date)</label><div class="input-group input-group-sm"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="text" class="form-control" ng-click="vm.openInitialDatePopup()" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" is-open="vm.initialDatePopup.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openInitialDatePopup()"><i class="fa fa-calendar"></i></button></span></div><div class="input-group input-group-sm"><span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="text" class="form-control" ng-click="vm.openFinalDatePopup()" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.toDate" ng-change="vm.onChangeDate()" is-open="vm.finalDatePopup.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openFinalDatePopup()"><i class="fa fa-calendar"></i></button></span></div></form><span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="timestamp"><span data-translate="audits.table.header.date">Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="principal"><span data-translate="audits.table.header.principal">User</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="type"><span data-translate="audits.table.header.status">State</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="data.message"><span data-translate="audits.table.header.data">Extra data</span>&nbsp;<i class="fa fa-sort"></i></th></tr></thead><tbody><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td>{{audit.timestamp| date:\'medium\'}}</td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></tbody></table></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></ul></div></div></div></div>');
$templateCache.put('app/admin/health/health.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="health.title">Health Check</span> <button type="button" class="btn btn-warning btn-sm pull-right" ng-click="vm.refresh()"><i class="fa fa-refresh"></i> <span data-translate="health.refresh.button">Refresh</span></button> <span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="name"><span data-translate="health.table.service">Service Name</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="status"><span data-translate="health.table.status">Status</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData | filter:filter | orderBy:predicate:reverse"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td><a class="btn btn-info btn-xs" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="fa fa-search-plus"></i></a></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()" data-dismiss="modal">&times;</button><h4 class="modal-title">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body"><h4 data-translate="health.details.properties">Properties</h4><div class="table-responsive" ng-show="vm.currentHealth.details"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th data-translate="health.details.name">Name</th><th data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="table-left">{{k}}</td><td>{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.cancel()"><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok"> OK</span></button></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="metrics.title">Application Metrics</span> <button type="button" class="btn btn-warning btn-sm pull-right" ng-click="vm.refresh()"><i class="fa fa-refresh"></i> <span data-translate="metrics.refresh.button">Refresh</span></button> <span class="clearfix"></span></div><div class="panel-body"><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="btn btn-info btn-xs" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="fa fa-search-plus"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-8" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-8" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-8" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-8" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th data-translate="metrics.jvm.http.table.mean">Mean</th><th><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="table-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th data-translate="metrics.servicesstats.table.count">Count</th><th data-translate="metrics.servicesstats.table.mean">Mean</th><th data-translate="metrics.servicesstats.table.min">Min</th><th data-translate="metrics.servicesstats.table.p50">p50</th><th data-translate="metrics.servicesstats.table.p75">p75</th><th data-translate="metrics.servicesstats.table.p95">p95</th><th data-translate="metrics.servicesstats.table.p99">p99</th><th data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td class="table-left">{{k}}</td><td class="table-right">{{v.count}}</td><td class="table-right">{{v.mean * 1000 | number:0}}</td><td class="table-right">{{v.min * 1000 | number:0}}</td><td class="table-right">{{v.p50 * 1000 | number:0}}</td><td class="table-right">{{v.p75 * 1000 | number:0}}</td><td class="table-right">{{v.p95 * 1000 | number:0}}</td><td class="table-right">{{v.p99 * 1000 | number:0}}</td><td class="table-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th data-translate="metrics.cache.hits">Cache Hits</th><th data-translate="metrics.cache.misses">Cache Misses</th><th data-translate="metrics.cache.gets">Cache Gets</th><th data-translate="metrics.cache.puts">Cache Puts</th><th data-translate="metrics.cache.removals">Cache Removals</th><th data-translate="metrics.cache.evictions">Cache Evictions</th><th data-translate="metrics.cache.hitPercent">Cache Hit %</th><th data-translate="metrics.cache.missPercent">Cache Miss %</th><th data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td class="table-left">{{v.name}}</td><td class="table-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="table-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="table-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="table-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="table-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="table-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="table-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="table-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="table-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="table-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="table-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th data-translate="metrics.datasource.count">Count</th><th data-translate="metrics.datasource.mean">Mean</th><th data-translate="metrics.datasource.min">Min</th><th data-translate="metrics.datasource.p50">p50</th><th data-translate="metrics.datasource.p75">p75</th><th data-translate="metrics.datasource.p95">p95</th><th data-translate="metrics.datasource.p99">p99</th><th data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="table-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="table-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="table-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="table-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="table-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="table-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="table-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="table-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body"><div class="form-group"><div class="col-md-8"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;</div><div class="col-md-4"><form class="form-inline pull-right"><label for="filter" data-translate="metrics.filter">Filter</label><input type="text" id="filter" ng-model="threadDumpFilter" class="form-control input-sm"></form></div></div><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp; {{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}})</div></div><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.cancel()"><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="configuration.title">Configuration</span><form class="form-inline pull-right"><label for="filter" data-translate="configuration.filter">Filter (by prefix)</label><input type="text" id="filter" ng-model="filter" class="form-control input-sm"></form><span class="clearfix"></span></div><div class="panel-body"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><div class="table-responsive" ng-hide="filteredConfig.length == 0"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="prefix" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="key" class="col-sm-8"><span data-translate="configuration.table.properties">Properties</span>&nbsp;<i class="fa fa-sort"></i></th></tr></thead><tbody><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td>{{entry.prefix}}</td><td><div class="col-md-12" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></tbody></table></div><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><div class="table-responsive" ng-hide="filtered.length == 0"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="key" class="col-sm-4"><span data-translate="configuration.table.property">Property</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="val" class="col-sm-8"><span data-translate="configuration.table.value">Value</span>&nbsp;<i class="fa fa-sort"></i></th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter | orderBy:predicate:reverse)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/admin/logs/logs.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left"><span data-translate="logs.title">Logs</span>&nbsp;|&nbsp; <span data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</span></span><form class="form-inline pull-right"><label for="filter" data-translate="logs.filter">Filter</label><input type="text" id="filter" ng-model="filter" class="form-control input-sm"></form><span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="name"><span data-translate="logs.table.name">Name</span>&nbsp;<i class="fa fa-sort"></i></th><th><span data-translate="logs.table.level">Level</span></th></tr></thead><tbody><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td class="table-left"><small>{{logger.name | characters:140}}</small></td><td><div class="btn-group"><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></div></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><span data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</span></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left" data-translate="userManagement.detail.title">User</span>&nbsp;"{{vm.user.login}}" <span class="clearfix"></span></div><div class="panel-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.avatar">Avatar</span></dt><dd><p><span ng-if="!vm.user.thumbnail"><ng-avatar initials="{{vm.nameInitials}}" bind="true" auto-color="true" corner-radius="5" width="100"></ng-avatar></span><img ng-if="vm.user.thumbnail" ng-src="{{\'data:\' + vm.user.thumbnailContentType + \';base64,\' + vm.user.thumbnail}}" style="max-height: 100px; max-width: 100px; border-radius: 5px"></p></dd><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.indicatorsName">Indicators Name</span></dt><dd>{{vm.user.indicatorsName}}</dd><dt><span data-translate="userManagement.company">Company</span></dt><dd>{{vm.user.company.naming}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><div ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{ authority }}</span></div></dd></dl></div><div class="panel-footer"><div class="text-right"><button type="submit" ui-sref="user-management" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" ng-submit="vm.save()" class="form-horizontal" show-validation novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><input type="hidden" name="id" ng-model="vm.user.id"> <input type="hidden" name="langKey" ng-model="vm.user.langKey"><div class="form-group"><div class="col-sm-10 col-md-offset-2"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="userManagement.login">Login</label><div class="col-sm-10"><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="userManagement.firstName">First Name</label><div class="col-sm-10"><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="userManagement.lastName">Last Name</label><div class="col-sm-10"><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="userManagement.email">Email</label><div class="col-sm-10"><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="userManagement.indicatorsName">Indicators Name</label><div class="col-sm-10"><input type="text" class="form-control" name="indicatorsName" ng-model="vm.user.indicatorsName" ng-maxlength="50"><div ng-show="editForm.indicatorsName.$invalid"><p class="help-block" ng-show="editForm.indicatorsName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="userManagement.company">Company</label><div class="col-sm-10"><ui-select name="company" ng-model="vm.user.company"><ui-select-match placeholder="{{\'userManagement.placeholder.company\' | translate}}" allow-clear="true">{{$select.selected.namingForOptions}}</ui-select-match><ui-select-choices repeat="company as company in vm.companies | filter: $select.search"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="userManagement.profiles">Profiles</label><div class="col-sm-10"><ui-select multiple="multiple" id="authority" name="authority" ng-model="vm.user.authorities" close-on-select="false"><ui-select-match placeholder="{{\'userManagement.placeholder.roles\' | translate}}">{{$item}}</ui-select-match><ui-select-choices repeat="authority in vm.authorities | filter: $select.search"><span ng-bind-html="authority | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group" ngf-drop ngf-change="vm.setThumbnail($file, vm.user)" ngf-pattern="\'image/*\'"><label class="col-sm-2 control-label" data-translate="userManagement.avatar">Avatar</label><div class="col-sm-10"><div><span ng-if="!vm.user.thumbnail"><ng-avatar initials="{{vm.nameInitials}}" bind="true" auto-color="true" corner-radius="5" width="100"></ng-avatar></span><img ng-if="vm.user.thumbnail" ng-src="{{\'data:\' + vm.user.thumbnailContentType + \';base64,\' + vm.user.thumbnail}}" style="max-height: 100px; max-width: 100px; border-radius: 5px"><div class="help-block clearfix"><button type="button" id="field_thumbnail_button" ngf-select class="btn btn-warning btn-xs" ngf-change="vm.setThumbnail($file, vm.user)" accept="image/*"><i class="fa fa-picture-o"></i>&nbsp;<span data-translate="entity.action.addimage">Add image</span></button> <button type="button" ng-if="vm.user.thumbnail" class="btn btn-danger btn-xs" ng-click="vm.user.thumbnail = null; vm.user.thumbnailContentType = null;"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button> <span ng-if="vm.user.thumbnail">{{vm.user.thumbnailContentType}}, {{vm.byteSize(vm.user.thumbnail)}}</span></div></div><input type="hidden" name="thumbnail" id="field_thumbnail" ng-model="vm.user.thumbnail"> <input type="hidden" name="thumbnailContentType" id="field_thumbnailContentType" ng-model="vm.user.thumbnailContentType"> <input type="hidden" id="langKey" name="langKey" value="pt-pt" ng-model="vm.user.langKey"></div></div><div class="form-group"><label class="col-sm-6 control-label" data-translate="userManagement.typeGeneric">Generic User</label><div class="col-sm-6"><label for="no" data-translate="entity.action.no">No</label><input type="radio" id="no" name="generic" ng-model="vm.user.generic" ng-value="false" checked="checked"><label style="margin-left: 3%" for="yes" data-translate="entity.action.yes">Yes</label><input type="radio" id="yes" name="generic" ng-model="vm.user.generic" ng-value="true"></div></div><div class="form-group"><label class="col-sm-6 control-label" data-translate="userManagement.responsibleValidator">Responsible Validator</label><div class="col-sm-6"><label for="noResponsible" data-translate="entity.action.no">No</label><input type="radio" id="noResponsible" name="responsibleValidator" ng-click="vm.validateResponsiveAndWallet()" ng-model="vm.user.responsibleValidator" ng-value="false" checked="checked"><label style="margin-left: 3%" for="yesResponsible" data-translate="entity.action.yes">Yes</label><input type="radio" id="yesResponsible" name="responsibleValidator" ng-model="vm.user.responsibleValidator" ng-value="true"></div></div><div class="form-group" ng-class="{\'has-error\': editForm.technicalDirectorName.$dirty && editForm.technicalDirectorName.$error.maxlength }" ng-if="vm.user.responsibleValidator"><label class="col-sm-2 control-label" for="technicalDirectorName" data-translate="userManagement.technicalDirectorName">Technical Director Name</label><div class="col-sm-10"><input id="technicalDirectorName" type="text" ng-required="vm.user.responsibleValidator" class="form-control" name="technicalDirectorName" ng-model="vm.user.technicalDirectorName" ng-maxlength="100"><div ng-show="editForm.technicalDirectorName.$invalid"><p class="help-block" ng-show="editForm.technicalDirectorName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group" ng-class="{\'has-error\': editForm.professionalWalletNumber.$dirty && editForm.professionalWalletNumber.$error.maxlength }" ng-if="vm.user.responsibleValidator"><label class="col-sm-2 control-label" for="professionalWalletNumber" data-translate="userManagement.professionalWalletNumber">Professional Wallet Number</label><div class="col-sm-10"><input id="professionalWalletNumber" type="text" ng-required="vm.user.responsibleValidator" class="form-control" name="professionalWalletNumber" ng-model="vm.user.professionalWalletNumber" ng-maxlength="100"><div ng-show="editForm.professionalWalletNumber.$invalid"><p class="help-block" ng-show="editForm.professionalWalletNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group" ng-if="vm.user.responsibleValidator"><label class="col-sm-6 control-label" data-translate="userManagement.allowDigitalSignature">Allow Digital Signature</label><div class="col-sm-6"><label for="noDigitalSignature" data-translate="entity.action.no">No</label><input type="radio" id="noDigitalSignature" name="allowDigitalSignature" ng-model="vm.user.allowDigitalSignature" ng-value="false" checked="checked"><label style="margin-left: 3%" for="yesDigitalSignature" data-translate="entity.action.yes">Yes</label><input type="radio" id="yesDigitalSignature" name="allowDigitalSignature" ng-model="vm.user.allowDigitalSignature" ng-value="true"></div></div><div ng-if="vm.user.allowDigitalSignature" class="form-group" ngf-drop ngf-change="vm.setSignatureThumbnail($file, vm.user)" ngf-pattern="\'image/*\'"><label class="col-sm-2 control-label" data-translate="userManagement.signature">Signature</label><div class="col-sm-10"><div><span ng-if="!vm.user.signatureThumbnail"><ng-avatar initials="{{vm.nameInitials}}" bind="true" auto-color="true" corner-radius="5" width="100"></ng-avatar></span><img ng-if="vm.user.signatureThumbnail && vm.user.allowDigitalSignature" ng-src="{{\'data:\' + vm.user.signatureThumbnailContentType + \';base64,\' + vm.user.signatureThumbnail}}" style="max-height: 50px; max-width: 100px; border-radius: 5px"><div class="help-block clearfix"><button type="button" id="field_signature_thumbnail_button" ngf-select class="btn btn-warning btn-xs" ngf-change="vm.setSignatureThumbnail($file, vm.user)" accept="image/*"><i class="fa fa-picture-o"></i>&nbsp;<span data-translate="entity.action.addimage">Add image</span></button> <button type="button" ng-if="vm.user.signatureThumbnail" class="btn btn-danger btn-xs" ng-click="vm.user.signatureThumbnail = null; vm.user.signatureThumbnailContentType = null;"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button> <span ng-if="vm.user.signatureThumbnail">{{vm.user.signatureThumbnailContentType}}, {{vm.byteSize(vm.user.signatureThumbnail)}}</span></div></div><input type="hidden" name="signatureThumbnail" id="field_signature_thumbnail" ng-model="vm.user.signatureThumbnail"> <input type="hidden" name="signatureThumbnailContentType" id="field_signatureThumbnailContentType" ng-model="vm.user.signatureThumbnailContentType"> <input type="hidden" id="signatureLangKey" name="signatureLangKey" value="pt-pt" ng-model="vm.user.langKey"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="userManagement.home.title">Users</span> <button type="button" class="btn btn-warning btn-sm pull-right" ui-sref="user-management.new"><i class="fa fa-plus"></i>&nbsp;<span data-translate="userManagement.home.createLabel">Create a new User</span></button> <span class="clearfix"></span></div><div class="panel-body"><form name="userMgmtForm" role="form"><div class="row"><div class="col-md-3"><div class="form-group"><div class="input-group"><input type="text" class="form-control input-sm" placeholder="{{\'global.form.search.placeholder.inTable\' | translate}}" ng-model="searchInTable"><div class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.clearSearchInTable()"><i class="fa fa-close"></i></button></div></div></div></div></div><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="activated"><span data-translate="userManagement.activated">Activated</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="company.naming"><span data-translate="userManagement.company">Company</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="userManagement.profiles">Profiles</th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="user in vm.users | filter:searchInTable | orderBy:predicate:reverse track by user.id"><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated">Activated</button></td><td class="table-left">{{user.login}}</td><td class="table-left">{{user.email}}</td><td class="table-left">{{user.company.naming}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td><div class="btn-group"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}"><i class="fa fa-search-plus"></i></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-xs" title="{{\'entity.action.edit\' | translate}}"><i class="fa fa-pencil"></i></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-xs" ng-disabled="vm.currentAccount.login==user.login" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></form></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/admin-settings/admin-settings.html','<div><uib-tabset active="active"><uib-tab index="0"><uib-tab-heading><i class="fa fa-list-ol fa-lg fa-fw"></i>&nbsp;<span data-translate="pharmaPortalApp.moduleSettings.home.title">Module Settings</span></uib-tab-heading><div ui-view="module-settings-view"></div></uib-tab><uib-tab index="1"><uib-tab-heading><i class="fa fa-heartbeat fa-lg fa-fw"></i>&nbsp;<span data-translate="pharmaPortalApp.policySettings.home.title">Policy Settings</span></uib-tab-heading><div ui-view="policy-settings-view"></div></uib-tab><uib-tab index="2"><uib-tab-heading><i class="fa fa-picture-o fa-lg fa-fw"></i>&nbsp;<span data-translate="pharmaPortalApp.themeSettings.home.title">Theme Settings</span></uib-tab-heading><div ui-view="theme-settings-view"></div></uib-tab><uib-tab index="3"><uib-tab-heading><i class="fa fa-refresh fa-lg fa-fw"></i>&nbsp;<span data-translate="pharmaPortalApp.externalSyncs.home.title">External Syncs</span></uib-tab-heading><div ui-view="external-syncs-view"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/entities/admin-settings/external-syncs.html','<div><label><span data-translate="pharmaPortalApp.externalSyncs.dbPharmaSynchronize">Synchronize DbPharma Products </span>: <button type="button" ng-click="syncProducts()"><span data-translate="pharmaPortalApp.externalSyncs.synchronizeStart">Start</span></button> {{vm.synchronizing}} {{vm.syncResult[0]}}</label></div>');
$templateCache.put('app/entities/admin-settings/module-settings.html','<div><form class="form-horizontal" ng-submit="vm.save()"><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="queriesModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="queriesModule" ng-model="vm.settings.queriesModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.queriesModule">Queries Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="applicationsModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="applicationsModule" ng-model="vm.settings.applicationsModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.applicationsModule">Applications Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="productsModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="productsModule" ng-model="vm.settings.productsModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.productsModule">Products Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="purchasesModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="purchasesModule" ng-model="vm.settings.purchasesModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.purchasesModule">Purchases Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="tradesModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="tradesModule" ng-model="vm.settings.tradesModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.tradesModule">Trades Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="receptionsModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="receptionsModule" ng-model="vm.settings.receptionsModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.receptionsModule">Receptions Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="returnsModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="returnsModule" ng-model="vm.settings.returnsModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.returnsModule">Returns Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="selfInvoiceCollectionModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="selfInvoiceCollectionModule" ng-model="vm.settings.selfInvoiceCollectionModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.selfInvoiceCollectionModule">Self Invoice Collection Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="receptionsWarehouseTransfModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="receptionsWarehouseTransfModule" ng-model="vm.settings.receptionsWarehouseTransfModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.receptionsWarehouseTransfModule">Warehouse Transfer Reception Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="salesModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="salesModule" ng-model="vm.settings.salesModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.salesModule">Sales Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="selloutsModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="selloutsModule" ng-model="vm.settings.selloutsModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.selloutsModule">Sellout Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="campaignsModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="campaignsModule" ng-model="vm.settings.campaignsModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.campaignsModule">Campaigns Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="balanceModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="balanceModule" ng-model="vm.settings.balanceModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.balanceModule">Balance Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="pickingModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="pickingModule" ng-model="vm.settings.pickingModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.pickingModule">Picking Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="infarmedModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="infarmedModule" ng-model="vm.settings.infarmedModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.infarmedModule">Picking Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="innergyPortalProductVerificationModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="innergyPortalProductVerificationModule" ng-model="vm.settings.innergyPortalProductVerificationModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.innergyPortalProductVerificationModule">innergyPortal Product Verification Module</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="innergyPortalOrdersModule" class="form-check-label"><input type="checkbox" class="form-check-input" id="innergyPortalOrdersModule" ng-model="vm.settings.innergyPortalOrdersModule"> <span data-translate="pharmaPortalApp.moduleSettings.modules.innergyPortalOrdersModule">innergyPortal Orders Module</span></label></div></div></div></div></div></div><div class="panel-footer"><div class="text-right"><button type="submit" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></div></form></div>');
$templateCache.put('app/entities/admin-settings/policy-settings.html','<div><form class="form-horizontal" ng-submit="vm.save()"><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-sm-12"><div js-tree="vm.treeConfig" ng-model="vm.treeData" tree="vm.treeInstance"></div></div></div></div><div class="panel-footer"><div class="text-right"><button type="submit" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></div></form></div>');
$templateCache.put('app/entities/admin-settings/theme-settings.html','<div><form class="form-horizontal form-settings" ng-submit="vm.save()"><div class="panel panel-default"><div class="panel-body"><div class="form-group"><label class="control-label col-sm-2" data-translate="pharmaPortalApp.themeSettings.logoDescription" for="field_logoDescription">Logo Description</label><div class="col-sm-10"><input type="text" class="form-control input-sm" name="logoDescription" id="field_logoDescription" ng-model="vm.settings.logoDescription"></div></div><div class="form-group" ngf-drop ngf-change="vm.setLogo($file, vm.settings)" ngf-pattern="\'image/*\'"><label class="control-label col-sm-2" data-translate="pharmaPortalApp.themeSettings.logo" for="field_logo_button">Logo</label><div class="col-sm-10"><div><img data-ng-src="{{\'data:\' + vm.settings.logoContentType + \';base64,\' + vm.settings.logo}}" style="max-height: 100px" ng-if="vm.settings.logo" alt="settings image"><div class="help-block clearfix"><button type="button" id="field_logo_button" ngf-select class="btn btn-warning btn-sm" ngf-change="vm.setLogo($file, vm.settings)" accept="image/*"><i class="fa fa-picture-o"></i>&nbsp;<span data-translate="entity.action.addimage">Add image</span></button> <button type="button" ng-if="vm.settings.logo" ng-click="vm.settings.logo=null;vm.settings.logoContentType=null;" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div><input type="hidden" class="form-control" name="logo" id="field_logo" ng-model="vm.settings.logo"> <input type="hidden" class="form-control" name="logoContentType" id="field_logoContentType" ng-model="vm.settings.logoContentType"></div></div></div><div class="panel-footer"><div class="text-right"><button type="submit" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></div></form></div>');
$templateCache.put('app/entities/as400-messages/as400-messages.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title" data-translate="pharmaPortalApp.as400Messages.home.title">AS400 Messages</span></div><div class="panel-body"><form class="form-horizontal container-fluid well well-sm" id="filterForm" name="filterForm"><div class="form-group-sm"><div class="col-sm-offset-9 col-sm-2"><label for="username" translate="pharmaPortalApp.as400Messages.username">Username</label><input type="text" class="form-control" id="username" name="username" ng-model="vm.filter.username"></div><div class="col-sm-1"><label class="col-sm-12">&nbsp;</label><button class="btn btn-warning" ng-click="vm.clearFilter()" title="{{\'entity.action.reset\' | translate}}"><i class="fa fa-times"></i></button> <button type="submit" class="btn btn-info" ng-click="vm.loadAll()" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i></button></div></div></form><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th class="col-lg-3"><span data-translate="pharmaPortalApp.as400Messages.date">Date</span>&nbsp;<i class="fa fa-sort"></i></th><th class="col-lg-9"><span data-translate="pharmaPortalApp.as400Messages.message">Message</span>&nbsp;<i class="fa fa-sort"></i></th></tr></thead><tbody><tr ng-repeat="message in vm.messages track by $index"><td class="col-lg-3">{{message.date | date:\'medium\'}}</td><td class="table-left col-lg-9">{{message.message}}</td></tr></tbody></table></div></div><div class="panel-footer"></div></div></div>');
$templateCache.put('app/entities/campaign/campaign-delete-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p data-translate="pharmaPortalApp.campaign.delete.question" translate-values="{name: \'{{vm.campaign.name}}\'}">Are you sure you want to delete this Campaign?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete(vm.campaignId)" ng-disabled="vm.campaign.editLocked" autofocus><span class="fa fa-trash-o"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div>');
$templateCache.put('app/entities/campaign/campaign-detail-dialog.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="pharmaPortalApp.campaign.detail.title">Campaign</span>&nbsp;"{{vm.campaign.name}}"</h4></div><div class="modal-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.campaign.name">Name</span></dt><dd><span>{{vm.campaign.name}}</span></dd><dt><span data-translate="pharmaPortalApp.campaign.campaignType">Campaign Type</span></dt><dd><span data-translate="{{\'pharmaPortalApp.campaignType.\' + vm.campaign.campaignType}}">{{vm.campaign.campaignType}}</span></dd><dt><span data-translate="pharmaPortalApp.campaign.startDate">Start Date</span></dt><dd><span>{{vm.campaign.startDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="pharmaPortalApp.campaign.endDate">End Date</span></dt><dd><span>{{vm.campaign.endDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="pharmaPortalApp.campaign.campaignStatus">Campaign Status</span></dt><dd><span ng-show="vm.campaign.campaignStatus"><i class="fa fa-check-square-o text-success"></i>&nbsp;<span data-translate="pharmaPortalApp.campaign.status.active">Active</span> </span><span ng-hide="vm.campaign.campaignStatus"><i class="fa fa-square text-danger"></i>&nbsp;<span data-translate="pharmaPortalApp.campaign.status.inactive">Inactive</span></span></dd><dt><span data-translate="pharmaPortalApp.campaign.companies">Campaign Pharmacies</span></dt><dd><ul class="list-group"><li class="list-group-item col-md-6" ng-repeat="company in vm.campaign.companies"><i class="fa fa-building"></i>&nbsp;{{ company.namingForOptions }}</li></ul></dd><dt><span data-translate="pharmaPortalApp.campaign.products">Campaign Products</span></dt><dd><any ng-show="vm.campaign.products.length"><ul class="list-group"><li class="list-group-item col-md-6" ng-repeat="product in vm.campaign.products"><i class="fa fa fa-cubes"></i>&nbsp;{{ product.cnp +" - "+product.description }}</li></ul></any><any ng-hide="vm.campaign.products.length"><span data-translate="pharmaPortalApp.campaign.hint.noProducts">No product has been added to this campaign yet</span></any></dd></dl></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="button" class="btn btn-primary btn-sm" ui-sref="campaign.edit({id:vm.campaign.id})" ng-click="vm.clear()" ng-disabled="vm.campaign.editLocked" autofocus><i class="fa fa-pencil"></i>&nbsp;<span data-translate="entity.action.edit">Edit</span></button></div></div>');
$templateCache.put('app/entities/campaign/campaign-edit.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.campaign.home.editLabel">Edit a Campaign</span> <button type="submit" class="btn btn-warning btn-sm pull-right" ui-sref="campaign-product-new({parentId: vm.campaign.id})"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.campaignProduct.newCampaignProduct">New Campaign Product</span></button> <span class="clearfix"></span></div><div class="panel-body"><div class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label" for="field_name" data-translate="pharmaPortalApp.campaign.name">Name</label><div class="col-sm-10"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.campaign.name" required></div></div><div class="form-group"><label class="col-sm-2 control-label" for="field_campaignType" data-translate="pharmaPortalApp.campaign.campaignType">Campaign Type</label><div class="col-sm-4"><ui-select id="field_campaignType" name="campaignType" ng-model="vm.campaign.campaignType" required><ui-select-match>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="item.value as item in vm.campaignTypes | filter: $select.search"><span ng-bind-html="item.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><label class="col-sm-2 control-label" for="field_campaignStatus" data-translate="pharmaPortalApp.campaign.campaignStatus">Campaign Status</label><div class="col-sm-4"><ui-select id="field_campaignStatus" name="campaignStatus" ng-model="vm.campaign.campaignStatus" required><ui-select-match>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="item.value as item in vm.statusItems | filter: $select.search"><span ng-bind-html="item.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><label class="col-sm-2 control-label" for="field_startDate" data-translate="pharmaPortalApp.campaign.startDate">Start Date</label><div class="col-sm-4"><div class="input-group input-group-sm"><input type="text" class="form-control" name="startDate" id="field_startDate" ng-click="vm.openDatePopup(\'start\')" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.campaign.startDate" is-open="vm.datePopup.start.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(\'start\')"><i class="fa fa-calendar"></i></button></span></div></div><label class="col-sm-2 control-label" for="field_endDate" data-translate="pharmaPortalApp.campaign.endDate">End Date</label><div class="col-sm-4"><div class="input-group input-group-sm"><input type="text" class="form-control" name="endDate" id="field_endDate" ng-click="vm.openDatePopup(\'end\')" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.campaign.endDate" is-open="vm.datePopup.end.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(\'end\')"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="name" data-translate="pharmaPortalApp.campaign.companies">Pharmacies</label><div class="col-sm-10"><ui-select multiple="multiple" id="name" name="name" ng-model="vm.campaign.companies" close-on-select="false" ng-change="vm.saveCampaign()" required><ui-select-match>{{$item.naming}}</ui-select-match><ui-select-choices repeat="company in vm.companies | filter: $select.search"><span ng-bind-html="company.naming | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><!-- if vm.campaign.campaignType === \'CHALLENGE\' --><!-- SE FOR DESAFIO --><any ng-if="vm.campaign.campaignType === \'CHALLENGE\'"><div class="container-fluid well well-sm"><div class="col-md-offset-4 col-md-4"><label ng-hide="vm.searchInTable" class="control-label">A visualizar um total de {{productContainerList.items.length}} produtos</label><label ng-show="vm.searchInTable" class="control-label">A visualizar {{(productContainerList.items | filter:vm.searchInTable).length}} produtos de um total de {{productContainerList.items.length}}</label></div><div class="col-md-4"><div class="input-group"><input type="text" class="form-control input-sm" placeholder="{{ \'pharmaPortalApp.campaignProduct.filter.placeholder\' | translate }}" ng-model="vm.searchInTable"><div class="input-group-btn"><button type="button" class="btn btn-info btn-sm" ng-click="vm.clearSearchInTable()"><i class="fa fa-close"></i></button></div></div></div></div><div class="form-group"><div class="col-sm-2 nopadding"><label class="col-sm-12 control-label" data-translate="pharmaPortalApp.campaign.products">Campaign Products</label><div class="col-sm-12 text-right"><button type="button" ui-sref="campaign-product-clear-list({id:vm.campaign.id})" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="pharmaPortalApp.campaignProduct.deleteAll.action">Clear product list</span></button></div></div><div class="col-sm-10"><div class="table-responsive"><!-- SE FOR DESAFIO --><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th data-translate="pharmaPortalApp.campaignProduct.cnp">CNP</th><th data-translate="pharmaPortalApp.campaignProduct.description">Description</th><th data-translate="pharmaPortalApp.campaignProduct.targetAmount">Target Amount</th><th data-translate="pharmaPortalApp.campaignProduct.referencePrice">Reference Price</th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="product in productContainerList.items | filter:vm.searchInTable | orderBy:\'description\'"><td class="form-group table-left"><span ng-show="product.editMode===\'\' || !product.editMode">{{product.cnp}}</span> <input ng-show="product.editMode!=\'\' && product.editMode" type="text" class="form-control input-sm text-center" id="field_cnp" ng-model="product.cnp" ng-blur="vm.save()"></td><td class="form-group table-left"><span ng-show="product.editMode===\'\' || !product.editMode">{{product.description}}</span> <input ng-show="product.editMode!=\'\' && product.editMode" type="text" class="form-control input-sm text-center" id="field_description" ng-model="product.description" ng-blur="vm.save()"></td><td class="form-group table-right"><span ng-show="product.editMode===\'\' || !product.editMode">{{product.targetAmount}}</span> <input ng-show="product.editMode!=\'\' && product.editMode" type="text" class="form-control input-sm text-center" id="field_targetAmount" ng-model="product.targetAmount" ng-blur="vm.save()"></td><td class="form-group table-right"><span ng-show="product.editMode===\'\' || !product.editMode">{{product.referencePrice | currency : \'\u20AC\'}}</span> <input ng-show="product.editMode!=\'\' && product.editMode" type="text" class="form-control input-sm text-center" id="field_referencePrice" ng-model="product.referencePrice" ng-blur="vm.save()" price></td><td><div class="btn-group"><button class="btn btn-primary btn-xs" ng-class="{ \'active\': product.editMode!=\'\' && product.editMode}" title="{{\'entity.action.edit\' | translate}}" ng-click="vm.toggleLineEditMode(product)"><i class="fa fa-pencil"></i></button> <button type="submit" ui-sref="campaign-product-delete({parentId:vm.campaign.id, prodId:product.id})" class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div></div></any><!-- FIM SE FOR DESAFIO --><!-- if vm.campaign.campaignType === \'PROMOTION\' --><!-- SE FOR PROMO\xC7\xC3O --><any ng-if="vm.campaign.campaignType === \'PROMOTION\'"><div class="container-fluid well well-sm"><div class="col-md-offset-4 col-md-4"><label ng-hide="vm.searchInTable" class="control-label">A visualizar um total de {{productContainerList.items.length}} produtos</label><label ng-show="vm.searchInTable" class="control-label">A visualizar {{(productContainerList.items | filter:vm.searchInTable).length}} produtos de um total de {{productContainerList.items.length}}</label></div><div class="col-md-4"><div class="input-group"><input type="text" class="form-control input-sm" placeholder="{{ \'pharmaPortalApp.campaignProduct.filter.placeholder\' | translate }}" ng-model="vm.searchInTable"><div class="input-group-btn"><button type="button" class="btn btn-info btn-sm" ng-click="vm.clearSearchInTable()"><i class="fa fa-close"></i></button></div></div></div></div><div class="form-group"><div class="col-sm-2 nopadding"><label class="col-sm-12 control-label" data-translate="pharmaPortalApp.campaign.products">Campaign Products</label><div class="col-sm-12 btn-group-vertical pull-right"><button type="button" ui-sref="campaign-product-clear-list({id:vm.campaign.id})" class="btn btn-danger btn-xs"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="pharmaPortalApp.campaignProduct.deleteAll.action">Clear product list</span></button> <button type="button" ng-click="vm.selectAllValid()" class="btn btn-success btn-xs"><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="pharmaPortalApp.campaignProduct.selectAll.action">Select all</span></button> <button type="button" ng-click="vm.unselectAll()" class="btn btn-info btn-xs"><i class="fa fa-square-o"></i>&nbsp;<span data-translate="pharmaPortalApp.campaignProduct.unselectAll.action">Unselect all</span></button></div></div><div class="col-sm-10"><div class="table-responsive"><table class="jh-table table table-striped multiDemo" table-hover-highlight><thead><tr><th data-translate="pharmaPortalApp.campaignProduct.cnp">CNP</th><th data-translate="pharmaPortalApp.campaignProduct.description">Description</th><th data-translate="pharmaPortalApp.campaignProduct.targetAmount">Target Amount</th><th data-translate="pharmaPortalApp.campaignProduct.referencePrice">Reference Price</th><th data-translate="pharmaPortalApp.campaignProduct.promoLine">Promo Line</th><th data-translate="pharmaPortalApp.campaignProduct.brandType">Brand Type</th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr data-ng-repeat="product in productContainerList.items | filter:vm.searchInTable | orderBy:[\'-promoLine\', \'description\'] track by product.id" dnd-disable-if="product.promoLine == true" dnd-selected="onSelectItem(productContainerList.items, product, event)" dnd-draggable="getSelectedItemsIncluding(productContainerList, product)" dnd-dragstart="onDragstart(productContainerList, event)" dnd-moved="onMoved(productContainerList)" dnd-dragend="onDragEnd(productContainerList)" ng-class="{\'primary\': product.selected}" ng-hide="productContainerList.dragging && product.selected" context-menu="menuOptions"><td class="form-group table-left"><span ng-show="product.editMode===\'\' || !product.editMode"><span dnd-handle="" class="dragHandle" draggable="true">:::</span>&nbsp;{{product.cnp}} </span><input ng-show="product.editMode!=\'\' && product.editMode" type="text" class="form-control input-sm text-center" id="cnp" ng-model="product.cnp" ng-blur="vm.save()"></td><td class="form-group table-left"><span ng-show="product.editMode===\'\' || !product.editMode">{{product.description}}</span> <input ng-show="product.editMode!=\'\' && product.editMode" type="text" class="form-control input-sm text-center" id="description" ng-model="product.description" ng-blur="vm.save()"></td><td class="form-group table-right"><span ng-show="product.editMode===\'\' || !product.editMode">{{product.targetAmount}}</span> <input ng-show="product.editMode!=\'\' && product.editMode" type="number" min="0" step="1" class="form-control input-sm text-center" id="targetAmount" ng-model="product.targetAmount" ng-blur="vm.save()"></td><td class="form-group table-right"><span ng-show="product.editMode===\'\' || !product.editMode">{{product.referencePrice | currency : \'\u20AC\'}}</span> <input ng-show="product.editMode!=\'\' && product.editMode" type="text" class="form-control input-sm text-center" id="referencePrice" ng-model="product.referencePrice" ng-blur="vm.save()" price></td><td><span ng-show="product.editMode===\'\' || !product.editMode"><span ng-show="product.promoLine"><i class="fa fa-check-square-o text-success"></i> </span><span ng-hide="product.promoLine"><i class="fa fa-square text-danger"></i> </span></span><input ng-show="product.editMode!=\'\' && product.editMode" type="checkbox" id="promoLine" ng-model="product.promoLine" ng-blur="vm.save()"></td><td class="form-group table-left"><span ng-show="product.editMode===\'\' || !product.editMode">{{\'pharmaPortalApp.brandType.\'+product.brandType | translate}}</span><ui-select ng-show="product.editMode!=\'\' && product.editMode" id="brandType" name="brandType" ng-model="product.brandType" required on-select="vm.save()"><ui-select-match allow-clear="true">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="item.value as item in vm.brandTypes | filter: $select.search"><span ng-bind-html="item.label | highlight: $select.search"></span></ui-select-choices></ui-select></td><td><div class="btn-group"><button class="btn btn-primary btn-xs" ng-class="{ \'active\': product.editMode!=\'\' && product.editMode}" title="{{\'entity.action.edit\' | translate}}" ng-click="vm.toggleLineEditMode(product)"><i class="fa fa-pencil"></i></button> <button type="submit" ng-click="vm.cloneCampaignProduct(product)" class="btn btn-warning btn-xs" title="{{\'entity.action.copy\' | translate}}"><span class="fa fa-files-o"></span></button> <button type="submit" ui-sref="campaign-product-delete({parentId:vm.campaign.id, prodId:product.id})" class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div></div><div class="container-fluid well" ng-if="vm.campaign.campaignType !== \'CHALLENGE\'"><div class="multiDemo"><uib-tabset active="vm.selectTab" vertical="true" type="tabs" class="tabs-left"><uib-tab index="$index" data-ng-repeat="list in campaignProductList | orderBy:\'description\' track by list.id" select="vm.onTabSelect($index)"><uib-tab-heading><span ng-class="{\'text-danger\': list.items.length == 0}">Artigo : {{list.cnp +\' - \'+ list.description}} ({{list.items.length}} produtos)</span></uib-tab-heading><div class="container-fluid panel"><ul dnd-list dnd-drop="onDrop(list, item, index)"><li ng-repeat="item in list.items | orderBy:\'description\'" class="panel panel-default" dnd-draggable="getSelectedItemsIncluding(list, item)" dnd-dragstart="onDragstart(list, event)" dnd-moved="onMoved(list)" dnd-dragend="list.dragging = false" dnd-selected="item.selected = !item.selected" ng-class="{\'panel-primary\': item.selected}" ng-hide="list.dragging && item.selected" context-menu="menuOptions2"><div class="panel-heading"><button type="button" class="close" ng-click="dropItem(list, item)">&times;</button><div class="row"><span class="col-md-2"><span data-translate="pharmaPortalApp.campaignProduct.cnp">CNP</span>: {{item.cnp}} </span><span class="col-md-5"><span data-translate="pharmaPortalApp.campaignProduct.description">Description</span>: {{item.description}} </span><span class="col-md-2"><span data-translate="pharmaPortalApp.campaignProduct.targetAmount">Target Amount</span>: {{item.targetAmount}} </span><span class="col-md-2"><span data-translate="pharmaPortalApp.campaignProduct.referencePrice">Reference Price</span>: {{item.referencePrice | currency : \'\u20AC\'}}</span></div></div></li></ul></div></uib-tab></uib-tabset></div></div></any><!-- FIM SE FOR PROMO\xC7\xC3O --></div><!-- END OF form-horizontal --></div><!-- END OF panel-body --><div class="panel-footer"><div class="row"><div class="col-md-8"><form class="form-inline" id="importTemplateForm" name="importTemplateForm" style="display: inline"><div class="form-group"><input type="file" class="file" ngf-select ng-model="vm.campaign.file" name="file" ngf-pattern="\'.xls,.csv,.xlsx\'" accept=".xls,.csv,.xlsx" ngf-max-size="20MB" required ngf-model-invalid="errorFile" ng-disabled="vm.working"><div class="input-group input-group-sm"><span class="input-group-btn"><button class="browse btn btn-primary" type="button"><i class="fa fa-search"></i>&nbsp;<span translate="global.form.file">File</span></button> </span><input type="text" name="file" class="form-control" disabled="disabled"></div></div><script>$(\'.browse\').on(\'click\', function(event){ var file = $(this).parent().parent().parent().find(\'.file\'); file.trigger(\'click\'); });\n\t\t\t\t\t\t\t$(\'.file\').on(\'change\', function(event){ $(this).parent().find(\'.form-control\').val($(this).val().replace(/C:\\\\fakepath\\\\/i, \'\')); });</script><div class="form-group"><a class="btn btn-info btn-sm" ng-click="importTemplateForm.$valid && !vm.working && vm.uploadFile(vm.campaign.file)" ng-disabled="!importTemplateForm.$valid || vm.working"><i class="fa fa-upload"></i>&nbsp;<span data-translate="entity.action.upload">Upload</span></a></div></form><a ng-click="vm.getTemplate()" class="btn btn-info btn-sm" style="margin-left: 15px"><i class="fa fa-download"></i>&nbsp;<span data-translate="entity.action.downloadTemplate">Download template</span></a></div><div class="col-md-4"><div class="text-right"><button type="button" class="btn btn-default btn-sm" ui-sref="campaign"><span class="fa fa-undo"></span>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="button" class="btn btn-success btn-sm" ng-click="vm.saveCampaign(true)" ng-disabled="editForm.$invalid" autofocus><span class="fa fa-floppy-o"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/campaign/campaign-new-dialog.html','<form class="form-horizontal" name="editForm" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.campaign.home.createLabel">Create a Campaign</h4></div><div class="modal-body"><div class="form-group"><label class="col-sm-2 control-label" for="field_name" data-translate="pharmaPortalApp.campaign.name">Name</label><div class="col-sm-10"><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.campaign.name" required></div></div><div class="form-group"><label class="col-sm-2 control-label" for="field_campaignType" data-translate="pharmaPortalApp.campaign.campaignType">Campaign Type</label><div class="col-sm-4"><ui-select id="field_campaignType" name="campaignType" ng-model="vm.campaign.campaignType" required><ui-select-match>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="item.value as item in vm.campaignTypes | filter: $select.search"><span ng-bind-html="item.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><label class="col-sm-2 control-label" for="field_campaignStatus" data-translate="pharmaPortalApp.campaign.campaignStatus">Campaign Status</label><div class="col-sm-4"><ui-select id="field_campaignStatus" name="campaignStatus" ng-model="vm.campaign.campaignStatus" required><ui-select-match>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="item.value as item in vm.statusItems | filter: $select.search"><span ng-bind-html="item.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><label class="col-sm-2 control-label" for="field_startDate" data-translate="pharmaPortalApp.campaign.startDate">Start Date</label><div class="col-sm-4"><div class="input-group input-group-sm"><input type="text" class="form-control" name="startDate" id="field_startDate" ng-click="vm.openDatePopup(\'start\')" uib-datepicker-popup="dd/MM/yyyy" required ng-model="vm.campaign.startDate" ng-value="vm.campaign.startDate | date: \'dd/MM/yyyy\'" is-open="vm.datePopup.start.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(\'start\')"><i class="fa fa-calendar"></i></button></span></div></div><label class="col-sm-2 control-label" for="field_endDate" data-translate="pharmaPortalApp.campaign.endDate">End Date</label><div class="col-sm-4"><div class="input-group input-group-sm"><input type="text" class="form-control" name="endDate" id="field_endDate" ng-click="vm.openDatePopup(\'end\')" uib-datepicker-popup="dd/MM/yyyy" required ng-model="vm.campaign.endDate" ng-value="vm.campaign.endDate | date: \'dd/MM/yyyy\'" is-open="vm.datePopup.end.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(\'end\')"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="form-group"><label class="col-sm-2 control-label" for="name" data-translate="pharmaPortalApp.campaign.companies">Pharmacies</label><div class="col-sm-10"><ui-select multiple="multiple" id="name" name="name" ng-model="vm.campaign.companies" close-on-select="false" required><ui-select-match>{{$item.naming}}</ui-select-match><ui-select-choices repeat="company in vm.companies | filter: $select.search"><span ng-bind-html="company.naming | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><div class="col-sm-12 small text-right">*&nbsp; <span data-translate="pharmaPortalApp.campaign.hint.products">Products belonging to this campaign will be added on the next screen</span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" data-dismiss="modal" ng-disabled="editForm.$invalid || vm.isSaving" autofocus><span class="fa fa-floppy-o"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/campaign/campaign-product-clear-list-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.campaign.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p data-translate="pharmaPortalApp.campaignProduct.deleteAll.question">Are you sure you want to clear product list of this Campaign?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger btn-sm" ng-disabled="vm.campaign.editLocked" autofocus><span class="fa fa-trash-o"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/campaign/campaign-product-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.campaignProduct.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p data-translate="pharmaPortalApp.campaignProduct.delete.question" translate-values="{name: \'{{vm.campaignProduct.description}}\'}">Are you sure you want to delete this Campaign Product?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger btn-sm" ng-disabled="vm.campaignProduct.editLocked" autofocus><span class="fa fa-trash-o"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/campaign/campaign-product-new-dialog.html','<form class="form-horizontal" name="createForm" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.campaignProduct.home.createLabel">Create a Campaign Product</h4></div><div class="modal-body"><div class="form-group"><label class="col-sm-4 control-label input-sm label-required" for="field_cnp" data-translate="pharmaPortalApp.campaignProduct.cnp">CNP</label><div class="col-sm-8"><input type="text" class="form-control input-sm" name="cnp" id="field_cnp" ng-model="vm.campaignProduct.cnp" required></div></div><div class="form-group"><label class="col-sm-4 control-label input-sm label-required" for="field_description" data-translate="pharmaPortalApp.campaignProduct.description">Description</label><div class="col-sm-8"><input type="text" class="form-control input-sm" name="description" id="field_description" ng-model="vm.campaignProduct.description" required></div></div><div class="form-group"><label class="col-sm-4 control-label input-sm" ng-class="{\'label-required\' : vm.campaign.campaignType === \'CHALLENGE\'}" for="field_targetAmount" data-translate="pharmaPortalApp.campaignProduct.targetAmount">Target Amount</label><div class="col-sm-8"><input type="text" class="form-control input-sm" name="targetAmount" id="field_targetAmount" ng-model="vm.campaignProduct.targetAmount" ng-required="vm.campaign.campaignType === \'CHALLENGE\'" price></div></div><div class="form-group"><label class="col-sm-4 control-label input-sm" ng-class="{\'label-required\' : vm.campaign.campaignType === \'CHALLENGE\'}" for="field_referencePrice" data-translate="pharmaPortalApp.campaignProduct.referencePrice">Reference Price</label><div class="col-sm-8"><input type="text" class="form-control input-sm" name="referencePrice" id="field_referencePrice" ng-model="vm.campaignProduct.referencePrice" ng-required="vm.campaign.campaignType === \'CHALLENGE\'" price></div></div><div class="form-group" ng-if="vm.campaign.campaignType !== \'CHALLENGE\'"><label class="col-sm-4 control-label input-sm" for="field_promoLine" data-translate="pharmaPortalApp.campaignProduct.promoLine">Promo Line</label><div class="col-sm-8"><input type="checkbox" name="promoLine" id="field_promoLine" ng-model="vm.campaignProduct.promoLine"></div></div><div class="form-group" ng-if="vm.campaignProduct.promoLine"><label class="col-sm-4 control-label input-sm" for="field_brandType" data-translate="pharmaPortalApp.campaignProduct.brandType">Brand Type</label><div class="col-sm-8"><ui-select id="field_brandType" name="brandType" ng-model="vm.campaignProduct.brandType" ng-required="vm.campaignProduct.promoLine"><ui-select-match allow-clear="true">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="item.value as item in vm.brandTypes | filter: $select.search"><span ng-bind-html="item.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div><span id="helpBlock" class="help-block text-right"><span style="color: red">*</span> - <span data-translate="pharmaPortalApp.campaignProduct.mandatoryHelp">Mandatory fields</span></span></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="createForm.$invalid || vm.isSaving" autofocus><span class="fa fa-floppy-o"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/campaign/campaigns.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.campaign.home.title">Campaigns</span> <button class="btn btn-warning btn-sm pull-right" ui-sref="campaign.new"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.campaign.home.createLabel">Create new Campaign</span></button> <span class="clearfix"></span></div><div class="panel-body"><form class="form-horizontal container-fluid well well-sm" id="filterForm" name="filterForm"><div class="form-group-sm"><div class="col-sm-2"><label for="startDate" translate="pharmaPortalApp.campaign.filter.startDate">Start Date</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="startDate" name="startDate" ng-click="vm.openDatePopup(\'start\')" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.filter.startDate" is-open="vm.datePopup.start.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(\'start\')"><i class="fa fa-calendar"></i></button></span></div></div><div class="col-sm-2"><label for="endDate" translate="pharmaPortalApp.campaign.filter.endDate">End Date</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="endDate" name="endDate" ng-click="vm.openDatePopup(\'end\')" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.filter.endDate" is-open="vm.datePopup.end.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(\'end\')"><i class="fa fa-calendar"></i></button></span></div></div><div class="col-sm-1"><label for="campaignStatus" translate="pharmaPortalApp.campaign.filter.campaignStatus">Campaign Status</label><ui-select id="campaignStatus" name="campaignStatus" ng-model="vm.filter.campaignStatus"><ui-select-match allow-clear="true">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="item.value as item in vm.statusItems | filter: $select.search"><span ng-bind-html="item.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label for="name" translate="pharmaPortalApp.campaign.filter.name">Campaign</label><ui-select id="name" name="name" ng-model="vm.filter.name"><ui-select-match allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="campaign as campaign in vm.campaigns | filter: $select.search"><span ng-bind-html="campaign.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-3"><label for="companies" translate="pharmaPortalApp.campaign.filter.company">Pharmacy</label><ui-select id="company" name="company" ng-model="vm.filter.company"><ui-select-match allow-clear="true">{{$select.selected.namingForOptions}}</ui-select-match><ui-select-choices repeat="company as company in vm.companies | filter: $select.search | orderBy:\'naming\'"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-1"><label class="col-sm-12">&nbsp;</label><button class="btn btn-warning" ng-click="vm.clearFilter()" title="{{\'entity.action.reset\' | translate}}"><i class="fa fa-times"></i></button> <button type="submit" class="btn btn-info" ng-click="vm.filterCampaigns()" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i></button></div></div></form><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="startDate"><span data-translate="pharmaPortalApp.campaign.startDate">Start Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="endDate"><span data-translate="pharmaPortalApp.campaign.endDate">End Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="campaignType"><span data-translate="pharmaPortalApp.campaign.campaignType">Campaign Type</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="campaignStatus"><span data-translate="pharmaPortalApp.campaign.campaignStatus">Campaign Status</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="name"><span data-translate="pharmaPortalApp.campaign.name">Name</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="campaign in vm.campaigns | orderBy:predicate:reverse track by $index"><td>{{campaign.startDate | date:\'mediumDate\'}}</td><td>{{campaign.endDate | date:\'mediumDate\'}}</td><td class="table-left" data-translate="{{\'pharmaPortalApp.campaignType.\' + campaign.campaignType}}">{{campaign.campaignType}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(campaign, true)" ng-show="!campaign.campaignStatus" data-translate="pharmaPortalApp.campaign.status.inactive">Inactive</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(campaign, false)" ng-show="campaign.campaignStatus" data-translate="pharmaPortalApp.campaign.status.active">Active</button></td><td class="table-left">{{campaign.name}}</td><td><div class="btn-group"><button type="submit" ui-sref="campaign-detail({id:campaign.id})" class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}"><span class="fa fa-search-plus"></span></button> <button type="submit" ui-sref="campaign.edit({id:campaign.id})" class="btn btn-primary btn-xs" title="{{\'entity.action.edit\' | translate}}" ng-disabled="campaign.editLocked"><span class="fa fa-pencil"></span></button> <button type="submit" ng-click="vm.cloneCampaign(campaign.id)" class="btn btn-warning btn-xs" title="{{\'entity.action.copy\' | translate}}"><span class="fa fa-files-o"></span></button> <button type="button" ng-click="vm.deleteCampaign(campaign.id)" class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}"><span class="fa fa-trash-o"></span></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/company/companies.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.company.home.title">Companies</span> <button class="btn btn-warning btn-sm pull-right" ng-click="vm.synch()"><i class="fa fa-refresh"></i>&nbsp;<span class="hidden-xs" data-translate="pharmaPortalApp.company.home.synchLabel"> Synch Companies</span></button><form class="form-inline pull-right"><div class="input-group input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'global.form.search\' | translate }}"><div class="input-group-btn input-group-sm"><button class="btn btn-warning" ng-click="vm.clear()" ng-if="vm.currentSearch" title="{{\'entity.action.reset\' | translate}}"><i class="fa fa-times"></i></button> <button class="btn btn-info" ng-click="vm.search()" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i></button></div></div></form><span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="client"><span data-translate="pharmaPortalApp.company.clientDeliveryPoint">Client (Delivery Point)</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="name1"><span data-translate="pharmaPortalApp.company.name1">Name 1</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="comercialName"><span data-translate="pharmaPortalApp.company.comercialName">Comercial Name</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="locality"><span data-translate="pharmaPortalApp.company.locality">Locality</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="companyPhone"><span data-translate="pharmaPortalApp.company.companyPhone">Company Phone</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="nif"><span data-translate="pharmaPortalApp.company.nif">Nif</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="clientType"><span data-translate="pharmaPortalApp.company.clientType">Client Type</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="warehouse"><span data-translate="pharmaPortalApp.company.warehouse">Warehouse</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="pharmaWarehouse"><span data-translate="pharmaPortalApp.company.pharmaWarehouse">Pharma Warehouse</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="company in vm.companies | orderBy:predicate:reverse track by company.id"><td class="table-left">{{company.client}} ({{company.deliveryPoint}})</td><td class="table-left">{{company.name1}}&nbsp;{{company.name2}}</td><td class="table-left">{{company.comercialName}}</td><td class="table-left">{{company.locality}}</td><td>{{company.companyPhone}}</td><td>{{company.nif}}</td><td class="table-left">{{company.clientType}} - {{company.clientTypeDesc}}</td><td>{{company.warehouse}}</td><td>{{company.pharmaWarehouse}}</td><td><div class="btn-group"><button type="submit" ui-sref="company-detail({id:company.id})" class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}"><i class="fa fa-search-plus"></i></button> <button type="submit" ui-sref="company.edit({id:company.id})" class="btn btn-primary btn-xs" title="{{\'entity.action.edit\' | translate}}"><i class="fa fa-pencil"></i></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/company/company-detail.html','<div><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left" data-translate="pharmaPortalApp.company.detail.title">Company</span> <span class="clearfix"></span></div><div class="panel-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.company.client">Client</span></dt><dd><span>{{vm.company.client}}</span></dd><dt><span data-translate="pharmaPortalApp.company.deliveryPoint">Delivery Point</span></dt><dd><span>{{vm.company.deliveryPoint}}</span></dd><dt><span data-translate="pharmaPortalApp.company.clientType">Client Type</span></dt><dd><span>{{vm.company.clientType}} - {{vm.company.clientTypeDesc}}</span></dd><dt><span data-translate="pharmaPortalApp.company.name1">Name 1</span></dt><dd><span>{{vm.company.name1}}&nbsp;{{vm.company.name2}}</span></dd><dt><span data-translate="pharmaPortalApp.company.comercialName">Comercial Name</span></dt><dd><span>{{vm.company.comercialName}}</span></dd><dt><span data-translate="pharmaPortalApp.company.address">Address</span></dt><dd><span>{{vm.company.address}}</span></dd><dt><span data-translate="pharmaPortalApp.company.locality">Locality</span></dt><dd><span>{{vm.company.locality}}</span></dd><dt><span data-translate="pharmaPortalApp.company.zipCode">Zip Code</span></dt><dd><span>{{vm.company.zipCode}}</span></dd><dt><span data-translate="pharmaPortalApp.company.zipLocal">Zip Local</span></dt><dd><span>{{vm.company.zipLocal}}</span></dd><dt><span data-translate="pharmaPortalApp.company.companyPhone">Company Phone</span></dt><dd><span>{{vm.company.companyPhone}}</span></dd><dt><span data-translate="pharmaPortalApp.company.nif">Nif</span></dt><dd><span>{{vm.company.nif}}</span></dd><dt><span data-translate="pharmaPortalApp.company.warehouse">Warehouse</span></dt><dd><span>{{vm.company.warehouse}}</span></dd><dt><span data-translate="pharmaPortalApp.company.pharmaWarehouse">Pharma Warehouse</span></dt><dd><span>{{vm.company.pharmaWarehouse}}</span></dd><dt><span data-translate="pharmaPortalApp.company.clientGroup">Client Group</span></dt><dd><span>{{vm.company.clientGroup}} - {{vm.company.clientGroupDesc}}</span></dd><dt><span data-translate="pharmaPortalApp.company.selloutFileType">Sellout FileType</span></dt><dd><span>{{vm.company.selloutFileType}}</span></dd><dt><span data-translate="pharmaPortalApp.company.selloutNickname">Sellout Nickname</span></dt><dd><span>{{vm.company.selloutNickname}}</span></dd><dt><span data-translate="pharmaPortalApp.company.customerSince">Customer Since</span></dt><dd><span>{{vm.company.customerSince == null ? \'Informa\xE7\xE3o n\xE3o dispon\xEDvel\' : vm.company.customerSince | date}}</span></dd></dl></div><div class="panel-body"><h2>Hor\xE1rio</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.company.schedule.workingDay">Dias \xDAteis</span></dt><dd><span>{{vm.schedule.workingDayOpen}} - {{vm.schedule.workingDayClose}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.company.schedule.saturday">S\xE1bados</span></dt><dd><span>{{vm.schedule.saturdayOpen}} - {{vm.schedule.saturdayClose}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.company.schedule.sunday">Domingos</span></dt><dd><span>{{vm.schedule.sundayOpen}} - {{vm.schedule.sundayClose}}</span></dd></dl><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.company.schedule.holiday">Feriados</span></dt><dd><span>{{vm.schedule.holidayOpen}} - {{vm.schedule.holidayClose}}</span></dd></dl></div><div class="panel-footer"><div class="text-right"><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="button" ui-sref="company-detail.edit({id:vm.company.id})" class="btn btn-primary btn-sm"><i class="fa fa-pencil"></i>&nbsp;<span data-translate="entity.action.edit">Edit</span></button></div></div></div></div>');
$templateCache.put('app/entities/company/company-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.company.home.editLabel">Edit a Company</h4></div><div class="modal-body"><input type="hidden" class="form-control" name="id" id="id" ng-model="vm.company.id"><div class="form-group"><label class="control-label" data-translate="pharmaPortalApp.company.selloutNickname" for="field_selloutNickname">selloutNickname</label><input type="text" class="form-control" name="selloutNickname" id="field_selloutNickname" ng-model="vm.company.selloutNickname"></div><div class="form-group"><label class="control-label" data-translate="pharmaPortalApp.company.selloutFileType" for="field_selloutFileType">selloutFileType</label><select class="form-control" name="selloutFileType" ng-model="vm.company.selloutFileType" id="field_selloutFileType"><option value="SIIFARMA" data-translate="pharmaPortalApp.company.selloutFileTypeEnum.SIIFARMA">SIFARMA</option><option value="LOGITOOL" data-translate="pharmaPortalApp.company.selloutFileTypeEnum.LOGITOOL">LOGITOOLS</option><option value="WINPHAR" data-translate="pharmaPortalApp.company.selloutFileTypeEnum.WINPHAR">WINPHAR</option></select></div><div class="form-group" moment-picker="vm.schedule.workingDayOpen" format="HH:mm:ss"><label class="control-label" for="field_workingDayOpen" data-translate="pharmaPortalApp.company.schedule.workingDayOpen">Working Day Open</label><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o"></i> </span><input class="form-control" placeholder="Select a time" ng-model="vm.schedule.workingDayOpen" ng-model-options="{ updateOn: \'blur\' }" id="field_workingDayOpen"></div></div><div class="form-group" moment-picker="vm.schedule.workingDayClose" format="HH:mm:ss"><label class="control-label" for="field_workingDayClose" data-translate="pharmaPortalApp.company.schedule.workingDayClose">Working Day Close</label><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o"></i> </span><input class="form-control" placeholder="Select a time" ng-model="vm.schedule.workingDayClose" ng-model-options="{ updateOn: \'blur\' }" id="field_workingDayClose"></div></div><div class="form-check"><input class="form-check-input" type="checkbox" value="vm.schedule.workingDayDisabled" id="workingDayDisabled" ng-model="vm.schedule.workingDayDisabled"><label class="form-check-label" for="workingDayDisabled" data-translate="pharmaPortalApp.company.schedule.workingDayDisabled">N\xE3o gerar Sellouts em dias Uteis</label></div><div class="form-group" moment-picker="vm.schedule.saturdayOpen" format="HH:mm:ss"><label class="control-label" for="field_saturdayOpen" data-translate="pharmaPortalApp.company.schedule.saturdayOpen">Saturday Open</label><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o"></i> </span><input class="form-control" placeholder="Select a time" ng-model="vm.schedule.saturdayOpen" ng-model-options="{ updateOn: \'blur\' }" id="field_saturdayOpen"></div></div><div class="form-group" moment-picker="vm.schedule.saturdayClose" format="HH:mm:ss"><label class="control-label" for="field_saturdayClose" data-translate="pharmaPortalApp.company.schedule.saturdayClose">Saturday Close</label><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o"></i> </span><input class="form-control" placeholder="Select a time" ng-model="vm.schedule.saturdayClose" ng-model-options="{ updateOn: \'blur\' }" id="field_saturdayClose"></div></div><div class="form-check"><input class="form-check-input" type="checkbox" value="vm.schedule.saturdayDisabled" id="saturdayDisabled" ng-model="vm.schedule.saturdayDisabled"><label class="form-check-label" for="saturdayDisabled" data-translate="pharmaPortalApp.company.schedule.saturdayDisabled">N\xE3o gerar Sellouts aos S\xE1bados</label></div><div class="form-group" moment-picker="vm.schedule.sundayOpen" format="HH:mm:ss"><label class="control-label" for="field_sundayOpen" data-translate="pharmaPortalApp.company.schedule.sundayOpen">Sunday Open</label><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o"></i> </span><input class="form-control" placeholder="Select a time" ng-model="vm.schedule.sundayOpen" ng-model-options="{ updateOn: \'blur\' }" id="field_sundayOpen"></div></div><div class="form-group" moment-picker="vm.schedule.sundayClose" format="HH:mm:ss"><label class="control-label" for="field_sundayClose" data-translate="pharmaPortalApp.company.schedule.sundayClose">Sunday Close</label><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o"></i> </span><input class="form-control" placeholder="Select a time" ng-model="vm.schedule.sundayClose" ng-model-options="{ updateOn: \'blur\' }" id="field_sundayClose"></div></div><div class="form-check"><input class="form-check-input" type="checkbox" value="vm.schedule.sundayDisabled" id="sundayDisabled" ng-model="vm.schedule.sundayDisabled"><label class="form-check-label" for="sundayDisabled" data-translate="pharmaPortalApp.company.schedule.sundayDisabled">N\xE3o gerar Sellouts aos Domingos</label></div><div class="form-group" moment-picker="vm.schedule.holidayOpen" format="HH:mm:ss"><label class="control-label" for="field_holidayOpen" data-translate="pharmaPortalApp.company.schedule.holidayOpen">Holiday Open</label><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o"></i> </span><input class="form-control" placeholder="Select a time" ng-model="vm.schedule.holidayOpen" ng-model-options="{ updateOn: \'blur\' }" id="field_holidayOpen"></div></div><div class="form-group" moment-picker="vm.schedule.holidayClose" format="HH:mm:ss"><label class="control-label" for="field_holidayClose" data-translate="pharmaPortalApp.company.schedule.holidayClose">Holiday Close</label><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o"></i> </span><input class="form-control" placeholder="Select a time" ng-model="vm.schedule.holidayClose" ng-model-options="{ updateOn: \'blur\' }" id="field_holidayClose"></div></div><div class="form-check"><input class="form-check-input" type="checkbox" value="vm.schedule.holidayDisabled" id="holidayDisabled" ng-model="vm.schedule.holidayDisabled"><label class="form-check-label" for="holidayDisabled" data-translate="pharmaPortalApp.company.schedule.holidayDisabled">N\xE3o gerar Sellouts em Feriados</label></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/pharma-balance/pharma-balance-confirm-dialog.html','<form name="submitCloseMonthForm" ng-submit="vm.confirmCloseMonth()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaBalance.confirmCloseMonthDialog.title">Confirm close month</h4></div><div class="modal-body"><div class="col-md-12"><div class="row"><span class="modal-title" data-translate="pharmaPortalApp.pharmaBalance.confirmCloseMonthDialog.body1">Confirm close month action submit?</span></div><div class="row"><span class="modal-title" data-translate="pharmaPortalApp.pharmaBalance.confirmCloseMonthDialog.body">To finish the closing month process, please indicate the date to be used in the documents that will be generated</span></div><div class="form-group row"><label for="orderDate" class="col-md-offset-1 col-md-3 control-label" translate="pharmaPortalApp.pharmaBalance.form.orderDate">Order Date</label><div class="col-md-7"><div class="input-group input-group-sm"><input type="text" class="form-control" ng-click="vm.openDatePopup()" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.orderDate" is-open="vm.datePopup.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="row"><span class="modal-title" data-translate="pharmaPortalApp.pharmaBalance.confirmCloseMonthDialog.body2">This action cannot be undone.</span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-balance/pharma-balance-report-dialog.html','<div class="table-dialog"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Relat\xF3rio de Demonstra\xE7\xE3o de Resultados por Farm\xE1cia</h4></div><div class="modal-body"><div class="container-fluid well well-sm"><div class="col-md-4"><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-info btn-sm" ng-click="vm.prevCompany()" title="{{\'pharmaPortalApp.pharmaBalance.form.back\' | translate}}"><i class="fa fa-step-backward"></i></button> </span><input class="form-control text-center text-uppercase input-sm" type="text" ng-value="vm.curPharmacy.naming" disabled="disabled"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm" ng-click="vm.nextCompany()" title="{{\'pharmaPortalApp.pharmaBalance.form.next\' | translate}}"><i class="fa fa-step-forward"></i></button></span></div></div><div class="col-md-offset-4 col-md-4"><button type="button" ng-click="vm.exportToPdf()" class="btn btn-warning btn-sm pull-right"><i class="fa fa-file-pdf-o"></i>&nbsp;<span data-translate="entity.action.exportToPdf">Export PDF</span></button></div></div><div class="container-fluid"><div id="demoScroll" class="table-responsive table-responsive5 demoScroll" infinite-scroll="loadMoreItems()" infinite-scroll-immediate-check="false" infinite-scroll-distance="1" infinite-scroll-container="\'#demoScroll\'" style="max-height:500px;overflow-x: hidden; overflow-y: auto"><table class="jh-table table table-striped table-bordered panel tableCell" table-hover-highlight float-thead="floatTheadOptions5" ng-model="detailedProductInfoDialog"><thead><tr class="topHeader"><th></th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.previousPeriodBalance">Previous Period Balance</th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.purchases">Purchases</th><th colspan="3" translate="pharmaPortalApp.pharmaBalance.table.initialAndPurchases">Initial + Purchases</th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.sales">Sales</th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.adjustment">Adjustment</th><th colspan="3" translate="pharmaPortalApp.pharmaBalance.table.nextPeriodBalance">Next Period Balance</th></tr><tr><th class="table-right" translate="pharmaPortalApp.pharmaBalance.form.product">Product</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.total">Total</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.diff">Diff</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.total">Total</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.total">Total</th></tr></thead><tbody><tr ng-repeat="item in detailedProductInfoDialog | filter: { productCnp: \'!999999999\' } track by $index"><td class="table-left"><strong>{{item.productCnp+\' - \'+item.productDesc}}</strong></td><td class="table-right">{{item.previousBalanceQuantity}}</td><td class="table-right">{{item.previousBalanceUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.purchasesQuantity}}</td><td class="table-right">{{item.purchasesUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.initialBalanceQuantity}}</td><td class="table-right">{{item.initialBalanceUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.initialBalanceTotal | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.salesQuantity}}</td><td class="table-right">{{item.salesUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.adjustmentBalance | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.adjustmentTotal | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.remainBalanceQuantity}}</td><td class="table-right">{{item.remainBalanceUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.remainBalanceTotal | currency : \'\u20AC\' : 2}}</td></tr></tbody><tfooter><tr ng-repeat="item in detailedProductInfoDialog | filter: { productCnp: \'999999999\' } track by $index"><td class="table-right">TOTAIS</td><td class="table-right">{{item.previousBalanceQuantity}}</td><td class="table-right"></td><td class="table-right">{{item.purchasesQuantity}}</td><td class="table-right"></td><td class="table-right">{{item.initialBalanceQuantity}}</td><td class="table-right"></td><td class="table-right">{{item.initialBalanceTotal | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.salesQuantity}}</td><td class="table-right"></td><td class="table-right"></td><td class="table-right">{{item.adjustmentTotal | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.remainBalanceQuantity}}</td><td class="table-right"></td><td class="table-right">{{item.remainBalanceTotal | currency : \'\u20AC\' : 2}}</td></tr></tfooter></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div></div>');
$templateCache.put('app/entities/pharma-balance/pharma-balances.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaBalance.home.title">Pharma Balance</span> <span class="clearfix"></span></div><div class="panel-body"><div class="form-inline container-fluid well well-sm"><div class="form-group"><label for="pharmacy" translate="pharmaPortalApp.pharmaBalance.form.period">Period</label>&nbsp;<div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-info btn-sm" ng-click="vm.prevPeriod()" title="{{\'pharmaPortalApp.pharmaBalance.form.back\' | translate}}"><i class="fa fa-step-backward"></i></button> </span><input class="form-control text-center text-uppercase input-sm" type="text" ng-value="vm.currentPeriod | date : \'MMMM / yyyy\'" disabled="disabled"> <span class="input-group-btn"><button type="button" class="btn btn-info btn-sm" ng-click="vm.nextPeriod()" title="{{\'pharmaPortalApp.pharmaBalance.form.next\' | translate}}" ng-disabled="!vm.monthIsLock"><i class="fa fa-step-forward"></i></button></span></div></div><div class="form-group">&nbsp;&nbsp;<label for="pharmacy" translate="pharmaPortalApp.pharmaBalance.form.pharmacy">Pharmacy</label>&nbsp;<any ng-switch="vm.curPharmaciesSelector.length"><any ng-switch-when="0"><input class="form-control text-center input-sm" type="text" value="{{pharmaPortalApp.pharmaBalance.form.noPharmacy | translate}}" disabled="disabled"></any><any ng-switch-default><ui-select multiple="multiple" id="pharmacy" name="pharmacy" ng-model="vm.filter.pharmacies" close-on-select="false" on-select="vm.doFilter()" on-remove="vm.doFilter()"><ui-select-match>{{$item.namingForOptions}}</ui-select-match><ui-select-choices repeat="item in vm.curPharmaciesSelector | filter: $select.search track by $index"><span ng-bind-html="item.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></any></any></div><div class="form-group">&nbsp;&nbsp;<label for="product" translate="pharmaPortalApp.pharmaBalance.form.product">Product</label>&nbsp;<ui-select multiple="multiple" id="product" name="product" ng-model="vm.filter.products" close-on-select="false" on-select="vm.doFilter()" on-remove="vm.doFilter()"><ui-select-match placeholder="{{\'global.form.search.placeholder.product\' | translate}}">{{$item.cnp + \' - \'+ $item.desc}}</ui-select-match><ui-select-choices repeat="item in vm.products | filter: $select.search track by $index" refresh="refreshSelectModel($select.search)" refresh-delay="500" minimum-input-length="3"><span ng-bind-html="item.cnp + \' - \'+ item.desc | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group pull-right"><any ng-switch="vm.monthIsLock"><any ng-switch-when="true"><h3 style="margin:0"><span class="label label-danger"><span translate="pharmaPortalApp.pharmaBalance.form.statusClosed">Closed</span></span></h3></any><any ng-switch-default><h3 style="margin:0"><span class="label label-success"><span translate="pharmaPortalApp.pharmaBalance.form.statuspen">Open</span></span></h3></any></any></div></div><uib-tabset active="active"><uib-tab index="0" heading="{{\'pharmaPortalApp.pharmaBalance.home.resultsReport\' | translate}}" ng-click="vm.getTab1Content()"><div class="container-fluid row"><any class="col-md-6"><div class="table-responsive table-responsive1"><table class="jh-table table table-striped table-bordered tableCell" table-hover-highlight float-thead="floatTheadOptions1" ng-model="globalValues"><thead><tr><th class="table-left" width="20%" data-translate="pharmaPortalApp.pharmaBalance.table.activity">Activity</th><th class="table-right" width="20%"></th><th class="table-right" width="15%" data-translate="pharmaPortalApp.pharmaBalance.table.month">Month</th><th class="table-right" width="15%" data-translate="pharmaPortalApp.pharmaBalance.table.percent">%</th><th class="table-right" width="15%" data-translate="pharmaPortalApp.pharmaBalance.table.accumulated">Accumulated</th><th class="table-right" width="15%" data-translate="pharmaPortalApp.pharmaBalance.table.percent">%</th></tr></thead><tbody><tr><td class="table-left"><strong data-translate="pharmaPortalApp.pharmaBalance.table.global">Global</strong></td><td class="table-right" data-translate="pharmaPortalApp.pharmaBalance.table.sales">Sales</td><td class="table-right">{{globalValues.month.sales | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td><td class="table-right">{{globalValues.accumulated.sales | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td></tr><tr><td></td><td class="table-right" data-translate="pharmaPortalApp.pharmaBalance.table.salesCost">Sales Cost</td><td class="table-right">{{globalValues.month.salesCost | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td><td class="table-right">{{globalValues.accumulated.salesCost | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td></tr><tr><td></td><td class="table-right" data-translate="pharmaPortalApp.pharmaBalance.table.adjustment">Adjustment</td><td class="table-right">{{globalValues.month.adjustments | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td><td class="table-right">{{globalValues.accumulated.adjustments | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td></tr><tr><td></td><td class="table-right" data-translate="pharmaPortalApp.pharmaBalance.table.margin">Margin</td><td class="table-right">{{globalValues.month.margin | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{globalValues.month.marginPerc | currency : \'%\' : 2}}</td><td class="table-right">{{globalValues.accumulated.margin | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{globalValues.accumulated.marginPerc | currency : \'%\' : 2}}</td></tr></tbody></table></div><div class="well"><highchart id="chart1" config="chartConfig"></highchart></div></any><any class="col-md-6"><div class="table-responsive table-responsive2"><table class="jh-table table table-striped table-bordered tableCell" table-hover-highlight float-thead="floatTheadOptions2" ng-model="globalValues.warehouse"><thead><tr><th class="table-left" width="20%" data-translate="pharmaPortalApp.pharmaBalance.table.activity">Activity</th><th class="table-right" width="20%"></th><th class="table-right" width="15%" data-translate="pharmaPortalApp.pharmaBalance.table.month">Month</th><th class="table-right" width="15%" data-translate="pharmaPortalApp.pharmaBalance.table.percent">%</th><th class="table-right" width="15%" data-translate="pharmaPortalApp.pharmaBalance.table.accumulated">Accumulated</th><th class="table-right" width="15%" data-translate="pharmaPortalApp.pharmaBalance.table.percent">%</th></tr></thead><tbody ng-repeat="warehouses in globalValues.warehouse track by $index"><tr><td class="table-left"><strong>{{warehouses.accumulated.entity.naming}}</strong></td><td class="table-right" data-translate="pharmaPortalApp.pharmaBalance.table.sales">Sales</td><td class="table-right">{{warehouses.month.sales | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td><td class="table-right">{{warehouses.accumulated.sales | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td></tr><tr><td></td><td class="table-right" data-translate="pharmaPortalApp.pharmaBalance.table.salesCost">Sales Cost</td><td class="table-right">{{warehouses.month.salesCost | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td><td class="table-right">{{warehouses.accumulated.salesCost | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td></tr><tr ng-hide="warehouses.month.entity.warehouse == 999"><td></td><td class="table-right" data-translate="pharmaPortalApp.pharmaBalance.table.adjustment">Adjustment</td><td class="table-right">{{warehouses.month.adjustments | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td><td class="table-right">{{warehouses.accumulated.adjustments | currency : \'\u20AC\' : 2}}</td><td class="table-right"></td></tr><tr><td></td><td class="table-right" data-translate="pharmaPortalApp.pharmaBalance.table.margin">Margin</td><td class="table-right">{{warehouses.month.margin | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{warehouses.month.marginPerc | currency : \'%\' : 2}}</td><td class="table-right">{{warehouses.accumulated.margin | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{warehouses.accumulated.marginPerc | currency : \'%\' : 2}}</td></tr></tbody></table></div></any></div></uib-tab><uib-tab index="1" heading="{{\'pharmaPortalApp.pharmaBalance.home.pharmaciesReport\' | translate}}" ng-click="vm.getTab2Content()"><div class="container-fluid"><div class="table-responsive table-responsive3"><table class="jh-table table table-striped table-bordered tableCell" table-hover-highlight float-thead="floatTheadOptions3" ng-model="detailedPharmacyInfo"><thead><tr class="topHeader"><th></th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.previousPeriodBalance">Previous Period Balance</th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.purchases">Purchases</th><th colspan="3" translate="pharmaPortalApp.pharmaBalance.table.initialAndPurchases">Initial + Purchases</th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.sales">Sales</th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.adjustment">Adjustment</th><th colspan="3" translate="pharmaPortalApp.pharmaBalance.table.nextPeriodBalance">Next Period Balance</th></tr><tr><th class="table-right" translate="pharmaPortalApp.pharmaBalance.form.pharmacy">Pharmacy</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.total">Total</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.diff">Diff</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.total">Total</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.total">Total</th></tr></thead><tbody ng-repeat="item in detailedPharmacyInfo track by $index"><tr><td class="table-left"><strong>{{item.company.naming}}</strong></td><td class="table-right">{{item.previousBalanceQuantity}}</td><td class="table-right">{{item.previousBalanceUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.purchasesQuantity}}</td><td class="table-right">{{item.purchasesUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.initialBalanceQuantity}}</td><td class="table-right">{{item.initialBalanceUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.initialBalanceTotal | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.salesQuantity}}</td><td class="table-right">{{item.salesUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.adjustmentBalance | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.adjustmentTotal | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.remainBalanceQuantity}}</td><td class="table-right">{{item.remainBalanceUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.remainBalanceTotal | currency : \'\u20AC\' : 2}}</td></tr></tbody></table></div></div></uib-tab><uib-tab index="2" heading="{{\'pharmaPortalApp.pharmaBalance.home.productsReport\' | translate}}" ng-click="vm.getTab3Content()"><div class="container-fluid"><div class="table-responsive table-responsive4"><span class="btn-group pull-right"><label class="btn btn-info" ng-model="vm.prodFilter" uib-btn-radio="\'0\'" ng-click="vm.doFilter()"><i class="fa fa-check-square-o" ng-class="{\'fa-square\' : vm.prodFilter != \'0\' }"></i>&nbsp;Entradas</label><label class="btn btn-info" ng-model="vm.prodFilter" uib-btn-radio="\'1\'" ng-click="vm.doFilter()"><i class="fa fa-check-square-o" ng-class="{\'fa-square\' : vm.prodFilter != \'1\' }"></i>&nbsp;Sa\xEDdas</label><label class="btn btn-info" ng-model="vm.prodFilter" uib-btn-radio="\'2\'" ng-click="vm.doFilter()"><i class="fa fa-check-square-o" ng-class="{\'fa-square\' : vm.prodFilter != \'2\' }"></i>&nbsp;Exist\xEAncias</label></span><table class="productsTable jh-table table table-striped table-bordered tableCell" table-hover-highlight float-thead="floatTheadOptions4" ng-model="detailedProductInfo"><thead><tr class="topHeader"><th></th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.previousPeriodBalance">Previous Period Balance</th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.purchases">Purchases</th><th colspan="3" translate="pharmaPortalApp.pharmaBalance.table.initialAndPurchases">Initial + Purchases</th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.sales">Sales</th><th colspan="2" translate="pharmaPortalApp.pharmaBalance.table.adjustment">Adjustment</th><th colspan="3" translate="pharmaPortalApp.pharmaBalance.table.nextPeriodBalance">Next Period Balance</th></tr><tr><th class="table-right" translate="pharmaPortalApp.pharmaBalance.form.product">Product</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.total">Total</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.diff">Diff</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.total">Total</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.units">Units</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.price">Price</th><th class="table-right" translate="pharmaPortalApp.pharmaBalance.table.total">Total</th></tr></thead><tbody infinite-scroll="loadMore()" infinite-scroll-distance="2" infinite-scroll-immediate-check="false"><tr ng-repeat="item in detailedProductInfo | filter: { productCnp: \'!999999999\' } track by $index"><td class="table-left"><strong>{{item.productCnp+\' - \'+item.productDesc}}</strong></td><td class="table-right">{{item.previousBalanceQuantity}}</td><td class="table-right">{{item.previousBalanceUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.purchasesQuantity}}</td><td class="table-right">{{item.purchasesUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.initialBalanceQuantity}}</td><td class="table-right">{{item.initialBalanceUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.initialBalanceTotal | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.salesQuantity}}</td><td class="table-right">{{item.salesUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.adjustmentBalance | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.adjustmentTotal | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.remainBalanceQuantity}}</td><td class="table-right">{{item.remainBalanceUnit | currency : \'\u20AC\' : 2}}</td><td class="table-right">{{item.remainBalanceTotal | currency : \'\u20AC\' : 2}}</td></tr></tbody></table></div></div></uib-tab></uib-tabset></div><div class="panel-footer"><div class="row"><div class="col-md-6"><button type="button" class="btn btn-info btn-sm" ui-sref="pharma-balance.report({period:vm.curPeriod})"><i class="fa fa-file-text-o"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaBalance.action.endMonthReport">End of the Month Report</span></button></div><div class="col-md-6"><div class="text-right"><button type="button" class="btn btn-warning btn-sm" ng-click="vm.closeMonth()" ng-disabled="vm.monthIsLock"><i class="fa fa-calculator"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaBalance.action.closeMonthCalc">Close Month Calculation</span></button> <button type="button" class="btn btn-success btn-sm" ui-sref="pharma-balance.closeMonth({period:vm.curPeriod})" ng-disabled="vm.monthIsLock"><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaBalance.action.confirm">Confirm</span></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/pharma-dashboard/pharma-dashboard-table-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" id="myChallengeTable" data-translate="pharmaPortalApp.pharmaDashboard.table.topChallenge" ng-show="vm.tableType==\'challenge\'">Top 10 Challenge</h4><h4 class="modal-title" id="myGlobaltable" data-translate="pharmaPortalApp.pharmaDashboard.table.topGlobal" ng-show="vm.tableType==\'global\'">Top 10 Global</h4><h4 class="modal-title" id="myPromotionTable" data-translate="pharmaPortalApp.pharmaDashboard.table.topPromotion" ng-show="vm.tableType==\'promotion\'">Top 10 Promotion</h4></div><div class="modal-body" style="overflow-y: auto; height: 600px"><div class="table-responsive table-responsive1"><table class="jh-table table table-striped dashboardTable" float-thead="floatTheadOptions1" ng-model="topSalesman"><thead><tr class="topHeader"><th class="table-right" width="5%">#</th><th class="table-center" width="20%"></th><th class="table-center" width="20%" data-translate="pharmaPortalApp.pharmaDashboard.table.name">Name</th><th class="table-left" width="20%" data-translate="pharmaPortalApp.pharmaDashboard.table.pharmacy">Pharmacy</th><th class="table-left" width="20%" data-translate="pharmaPortalApp.pharmaDashboard.table.value" ng-hide="vm.tableType==\'promotion\'">Value</th><th class="table-right" width="20%" data-translate="pharmaPortalApp.pharmaDashboard.table.quantity" ng-show="vm.tableType==\'promotion\'">Quantity</th></tr></thead><tbody><tr ng-repeat="salesman in vm.popupSalesman"><td class="table-right"></td><td class="table-center"><div ng-if="loadPhotos(salesman.salesmanDescription)==null"><ng-avatar string="{{salesman.salesmanDescription}}" upper-case="true" bind="true" auto-color="true" width="50" round-shape="true" style="padding: 5px; margin: 0 auto"></ng-avatar></div><img ng-src="{{\'data:\' + vm.tableUser.thumbnailContentType + \';base64,\' + vm.tableUser.thumbnail}}" ng-if="loadPhotos(salesman.salesmanDescription)!=null" style="max-height: 50px; max-width: 75px; padding: 5px; border-radius: 15px"></td><td class="table-left">{{salesman.salesmanDescription}}</td><td class="table-left">{{salesman.pharmacyDescription}}</td><td class="table-right" ng-hide="vm.tableType==\'promotion\'">{{salesman.value | currency :\'\u20AC\' : \'2\'}}<br><h6 ng-show="vm.tableType==\'challenge\'">({{salesman.quantity}})</h6></td><td class="table-right" ng-show="vm.tableType==\'promotion\'">{{salesman.quantity}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.cancel()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaDashboard.close">Close</span></button></div>');
$templateCache.put('app/entities/pharma-dashboard/pharma-dashboard.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaDashboard.home.title">Dashboard</span> <button class="btn btn-warning btn-sm pull-right" ng-click="vm.changeFilter()"><i ng-class="{\'fa fa-search-plus\':vm.showFilter==false, \'fa fa-search-minus\':vm.showFilter==true}"></i></button> <span class="clearfix"></span></div><div class="panel-body"><div ng-class="{\'dashboardSM\':vm.isSM, \'dashboardMD\':vm.isMD}"><div class="container-fluid well well-sm" ng-show="vm.showFilter"><form id="filterDashboard"><div class="col-md-4"><div class="form-group"><label for="periodDashboard" data-translate="pharmaPortalApp.pharmaDashboard.form.period">Period</label><ui-select id="periodDashboard" name="period" ng-model="vm.filter.period"><ui-select-match allow-clear="false">{{$select.selected.monthName}} {{$select.selected.year}}</ui-select-match><ui-select-choices repeat="period as period in vm.periods | filter: $select.search"><span ng-bind-html="period.monthName + \' \' + period.year | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><label for="periodTypeDashboard" data-translate="pharmaPortalApp.pharmaDashboard.form.periodType">Period Type</label><ui-select id="periodTypeDashboard" name="periodType" ng-model="vm.filter.periodType"><ui-select-match allow-clear="false">{{$select.selected.periodTypeName}}</ui-select-match><ui-select-choices repeat="periodType as periodType in vm.periodTypes | filter: $select.search"><span ng-bind-html="periodType.periodTypeName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><label for="campaignTypeDashboard" data-translate="pharmaPortalApp.pharmaDashboard.form.campaignType">Campaign Type</label><ui-select id="campaignTypeDashboard" name="campaignType" ng-model="vm.filter.campaignType" on-select="loadCampaigns()"><ui-select-match allow-clear="true">{{\'pharmaPortalApp.pharmaDashboard.campaignType.\' + $select.selected | translate}}</ui-select-match><ui-select-choices repeat="campaignType as campaignType in vm.campaignTypes | filter: $select.search"><span ng-bind-html="\'pharmaPortalApp.pharmaDashboard.campaignType.\' + campaignType | translate | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><label for="campaignNameDashboard" data-translate="pharmaPortalApp.pharmaDashboard.form.campaign">Campaign</label><ui-select id="campaignNameDashboard" name="campaignName" ng-model="vm.filter.campaign" ng-disabled="vm.filter.campaignType==null" on-select="loadPharmacies()"><ui-select-match allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="campaign as campaign in vm.filteredCampaigns | filter: $select.search"><span ng-bind-html="campaign.name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><label for="companyDashboard" data-translate="pharmaPortalApp.pharmaDashboard.form.pharmacy">Pharmacy</label><ui-select id="companyDashboard" name="company" ng-model="vm.filter.company" ng-disabled="vm.isAuthorized == false" on-select="loadSalesman()"><ui-select-match allow-clear="true">{{$select.selected.namingForOptions}}</ui-select-match><ui-select-choices repeat="company as company in vm.companies | filter: $select.search | orderBy:\'naming\'"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-4"><div class="form-group"><label for="salesmanDashboard" data-translate="pharmaPortalApp.pharmaDashboard.form.salesman">Salesman</label><ui-select id="salesmanDashboard" name="salesman" ng-model="vm.filter.salesman" ng-disabled="vm.filter.company==null"><ui-select-match allow-clear="true">{{$select.selected.salesmanDescription}}</ui-select-match><ui-select-choices repeat="salesman as salesman in vm.filteredSalesman | filter: $select.search"><span ng-bind-html="salesman.salesmanDescription | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-12"><div class="form-group pull-right"><button class="btn btn-warning" ng-click="vm.clearFilter()" title="{{\'entity.action.reset\' | translate}}"><i class="fa fa-times"></i>&nbsp; <span data-translate="entity.action.reset">Reset</span></button> <button type="submit" class="btn btn-info" ng-click="vm.filterDashboard()" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i>&nbsp; <span data-translate="entity.action.search">search</span></button></div></div></form></div><div class="row"><div class="col-md-9"><div class="row"><div class="col-md-12" ng-class="{\'col-md-6\':vm.filter.campaignType == null}" id="challengeCard" ng-hide="vm.filter.campaignType==\'PROMOTION\'"><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title" data-translate="pharmaPortalApp.pharmaDashboard.panel.challenge">Challenge</h3><span class="clearfix"></span></div><div class="panel-body"><div class="row"><div id="salesmanValuePanel" class="col-md-6" ng-class="{\'bg-danger\':vm.salesman.value<vm.lastSalesman.value,\'bg-warning\':vm.salesman.value==vm.lastSalesman.value||vm.lastSalesman.value==null || vm.salesman.value==null,\'bg-success\':vm.salesman.value>vm.lastSalesman.value}"><div class="panel-body"><h4 class="panel-title">{{vm.salesman.salesmanDescription}}</h4><h4>{{vm.salesman.value | currency : \'\u20AC\' : \'2\'}}</h4><p><span data-translate="pharmaPortalApp.pharmaDashboard.panel.target">Target</span>: {{vm.salesman.targetValue | currency : \'\u20AC\' : \'2\'}}</p><p><span data-translate="pharmaPortalApp.pharmaDashboard.panel.previous">Previous</span>: {{vm.lastSalesman.value | currency : \'\u20AC\' : \'2\'}}</p></div><span class="clearfix"></span></div><div id="pharmValuePanel" class="col-md-6" ng-class="{\'bg-danger\':vm.pharmacy.value<vm.lastPharmacy.value,\'bg-warning\':vm.pharmacy.value==vm.lastPharmacy.value||vm.lastPharmacy.value==null || vm.pharmacy.value==null,\'bg-success\':vm.pharmacy.value>vm.lastPharmacy.value}"><div class="panel-body"><h4 class="panel-title">{{vm.pharmacy.pharmacyDescription}}</h4><h4>{{vm.pharmacy.value | currency : \'\u20AC\' : \'2\'}}</h4><p><span data-translate="pharmaPortalApp.pharmaDashboard.panel.target">Target</span>: {{vm.pharmacy.targetValue | currency : \'\u20AC\' : \'2\'}}</p><p><span data-translate="pharmaPortalApp.pharmaDashboard.panel.previous">Previous</span>: {{vm.lastPharmacy.value | currency : \'\u20AC\' : \'2\'}}</p></div><span class="clearfix"></span></div></div></div></div></div><div class="col-md-12" ng-class="{\'col-md-6\':vm.filter.campaignType == null}" id="promotionCard" ng-hide="vm.filter.campaignType==\'CHALLENGE\'"><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title" data-translate="pharmaPortalApp.pharmaDashboard.panel.promotion">Newsletter</h3><span class="clearfix"></span></div><div class="panel-body"><div class="row"><div id="salesmanQuantityPanel" class="col-md-6" ng-class="{\'bg-danger\':vm.salesman.quantity<vm.lastSalesman.quantity,\'bg-warning\':vm.salesman.quantity==vm.lastSalesman.quantity||vm.lastSalesman.quantity==null || vm.salesman.quantity==null,\'bg-success\':vm.salesman.quantity>vm.lastSalesman.quantity}"><div class="panel-body"><h4 class="panel-title">{{vm.salesman.salesmanDescription}}</h4><h4>{{vm.salesman.quantity}}</h4><p><span data-translate="pharmaPortalApp.pharmaDashboard.panel.target">Target</span>: {{vm.salesman.targetQuantity}}</p><p><span data-translate="pharmaPortalApp.pharmaDashboard.panel.previous">Previous</span>: {{vm.lastSalesman.quantity}}</p></div><span class="clearfix"></span></div><div id="pharmQuantityPanel" class="col-md-6" ng-class="{\'bg-danger\':vm.pharmacy.quantity<vm.lastPharmacy.quantity,\'bg-warning\':vm.pharmacy.quantity==vm.lastPharmacy.quantity||vm.lastPharmacy.quantity==null || vm.pharmacy.quantity==null,\'bg-success\':vm.pharmacy.quantity>vm.lastPharmacy.quantity}"><div class="panel-body"><h4 class="panel-title">{{vm.pharmacy.pharmacyDescription}}</h4><h4>{{vm.pharmacy.quantity}}</h4><p><span data-translate="pharmaPortalApp.pharmaDashboard.panel.target">Target</span>: {{vm.pharmacy.targetQuantity}}</p><p><span data-translate="pharmaPortalApp.pharmaDashboard.panel.previous">Previous</span>: {{vm.lastPharmacy.quantity}}</p></div><span class="clearfix"></span></div></div></div></div></div></div><div class="row"><div class="col-md-6" ng-class="{\'col-md-4\':vm.filter.campaignType == null}" id="tabTotal"><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title" data-translate="pharmaPortalApp.pharmaDashboard.table.topGlobal">Top 10 Global</h3><span class="clearfix"></span></div><div class="panel-body"><div class="row"><div class="table-responsive"><table class="jh-table table table-striped table-condensed dashboardTable" float-thead="floatTheadOptions1" ng-model="topSalesman"><thead><tr class="topHeader"><th class="table-center">#</th><th class="table-center" data-translate="pharmaPortalApp.pharmaDashboard.table.name">Name</th><th class="table-center"><span data-translate="pharmaPortalApp.pharmaDashboard.table.pharmacy">Pharmacy</span> &nbsp;|&nbsp;<br><span data-translate="pharmaPortalApp.pharmaDashboard.table.value">Value</span></th></tr></thead><tbody><tr ng-repeat="salesman in vm.selloutTop"><td class="text-right"></td><td class="text-center"><div ng-if="loadPhotos(salesman.salesmanDescription)==null"><ng-avatar string="{{salesman.salesmanDescription}}" upper-case="true" bind="true" auto-color="true" width="50" round-shape="true" style="padding: 5px; margin: 0 auto"></ng-avatar></div><img ng-src="{{\'data:\' + vm.tableUser.thumbnailContentType + \';base64,\' + vm.tableUser.thumbnail}}" ng-if="loadPhotos(salesman.salesmanDescription)!=null" style="max-height: 50px; max-width: 75px; padding: 5px; border-radius: 15px"><p>{{salesman.salesmanDescription}}</p></td><td class="table-right"><p>{{salesman.pharmacyDescription}}</p><p><strong>{{salesman.value | currency :\'\u20AC\' : \'2\'}}</strong></p></td></tr></tbody></table><div class="col-md-12"><button type="button" class="btn btn-info btn-xs btn-block" ng-click="vm.openPopup(\'global\')" data-translate="pharmaPortalApp.pharmaDashboard.table.seeAll">See All</button></div></div></div></div></div></div><div class="col-md-6" ng-class="{\'col-md-4\':vm.filter.campaignType == null}" id="tabValue" ng-hide="vm.filter.campaignType==\'PROMOTION\'"><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title" data-translate="pharmaPortalApp.pharmaDashboard.table.topChallenge">Top 10 Challenge</h3><span class="clearfix"></span></div><div class="panel-body"><div class="row"><div class="table-responsive"><table class="jh-table table table-striped table-condensed dashboardTable" float-thead="floatTheadOptions1" ng-model="topSalesman"><thead><tr class="topHeader"><th class="table-center">#</th><th class="table-center" data-translate="pharmaPortalApp.pharmaDashboard.table.name">Name</th><th class="table-center"><span data-translate="pharmaPortalApp.pharmaDashboard.table.pharmacy">Pharmacy</span> &nbsp;|&nbsp;<br><span data-translate="pharmaPortalApp.pharmaDashboard.table.value">Value</span></th></tr></thead><tbody><tr ng-repeat="salesman in vm.salesmanValue"><td class="table-right"></td><td class="text-center"><div ng-if="loadPhotos(salesman.salesmanDescription)==null"><ng-avatar string="{{salesman.salesmanDescription}}" upper-case="true" bind="true" auto-color="true" width="50" round-shape="true" style="padding: 5px; margin: 0 auto"></ng-avatar></div><img ng-src="{{\'data:\' + vm.tableUser.thumbnailContentType + \';base64,\' + vm.tableUser.thumbnail}}" ng-if="loadPhotos(salesman.salesmanDescription)!=null" style="max-height: 50px; max-width: 75px; padding: 5px; border-radius: 15px"><p>{{salesman.salesmanDescription}}</p></td><td class="table-right"><p>{{salesman.pharmacyDescription}}</p><p><strong>{{salesman.value | currency :\'\u20AC\' : \'2\'}}</strong><br></p><h6>({{salesman.quantity}})</h6><p></p></td></tr></tbody></table><div class="col-md-12"><button type="button" class="btn btn-info btn-xs btn-block" ng-click="vm.openPopup(\'challenge\')" data-translate="pharmaPortalApp.pharmaDashboard.table.seeAll">See All</button></div></div></div></div></div></div><div class="col-md-6" ng-class="{\'col-md-4\':vm.filter.campaignType == null}" id="tabQuantity" ng-hide="vm.filter.campaignType==\'CHALLENGE\'"><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title" data-translate="pharmaPortalApp.pharmaDashboard.table.topPromotion">Top 10 Newsletter</h3><span class="clearfix"></span></div><div class="panel-body"><div class="row"><div class="table-responsive"><table class="jh-table table table-striped table-condensed dashboardTable" float-thead="floatTheadOptions3" ng-model="topSalesman"><thead><tr class="topHeader"><th class="table-center">#</th><th class="table-center" data-translate="pharmaPortalApp.pharmaDashboard.table.name">Name</th><th class="table-center"><span data-translate="pharmaPortalApp.pharmaDashboard.table.pharmacy">Pharmacy</span> &nbsp;|&nbsp;<br><span data-translate="pharmaPortalApp.pharmaDashboard.table.quantity">Quantity</span></th></tr></thead><tbody><tr ng-repeat="salesman in vm.salesmanQuantity"><td class="table-right"></td><td class="table-center"><div ng-if="loadPhotos(salesman.salesmanDescription)==null"><ng-avatar string="{{salesman.salesmanDescription}}" upper-case="true" bind="true" auto-color="true" width="50" round-shape="true" style="padding: 5px; margin: 0 auto"></ng-avatar></div><img ng-src="{{\'data:\' + vm.tableUser.thumbnailContentType + \';base64,\' + vm.tableUser.thumbnail}}" ng-if="loadPhotos(salesman.salesmanDescription)!=null" style="max-height: 50px; max-width: 75px; padding: 5px; border-radius: 15px"><p>{{salesman.salesmanDescription}}</p></td><td class="table-right"><p>{{salesman.pharmacyDescription}}</p><p><strong>{{salesman.quantity}}</strong></p></td></tr></tbody></table><div class="col-md-12"><button type="button" class="btn btn-info btn-xs btn-block" ng-click="vm.openPopup(\'promotion\')" data-translate="pharmaPortalApp.pharmaDashboard.table.seeAll">See All</button></div></div></div></div></div></div></div></div><div id="topPharm" class="col-md-3"><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title" data-translate="pharmaPortalApp.pharmaDashboard.topPharmacies">Top Pharmacies</h3><span class="clearfix"></span></div><div class="panel-body"><ol type="1" style="padding-inline-start:15px"><li ng-repeat="pharmacy in vm.topPharmacies"><h5>{{pharmacy.pharmacyDescription}}</h5><div class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{pharmacy.meanValue}}" style="width: {{pharmacy.meanValue * 100 / vm.maxPharmValue}}%" aria-valuemin="0" aria-valuemax="vm.maxPharmValue">{{pharmacy.meanValue | currency :\'\u20AC\' : \'2\'}}</div></div></li></ol></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/pharma-covid/pharma-covid-detail.html','<form name="submitPharmaCovid" ng-submit="vm.exportCSV()"><div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left"><span data-translate="pharmaPortalApp.pharmaCovid.home.title">Pharma Covid</span><any ng-if="vm.startDate != null && vm.endDate != null">&nbsp;de&nbsp;<span>{{vm.startDate | date: \'dd/MM/yyyy\'}}</span>&nbsp;a&nbsp;<span>{{vm.endDate | date: \'dd/MM/yyyy\'}}</span></any></span><div class="btn-group pull-right"><button type="submit" class="btn btn-success btn-sm" ng-disabled="vm.covidList.length <= 0"><i class="fa fa-file-code-o"></i>&nbsp;<span class="hidden-xs" data-translate="pharmaPortalApp.pharmaCovid.home.exportCSV">Export to CSV</span></button> <button type="button" class="btn btn-info btn-sm" ng-click="vm.intervalModal()"><i class="fa fa-calendar-check-o"></i>&nbsp;<span class="hidden-xs" data-translate="pharmaPortalApp.pharmaCovid.home.selectInterval">Select Interval</span></button></div><span class="clearfix"></span></div><div class="panel-body"><div class="alert alert-warning" ng-show="vm.covidList.length <= 0" data-translate="pharmaPortalApp.pharmaCovid.noResults"></div><div class="table-responsive" ng-show="vm.covidList.length > 0"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th data-translate="pharmaPortalApp.pharmaCovid.nRegistoMedicamento">N Registo Medicamento</th><th data-translate="pharmaPortalApp.pharmaCovid.descricaoMedicamento">Descricao Medicamento</th><th data-translate="pharmaPortalApp.pharmaCovid.unidadesStock">Unidades Stock</th><th data-translate="pharmaPortalApp.pharmaCovid.unidadesAdquiridas">Unidades Adquiridas</th><th data-translate="pharmaPortalApp.pharmaCovid.unidadesVendidasHospitaisSns">Unidades Vendidas Hospitais SNS</th><th data-translate="pharmaPortalApp.pharmaCovid.vendasHospitaisSns">Vendas Hospitais SNS</th><th data-translate="pharmaPortalApp.pharmaCovid.unidadesVendidasHospitaisPrivados">Unidades Vendidas Hospitais Privados</th><th data-translate="pharmaPortalApp.pharmaCovid.vendasHospitaisPrivados">Vendas Hospitais Privados</th><th data-translate="pharmaPortalApp.pharmaCovid.unidadesVendidasFarmacias">Unidades Vendidas Farmacias</th><th data-translate="pharmaPortalApp.pharmaCovid.vendasFarmacias">Vendas Farmacias</th><th data-translate="pharmaPortalApp.pharmaCovid.unidadesVendidasDistribuidores">Unidades Vendidas Distribuidores</th><th data-translate="pharmaPortalApp.pharmaCovid.vendasDistribuidores">Vendas Distribuidores</th><th data-translate="pharmaPortalApp.pharmaCovid.unidadesVendidasIntracomunitarioExportacao">Unidades Vendidas Intracomunitario Exportacao</th><th data-translate="pharmaPortalApp.pharmaCovid.vendasIntracomunitarioExportacao">Vendas Intracomunitario Exportacao</th></tr></thead><tbody><tr ng-repeat="covid in vm.covidList track by $index"><td class="table-left">{{covid.nRegistoMedicamento}}</td><td class="table-left">{{covid.descricaoMedicamento}}</td><td class="table-right">{{covid.unidadesStock | number:0}}</td><td class="table-right">{{covid.unidadesAdquiridas | number:0}}</td><td class="table-right">{{covid.unidadesVendidasHospitaisSns | number:0}}</td><td class="table-right">{{covid.vendasHospitaisSns | number:0}}</td><td class="table-right">{{covid.unidadesVendidasHospitaisPrivados | number:0}}</td><td class="table-right">{{covid.vendasHospitaisPrivados | number:0}}</td><td class="table-right">{{covid.unidadesVendidasFarmacias | number:0}}</td><td class="table-right">{{covid.vendasFarmacias | number:0}}</td><td class="table-right">{{covid.unidadesVendidasDistribuidores | number:0}}</td><td class="table-right">{{covid.vendasDistribuidores | number:0}}</td><td class="table-right">{{covid.unidadesVendidasIntracomunitarioExportacao | number:0}}</td><td class="table-right">{{covid.vendasIntracomunitarioExportacao | number:0}}</td></tr></tbody></table></div></div></div></div></form>');
$templateCache.put('app/entities/pharma-covid/pharma-covid-dialog.html','<form class="form-horizontal" name="datesForm" ng-submit="vm.proceed()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaCovid.dialog.title">Date Interval</h4></div><div class="modal-body" id="modal-body"><p data-translate="pharmaPortalApp.pharmaCovid.dialog.message">Select the start and end date for the report data</p><div class="form-group"><label for="startDate" class="col-md-3 control-label" translate="pharmaPortalApp.pharmaCovid.form.startDate">Start Date</label><div class="col-md-6"><div class="input-group input-group-sm"><input type="text" class="form-control" id="startDate" ng-click="vm.openDatePopup(1)" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.startDate" is-open="vm.datePopup1.opened" datepicker-options="vm.dateOptions" placeholder="{{\'pharmaPortalApp.pharmaCovid.form.startDate\' | translate}}" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(1)"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="form-group"><label for="endDate" class="col-md-3 control-label" translate="pharmaPortalApp.pharmaCovid.form.endDate">End Date</label><div class="col-md-6"><div class="input-group input-group-sm"><input type="text" class="form-control" id="endDate" ng-click="vm.openDatePopup(2)" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.endDate" is-open="vm.datePopup2.opened" datepicker-options="vm.dateOptions" placeholder="{{\'pharmaPortalApp.pharmaCovid.form.endDate\' | translate}}" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(2)"><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="datesForm.$invalid"><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.ok">OK</span></button></div></form>');
$templateCache.put('app/entities/pharma-fault-report-header/pharma-fault-report-header-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pharmaFaultReportHeader.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="pharmaPortalApp.pharmaFaultReportHeader.delete.question" translate-values="{id: \'{{vm.pharmaFaultReportHeader.id}}\'}">Are you sure you want to delete this Pharma Fault Report Header?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pharma-fault-report-header/pharma-fault-report-header-detail.html','<div><h2><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.detail.title">Pharma Fault Report Header</span> {{vm.pharmaFaultReportHeader.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.reportDate">Report Date</span></dt><dd><span>{{vm.pharmaFaultReportHeader.reportDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.orderNumber">Order Number</span></dt><dd><span>{{vm.pharmaFaultReportHeader.orderNumber}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.supplierCode">Supplier Code</span></dt><dd><span>{{vm.pharmaFaultReportHeader.supplierCode}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.supplierDesc">Supplier Desc</span></dt><dd><span>{{vm.pharmaFaultReportHeader.supplierDesc}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.reprocessKey">Reprocess Key</span></dt><dd><span>{{vm.pharmaFaultReportHeader.reprocessKey}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.orderDate">Order Date</span></dt><dd><span>{{vm.pharmaFaultReportHeader.orderDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.status">Status</span></dt><dd><span data-translate="{{\'pharmaPortalApp.PharmaFaultReportStatus.\' + vm.pharmaFaultReportHeader.status}}">{{vm.pharmaFaultReportHeader.status}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.responseCode">Response Code</span></dt><dd><span>{{vm.pharmaFaultReportHeader.responseCode}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.responseMessage">Response Message</span></dt><dd><span>{{vm.pharmaFaultReportHeader.responseMessage}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="pharma-fault-report-header-detail.edit({id:vm.pharmaFaultReportHeader.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/pharma-fault-report-header/pharma-fault-report-header-history-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaFaultReportHeader.errors.title">Request history</h4></div><div class="modal-body"><div class="table-responsive"><table class="table table-condensed table-bordered table-striped table-hover"><thead><tr class="active"><th><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.errors.createdDate">Created Date</span></th><th><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.errors.errorCode">Error Code</span></th><th><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.errors.errorMessage">Error Message</span></th></tr></thead><tbody><tr ng-repeat="errorLine in vm.headerErrors | orderBy:\'-createdDate\' track by $index"><td>{{errorLine.createdDate | date:\'dd-MM-yyyy HH:mm:ss\'}}</td><td>{{errorLine.errorCode}}</td><td>{{errorLine.errorMessage}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-undo"></span>&nbsp;<span data-translate="entity.action.back">Back</span></button></div>');
$templateCache.put('app/entities/pharma-fault-report-header/pharma-fault-report-headers.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaFaultReportHeader.home.title">Pharma Fault Report Headers</span><div class="btn-group pull-right"><button type="button" class="btn btn-warning btn-sm" ng-click="vm.resync()"><i class="fa fa-refresh"></i>&nbsp;<span class="hidden-xs" data-translate="pharmaPortalApp.pharmaFaultReportHeader.resync">Resync</span></button> <button type="button" class="btn btn-info btn-sm" ng-click="vm.resend()"><i class="fa fa-calendar-check-o"></i>&nbsp;<span class="hidden-xs" data-translate="pharmaPortalApp.pharmaFaultReportHeader.resend">Resend</span></button></div><span class="clearfix"></span></div><div class="panel-body"><jhi-alert></jhi-alert><div class="table-responsive"><div class="alert alert-warning" ng-show="vm.pharmaFaultReportHeaders.length <= 0" style="margin-bottom: 0"><span data-translate="entity.noResults"></span></div><table class="jh-table table table-striped" ng-show="vm.pharmaFaultReportHeaders.length > 0"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="reportDate"><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.reportDate">Report Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="orderNumber"><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.orderNumber">Order Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="supplierDesc"><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.supplier">Supplier</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="orderDate"><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.orderDate">Order Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span data-translate="pharmaPortalApp.pharmaFaultReportHeader.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat-start="pharmaFaultReportHeader in vm.pharmaFaultReportHeaders track by pharmaFaultReportHeader.id"><td>{{pharmaFaultReportHeader.reportDate | date:\'mediumDate\'}}</td><td>{{pharmaFaultReportHeader.orderNumber}}</td><td>{{pharmaFaultReportHeader.supplierCode + \' - \'+ pharmaFaultReportHeader.supplierDesc}}</td><td>{{pharmaFaultReportHeader.orderDate | date:\'mediumDate\'}}</td><td data-translate="{{\'pharmaPortalApp.PharmaFaultReportStatus.\' + pharmaFaultReportHeader.status}}">{{pharmaFaultReportHeader.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.expandCollapse(pharmaFaultReportHeader)" class="btn btn-info btn-sm"><i ng-if="pharmaFaultReportHeader.expanded" class="fa fa-caret-up"></i> <i ng-if="!pharmaFaultReportHeader.expanded" class="fa fa-caret-down"></i></button> <button type="submit" ui-sref="pharma-fault-report-header.history({id:pharmaFaultReportHeader.id})" class="btn btn-primary btn-sm" ng-placeholder="{{entity.action.history |translate}}" ng-disabled="pharmaFaultReportHeader.pharmaRepHeaderErrors.length == 0"><span class="glyphicon glyphicon-education"></span></button> <button type="submit" ui-sref="pharma-fault-report-header.delete({id:pharmaFaultReportHeader.id})" class="btn btn-danger btn-sm" ng-placeholder="{{entity.action.delete |translate}}"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr><tr ng-show="pharmaFaultReportHeader.expanded" ng-repeat-end="pharmaFaultReportHeader" class="success"><td colspan="7"><div class="alert alert-warning" ng-show="pharmaFaultReportHeader.pharmaFaultReportLines.length <= 0" style="margin-bottom: 0"><span data-translate="entity.noResults"></span></div><table class="table table-condensed table-bordered table-striped table-hover" style="margin-bottom: 0" ng-show="pharmaFaultReportHeader.pharmaFaultReportLines.length > 0"><thead><tr><th class="text-center" data-translate="pharmaPortalApp.pharmaFaultReportLine.productCode">Product Code</th><th class="text-center" data-translate="pharmaPortalApp.pharmaFaultReportLine.productDesc">Product Desc</th><th class="text-center" data-translate="pharmaPortalApp.pharmaFaultReportLine.orderedQuantity">Ordered Quantity</th><th class="text-center" data-translate="pharmaPortalApp.pharmaFaultReportLine.receivedQuantity">Received Quantity</th><th class="text-center" data-translate="pharmaPortalApp.pharmaFaultReportLine.missingQuantity">Missing Quantity</th><th class="text-center" data-translate="pharmaPortalApp.pharmaFaultReportLine.exportedQuantity">Exported Quantity</th><th></th></tr></thead><tbody><tr ng-repeat="lineLine in pharmaFaultReportHeader.pharmaFaultReportLines"><td class="text-center">{{lineLine.productCode}}</td><td class="text-center">{{lineLine.productDesc}}</td><td class="text-center">{{lineLine.orderedQuantity}}</td><td class="text-center">{{lineLine.receivedQuantity}}</td><td class="text-center">{{lineLine.missingQuantity}}</td><td class="text-center">{{lineLine.exportedQuantity}}</td><td class="text-right"><button type="submit" ui-sref="pharma-fault-report-line-history({id:lineLine.id})" class="btn btn-primary btn-sm" ng-placeholder="{{entity.action.history |translate}}" ng-disabled="lineLine.pharmaRepLineErrors.length == 0"><span class="glyphicon glyphicon-education"></span></button></td></tr></tbody></table></td></tr></tbody></table></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/pharma-fault-report-header/pharma-fault-report-line-history-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaFaultReportLine.errors.title">Request history</h4></div><div class="modal-body"><div class="table-responsive"><table class="table table-condensed table-bordered table-striped table-hover"><thead><tr class="active"><th><span data-translate="pharmaPortalApp.pharmaFaultReportLine.errors.createdDate">Created Date</span></th><th><span data-translate="pharmaPortalApp.pharmaFaultReportLine.errors.errorCode">Error Code</span></th><th><span data-translate="pharmaPortalApp.pharmaFaultReportLine.errors.errorMessage">Error Message</span></th></tr></thead><tbody><tr ng-repeat="errorLine in vm.lineErrors | orderBy:\'-createdDate\' track by $index"><td>{{errorLine.createdDate | date:\'dd-MM-yyyy HH:mm:ss\'}}</td><td>{{errorLine.errorCode}}</td><td>{{errorLine.errorMessage}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-undo"></span>&nbsp;<span data-translate="entity.action.back">Back</span></button></div>');
$templateCache.put('app/entities/pharma-infarmed/choose-psychotropics-date.html','<div ng-switch="vm.showLastPage"><div ng-switch-when="false"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear(\'cancel\', \'\')">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.psychotropics.modal.title">Choose Date</h4></div><div class="modal-body"><div class="input-group"><span class="input-group-addon" translate="pharmaPortalApp.psychotropics.years.title">Years</span><ui-select style="min-width: 150px" name="years" on-select="vm.yearSelected($item)" ng-model="vm.selectedYear"><ui-select-match allow-clear="true">{{$select.selected}}</ui-select-match><ui-select-choices repeat="year in vm.years | filter: $select.search"><span ng-bind-html="year | highlight: $select.search"></span></ui-select-choices></ui-select></div><br><div class="input-group"><span class="input-group-addon" translate="pharmaPortalApp.psychotropics.months.title">Months</span><ui-select style="min-width: 225px" name="months" ng-model="vm.selectedMonth"><ui-select-match allow-clear="true">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="months in vm.monthsToShow | filter: $select.search"><span ng-bind-html="months.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear(\'cancel\', \'\')"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" ng-click="vm.getAllRequisitions()" ng-disabled="vm.selectedMonth == null || vm.selectedYear == null" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.proceed">Yes</span></button></div></div></div></div><div ng-switch-when="true"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear(\'cancel\', \'\')">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.psychotropics.modal.titleNewRequisitions">New Requisitions</h4><div class="pull-right"><button ng-show="vm.newRequisitionsPsychotropics.length > 0 && vm.allowValidations" type="submit" class="btn btn-warning btn-sm" ng-click="vm.availableAll()" ng-disabled="vm.disableButtons"><i class="fa fa-check"></i>&nbsp;<span data-translate="pharmaPortalApp.psychotropics.availableAll">Validate</span></button></div></div><div class="modal-body"><div class="col-md-12"><script type="text/ng-template" id="nodes_renderer.html"><div data-nodrag ui-tree-handle class="tree-node tree-node-content">\n                        <a ng-if="node.level != 4" class="btn btn-success btn-xs" data-nodrag ng-click="vm.getNextTreeLevel(collapsed, node);toggle(this);">\n                            <span class="glyphicon" ng-class="{\'glyphicon-chevron-right\': collapsed,\'glyphicon-chevron-down\': !collapsed}"></span>\n                        </a>\n                        <any ng-click="vm.applyFiltersTree(node)" ng-if="node.level != 3 && node.level != 0">{{node.label}}</any>\n                        <any ng-if="node.level == 0">{{node.label}}</any>\n                        <any ng-click="vm.applyFiltersTree(node)" ng-if="node.level == 3 && node.level != 0">{{\'pharmaPortalApp.psychotropics.type.\' + node.label | translate}}</any>\n                    </div>\n\n                    <ol ui-tree-nodes="" ng-model="node.children" data-nodrag ng-class="{hidden: collapsed}">\n                        <li ng-repeat="node in node.children" ui-tree-node collapsed="true" data-nodrag\n                            ng-include="\'nodes_renderer.html\'">\n                        </li>\n                    </ol></script><div class="container-fluid well well-sm col-md-3"><div class="form-group-md col-md-12"><button type="button" class="btn btn-primary btn-md btn-block" ng-click="vm.resetDataFilter();vm.getAllDataFromDataBase();" data-translate="pharmaPortalApp.psychotropics.home.action.removefilters">Remove</button></div><div class="col-md-12"><hr style="border-color: #006ffb; background-color: #006ffb"><div ui-tree id="tree-root"><ol ui-tree-nodes ng-model="data"><li ng-repeat="node in data" collapsed="true" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></div></div><div class="col-md-9"><blockquote ng-hide="vm.newRequisitionsPsychotropics.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.psychotropics.message.noOpenRequisitions">No Open Requisitions</blockquote><div class="table-responsive" ng-show="vm.newRequisitionsPsychotropics.length > 0"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th ng-if="vm.allowValidations"><input ng-model="vm.selectAll" ng-click="vm.selectAllPage(vm.selectAll)" type="checkbox" name="selectAll"></th><th jh-sort-by="commercialName" style="max-width:200px;word-wrap:break-word"><span data-translate="pharmaPortalApp.psychotropics.new.table.company">company</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="date"><span data-translate="pharmaPortalApp.psychotropics.new.table.date">Date</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="responsible"><span data-translate="pharmaPortalApp.psychotropics.new.table.responsible">responsible</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="type"><span data-translate="pharmaPortalApp.psychotropics.new.table.type">type</span>&nbsp; <i class="fa fa-sort"></i></th><th style="min-width:70px"><span data-translate="pharmaPortalApp.psychotropics.new.table.tables">tables</span></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat=" psychotropicsHeader in vm.newRequisitionsPsychotropics"><td ng-if="vm.allowValidations"><input ng-model="psychotropicsHeader.selected" ng-click="vm.checkIfIsAllLinesSelected(); vm.selectLine()" type="checkbox" name="selected"></td><td class="table-left" style="max-width:200px;word-wrap:break-word"><any ng-if="psychotropicsHeader.type == \'SALES\'">{{psychotropicsHeader.cli_pe + \' - \' + psychotropicsHeader.commercialName}}</any><any ng-if="psychotropicsHeader.type == \'BUYS\'">{{psychotropicsHeader.numSupplier + \' - \' + psychotropicsHeader.commercialName}}</any></td><td class="table-center">{{psychotropicsHeader.date | date: \'dd/MM/yyyy\'}}</td><td class="table-left">{{psychotropicsHeader.responsible }}</td><td class="table-left">{{\'pharmaPortalApp.psychotropics.type.\' + psychotropicsHeader.type | translate}}</td><td class="table-left"><any ng-repeat="elements in vm.getTablesFromLines(psychotropicsHeader)"><p>{{elements}}</p></any></td><td class="table-center"><div class="btn-group"><button class="btn btn-warning btn-xs" ng-show="vm.allowValidations" title="{{\'pharmaPortalApp.psychotropics.available\' | translate}}" ng-click="vm.availableRequisition(psychotropicsHeader)"><span class="fa fa-check"></span></button> <button class="btn btn-danger btn-xs" ng-click="vm.cancelRequisition(psychotropicsHeader.id); vm.getAllDataFromDataBase();" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div></div><div class="clearfix"></div></div><div class="modal-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div class="text-right"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.cancelAll();"><i class="fa fa-undo"></i>&nbsp; <span data-translate="entity.action.back">Cancel</span></button> <button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear(\'cancel\', \'\')"><i class="fa fa-check"></i>&nbsp; <span data-translate="entity.action.confirm">Confirmar</span></button></div></div></div></div>');
$templateCache.put('app/entities/pharma-infarmed/choose-psychotropics-reports-number.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear(\'cancel\')">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.psychotropics.modal.number.title">Choose Date</h4></div><div class="modal-body"><div class="input-group"><span class="input-group-addon" translate="pharmaPortalApp.psychotropics.modal.number.copies">copies</span><select style="min-width: 150px" name="years" ng-change="onChange()" class="form-control" ng-model="vm.selectedCopies"><option value="1">1 - ORIGINAL</option><option value="2">2 - ORIGINAL + DUPLICADO</option><option value="3">3 - ORIGINAL + DUPLICADO + TRIPLICADO</option></select></div></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear(\'cancel\')"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" ng-click="vm.clear(vm.selectedCopies)" id="print" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.proceed">Yes</span></button></div></div></div>');
$templateCache.put('app/entities/pharma-infarmed/psychotropicsRequisitions-detail.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.psychotropics.detail.title">Requisi\xE7\xF5es Detalhe</span> <span class="clearfix"></span></div><div class="panel-body"><div style="text-align: right"><button class="btn btn-default btn-xs" title="{{\'pharmaPortalApp.pharmaPicking.home.action.search\' | translate}}" ng-click="showSearch = !showSearch"><i class="fa fa-search"></i></button></div><div class="container-fluid well well-sm" ng-hide="!showSearch"><div class="row"><div class="form-group-sm col-md-4"><label for="invoice" class="col-md-5 control-label" data-translate="pharmaPortalApp.psychotropics.new.table.invoice">Invoice</label><div class="col-md-7"><ui-select class="col-md-7" id="invoice" name="invoice" ng-required="true" ng-model="vm.tableFilters.invoice"><ui-select-match placeholder="{{\'pharmaPortalApp.psychotropics.new.table.invoice\' | translate}}">{{$select.selected.value === \'\' ? \'\' : $select.selected.label}}</ui-select-match><ui-select-choices repeat=" value.label as value in vm.filters.invoices "><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group-sm col-md-4"><label for="cnp" class="col-md-5 control-label" data-translate="pharmaPortalApp.psychotropics.detail.table.cnp">Cnp</label><div class="col-md-7"><ui-select class="" id="cnp" name="cnp" ng-required="true" ng-model="vm.tableFilters.cnp"><ui-select-match placeholder="{{\'pharmaPortalApp.psychotropics.detail.table.cnp\' | translate}}">{{$select.selected.value === \'\' ? \'\' : $select.selected.label}}</ui-select-match><ui-select-choices repeat="value.label as value  in vm.filters.cnps "><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row">&nbsp;</div><div class="row"><div class="form-group-sm col-md-4"><label for="description" class="col-md-5 control-label" data-translate="pharmaPortalApp.psychotropics.detail.table.description">description</label><div class="col-md-7"><ui-select class="" id="description" name="description" ng-required="true" ng-model="vm.tableFilters.description"><ui-select-match placeholder="{{\'pharmaPortalApp.psychotropics.detail.table.description\' | translate}}">{{$select.selected.value === \'\' ? \'\' : $select.selected.label}}</ui-select-match><ui-select-choices repeat="value.label as value  in vm.filters.descriptions"><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group-sm col-md-4"><label for="quantitySent" class="col-md-5 control-label" data-translate="pharmaPortalApp.psychotropics.detail.table.quantitySent">quantitySent</label><div class="col-md-7"><ui-select class="" id="quantitySent" name="quantitySent" ng-required="true" ng-model="vm.tableFilters.quantitySent"><ui-select-match placeholder="{{\'pharmaPortalApp.psychotropics.detail.table.quantitySent\' | translate}}">{{$select.selected.value === \'\' ? \'\' : $select.selected.label}}</ui-select-match><ui-select-choices repeat="value.label as value  in vm.filters.quantitySents "><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-3 text-right"><div class="btn-group"><button class="btn btn-warning btn-sm" ng-click="vm.clearFilter()" title="{{\'entity.action.reset\' | translate}}"><i class="fa fa-times"></i></button> <button type="submit" class="btn btn-info btn-sm" ng-click="vm.loadAll()" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i></button></div></div></div></div><div><blockquote ng-hide="vm.requisition.infarmedRequisitionLines.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.psychotropics.message.noDetailRequisitions">No Open Requisitions</blockquote><div class="table-responsive" ng-show="vm.requisition.infarmedRequisitionLines.length > 0"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="document"><span data-translate="pharmaPortalApp.psychotropics.new.table.invoice">Invoice</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="date"><span data-translate="pharmaPortalApp.psychotropics.new.table.date">Date</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="cnp"><span data-translate="pharmaPortalApp.psychotropics.detail.table.cnp">CNP</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="description"><span data-translate="pharmaPortalApp.psychotropics.detail.table.description">description</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="guideNumber" ng-show="infarmedRequisitionLine.type == \'BUYS\'"><span data-translate="pharmaPortalApp.psychotropics.detail.table.guideNumber">guideNumber</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="quantitySent"><span data-translate="pharmaPortalApp.psychotropics.detail.table.quantitySent">quantitySent</span>&nbsp; <i class="fa fa-sort"></i></th></tr></thead><tbody><tr ng-repeat=" infarmedRequisitionLine in vm.infarmedRequisitionLines"><td class="table-left">{{infarmedRequisitionLine.document}}</td><td class="table-center">{{infarmedRequisitionLine.date | date:\'dd/MM/yyyy\'}}</td><td class="table-left">{{infarmedRequisitionLine.cnp}}</td><td class="table-left">{{infarmedRequisitionLine.description}}</td><td ng-show="infarmedRequisitionLine.type == \'BUYS\'" class="table-left">{{infarmedRequisitionLine.guideNumber}}</td><td class="table-right">{{infarmedRequisitionLine.quantitySent}}</td></tr></tbody></table></div></div></div><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div class="panel-footer"><div class="text-right"><button type="submit" ui-sref="psychotropics" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div></div></div></div>');
$templateCache.put('app/entities/pharma-infarmed/psychotropicsRequisitions.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.psychotropics.home.title">Requisi\xE7\xF5es</span><div class="pull-right"><button ng-show="vm.psychotropicsHeaders.length > 0 &&  (vm.actualStatus == \'VALIDATED\' || vm.actualStatus ==  \'AVAILABLE\')  && vm.account.allowDigitalSignature" type="submit" ng-disabled="vm.disableButtons" class="btn btn-default btn-sm" ng-click="vm.generateAll()"><i class="fa fa-check"></i>&nbsp;<span data-translate="pharmaPortalApp.psychotropics.generateAll">generateAll</span></button> <button ng-show="vm.psychotropicsHeaders.length > 0 &&  vm.actualStatus == \'CREATED\' && vm.allowAvailable" type="submit" ng-disabled="vm.disableButtons" class="btn btn-warning btn-sm" ng-click="vm.availableAll()"><i class="fa fa-check"></i>&nbsp;<span data-translate="pharmaPortalApp.psychotropics.availableAll">Validate</span></button> <button ng-show="vm.psychotropicsHeaders.length > 0 &&  vm.actualStatus == \'AVAILABLE\' && vm.allowValidations" type="submit" ng-disabled="vm.disableButtons" class="btn btn-success btn-sm" ng-click="vm.validateAll()"><i class="fa fa-check"></i>&nbsp;<span data-translate="pharmaPortalApp.psychotropics.validateAll">Validate</span></button> <button type="button" class="btn btn-warning btn-sm" ng-if="vm.allowCreate" ng-click="vm.openChooseModal()"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.psychotropics.home.action.new">NewRequisition</span></button></div><span class="clearfix"></span></div><div class="panel-body"><div style="text-align: right"></div><div class="col-md-12"><script type="text/ng-template" id="nodes_renderer.html"><div data-nodrag ui-tree-handle class="tree-node tree-node-content">\n                        <a ng-if="node.level != 4" class="btn btn-success btn-xs" data-nodrag ng-click="vm.getNextTreeLevel(collapsed, node);toggle(this);">\n                            <span class="glyphicon" ng-class="{ \'glyphicon-chevron-right\': collapsed, \'glyphicon-chevron-down\': !collapsed }"></span>\n                        </a>\n                        <any ng-click="vm.applyFiltersTree(node)" ng-if="node.level != 3 && node.level != 0">{{node.label}}</any>\n                        <any ng-if="node.level == 0">{{node.label}}</any>\n                        <any ng-click="vm.applyFiltersTree(node)" ng-if="node.level == 3 && node.level != 0">{{\'pharmaPortalApp.psychotropics.type.\' + node.label | translate}}</any>\n                    </div>\n\n                    <ol ui-tree-nodes="" ng-model="node.children" data-nodrag ng-class="{hidden: collapsed}">\n                        <li ng-repeat="node in node.children" ui-tree-node collapsed="true" data-nodrag ng-include="\'nodes_renderer.html\'"></li>\n                    </ol></script><div class="container-fluid well well-sm col-md-3"><div class="form-group-md col-md-12" style="margin-bottom: 10px"><button type="button" class="btn btn-primary btn-md btn-block" ng-click="vm.clearFilter()" data-translate="pharmaPortalApp.psychotropics.home.action.removefilters">Remove</button></div><div class="form-group-md col-md-12" style="margin-bottom: 10px"><ui-select on-select="vm.selectedOption()" reset-search-input="false" class="" id="status" name="status" ng-model="vm.tableFilters.status"><ui-select-match allow-clear="true" placeholder="{{\'pharmaPortalApp.psychotropics.filters.status\' | translate}}">{{\'pharmaPortalApp.psychotropics.status.\'+ $select.selected | translate}}</ui-select-match><ui-select-choices repeat="status in  vm.status  | filter: $select.search"><span ng-bind-html="\'pharmaPortalApp.psychotropics.status.\'+ status | translate | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group-md col-md-12" style="margin-bottom: 10px"><ui-select id="products" ng-model="vm.tableFilters.cnp" on-select="vm.selectedOption()" reset-search-input="false" uis-open-close="vm.onOpenClose()" fix-selected-item><ui-select-match allow-clear="true" placeholder="{{\'pharmaPortalApp.psychotropics.filters.products\' | translate}}">{{$select.selected.cnp}} - {{$select.selected.commercialName}}</ui-select-match><ui-select-choices repeat=" product in (vm.products | filter: $select.search)" refresh="refreshSelectModel($select.search)" refresh-delay="500" minimum-input-length="3"><span ng-bind-html="product.cnp + \' - \'+ product.commercialName | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group-md col-md-12"><ui-select reset-search-input="false" on-select="vm.selectedOption()" class="" id="responsible" name="status" ng-model="vm.tableFilters.responsible"><ui-select-match allow-clear="true" placeholder="{{\'pharmaPortalApp.psychotropics.filters.responsible\' | translate}}">{{$select.selected}}</ui-select-match><ui-select-choices repeat="user in  vm.usersResponsible | filter: $select.search"><span ng-bind-html="user | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-md-12"><hr style="border-color: #006ffb; background-color: #006ffb"><div ui-tree id="tree-root"><ol ui-tree-nodes ng-model="data"><li ng-repeat="node in data" collapsed="true" ui-tree-node ng-include="\'nodes_renderer.html\'"></li></ol></div></div></div><div class="col-md-9"><blockquote ng-hide="vm.psychotropicsHeaders.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.psychotropics.message.noOpenRequisitions">No Open Requisitions</blockquote><div class="table-responsive" ng-show="vm.psychotropicsHeaders.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.psychotropicsHeaders"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th ng-if=" vm.actualStatus == \'VALIDATED\' ||vm.actualStatus == \'CREATED\' ||vm.actualStatus == \'AVAILABLE\' "><input ng-model="vm.selectAll" ng-click="vm.selectAllPage(vm.selectAll)" type="checkbox" name="selectAll"></th><th jh-sort-by="period"><span data-translate="pharmaPortalApp.psychotropics.new.table.period">Period</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="numberRequisition"><span data-translate="pharmaPortalApp.psychotropics.new.table.numberOfRequisition">numberOfRequisition</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="commercialName" style="max-width:200px;word-wrap:break-word"><span data-translate="pharmaPortalApp.psychotropics.new.table.company">company</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="responsible"><span data-translate="pharmaPortalApp.psychotropics.new.table.responsible">responsible</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="type"><span data-translate="pharmaPortalApp.psychotropics.new.table.type">type</span>&nbsp; <i class="fa fa-sort"></i></th><th><span data-translate="pharmaPortalApp.psychotropics.new.table.tables">tables</span></th><th jh-sort-by="status"><span data-translate="pharmaPortalApp.psychotropics.new.table.status">status</span>&nbsp; <i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="psychotropicsHeader in vm.psychotropicsHeaders"><td ng-if="   vm.actualStatus == \'AVAILABLE\' ||vm.actualStatus == \'VALIDATED\' || vm.actualStatus == \'CREATED\'"><input ng-model="psychotropicsHeader.selected" ng-click="vm.checkIfIsAllLinesSelected(); vm.selectLine()" type="checkbox" name="selected"></td><td class="table-left">{{vm.getPeriodTolabel(psychotropicsHeader.searchBy)}}</td><td class="table-right">{{psychotropicsHeader.numberRequisition}}</td><td style="max-width:200px;word-wrap:break-word" class="table-left"><any ng-if="psychotropicsHeader.type == \'SALES\'">{{psychotropicsHeader.cli_pe + \' - \' + psychotropicsHeader.commercialName}}</any><any ng-if="psychotropicsHeader.type == \'BUYS\'">{{psychotropicsHeader.numSupplier + \' - \' + psychotropicsHeader.commercialName}}</any></td><td class="table-left">{{psychotropicsHeader.responsible}}</td><td class="table-left">{{\'pharmaPortalApp.psychotropics.type.\' + psychotropicsHeader.type | translate}}</td><td class="table-left"><any ng-repeat="elements in vm.getTablesFromLines(psychotropicsHeader)"><p>{{elements}}</p></any></td><td class="table-left text-success" ng-if="psychotropicsHeader.status == \'VALIDATED\'">{{\'pharmaPortalApp.psychotropics.status.\' + psychotropicsHeader.status | translate}}</td><td class="table-left text-warning" ng-if="psychotropicsHeader.status == \'CREATED\' || psychotropicsHeader.status == \'AVAILABLE\'">{{\'pharmaPortalApp.psychotropics.status.\' + psychotropicsHeader.status | translate}}</td><td class="text-danger table-left" ng-if="psychotropicsHeader.status == \'DELETED\'">{{\'pharmaPortalApp.psychotropics.status.\' + psychotropicsHeader.status | translate}}</td><td class="table-center"><div class="btn-group"><button class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}" ui-sref="psychotropics.detail({requisition:psychotropicsHeader , back: true})" ng-click="vm.saveFilterToLocalStorage() ; vm.removeLocalStorage = true"><span class="fa fa-search-plus"></span></button> <button ng-show="vm.account.allowDigitalSignature" class="btn btn-default btn-xs" title="{{\'entity.action.print\' | translate}}" ng-click="vm.generatePdf(psychotropicsHeader)"><i class="fa fa-print"></i></button> <button class="btn btn-warning btn-xs" ng-if="psychotropicsHeader.status == \'CREATED\' && vm.allowAvailable" title="{{\'pharmaPortalApp.psychotropics.available\' | translate}}" ng-click="vm.availableRequisition(psychotropicsHeader)"><span class="fa fa-check"></span></button> <button class="btn btn-success btn-xs" ng-if="psychotropicsHeader.status == \'AVAILABLE\' && vm.allowValidations" title="{{\'pharmaPortalApp.psychotropics.validate\' | translate}}" ng-click="vm.validateRequisition(psychotropicsHeader)"><span class="fa fa-check"></span></button> <button class="btn btn-danger btn-xs" ng-show="psychotropicsHeader.status == \'AVAILABLE\' || psychotropicsHeader.status == \'CREATED\' || vm.allowAvailable" ng-click="vm.deleteRequisition(psychotropicsHeader.id, psychotropicsHeader.status);" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/pharma-fault-settings/pharma-fault-settings.html','<div><form class="form-horizontal" name="editForm" ng-submit="vm.save()" show-validation><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaFaultSettings.title">Pharma Fault Settings</span> <span class="clearfix"></span></div><div class="panel-body"><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.pharmaFaultSettings.wsFaultUsername" for="field_wsFaultUsername">Ws Fault Username</label><div class="col-sm-10"><input type="text" class="form-control" name="wsFaultUsername" id="field_wsFaultUsername" ng-model="vm.pharmaFaultSettings.wsFaultUsername" required><div ng-show="editForm.wsFaultUsername.$dirty && editForm.wsFaultUsername.$invalid"><p class="help-block" ng-show="editForm.wsFaultUsername.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.pharmaFaultSettings.wsFaultPassword" for="field_wsFaultPassword">Ws Fault Password</label><div class="col-sm-10"><input type="text" class="form-control" name="wsFaultPassword" id="field_wsFaultPassword" ng-model="vm.pharmaFaultSettings.wsFaultPassword" required><div ng-show="editForm.wsFaultPassword.$dirty && editForm.wsFaultPassword.$invalid"><p class="help-block" ng-show="editForm.wsFaultPassword.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.pharmaFaultSettings.wsFaultAddress" for="field_wsFaultAddress">Ws Fault Address</label><div class="col-sm-10"><input type="text" class="form-control" name="wsFaultAddress" id="field_wsFaultAddress" ng-model="vm.pharmaFaultSettings.wsFaultAddress" required><div ng-show="editForm.wsFaultAddress.$dirty && editForm.wsFaultAddress.$invalid"><p class="help-block" ng-show="editForm.wsFaultAddress.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.pharmaFaultSettings.wsFaultNIF" for="field_wsFaultNIF">Ws Fault NIF</label><div class="col-sm-10"><input type="text" class="form-control" name="wsFaultNIF" id="field_wsFaultNIF" ng-model="vm.pharmaFaultSettings.wsFaultNIF" required><div ng-show="editForm.wsFaultNIF.$dirty && editForm.wsFaultNIF.$invalid"><p class="help-block" ng-show="editForm.wsFaultNIF.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.pharmaFaultSettings.numAutDistGrosso" for="field_numAutDistGrosso">Num Aut Dist Grosso</label><div class="col-sm-10"><input type="text" class="form-control" name="numAutDistGrosso" id="field_numAutDistGrosso" ng-model="vm.pharmaFaultSettings.numAutDistGrosso"></div></div></div><div class="panel-footer"><div class="text-right"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></div></form></div>');
$templateCache.put('app/entities/pharma-purchase/pharma-purchases.html','<div><div class="row"><div class="col-md-8"><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><div class="panel-title pull-left"><span ng-show="vm.isPharma" data-translate="pharmaPortalApp.pharmaPurchase.home.newPharmaPurchase">New pharma purchase</span> <span ng-hide="vm.isPharma" data-translate="pharmaPortalApp.pharmaPurchase.home.newWholesalePurchase">New wholesale purchase</span></div><div class="panel-search-form col-sm-6 pull-right"><form name="searchForm"><div class="input-group"><div class="input-group-btn" uib-dropdown auto-close="outsideClick"><span on-toggle="toggled(open)" class="btn btn-default btn-sm" ng-class="{\'btn-success\': search.showNoStock || search.ownWarehouse}" uib-dropdown-toggle><i class="fa fa-cogs"></i>&nbsp;<i class="caret"></i></span><ul class="dropdown-menu" uib-dropdown-menu><li><div class="checkbox dropdown-item"><label><input type="checkbox" ng-model="search.showNoStock" id="showNoStock"> <span data-translate="pharmaPortalApp.pharmaPurchase.dropdown.includeWithNoStock">Include without stock</span></label></div></li><li ng-show="vm.ownWarehouse"><div class="checkbox dropdown-item"><label><input type="checkbox" ng-model="search.ownWarehouse" id="ownWarehouse" ng-disabled="isRetainedProductsOrder()"> <span data-translate="pharmaPortalApp.pharmaPurchase.dropdown.includeRetainedProducts">Retained Products</span> <span tooltip-placement="bottom" uib-tooltip="{{\'pharmaPortalApp.pharmaPurchase.hint.retainedProducts\' | translate}}"><i class="fa fa-question-circle-o"></i></span></label></div></li></ul></div><input type="text" class="form-control input-sm" ng-model="search.searchQuery" id="searchQuery" placeholder="{{\'global.form.search.placeholder.product.attr\' | translate}}" autocomplete="off"><div class="input-group-btn"><button class="btn btn-info btn-sm" ng-click="searchProducts()" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i></button></div></div></form></div><div class="clearfix"></div></div><div class="panel-body"><div class="jumbotron text-center" ng-hide="productsList.length"><i class="fa fa-search-minus fa-3x"></i>&nbsp;&nbsp;&nbsp;Por favor utilize o campo de pesquisa no topo da p\xE1gina</div><form name="orderPurchaseForm" role="form" ng-show="productsList.length"><div class="row"><div class="col-md-6"><any ng-hide="searchInTable">A pesquisa por "{{search.searchQuery}}" retornou {{productsList.length}} items</any><any ng-show="searchInTable">Mostrando {{(productsList | filter:searchInTable).length}} items de um total de {{productsList.length}}</any></div><div class="col-md-offset-3 col-md-3"><div class="form-group"><div class="input-group"><input type="text" class="form-control input-sm" placeholder="{{\'global.form.search.placeholder.inTable\' | translate}}" ng-model="searchInTable"><div class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.clearSearchInTable()"><i class="fa fa-close"></i></button></div></div></div></div></div><div class="table-responsive"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="productsList"><thead><tr class="topHeader"><th>CNP</th><th>Descri\xE7\xE3o</th><th>Laborat\xF3rio</th><th><span ng-show="vm.isPharma">PVF</span> <span ng-hide="vm.isPharma">PVA</span></th><th>Desc %</th><th>Pre\xE7o</th><th>Stock</th><th>Qtd</th><th>Total</th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="product in productsList | filter:searchInTable track by $index"><td class="table-left">{{product.cnp}}</td><td class="table-left" ng-bind-html="product.fullHtmlName"></td><td class="table-left"><a ng-click="vm.searchByLab(product.lab)">{{product.lab}}</a></td><td class="table-right"><any ng-show="vm.isPharma">{{product.pvfeur | currency : \'&euro;\' : 2}}</any><any ng-hide="vm.isPharma">{{product.pvaeur | currency : \'&euro;\' : 2}}</any></td><td class="table-right"><any ng-show="vm.isPharma">{{product.pvfdesc | currency : \'%\' : 2}}</any><any ng-hide="vm.isPharma">{{product.pvadesc | currency : \'%\' : 2}}</any></td><td class="table-right">{{product.pvp | currency : \'&euro;\' : 2}}</td><td>{{product.warehousestock ? product.warehousestock : 0 | number : 0}}</td><td><input type="number" min="1" step="1" pattern="\\d{1,}" class="form-control input-xs" ng-model="product.qtd" on-enter="vm.addProduct(product)"></td><td class="table-right">{{product.qtd * product.pvp | currency : \'&euro;\' : 2}}</td><td><button class="btn btn-success btn-xs" title="Adicionar Item" ng-click="vm.addProduct(product)" ng-disabled="vm.isValidForOrder(product)"><i class="fa fa-plus"></i></button></td></tr></tbody></table></div></form></div><div class="panel-footer"><div class="row"><div class="col-md-12 text-right"><button class="btn btn-warning btn-sm" ng-disabled="isProductSearchEmpty()" ng-click="vm.exportSearchToExcel()"><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span></button> <button class="btn btn-success btn-sm" ng-disabled="isProductSearchEmpty()" ng-click="vm.addAllProducts()"><i class="fa fa-plus"></i>&nbsp;Adicionar Todos</button></div></div></div></div></div><div class="col-md-4"><div id="curOrderList" class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left">Encomenda atual</span><div class="btn-group pull-right"><button class="btn btn-danger btn-sm" ui-sref="pharma-purchase.clearOrder()" ng-disabled="isOrderEmpty()"><i class="fa fa-recycle"></i> Limpar Encomenda</button></div><span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th>CNP</th><th>Descri\xE7\xE3o</th><th>Qtd</th><th>Pre\xE7o</th><th>IVA</th><th>Total</th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr class="small" ng-repeat="orderProd in purchaseOrderList track by orderProd.cnp"><td class="table-left">{{orderProd.cnp}}</td><td class="table-left" ng-bind-html="orderProd.fullHtmlName"></td><td class="form-group" ng-class="{\'has-error has-feedback text-danger\': orderProd.invalidQtd}"><span ng-if="orderProd.editMode===\'\' || !orderProd.editMode"><span class="alert alert-danger" ng-show="orderProd.invalidQtd">{{orderProd.qtd}}</span> <span ng-hide="orderProd.invalidQtd">{{orderProd.qtd | number : 0}}</span> </span><input ng-if="orderProd.editMode!=\'\' && orderProd.editMode" type="text" class="form-control input-xs text-center" id="qtd" ng-model="orderProd.qtd" ng-class="{ \'alert-danger\': orderProd.qtd <= 0 }" ng-keypress="vm.validateLines(orderProd,$event)" ng-blur="vm.validateLines(orderProd,$event)"> <i class="fa fa-remove form-control-feedback"></i></td><td class="table-right">{{orderProd.pvp | currency : \'&euro;\' : 2}}</td><td class="table-right">{{orderProd.txiva | currency : \'%\' : 2}}</td><td class="table-right">{{orderProd.qtd * orderProd.pvp | currency : \'&euro;\' : 2}}</td><td><div class="btn-group"><button class="btn btn-primary btn-xs" ng-class="{ \'active\': orderProd.editMode!=\'\' && orderProd.editMode}" title="{{\'entity.action.edit\' | translate}}" ng-click="vm.toggleLineEditMode(orderProd)"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-xs" title="Remover Item" ui-sref="pharma-purchase.removeProduct({cnpToDel:orderProd.cnp})"><i class="fa fa-trash"></i></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="row"><div class="col-sm-12 small"><label class="col-md-offset-4 col-sm-4">Total</label><div class="col-sm-4 text-right">{{purchaseTotals.total | currency : \'&euro;\' : 2}}</div></div><div class="col-sm-12 small"><label class="col-md-offset-4 col-sm-4">Total <span ng-show="vm.isPharma">PVF</span> <span ng-hide="vm.isPharma">PVA</span></label><div class="col-sm-4 text-right">{{purchaseTotals.totalPV | currency : \'&euro;\' : 2}}</div></div><div class="col-sm-12 small"><label class="col-md-offset-4 col-sm-4">Total Desc</label><div class="col-sm-4 text-right">{{purchaseTotals.totalDesc | currency : \'&euro;\' : 2}}</div></div><div class="col-sm-12 small" ng-show="vm.portalSettings.chargeShippingCosts == true && vm.portalSettings.hasMinOrderValue == true && vm.portalSettings.minOrderValue > (purchaseTotals.total - vm.portalSettings.shippingCosts)"><label class="col-md-offset-4 col-sm-4"><span tooltip-placement="top" uib-tooltip="Para encomendas com valor inferior a {{vm.portalSettings.minOrderValue | currency : \'&euro;\' : 2}} ser\xE1 cobrada uma taxa de transporte"><i class="fa fa-question-circle-o"></i> </span>Valor de Transporte</label><div class="col-sm-4 text-right">{{vm.portalSettings.shippingCosts | currency : \'&euro;\' : 2}}</div></div></div><div class="row"><div class="col-md-12 text-right"><button class="btn btn-warning btn-sm" ng-click="vm.orderToExcel()" ng-disabled="isOrderEmpty() || vm.hasErrors"><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span></button> <button class="btn btn-success btn-sm" ng-click="vm.confirmOrderDialog()" ng-disabled="isOrderEmpty() || vm.hasErrors || purchaseTotals.total < 0 || (!vm.portalSettings.allowZeroPriceOrders && purchaseTotals.total == 0)"><i class="fa fa-list"></i>&nbsp;Encomendar</button></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/pharma-purchase/purchase-alert-dialog.html','<form ng-submit="vm.confirmAlert()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Informa\xE7\xE3o</h4></div><div class="modal-body" id="modal-body"><span ng-bind-html="message"></span></div><div class="modal-footer"><button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/pharma-purchase/purchase-clear-order-dialog.html','<form name="clearOrderForm" ng-submit="vm.confirmClearOrder()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Limpar lista a encomendar?</h4></div><div class="modal-body"><p>Selecionou retirar todos os produtos da sua lista a encomendar.</p><p>Pretende continuar?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-purchase/purchase-confirm-order-dialog.html','<form name="confirmOrderForm" ng-submit="vm.confirmOrder()" class="form-horizontal" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Submeter Encomenda</h4></div><div class="modal-body" ng-switch="vm.orderReady"><div ng-switch-when="0"><div class="form-group"><div class="col-sm-12"><p>Est\xE1 prestes a submeter a sua encomenda.</p></div><div class="col-sm-12"><p>Se pretender, poder\xE1 ainda indicar uma pequena descri\xE7\xE3o no campo que se segue.</p></div></div><div class="form-group"><label for="description" class="col-sm-4 control-label">Descri\xE7\xE3o encomenda</label><div class="col-sm-8"><input type="text" id="description" class="form-control" ng-model="vm.orderDescription" maxlength="15" autocomplete="off"></div></div></div><div ng-switch-when="1"><div class="form-group"><div class="col-sm-12"><p>A encomenda n\xE3o pode ser submetida enquanto n\xE3o atingir o valor m\xEDnimo de <b>{{vm.orderInfoValues.minValue | currency : \'&euro;\' : 2}}</b>.</p><p>Ainda est\xE1 <b>{{vm.orderInfoValues.curDiff | currency : \'&euro;\' : 2}}</b> abaixo desse valor m\xEDnimo.</p></div></div></div><div ng-switch-when="2"><div class="form-group"><div class="col-sm-12"><p>Est\xE1 prestes a submeter a sua encomenda com um <b>valor total igual a zero</b>.</p></div><div class="col-sm-12"><p>Se pretender, poder\xE1 ainda indicar uma pequena descri\xE7\xE3o no campo que se segue.</p></div></div><div class="form-group"><label for="description" class="col-sm-4 control-label">Descri\xE7\xE3o encomenda</label><div class="col-sm-8"><input type="text" class="form-control" ng-model="vm.orderDescription" maxlength="15" autocomplete="off"></div></div></div><div ng-switch-when="3"><div class="form-group"><div class="col-sm-12"><p>A encomenda n\xE3o pode ser submetida enquanto o valor total for menor ou igual a zero.</p></div></div></div></div><div class="modal-footer" ng-switch="vm.orderReady"><div ng-switch-when="0|2" ng-switch-when-separator="|"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="vm.processing" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div><div ng-switch-when="1|3" ng-switch-when-separator="|"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div></div></form>');
$templateCache.put('app/entities/pharma-purchase/purchase-confirm.fullsearch-dialog.html','<form name="confirmFullSearchForm" ng-submit="vm.confirmAddProducts()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Informa\xE7\xE3o</h4></div><div class="modal-body" id="modal-body"><any ng-switch="message"><any ng-switch-when="NOK"><p>A op\xE7\xE3o "Incluir s/stock" est\xE1 selecionada.</p><p>Por quest\xF5es de performance, apenas \xE9 permitido efetuar pesquisas com 3 ou mais caracteres.</p></any><any ng-switch-when="OK"><p><b>Aten\xE7\xE3o</b>: a a\xE7\xE3o de procurar produtos usando menos de 3 caracteres no termo a pesquisar pode demorar alguns minutos.</p><p>Pretende continuar?</p></any></any></div><div class="modal-footer"><any ng-switch="message"><any ng-switch-when="NOK"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></any><any ng-switch-when="OK"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></any></any></div></form>');
$templateCache.put('app/entities/pharma-purchase/purchase-remove-product-dialog.html','<form ng-submit="vm.confirmRemoveProduct()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Retirar produto da lista a encomendar?</h4></div><div class="modal-body"><p>Selecionou remover o seguinte produto da sua lista a encomendar:</p><p>{{vm.product.nome}}&nbsp;{{vm.product.dosagem}}&nbsp;{{vm.product.emb}}</p><p>CNP: {{vm.product.cnp}}</p><p>Quantidade: {{vm.product.qtd | number:0}}</p><p>Pre\xE7o Unit: {{vm.product.pvp | currency : \'&euro;\' : 2}}</p><p>Pretende continuar?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-purchase/purchase-save-template-dialog.html','<form name="confirmSaveTemplateForm" ng-submit="vm.confirmSaveTemplate()" class="form-horizontal" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Guardar Template</h4></div><div class="modal-body"><div class="form-group"><div class="col-sm-12"><p>Indique o nome que pretende atribuir ao novo Template</p></div></div><div class="form-group"><label for="name" class="col-sm-4 control-label">Nome do Template</label><div class="col-sm-8"><input type="text" class="form-control" ng-model="vm.name" autocomplete="off"></div></div><div class="form-group"><div class="col-sm-12"><p>Se pretende atualizar um Template j\xE1 existente, marque a op\xE7\xE3o "Atualizar existente" e indique o template a atualizar no campo "Outros Templates".</p></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label><input type="checkbox" ng-model="vm.settings.hasMinOrderValue"> <span>Atualizar existente</span></label></div></div></div><div class="form-group" ng-class="[{\'has-error\': confirmOrderForm.$submitted && confirmOrderForm.company.$invalid}]"><label for="existentPromo" class="col-sm-4 control-label">Outros Templates</label><div class="col-sm-8"><ui-select name="company" ng-model="vm.order.company" on-select="selectCompany($item, $model)" on-remove="unselectCompany($item, $model)" required ng-disabled="!vm.settings.hasMinOrderValue"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaPurchase.placeholder.company\' | translate}}" allow-clear="true">{{$select.selected.naming}}</ui-select-match><ui-select-choices repeat="company as company in vm.companies | filter: $select.search | orderBy:\'naming\'"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-purchase/purchase-success-dialog.html','<form ng-submit="vm.confirmAddProducts()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Informa\xE7\xE3o</h4></div><div class="modal-body" id="modal-body"><span ng-bind-html="message"></span></div><div class="modal-footer"><button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">OK</span></button></div></form>');
$templateCache.put('app/entities/pharma-picking/invoiced-and-claimed-dialog.html','<form class="form-group" ng-submit="vm.close()"><div class="modal-header"><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.detail.table.conferenceZone">Zona de produtos em confer\xEAncia</h4></div><div class="modal-body"><blockquote ng-hide="vm.pharmaPicking.pharmaPickingLines.length > 0" id="blockquote_helpBlock" name="helpBlock" class="help-block" data-translate="pharmaPortalApp.pharmaPicking.detail.message.noLinesLeft">No Pending Picking Lines</blockquote><div class="table-responsive" ng-show="vm.pharmaPicking.pharmaPickingLines.length > 0"><h4 ng-if="vm.pharmaPicking.invoiceNumber" style="font-weight: bold" data-translate="pharmaPortalApp.pharmaPicking.detail.table.invoiceNumber" translate-values="{invoiceNumber: \'{{vm.pharmaPicking.invoiceNumber}}\'}"></h4><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions"><thead><tr jh-sort="predicateL" ascending="reverseL"><th><span data-translate="pharmaPortalApp.pharmaPicking.detail.table.cnp">CNP</span></th><th><span data-translate="pharmaPortalApp.pharmaPicking.detail.table.description">Description</span></th><th><span data-translate="pharmaPortalApp.pharmaPicking.detail.table.invoicedQuantity">Quantity</span></th><th><span data-translate="pharmaPortalApp.pharmaPicking.detail.table.claimedQuantity">Quantity</span></th></tr></thead><tbody><tr ng-repeat="pharmaPickingLine in vm.pharmaPicking.pharmaPickingLines"><td class="table-left">{{pharmaPickingLine.cnp}}</td><td class="table-left">{{pharmaPickingLine.description}}</td><td class="table-right">{{pharmaPickingLine.invoicedQuantity-pharmaPickingLine.receivedQuantity-pharmaPickingLine.claimedQuantity}}</td><td class="table-right">{{pharmaPickingLine.claimedQuantity}}</td></tr></tbody></table></div></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button type="submit" class="btn btn-default btn-sm"><i class="fa fa-ban"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.close">Close</span></button></div></div></div></form>');
$templateCache.put('app/entities/pharma-picking/pharma-close-conference-dialog.html','<form name="submitPickingHeaderForm" class="form-inline" ng-submit="vm.clear(vm.userName)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.detail.userGeneric.indicateName">Indicate name</h4></div><div class="modal-body"><div class="form-group"><label for="nameUserCloseConference"><span data-translate="pharmaPortalApp.pharmaPicking.detail.userGeneric.askName">To continue, please enter your name</span></label>&nbsp;&nbsp; <input required type="text" class="form-control" id="nameUserCloseConference" ng-model="vm.userName"></div></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear(\'cancel\')"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="vm.userName == null" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.proceed">Yes</span></button></div></div></div></form>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-confirm-products.html','<div class="modal-header"><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.titleListComplain">Employee ID</h4></div><div class="modal-body"><div class="row"><div class="col-sm-12"><table class="jh-table table table-striped"><thead><tr><th class="text-center" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.article">Artigo</th><th class="text-center" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.quantity">Quantidade</th></tr></thead><tbody><tr ng-repeat="product in products"><th>{{product.description}}</th><th>{{product.invoicedQuantity - product.receivedQuantity - (product.suggestion != null ? product.suggestion : 0)}}</th></tr></tbody></table></div><div class="col-sm-12 text-center"><ul uib-pagination total-items="totalItems" ng-model="vm.page" items-per-page="itemsPerPage"></ul></div></div></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.complain">Complain</span></button></div></div></div>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-define-pharmacy.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear(\'cancel\')">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.selectPharmacy.title">Employee ID</h4></div><form name="transportPickingHeaderForm" class="form-inline" ng-submit="vm.submit()"><div class="modal-body"><div class="row"><div class="col-sm-12"><label for="warehouseSales" class="col-sm-4" data-translate="pharmaPortalApp.pharmaPicking.selectPharmacy.description">Warehouse for sales</label><div class="col-sm-4"><ui-select id="warehouseSales" ng-model="vm.settings.warehouseSales"><ui-select-match>{{$select.selected.namingForOptions}}</ui-select-match><ui-select-choices repeat="warehouse as warehouse in warehouses | filter: $select.search track by warehouse.id"><span ng-bind-html="warehouse.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div></form><div class="modal-footer"><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear(\'cancel\')"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-success btn-sm" ng-click="vm.submit()" ng-disabled="vm.settings.warehouseSales == null"><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.proceed">Yes</span></button></div></div></div>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-define-warehouse.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear(\'cancel\')">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.selectPharmacy.title">Employee ID</h4></div><div class="modal-body"><div class="row"><div class="col-sm-12"><label for="warehouseSales" class="col-sm-4" data-translate="pharmaPortalApp.pharmaPicking.selectPharmacy.description">Warehouse</label><div class="col-sm-8"><ui-select id="warehouseSales" ng-model="vm.warehouseSales"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="warehouse in (warehouses | filter: $select.search) track by warehouse.code"><span ng-bind-html="warehouse.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear(\'cancel\')"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-success btn-sm" ng-click="vm.submit()" ng-disabled="vm.warehouseSales == null"><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.proceed">Yes</span></button></div></div></div>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-delete-dialog.html','<form name="deletePickingHeaderForm" ng-submit="vm.confirmPharmaPickingDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.home.deleteDialog.title">Confirm Picking Header</h4></div><div class="modal-body"><p><span class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.home.deleteDialog.body">Confirm Picking Header delete?</span></p><p><span data-translate="pharmaPortalApp.pharmaPicking.home.form.warehouse">Warehouse</span>: {{vm.pharmaPicking.pharmacyWarehouse + " - " + vm.pharmaPicking.pharmacyName}}</p><p><span data-translate="pharmaPortalApp.pharmaPicking.home.form.supplier">Supplier</span>: {{vm.pharmaPicking.supplierCode + " - " + vm.pharmaPicking.supplierName}}</p><p><span data-translate="pharmaPortalApp.pharmaPicking.home.form.receipt">SupplierDocument</span>: {{vm.pharmaPicking.receipt}}</p><p><span data-translate="pharmaPortalApp.pharmaPicking.home.form.pickingDate">Picking Date</span>: {{vm.pharmaPicking.documentDate | date:\'dd/MM/yyyy\'}}</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger btn-sm" autofocus ng-disabled="vm.hide"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-detail.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaPicking.detail.title">Pharma Picking</span> <span class="clearfix"></span></div><div class="panel-body"><div class="container-fluid well well-sm"><div class="row"><div class="col-md-5"><div class="row"><div class="col-md-6 form-group form-group-sm"><div class="row"><label for="documentDate" class="col-lg-4 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.documentDate">Document Date</label><div class="col-lg-8"><div class="input-group input-group-sm"><input type="text" id="documentDate" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.header.documentDate" placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.documentDate\' | translate}}" ng-disabled="true"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-disabled="true"><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="col-md-6 form-group form-group-sm"><div class="row"><label for="receipt" class="control-label col-lg-4" translate="pharmaPortalApp.pharmaPicking.detail.form.receipt">Receipt</label><div class="col-lg-8"><input type="text" id="receipt" class="form-control" ng-model="vm.header.receipt" placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.receipt\' | translate}}" ng-disabled="true"></div></div></div></div></div><div class="col-md-7"><div class="row"><div class="col-md-4 form-group form-group-sm"><div class="row"><label for="dateCreated" class="col-lg-3 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.dateCreated">Date</label><div class="col-lg-9"><div class="input-group input-group-sm"><input type="text" id="dateCreated" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.header.dateCreated" placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.dateCreated\' | translate}}" ng-disabled="true"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-disabled="true"><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="col-md-5 form-group form-group-sm"><div class="row"><label for="username" class="col-lg-4 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.username">Username</label><div class="col-lg-8"><input type="text" id="username" class="form-control" ng-model="vm.header.lastModifyingUser" placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.username\' | translate}}" ng-disabled="true"></div></div></div><div class="col-md-3 form-group form-group-sm"><div class="row"><label for="status" class="control-label col-lg-4" translate="pharmaPortalApp.pharmaPicking.detail.form.status">Status</label><div class="col-lg-8"><span ng-if="vm.header.status != \'TRANSPORTED\'" id="status" class="label" ng-class="{\'label-warning\': vm.header.status == \'EXECUTING\', \'label-danger\': vm.header.status == \'CLOSED\'}">{{\'pharmaPortalApp.pharmaPicking.status.\' + vm.header.status | translate}} </span><span ng-if="vm.header.status == \'TRANSPORTED\'" class="label" data-toggle="tooltip" data-placement="top" title="{{vm.header.transportedPickingUser }} em  {{vm.header.lastModifyingDate | date:\'yyyy-MM-dd HH:mm:ss\'}}" ng-class="{\'label-success\': vm.header.status == \'TRANSPORTED\'}">{{\'pharmaPortalApp.pharmaPicking.status.\' + vm.header.status | translate}}</span></div></div></div></div></div></div><div class="row"><div class="col-md-5 form-group form-group-sm"><div class="row"><label for="pharmacyName" class="control-label col-lg-2" translate="pharmaPortalApp.pharmaPicking.detail.form.pharmacyName">Pharmacy</label><div class="col-lg-10"><input type="text" id="pharmacyName" class="form-control" ng-model="vm.header.pharmacy" placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.pharmacyName\' | translate}}" ng-disabled="true"></div></div></div><div class="col-md-7 form-group form-group-sm"><div class="row"><label for="supplier" class="col-lg-2 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.supplier">Supplier</label><div class="col-lg-10"><input type="text" id="supplier" class="form-control" ng-model="vm.header.supplier" placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.supplier\' | translate}}" ng-disabled="true"></div></div></div></div><form class="row" id="pickingForm" name="pickingForm" novalidate><div class="col-md-5"><div class="row"><any ng-if="vm.portalSettings.pickingQuantity"><div class="col-md-6 form-group form-group-sm"><div class="row"><label for="productPick" class="col-lg-4 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.product">Product</label><div class="col-lg-8"><input type="text" class="form-control" autofocus ng-model="vm.form.product" id="productPick" name="product" required placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.product\' | translate}}" ng-disabled="vm.locked"></div></div></div><div class="col-md-6 form-group form-group-sm"><div class="row"><label for="quantity" class="col-lg-5 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.quantity">Quantity</label><div class="col-lg-7"><div class="input-group input-group-sm"><input type="number" class="form-control" ng-model="vm.form.quantity" id="quantity" name="quantity" min="1" ng-pattern="/^\\d*$/" ng-disabled="vm.locked"> <span class="input-group-btn"><button type="submit" ng-click="vm.submitPharmaProduct()" ng-disabled="vm.locked || pickingForm.$invalid" class="btn btn-success btn-sm"><i class="fa fa-plus"></i></button></span></div></div></div></div></any><any ng-if="!vm.portalSettings.pickingQuantity"><div class="col-md-12 form-group form-group-sm"><div class="row"><label for="product" class="col-lg-2 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.product">Product</label><div class="col-lg-10"><div class="input-group input-group-sm"><input type="text" class="form-control" autofocus ng-model="vm.form.product" id="product" name="product" required placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.product\' | translate}}" ng-disabled="vm.locked"> <span class="input-group-btn"><button type="submit" ng-click="vm.submitPharmaProduct()" ng-disabled="vm.locked || pickingForm.$invalid" class="btn btn-success btn-sm"><i class="fa fa-plus"></i></button></span></div></div></div></div></any></div></div><div class="col-md-7"><div class="row"><div class="col-md-8 col-xs-6 form-group form-group-sm"><div class="row"><label class="control-label col-lg-6" translate="pharmaPortalApp.pharmaPicking.detail.form.remainingLines">Remaining Lines</label><div class="col-lg-6"><span class="lead">{{pendingLines.length}}</span></div></div></div><div class="col-md-4 col-xs-6 form-group form-group-sm text-right"><span class="hidden-lg"><br></span><button type="button" ng-click="vm.deleteRightTableLines()" ng-disabled="vm.working || vm.locked || processedLines.length == 0" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.detail.action.clearList">Clear list</span></button></div></div></div></form></div><blockquote ng-hide="vm.pharmaPicking.pharmaPickingLines.length > 0" class="help-block" data-translate="pharmaPortalApp.pharmaPicking.detail.message.noPickingLines">No Picking Lines</blockquote><div class="row"><div class="col-md-6" ng-show="vm.pharmaPicking.pharmaPickingLines.length > 0"><h3><span data-translate="pharmaPortalApp.pharmaPicking.detail.table.conferenceZone">Zona de produtos em confer\xEAncia</span><style>.blink {\n                                animation: blinker 2.7s linear infinite;\n                            }\n\n                            @keyframes blinker {\n                                50% {\n                                    opacity: 0;\n                                }\n                            }</style><span ng-if="vm.header.status != \'EXECUTING\'" ng-click="vm.showInfo()"><i class="fa fa-info-circle text-success blink" style="cursor: pointer"></i></span></h3><blockquote ng-hide="pendingLines.length > 0" id="blockquote_helpBlock" name="helpBlock" class="help-block" data-translate="pharmaPortalApp.pharmaPicking.detail.message.noLinesLeft">No Pending Picking Lines</blockquote><div class="table-responsive" ng-show="pendingLines.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.pharmaPicking.pharmaPickingLines"><thead><tr jh-sort="predicateL" ascending="reverseL"><th jh-sort-by="cnp"><span data-translate="pharmaPortalApp.pharmaPicking.detail.table.cnp">CNP</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="description"><span data-translate="pharmaPortalApp.pharmaPicking.detail.table.description">Description</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="invoicedQuantity"><span data-translate="pharmaPortalApp.pharmaPicking.detail.table.quantity">Quantity</span>&nbsp;<i class="fa fa-sort"></i></th></tr></thead><tbody><tr ng-repeat="pharmaPickingLine in vm.pharmaPicking.pharmaPickingLines | filter:filter | filter:vm.leftTableFilter | orderBy:predicateL:reverseL as pendingLines"><td class="table-left">{{pharmaPickingLine.cnp}}</td><td class="table-left">{{pharmaPickingLine.description}}</td><td class="table-right">{{pharmaPickingLine.invoicedQuantity-pharmaPickingLine.receivedQuantity}}</td></tr></tbody></table></div></div><div class="col-md-6" ng-show="vm.pharmaPicking.pharmaPickingLines.length > 0"><h3 data-translate="pharmaPortalApp.pharmaPicking.detail.table.conferredZone">Zona de produtos conferidos</h3><blockquote ng-hide="processedLines.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.pharmaPicking.detail.message.noLinesRight">No Processed Picking Lines</blockquote><div class="table-responsive" ng-show="processedLines.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.pharmaPicking.pharmaPickingLines"><thead><tr jh-sort="predicateR" ascending="reverseR"><th jh-sort-by="cnp"><span data-translate="pharmaPortalApp.pharmaPicking.detail.table.cnp">CNP</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="description"><span data-translate="pharmaPortalApp.pharmaPicking.detail.table.description">Description</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="invoicedQuantity"><span data-translate="pharmaPortalApp.pharmaPicking.detail.table.quantity">Quantity</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="pharmaPickingLine in vm.pharmaPicking.pharmaPickingLines  | filter:filter | filter:vm.rightTableFilter | orderBy:predicateR:reverseR as processedLines"><td class="table-left">{{pharmaPickingLine.cnp}}</td><td class="table-left">{{pharmaPickingLine.description}}</td><td class="table-right">{{pharmaPickingLine.receivedQuantity}}</td><td class="table-center"><div class="btn-group"><button class="btn btn-danger btn-xs" ng-disabled="vm.working || vm.locked" title="{{\'entity.action.delete\' | translate}}" ng-click="vm.deletePharmaPickingLine(pharmaPickingLine)"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div></div></div><div class="panel-footer"><div class="row"><form class="col-md-12" ng-submit="vm.submitPharmaPicking()"><div class="text-right"><button type="button" ng-click="vm.back()" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="submit" ng-disabled="vm.working || vm.locked" class="btn btn-success btn-sm"><i class="fa fa-cloud-upload"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.detail.action.submit">Submit</span></button></div></form></div></div></div></div>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-import-files.html','<style>.btn-label {position: relative;left: -12px;display: inline-block;padding: 6px 12px;background: rgba(0,0,0,0.15);border-radius: 3px 0 0 3px;}\n    .btn-labeled {padding-top: 0;padding-bottom: 0;}</style><div><div class="panel panel-default"><div class="panel-heading"><form class="row"><div class="col-sm-8 col-sm-4"><label class="control-label" for="file" translate="global.form.file">File</label><input type="file" class="file" ngf-select ng-model="vm.importFile.file" id="file" ng-change="vm.changeFile()" ngf-pattern="\'.xlsx\'" accept=".xlsx" ngf-max-size="20MB" ngf-model-invalid="errorFile"><div class="input-group input-group-sm"><span class="input-group-btn"><button class="browse btn btn-primary" type="button"><i class="fa fa-search"></i>&nbsp;<span translate="entity.action.search">Search</span></button> </span><input id="filename" type="text" name="file" class="form-control" disabled="disabled"> <span class="input-group-btn"><button type="button" class="btn btn-success btn-sm" ng-click="vm.uploadFile()"><i class="fa fa-upload"></i>&nbsp;<span data-translate="entity.action.upload">Upload</span></button></span></div></div><script>$(\'.browse\').on(\'click\', function (event) {\n                        var file = $(this).parent().parent().parent().find(\'.file\');\n                        file.trigger(\'click\');\n                    });\n                    $(\'.file\').on(\'change\', function (event) {\n                        $(this).parent().find(\'.form-control\').val($(this).val().replace(/C:\\\\fakepath\\\\/i, \'\'));\n                    });</script></form></div><div class="panel-body"><div><div style="text-align: right"><button class="btn btn-default btn-xs" title="{{\'pharmaPortalApp.pharmaPicking.home.action.search\' | translate}}" ng-click="showSearch = !showSearch"><i class="fa fa-search"></i></button></div><div class="container-fluid well well-sm" ng-hide="showSearch"><form class="row" ng-submit="vm.transition()"><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': pickingForm.supplierName.$invalid && pickingForm.supplierName.$dirty }"><label for="supplierName" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPickingImportFile.search.company">Company</label><div class="col-md-7"><ui-select class="" id="supplierName" name="supplierName" ng-model="vm.tableFilters.company"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaPickingImportFile.search.company\' | translate}}">{{$select.selected.value === \'\' ? \'\' : $select.selected.label}}</ui-select-match><ui-select-choices repeat="value as value in (vm.companylist)"><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-3 form-group-sm"><label for="supplierName" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPickingImportFile.search.product">Product</label><div class="col-md-7"><input type="text" class="form-control input-sm" ng-model="vm.tableFilters.product" id="productFilter" placeholder="{{\'pharmaPortalApp.pharmaPickingImportFile.search.product\' | translate}}" autocomplete="off"></div></div><div class="col-md-3 form-group-sm"><label for="startDate" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.startDate">Start Date</label><div class="col-md-7"><div class="input-group input-group-sm"><input type="text" class="form-control" id="startDate" ng-click="vm.openDatePopup()" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.tableFilters.initDate" is-open="vm.datePopup.opened" datepicker-options="vm.dateOptions" placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.startDate\' | translate}}" ng-disabled="vm.working" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="col-md-3 text-right"><div class="btn-group"><button type="button" class="btn btn-warning btn-sm" ng-click="vm.clearFilter()" title="{{\'entity.action.reset\' | translate}}"><i class="fa fa-times"></i></button> <button type="submit" class="btn btn-info btn-sm" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i></button></div></div></form></div><div><blockquote ng-hide="vm.importFiles.length > 0" id="helpBlock" class="help-block">N\xE3o existem ficheiros importados</blockquote><div class="table-responsive" ng-show="vm.importFiles.length > 0"><table class="jh-table table table-striped panel tableCell"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sort()"><th jh-sort-by="company"><span data-translate="pharmaPortalApp.pharmaPickingImportFile.company">Company</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="productCNP"><span data-translate="pharmaPortalApp.pharmaPickingImportFile.product">Produto</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="initialDate"><span data-translate="pharmaPortalApp.pharmaPickingImportFile.initialDate">Initial Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="quantity"><span data-translate="pharmaPortalApp.pharmaPickingImportFile.quantity">Quantity</span>&nbsp;<i class="fa fa-sort"></i></th><th></th></tr></thead><tbody><tr ng-repeat="importFile in vm.importFiles"><td class="table-left">{{importFile.companyName1}}</td><td style="text-align: left !important">{{importFile.productCNP + (importFile.productDescription ? (" - " + importFile.productDescription) : "")}}</td><td class="table-center">{{importFile.initialDate | date:\'dd/MM/yyyy\'}}</td><td class="table-center">{{importFile.quantity}}</td><td class="table-center"><div class="btn-group"><button class="btn btn-danger btn-sm" title="{{\'entity.action.delete\' | translate}}" ng-click="vm.deleteLine(importFile)"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div><div class="panel-footer"><div class="col-sm-8"><button ng-click="vm.downloadFile()" class="btn btn-info btn-sm"><i class="fa fa-download"></i>&nbsp;<span data-translate="entity.action.downloadTemplate">Download template</span></button></div><div class="text-right"><button type="submit" ui-sref="pharma-picking" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button class="btn btn-warning btn-sm" ng-click="vm.exportFile()"><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span></button></div></div></div></div></div>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-keep-in-pharmacy-dialog.html','<div><form name="submitPickingHeaderForm" class="form-inline"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear(\'close\')">&times;</button><div class="btn-group btn-breadcrumb"><button type="button" class="btn btn-default" data-translate="pharmaPortalApp.pharmaPicking.detail.title" ng-click="vm.clear(\'goToPickingDetail\')">Picking Detail</button> <button type="button" class="btn btn-default" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.title" ng-click="vm.clear(\'close\')">Picking Header</button><div class="btn btn-success" style="cursor: text" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.keepInPharmacyTitle">Picking Header</div></div><!--<h4 class="modal-title"--><!--data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.title">Confirm--><!--Picking Header</h4>--></div><div class="modal-body"><div class="alert alert-danger" ng-show="vm.invalidSuggestion" data-translate="pharmaPortalApp.pharmaPickingImportFile.message.invalidSuggestion"></div><div class="alert alert-info" ng-show="vm.checkSuggestionError()" data-translate="pharmaPortalApp.pharmaPickingImportFile.message.suggestionError"></div><p><span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.keepInPharmacyDialog.body">Foi detetado produto conferido. Produto ficou na farm\xE1cia?</span></p><div class="row"><div class="col-sm-12"><table class="jh-table table table-striped"><thead><tr><th><input type="checkbox" ng-model="vm.allSelected" ng-change="vm.selectAll(vm.allSelected)"></th><th data-translate="pharmaPortalApp.pharmaPickingImportFile.article">Artigo</th><th data-translate="pharmaPortalApp.pharmaPickingImportFile.suggestion">Sugest\xE3o</th></tr></thead><tbody><tr ng-repeat="product in products"><td><input type="checkbox" ng-model="product.isSelectedSuggestion" ng-change="vm.selectProduct()"></td><td style="text-align: left !important">{{product.cnp}} - {{product.description}}</td><td class="form-group" ng-class="{\'has-error has-feedback text-danger\': product.suggestion && (product.suggestion < 1 || product.suggestion > product.receivedQuantity)}"><span ng-show="product.editMode == \'\' || !product.editMode">{{product.suggestion | number : 0}}</span> <input id="{{product.id}}" ng-show="product.editMode !=\'\' && product.editMode" type="text" class="form-control input-xs text-center" ng-model="product.suggestion" ng-change="vm.checkSuggestionQuantity()" on-enter="vm.toggleLineEditMode(product)" ng-class="{ \'alert-danger\': product.suggestion && (product.suggestion < 1 || product.suggestion > product.receivedQuantity)}"> <i class="fa fa-remove form-control-feedback" style="margin: 0px"></i></td><td><button type="button" class="btn btn-primary btn-xs" ng-show="product.editMode ==\'\' || !product.editMode" title="{{\'entity.action.edit\' | translate}}" ng-click="vm.toggleLineEditMode(product)"><i class="fa fa-pencil"></i></button> <button type="button" class="btn btn-success btn-xs" ng-show="product.editMode!=\'\' && product.editMode" title="{{\'entity.action.ok\' | translate}}" ng-click="vm.toggleLineEditMode(product)"><i class="fa fa-check"></i></button></td></tr></tbody></table></div><div class="col-sm-12 text-center"><ul uib-pagination total-items="totalItems" ng-model="vm.page" items-per-page="itemsPerPage"></ul></div></div></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear(\'close\')"><i class="fa fa-undo"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.keepInPharmacyDialog.back">Back</span></button> <button type="button" class="btn btn-success btn-sm" ng-disabled="submitPickingHeaderForm.$invalid" ng-click="vm.confirmPharmaPickingSubmit()"><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.keepInPharmacyDialog.confirm">Confirm</span></button></div></div></div></form></div>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-new.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaPicking.new.title">New Picking</span><div class="btn-group pull-right"><button class="btn btn-info btn-sm" title="{{\'pharmaPortalApp.pharmaPicking.home.action.search\' | translate}}" ng-click="showSearch = !showSearch"><i class="fa fa-search"></i></button></div><span class="clearfix"></span></div><div class="panel-body"><div class="container-fluid well well-sm" ng-hide="showSearch"><div class="row"><div class="form-group-sm col-md-6"><label for="supplierFilter" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaPicking.new.filters.supplier">Supplier</label><div class="col-md-8"><ui-select class="" id="supplierFilter" ng-model="vm.tableFilters.supplier"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaPicking.new.filters.supplier\' | translate}}">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="value as value in (vm.supplierFilterPicklist | filter: $select.search)"><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group-sm col-md-3"><label for="initDateFilter" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPicking.new.filters.initDate">Initial Date</label><div class="col-md-7"><div class="input-group input-group-sm"><input type="text" class="form-control" id="initDateFilter" ng-click="vm.openInitDatePopup()" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.tableFilters.initDate" is-open="vm.initDatePopup.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openInitDatePopup()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="form-group-sm col-md-3"><label for="endDateFilter" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPicking.new.filters.endDate">End Date</label><div class="col-md-7"><div class="input-group input-group-sm"><input type="text" class="form-control" id="endDateFilter" ng-click="vm.openEndDatePopup()" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.tableFilters.endDate" is-open="vm.endDatePopup.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openEndDatePopup()"><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="row">&nbsp;</div><div class="row"><div class="form-group-sm col-md-6"><label for="pharmacyFilter" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaPicking.new.filters.pharmacy">Pharmacy</label><div class="col-md-8"><ui-select id="pharmacyFilter" ng-model="vm.tableFilters.pharmacy"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaPicking.new.filters.pharmacy\' | translate}}">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="value as value in (vm.pharmaciesFilterPicklist | filter: $select.search) track by $index"><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group-sm col-md-6"><input type="text" class="form-control input-sm" ng-model="vm.tableFilters.receipt" id="receiptFilter" placeholder="{{\'pharmaPortalApp.pharmaPicking.new.filters.receipt\' | translate}}" autocomplete="off"></div></div></div><div><blockquote ng-hide="vm.lines.length > 0" id="helpBlock" class="help-block">N\xE3o foram encontradas confer\xEAncias em aberto</blockquote><div class="table-responsive" ng-show="vm.lines.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.lines"><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="receipt"><span data-translate="pharmaPortalApp.pharmaPicking.new.table.receipt">Receipt</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="supplierCode"><span data-translate="pharmaPortalApp.pharmaPicking.new.table.supplier">Supplier</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="documentDate"><span data-translate="pharmaPortalApp.pharmaPicking.new.table.documentDate">Document Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="pharmacyName"><span data-translate="pharmaPortalApp.pharmaPicking.new.table.pharmacy">Pharmacy</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by=""><span data-translate="pharmaPortalApp.pharmaPicking.new.table.status">Status</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="pharmaPortalApp.pharmaPicking.new.table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="pharmaTransfReceptionHeader in vm.lines | filter:filter | orderBy:predicate:reverse | filter:vm.filterLine track by $index"><td class="table-left">{{pharmaTransfReceptionHeader.receipt}}</td><td class="table-left">{{pharmaTransfReceptionHeader.supplierCode}} - {{pharmaTransfReceptionHeader.supplierName}}</td><td class="table-center">{{pharmaTransfReceptionHeader.documentDate | date:"dd/MM/yyyy"}}</td><td class="table-left">{{pharmaTransfReceptionHeader.pharmacyWarehouse}} - {{pharmaTransfReceptionHeader.pharmacyName}}</td><td class="table-left"><span class="label" ng-class="\'label-success\'"><span data-translate="pharmaPortalApp.pharmaPicking.status.OPEN">OPEN</span></span></td><td class="table-center"><div class="btn-group"><button ng-disabled="vm.isSaving" class="btn btn-primary btn-xs" title="{{\'entity.action.receive\' | translate}}" ng-click="vm.save(pharmaTransfReceptionHeader.supplierCode, pharmaTransfReceptionHeader.supplierReference)"><i class="fa fa-pencil"></i></button></div></td></tr></tbody></table></div></div></div><div class="panel-footer"><div class="text-right"><button type="button" ui-sref="pharma-picking" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div></div></div></div>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-show-history-detail.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaPickingShowHistory.home.title">Pharma Picking</span> <span class="clearfix"></span></div><div class="panel-body"><div style="text-align: right"><button class="btn btn-default btn-xs" title="{{\'pharmaPortalApp.pharmaPicking.home.action.search\' | translate}}" ng-click="showSearch = !showSearch"><i class="fa fa-search"></i></button></div><form class="container-fluid well well-sm" ng-hide="showSearch" ng-submit="vm.transition()"><div class="row"><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': pickingForm.pharmacyWarehouse.$invalid && pickingForm.pharmacyWarehouse.$dirty }"><label for="pharmaWarehouse" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPickingShowHistory.search.pharmacy">Pharmacy Warehouse</label><div class="col-md-7"><ui-select class="" id="pharmaWarehouse" name="pharmaWarehouse" ng-required="true" ng-model="vm.saveSearch.company" ng-disabled="true"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaPickingShowHistory.search.pharmacy\' | translate}}">{{$select.selected.value === \'\' ? \'\' : $select.selected.label}}</ui-select-match><ui-select-choices repeat="value as value in (vm.pharmaciesFilterPicklist | filter: $select.search)"><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-3 form-group-sm"><label for="year" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPickingShowHistory.search.year">Start Date</label><div class="col-md-7"><input type="number" step="1" min="1997" class="form-control" id="year" ng-model="vm.saveSearch.year" placeholder="{{\'pharmaPortalApp.pharmaPickingShowHistory.search.year\' | translate}}" ng-disabled="true"></div></div><div class="col-md-3 form-group-sm"><label for="month" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPickingShowHistory.search.month">Month</label><div class="col-md-7"><input type="number" step="1" min="1" max="12" class="form-control" id="month" ng-model="vm.saveSearch.month" ng-disabled="true" placeholder="{{\'pharmaPortalApp.pharmaPickingShowHistory.search.month\' | translate}}"></div></div><div class="col-md-3 form-group-sm"><label for="product" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPickingShowHistory.search.product">Product</label><div class="col-md-7"><input type="text" class="form-control input-sm" ng-model="vm.saveSearch.product" id="product" ng-disabled="true" placeholder="{{\'pharmaPortalApp.pharmaPickingShowHistory.search.product\' | translate}}" autocomplete="off"></div></div></div></form><div><blockquote ng-hide="vm.pharmaPickingHeaders.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.pharmaPickingShowHistory.message.noHistory">No History</blockquote><div class="table-responsive panel panel-success" ng-show="vm.pharmaPickingHeaders.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.pharmaPickingHeaders"><div class="panel-heading text-center"><ul class="list-inline"><li ng-if="vm.saveSearch.company"><span style="margin: 4px">{{vm.saveSearch.company.label}}</span> <i class="fa fas fa-arrow-right"></i></li><li ng-if="vm.saveSearch.year"><span style="margin: 4px">{{vm.saveSearch.year}}</span> <i class="fa fas fa-arrow-right"></i></li><li ng-if="vm.saveSearch.month"><span style="margin: 4px">{{vm.saveSearch.month}}</span> <i class="fa fas fa-arrow-right"></i></li><li><span style="margin: 4px">{{vm.cnp + \' - \' + vm.saveSearch.description}}</span></li></ul></div><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sort()"><th jh-sort-by="pharmaPickingHeader.dateCreated"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.dateCreated">Start Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="pharmaPickingHeader.receipt"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.receipt">Receipt</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="pharmaPickingHeader.supplier"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.supplier">Supplier</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="pharmaPickingHeader.documentDate"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.documentDate">Document Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="pharmaPickingHeader.username"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.username">Username</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="pharmaPickingHeader.warehouse"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.warehouse">Warehouse</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="pharmaPickingHeader.lastModifyingDate"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.lastModifyingDate">lastModifyingDate</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="pharmaPickingHeader.status"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.status">Status</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="pharmaPickingHeader in vm.pharmaPickingHeaders"><td>{{pharmaPickingHeader.dateCreated | date:\'dd/MM/yyyy\'}}</td><td class="table-left">{{pharmaPickingHeader.receipt}}</td><td class="table-left">{{pharmaPickingHeader.supplierCode + " - " + pharmaPickingHeader.supplierName}}</td><td class="table-center">{{pharmaPickingHeader.documentDate | date:\'dd/MM/yyyy\'}}</td><td class="table-left">{{pharmaPickingHeader.lastModifyingUser}}</td><td class="table-left">{{pharmaPickingHeader.pharmacyWarehouse + " - " + pharmaPickingHeader.pharmacyName}}</td><td class="table-center">{{pharmaPickingHeader.lastModifyingDate | date:\'dd/MM/yyyy\'}}</td><td ng-if="pharmaPickingHeader.status != \'TRANSPORTED\'" class="table-left"><span class="label" ng-class="{\'label-warning\': pharmaPickingHeader.status == \'EXECUTING\', \'label-danger\': pharmaPickingHeader.status == \'CLOSED\', \'label-info\': pharmaPickingHeader.status == \'OPEN\'}">{{\'pharmaPortalApp.pharmaPicking.status.\' + pharmaPickingHeader.status | translate}}</span></td><td ng-if="pharmaPickingHeader.status == \'TRANSPORTED\'" class="table-left"><span class="label" data-toggle="tooltip" data-placement="top" title="{{pharmaPickingHeader.lastModifyingUser}} em {{pharmaPickingHeader.lastModifyingDate | date:\'yyyy-MM-dd HH:mm:ss\'}}" ng-class="{\'label-success\': pharmaPickingHeader.status == \'TRANSPORTED\'}">{{\'pharmaPortalApp.pharmaPicking.status.\' + pharmaPickingHeader.status | translate}}</span></td><td class="table-center"><div class="btn-group"><button class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}" ui-sref="pharma-picking-detail({id:pharmaPickingHeader.id})"><span class="fa fa-search-plus"></span></button></div></td></tr></tbody></table><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div></div><div class="panel-footer"><div class="text-right"><button type="button" ng-click="vm.back()" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div></div></div></div>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-show-history.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaPickingShowHistory.home.title">Pharma Picking</span> <span class="clearfix"></span></div><div class="panel-body"><div style="text-align: right"><button class="btn btn-default btn-xs" title="{{\'pharmaPortalApp.pharmaPicking.home.action.search\' | translate}}" ng-click="showSearch = !showSearch"><i class="fa fa-search"></i></button></div><form class="container-fluid well well-sm" ng-hide="showSearch" ng-submit="vm.transition()"><div class="row"><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': pickingForm.pharmacyWarehouse.$invalid && pickingForm.pharmacyWarehouse.$dirty }"><label for="pharmaWarehouse" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPickingShowHistory.search.pharmacy">Pharmacy Warehouse</label><div class="col-md-7"><ui-select class="" id="pharmaWarehouse" name="pharmaWarehouse" ng-required="true" ng-model="vm.tableFilters.company" ng-disabled="vm.working"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaPickingShowHistory.search.pharmacy\' | translate}}">{{$select.selected.value === \'\' ? \'\' : $select.selected.label}}</ui-select-match><ui-select-choices repeat="value as value in (vm.pharmaciesFilterPicklist | filter: $select.search)"><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-3 form-group-sm"><label for="year" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPickingShowHistory.search.year">Start Date</label><div class="col-md-7"><input type="number" step="1" min="1997" class="form-control" id="year" ng-model="vm.tableFilters.year" placeholder="{{\'pharmaPortalApp.pharmaPickingShowHistory.search.year\' | translate}}"></div></div><div class="col-md-3 form-group-sm"><label for="month" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPickingShowHistory.search.month">Month</label><div class="col-md-7"><input type="number" step="1" min="1" max="12" class="form-control" id="month" ng-model="vm.tableFilters.month" placeholder="{{\'pharmaPortalApp.pharmaPickingShowHistory.search.month\' | translate}}"></div></div><div class="col-md-3 form-group-sm"><label for="product" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPickingShowHistory.search.product">Product</label><div class="col-md-7"><input type="text" class="form-control input-sm" ng-model="vm.tableFilters.product" id="product" placeholder="{{\'pharmaPortalApp.pharmaPickingShowHistory.search.product\' | translate}}" autocomplete="off"></div></div></div><div class="row">&nbsp;</div><div class="row"><div class="col-sm-offset-9 col-md-3 text-right"><div class="btn-group"><button type="button" class="btn btn-warning btn-sm" ng-click="vm.clearFilter()" title="{{\'entity.action.reset\' | translate}}"><i class="fa fa-times"></i></button> <button type="submit" class="btn btn-info btn-sm" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i></button></div></div></div></form><div><blockquote ng-hide="vm.pharmaPickingShowHistory.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.pharmaPickingShowHistory.message.noHistory">No History</blockquote><div class="table-responsive" ng-show="vm.pharmaPickingShowHistory.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.pharmaPickingShowHistory"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sort()"><th jh-sort-by="cnp"><span data-translate="pharmaPortalApp.pharmaPickingShowHistory.table.product">Produto</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="pharmaPickingHeader.pharmacyWarehouse"><span data-translate="pharmaPortalApp.pharmaPickingShowHistory.table.pharmacy">Warehouse</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="receivedQuantity"><span data-translate="pharmaPortalApp.pharmaPickingShowHistory.table.received_quantity">Received quantity</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="sumInvoicedQuantity"><span data-translate="pharmaPortalApp.pharmaPickingShowHistory.table.invoiced_quantity">Invoiced quantity</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="claimedQuantity"><span data-translate="pharmaPortalApp.pharmaPickingShowHistory.table.claimed_quantity">Claimed quantity</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="transportedQuantity"><span data-translate="pharmaPortalApp.pharmaPickingShowHistory.table.transported_quantity">Transported quantity</span> &nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="pharmaPickingShowHistory in vm.pharmaPickingShowHistory"><td class="table-left">{{pharmaPickingShowHistory.productCNP + \' - \' + pharmaPickingShowHistory.productDescription}}</td><td class="table-left">{{pharmaPickingShowHistory.pharmacyWarehouse + " - " + pharmaPickingShowHistory.pharmacyName}}</td><td class="table-center">{{pharmaPickingShowHistory.receivedQuantity ? pharmaPickingShowHistory.receivedQuantity : 0}}</td><td class="table-center">{{pharmaPickingShowHistory.invoicedQuantity ? pharmaPickingShowHistory.invoicedQuantity : 0}}</td><td class="table-center">{{pharmaPickingShowHistory.claimedQuantity ? pharmaPickingShowHistory.claimedQuantity : 0}}</td><td class="table-center">{{pharmaPickingShowHistory.transportedQuantity ? pharmaPickingShowHistory.transportedQuantity : 0}}</td><td class="table-center"><div class="btn-group"><button class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}" ui-sref="pharma-picking-show-history-detail({saveSearch:vm.saveSearchFunction(pharmaPickingShowHistory), cnp: pharmaPickingShowHistory.productCNP})"><span class="fa fa-search-plus"></span></button></div></td></tr></tbody></table></div></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-submit-complete-dialog.html','<form name="submitPickingHeaderForm" ng-submit="vm.confirmPharmaPickingSubmit()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.title">Confirm Picking Header</h4></div><div class="modal-body"><p><span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.completeDialog.body" translate-values="{receipt: \'{{vm.pharmaPicking.receipt}}\', supplier: \'{{vm.supplier}}\'}">Are you sure you want to confirm picking related to {{vm.pharmaPicking.receipt}} of supplier {{vm.supplier}}?</span></p></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></div></div></form>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-submit-incomplete-dialog.html','<div><form name="submitPickingHeaderForm" class="form-inline" ng-submit="vm.confirmPharmaPickingSubmit(\'invoice\')"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear(\'close\')">&times;</button><div class="btn-group btn-breadcrumb"><button class="btn btn-default" type="button" data-translate="pharmaPortalApp.pharmaPicking.detail.title" ng-click="vm.clear(\'close\')">Picking Detail</button><div class="btn btn-success" style="cursor: text" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.title">Picking Header</div><!--<div class="btn btn-success" style="cursor: text" disabled>Breadcrumbs</div>--></div></div><div class="modal-body"><div class="alert alert-danger" ng-show="vm.passwordInvalid" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.passwordInvalid"><strong>The password entered is invalid.</strong></div><p><span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.body">Foi detetado produto em falta. Ficou com o produto?</span></p><div class="form-group"><label for="confirmPassword"><span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.label">To continue, please input the confirmation password</span></label>&nbsp;&nbsp; <input required type="password" class="form-control" id="confirmPassword" ng-model="vm.password" ng-change="vm.passwordInvalid = false"></div><div class="row"><div class="col-sm-12"><table class="jh-table table table-striped"><thead><tr><th><input type="checkbox" ng-model="vm.allSelected" ng-change="vm.selectAll(vm.allSelected)"></th><th data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.article">Artigo</th><th data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.quantity">Quantidade</th></tr></thead><tbody><tr ng-repeat="product in products"><th><input type="checkbox" ng-model="product.selected" ng-change="vm.selectProduct()"></th><th style="text-align: left !important">{{product.cnp}} - {{product.description}}</th><th>{{product.invoicedQuantity - product.receivedQuantity}}</th></tr></tbody></table></div><div class="col-sm-12 text-center"><ul uib-pagination total-items="totalItems" ng-model="vm.page" items-per-page="itemsPerPage"></ul></div></div></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button ng-disabled="submitPickingHeaderForm.$invalid" type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.confirmPharmaPickingSubmit(\'complaint\')"><i class="fa fa-ban"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.noButton">No</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="submitPickingHeaderForm.$invalid" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.yesButton">Yes</span></button></div></div></div></form></div>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-submit-overquantity-dialog.html','<form name="submitPickingHeaderForm" class="form-inline" ng-submit="vm.confirmPharmaPickingSubmit()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.title">Confirm Picking Header</h4></div><div class="modal-body"><div class="alert alert-danger" ng-show="vm.passwordInvalid" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.passwordInvalid"><strong>The password entered is invalid.</strong></div><p><span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.overQuantity">You\'re trying to close a picking conference that has items with received quantities greater than invoiced.</span></p><div class="form-group"><label for="confirmPassword"><span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.label">To continue, please input the confirmation password</span></label>&nbsp;&nbsp; <input required type="password" class="form-control" id="confirmPassword" ng-model="vm.password" ng-change="vm.passwordInvalid = false"></div></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="submitPickingHeaderForm.$invalid" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></div></div></form>');
$templateCache.put('app/entities/pharma-picking/pharma-picking-transport-dialog.html','<form name="transportPickingHeaderForm" class="form-inline" ng-submit="vm.submit()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.transport.title">Employee ID</h4></div><div class="modal-body"><div class="form-group"><label for="employeeNumberTransport"><span data-translate="pharmaPortalApp.pharmaPicking.transport.employeeNumber">Employee number</span></label>&nbsp;&nbsp; <input required type="text" class="form-control" id="employeeNumberTransport" ng-model="vm.employeeNumber" ng-focus="numberFocused()" ng-blur="numberBlurred()"></div></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear(\'cancel\')"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-success btn-sm" ng-click="vm.submit()" ng-disabled="vm.employeeNumber == null"><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.proceed">Yes</span></button></div></div></div></form>');
$templateCache.put('app/entities/pharma-picking/pharma-picking.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaPicking.home.title">Pharma Picking</span><div class="pull-right"><button ng-if="vm.noPharmacy" type="button" class="btn btn-info btn-sm" ui-sref="pharma-picking-import-files" has-any-authority="ROLE_ADMIN"><i class="fa fa-folder"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.home.action.import">Import</span></button> <button type="button" class="btn btn-success btn-sm" ng-click="vm.transportAction()" ng-disabled="vm.haveItemsToTransport <= 0"><i class="fa fa-truck"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.home.action.transport">Transport</span></button> <button type="button" class="btn btn-warning btn-sm" ui-sref="pharma-picking.new"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.home.action.newPickings">NewPicking</span></button></div><span class="clearfix"></span></div><div class="panel-body"><div style="text-align: right"><button class="btn btn-default btn-xs" title="{{\'pharmaPortalApp.pharmaPicking.home.action.search\' | translate}}" ng-click="showSearch = !showSearch"><i class="fa fa-search"></i></button></div><div class="container-fluid well well-sm" ng-hide="showSearch"><div class="row"><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': pickingForm.supplierName.$invalid && pickingForm.supplierName.$dirty }"><label for="supplierName" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.supplier">Supplier Name</label><div class="col-md-7"><ui-select class="" id="supplierName" name="supplierName" ng-required="true" ng-model="vm.tableFilters.supplier" ng-disabled="vm.working"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.supplier\' | translate}}">{{$select.selected.value === \'\' ? \'\' : $select.selected.label}}</ui-select-match><ui-select-choices repeat="value as value in (vm.supplierFilterPicklist | filter: $select.search)"><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-3 form-group-sm"><label for="startDate" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.startDate">Start Date</label><div class="col-md-7"><div class="input-group input-group-sm"><input type="text" class="form-control" id="startDate" ng-click="vm.openDatePopup(1)" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.tableFilters.initDate" is-open="vm.datePopup1.opened" datepicker-options="vm.dateOptions" placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.startDate\' | translate}}" ng-disabled="vm.working" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(1)"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="col-md-3 form-group-sm"><label for="receptionDate" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.endDate">End Date</label><div class="col-md-7"><div class="input-group input-group-sm"><input type="text" class="form-control" id="receptionDate" ng-click="vm.openDatePopup(2)" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.tableFilters.endDate" is-open="vm.datePopup2.opened" datepicker-options="vm.dateOptions" placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.endDate\' | translate}}" ng-disabled="vm.working" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(2)"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="col-md-3 form-group-sm"><input type="text" class="form-control input-sm" ng-model="vm.tableFilters.receipt" id="receiptFilter" placeholder="{{\'pharmaPortalApp.pharmaPicking.new.filters.receipt\' | translate}}" autocomplete="off"></div></div><div class="row">&nbsp;</div><div class="row"><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': pickingForm.lastModifyingUser.$invalid && pickingForm.lastModifyingUser.$dirty }"><label for="username" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.username">Username</label><div class="col-md-7"><ui-select class="" id="username" name="username" ng-required="true" ng-model="vm.tableFilters.user" ng-disabled="vm.working"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.lastModifyingUser\' | translate}}">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="value as value in (vm.userFilterPicklist | filter: $select.search)"><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': pickingForm.pharmacyWarehouse.$invalid && pickingForm.pharmacyWarehouse.$dirty }"><label for="pharmaWarehouse" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.pharmacy">Pharmacy Warehouse</label><div class="col-md-7"><ui-select class="" id="pharmaWarehouse" name="pharmaWarehouse" ng-required="true" ng-model="vm.tableFilters.pharmacy" ng-disabled="vm.working"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.pharmacy\' | translate}}">{{$select.selected.value === \'\' ? \'\' : $select.selected.label}}</ui-select-match><ui-select-choices repeat="value as value in (vm.pharmaciesFilterPicklist | filter: $select.search)"><span ng-bind-html="value.label | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': pickingForm.status.$invalid && pickingForm.status.$dirty }"><label for="status" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaPicking.detail.form.status">Status</label><div class="col-md-7"><ui-select class="" id="status" name="status" ng-required="true" ng-model="vm.tableFilters.status" ng-disabled="vm.working"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaPicking.detail.form.status\' | translate}}">{{\'pharmaPortalApp.pharmaPicking.status.\'+ $select.selected.value | translate}}</ui-select-match><ui-select-choices repeat="pickingState in vm.pickingStatus | filter: $select.search"><span ng-bind-html="\'pharmaPortalApp.pharmaPicking.status.\'+ pickingState.label | translate | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="col-md-3 text-right"><div class="btn-group"><button class="btn btn-warning btn-sm" ng-click="vm.clearFilter()" title="{{\'entity.action.reset\' | translate}}"><i class="fa fa-times"></i></button> <button type="submit" class="btn btn-info btn-sm" ng-click="vm.transition()" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i></button></div></div></div></div><div><blockquote ng-hide="vm.pharmaPickingHeaders.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.pharmaPicking.message.noOpenPicking">No Open Picking</blockquote><div class="table-responsive" ng-show="vm.pharmaPickingHeaders.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.pharmaPickingHeaders"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.sort()"><th jh-sort-by="dateCreated"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.dateCreated">Start Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="receipt"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.receipt">Receipt</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="supplierCode"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.supplier">Supplier</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="documentDate"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.documentDate">Document Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="lastModifyingUser"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.username">Username</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="pharmacyWarehouse"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.warehouse">Warehouse</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="status"><span data-translate="pharmaPortalApp.pharmaPicking.home.table.status">Status</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="pharmaPickingHeader in vm.pharmaPickingHeaders"><td>{{pharmaPickingHeader.dateCreated | date:\'dd/MM/yyyy\'}}</td><td class="table-left">{{pharmaPickingHeader.receipt}}</td><td class="table-left">{{pharmaPickingHeader.supplierCode + " - " + pharmaPickingHeader.supplierName}}</td><td class="table-center">{{pharmaPickingHeader.documentDate | date:\'dd/MM/yyyy\'}}</td><td class="table-left">{{pharmaPickingHeader.lastModifyingUser}}</td><td class="table-left">{{pharmaPickingHeader.pharmacyWarehouse + " - " + pharmaPickingHeader.pharmacyName}}</td><td ng-if="pharmaPickingHeader.status != \'TRANSPORTED\'" class="table-left"><span class="label" ng-class="{\'label-warning\': pharmaPickingHeader.status == \'EXECUTING\', \'label-danger\': pharmaPickingHeader.status == \'CLOSED\', \'label-info\': pharmaPickingHeader.status == \'OPEN\'}">{{\'pharmaPortalApp.pharmaPicking.status.\' + pharmaPickingHeader.status | translate}}</span></td><td ng-if="pharmaPickingHeader.status == \'TRANSPORTED\'" class="table-left"><span class="label" data-toggle="tooltip" data-placement="top" title="{{pharmaPickingHeader.transportedPickingUser}} em {{pharmaPickingHeader.lastModifyingDate | date:\'yyyy-MM-dd HH:mm:ss\'}}" ng-class="{\'label-success\': pharmaPickingHeader.status == \'TRANSPORTED\'}">{{\'pharmaPortalApp.pharmaPicking.status.\' + pharmaPickingHeader.status | translate}}</span></td><td class="table-center"><div class="btn-group"><button class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}" ui-sref="pharma-picking-detail({id:pharmaPickingHeader.id})"><span class="fa fa-search-plus"></span></button> <button ng-hide="pharmaPickingHeader.status == \'CLOSED\' || pharmaPickingHeader.status == \'TRANSPORTED\'" class="btn btn-primary btn-xs" title="{{\'entity.action.edit\' | translate}}" ui-sref="pharma-picking-detail.edit({id:pharmaPickingHeader.id})"><i class="fa fa-pencil"></i></button> <button ng-show="pharmaPickingHeader.status == \'CLOSED\' || pharmaPickingHeader.status == \'TRANSPORTED\'" class="btn btn-default btn-xs" title="{{\'entity.action.print\' | translate}}" ng-click="vm.generatePdf(pharmaPickingHeader.id)"><i class="fa fa-print"></i></button> <button class="btn btn-danger btn-xs" ng-if="pharmaPickingHeader.status != \'TRANSPORTED\' && pharmaPickingHeader.status != \'CLOSED\'" ng-disabled="pharmaPickingHeader.status == \'CLOSED\' && vm.disabled" title="{{\'entity.action.delete\' | translate}}" ui-sref="pharma-picking-delete({id:pharmaPickingHeader.id})"><i class="fa fa-trash-o"></i></button> <button class="btn btn-danger btn-xs" ng-if="pharmaPickingHeader.status == \'CLOSED\'" has-any-authority="ROLE_ADMIN" title="{{\'entity.action.delete\' | translate}}" ui-sref="pharma-picking-delete({id:pharmaPickingHeader.id})"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/pharma-picking/user-question.html','<form class="form-group" ng-submit="vm.close()"><div class="modal-header"><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.titleConfirme">Confirm Picking Header</h4></div><div class="modal-body"><h5 class="modal-title" data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.titleConfirmeAll">Confirm Picking Header</h5></div><div class="modal-footer"><div class="row"><div class="col-md-12"><button ng-disabled="!vm.allSelected" type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaPicking.detail.submitDialog.incompleteDialog.yes">Yes</span></button></div></div></div></form>');
$templateCache.put('app/entities/pharma-reception/pharma-reception-confirm-differences-dialog.html','<form name="submitReceptionHeaderForm" ng-submit="vm.exportToExcel()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaReception.confirmDifferencesDialog.title">Confirm Differences</h4></div><div class="modal-body"><p><span class="modal-title" data-translate="pharmaPortalApp.pharmaReception.confirmDifferencesDialog.body">Confirm Reception Header submit?</span></p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.close()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-reception/pharma-reception-delete-dialog.html','<form name="deleteReceptionHeaderForm" ng-submit="vm.confirmPharmaReceptionDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaReception.deleteDialog.title">Confirm Reception Header</h4></div><div class="modal-body"><p><span class="modal-title" data-translate="pharmaPortalApp.pharmaReception.deleteDialog.body">Confirm Reception Header delete?</span></p><p><span data-translate="pharmaPortalApp.pharmaReception.form.receptionDate">Reception Date</span>: {{vm.pharmaReception.date | date:\'dd/MM/yyyy\'}}</p><p><span data-translate="pharmaPortalApp.pharmaReception.form.warehouse">Warehouse</span>: {{vm.getWarehouseFullDescription(vm.pharmaReception.warehouse)}}</p><p><span data-translate="pharmaPortalApp.pharmaReception.form.supplier">Supplier</span>: {{vm.getSupplierFullDescription(vm.pharmaReception.supplier)}}</p><p><span data-translate="pharmaPortalApp.pharmaReception.form.supplierDocument">SupplierDocument</span>: {{vm.pharmaReception.supplierDocument}}</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger btn-sm" autofocus><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pharma-reception/pharma-reception-detail.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaReception.home.title">Pharma Reception</span> <button type="submit" class="btn btn-warning btn-sm pull-right" ui-sref="pharma-reception-line.new({parentId: vm.pharmaReception.id})"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaReception.action.newReceptionLine">New Reception Line</span></button> <span class="clearfix"></span></div><div class="panel-body"><form class="container-fluid well well-sm" ng-submit="vm.save()" id="receptionForm" name="receptionForm"><fieldset ng-disabled="vm.pharmaReception.status === \'SUBMITTED\'"><div class="row"><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': receptionForm.receptionDate.$invalid && receptionForm.receptionDate.$dirty }"><label for="receptionDate" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaReception.form.receptionDate">Reception Date</label><div class="col-md-7"><div class="input-group input-group-sm"><input type="text" class="form-control" id="receptionDate" ng-click="vm.openDatePopup()" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.pharmaReception.date" is-open="vm.datePopup.opened" datepicker-options="vm.dateOptions" placeholder="{{\'pharmaPortalApp.pharmaReception.form.receptionDate\' | translate}}" ng-disabled="vm.working" ng-blur="vm.save()" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="form-group-sm col-md-5" ng-class="{ \'has-error\': receptionForm.warehouse.$invalid && receptionForm.warehouse.$dirty }"><label for="warehouse" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.form.warehouse">Warehouse</label><div class="col-md-8"><ui-select class="" id="warehouse" name="warehouse" ng-required="true" ng-model="vm.pharmaReception.warehouse" ng-disabled="vm.working"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaReception.form.warehouse\' | translate}}">{{$select.selected.code + \' - \' + $select.selected.description}}</ui-select-match><ui-select-choices repeat="warehouse.code as warehouse in (vm.warehouses | filter: $select.search)"><span ng-bind-html="warehouse.code + \' - \' + warehouse.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group-sm col-md-4" ng-class="{ \'has-error\': receptionForm.supplier.$invalid && receptionForm.supplier.$dirty }"><label for="supplier" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.form.supplier">Supplier</label><div class="col-md-8"><ui-select class="" id="supplier" name="supplier" ng-required="true" ng-model="vm.pharmaReception.supplier" ng-disabled="vm.working"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaReception.form.supplier\' | translate}}">{{$select.selected.code + \' - \' + $select.selected.description}}</ui-select-match><ui-select-choices repeat="supplier.code as supplier in (vm.suppliers | filter: $select.search)"><span ng-bind-html="supplier.code + \' - \' + supplier.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row">&nbsp;</div><div class="row"><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': receptionForm.supplierDocument.$invalid && receptionForm.supplierDocument.$dirty }"><label for="supplierDocument" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaReception.form.supplierDocument">Supplier Document</label><div class="col-md-7"><input type="text" class="form-control" id="supplierDocument" name="supplierDocument" size="12" maxlength="12" ng-model="vm.pharmaReception.supplierDocument" placeholder="{{\'pharmaPortalApp.pharmaReception.form.supplierDocument\' | translate}}" required ng-disabled="vm.working" ng-blur="vm.save()"></div></div><div class="form-group-sm col-md-5" ng-class="{ \'has-error\': receptionForm.orderType.$invalid && receptionForm.orderType.$dirty }"><label for="orderType" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.form.orderType">Order Type</label><div class="col-md-8"><ui-select class="" id="orderType" name="orderType" ng-required="true" ng-model="vm.pharmaReception.orderType" ng-disabled="vm.working"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaReception.form.orderType\' | translate}}">{{$select.selected.type + \' - \' + $select.selected.name}}</ui-select-match><ui-select-choices repeat="orderType.type as orderType in (vm.orderTypes | filter: $select.search)"><span ng-bind-html="orderType.type + \' - \' + orderType.name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group-sm col-md-4"><label for="username" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.form.username">Username</label><div class="col-md-8"><input type="text" class="form-control" id="username" name="username" ng-model="vm.pharmaReception.username" placeholder="{{\'pharmaPortalApp.pharmaReception.form.username\' | translate}}" ng-disabled="true"></div></div></div></fieldset></form><blockquote ng-hide="vm.pharmaReception.pharmaReceptionLines.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.pharmaReception.message.noReceptionLines">No Reception Lines</blockquote><div class="table-responsive" ng-show="vm.pharmaReception.pharmaReceptionLines.length > 0"><fieldset ng-disabled="vm.pharmaReception.status === \'SUBMITTED\'"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.pharmaReception.pharmaReceptionLines"><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="cnp"><span data-translate="pharmaPortalApp.pharmaReception.table.cnp">CNP</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="description"><span data-translate="pharmaPortalApp.pharmaReception.table.description">Description</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="vatRate"><span data-translate="pharmaPortalApp.pharmaReception.table.vatRate">VAT Rate</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="lot"><span data-translate="pharmaPortalApp.pharmaReception.table.lot">Lot</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="expirationDate"><span data-translate="pharmaPortalApp.pharmaReception.table.expirationDate">Expiration Date</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="receivedQuantity"><span data-translate="pharmaPortalApp.pharmaReception.table.receivedQuantity">Received Quantity</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="qualityStatus"><span data-translate="pharmaPortalApp.pharmaReception.table.qualityStatus">Quality Status</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="invoicedQuantity"><span data-translate="pharmaPortalApp.pharmaReception.table.invoicedQuantity">Invoiced Quantity</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="bonusQuantity"><span data-translate="pharmaPortalApp.pharmaReception.table.bonusQuantity">Bonus Quantity</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="unitPrice"><span data-translate="pharmaPortalApp.pharmaReception.table.unitPrice">Unit Price</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="discount1"><span data-translate="pharmaPortalApp.pharmaReception.table.discount1">Discount 1</span>&nbsp; <i class="fa fa-sort"></i></th><th jh-sort-by="discount2"><span data-translate="pharmaPortalApp.pharmaReception.table.discount2">Discount 2</span>&nbsp; <i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="pharmaReceptionLine in vm.pharmaReception.pharmaReceptionLines | filter : { serviceLine : false } | orderBy:predicate:reverse"><td class="table-left">{{pharmaReceptionLine.cnp}}</td><td class="table-left">{{pharmaReceptionLine.description}}</td><td class="text-right">{{pharmaReceptionLine.vatRate | currency : \'%\' : 0}}</td><td class="form-group table-left" ng-class="{ \'text-danger\': pharmaReceptionLine.lot.length < 1, \'has-error has-feedback\': pharmaReceptionLine.lot.length < 1}"><span ng-show="pharmaReceptionLine.editMode===\'\' || !pharmaReceptionLine.editMode">{{pharmaReceptionLine.lot | uppercase}} </span><input ng-show="pharmaReceptionLine.editMode!=\'\' && pharmaReceptionLine.editMode" ng-class="{ \'alert-danger\': pharmaReceptionLine.lot.length < 1}" type="text" class="form-control input-sm text-center" id="lot" name="lot" ng-model="pharmaReceptionLine.lot" ng-model-options="{updateOn: \'blur\'}" size="15" maxlength="15" placeholder="{{\'pharmaPortalApp.pharmaReception.table.lot\' | translate}}" ng-blur="vm.onBlurFromLot(pharmaReceptionLine)"> <span class="fa fa-remove form-control-feedback"></span></td><td class="form-group"><span ng-show="pharmaReceptionLine.editMode===\'\' || !pharmaReceptionLine.editMode">{{pharmaReceptionLine.expirationDate!=null && pharmaReceptionLine.expirationDate != \'\' ? ("000000"+pharmaReceptionLine.expirationDate).slice(-6) : \'\'}} </span><input ng-show="pharmaReceptionLine.editMode!=\'\' && pharmaReceptionLine.editMode" type="text" class="form-control input-sm text-center" id="expirationDate" name="expirationDate" ng-model="pharmaReceptionLine.expirationDate" size="6" maxlength="6" placeholder="{{\'pharmaPortalApp.pharmaReception.table.expirationDate\' | translate}}" ng-blur="vm.save()"></td><!-- Qtd(rec) --><td class="form-group" ng-class="{ \'text-danger\': pharmaReceptionLine.receivedQuantity != pharmaReceptionLine.invoicedQuantity + pharmaReceptionLine.bonusQuantity, \'has-error has-feedback\': pharmaReceptionLine.errorOnReceivedQuantity}"><span class="form-control input-sm text-center" ng-show="pharmaReceptionLine.editMode===\'\' || !pharmaReceptionLine.editMode">{{pharmaReceptionLine.receivedQuantity}} </span><input ng-show="pharmaReceptionLine.editMode!=\'\' && pharmaReceptionLine.editMode" type="number" class="form-control input-sm text-center" ng-class="{ \'alert-danger\': pharmaReceptionLine.receivedQuantity != pharmaReceptionLine.invoicedQuantity + pharmaReceptionLine.bonusQuantity}" id="receivedQuantity" name="receivedQuantity" step="0.001" ng-model="pharmaReceptionLine.receivedQuantity" placeholder="{{\'pharmaPortalApp.pharmaReception.table.receivedQuantity\' | translate}}" ng-init="pharmaReceptionLine.errorOnReceivedQuantity = (pharmaReceptionLine.receivedQuantity < 0 ? true : false); pharmaReceptionLine.oldReceivedQuantity = pharmaReceptionLine.receivedQuantity;" ng-blur="vm.onBlurFromReceivedQuantity(pharmaReceptionLine)"> <i class="fa fa-remove form-control-feedback"></i></td><!-- Quality --><td class="form-group"><span ng-show="pharmaReceptionLine.editMode===\'\' || !pharmaReceptionLine.editMode">{{pharmaReceptionLine.qualityStatus}}</span><ui-select ng-show="pharmaReceptionLine.editMode!=\'\' && pharmaReceptionLine.editMode" class="" id="qualityStatus" name="qualityStatus" ng-required="true" ng-model="pharmaReceptionLine.qualityStatus" ng-disabled="vm.isSaving" on-select="vm.save()"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaReception.table.qualityStatus\' | translate}}">{{$select.selected.code != \'\' ? $select.selected.code + \' - \' + $select.selected.description : \'&nbsp;\'}}</ui-select-match><ui-select-choices repeat="qualityStatus.code as qualityStatus in (vm.qualityStatuses | filter: $select.search)"><span ng-bind-html="qualityStatus.code != \'\' ? qualityStatus.code + \' - \' + qualityStatus.description : \'&nbsp;\' | highlight: $select.search"></span></ui-select-choices></ui-select></td><!-- Qtd (cob) --><td class="form-group" ng-class="{ \'has-error has-feedback\': pharmaReceptionLine.errorOnInvoicedQuantity}"><input type="number" class="form-control input-sm text-center" ng-class="{ \'alert-danger\': pharmaReceptionLine.receivedQuantity != pharmaReceptionLine.invoicedQuantity + pharmaReceptionLine.bonusQuantity}" id="invoicedQuantity" name="invoicedQuantity" step="0.001" ng-model="pharmaReceptionLine.invoicedQuantity" placeholder="{{\'pharmaPortalApp.pharmaReception.table.invoicedQuantity\' | translate}}" ng-init="pharmaReceptionLine.errorOnInvoicedQuantity = (pharmaReceptionLine.invoicedQuantity < 0 ? true : false)" ng-blur="vm.onBlurFromInvoicedQuantity(pharmaReceptionLine)"> <i class="fa fa-remove form-control-feedback"></i></td><!-- Bonus --><td class="form-group" ng-class="{ \'has-error has-feedback\': pharmaReceptionLine.errorOnBonusQuantity}"><input type="number" class="form-control input-sm text-center" ng-class="{ \'alert-danger\': pharmaReceptionLine.receivedQuantity != pharmaReceptionLine.invoicedQuantity + pharmaReceptionLine.bonusQuantity}" id="field_bonusQuantity" name="bonusQuantity" step="0.001" ng-model="pharmaReceptionLine.bonusQuantity" placeholder="{{\'pharmaPortalApp.pharmaReception.table.bonusQuantity\' | translate}}" ng-init="pharmaReceptionLine.errorOnBonusQuantity = (pharmaReceptionLine.bonusQuantity < 0 ? true : false)" ng-blur="vm.onBlurFromBonusQuantity(pharmaReceptionLine)"> <i class="fa fa-remove form-control-feedback"></i></td><td><input type="text" class="form-control input-sm text-center" id="field_unitPrice" name="unitPrice" ng-model="pharmaReceptionLine.unitPrice" placeholder="{{\'pharmaPortalApp.pharmaReception.table.unitPrice\' | translate}}" ng-blur="vm.save()" price></td><td><input type="number" class="form-control input-sm text-center" id="field_discount1" name="discount1" step="0.01" ng-model="pharmaReceptionLine.discount1" placeholder="{{\'pharmaPortalApp.pharmaReception.table.discount1\' | translate}}" ng-blur="vm.save()"></td><td><input type="number" class="form-control input-sm text-center" id="field_discount2" name="discount2" step="0.01" ng-model="pharmaReceptionLine.discount2" placeholder="{{\'pharmaPortalApp.pharmaReception.table.discount2\' | translate}}" ng-blur="vm.save()"></td><td class="text-center"><div class="btn-group"><button class="btn btn-primary btn-xs" ng-class="{ \'active\': pharmaReceptionLine.editMode!=\'\' && pharmaReceptionLine.editMode}" title="{{\'entity.action.edit\' | translate}}" ng-click="vm.togglePharmaReceptionLineEditMode(pharmaReceptionLine)"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}" ui-sref="pharma-reception-line.delete({parentId: vm.pharmaReception.id, lineId: pharmaReceptionLine.id})"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody><tfoot><tr><th colspan="5"></th><th class="text-center" style="border-top: 1px solid #aaa"><strong>{{vm.totalizer.receivedQuantity}}</strong></th><th colspan="1"></th><th colspan="2" class="text-center" style="border-top: 1px solid #aaa"><strong>{{vm.totalizer.invoicedPlusBonusQuantity}}</strong></th><th colspan="4"></th></tr></tfoot></table></fieldset></div><div class="row"><div class="col-md-6" ng-if="vm.portalSettings.exportPurchaseInvoice"><blockquote><h4 data-translate="pharmaPortalApp.pharmaReception.services">Services</h4><table class="jh-table table table-condensed table-border panel" table-hover-highlight><thead><tr><th><span data-translate="pharmaPortalApp.pharmaReception.table.code">Code</span></th><th><span data-translate="pharmaPortalApp.pharmaReception.table.description">Description</span></th><th><span data-translate="pharmaPortalApp.pharmaReception.table.vatRate">VAT Rate</span></th><th><span data-translate="pharmaPortalApp.pharmaReception.table.lineNetPrice">Line Net Price</span></th><th data-translate="table.actions">Actions</th></tr></thead><tr ng-repeat="pharmaReceptionLine in vm.pharmaReception.pharmaReceptionLines | filter : { serviceLine : true } | orderBy:predicate:reverse"><td class="table-left">{{pharmaReceptionLine.cnp}}</td><td class="table-left">{{pharmaReceptionLine.description}}</td><td class="table-right">{{pharmaReceptionLine.vatRate | currency : \'%\' : 0}}</td><td><input type="text" class="form-control input-sm text-center" id="unitPrice" name="unitPrice" ng-model="pharmaReceptionLine.unitPrice" placeholder="{{\'pharmaPortalApp.pharmaReception.table.unitPrice\' | translate}}" ng-blur="vm.save()" price></td><td class="text-center"><div class="btn-group"><button class="btn btn-primary btn-xs" ng-class="{ \'active\': pharmaReceptionLine.editMode!=\'\' && pharmaReceptionLine.editMode}" title="{{\'entity.action.edit\' | translate}}" ng-click="vm.togglePharmaReceptionLineEditMode(pharmaReceptionLine)"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}" ui-sref="pharma-reception-line.delete({parentId: vm.pharmaReception.id, lineId: pharmaReceptionLine.id})"><i class="fa fa-trash-o"></i></button></div></td></tr></table></blockquote></div><div class="col-md-6"><blockquote><h4 data-translate="pharmaPortalApp.pharmaReception.totals">Totals</h4><table class="jh-table table table-condensed table-border panel" table-hover-highlight><thead><tr><th></th><th><span data-translate="pharmaPortalApp.pharmaReception.total.incidenceBase">Incidence Base</span></th><th><span data-translate="pharmaPortalApp.pharmaReception.total.discount">Discount</span></th><th><span data-translate="pharmaPortalApp.pharmaReception.total.vatValue">VAT Value</span></th><th><span data-translate="pharmaPortalApp.pharmaReception.total.total">Total</span></th></tr></thead><tr ng-repeat="vatRateTotalizer in vm.totalizer.vatTable | orderBy:sorterFunc"><td>{{vatRateTotalizer.vatRate | currency : \'%\' : 0}}</td><td class="table-right">{{vatRateTotalizer.incidenceBase | currency }}</td><td class="table-right">{{vatRateTotalizer.discount | currency }}</td><td class="table-right">{{vatRateTotalizer.vatValue | currency }}</td><td class="table-right">{{vatRateTotalizer.total | currency }}</td></tr><tr class="active"><td>{{\'pharmaPortalApp.pharmaReception.total.total\' | translate | uppercase}}</td><td class="table-right">{{vm.totalizer.incidenceBase | currency }}</td><td class="table-right">{{vm.totalizer.discount | currency }}</td><td class="table-right">{{vm.totalizer.vatValue | currency }}</td><td class="table-right">{{vm.totalizer.total | currency }}</td></tr></table></blockquote></div><div ng-class="{\'col-md-offset-6 col-md-6\' : vm.portalSettings.exportPurchaseInvoice, \'col-md-6\' : !vm.portalSettings.exportPurchaseInvoice }" ng-show="vm.totalizer.differences != 0"><div class="text-center text-danger well" style="vertical-align: bottom"><strong>{{\'pharmaPortalApp.pharmaReception.total.differences\' | translate}}: {{vm.totalizer.differences | currency}}</strong></div></div></div></div><div class="panel-footer"><div class="row"><div class="col-md-8"><form class="form-inline" id="importTemplateForm" name="importTemplateForm" style="display: inline"><fieldset ng-disabled="vm.pharmaReception.status === \'SUBMITTED\'"><div class="form-group"><input type="file" class="file" ngf-select ng-model="vm.pharmaReception.file" name="file" ngf-pattern="\'.xls,.csv,.xlsx\'" accept=".xls,.csv,.xlsx" ngf-max-size="20MB" required ngf-model-invalid="errorFile" ng-disabled="vm.working"><div class="input-group input-group-sm"><span class="input-group-btn"><button class="browse btn btn-primary" type="button"><i class="fa fa-search"></i>&nbsp;<span translate="global.form.file">File</span></button> </span><input type="text" name="file" class="form-control" disabled="disabled"></div></div><script>$(\'.browse\').on(\'click\', function (event) {\n                                    var file = $(this).parent().parent().parent().find(\'.file\');\n                                    file.trigger(\'click\');\n                                });\n                                $(\'.file\').on(\'change\', function (event) {\n                                    $(this).parent().find(\'.form-control\').val($(this).val().replace(/C:\\\\fakepath\\\\/i, \'\'));\n                                });</script><div class="form-group"><a class="btn btn-info btn-sm" ng-click="importTemplateForm.$valid && !vm.working && vm.uploadFile(vm.pharmaReception.file)" ng-disabled="!importTemplateForm.$valid || vm.working"><i class="fa fa-upload"></i>&nbsp;<span data-translate="entity.action.upload">Upload</span></a></div><a ng-click="vm.getTemplate()" class="btn btn-info btn-sm" style="margin-left: 15px"><i class="fa fa-download"></i>&nbsp;<span data-translate="entity.action.downloadTemplate">Download template</span></a></fieldset></form></div><div class="col-md-4"><div class="text-right"><button type="submit" ng-click="vm.backToReceptions()" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button><div class="btn-group dropup" uib-dropdown ng-show="vm.portalSettings.exportLogitoolsFile"><button type="button" class="btn btn-warning btn-sm dropdown-toggle" uib-dropdown-toggle><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span>&nbsp;<span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu><li><a ng-click="vm.exportToExcel()"><i class="fa fa-th-list"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaReception.form.exportScreen">Screen info</span></a></li><li><a ng-click="vm.exportToLogitoolsExcel()"><i class="fa fa-map-signs"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaReception.form.exportLogitoolsFile">Logitools file</span></a></li></ul></div><button type="submit" ng-click="vm.exportToExcel()" class="btn btn-warning btn-sm" ng-hide="vm.portalSettings.exportLogitoolsFile"><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span></button> <button type="submit" ng-click="vm.submitPharmaReception()" class="btn btn-success btn-sm"><any ng-if="vm.pharmaReception.status === \'SUBMITTED\'"><i class="fa fa-cloud-upload"></i>&nbsp;<span data-translate="entity.action.comunicateInvoice">Comunicate invoice</span></any><any ng-if="vm.pharmaReception.status != \'SUBMITTED\'"><i class="fa fa-cloud-upload"></i>&nbsp;<span data-translate="entity.action.comunicateNote">Comunicate note</span></any></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/pharma-reception/pharma-reception-line-delete-dialog.html','<form name="deleteReceptionLineForm" ng-submit="vm.confirmPharmaReceptionLineDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaReception.deleteDialog.title">Confirm Reception Header</h4></div><div class="modal-body"><p><span class="modal-title" data-translate="pharmaPortalApp.pharmaReception.deleteLineDialog.body">Confirm Reception Line delete?</span></p><p><span data-translate="pharmaPortalApp.pharmaReception.form.cnp">CNP</span>: {{vm.pharmaReceptionLine.cnp}}</p><p><span data-translate="pharmaPortalApp.pharmaReception.form.description">Description</span>: {{vm.pharmaReceptionLine.description}}</p><p><span data-translate="pharmaPortalApp.pharmaReception.form.lot">Lot</span>: {{vm.pharmaReceptionLine.lot}}</p><p><span data-translate="pharmaPortalApp.pharmaReception.form.expirationDate">Expiration Date</span>: {{vm.pharmaReceptionLine.expirationDate}}</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger btn-sm" autofocus><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pharma-reception/pharma-reception-line-new-dialog.html','<div ng-form="dialogForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaReception.createPharmaReceptionLineDialog.title">Create Pharma Reception Line</h4></div><any ng-switch="vm.portalSettings.exportPurchaseInvoice" ng-cloak><any ng-switch-when="false"><div class="modal-body form-horizontal"><div class="container-fluid" ng-form="createProductLineForm"><div class="col-md-12">&nbsp;</div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.product.$invalid && createProductLineForm.product.$dirty }"><label for="filterProduct_div" class="col-md-4 control-label input-sm label-required" data-translate="pharmaPortalApp.pharmaReception.line.form.product">Product</label><div class="form-group-sm col-md-8" id="filterProduct_div"><ui-select id="filterProduct" ng-model="vm.pharmaReceptionLine.product" reset-search-input="false" fix-selected-item uis-open-close="onOpenClose(isOpen)" class="manualHighlight" required><ui-select-match placeholder="{{\'global.form.search.placeholder.product\' | translate}}">{{$select.selected.cnp}} - {{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="product as product in vm.products track by product.cnp" refresh="refreshSelectModel($select.search)" refresh-delay="500" minimum-input-length="3"><span ng-bind-html="product.cnp +\' - \'+ product.fullHtmlName"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.lot.$invalid && createProductLineForm.lot.$dirty }"><label for="lot" class="col-md-4 control-label input-sm label-required"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.lot\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.lot\' | translate}}</label><div class="form-group col-md-8"><input type="text" class="form-control input-sm" id="lot" name="lot" size="15" maxlength="15" ng-model="vm.pharmaReceptionLine.lot" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.lot\' | translate}}" required ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.expirationDate.$invalid && createProductLineForm.expirationDate.$dirty }"><label for="expirationDate" class="col-md-4 control-label input-sm" data-translate="pharmaPortalApp.pharmaReception.line.form.expirationDate">Expiration Date</label><div class="form-group col-md-8"><input type="text" class="form-control input-sm" id="expirationDate" name="expirationDate" size="6" maxlength="6" ng-model="vm.pharmaReceptionLine.expirationDate" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.expirationDate\' | translate}} (mmaaaa)" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.receivedQuantity.$invalid && createProductLineForm.receivedQuantity.$dirty }"><label for="receivedQuantity" class="col-md-4 control-label input-sm label-required"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.receivedQuantity\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.receivedQuantity\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="receivedQuantity" name="receivedQuantity" min="0" step="0.001" ng-model="vm.pharmaReceptionLine.receivedQuantity" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.receivedQuantity\' | translate}}" required ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.qualityStatus.$invalid && createProductLineForm.qualityStatus.$dirty }"><label for="qualityStatus_div" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.qualityStatus\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.qualityStatus\' | translate}}</label><div class="form-group-sm col-md-8" id="qualityStatus_div"><ui-select class="" id="qualityStatus" name="qualityStatus" ng-model="vm.pharmaReceptionLine.qualityStatus" ng-disabled="vm.isSaving"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaReception.form.qualityStatus\' | translate}}">{{$select.selected.code != \'\' ? $select.selected.code + \' - \' + $select.selected.description : \'&nbsp;\'}}</ui-select-match><ui-select-choices repeat="qualityStatus.code as qualityStatus in (vm.qualityStatuses | filter: $select.search)"><span ng-bind-html="qualityStatus.code != \'\' ? qualityStatus.code + \' - \' + qualityStatus.description : \'&nbsp;\' | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.invoicedQuantity.$invalid && createProductLineForm.invoicedQuantity.$dirty }"><label for="invoicedQuantity" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.invoicedQuantity\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.invoicedQuantity\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="invoicedQuantity" name="invoicedQuantity" min="0" step="0.001" ng-model="vm.pharmaReceptionLine.invoicedQuantity" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.invoicedQuantity\' | translate}}" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.bonusQuantity.$invalid && createProductLineForm.bonusQuantity.$dirty }"><label for="bonusQuantity" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.bonusQuantity\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.bonusQuantity\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="bonusQuantity" name="bonusQuantity" min="0" step="0.001" ng-model="vm.pharmaReceptionLine.bonusQuantity" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.bonusQuantity\' | translate}}" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.unitPrice.$invalid && createProductLineForm.unitPrice.$dirty }"><label for="unitPrice" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.unitPrice\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.unitPrice\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="unitPrice" name="unitPrice" step="0.001" ng-model="vm.pharmaReceptionLine.unitPrice" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.unitPrice\' | translate}}" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.discount1.$invalid && createProductLineForm.discount1.$dirty }"><label for="discount1" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.discount1\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.discount1\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="discount1" name="discount1" step="0.01" ng-model="vm.pharmaReceptionLine.discount1" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.discount1\' | translate}}" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.discount2.$invalid && createProductLineForm.discount2.$dirty }"><label for="discount2" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.discount2\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.discount2\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="discount2" name="discount2" step="0.01" ng-model="vm.pharmaReceptionLine.discount2" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.discount2\' | translate}}" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div><span class="help-block text-right" style="margin-right: 20px"><span style="color: red">*</span> - {{\'pharmaPortalApp.pharmaReception.line.form.mandatoryHelp\' | translate}}</span></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button ng-click="vm.createPharmaReceptionLine()" class="btn btn-success btn-sm" ng-disabled="!dialogForm.createProductLineForm.$valid || vm.isSaving"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></any><any ng-switch-when="true"><div class="modal-body form-horizontal"><uib-tabset active="vm.activeTab"><uib-tab index="0" disable="vm.pharmaReception.status === \'SUBMITTED\'"><uib-tab-heading><i class="fa fa-shopping-basket"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaReception.line.tab.products">Products</span></uib-tab-heading><div class="container-fluid" ng-form="createProductLineForm"><div class="col-md-12">&nbsp;</div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.product.$invalid && createProductLineForm.product.$dirty }"><label for="filterProduct2_div" class="col-md-4 control-label input-sm label-required" data-translate="pharmaPortalApp.pharmaReception.line.form.product">Product</label><div class="form-group-sm col-md-8" id="filterProduct2_div"><ui-select id="filterProduct2" ng-model="vm.pharmaReceptionLine.product" reset-search-input="false" fix-selected-item uis-open-close="onOpenClose(isOpen)" class="manualHighlight" required><ui-select-match placeholder="{{\'global.form.search.placeholder.product\' | translate}}">{{$select.selected.cnp}} - {{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="product as product in (vm.products | filter: $select.search) track by product.cnp" refresh="refreshSelectModel($select.search)" refresh-delay="500" minimum-input-length="3"><span ng-bind-html="product.cnp +\' - \'+ product.fullHtmlName | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.lot.$invalid && createProductLineForm.lot.$dirty }"><label for="lot2" class="col-md-4 control-label input-sm label-required"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.lot\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.lot\' | translate}}</label><div class="form-group col-md-8"><input type="text" class="form-control input-sm" id="lot2" name="lot" size="15" maxlength="15" ng-model="vm.pharmaReceptionLine.lot" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.lot\' | translate}}" required ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.expirationDate.$invalid && createProductLineForm.expirationDate.$dirty }"><label for="expirationDate2" class="col-md-4 control-label input-sm" data-translate="pharmaPortalApp.pharmaReception.line.form.expirationDate">Expiration Date</label><div class="form-group col-md-8"><input type="text" class="form-control input-sm" id="expirationDate2" name="expirationDate" size="6" maxlength="6" ng-model="vm.pharmaReceptionLine.expirationDate" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.expirationDate\' | translate}} (mmaaaa)" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.receivedQuantity.$invalid && createProductLineForm.receivedQuantity.$dirty }"><label for="receivedQuantity2" class="col-md-4 control-label input-sm label-required"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.receivedQuantity\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.receivedQuantity\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="receivedQuantity2" name="receivedQuantity" min="0" step="0.001" ng-model="vm.pharmaReceptionLine.receivedQuantity" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.receivedQuantity\' | translate}}" required ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.qualityStatus.$invalid && createProductLineForm.qualityStatus.$dirty }"><label for="qualityStatus2_div" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.qualityStatus\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.qualityStatus\' | translate}}</label><div class="form-group-sm col-md-8" id="qualityStatus2_div"><ui-select class="" id="qualityStatus2" name="qualityStatus" ng-model="vm.pharmaReceptionLine.qualityStatus" ng-disabled="vm.isSaving"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaReception.form.qualityStatus\' | translate}}">{{$select.selected.code != \'\' ? $select.selected.code + \' - \' + $select.selected.description : \'&nbsp;\'}}</ui-select-match><ui-select-choices repeat="qualityStatus.code as qualityStatus in (vm.qualityStatuses | filter: $select.search)"><span ng-bind-html="qualityStatus.code != \'\' ? qualityStatus.code + \' - \' + qualityStatus.description : \'&nbsp;\' | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.invoicedQuantity.$invalid && createProductLineForm.invoicedQuantity.$dirty }"><label for="invoicedQuantity2" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.invoicedQuantity\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.invoicedQuantity\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="invoicedQuantity2" name="invoicedQuantity" min="0" step="0.001" ng-model="vm.pharmaReceptionLine.invoicedQuantity" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.invoicedQuantity\' | translate}}" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.bonusQuantity.$invalid && createProductLineForm.bonusQuantity.$dirty }"><label for="bonusQuantity2" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.bonusQuantity\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.bonusQuantity\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="bonusQuantity2" name="bonusQuantity" min="0" step="0.001" ng-model="vm.pharmaReceptionLine.bonusQuantity" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.bonusQuantity\' | translate}}" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.unitPrice.$invalid && createProductLineForm.unitPrice.$dirty }"><label for="unitPrice2" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.unitPrice\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.unitPrice\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="unitPrice2" name="unitPrice" step="0.001" ng-model="vm.pharmaReceptionLine.unitPrice" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.unitPrice\' | translate}}" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.discount1.$invalid && createProductLineForm.discount1.$dirty }"><label for="discount11" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.discount1\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.discount1\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="discount11" name="discount1" step="0.01" ng-model="vm.pharmaReceptionLine.discount1" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.discount1\' | translate}}" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createProductLineForm.discount2.$invalid && createProductLineForm.discount2.$dirty }"><label for="discount22" class="col-md-4 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaReception.line.form.hint.discount2\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaReception.line.form.discount2\' | translate}}</label><div class="form-group col-md-8"><input type="number" class="form-control input-sm" id="discount22" name="discount2" step="0.01" ng-model="vm.pharmaReceptionLine.discount2" placeholder="{{\'pharmaPortalApp.pharmaReception.line.form.discount2\' | translate}}" ng-disabled="vm.isSaving"></div></div></div><div class="row"><div><span class="help-block text-right" style="margin-right: 20px"><span style="color: red">*</span> - {{\'pharmaPortalApp.pharmaReception.line.form.mandatoryHelp\' | translate}}</span></div></div></div></uib-tab><uib-tab index="1"><uib-tab-heading><i class="fa fa-handshake-o"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaReception.line.tab.services">Services</span></uib-tab-heading><div class="container-fluid" ng-form="createServiceLineForm"><div class="col-md-12">&nbsp;</div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createServiceLineForm.serviceType.$invalid && createServiceLineForm.serviceType.$dirty }"><label for="serviceType_div" class="col-md-4 control-label input-sm label-required" data-translate="pharmaPortalApp.pharmaReception.line.form.serviceType">Service Type</label><div class="form-group-sm col-md-8" id="serviceType_div"><ui-select id="serviceType" ng-model="vm.pharmaReceptionLine.serviceType" uis-open-close="onOpenClose(isOpen)" required><ui-select-match>{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="serviceType in (vm.serviceTypes | filter: $select.search) track by $index"><span ng-bind-html="serviceType.code +\' - \'+ serviceType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createServiceLineForm.vatRate.$invalid && createServiceLineForm.vatRate.$dirty }"><label for="vatRate" class="col-md-4 control-label input-sm label-required" data-translate="pharmaPortalApp.pharmaReception.line.form.vatRate">Vat Rate</label><div class="form-group col-md-4"><div class="input-group"><input type="text" class="form-control input-sm" id="vatRate" name="vatRate" ng-model="vm.pharmaReceptionLine.serviceType.vatRate" ng-disabled="true"> <span class="input-group-addon" style="width: 40px">%</span></div></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createServiceLineForm.lineNetPrice.$invalid && createServiceLineForm.lineNetPrice.$dirty }"><label for="lineNetPrice" class="col-md-4 control-label input-sm label-required" data-translate="pharmaPortalApp.pharmaReception.line.form.lineNetPrice">Line Net Price</label><div class="form-group col-md-4"><div class="input-group"><input type="number" class="form-control input-sm" id="lineNetPrice" name="lineNetPrice" min="0" step=".01" ng-model="vm.pharmaReceptionLine.lineNetPrice" required ng-disabled="vm.isSaving"> <span class="input-group-addon" style="width: 40px">&euro;</span></div></div></div></div><div class="row"><div><span class="help-block text-right" style="margin-right: 20px"><span style="color: red">*</span> - {{\'pharmaPortalApp.pharmaReception.line.form.mandatoryHelp\' | translate}}</span></div></div></div></uib-tab></uib-tabset></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button ng-show="vm.activeTab == 0" ng-click="vm.createPharmaReceptionLine()" class="btn btn-success btn-sm" ng-disabled="!dialogForm.createProductLineForm.$valid || vm.isSaving"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button> <button ng-show="vm.activeTab == 1" ng-click="vm.createPharmaReceptionServiceLine()" class="btn btn-success btn-sm" ng-disabled="!dialogForm.createServiceLineForm.$valid || vm.isSaving"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></any></any></div>');
$templateCache.put('app/entities/pharma-reception/pharma-reception-line.html','<div></div>');
$templateCache.put('app/entities/pharma-reception/pharma-reception-new.html','<div><form class="container-fluid well well-sm" ng-submit="vm.save()" id="receptionForm" name="receptionForm"><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaReception.new.title">Pharma Reception</span> <span class="clearfix"></span></div><div class="panel-body"><div class="row"><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': receptionForm.receptionDate.$invalid && receptionForm.receptionDate.$dirty }"><label for="receptionDate" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaReception.form.receptionDate">Reception Date</label><div class="col-md-7"><div class="input-group input-group-sm"><input type="text" class="form-control" ng-click="vm.openDatePopup()" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.pharmaReception.date" is-open="vm.datePopup.opened" datepicker-options="vm.dateOptions" placeholder="{{\'pharmaPortalApp.pharmaReception.form.receptionDate\' | translate}}" ng-disabled="vm.working" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="form-group-sm col-md-5" ng-class="{ \'has-error\': receptionForm.warehouse.$invalid && receptionForm.warehouse.$dirty }"><label for="warehouse" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.form.warehouse">Warehouse</label><div class="col-md-8"><ui-select class="" id="warehouse" name="warehouse" ng-required="true" ng-model="vm.pharmaReception.warehouse" ng-disabled="vm.working" on-select="vm.checkCompanyWar($item, $model)"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaReception.form.warehouse\' | translate}}">{{$select.selected.code + \' - \' + $select.selected.description}}</ui-select-match><ui-select-choices repeat="warehouse.code as warehouse in (vm.warehouses | filter: $select.search)"><span ng-bind-html="warehouse.code + \' - \' + warehouse.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group-sm col-md-4" ng-class="{ \'has-error\': receptionForm.supplier.$invalid && receptionForm.supplier.$dirty }"><label for="supplier" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.form.supplier">Supplier</label><div class="col-md-8"><ui-select class="" id="supplier" name="supplier" ng-required="true" ng-model="vm.pharmaReception.supplier" ng-disabled="vm.working" on-select="vm.checkCompanySup($item, $model)"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaReception.form.supplier\' | translate}}">{{$select.selected.code + \' - \' + $select.selected.description}}</ui-select-match><ui-select-choices repeat="supplier.code as supplier in (vm.suppliers | filter: $select.search)"><span ng-bind-html="supplier.code + \' - \' + supplier.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row">&nbsp;</div><div class="row"><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': receptionForm.supplierDocument.$invalid && receptionForm.supplierDocument.$dirty }"><label for="supplierDocument" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaReception.form.supplierDocument">Supplier Document</label><div class="col-md-7"><input type="text" class="form-control" id="supplierDocument" name="supplierDocument" size="12" maxlength="12" ng-model="vm.pharmaReception.supplierDocument" placeholder="{{\'pharmaPortalApp.pharmaReception.form.supplierDocument\' | translate}}" required ng-disabled="vm.working"></div></div><div class="form-group-sm col-md-5" ng-class="{ \'has-error\': receptionForm.orderType.$invalid && receptionForm.orderType.$dirty }"><label for="orderType" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.form.orderType">Order Type</label><div class="col-md-8"><ui-select class="" id="orderType" name="orderType" ng-required="true" ng-model="vm.pharmaReception.orderType" ng-disabled="vm.working"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaReception.form.orderType\' | translate}}">{{$select.selected.type + \' - \' + $select.selected.name}}</ui-select-match><ui-select-choices repeat="orderType.type as orderType in (vm.orderTypes | filter: $select.search)"><span ng-bind-html="orderType.type + \' - \' + orderType.name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="panel-footer"><div class="text-right"><button type="button" ui-sref="pharma-reception" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="submit" ng-click="vm.save()" class="btn btn-success btn-sm" ng-disabled="!receptionForm.$valid || vm.isSaving"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></div></form></div>');
$templateCache.put('app/entities/pharma-reception/pharma-reception-new.inactive-dialog.html','<form name="confirmFullSearchForm" ng-submit="vm.confirmAddProducts()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><b>Aviso</b> - {{message.company}}</h4></div><div class="modal-body" id="modal-body"><any ng-switch="message.type"><any ng-switch-when="1"><p><b>Ponto de entrega deste cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate}}, {{message.regTime}}</p></any><any ng-switch-when="2"><p><b>Cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate | date : format : shortDate}}, {{message.regTime | date : \'hh:mm:ss\'}}</p></any></any></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/pharma-reception/pharma-reception-submit-dialog.html','<div ng-show="vm.portalSettings.exportPurchaseInvoice"><form name="submitReceptionPurchaseInvoiceHeaderForm" ng-submit="vm.confirmReceptionPurchaseInvoiceSubmit()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaReception.submitDialog.title">Confirm Reception Header</h4></div><div class="modal-body"><p><span class="modal-title" data-translate="pharmaPortalApp.pharmaReception.form.invoice.body">To complete the submission process, fill in the requested information below</span></p><div class="row"><div class="form-group-sm col-md-12"><label for="receptionDefineNoteCreation" class="form-check-label col-md-6 control-label" ng-show="vm.portalSettings.receptionDefineNoteCreation"><span data-translate="pharmaPortalApp.pharmaReception.submitDialog.createReceptionNote">Create Reception Note</span> <input type="checkbox" class="form-check-input" name="receptionDefineNoteCreation" ng-model="vm.createReceptionNote"></label></div></div><div class="row"><div class="form-group-sm col-md-6" ng-class="{ \'has-error\': submitReceptionPurchaseInvoiceHeaderForm.invoiceDate.$invalid && submitReceptionPurchaseInvoiceHeaderForm.invoiceDate.$dirty }"><label for="invoiceDate" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.form.invoice.invoiceDate">Invoice date</label><div class="col-md-8"><div class="input-group input-group-sm"><input type="text" class="form-control" ng-click="vm.openDatePopup()" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.pharmaReception.pharmaReceptionInvoice.invoiceDate" is-open="vm.datePopup.opened" datepicker-options="vm.dateOptions" ng-blur="vm.save()" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="form-group-sm col-md-6" ng-class="{ \'has-error\': submitReceptionPurchaseInvoiceHeaderForm.invoicePurchaseType.$invalid && submitReceptionPurchaseInvoiceHeaderForm.invoicePurchaseType.$dirty }"><label for="invoicePurchaseType" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.form.invoice.invoicePurchaseType">Purchase Type</label><div class="col-md-8"><ui-select name="invoicePurchaseType" ng-required="true" ng-model="vm.pharmaReception.pharmaReceptionInvoice.invoicePurchaseType" on-select="saveInvoicePurchaseType($item, $model)"><ui-select-match>{{$select.selected.type + \' - \' + $select.selected.name}}</ui-select-match><ui-select-choices repeat="purchaseType.type as purchaseType in (vm.purchaseTypes | filter: $select.search)"><span ng-bind-html="purchaseType.type + \' - \' + purchaseType.name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row">&nbsp;</div><div class="row"><div class="form-group-sm col-md-6" ng-class="{ \'has-error\': submitReceptionPurchaseInvoiceHeaderForm.invoiceNumber.$invalid && submitReceptionPurchaseInvoiceHeaderForm.invoiceNumber.$dirty }"><label for="invoiceNumber" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.form.invoice.invoiceNumber">Invoice Number</label><div class="col-md-8"><input type="number" class="form-control" name="invoiceNumber" ng-model="vm.pharmaReception.pharmaReceptionInvoice.invoiceNumber" min="0" max="99999999" step="1" ng-blur="vm.save()" required></div></div><div class="form-group-sm col-md-6" ng-class="{ \'has-error\': submitReceptionPurchaseInvoiceHeaderForm.invoiceBroadReference.$invalid && submitReceptionPurchaseInvoiceHeaderForm.invoiceBroadReference.$dirty }"><label for="invoiceBroadReference" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.form.invoice.invoiceBroadReference">Broad Reference</label><div class="col-md-8"><input type="text" class="form-control" name="invoiceBroadReference" ng-model="vm.pharmaReception.pharmaReceptionInvoice.invoiceBroadReference" maxlength="15" ng-maxlength="15" ng-blur="vm.save()"></div></div></div><div class="row">&nbsp;</div><table class="jh-table table table-striped panel tableCell"><thead><tr><th><span data-translate="pharmaPortalApp.pharmaReception.table.vatRate">VAT Rate</span></th><th><span data-translate="pharmaPortalApp.pharmaReception.table.vatValue">Value of VAT</span></th><th><span data-translate="pharmaPortalApp.pharmaReception.table.productsValue">Value Products</span></th><th><span data-translate="pharmaPortalApp.pharmaReception.table.productsDiscount">Discount products</span></th><th><span data-translate="pharmaPortalApp.pharmaReception.table.servicesValue">Value services</span></th><th><span data-translate="pharmaPortalApp.pharmaReception.table.servicesDiscount">Discount services</span></th></tr></thead><tbody><tr ng-repeat="vatRateTotalizer in vm.pharmaReception.pharmaReceptionInvoice.pharmaReceptionVatLines | orderBy:sorterFunc"><td>{{vatRateTotalizer.vatRate | currency : \'%\' : 0}}</td><td ng-class="{ \'has-error\': submitReceptionPurchaseInvoiceHeaderForm[\'vatAmount_\' + $index].$invalid && submitReceptionPurchaseInvoiceHeaderForm[\'vatAmount_\' + $index].$dirty }"><input type="number" name="vatAmount_{{$index}}" class="form-control" ng-model="vatRateTotalizer.vatAmount" min="0" step="0.01" ng-blur="vm.save()" required></td><td ng-class="{ \'has-error\': submitReceptionPurchaseInvoiceHeaderForm[\'productsAmount_\' + $index].$invalid && submitReceptionPurchaseInvoiceHeaderForm[\'productsAmount_\' + $index].$dirty }"><input type="number" name="productsAmount_{{$index}}" class="form-control" ng-model="vatRateTotalizer.productsAmount" min="0" step="0.01" ng-blur="vm.save()" required></td><td ng-class="{ \'has-error\': vatRateTotalizer.productsAmount < vatRateTotalizer.discountProductsAmount || (submitReceptionPurchaseInvoiceHeaderForm[\'discountProductsAmount_\' + $index].$invalid && submitReceptionPurchaseInvoiceHeaderForm[\'discountProductsAmount_\' + $index].$dirty) }"><input type="number" name="discountProductsAmount_{{$index}}" class="form-control" ng-model="vatRateTotalizer.discountProductsAmount" min="0" step="0.01" ng-blur="vm.save()" required ng-disabled="!vatRateTotalizer.productsAmount"></td><td ng-class="{ \'has-error\': submitReceptionPurchaseInvoiceHeaderForm[\'servicesAmount_\' + $index].$invalid && submitReceptionPurchaseInvoiceHeaderForm[\'servicesAmount_\' + $index].$dirty }"><input type="number" name="servicesAmount_{{$index}}" class="form-control" ng-model="vatRateTotalizer.servicesAmount" min="0" step="0.01" ng-blur="vm.save()" required></td><td ng-class="{ \'has-error\': vatRateTotalizer.servicesAmount < vatRateTotalizer.discountServicesAmount || (submitReceptionPurchaseInvoiceHeaderForm[\'discountServicesAmount_\' + $index].$invalid && submitReceptionPurchaseInvoiceHeaderForm[\'discountServicesAmount_\' + $index].$dirty) }"><input type="number" name="discountServicesAmount_{{$index}}" class="form-control" ng-model="vatRateTotalizer.discountServicesAmount" min="0" step="0.01" ng-blur="vm.save()" required ng-disabled="!vatRateTotalizer.servicesAmount"></td></tr></tbody><tfoot><tr><td></td><td class="text-right" ng-class="{ \'has-error\': submitReceptionPurchaseInvoiceHeaderForm.invoiceAmount.$invalid && submitReceptionPurchaseInvoiceHeaderForm.invoiceAmount.$dirty }"><span data-translate="pharmaPortalApp.pharmaReception.table.invoiceAmount">Invoice Amount</span></td><td ng-class="{ \'has-error\': submitReceptionPurchaseInvoiceHeaderForm.invoiceAmount.$invalid && submitReceptionPurchaseInvoiceHeaderForm.invoiceAmount.$dirty }"><input type="number" name="invoiceAmount" class="form-control" ng-model="vm.pharmaReception.pharmaReceptionInvoice.invoiceAmount" step="0.01" ng-blur="vm.save()" required></td><td class="text-right" ng-class="{ \'has-error\': submitReceptionPurchaseInvoiceHeaderForm.paymentDiscount.$invalid && submitReceptionPurchaseInvoiceHeaderForm.paymentDiscount.$dirty }"><span data-translate="pharmaPortalApp.pharmaReception.table.paymentDiscount">Payment ready discount</span></td><td ng-class="{ \'has-error\': submitReceptionPurchaseInvoiceHeaderForm.paymentDiscount.$invalid && submitReceptionPurchaseInvoiceHeaderForm.paymentDiscount.$dirty }"><input type="number" name="paymentDiscount" class="form-control" ng-model="vm.pharmaReception.pharmaReceptionInvoice.paymentDiscount" step="0.01" ng-blur="vm.save()" required></td><td></td></tr></tfoot></table></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="!submitReceptionPurchaseInvoiceHeaderForm.$valid" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form></div><!-- ################################################## --><div ng-hide="vm.portalSettings.exportPurchaseInvoice"><form name="submitReceptionHeaderForm" ng-submit="vm.confirmPharmaReceptionSubmit()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaReception.submitDialog.title">Confirm Reception Header</h4></div><div class="modal-body"><p><span class="modal-title" data-translate="pharmaPortalApp.pharmaReception.submitDialog.body">Confirm Reception Header submit?</span></p><ul><li><span data-translate="pharmaPortalApp.pharmaReception.form.receptionDate">Reception Date</span>: {{vm.pharmaReception.date | date:\'dd/MM/yyyy\'}}</li><li><span data-translate="pharmaPortalApp.pharmaReception.form.warehouse">Warehouse</span>: {{vm.getWarehouseFullDescription()}}</li><li><span data-translate="pharmaPortalApp.pharmaReception.form.supplier">Supplier</span>: {{vm.getSupplierFullDescription()}}</li><li><span data-translate="pharmaPortalApp.pharmaReception.form.supplierDocument">SupplierDocument</span>: {{vm.pharmaReception.supplierDocument}}</li></ul><div ng-show="vm.totalizer.differences != 0"><p><span data-translate="pharmaPortalApp.pharmaReception.total.differences">Differences</span>: {{vm.totalizer.differences | currency}}</p></div><label for="receptionDefineNoteCreation" class="form-check-label" ng-show="vm.portalSettings.receptionDefineNoteCreation"><span data-translate="pharmaPortalApp.pharmaReception.submitDialog.createReceptionNote">Create Reception Note</span> <input type="checkbox" class="form-check-input" name="receptionDefineNoteCreation" ng-model="vm.createReceptionNote"></label></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form></div>');
$templateCache.put('app/entities/pharma-reception/pharma-reception-validate-vat-number-dialog.html','<form name="validateVatNumberForm" ng-submit="vm.validateVatNumber()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaReception.validateVatNumberDialog.title">Supplier VAT number validation</h4></div><div class="modal-body"><p><span class="modal-title" data-translate="pharmaPortalApp.pharmaReception.validateVatNumberDialog.body">To continue, enter the VAT number of the supplier referenced in this invoice"</span></p><div class="row"><div class="form-group-sm" ng-class="{ \'has-error\': validateVatNumberForm.vatNumber.$invalid && validateVatNumberForm.vatNumber.$dirty }"><label for="vatNumber" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaReception.validateVatNumberDialog.vatNumber">VAT Number</label><div class="col-md-8"><input type="number" class="form-control" name="vatNumber" ng-model="vm.vatNumber" min="0" max="999999999" step="1" required></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.proceed">Continue</span></button></div></form>');
$templateCache.put('app/entities/pharma-reception/pharma-reception.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaReception.home.title">Pharma Receptions</span> <button type="button" class="btn btn-warning btn-sm pull-right" ui-sref="pharma-reception.new"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaReception.action.newReception">New Reception</span></button> <span class="clearfix"></span></div><div class="panel-body"><blockquote ng-hide="vm.pharmaReceptionHeaders.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.pharmaReception.message.noOpenReceptions">No Open Receptions</blockquote><div class="table-responsive" ng-show="vm.pharmaReceptionHeaders.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.pharmaReceptionHeaders"><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="date"><span data-translate="pharmaPortalApp.pharmaReception.table.receptionDate">Reception Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="warehouse"><span data-translate="pharmaPortalApp.pharmaReception.table.warehouse">Warehouse</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="supplier"><span data-translate="pharmaPortalApp.pharmaReception.table.supplier">Supplier</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="supplierDocument"><span data-translate="pharmaPortalApp.pharmaReception.table.supplierDocument">Supplier Document</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="orderType"><span data-translate="pharmaPortalApp.pharmaReception.table.orderType">Order Type</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="username"><span data-translate="pharmaPortalApp.pharmaReception.table.username">Username</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="status"><span data-translate="pharmaPortalApp.pharmaReception.table.status">Status</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="pharmaReceptionHeader in vm.pharmaReceptionHeaders | filter:filter | orderBy:predicate:reverse"><td>{{pharmaReceptionHeader.date | date:\'dd/MM/yyyy\'}}</td><td class="table-left">{{vm.getWarehouseFullDescription(pharmaReceptionHeader.warehouse)}}</td><td class="table-left">{{vm.getSupplierFullDescription(pharmaReceptionHeader.supplier)}}</td><td class="table-left">{{pharmaReceptionHeader.supplierDocument}}</td><td class="table-left">{{vm.getOrderTypeFullDescription(pharmaReceptionHeader.orderType)}}</td><td class="table-left">{{pharmaReceptionHeader.username}}</td><td class="table-left">{{\'pharmaPortalApp.pharmaReception.pharmaReceptionStatus.\'+pharmaReceptionHeader.status | translate}}</td><td><div class="btn-group"><button class="btn btn-primary btn-xs" title="{{\'entity.action.edit\' | translate}}" ui-sref="pharma-reception-detail({id:pharmaReceptionHeader.id})"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}" ui-sref="pharma-reception.delete({id:pharmaReceptionHeader.id})"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/pharma-return/pharma-return.inactive-dialog.html','<form name="confirmFullSearchForm" ng-submit="vm.confirmAddProducts()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><b>Aviso</b> - {{message.company}}</h4></div><div class="modal-body" id="modal-body"><any ng-switch="message.type"><any ng-switch-when="1"><p><b>Ponto de entrega deste cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate}}, {{message.regTime}}</p></any><any ng-switch-when="2"><p><b>Cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate | date : format : shortDate}}, {{message.regTime | date : \'hh:mm:ss\'}}</p></any></any></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/pharma-return/pharma-returns.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><div class="panel-title col-sm-6 pull-left no-padding"><span class="pull-left" data-translate="pharmaPortalApp.pharmaReturn.home.newReturn">New return</span><div class="col-sm-8 pull-left"><div has-any-authority="ROLE_ADMIN,ROLE_SUPER_ADMIN,ROLE_PHARMA_ADMIN"><ui-select name="company" ng-model="vm.currentCompany" on-select="vm.updateCompany($item, $model)"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaReturn.placeholder.company\' | translate}}" allow-clear="true">{{$select.selected.namingForOptions}}</ui-select-match><ui-select-choices repeat="company as company in vm.companies | filter: $select.search | orderBy:\'naming\'"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="btn-group pull-right"><button class="btn btn-danger btn-sm" ui-sref="pharma-return.clearReturn()" ng-disabled="isOrderEmpty()"><i class="fa fa-recycle"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaReturn.home.clearReturn">Clear return</span></button></div><span class="clearfix"></span></div><div class="panel-body"><div ng-hide="vm.currentCompany"><div class="jumbotron text-center"><h4><i class="fa fa-building fa-3x"></i>&nbsp;&nbsp;&nbsp;Por favor escolha o cliente a partir do qual pretende efetuar a devolu\xE7\xE3o</h4></div></div><div ng-show="vm.currentCompany"><form id="returnProductForm" name="returnProductForm" class="form container-fluid well well-sm" ng-submit="vm.addProduct()"><div class="form-group form-group-sm col-md-4 col-sm-5"><ui-select id="filterProduct" ng-model="vm.products.selected" reset-search-input="false" fix-selected-item uis-open-close="onOpenClose(isOpen)" on-select="getPriceFromPolicy($item, $model, !vm.isTotalSet)" required><ui-select-match placeholder="{{\'global.form.search.placeholder.product\' | translate}}">{{$select.selected.cnp}} - {{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="product as product in vm.products track by product.cnp" refresh="refreshSelectModel($select.search)" refresh-delay="500" minimum-input-length="3"><span ng-bind-html="product.cnp +\' - \'+ product.fullHtmlName"></span></ui-select-choices></ui-select></div><div class="form-group col-md-2 col-sm-2"><div class="input-group input-group-sm"><input type="text" class="form-control" ng-model="vm.products.selected.qtd" ng-disabled="!vm.products.selected" placeholder="{{\'pharmaPortalApp.pharmaReturn.placeholder.quantity\' | translate}}" required> <span class="input-group-addon"><i class="fa fa-archive"></i></span></div></div><div class="form-group col-md-2 col-sm-2"><div class="input-group input-group-sm" ng-if="!vm.isTotalSet"><input id="falseInput" type="text" class="form-control" ng-class="{\'download\': vm.showAnimation }" ng-model="vm.products.selected.price" ng-disabled="!vm.products.selected || vm.validPolicyPrice || (vm.products.selected.price == 0 && !vm.portalSettings.manualReturnPriceIfNull)" placeholder="{{\'pharmaPortalApp.pharmaReturn.placeholder.unitPrice\' | translate}}" required price> <span class="input-group-addon"><i class="fa fa-eur"></i></span></div><div class="input-group input-group-sm" ng-if="vm.isTotalSet"><input ng-class="{\'download\': vm.showAnimation }" id="trueInput" type="text" class="form-control" ng-model="vm.products.selected.total" ng-disabled="!vm.products.selected" placeholder="{{\'pharmaPortalApp.pharmaReturn.placeholder.unitTotalPrice\' | translate}}" required price> <span class="input-group-addon"><i class="fa fa-eur"></i></span></div></div><div class="form-group col-md-1 col-sm-1"><button class="btn btn-success btn-sm" title="{{\'pharmaPortalApp.pharmaReturn.placeholder.addItem\' | translate}}" ng-disabled="returnProductForm.$invalid"><i class="fa fa-plus"></i></button></div><toggle ng-model="vm.isTotalSet" ng-change="vm.changeToggle()" on="{{  vm.getOnTranslation()}}" off="{{  vm.getOffTranslation()}}"></toggle></form><form name="returnForm" role="form"><div class="table-responsive"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="orderList"><thead><tr class="topHeader"><th><span data-translate="pharmaPortalApp.pharmaReturn.cnp">CNP</span></th><th><span data-translate="pharmaPortalApp.pharmaReturn.description">Description</span></th><th><span data-translate="pharmaPortalApp.pharmaReturn.qtd">Quantity</span></th><th><span data-translate="pharmaPortalApp.pharmaReturn.price">Unit price</span></th><th><span data-translate="pharmaPortalApp.pharmaReturn.vat">IVA</span></th><th><span data-translate="pharmaPortalApp.pharmaReturn.total">Total</span></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="returnProd in orderList | orderBy:\'\':true track by returnProd.cnp"><td class="table-left" ng-init="returnProd.editMode = \'\' ">{{returnProd.cnp}}</td><td class="table-left" ng-bind-html="returnProd.fullHtmlName" style="width: 30%"></td><td class="form-group" ng-class="{\'has-error has-feedback text-danger\': returnProd.invalidQtd}"><span ng-if="returnProd.editMode===\'\' || !returnProd.editMode"><span class="alert alert-danger" ng-show="returnProd.invalidQtd">{{returnProd.qtd}}</span> <span ng-hide="returnProd.invalidQtd">{{returnProd.qtd | number : 0}}</span> </span><input ng-if="returnProd.editMode!=\'\' && returnProd.editMode" type="text" class="form-control input-xs text-center" id="qtd" ng-model="returnProd.qtd" ng-class="{ \'alert-danger\': returnProd.qtd <= 0 }" ng-keypress="vm.validateLines(returnProd,$event)" ng-blur="vm.validateLines(returnProd,$event)" on-enter="vm.validateLines(returnProd,\'onEnter\');vm.toggleLineEditMode(returnProd)"> <i class="fa fa-remove form-control-feedback"></i></td><td class="form-group" ng-class="{\'has-error has-feedback text-danger\': returnProd.invalidPrice}"><span ng-if="returnProd.editMode===\'\' || !returnProd.editMode"><span class="alert alert-danger" ng-show="returnProd.invalidPrice">{{returnProd.price}}</span> <span ng-hide="returnProd.invalidPrice">{{returnProd.price | currency : \'&euro;\' : 2}}</span> </span><input ng-if="returnProd.editMode!=\'\' && returnProd.editMode" type="text" class="form-control input-xs text-center" id="price" ng-model="returnProd.price" ng-class="{ \'alert-danger\': returnProd.price <= 0 }" ng-keypress="vm.validateLines(returnProd,$event)" ng-blur="vm.validateLines(returnProd,$event)" ng-disabled="returnProd.validPolicyPrice" on-enter="vm.validateLines(returnProd,\'onEnter\');vm.toggleLineEditMode(returnProd)" price> <i class="fa fa-remove form-control-feedback"></i></td><td class="table-right">{{returnProd.txiva | currency : \'%\' : 2}}</td><td class="form-group" ng-class="{\'has-error has-feedback text-danger\': returnProd.invalidPrice}"><span ng-if="returnProd.editMode===\'\' || !returnProd.editMode"><span class="alert alert-danger" ng-show="returnProd.invalidPrice">{{returnProd.total}}</span> <span>{{returnProd.total | currency : \'&euro;\' : 2}}</span> </span><input ng-if="returnProd.editMode!=\'\' && returnProd.editMode" type="text" class="form-control input-xs text-center" id="total" ng-model="returnProd.total" ng-class="{ \'alert-danger\': returnProd.price <= 0 }" ng-keypress="vm.validateLines(returnProd,$event)" ng-blur="vm.validateLines(returnProd,$event)" on-enter="vm.validateLines(returnProd,\'onEnter\');vm.toggleLineEditMode(returnProd)" price required> <i class="fa fa-remove form-control-feedback"></i></td><td><div class="btn-group"><button class="btn btn-primary btn-xs" title="{{\'pharmaPortalApp.pharmaReturn.placeholder.editItem\' | translate}}" ng-class="{ \'active\': returnProd.editMode!=\'\' && returnProd.editMode}" ng-click="vm.toggleLineEditMode(returnProd);"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-xs" title="{{\'pharmaPortalApp.pharmaReturn.placeholder.removeItem\' | translate}}" ui-sref="pharma-return.removeLine({cnpToDel:returnProd.cnp})"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></form></div><div class="panel-footer"><div class="row" ng-show="vm.currentCompany"><div class="col-sm-12 small"><label class="col-sm-offset-5 col-sm-4"><span data-translate="pharmaPortalApp.pharmaReturn.totalizer.qtd">Total in quantity</span></label><div class="col-sm-2 text-right">{{totalizer.qtd | number : 0}}</div></div><div class="col-sm-12 small"><label class="col-sm-offset-5 col-sm-4"><span data-translate="pharmaPortalApp.pharmaReturn.totalizer.value">Total in value</span></label><div class="col-sm-2 text-right">{{totalizer.price | currency : \'&euro;\' : 2}}</div></div><div class="col-sm-12 small"><label class="col-sm-offset-5 col-sm-4"><span data-translate="pharmaPortalApp.pharmaReturn.totalizer.doc">Document Total (inc VAT)</span></label><div class="col-sm-2 text-right">{{totalizer.docTotal | currency : \'&euro;\' : 2}}</div></div></div><div class="row"><div class="col-md-12 text-right"><button class="btn btn-warning btn-sm" ng-disabled="isOrderEmpty()" ng-click="vm.exportToExcel()"><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span></button> <button class="btn btn-success btn-sm" ng-disabled="isOrderEmpty()" ui-sref="pharma-return.confirmReturn()"><i class="fa fa-list"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaReturn.home.submitReturn">Submit return</span></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/pharma-return/return-clear-dialog.html','<form ng-submit="vm.confirmClearOrder()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaReturn.clearReturn.title">Clear return\'s list?</h4></div><div class="modal-body"><p><span data-translate="pharmaPortalApp.pharmaReturn.clearReturn.body">You have selected to remove all products from your return list</span></p><p><span data-translate="pharmaPortalApp.pharmaReturn.clearReturn.confirm">Do you want to continue?</span></p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-return/return-confirm-dialog.html','<form ng-submit="vm.confirmOrder()" class="form-horizontal" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaReturn.submitReturn.title">Submit pharmacy return</h4></div><div class="modal-body"><div class="form-group"><div class="col-sm-12"><p><span data-translate="pharmaPortalApp.pharmaReturn.submitReturn.body">Indicate, if desired, the return guide number generated to accompany the merchandise.</span></p></div></div><div class="form-group"><label for="returnGuide" class="col-sm-4 control-label" data-translate="pharmaPortalApp.pharmaReturn.submitReturn.returnGuide">Return Guide</label><div class="col-sm-8"><input type="text" class="form-control" ng-model="vm.order.returnGuide" maxlength="15" autocomplete="off"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="vm.processing" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-return/return-remove-line-dialog.html','<form ng-submit="vm.confirmRemoveLine()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaReturn.removeLine.title">Remove product from the returns list?</h4></div><div class="modal-body"><p><span data-translate="pharmaPortalApp.pharmaReturn.removeLine.body">You have selected to remove the following product from your return list</span></p><p>{{vm.product.nome}}&nbsp;{{vm.product.dosagem}}&nbsp;{{vm.product.emb}}</p><p><span data-translate="pharmaPortalApp.pharmaReturn.cnp">CNP</span>: {{vm.product.cnp}}</p><p><span data-translate="pharmaPortalApp.pharmaReturn.qtd">Quantity</span>: {{vm.product.qtd | number:0}}</p><p><span data-translate="pharmaPortalApp.pharmaReturn.price">Unit price</span>: {{vm.product.price | currency : \'&euro;\' : 2}}</p><p><span data-translate="pharmaPortalApp.pharmaReturn.removeLine.confirm">Do you want to continue?</span></p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-sale/pharma-sale.inactive-dialog.html','<form name="confirmFullSearchForm" ng-submit="vm.confirmAddProducts()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><b>Aviso</b> - {{message.company}}</h4></div><div class="modal-body" id="modal-body"><any ng-switch="message.type"><any ng-switch-when="1"><p><b>Ponto de entrega deste cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate}}, {{message.regTime}}</p></any><any ng-switch-when="2"><p><b>Cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate | date : format : shortDate}}, {{message.regTime | date : \'hh:mm:ss\'}}</p></any></any></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/pharma-sale/pharma-sales.html','<div><div class="row"><div ng-class="vm.currentCompany ? \'col-md-8 no-padding-right\' : \'col-md-12\'"><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><div class="panel-title col-sm-6 pull-left no-padding"><span class="pull-left">Nova venda ao cliente:</span><div class="col-sm-8 pull-left"><ui-select name="company" ng-model="vm.currentCompany" on-select="vm.updateCompany($item, $model)"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaSale.placeholder.company\' | translate}}" allow-clear="true">{{$select.selected.namingForOptions}}</ui-select-match><ui-select-choices repeat="company as company in vm.companies | filter: $select.search | orderBy:\'naming\'"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="panel-search-form col-sm-6 pull-right" ng-show="vm.currentCompany"><form name="searchForm"><div class="input-group"><div class="input-group-btn" uib-dropdown auto-close="outsideClick"><span on-toggle="toggled(open)" class="btn btn-default btn-sm" ng-class="{\'btn-success\': search.showNoStock || search.ownWarehouse}" uib-dropdown-toggle><i class="fa fa-cogs"></i>&nbsp;<i class="caret"></i></span><ul class="dropdown-menu" uib-dropdown-menu><li><div class="checkbox dropdown-item"><label><input type="checkbox" ng-model="search.showNoStock" id="showNoStock"> <span data-translate="pharmaPortalApp.pharmaSale.dropdown.includeWithNoStock">Include without stock</span></label></div></li><li ng-show="vm.ownWarehouse"><div class="checkbox dropdown-item"><label><input type="checkbox" ng-model="search.ownWarehouse" id="ownWarehouse" ng-disabled="isRetainedProductsOrder()"> <span data-translate="pharmaPortalApp.pharmaSale.dropdown.includeRetainedProducts">Retained Products</span> <span tooltip-placement="bottom" uib-tooltip="Selecionar esta op\xE7\xE3o implica que a encomenda apenas possa conter produtos retidos"><i class="fa fa-question-circle-o"></i></span></label></div></li></ul></div><input type="text" class="form-control input-sm" ng-model="search.searchQuery" id="searchQuery" placeholder="{{\'global.form.search.placeholder.product.attr\' | translate}}" autocomplete="off"><div class="input-group-btn"><button class="btn btn-info btn-sm" ng-click="searchProducts()" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i></button></div></div></form></div><div class="clearfix"></div></div><div class="panel-body"><div ng-hide="vm.currentCompany"><div class="jumbotron text-center"><h4><i class="fa fa-building fa-3x"></i>&nbsp;&nbsp;&nbsp;Por favor escolha o cliente para o qual pretende encomendar</h4></div></div><div ng-show="vm.currentCompany"><div class="jumbotron text-center" ng-hide="productsList.length"><h4><i class="fa fa-search-minus fa-3x"></i>&nbsp;&nbsp;&nbsp;Por favor utilize o campo de pesquisa no topo da p\xE1gina</h4></div><form name="orderSaleForm" role="form" ng-show="productsList.length"><div class="row"><div class="col-md-6"><any ng-hide="searchInTable">A pesquisa por "{{search.searchQuery}}" retornou {{productsList.length}} items</any><any ng-show="searchInTable">Mostrando {{(productsList | filter:searchInTable).length}} items de um total de {{productsList.length}}</any></div><div class="col-md-offset-3 col-md-3"><div class="form-group"><div class="input-group"><input type="text" class="form-control input-sm" placeholder="{{\'global.form.search.placeholder.inTable\' | translate}}" ng-model="searchInTable"><div class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.clearSearchInTable()"><i class="fa fa-close"></i></button></div></div></div></div></div><div class="table-responsive"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="productsList"><thead><tr class="topHeader"><th>CNP</th><th>Descri\xE7\xE3o</th><th>Laborat\xF3rio</th><th><span ng-show="vm.isPharma">PVF</span> <span ng-hide="vm.isPharma">PVA</span></th><th>Desc %</th><th>Pre\xE7o</th><th>Stock</th><th>Qtd</th><th>Total</th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="product in productsList | filter:searchInTable track by $index"><form id="salesProductForm" name="salesProductForm"><td class="table-left">{{product.cnp}}</td><td class="table-left" ng-bind-html="product.fullHtmlName"></td><td class="table-left"><a ng-click="vm.searchByLab(product.lab)">{{product.lab}}</a></td><td class="table-right"><any ng-show="vm.isPharma">{{product.pvfeur | currency : \'&euro;\' : 2}}</any><any ng-hide="vm.isPharma">{{product.pvaeur | currency : \'&euro;\' : 2}}</any></td><td class="table-right"><any ng-show="vm.isPharma">{{product.pvfdesc | currency : \'%\' : 2}}</any><any ng-hide="vm.isPharma">{{product.pvadesc | currency : \'%\' : 2}}</any></td><td class="table-right">{{product.pvp | currency : \'&euro;\' : 2}}</td><td>{{product.warehousestock ? product.warehousestock : 0 | number : 0}}</td><td><input type="number" min="1" step="1" pattern="\\d{1,}" class="form-control input-xs" ng-model="product.qtd" on-enter="vm.addProduct(product)"></td><td class="table-right" ng-if="!salesProductForm.$invalid">{{product.qtd * product.pvp | currency : \'&euro;\' : 2}}</td><td class="table-right" ng-if="salesProductForm.$invalid"></td><td><button class="btn btn-success btn-xs" title="Adicionar Item" ng-click="vm.addProduct(product)" ng-disabled="vm.isValidForOrder(product) || salesProductForm.$invalid"><i class="fa fa-plus"></i></button></td></form></tr></tbody></table></div></form></div></div><div class="panel-footer"><div class="row"><div class="col-md-12 text-right"><button class="btn btn-warning btn-sm" ng-disabled="isProductSearchEmpty()" ng-click="vm.exportSearchToExcel()"><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span></button> <button class="btn btn-success btn-sm" ng-disabled="isProductSearchEmpty()" ng-click="vm.addAllProducts()"><i class="fa fa-plus"></i>&nbsp;Adicionar Todos</button></div></div></div></div></div><div class="col-md-4" ng-show="vm.currentCompany"><div id="curOrderList" class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left">Encomenda atual</span><div class="btn-group pull-right"><button class="btn btn-danger btn-sm" ui-sref="pharma-sale.clearOrder()" ng-disabled="isOrderEmpty()"><i class="fa fa-recycle"></i> Limpar Encomenda</button></div><span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th>CNP</th><th>Descri\xE7\xE3o</th><th>Qtd</th><th>Pre\xE7o</th><th>IVA</th><th>Total</th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr class="small" ng-repeat="orderProd in saleOrderList track by orderProd.cnp"><td class="table-left">{{orderProd.cnp}}</td><td class="table-left" ng-bind-html="orderProd.fullHtmlName"></td><td class="form-group" ng-class="{\'has-error has-feedback text-danger\': orderProd.invalidQtd}"><span ng-if="orderProd.editMode===\'\' || !orderProd.editMode"><span class="alert alert-danger" ng-show="orderProd.invalidQtd">{{orderProd.qtd}}</span> <span ng-hide="orderProd.invalidQtd">{{orderProd.qtd | number : 0}}</span> </span><input ng-if="orderProd.editMode!=\'\' && orderProd.editMode" type="text" class="form-control input-xs text-center" id="qtd" ng-model="orderProd.qtd" ng-class="{ \'alert-danger\': orderProd.qtd <= 0 }" ng-keypress="vm.validateLines(orderProd,$event)" ng-blur="vm.validateLines(orderProd,$event)"> <i class="fa fa-remove form-control-feedback"></i></td><td class="table-right">{{orderProd.pvp | currency : \'&euro;\' : 2}}</td><td class="table-right">{{orderProd.txiva | currency : \'%\' : 2}}</td><td class="table-right">{{orderProd.qtd * orderProd.pvp | currency : \'&euro;\' : 2}}</td><td><div class="btn-group"><button class="btn btn-primary btn-xs" ng-class="{ \'active\': orderProd.editMode!=\'\' && orderProd.editMode}" title="{{\'entity.action.edit\' | translate}}" ng-click="vm.toggleLineEditMode(orderProd)"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-xs" title="Remover Item" ui-sref="pharma-sale.removeProduct({cnpToDel:orderProd.cnp})"><i class="fa fa-trash"></i></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="row"><div class="col-sm-12 small"><label class="col-md-offset-4 col-sm-4">Total</label><div class="col-sm-4 text-right">{{saleTotals.total | currency : \'&euro;\' : 2}}</div></div><div class="col-sm-12 small"><label class="col-md-offset-4 col-sm-4">Total <span ng-show="vm.isPharma">PVF</span> <span ng-hide="vm.isPharma">PVA</span></label><div class="col-sm-4 text-right">{{saleTotals.totalPV | currency : \'&euro;\' : 2}}</div></div><div class="col-sm-12 small"><label class="col-md-offset-4 col-sm-4">Total Desc</label><div class="col-sm-4 text-right">{{saleTotals.totalDesc | currency : \'&euro;\' : 2}}</div></div><div class="col-sm-12 small" ng-show="vm.portalSettings.chargeShippingCosts == true && vm.portalSettings.hasMinOrderValue == true && vm.portalSettings.minOrderValue > (saleTotals.total - vm.portalSettings.shippingCosts)"><label class="col-md-offset-4 col-sm-4"><span tooltip-placement="top" uib-tooltip="Para encomendas com valor inferior a {{vm.portalSettings.minOrderValue | currency : \'&euro;\' : 2}} ser\xE1 cobrada uma taxa de transporte"><i class="fa fa-question-circle-o"></i> </span>Valor de Transporte</label><div class="col-sm-4 text-right">{{vm.portalSettings.shippingCosts | currency : \'&euro;\' : 2}}</div></div></div><div class="row"><div class="col-md-12 text-right"><button class="btn btn-warning btn-sm" ng-click="vm.orderToExcel()" ng-disabled="isOrderEmpty() || vm.hasErrors"><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span></button> <button class="btn btn-success btn-sm" ng-click="vm.confirmOrderDialog()" ng-disabled="isOrderEmpty() || vm.hasErrors"><i class="fa fa-list"></i>&nbsp;Encomendar</button></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/pharma-sale/sale-alert-dialog.html','<form ng-submit="vm.confirmAlert()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Informa\xE7\xE3o</h4></div><div class="modal-body" id="modal-body"><span ng-bind-html="message"></span></div><div class="modal-footer"><button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/pharma-sale/sale-clear-order-dialog.html','<form name="clearOrderForm" ng-submit="vm.confirmClearOrder()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Limpar lista a encomendar?</h4></div><div class="modal-body"><p>Selecionou retirar todos os produtos da sua lista a encomendar.</p><p>Pretende continuar?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-sale/sale-confirm-order-dialog.html','<form name="confirmOrderForm" ng-submit="vm.confirmOrder()" class="form-horizontal" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Submeter Encomenda</h4></div><div class="modal-body" ng-switch="vm.orderReady"><div ng-switch-when="true"><div class="form-group"><div class="col-sm-12"><p>Est\xE1 prestes a submeter a sua encomenda.</p></div><div class="col-sm-12"><p>Se pretender, poder\xE1 ainda indicar uma pequena descri\xE7\xE3o no campo que se segue.</p></div></div><div class="form-group"><label for="description" class="col-sm-4 control-label">Descri\xE7\xE3o encomenda</label><div class="col-sm-8"><input type="text" id="description" class="form-control" ng-model="vm.orderDescription" maxlength="15" autocomplete="off"></div></div></div><div ng-switch-when="false"><div class="form-group"><div class="col-sm-12"><p>A encomenda n\xE3o pode ser submetida enquanto n\xE3o atingir o valor m\xEDnimo de <b>{{vm.orderInfoValues.minValue | currency : \'&euro;\' : 2}}</b>.</p><p>Ainda est\xE1 <b>{{vm.orderInfoValues.curDiff | currency : \'&euro;\' : 2}}</b> abaixo desse valor m\xEDnimo.</p></div></div></div></div><div class="modal-footer" ng-switch="vm.orderReady"><div ng-switch-when="true"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="vm.processing" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div><div ng-switch-when="false"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div></div></form>');
$templateCache.put('app/entities/pharma-sale/sale-confirm.fullsearch-dialog.html','<form name="confirmFullSearchForm" ng-submit="vm.confirmAddProducts()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Informa\xE7\xE3o</h4></div><div class="modal-body" id="modal-body"><any ng-switch="message"><any ng-switch-when="NOK"><p>A op\xE7\xE3o "Incluir s/stock" est\xE1 selecionada.</p><p>Por quest\xF5es de performance, apenas \xE9 permitido efetuar pesquisas com 3 ou mais caracteres.</p></any><any ng-switch-when="OK"><p><b>Aten\xE7\xE3o</b>: a a\xE7\xE3o de procurar produtos usando menos de 3 caracteres no termo a pesquisar pode demorar alguns minutos.</p><p>Pretende continuar?</p></any></any></div><div class="modal-footer"><any ng-switch="message"><any ng-switch-when="NOK"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></any><any ng-switch-when="OK"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></any></any></div></form>');
$templateCache.put('app/entities/pharma-sale/sale-remove-product-dialog.html','<form ng-submit="vm.confirmRemoveProduct()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Retirar produto da lista a encomendar?</h4></div><div class="modal-body"><p>Selecionou remover o seguinte produto da sua lista a encomendar:</p><p>{{vm.product.nome}}&nbsp;{{vm.product.dosagem}}&nbsp;{{vm.product.emb}}</p><p>CNP: {{vm.product.cnp}}</p><p>Quantidade: {{vm.product.qtd | number:0}}</p><p>Pre\xE7o Unit: {{vm.product.pvp | currency : \'&euro;\' : 2}}</p><p>Pretende continuar?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-sale/sale-success-dialog.html','<form ng-submit="vm.confirmAddProducts()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Informa\xE7\xE3o</h4></div><div class="modal-body" id="modal-body"><span ng-bind-html="message"></span></div><div class="modal-footer"><button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">OK</span></button></div></form>');
$templateCache.put('app/entities/pharma-self-test/pharma-self-test-detail.html','<form name="submitPharmaSelfTest" ng-submit="vm.exportCSV()"><div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left"><span data-translate="pharmaPortalApp.pharmaSelfTest.home.title">Pharma Self Test</span><any ng-if="vm.startDate != null && vm.endDate != null">&nbsp;de&nbsp;<span>{{vm.startDate | date: \'dd/MM/yyyy\'}}</span>&nbsp;a&nbsp;<span>{{vm.endDate | date: \'dd/MM/yyyy\'}}</span></any></span><div class="btn-group pull-right"><button type="submit" class="btn btn-success btn-sm" ng-disabled="vm.itemsList.length <= 0"><i class="fa fa-file-code-o"></i>&nbsp;<span class="hidden-xs" data-translate="pharmaPortalApp.pharmaSelfTest.home.exportCSV">Export to CSV</span></button> <button type="button" class="btn btn-info btn-sm" ng-click="vm.intervalModal()"><i class="fa fa-calendar-check-o"></i>&nbsp;<span class="hidden-xs" data-translate="pharmaPortalApp.pharmaSelfTest.home.selectInterval">Select Interval</span></button></div><span class="clearfix"></span></div><div class="panel-body"><div class="alert alert-warning" ng-show="vm.itemsList.length <= 0" data-translate="pharmaPortalApp.pharmaSelfTest.noResults"></div><div class="table-responsive" ng-show="vm.itemsList.length > 0"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th data-translate="pharmaPortalApp.pharmaSelfTest.nRegisto">N Registo Medicamento</th><th data-translate="pharmaPortalApp.pharmaSelfTest.quantidade">Quantidade</th><th data-translate="pharmaPortalApp.pharmaSelfTest.tipoEntidadeVendeu">Tipo Entidade Vendeu</th></tr></thead><tbody><tr ng-repeat="item in vm.itemsList track by $index"><td class="table-left">{{item.nRegisto}}</td><td class="table-right">{{item.quantidade | number:0}}</td><td class="table-right">{{item.tipoEntidadeVendeu}}</td></tr></tbody></table></div></div></div></div></form>');
$templateCache.put('app/entities/pharma-self-test/pharma-self-test-dialog.html','<form class="form-horizontal" name="datesForm" ng-submit="vm.proceed()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaSelfTest.dialog.title">Date Interval</h4></div><div class="modal-body" id="modal-body"><p data-translate="pharmaPortalApp.pharmaSelfTest.dialog.message">Select the start and end date for the report data</p><div class="form-group"><label for="startDate" class="col-md-3 control-label" translate="pharmaPortalApp.pharmaSelfTest.form.startDate">Start Date</label><div class="col-md-6"><div class="input-group input-group-sm"><input type="text" class="form-control" id="startDate" ng-click="vm.openDatePopup(1)" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.startDate" is-open="vm.datePopup1.opened" datepicker-options="vm.dateOptions" placeholder="{{\'pharmaPortalApp.pharmaSelfTest.form.startDate\' | translate}}" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(1)"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="form-group"><label for="endDate" class="col-md-3 control-label" translate="pharmaPortalApp.pharmaSelfTest.form.endDate">End Date</label><div class="col-md-6"><div class="input-group input-group-sm"><input type="text" class="form-control" id="endDate" ng-click="vm.openDatePopup(2)" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.endDate" is-open="vm.datePopup2.opened" datepicker-options="vm.dateOptions" placeholder="{{\'pharmaPortalApp.pharmaSelfTest.form.endDate\' | translate}}" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(2)"><i class="fa fa-calendar"></i></button></span></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="datesForm.$invalid"><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.ok">OK</span></button></div></form>');
$templateCache.put('app/entities/pharma-supplier-complaint/pharma-supplier-complaint.html','<form ng-submit="vm.generatePdf()"><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaSupplierComplaint.title">Supplier complaint</span> <span class="clearfix"></span></div><div class="panel-body"><div class="container-fluid well well-sm"><form class="form-horizontal" name="editForm" role="form"><div class="form-group"><label class="col-sm-3 control-label" data-translate="pharmaPortalApp.pharmaSupplierComplaint.supplier">Designa\xE7\xE3o do fornecedor:</label><div class="col-sm-9"><p class="form-control-static">{{vm.pharmaPicking.supplierCode}} - {{vm.pharmaPicking.supplierName}}</p></div></div><div class="form-group"><label class="col-sm-3 control-label" data-translate="pharmaPortalApp.pharmaSupplierComplaint.documentNumber">N\xFAmero do documento do fornecedor:</label><div class="col-sm-9"><p class="form-control-static">{{vm.pharmaPicking.receipt}}</p></div></div><div class="form-group"><label class="col-sm-3 control-label" data-translate="pharmaPortalApp.pharmaSupplierComplaint.documentDate">Data documento fornecedor:</label><div class="col-sm-9"><p class="form-control-static">{{vm.pharmaPicking.documentDate | date: \'dd/MM/yyyy\'}}</p></div></div><div class="form-group"><label class="col-sm-3 control-label" data-translate="pharmaPortalApp.pharmaSupplierComplaint.pharmacy">Designa\xE7\xE3o da Farm\xE1cia:</label><div class="col-sm-9"><p class="form-control-static">{{vm.pharmaPicking.pharmacyWarehouse + " - " + vm.pharmaPicking.pharmacyName}}</p></div></div><div class="form-group"><label class="col-sm-3 control-label" data-translate="pharmaPortalApp.pharmaSupplierComplaint.complaintDate">Data reclama\xE7\xE3o:</label><div class="col-sm-9"><p class="form-control-static">{{vm.date | date: \'dd/MM/yyyy\'}}</p></div></div><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions"><thead><tr><th data-translate="pharmaPortalApp.pharmaSupplierComplaint.product">Produto</th><th data-translate="pharmaPortalApp.pharmaSupplierComplaint.invoiceQuantity">Quantidade Faturada</th><th data-translate="pharmaPortalApp.pharmaSupplierComplaint.quantityChecked">Quantidade Conferida</th><th data-translate="pharmaPortalApp.pharmaSupplierComplaint.missingQuantity">Quantidade em falta</th><th data-translate="pharmaPortalApp.pharmaSupplierComplaint.reason">Motivo</th></tr></thead><tbody><tr ng-repeat="line in vm.pharmaPicking.pharmaPickingLines | complaint:vm.pharmaPicking.changeState"><td class="table-left">{{line.cnp + \' - \' + line.description}}</td><td>{{line.invoicedQuantity}}</td><td>{{vm.toInt((line.receivedQuantity ? line.receivedQuantity : 0), (line.suggestion ? line.suggestion : 0))}}</td><td>{{line.claimedQuantity}}</td><td><div ng-class="{\'has-error\': !line.reason}"><input type="text" class="input-sm form-control has-error" ng-model="line.reason" required></div></td></tr></tbody></table></form></div></div><div class="panel-footer"><div class="row"><div class="col-md-12 text-right"><button ng-if="vm.changeState" type="button" class="btn btn-default btn-sm" ng-click="vm.back()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-download"></i>&nbsp;<span data-translate="entity.action.exportToPdf">Export to PDF</span></button></div></div></div></div></form>');
$templateCache.put('app/entities/pharma-trade/pharma-trade.inactive-dialog.html','<form name="confirmFullSearchForm" ng-submit="vm.confirmAddProducts()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><b>Aviso</b> - {{message.company}}</h4></div><div class="modal-body" id="modal-body"><any ng-switch="message.type"><any ng-switch-when="1"><p><b>Ponto de entrega deste cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate}}, {{message.regTime}}</p></any><any ng-switch-when="2"><p><b>Cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate | date : format : shortDate}}, {{message.regTime | date : \'hh:mm:ss\'}}</p></any></any></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/pharma-trade/pharma-trades.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaTrade.home.newTrade">New Order (Trade)</span><div class="btn-group pull-right"><button class="btn btn-danger btn-sm" ui-sref="pharma-trade.clearOrder()" ng-disabled="isOrderEmpty()"><i class="fa fa-recycle"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaTrade.home.clearTrade">Clear trade</span></button></div><span class="clearfix"></span></div><div class="panel-body"><form id="tradeProductForm" name="tradeProductForm" class="form container-fluid well well-sm" ng-submit="vm.addProduct()"><div class="form-group form-group-sm col-md-4 col-sm-5"><ui-select id="filterProduct" ng-model="vm.products.selected" reset-search-input="false" fix-selected-item uis-open-close="onOpenClose(isOpen)" on-select="getPriceFromPolicy($item, $model)" required><ui-select-match placeholder="{{\'global.form.search.placeholder.product\' | translate}}">{{$select.selected.cnp}} - {{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="product as product in vm.products track by product.cnp" refresh="refreshSelectModel($select.search)" refresh-delay="500" minimum-input-length="3"><span ng-bind-html="product.cnp +\' - \'+ product.fullHtmlName"></span></ui-select-choices></ui-select></div><div class="form-group col-md-2 col-sm-3"><div class="input-group input-group-sm"><input type="number" min="1" step="1" pattern="\\d{1,}" class="form-control" ng-model="vm.products.selected.qtd" ng-disabled="!vm.products.selected" placeholder="{{\'pharmaPortalApp.pharmaTrade.placeholder.quantity\' | translate}}" required> <span class="input-group-addon"><i class="fa fa-archive"></i></span></div></div><div class="form-group col-md-2 col-sm-3"><div class="input-group input-group-sm"><input type="text" class="form-control" ng-model="vm.products.selected.price" ng-disabled="!vm.products.selected || vm.validPolicyPrice || (vm.products.selected.price == 0 && !vm.portalSettings.manualPriceIfNull)" placeholder="{{\'pharmaPortalApp.pharmaTrade.placeholder.unitPrice\' | translate}}" required price> <span class="input-group-addon"><i class="fa fa-eur"></i></span></div></div><div class="form-group col-md-1 col-sm-1"><button class="btn btn-success btn-sm" title="{{\'pharmaPortalApp.pharmaTrade.placeholder.addItem\' | translate}}" ng-disabled="tradeProductForm.$invalid"><i class="fa fa-plus"></i></button></div></form><div class="table-responsive"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="orderList"><thead><tr class="topHeader"><th><span data-translate="pharmaPortalApp.pharmaTrade.cnp">CNP</span></th><th><span data-translate="pharmaPortalApp.pharmaTrade.description">Description</span></th><th><span data-translate="pharmaPortalApp.pharmaTrade.qtd">Quantity</span></th><th><span data-translate="pharmaPortalApp.pharmaTrade.price">Unit price</span></th><th><span data-translate="pharmaPortalApp.pharmaTrade.vat">IVA</span></th><th><span data-translate="pharmaPortalApp.pharmaTrade.total">Total</span></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="orderProdLine in orderList track by orderProdLine.cnp"><td class="table-left" ng-init="orderProdLine.editMode = \'\' ">{{orderProdLine.cnp}}</td><td class="table-left" ng-bind-html="orderProdLine.fullHtmlName" style="width:30%"></td><td class="form-group" ng-class="{\'has-error has-feedback text-danger\': orderProdLine.invalidQtd}"><span ng-if="orderProdLine.editMode===\'\' || !orderProdLine.editMode"><span class="alert alert-danger" ng-show="orderProdLine.invalidQtd">{{orderProdLine.qtd}}</span> <span ng-hide="orderProdLine.invalidQtd">{{orderProdLine.qtd | number : 0}}</span> </span><input ng-if="orderProdLine.editMode!=\'\' && orderProdLine.editMode" type="text" class="form-control input-xs text-center" id="qtd" ng-model="orderProdLine.qtd" ng-class="{ \'alert-danger\': orderProdLine.qtd <= 0 }" ng-keypress="vm.validateLines(orderProdLine,$event)" ng-blur="vm.validateLines(orderProdLine,$event)"> <i class="fa fa-remove form-control-feedback"></i></td><td class="form-group" ng-class="{\'has-error has-feedback text-danger\': orderProdLine.invalidPrice}"><span ng-if="orderProdLine.editMode===\'\' || !orderProdLine.editMode"><span class="alert alert-danger" ng-show="orderProdLine.invalidPrice">{{orderProdLine.price}}</span> <span ng-hide="orderProdLine.invalidPrice">{{orderProdLine.price | currency : \'&euro;\' : 2}}</span> </span><input ng-if="orderProdLine.editMode!=\'\' && orderProdLine.editMode" type="text" class="form-control input-xs text-center" id="price" ng-model="orderProdLine.price" ng-class="{ \'alert-danger\': orderProdLine.price <= 0 }" ng-keypress="vm.validateLines(orderProdLine,$event)" ng-blur="vm.validateLines(orderProdLine,$event)" ng-disabled="orderProdLine.validPolicyPrice" price> <i class="fa fa-remove form-control-feedback"></i></td><td class="table-right">{{orderProdLine.txiva | currency : \'%\' : 2}}</td><td class="table-right">{{orderProdLine.qtd * orderProdLine.price | currency : \'&euro;\' : 2}}</td><td><div class="btn-group"><button class="btn btn-primary btn-xs" title="{{\'pharmaPortalApp.pharmaTrade.placeholder.editItem\' | translate}}" ng-class="{ \'active\': orderProdLine.editMode!=\'\' && orderProdLine.editMode}" ng-click="vm.toggleLineEditMode(orderProdLine)"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-xs" title="{{\'pharmaPortalApp.pharmaTrade.placeholder.removeItem\' | translate}}" ui-sref="pharma-trade.removeProduct({cnpToDel:orderProdLine.cnp})"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="row"><div class="col-sm-12 small"><label class="col-sm-offset-5 col-sm-4"><span data-translate="pharmaPortalApp.pharmaTrade.totalizer.qtd">Total in quantity</span></label><div class="col-sm-2 text-right">{{totalizer.qtd | number : 0}}</div></div><div class="col-sm-12 small"><label class="col-sm-offset-5 col-sm-4"><span data-translate="pharmaPortalApp.pharmaTrade.totalizer.value">Total in value</span></label><div class="col-sm-2 text-right">{{totalizer.price | currency : \'&euro;\' : 2}}</div></div><div class="col-sm-12 small"><label class="col-sm-offset-5 col-sm-4"><span data-translate="pharmaPortalApp.pharmaTrade.totalizer.doc">Document Total (inc VAT)</span></label><div class="col-sm-2 text-right">{{totalizer.docTotal | currency : \'&euro;\' : 2}}</div></div></div><div class="row"><div class="col-md-12 text-right"><button class="btn btn-warning btn-sm" ng-click="vm.exportToExcel()" ng-disabled="isOrderEmpty() || vm.hasErrors"><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span></button> <button class="btn btn-success btn-sm" ui-sref="pharma-trade.confirmOrder()" ng-disabled="isOrderEmpty() || vm.hasErrors"><i class="fa fa-list"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaTrade.home.submitTrade">Submit trade</span></button></div></div></div></div></div>');
$templateCache.put('app/entities/pharma-trade/trade-clear-order-dialog.html','<form name="clearOrderForm" ng-submit="vm.confirmClearOrder()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaTrade.clearTrade.title">Clear trade\'s list?</h4></div><div class="modal-body"><p><span data-translate="pharmaPortalApp.pharmaTrade.clearTrade.body">You have selected to remove all products from your trade list</span></p><p><span data-translate="pharmaPortalApp.pharmaTrade.clearTrade.confirm">Do you want to continue?</span></p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-trade/trade-confirm-order-dialog.html','<form name="confirmOrderForm" ng-submit="vm.confirmOrder()" class="form-horizontal" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaTrade.submitTrade.title">Submit pharmacy trade order</h4></div><div class="modal-body"><div class="form-group"><div class="col-sm-12"><p><span data-translate="pharmaPortalApp.pharmaTrade.submitTrade.body1">Indicate the company that will receive the product.</span></p></div><div class="col-sm-12"><p><span data-translate="pharmaPortalApp.pharmaTrade.submitTrade.body2">If you want, you could indicate the generated return guide number.</span></p></div></div><div class="form-group" ng-class="[{\'has-error\': confirmOrderForm.$submitted && confirmOrderForm.company.$invalid}]"><label for="name" class="col-sm-4 control-label" data-translate="pharmaPortalApp.pharmaTrade.submitTrade.receptionCompany">Reception Company</label><div class="col-sm-8"><ui-select name="company" ng-model="vm.order.company" on-select="vm.selectCompany($item, $model)" on-remove="unselectCompany($item, $model)" required><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaTrade.placeholder.company\' | translate}}" allow-clear="true">{{$select.selected.namingForOptions}}</ui-select-match><ui-select-choices repeat="company as company in vm.companies | filter: { namingForOptions: $select.search } | orderBy:\'naming\'"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div class="form-group"><label for="name" class="col-sm-4 control-label" data-translate="pharmaPortalApp.pharmaTrade.submitTrade.returnGuide">Return Guide</label><div class="col-sm-8"><input type="text" class="form-control" ng-model="vm.order.description" maxlength="15" autocomplete="off"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="vm.processing" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-trade/trade-remove-product-dialog.html','<form ng-submit="vm.confirmRemoveProduct()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaTrade.removeLine.title">Remove product from the order list?</h4></div><div class="modal-body"><p><span data-translate="pharmaPortalApp.pharmaTrade.removeLine.body">You have selected to remove the following product from your order list</span></p><p>{{vm.product.nome}}&nbsp;{{vm.product.dosagem}}&nbsp;{{vm.product.emb}}</p><p><span data-translate="pharmaPortalApp.pharmaTrade.cnp">CNP</span>: {{vm.product.cnp}}</p><p><span data-translate="pharmaPortalApp.pharmaTrade.qtd">Quantity</span>: {{vm.product.qtd | number:0}}</p><p><span data-translate="pharmaPortalApp.pharmaTrade.price">Unit price</span>: {{vm.product.price | currency : \'&euro;\' : 2}}</p><p><span data-translate="pharmaPortalApp.pharmaTrade.removeLine.confirm">Do you want to continue?</span></p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-transf-reception/pharma-transf-reception-delete-dialog.html','<form name="deleteReceptionHeaderForm" ng-submit="vm.confirmPharmaTransfReceptionDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaTransfReception.deleteDialog.title">Confirm Reception Header</h4></div><div class="modal-body"><p><span class="modal-title" data-translate="pharmaPortalApp.pharmaTransfReception.deleteDialog.body">Confirm Reception Header delete?</span></p><ul><li><span data-translate="pharmaPortalApp.pharmaTransfReception.receptionDate">Reception Date</span>: {{vm.pharmaTransfReception.receptionDate | date:\'dd/MM/yyyy\'}}</li><li><span data-translate="pharmaPortalApp.pharmaTransfReception.originWarehouse">Origin Warehouse</span>: {{vm.getWarehouseFullDescription(vm.pharmaTransfReception.originWarehouse)}}</li><li><span data-translate="pharmaPortalApp.pharmaTransfReception.destinationWarehouse">Destination Warehouse</span>: {{vm.getWarehouseFullDescription(vm.pharmaTransfReception.destinationWarehouse)}}</li><li><span data-translate="pharmaPortalApp.pharmaTransfReception.clientDocument">Client Document</span>: {{vm.pharmaTransfReception.clientDocument}}</li><li><span data-translate="pharmaPortalApp.pharmaTransfReception.requisition">Requisition</span>: {{vm.pharmaTransfReception.requisition}}</li></ul></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger btn-sm" autofocus><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pharma-transf-reception/pharma-transf-reception-detail-dialog.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span data-translate="pharmaPortalApp.pharmaTransfReception.detail.title">Pharma Reception Details</span>&nbsp;"{{vm.pharmaTransfReception.id}}"</h4></div><div class="modal-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.pharmaTransfReception.status">Status</span></dt><dd><span>{{\'pharmaPortalApp.pharmaReceptionStatus.\'+vm.pharmaTransfReception.status | translate}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaTransfReception.originDate">Origin Date</span></dt><dd><span>{{vm.pharmaTransfReception.originDate | date: \'dd/MM/yyyy\'}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaTransfReception.receptionDate">Reception Date</span></dt><dd><span>{{vm.pharmaTransfReception.receptionDate | date: \'dd/MM/yyyy\'}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaTransfReception.saleReference">Sale Reference</span></dt><dd><span>{{vm.pharmaTransfReception.saleReference}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaTransfReception.requisition">Requisition</span></dt><dd><span>{{vm.pharmaTransfReception.requisition}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaTransfReception.originWarehouse">Origin Warehouse</span></dt><dd><span>{{vm.getWarehouseFullDescription(vm.pharmaTransfReception.originWarehouse)}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaTransfReception.destinationWarehouse">Destination Warehouse</span></dt><dd><span>{{vm.getWarehouseFullDescription(vm.pharmaTransfReception.destinationWarehouse)}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaTransfReception.transferType">Transfer Type</span></dt><dd><span>{{vm.getTransferTypeFullDescription(vm.pharmaTransfReception.transferType)}}</span></dd><dt><span data-translate="pharmaPortalApp.pharmaTransfReception.username">Username</span></dt><dd><span>{{vm.pharmaTransfReception.username}}</span></dd></dl><div class="row"><div class="col-md-12"><blockquote ng-hide="vm.manualReceptionLines.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.pharmaTransfReception.message.noReceptionLines">No Reception Lines</blockquote><div class="table-responsive" ng-show="vm.manualReceptionLines.length > 0"><table class="table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.manualReceptionLines"><thead><tr><th data-translate="pharmaPortalApp.pharmaTransfReception.line.cnp">CNP</th><th data-translate="pharmaPortalApp.pharmaTransfReception.line.description">Description</th><th data-translate="pharmaPortalApp.pharmaTransfReception.line.vatRate">VAT Rate</th><th data-translate="pharmaPortalApp.pharmaTransfReception.line.lot">Lot</th><th data-translate="pharmaPortalApp.pharmaTransfReception.line.expirationDate">Expiration Date</th><th data-translate="pharmaPortalApp.pharmaTransfReception.line.receivedQuantity">Received Quantity</th><th data-translate="pharmaPortalApp.pharmaTransfReception.line.qualityStatus">Quality Status</th></tr></thead><tbody><tr ng-repeat="pharmaTransfReceptionLine in vm.manualReceptionLines"><td class="table-left">{{pharmaTransfReceptionLine.cnp}}</td><td class="table-left">{{pharmaTransfReceptionLine.description}}</td><td class="text-right">{{pharmaTransfReceptionLine.vatRate | currency : \'%\' : 0}}</td><td class="table-left">{{pharmaTransfReceptionLine.lot | uppercase}}</td><td>{{pharmaTransfReceptionLine.expirationDate!=null && pharmaTransfReceptionLine.expirationDate != \'\' ? ("000000"+pharmaTransfReceptionLine.expirationDate).slice(-6) :\'\'}}</td><td>{{pharmaTransfReceptionLine.receivedQuantity}}</td><td>{{pharmaTransfReceptionLine.qualityStatus}}</td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" ng-click="vm.clear()" ui-sref="pharma-transf-reception-edit({id:vm.pharmaTransfReception.id})" ng-disabled="{{vm.pharmaTransfReception.status != \'CREATED\'}}" autofocus><i class="fa fa-pencil"></i>&nbsp;<span data-translate="entity.action.edit">Edit</span></button></div></div>');
$templateCache.put('app/entities/pharma-transf-reception/pharma-transf-reception-edit.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaTransfReception.home.title">Pharma Reception</span> <button type="submit" class="btn btn-warning btn-sm pull-right" ui-sref="pharma-transf-reception-line.new({parentId: vm.pharmaTransfReception.id})"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaTransfReception.action.newReceptionLine">New Reception Line</span></button> <span class="clearfix"></span></div><div class="panel-body"><form class="container-fluid well well-sm" ng-submit="vm.save()" id="receptionForm" name="receptionForm"><div class="row"><div class="form-group-sm col-md-3"><label for="originDate" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.originDate">Origin Date</label><div class="col-md-7"><input type="text" class="form-control" ng-value="vm.pharmaTransfReception.originDate | date: \'dd/MM/yyyy\'" ng-disabled="true"></div></div><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': receptionForm.receptionDate.$invalid && receptionForm.receptionDate.$dirty }"><label for="receptionDate" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.receptionDate">Reception Date</label><div class="col-md-7"><div class="input-group input-group-sm"><input type="text" class="form-control" ng-click="vm.openDatePopup()" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.pharmaTransfReception.receptionDate" ng-value="vm.pharmaTransfReception.receptionDate | date: \'dd/MM/yyyy\'" is-open="vm.datePopup.opened" datepicker-options="vm.dateOptions" placeholder="{{\'pharmaPortalApp.pharmaTransfReception.receptionDate\' | translate}}" ng-disabled="vm.working" ng-blur="vm.save()" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}" required> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup()"><i class="fa fa-calendar"></i></button></span></div></div></div><div class="form-group-sm col-md-3"><label for="saleReference" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.saleReference">Sale Reference</label><div class="col-md-7"><input type="text" class="form-control" ng-value="vm.pharmaTransfReception.saleReference" ng-disabled="true"></div></div><div class="form-group-sm col-md-3"><label for="requisition" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.requisition">Requisition</label><div class="col-md-7"><input type="text" class="form-control" ng-value="vm.pharmaTransfReception.requisition" ng-disabled="true"></div></div></div><div class="row">&nbsp;</div><div class="row"><div class="form-group-sm col-md-3"><label for="originWarehouse" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.originWarehouse">Origin Warehouse</label><div class="col-md-7"><input type="text" class="form-control" ng-value="vm.getWarehouseFullDescription(vm.pharmaTransfReception.originWarehouse)" ng-disabled="true"></div></div><div class="form-group-sm col-md-3"><label for="destinationWarehouse" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.destinationWarehouse">Destination Warehouse</label><div class="col-md-7"><input type="text" class="form-control" ng-value="vm.getWarehouseFullDescription(vm.pharmaTransfReception.destinationWarehouse)" ng-disabled="true"></div></div><div class="form-group-sm col-md-3"><label for="transferType" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.transferType">Transfer Type</label><div class="col-md-7"><input type="text" class="form-control" ng-value="vm.getTransferTypeFullDescription(vm.pharmaTransfReception.transferType)" ng-disabled="true"></div></div><div class="form-group-sm col-md-3"><label for="username" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.username">Username</label><div class="col-md-7"><input type="text" class="form-control" ng-value="vm.pharmaTransfReception.username" ng-disabled="true"></div></div></div></form><blockquote ng-hide="vm.manualReceptionLines.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.pharmaTransfReception.message.noReceptionLines">No Reception Lines</blockquote><div class="table-responsive" ng-show="vm.manualReceptionLines.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.manualReceptionLines"><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="cnp"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.cnp">CNP</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="description"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.description">Description</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="vatRate"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.vatRate">VAT Rate</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="lot"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.lot">Lot</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="expirationDate"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.expirationDate">Expiration Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="receivedQuantity"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.receivedQuantity">Received Quantity</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="qualityStatus"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.qualityStatus">Quality Status</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="pharmaTransfReceptionLine in vm.manualReceptionLines | filter:filter | orderBy:predicate:reverse"><td class="table-left">{{pharmaTransfReceptionLine.cnp}}</td><td class="table-left">{{pharmaTransfReceptionLine.description}}</td><td class="text-right">{{pharmaTransfReceptionLine.vatRate | currency : \'%\' : 0}}</td><td class="form-group table-left" ng-class="{ \'text-danger\': pharmaTransfReceptionLine.lot.length < 1, \'has-error has-feedback\': pharmaTransfReceptionLine.lot.length < 1}"><span ng-show="pharmaTransfReceptionLine.editMode===\'\' || !pharmaTransfReceptionLine.editMode">{{pharmaTransfReceptionLine.lot | uppercase}}</span> <input ng-show="pharmaTransfReceptionLine.editMode!=\'\' && pharmaTransfReceptionLine.editMode" ng-class="{ \'alert-danger\': pharmaTransfReceptionLine.lot.length < 1}" type="text" class="form-control input-sm text-center" id="lot" name="lot" ng-model="pharmaTransfReceptionLine.lot" ng-model-options="{updateOn: \'blur\'}" size="15" maxlength="15" placeholder="{{\'pharmaPortalApp.pharmaTransfReception.line.lot\' | translate}}" ng-blur="vm.onBlurFromLot(pharmaTransfReceptionLine)"> <i class="fa fa-remove form-control-feedback"></i></td><td class="form-group"><span ng-show="pharmaTransfReceptionLine.editMode===\'\' || !pharmaTransfReceptionLine.editMode">{{pharmaTransfReceptionLine.expirationDate!=null && pharmaTransfReceptionLine.expirationDate != \'\' ? ("000000"+pharmaTransfReceptionLine.expirationDate).slice(-6) : \'\'}}</span> <input ng-show="pharmaTransfReceptionLine.editMode!=\'\' && pharmaTransfReceptionLine.editMode" type="text" class="form-control input-sm text-center" id="expirationDate" name="expirationDate" ng-model="pharmaTransfReceptionLine.expirationDate" size="6" maxlength="6" placeholder="{{\'pharmaPortalApp.pharmaTransfReception.line.expirationDate\' | translate}}" ng-blur="vm.save()"></td><td class="form-group"><span ng-show="pharmaTransfReceptionLine.editMode===\'\' || !pharmaTransfReceptionLine.editMode">{{pharmaTransfReceptionLine.receivedQuantity}}</span> <input ng-show="pharmaTransfReceptionLine.editMode!=\'\' && pharmaTransfReceptionLine.editMode" type="number" class="form-control input-sm text-center" ng-class="{ \'alert-danger\': pharmaTransfReceptionLine.receivedQuantity != pharmaTransfReceptionLine.invoicedQuantity + pharmaTransfReceptionLine.bonusQuantity}" id="receivedQuantity" name="receivedQuantity" step="0.001" ng-model="pharmaTransfReceptionLine.receivedQuantity" placeholder="{{\'pharmaPortalApp.pharmaTransfReception.line.receivedQuantity\' | translate}}" ng-init="pharmaTransfReceptionLine.errorOnReceivedQuantity = (pharmaTransfReceptionLine.receivedQuantity < 0 ? true : false); pharmaTransfReceptionLine.oldReceivedQuantity = pharmaTransfReceptionLine.receivedQuantity;" ng-blur="vm.onBlurFromReceivedQuantity(pharmaTransfReceptionLine)"> <i class="fa fa-remove form-control-feedback"></i></td><td class="form-group"><span ng-show="pharmaTransfReceptionLine.editMode===\'\' || !pharmaTransfReceptionLine.editMode">{{pharmaTransfReceptionLine.qualityStatus}}</span><ui-select ng-show="pharmaTransfReceptionLine.editMode!=\'\' && pharmaTransfReceptionLine.editMode" class="" id="qualityStatus" name="qualityStatus" ng-required="true" ng-model="pharmaTransfReceptionLine.qualityStatus" ng-disabled="vm.isSaving" on-select="vm.save()"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaTransfReception.line.qualityStatus\' | translate}}">{{$select.selected.code != \'\' ? $select.selected.code + \' - \' + $select.selected.description : \'&nbsp;\'}}</ui-select-match><ui-select-choices repeat="qualityStatus.code as qualityStatus in (vm.qualityStatuses | filter: $select.search)"><span ng-bind-html="qualityStatus.code != \'\' ? qualityStatus.code + \' - \' + qualityStatus.description : \'&nbsp;\' | highlight: $select.search"></span></ui-select-choices></ui-select></td><td class="text-center"><div class="btn-group"><button class="btn btn-primary btn-xs" ng-class="{ \'active\': pharmaTransfReceptionLine.editMode!=\'\' && pharmaTransfReceptionLine.editMode}" title="{{\'entity.action.edit\' | translate}}" ng-click="vm.togglePharmaTransfReceptionLineEditMode(pharmaTransfReceptionLine)"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}" ui-sref="pharma-transf-reception-line.delete({parentId: vm.pharmaTransfReception.id, lineId: pharmaTransfReceptionLine.id})"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="row"><div class="col-md-8"><form class="form-inline" id="importTemplateForm" name="importTemplateForm" style="display: inline"><div class="form-group"><input type="file" class="file" ngf-select ng-model="vm.pharmaTransfReception.file" name="file" ngf-pattern="\'.xls,.csv,.xlsx\'" accept=".xls,.csv,.xlsx" ngf-max-size="20MB" required ngf-model-invalid="errorFile" ng-disabled="vm.working"><div class="input-group input-group-sm"><span class="input-group-btn"><button class="browse btn btn-primary" type="button"><i class="fa fa-search"></i>&nbsp;<span translate="global.form.file">File</span></button> </span><input type="text" name="file" class="form-control" disabled="disabled"></div></div><script>$(\'.browse\').on(\'click\', function(event){ var file = $(this).parent().parent().parent().find(\'.file\'); file.trigger(\'click\'); });\n\t\t\t\t\t\t\t$(\'.file\').on(\'change\', function(event){ $(this).parent().find(\'.form-control\').val($(this).val().replace(/C:\\\\fakepath\\\\/i, \'\')); });</script><div class="form-group"><a type="submit" class="btn btn-info btn-sm" ng-click="importTemplateForm.$valid && !vm.working && vm.uploadFile(vm.pharmaTransfReception.file)" ng-disabled="!importTemplateForm.$valid || vm.working"><i class="fa fa-upload"></i>&nbsp;<span data-translate="entity.action.upload">Upload</span></a></div></form><a href="" ng-click="vm.getTemplate()" class="btn btn-info btn-sm" style="margin-left: 15px"><i class="fa fa-download"></i>&nbsp;<span data-translate="entity.action.downloadTemplate">Download template</span></a></div><div class="col-md-4"><div class="text-right"><button type="submit" ng-click="vm.backToReceptions()" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button><div class="btn-group dropup" uib-dropdown ng-show="vm.portalSettings.exportLogitoolsFile"><button type="button" class="btn btn-warning btn-sm dropdown-toggle" uib-dropdown-toggle><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span>&nbsp;<span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu><li><a ng-click="vm.exportToExcel()"><i class="fa fa-th-list"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaTransfReception.exportScreen">Screen info</span></a></li><li><a ng-click="vm.exportToLogitoolsExcel()"><i class="fa fa-map-signs"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaTransfReception.exportLogitoolsFile">Logitools file</span></a></li></ul></div><button type="submit" ng-click="vm.exportToExcel()" class="btn btn-warning btn-sm" ng-hide="vm.portalSettings.exportLogitoolsFile" ng-disabled="vm.manualReceptionLines.length < 1"><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span></button> <button type="submit" ng-click="vm.submitPharmaTransfReception()" class="btn btn-success btn-sm" ng-disabled="vm.manualReceptionLines.length < 1"><i class="fa fa-cloud-upload"></i>&nbsp;<span data-translate="entity.action.submit">Submit</span></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/pharma-transf-reception/pharma-transf-reception-line-delete-dialog.html','<form name="deleteReceptionLineForm" ng-submit="vm.confirmPharmaTransfReceptionLineDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaTransfReception.deleteLineDialog.title">Confirm Reception Header</h4></div><div class="modal-body"><p><span class="modal-title" data-translate="pharmaPortalApp.pharmaTransfReception.deleteLineDialog.body">Confirm Reception Line delete?</span></p><ul><li><span data-translate="pharmaPortalApp.pharmaTransfReception.line.cnp">CNP</span>: {{vm.pharmaTransfReceptionLine.cnp}}</li><li><span data-translate="pharmaPortalApp.pharmaTransfReception.line.description">Description</span>: {{vm.pharmaTransfReceptionLine.description}}</li><li><span data-translate="pharmaPortalApp.pharmaTransfReception.line.lot">Lot</span>: {{vm.pharmaTransfReceptionLine.lot}}</li><li><span data-translate="pharmaPortalApp.pharmaTransfReception.line.expirationDate">Expiration Date</span>: {{vm.pharmaTransfReceptionLine.expirationDate}}</li></ul></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger btn-sm" autofocus><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/pharma-transf-reception/pharma-transf-reception-line-new-dialog.html','<form name="createPharmaTransfReceptionLineForm" ng-submit="vm.createPharmaTransfReceptionLine()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaTransfReception.createPharmaTransfReceptionLineDialog.title">Create Pharma Reception Line</h4></div><div class="modal-body form-horizontal"><div class="row"><div class="form-group" ng-class="{ \'has-error\': createPharmaTransfReceptionLineForm.product.$invalid && createPharmaTransfReceptionLineForm.product.$dirty }"><label for="filterProduct_div" class="col-md-3 control-label input-sm label-required" data-translate="pharmaPortalApp.pharmaTransfReception.line.product">Product</label><div class="form-group-sm col-md-9" id="filterProduct_div"><ui-select id="filterProduct" ng-model="vm.pharmaTransfReceptionLine.product" reset-search-input="false" fix-selected-item uis-open-close="onOpenClose(isOpen)" class="manualHighlight" required><ui-select-match placeholder="{{\'global.form.search.placeholder.product\' | translate}}">{{$select.selected.cnp}} - {{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="product as product in vm.products track by product.cnp" refresh="refreshSelectModel($select.search)" refresh-delay="500" minimum-input-length="3"><span ng-bind-html="product.cnp +\' - \'+ product.fullHtmlName"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createPharmaTransfReceptionLineForm.lot.$invalid && createPharmaTransfReceptionLineForm.lot.$dirty }"><label for="lot" class="col-md-3 control-label input-sm label-required"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaTransfReception.line.hint.lot\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaTransfReception.line.lot\' | translate}}</label><div class="form-group col-md-9"><input type="text" class="form-control input-sm" id="lot" name="lot" size="15" maxlength="15" ng-model="vm.pharmaTransfReceptionLine.lot" placeholder="{{\'pharmaPortalApp.pharmaTransfReception.line.lot\' | translate}}" required ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createPharmaTransfReceptionLineForm.expirationDate.$invalid && createPharmaTransfReceptionLineForm.expirationDate.$dirty }"><label for="expirationDate" class="col-md-3 control-label input-sm label-required" data-translate="pharmaPortalApp.pharmaTransfReception.line.expirationDate">Expiration Date</label><div class="form-group col-md-9"><input type="text" class="form-control input-sm" id="expirationDate" name="expirationDate" size="6" maxlength="6" ng-model="vm.pharmaTransfReceptionLine.expirationDate" placeholder="{{\'pharmaPortalApp.pharmaTransfReception.line.expirationDate\' | translate}} (mmaaaa)" required ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createPharmaTransfReceptionLineForm.receivedQuantity.$invalid && createPharmaTransfReceptionLineForm.receivedQuantity.$dirty }"><label for="receivedQuantity" class="col-md-3 control-label input-sm label-required"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaTransfReception.line.hint.receivedQuantity\' | translate}}"><i class="fa fa-question-circle-o"></i></span> {{\'pharmaPortalApp.pharmaTransfReception.line.receivedQuantity\' | translate}}</label><div class="form-group col-md-9"><input type="number" class="form-control input-sm" id="receivedQuantity" name="receivedQuantity" min="0" step="0.001" ng-model="vm.pharmaTransfReceptionLine.receivedQuantity" placeholder="{{\'pharmaPortalApp.pharmaTransfReception.line.receivedQuantity\' | translate}}" required ng-disabled="vm.isSaving"></div></div></div><div class="row"><div class="form-group" ng-class="{ \'has-error\': createPharmaTransfReceptionLineForm.qualityStatus.$invalid && createPharmaTransfReceptionLineForm.qualityStatus.$dirty }"><label for="qualityStatus_div" class="col-md-3 control-label input-sm"><span tooltip-placement="top" uib-tooltip="{{\'pharmaPortalApp.pharmaTransfReception.line.hint.qualityStatus\' | translate}}"><i class="fa fa-question-circle-o"></i> </span>{{\'pharmaPortalApp.pharmaTransfReception.line.qualityStatus\' | translate}}</label><div class="form-group-sm col-md-9" id="qualityStatus_div"><ui-select id="qualityStatus" ng-model="vm.pharmaTransfReceptionLine.qualityStatus" ng-disabled="vm.isSaving"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaTransfReception.line.qualityStatus\' | translate}}">{{$select.selected.code != \'\' ? $select.selected.code + \' - \' + $select.selected.description : \'&nbsp;\'}}</ui-select-match><ui-select-choices repeat="qualityStatus.code as qualityStatus in (vm.qualityStatuses | filter: $select.search)"><span ng-bind-html="qualityStatus.code != \'\' ? qualityStatus.code + \' - \' + qualityStatus.description : \'&nbsp;\' | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div><span id="helpBlock" class="help-block text-right" style="margin-right: 20px"><span style="color: red">*</span> - {{\'pharmaPortalApp.pharmaTransfReception.line.mandatoryHelp\' | translate}}</span></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="!createPharmaTransfReceptionLineForm.$valid || vm.isSaving"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/pharma-transf-reception/pharma-transf-reception-line.html','<div></div>');
$templateCache.put('app/entities/pharma-transf-reception/pharma-transf-reception-new.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaTransfReception.new.title">New Pharma Warehouse Transfer Reception</span> <span class="clearfix"></span></div><div class="panel-body"><div class="container-fluid well well-sm"><div class="row"><div class="form-group-sm col-md-5" ng-class="{ \'has-error\': receptionForm.warehouse.$invalid && receptionForm.warehouse.$dirty }"><label for="warehouse" class="col-md-4 control-label" translate="pharmaPortalApp.pharmaTransfReception.destinationWarehouse">Destination Warehouse</label><div class="col-md-8"><ui-select id="destinationWarehouse" ng-required="true" ng-model="vm.destinationWarehouse" ng-disabled="vm.working" on-select="getReceptionsFromDestinationWarehouse($item, $model)"><ui-select-match placeholder="{{\'pharmaPortalApp.pharmaTransfReception.new.placeholder.destinationWarehouse\' | translate}}">{{$select.selected.code + \' - \' + $select.selected.description}}</ui-select-match><ui-select-choices repeat="warehouse.code as warehouse in (vm.warehouses | filter: $select.search)"><span ng-bind-html="warehouse.code + \' - \' + warehouse.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div ng-show="vm.destinationWarehouse"><blockquote ng-hide="vm.currentPharmaTransfReceptionHeader.length > 0" id="helpBlock" class="help-block">N\xE3o foram encontradas guias em aberto para o armaz\xE9m de destino selecionado</blockquote><div class="table-responsive" ng-show="vm.currentPharmaTransfReceptionHeader.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.currentPharmaTransfReceptionHeader"><thead><tr><th ng-click="sortType = autoSort; sortReverse = !sortReverse;"><span data-translate="pharmaPortalApp.pharmaTransfReception.originDate">Origin Date</span>&nbsp;<i class="fa fa-sort"></i></th><th ng-click="sortType = autoSort; sortReverse = !sortReverse;"><span data-translate="pharmaPortalApp.pharmaTransfReception.originWarehouse">Origin Warehouse</span>&nbsp;<i class="fa fa-sort"></i></th><th ng-click="sortType = autoSort; sortReverse = !sortReverse;"><span data-translate="pharmaPortalApp.pharmaTransfReception.clientDocument">Client Document</span>&nbsp;<i class="fa fa-sort"></i></th><th ng-click="sortType = autoSort; sortReverse = !sortReverse;"><span data-translate="pharmaPortalApp.pharmaTransfReception.transferType">Transfer Type</span>&nbsp;<i class="fa fa-sort"></i></th><th ng-click="sortType = autoSort; sortReverse = !sortReverse;"><span data-translate="pharmaPortalApp.pharmaTransfReception.client">Client</span>&nbsp;<i class="fa fa-sort"></i></th><th ng-click="sortType = autoSort; sortReverse = !sortReverse;"><span data-translate="pharmaPortalApp.pharmaTransfReception.billingType">Billing Type</span>&nbsp;<i class="fa fa-sort"></i></th><th ng-click="sortType = autoSort; sortReverse = !sortReverse;"><span data-translate="pharmaPortalApp.pharmaTransfReception.saleReference">Sale Reference</span>&nbsp;<i class="fa fa-sort"></i></th><th ng-click="sortType = autoSort; sortReverse = !sortReverse;"><span data-translate="pharmaPortalApp.pharmaTransfReception.requisition">Requisition</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="pharmaTransfReceptionHeader in vm.currentPharmaTransfReceptionHeader | filter:filter | orderBy:sortType:sortReverse"><td>{{pharmaTransfReceptionHeader.origindate | parseDate:\'ddMMyyyy\' | date:\'dd/MM/yyyy\'}}</td><td class="table-left">{{vm.getWarehouseFullDescription(pharmaTransfReceptionHeader.originwarehouse)}}</td><td class="table-left">{{pharmaTransfReceptionHeader.clientdocument}}</td><td class="table-left">{{vm.getTransferTypeFullDescription(pharmaTransfReceptionHeader.transfertype)}}</td><td class="table-left">{{vm.getClientFullDescription(pharmaTransfReceptionHeader.client)}}</td><td class="table-left">{{vm.getInvoiceTypeFullDescription(pharmaTransfReceptionHeader.billingtype)}}</td><td class="table-left">{{pharmaTransfReceptionHeader.salereference}}</td><td class="table-left">{{pharmaTransfReceptionHeader.requisition}}</td><td><div class="btn-group"><button class="btn btn-primary btn-xs" title="{{\'entity.action.receive\' | translate}}" ng-click="vm.save(pharmaTransfReceptionHeader.key)"><i class="fa fa-pencil"></i></button></div></td></tr></tbody></table></div></div></div><div class="panel-footer"><div class="text-right"><button type="button" ui-sref="pharma-transf-reception" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div></div></div></div>');
$templateCache.put('app/entities/pharma-transf-reception/pharma-transf-reception-new.inactive-dialog.html','<form name="confirmFullSearchForm" ng-submit="vm.confirmAddProducts()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><b>Aviso</b> - {{message.company}}</h4></div><div class="modal-body" id="modal-body"><any ng-switch="message.type"><any ng-switch-when="1"><p><b>Ponto de entrega deste cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate}}, {{message.regTime}}</p></any><any ng-switch-when="2"><p><b>Cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate | date : format : shortDate}}, {{message.regTime | date : \'hh:mm:ss\'}}</p></any></any></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/pharma-transf-reception/pharma-transf-reception-submit-dialog.html','<form name="submitReceptionHeaderForm" ng-submit="vm.confirmPharmaTransfReceptionSubmit()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.pharmaTransfReception.submitDialog.title">Confirm Reception Header</h4></div><div class="modal-body"><div class="container-fluid well well-sm" ng-submit="vm.save()" id="receptionForm" name="receptionForm"><div class="row"><div class="form-group-sm col-md-3"><label for="originDate" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.originDate">Origin Date</label><div class="col-md-7">{{vm.pharmaTransfReception.originDate | date: \'dd/MM/yyyy\'}}</div></div><div class="form-group-sm col-md-3" ng-class="{ \'has-error\': receptionForm.receptionDate.$invalid && receptionForm.receptionDate.$dirty }"><label for="receptionDate" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.receptionDate">Reception Date</label><div class="col-md-7">{{vm.pharmaTransfReception.receptionDate | date: \'dd/MM/yyyy\'}}</div></div><div class="form-group-sm col-md-3"><label for="saleReference" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.saleReference">Sale Reference</label><div class="col-md-7">{{vm.pharmaTransfReception.saleReference}}</div></div><div class="form-group-sm col-md-3"><label for="requisition" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.requisition">Requisition</label><div class="col-md-7">{{vm.pharmaTransfReception.requisition}}</div></div></div><div class="row">&nbsp;</div><div class="row"><div class="form-group-sm col-md-3"><label for="originWarehouse" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.originWarehouse">Origin Warehouse</label><div class="col-md-7">{{vm.getWarehouseFullDescription(vm.pharmaTransfReception.originWarehouse)}}</div></div><div class="form-group-sm col-md-3"><label for="destinationWarehouse" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.destinationWarehouse">Destination Warehouse</label><div class="col-md-7">{{vm.getWarehouseFullDescription(vm.pharmaTransfReception.destinationWarehouse)}}</div></div><div class="form-group-sm col-md-3"><label for="transferType" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.transferType">Transfer Type</label><div class="col-md-7">{{vm.getTransferTypeFullDescription(vm.pharmaTransfReception.transferType)}}</div></div><div class="form-group-sm col-md-3"><label for="username" class="col-md-5 control-label" translate="pharmaPortalApp.pharmaTransfReception.username">Username</label><div class="col-md-7">{{vm.pharmaTransfReception.username}}</div></div></div></div><div ng-hide="vm.hasDiffs"><p class="modal-title">N\xE3o foram encontradas diferen\xE7as nesta rece\xE7\xE3o.</p></div><div ng-show="vm.hasDiffs"><p class="modal-title">Foram detetadas diferen\xE7as nesta rece\xE7\xE3o.</p><div class="table-responsive" ng-show="vm.pharmaTransfReception.pharmaTransfReceptionLines.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.pharmaTransfReceptionLines"><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="cnp"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.cnp">CNP</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="description"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.description">Description</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="vatRate"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.vatRate">VAT Rate</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="invoicedQuantity"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.invoicedQuantity">Invoiced Quantity</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="receivedQuantity"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.receivedQuantity">Received Quantity</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="quantityDifferences"><span data-translate="pharmaPortalApp.pharmaTransfReception.line.quantityDifferences">Quantity Differences</span>&nbsp;<i class="fa fa-sort"></i></th></tr></thead><tbody><tr ng-repeat="pharmaTransfReceptionLine in vm.pharmaTransfReceptionLines | filter:filter | orderBy:predicate:reverse"><td class="table-left">{{pharmaTransfReceptionLine.cnp}}</td><td class="table-left">{{pharmaTransfReceptionLine.description}}</td><td class="text-right">{{pharmaTransfReceptionLine.vatrate | currency : \'%\' : 0}}</td><td class="text-right">{{pharmaTransfReceptionLine.invoicedquantity | number : 2}}</td><td class="text-right">{{pharmaTransfReceptionLine.receivedquantity | number : 2}}</td><td class="text-right text-danger">{{pharmaTransfReceptionLine.quantitydifferences | number : 2}}</td></tr></tbody></table></div></div><p><span class="modal-title" data-translate="pharmaPortalApp.pharmaTransfReception.submitDialog.body">Confirm Reception Header submit?</span></p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/pharma-transf-reception/pharma-transf-reception.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.pharmaTransfReception.home.title">Pharma Warehouse Transfer Receptions</span> <button type="button" class="btn btn-warning btn-sm pull-right" ui-sref="pharma-transf-reception.new"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.pharmaTransfReception.action.newReception">New Reception</span></button> <span class="clearfix"></span></div><div class="panel-body"><blockquote ng-hide="vm.pharmaTransfReceptionHeaders.length > 0" id="helpBlock" class="help-block" data-translate="pharmaPortalApp.pharmaTransfReception.message.noOpenReceptions">No Open Receptions</blockquote><div class="table-responsive" ng-show="vm.pharmaTransfReceptionHeaders.length > 0"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="vm.pharmaTransfReceptionHeaders"><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="receptionDate"><span data-translate="pharmaPortalApp.pharmaTransfReception.receptionDate">Reception Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="originWarehouse"><span data-translate="pharmaPortalApp.pharmaTransfReception.originWarehouse">Origin Warehouse</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="destinationWarehouse"><span data-translate="pharmaPortalApp.pharmaTransfReception.destinationWarehouse">Destination Warehouse</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="clientDocument"><span data-translate="pharmaPortalApp.pharmaTransfReception.clientDocument">Client Document</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="client"><span data-translate="pharmaPortalApp.pharmaTransfReception.client">Client</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="billingType"><span data-translate="pharmaPortalApp.pharmaTransfReception.billingType">Billing Type</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="saleReference"><span data-translate="pharmaPortalApp.pharmaTransfReception.saleReference">Sale Reference</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="requisition"><span data-translate="pharmaPortalApp.pharmaTransfReception.requisition">Requisition</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="transferType"><span data-translate="pharmaPortalApp.pharmaTransfReception.transferType">Transfer Type</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="originDate"><span data-translate="pharmaPortalApp.pharmaTransfReception.originDate">Origin Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="username"><span data-translate="pharmaPortalApp.pharmaTransfReception.username">Username</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="status"><span data-translate="pharmaPortalApp.pharmaTransfReception.status">Status</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="pharmaTransfReceptionHeader in vm.pharmaTransfReceptionHeaders | filter:filter | orderBy:predicate:reverse" ng-class="{\'warning\': pharmaTransfReceptionHeader.status == \'ERROR\', \'danger\': pharmaTransfReceptionHeader.status == \'BUSY\', \'success\': pharmaTransfReceptionHeader.status == \'SUBMITTED\'}"><td>{{pharmaTransfReceptionHeader.receptionDate | date:\'dd/MM/yyyy\'}}</td><td class="table-left">{{vm.getWarehouseFullDescription(pharmaTransfReceptionHeader.originWarehouse)}}</td><td class="table-left">{{vm.getWarehouseFullDescription(pharmaTransfReceptionHeader.destinationWarehouse)}}</td><td class="table-left">{{pharmaTransfReceptionHeader.clientDocument}}</td><td class="table-left">{{vm.getClientFullDescription(pharmaTransfReceptionHeader.client)}}</td><td class="table-left">{{vm.getInvoiceTypeFullDescription(pharmaTransfReceptionHeader.billingtype)}}</td><td class="table-left">{{pharmaTransfReceptionHeader.saleReference}}</td><td class="table-left">{{pharmaTransfReceptionHeader.requisition}}</td><td class="table-left">{{vm.getTransferTypeFullDescription(pharmaTransfReceptionHeader.transfertype)}}</td><td>{{pharmaTransfReceptionHeader.originDate | date:\'dd/MM/yyyy\'}}</td><td class="table-left">{{pharmaTransfReceptionHeader.username}}</td><td class="table-left">{{\'pharmaPortalApp.pharmaReceptionStatus.\'+pharmaTransfReceptionHeader.status | translate}}</td><td><div class="btn-group"><button class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}" ui-sref="pharma-transf-reception-detail({id:pharmaTransfReceptionHeader.id})"><span class="fa fa-search-plus"></span></button> <button class="btn btn-primary btn-xs" title="{{\'entity.action.edit\' | translate}}" ui-sref="pharma-transf-reception-edit({id:pharmaTransfReceptionHeader.id})" ng-disabled="{{pharmaTransfReceptionHeader.status != \'CREATED\'}}"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}" ui-sref="pharma-transf-reception.delete({id:pharmaTransfReceptionHeader.id})" ng-disabled="{{pharmaTransfReceptionHeader.status != \'CREATED\'}}"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/policy-definition/policy-definition-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p data-translate="pharmaPortalApp.policyDefinition.delete.question">Are you sure you want to delete this Policy Definition?</p><p data-ng-repeat="policyDefinition in records">{{vm.getPolicyDesc(policyDefinition)}}</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/policy-definition/policy-definition-edit-dialog.html','<form class="form-horizontal" name="editForm" ng-submit="vm.savePolicies()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><span translate="pharmaPortalApp.policyDefinition.home.title">Title</span> <span ng-if="multiplePolicyDefinition" data-translate="pharmaPortalApp.policyDefinition.multiplePolicyDefinitionMessage" translate-values=" {count: \'{{records.length}}\'}"></span></h4></div><div class="modal-body"><div class="policyDetail"><div class="panel panel-default" ng-if="policyDefinition"><div class="panel-body"><fieldset class="small" ng-if="(!newPolicy && !multiplePolicyDefinition) || saveState === 2"><legend translate="global.field.policyHierarchy">Policy Hierarchy</legend><div class="form-group" ng-repeat="field in policyDefinition.hierarchy.metadata"><label for="{{field.name}}" class="col-sm-4 control-label" translate="global.field.policyType.names.{{field.name}}">{{field.name}}</label><!-- if TEXT field --><div class="col-sm-8" ng-if="field.type==\'text\'"><input type="text" class="form-control" id="{{field.name}}" name="{{field.name}}" ng-model="policyDefinition.hierarchy[field.name]" ng-disabled="policyDefinition.id"></div><!-- if SELECT field --><div class="col-sm-8" ng-if="field.type==\'select\'"><ui-select id="{{field.name}}" name="{{field.name}}" focus-on="{{field.name}}_Select" ng-model="policyDefinition.hierarchy[field.name]" ng-change="vm.addToSelectList($select)" ng-disabled="policyDefinition.id"><ui-select-match allow-clear="true">{{$select.selected.selectLabel}}</ui-select-match><ui-select-choices repeat="option in policyDefinition.hierarchy[field.name+\'_list\'] | orderBy: \'name\' | filter: $select.search track by $index"><div ng-bind-html="option.selectLabel | highlight: $select.search"></div></ui-select-choices></ui-select></div><!-- if SEARCH SELECT field --><div class="col-sm-8" ng-if="field.type==\'searchSelect\'"><ui-select id="{{field.name}}" name="{{field.name}}" focus-on="{{field.name}}_Select" ng-model="policyDefinition.hierarchy[field.name]" ng-change="vm.addToSelectList($select)" ng-disabled="policyDefinition.id"><ui-select-match allow-clear="true">{{$select.selected.selectLabel}}</ui-select-match><ui-select-choices repeat="option in policyDefinition.hierarchy[field.name+\'_list\'] | orderBy: \'name\' | filter: $select.search track by $index" refresh="refreshSelectModel($select.search, field.url, field.name)" refresh-delay="500" minimum-input-length="3"><div ng-bind-html="option.selectLabel | highlight: $select.search"></div></ui-select-choices></ui-select></div><!-- if ENUM field --><div class="col-sm-8" ng-if="field.type==\'enum\'"><ui-select id="{{field.name}}" name="{{field.name}}" focus-on="{{field.name}}_Select" ng-model="policyDefinition.hierarchy[field.name]" ng-change="vm.addToSelectList($select)" ng-disabled="policyDefinition.id"><ui-select-match allow-clear="true">{{\'context.\' + $select.selected | translate}}</ui-select-match><ui-select-choices repeat="option in policyDefinition.hierarchy[field.name+\'_list\'] | prefixTranslate : $select.search : \'context.\' track by $index"><div ng-bind-html="\'context.\'+option | translate | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></fieldset><fieldset class="small" ng-if="saveState !== 2"><legend translate="global.field.policyImplementation">Policy Implementation</legend><div class="form-group" ng-if="policyImplementations"><label class="col-sm-4 control-label"><span translate="global.field.policyImplementation">Policy Implementation</span> <span ng-show="policyDefinition.policyImplementation" tooltip-placement="right" tooltip-append-to-body="true" uib-tooltip-html="vm.translateString(\'help.\'+policyDefinition.policyImplementation)"><i class="fa fa-question-circle-o"></i></span></label><div class="col-sm-8"><ui-select id="policyImplementation" name="policyImplementation" ng-model="policyDefinition.policyImplementation" ng-change="updateInputs()"><ui-select-match allow-clear="true">{{$select.selected | translate}}</ui-select-match><ui-select-choices repeat="option in policyImplementations | orderBy: \'name\' | prefixTranslate : $select.search track by $index"><div ng-bind-html="option | translate | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="form-group" ng-repeat="field in policyDefinition.input.metadata"><label for="{{field.name}}" class="col-sm-4 control-label col-md-offset-{{field.indent}}" translate="global.field.policyInput.names.{{field.name}}">{{field.name}}</label><div class="col-sm-{{8-field.indent}}"><!-- if TEXT field --> <input type="text" ng-if="field.type==\'text\'" class="form-control" id="{{field.name}}" name="{{field.name}}" ng-model="policyDefinition.input[field.name]" price><!-- if Percent (Min:-100 | Max:100) field --> <input type="number" ng-if="field.type==\'percentMinMax\'" class="form-control" id="{{field.name}}" name="{{field.name}}" min="-100" max="100" ng-model="policyDefinition.input[field.name]" price><div class="has-error" ng-if="field.type==\'percentMinMax\'"><div class="help-block no-margin"><ul class="list-unstyled no-margin"><li ng-show="editForm.{{field.name}}.$error.max">{{"entity.validation.max" | translate:\'{ max: "100" }\'}}</li><li ng-show="editForm.{{field.name}}.$error.min">{{"entity.validation.min" | translate:\'{ min: "-100" }\'}}</li><li ng-show="editForm.{{field.name}}.$error.number">{{"entity.validation.number" | translate}}</li></ul></div></div><!-- if BOOLEAN field --><div class="checkbox" ng-if="field.type==\'boolean\'"><label><input type="checkbox" id="{{field.name}}" name="{{field.name}}" ng-model="policyDefinition.input[field.name]"> <span class="checkbox-material"><span class="check"></span></span></label></div><!-- if DATE field --> <input type="datetime" ng-if="field.type==\'date\'" class="form-control" id="{{field.name}}" name="{{field.name}}" ng-disabled="policyDefinition.hierarchy && policyDefinition.hierarchy.hash===\'\' && field.name==\'expirationDate\'" ng-model="policyDefinition.input[field.name]"><!-- if LIST field --><div ng-if="field.type==\'list\'" class="form-horizontal"><div ng-repeat="item in policyDefinition.input[field.name] track by $index" class="form-group"><label class="col-sm-1 control-label">{{$index + 1}}</label><div class="col-sm-8"><input type="text" ng-model="policyDefinition.input[field.name][$index]" class="form-control input-sm" price></div><div class="col-sm-1"><span class="btn btn-danger btn-xs" ng-click="policyDefinition.input[field.name].splice($index, 1)" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></span></div></div><div><span class="btn btn-sm btn-success" ng-click="addNew(field.name)"><i class="fa fa-plus"></i> {{"entity.action.addnew" | translate}} </span><span class="btn btn-sm btn-success" ng-click="addNew12(field.name)"><i class="fa fa-plus"></i> {{"entity.action.addnew12" | translate}}</span></div></div><!-- if ENUM field --><div class="col-sm-8" ng-if="field.type==\'enum\'"><ui-select id="{{field.name}}" name="{{field.name}}" focus-on="{{field.name}}_Select" ng-model="policyDefinition.input[field.name]" ng-change="vm.addToSelectList($select)" ng-disabled="policyDefinition.id"><ui-select-match allow-clear="true">{{\'context.\' + $select.selected | translate}}</ui-select-match><ui-select-choices repeat="option in policyDefinition.input[field.name+\'_list\'] | prefixTranslate : $select.search : \'global.field.policyInput.names.\' track by $index"><div ng-bind-html="\'global.field.policyInput.names.\'+option | translate | highlight: $select.search"></div></ui-select-choices></ui-select></div><!-- if SELECT field --><div ng-if="field.type==\'select\'"><ui-select id="{{field.name}}" name="{{field.name}}" ng-model="policyDefinition.input[field.name]"><ui-select-match allow-clear="true">{{$select.selected.selectLabel}}</ui-select-match><ui-select-choices repeat="option in policyDefinition.input[field.name+\'_list\'] | orderBy: \'name\' | filter: $select.search track by $index"><div ng-bind-html="option.selectLabel | highlight: $select.search"></div></ui-select-choices></ui-select></div><!-- if LIST SELECT field --><div ng-if="field.type==\'listSelect\'" class="form-horizontal"><div ng-repeat="item in policyDefinition.input[field.name] track by $index" class="form-group"><label class="col-sm-1 control-label">{{$index + 1}}</label><div class="col-sm-8" ng-if="field.type==\'listSelect\'"><ui-select id="{{field.name}}" name="{{field.name}}" ng-model="policyDefinition.input[field.name][$index]"><ui-select-match allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="option in policyDefinition.input[field.name+\'_list\'] | filter: $select.search track by $index"><div ng-bind-html="option.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-1"><span class="btn btn-danger btn-xs" ng-click="policyDefinition.input[field.name].splice($index, 1)" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></span></div></div><div><span class="btn btn-sm btn-success" ng-click="addNew(field.name)"><i class="fa fa-plus"></i> {{"entity.action.addnew" | translate}}</span></div></div><!-- if TYPEAHEAD field --><div ng-if="field.type==\'listSelectTypeAHead\'" class="form-horizontal"><div ng-repeat="item in policyDefinition.input[field.name] track by $index" class="container-fluid"><label class="col-sm-1 control-label">{{$index + 1}}</label><div class="col-sm-8"><ui-select reach-infinity="requestMoreItems(field)" ng-model="policyDefinition.input[field.name][$index]"><ui-select-match placeholder="Insira Nome">{{$select.selected.name}}</ui-select-match><ui-select-choices refresh="refreshList(field , $select.search)" refresh-delay="250" repeat="item in typeaheadArray | filter: filter: $select.search track by $index" ui-disable-choice="collection.disabled"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-1"><span class="btn btn-danger btn-xs" ng-click="policyDefinition.input[field.name].splice($index, 1);" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></span></div></div><div><span class="btn btn-sm btn-success" ng-click="addNew(field.name)"><i class="fa fa-plus"></i> {{"entity.action.addnew" | translate}}</span></div></div><!-- if EXCEL IMPORTED LIST field --><div ng-if="field.type==\'excelImportedList\'"><div class="btn-group btn-group-justified" role="group"><div class="btn-group" role="group"><button class="btn btn-warning btn-sm" ng-click="vm.getTemplate(field.templatePath)"><i class="fa fa-download"></i>&nbsp;<span data-translate="entity.action.downloadTemplate">Download template</span></button></div><div class="btn-group" role="group"><button type="button" class="btn btn-success btn-sm" ui-sref="{{field.listStateName}}-import({ id : policyDefinition.input.id})" ng-disabled="!policyDefinition.input.id"><i class="fa fa-upload"></i>&nbsp;<span data-translate="entity.action.uploadExcel">Upload excel</span></button></div><div class="btn-group" role="group"><button type="button" class="btn btn-primary btn-sm" ui-sref="{{field.listStateName}}-export({ id : policyDefinition.input.id})" ng-disabled="!policyDefinition.input.id"><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export to excel</span></button></div><div class="btn-group" role="group"><button type="button" class="btn btn-info btn-sm" ui-sref="{{field.listStateName}}-list({ id : policyDefinition.input.id})" ng-disabled="!policyDefinition.input.id"><i class="fa fa-search-plus"></i>&nbsp;<span data-translate="entity.action.view">View</span></button></div></div></div></div></div></fieldset></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button ng-if="vm.isValidToDelete()" type="button" class="btn btn-danger btn-sm" ng-click="vm.deletePolicies()"><i class="fa fa-trash-o"></i>&nbsp;<span translate="entity.action.delete">Delete</span></button> <button ng-if="vm.isImplDefined() && saveState === 1" type="button" class="btn btn-warning btn-sm" data-dismiss="modal" ng-click="vm.nextSaveState()"><i class="fa fa-chevron-right"></i> <span data-translate="entity.action.next">Next</span></button> <button ng-if="saveState === 2" type="button" class="btn btn-warning btn-sm" data-dismiss="modal" ng-click="vm.previousSaveState()"><i class="fa fa-chevron-left"></i> <span data-translate="entity.action.previous">Previous</span></button> <button ng-if="!newPolicy || saveState === 2" type="submit" class="btn btn-success btn-sm" data-dismiss="modal" ng-disabled="!vm.isImplDefined() || editForm.$invalid || vm.isSaving" autofocus><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/policy-definition/policy-definitions.html','<div><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left"><label class="control-label" translate="pharmaPortalApp.policyDefinition.home.selectedPolicy">Selected policy:</label></span><div class="col-md-8 pull-left"><ui-select id="selectedPolicyType" name="selectedPolicyType" ng-model="policyType" ng-change="vm.policyTypeSelection($select.selected)" class="ui-select-sm"><ui-select-match allow-clear="true" placeholder="{{\'pharmaPortalApp.policyDefinition.home.noSelection\' | translate}}">{{$select.selected.name | translate}}</ui-select-match><ui-select-choices repeat="policyType as policyType in (policyTypes | filter: $select.search) | orderBy:\'name\' track by $index"><div ng-bind-html="policyType.fqn | translate | highlight: $select.search"></div></ui-select-choices></ui-select></div><span class="clearfix"></span></div><div class="panel-body"><div class="row" ng-show="policyType"><div class="col tree"><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><div class="row" style="padding-bottom: 15px"><div class="btn-group pull-right" style="padding-right: 15px"><button type="button" ng-if="!showFilter" class="btn btn-primary btn-sm" ng-click="vm.toggleFilter()"><i class="fa fa-search"></i> <span class="hidden-sm hidden-xs" translate="global.filter.search">Pesquisar</span></button></div></div><div class="row" style="padding-bottom: 15px" ng-if="showFilter"><div class="col-sm-8" ng-repeat="field in searchPolicyDefinition.hierarchy.metadata"><label for="{{field.name}}" class="col-sm-8 control-label" translate="global.field.policyType.names.{{field.name}}">{{field.name}}</label><div class="col-sm-8" ng-if="field.type==\'text\'"><!-- if TEXT field --> <input type="text" class="form-control" id="{{field.name}}" name="{{field.name}}" ng-model="searchPolicyDefinition.hierarchy[field.name]" ng-change="filterObject[field.name]=searchPolicyDefinition.hierarchy[field.name]"></div><div class="col-sm-8" ng-if="field.type==\'select\'"><!-- if SELECT field --><ui-select id="{{field.name}}" name="{{field.name}}" focus-on="{{field.name}}_Select" ng-model="searchPolicyDefinition.hierarchy[field.name]" ng-change="filterObject[field.name]=searchPolicyDefinition.hierarchy[field.name]"><ui-select-match allow-clear="true">{{$select.selected.selectLabel}}</ui-select-match><ui-select-choices repeat="option in searchPolicyDefinition.hierarchy[field.name+\'_list\'] | orderBy: \'name\' | filter: $select.search track by $index"><div ng-bind-html="option.selectLabel | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-8" ng-if="field.type==\'searchSelect\'"><!-- if SEARCH SELECT field --><ui-select id="{{field.name}}" name="{{field.name}}" focus-on="{{field.name}}_Select" ng-model="searchPolicyDefinition.hierarchy[field.name]" ng-change="filterObject[field.name]=searchPolicyDefinition.hierarchy[field.name]"><ui-select-match allow-clear="true">{{$select.selected.selectLabel}}</ui-select-match><ui-select-choices repeat="option in searchPolicyDefinition.hierarchy[field.name+\'_list\'] | orderBy: \'name\' | filter: $select.search track by $index" refresh="refreshSelectModelForSearchPolicyDefinition($select.search, field.url, field.name)" refresh-delay="500" minimum-input-length="3"><div ng-bind-html="option.selectLabel | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-sm-8" ng-if="field.type==\'enum\'"><!-- if ENUM field --><ui-select id="{{field.name}}" name="{{field.name}}" ng-model="searchPolicyDefinition.hierarchy[field.name]" ng-change="filterObject[field.name]=searchPolicyDefinition.hierarchy[field.name]"><ui-select-match allow-clear="true">{{\'context.\' + $select.selected | translate}}</ui-select-match><ui-select-choices repeat="option in searchPolicyDefinition.hierarchy[field.name+\'_list\'] | prefixTranslate : $select.search : \'context.\' track by $index"><div ng-bind-html="\'context.\'+option | translate | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-sm-8"><label for="selectImpl" class="col-sm-8 control-label" translate="global.field.policyImplementation">policyImplementation</label><div class="col-sm-8"><ui-select id="selectImpl" name="selectImpl" ng-model="selectedImpl" ng-change="filterObject[\'selectedImpl\']=$select.selected"><ui-select-match allow-clear="true">{{$select.selected | translate}}</ui-select-match><ui-select-choices repeat="policyOption in policyImplementationsSelector | orderBy: this | prefixTranslate : $select.search track by $index"><div ng-bind-html="policyOption | translate | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row" style="padding-bottom: 15px" ng-if="showFilter"><div class="btn-group pull-right" style="padding-right: 15px"><!-- <button type="button"\n                                             class="btn btn-warning btn-sm"\n                                             ng-click="vm.startFilter()">\n                                         <i class="fa fa-search"></i>\n                                         <span class="hidden-sm hidden-xs"\n                                               translate="global.filter.search">Pesquisar</span>\n                                     </button>\n                                    --> <button type="button" class="btn btn-dark btn-sm" ng-click="vm.clearFilter()"><i class="fa fa-trash-o"></i> <span class="hidden-sm hidden-xs" translate="global.filter.clear">Limpar</span></button></div></div><div class="row" style="padding-bottom: 15px"><div class="btn-group pull-left" style="padding-left: 15px"><button type="button" class="btn btn-info btn-sm" ng-click="vm.expandAll()"><i class="fa fa-plus-square"></i>&nbsp;<span class="hidden-sm hidden-xs" translate="entity.action.expandAll">Expand all</span></button> <button type="button" class="btn btn-default btn-sm" ng-click="vm.collapseAll()"><i class="fa fa-minus-square"></i>&nbsp;<span class="hidden-sm hidden-xs" translate="entity.action.collapseAll">Collapse all</span></button></div><div class="btn-group pull-right" style="padding-right: 15px"><button type="button" class="btn btn-warning btn-sm" ng-click="vm.openModalForNewPolicy()"><i class="fa fa-plus"></i>&nbsp;<span class="hidden-xs" translate="pharmaPortalApp.policyDefinition.home.createLabel">Create a new policy</span></button> <button type="button" class="btn btn-default btn-sm" ng-click="vm.openModalEditForSelection()"><i class="fa fa-search"></i>&nbsp;<span class="hidden-xs" translate="pharmaPortalApp.policyDefinition.viewDetails">View Details</span></button></div><span class="clearfix"></span></div><div class="row" style="padding-bottom: 15px"><div class="pull-right" style="padding-right: 15px"><label for="selectAll" translate="entity.action.selectAll">Select All</label><input type="checkbox" id="selectAll" name="selectAll" ng-model="isSelectAll" ng-change="vm.toggleSelectAll()"></div></div></div><div class="panel-body"><!-- Nested node template --><script type="text/ng-template" id="policyTreeNode.html"><ANY ng-switch="vm.isPolicyDefinitionNode(node)" ng-if="vm.showNode(node)">\n                                    <ANY ng-switch-when="true">\n                                        <div ng-click="vm.toggleNode(this)" style="z-index:0;">\n                                            <ng-include src="\'policyDefinitionNode.html\'"/>\n                                        </div>\n                                    </ANY>\n                                    <ANY ng-switch-when="false">\n                                        <div ng-class="vm.hasPolicyDefinitionNode(node) ? \'col-md-5\' : \'col-md-12\'"\n                                             ng-click="vm.toggleNode(this)" style="z-index:1;">\n                                            <i ng-class="{\'fa fa-minus-square-o\':!collapsed, \'fa fa-plus-square-o\': collapsed}"></i>&nbsp;{{vm.stringEntity(node.data)}}\n                                        </div>\n\n                                        <ol ui-tree-nodes="" ng-model="node.children" ng-class="{\'hidden\':collapsed}">\n                                            <li class="row" ng-repeat="node in node.children" ui-tree-node\n                                                ng-include="\'policyTreeNode.html\'"></li>\n                                        </ol>\n                                    </ANY>\n                                </ANY></script><script type="text/ng-template" id="policyDefinitionNode.html"><div class="col-sm" ng-style="{\'border-bottom\': \'1px solid #9acfea\'}">\n                                    <span id="node_{{node.data.id}}" ng-click="vm.selectNode(this,true)"\n                                          ng-class="{\'text-danger\':node.data.input.expired, \'text-warning\':node.data.input.expiring }">\n                                        <span><i class="fa fa-cogs"\n                                                 ng-class="{\'text-warning\': selectedPolicyDefinition === node.data, \'text-primary\': selectedPolicyDefinition !== node.data  }"></i> {{node.data.policyImplementation | translate}}</span>\n                                        <ANY>\n                                            <span> <b>{{node.data.input.metadataValues}}</b></span>\n                                            <span\n                                                ng-show="node.data.input.expirationDate">[{{node.data.input.expirationDate}}]</span>\n                                            <span><i class="fa"\n                                                     ng-class="{\'fa-check-circle text-success\' : node.data.input.showMsgIfSuccess, \'fa-times-circle text-danger\' : node.data.input.showMsgIfSuccess != true}"></i></span>\n                                            <span><i class="fa"\n                                                     ng-class="{\'fa-check-circle text-success\' : node.data.input.showMsgIfNotSuccess, \'fa-times-circle text-danger\' : node.data.input.showMsgIfNotSuccess != true}"></i></span>\n                                         </ANY>\n                                    </span>\n                                    <input type="checkbox" class="pull-right" id="{{field.name}}" name="{{field.name}}"\n                                           ng-model="node.selected"\n                                           ng-change="vm.updateSelection(node.data, node.selected)">\n                                </div>\n                                <span class="clearfix"></span></script><div ui-tree><ol ui-tree-nodes="" ng-model="policyDefinitions.children" id="tree-root"><li ng-repeat="node in policyDefinitions.children | orderBy:\'node.data.hierarchy\'" ui-tree-node ng-include="\'policyTreeNode.html\'"></li></ol></div></div></div></div></div><div class="row" ng-show="!policyType"><div class="col-md-12"><div class="jumbotron text-center" ng-hide="productsList.length"><h4><i class="fa fa-slack fa-3x"></i>&nbsp;&nbsp;&nbsp;Selecione uma pol\xEDtica no topo da p\xE1gina</h4></div></div></div></div></div></div>');
$templateCache.put('app/entities/portal-app/portal-app-board.html','<div><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left" data-translate="pharmaPortalApp.portalApps.home.title">Portal Apps</span> <span class="clearfix"></span></div><div class="panel-body"><div ng-repeat="portalApp in vm.portalApps track by portalApp.id"><div class="app_box col-lg-2 col-md-4 col-sm-6"><a href="{{portalApp.link}}" target="_blank" class="app_link"><span class="row text-center"><img data-ng-src="{{\'data:\' + portalApp.thumbnailContentType + \';base64,\' + portalApp.thumbnail}}"> </span><span class="row text-center">{{portalApp.title}}</span></a></div></div></div></div></div>');
$templateCache.put('app/entities/portal-app/portal-app-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.report.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p data-translate="pharmaPortalApp.portalApp.delete.question" translate-values="{id: \'{{vm.report.title}}\'}">Are you sure you want to delete this Report?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm" autofocus><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/portal-app/portal-app-detail.html','<div><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left" data-translate="pharmaPortalApp.portalApp.detail.title">Portal App</span>&nbsp;{{vm.portalApp.id}} <span class="clearfix"></span></div><div class="panel-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.portalApp.title">Title</span></dt><dd><span>{{vm.portalApp.title}}</span></dd><dt><span data-translate="pharmaPortalApp.portalApp.link">Link</span></dt><dd><span>{{vm.portalApp.link}}</span></dd><dt><span data-translate="pharmaPortalApp.portalApp.thumbnail">Thumbnail</span></dt><dd><div ng-if="vm.portalApp.thumbnail"><a ng-click="vm.openFile(vm.portalApp.thumbnailContentType, vm.portalApp.thumbnail)"><img data-ng-src="{{\'data:\' + vm.portalApp.thumbnailContentType + \';base64,\' + vm.portalApp.thumbnail}}" style="max-width: 200px" alt="portalApp image"></a></div></dd></dl></div><div class="panel-footer"><div class="text-right"><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="button" ui-sref="portal-app-detail.edit({id:vm.portalApp.id})" class="btn btn-primary btn-sm"><i class="fa fa-pencil"></i>&nbsp;<span data-translate="entity.action.edit">Edit</span></button></div></div></div></div>');
$templateCache.put('app/entities/portal-app/portal-app-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPortalAppLabel" data-translate="pharmaPortalApp.portalApp.home.createOrEditLabel">Create or edit a Portal App</h4></div><div class="modal-body"><input type="hidden" class="form-control" name="id" id="id" ng-model="vm.portalApp.id"><div class="form-group"><label class="control-label" data-translate="pharmaPortalApp.portalApp.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.portalApp.title"></div><div class="form-group"><label class="control-label" data-translate="pharmaPortalApp.portalApp.link" for="field_link">Link</label><input type="text" class="form-control" name="link" id="field_link" ng-model="vm.portalApp.link"></div><div class="form-group" ngf-drop ngf-change="vm.setThumbnail($file, vm.portalApp)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="pharmaPortalApp.portalApp.thumbnail" for="field_thumbnail_button">Thumbnail</label><div><img data-ng-src="{{\'data:\' + vm.portalApp.thumbnailContentType + \';base64,\' + vm.portalApp.thumbnail}}" style="max-height: 100px" ng-if="vm.portalApp.thumbnail" alt="portalApp image"><div class="help-block clearfix"><button type="button" id="field_thumbnail_button" ngf-select class="btn btn-warning btn-sm" ngf-change="vm.setThumbnail($file, vm.portalApp)" accept="image/*"><i class="fa fa-picture-o"></i>&nbsp;<span data-translate="entity.action.addimage">Add image</span></button> <span ng-if="vm.portalApp.thumbnail"><button type="button" ng-click="vm.portalApp.thumbnail=null;vm.portalApp.thumbnailContentType=null;" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button> <span>{{vm.portalApp.thumbnailContentType}}, {{vm.byteSize(vm.portalApp.thumbnail)}}</span></span></div></div><input type="hidden" class="form-control" name="thumbnail" id="field_thumbnail" ng-model="vm.portalApp.thumbnail"> <input type="hidden" class="form-control" name="thumbnailContentType" id="field_thumbnailContentType" ng-model="vm.portalApp.thumbnailContentType"></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/portal-app/portal-apps.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.portalApp.home.title">Portal Apps</span> <button class="btn btn-warning btn-sm pull-right" ui-sref="portal-app.new"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.portalApp.home.createLabel">Create new Portal App</span></button> <span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="title"><span data-translate="pharmaPortalApp.portalApp.title">Title</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="link"><span data-translate="pharmaPortalApp.portalApp.link">Link</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="portalApp in vm.portalApps | filter:filter | orderBy:predicate:reverse track by portalApp.id"><td class="table-left">{{portalApp.title}}</td><td class="table-left">{{portalApp.link}}</td><td><div class="btn-group"><button type="submit" ui-sref="portal-app-detail({id:portalApp.id})" class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}"><i class="fa fa-search-plus"></i></button> <button type="submit" ui-sref="portal-app.edit({id:portalApp.id})" class="btn btn-primary btn-xs" title="{{\'entity.action.edit\' | translate}}"><i class="fa fa-pencil"></i></button> <button type="submit" ui-sref="portal-app.delete({id:portalApp.id})" class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/portal-notification/portal-notification-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.portalNotification.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p data-translate="pharmaPortalApp.portalNotification.delete.question" translate-values="{id: \'{{vm.portalNotification.id}}\'}">Are you sure you want to delete this PortalNotification?</p></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-sm btn-danger"><span class="fa fa-trash-o"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/portal-notification/portal-notification-detail.html','<div><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left"><b><span data-translate="pharmaPortalApp.portalNotification.subject">Subject</span>:&nbsp;</b> {{vm.portalNotification.subject}} </span><span class="clearfix"></span></div><div class="panel-body"><div class="container-fluid"><div class="col-sm-4"><label translate="pharmaPortalApp.portalNotification.date">Date</label><div class="form-group">{{vm.portalNotification.date | date:\'medium\'}}</div></div><div class="col-sm-4"><label translate="pharmaPortalApp.portalNotification.priority">Priority</label><div class="form-group"><i ng-show="vm.portalNotification.priority == \'HIGH\'" class="fa fas fa-2x fa-arrow-up text-danger" title="{{\'PortalNotificationPriority.\' + vm.portalNotification.priority | translate}}"></i> <i ng-show="vm.portalNotification.priority == \'MEDIUM\'" class="fa fas fa-2x fa-arrow-right text-warning" title="{{\'PortalNotificationPriority.\' + vm.portalNotification.priority | translate}}"></i> <i ng-show="vm.portalNotification.priority == \'LOW\'" class="fa fas fa-2x fa-arrow-down text-success" title="{{\'PortalNotificationPriority.\' + vm.portalNotification.priority | translate}}"></i></div></div><div class="col-sm-4"><label translate="pharmaPortalApp.portalNotification.category">Category</label><div class="form-group"><i ng-show="vm.portalNotification.category == \'ERROR\'" class="fa fas fa-2x fa-times text-danger" title="{{\'PortalNotificationCategory.\' + vm.portalNotification.category | translate}}"></i> <i ng-show="vm.portalNotification.category == \'INFO\'" class="fa fas fa-2x fa-info-circle text-info" title="{{\'PortalNotificationCategory.\' + vm.portalNotification.category | translate}}"></i> <i ng-show="vm.portalNotification.category == \'MESSAGE\'" class="fa fas fa-2x fa-comments text-primary" title="{{\'PortalNotificationCategory.\' + vm.portalNotification.category | translate}}"></i></div></div></div><div class="container-fluid"><div class="col-sm-4"><label translate="pharmaPortalApp.portalNotification.notificationToUser">PortalNotification To User</label><div class="form-group">{{vm.portalNotification.portalNotificationToUserLogin}}</div></div><div class="col-sm-4" ng-if="vm.portalNotification.destinationLogin"><label translate="pharmaPortalApp.portalNotification.destination">Destination</label><div class="form-group">{{vm.portalNotification.destinationLogin}}</div></div><div class="col-sm-4" ng-if="vm.portalNotification.companyDestinationComercialName"><label translate="pharmaPortalApp.portalNotification.companyDestination">Company Destination</label><div class="form-group">{{vm.portalNotification.companyDestinationComercialName}}</div></div></div><div class="container-fluid"><div class="col-sm-12"><label translate="pharmaPortalApp.portalNotification.message">Message</label><div class="form-group"><div class="panel panel-default"><div class="panel-body">{{vm.portalNotification.message}}</div></div></div></div></div></div><div class="panel-footer"><div class="text-right"><button ui-sref="portal-notification" class="btn btn-sm btn-default"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div></div></div></div>');
$templateCache.put('app/entities/portal-notification/portal-notification-dialog.html','<form class="form-horizontal" novalidate name="editForm" role="form" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.portalNotification.home.createOrEditLabel">Create or edit a PortalNotification</h4></div><div class="modal-body"><input type="hidden" name="id" ng-model="vm.portalNotification.id"><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.portalNotification.subject" for="field_subject">Subject</label><div class="col-sm-10"><input type="text" class="form-control" name="subject" id="field_subject" ng-model="vm.portalNotification.subject" required ng-minlength="3"><div ng-show="editForm.subject.$invalid"><p class="help-block" ng-show="editForm.subject.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.subject.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="3">This field is required to be at least 3 characters.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.portalNotification.message" for="field_message">Message</label><div class="col-sm-10"><textarea class="form-control" name="message" id="field_message" ng-model="vm.portalNotification.message" rows="5" required ng-minlength="5"></textarea><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.message.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="5">This field is required to be at least 5 characters.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.portalNotification.category" for="field_category">Category</label><div class="col-sm-10" id="field_category"><ui-select name="category" ng-model="vm.portalNotification.category" required><ui-select-match allow-clear="true">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="category.value as category in vm.categories | filter: $select.search"><span ng-bind-html="category.label | highlight: $select.search"></span></ui-select-choices></ui-select><div ng-show="editForm.category.$invalid"><p class="help-block" ng-show="editForm.category.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.portalNotification.priority" for="field_priority">Priority</label><div class="col-sm-10" id="field_priority"><ui-select name="priority" ng-model="vm.portalNotification.priority" required><ui-select-match allow-clear="true">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="priority.value as priority in vm.priorities | filter: $select.search"><span ng-bind-html="priority.label | highlight: $select.search"></span></ui-select-choices></ui-select><div ng-show="editForm.priority.$invalid"><p class="help-block" ng-show="editForm.priority.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.portalNotification.destination" for="field_destination">Destination</label><div class="col-sm-10" id="field_destination"><ui-select name="destination" ng-model="vm.portalNotification.destinationId"><ui-select-match allow-clear="true">{{$select.selected.login}}</ui-select-match><ui-select-choices repeat="user.id as user in vm.users | filter: $select.search"><span ng-bind-html="user.login | highlight: $select.search"></span></ui-select-choices></ui-select><div ng-show="vm.errorDestination"><p class="help-block alert alert-danger" ng-show="vm.errorDestination" data-translate="pharmaPortalApp.portalNotification.notificationError">S\xF3 pode haver um destinat\xE1rio.</p></div></div></div><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.portalNotification.companyDestination" for="field_companyDestination">Company Destination</label><div class="col-sm-10" id="field_companyDestination"><ui-select name="companyDestination" ng-model="vm.portalNotification.companyDestinationId"><ui-select-match allow-clear="true">{{$select.selected.naming}}</ui-select-match><ui-select-choices repeat="company.id as company in vm.companies | filter: $select.search | orderBy:\'naming\'"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select><div ng-show="vm.errorDestination"><p class="help-block alert alert-danger" ng-show="vm.errorDestination" data-translate="pharmaPortalApp.portalNotification.notificationError">S\xF3 pode haver um destinat\xE1rio.</p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/portal-notification/portal-notifications.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.portalNotification.home.title">PortalNotifications</span> <button class="btn btn-warning btn-sm pull-right" ui-sref="portal-notification.new"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.portalNotification.home.createLabel">Create new PortalNotification</span></button> <span class="clearfix"></span></div><div class="panel-body"><form class="form-horizontal container-fluid well well-sm" id="filterForm" name="filterForm"><div class="form-group-sm"><div class="col-sm-2"><label for="field_date" translate="pharmaPortalApp.portalNotification.filter.date">Date</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_date" name="date" ng-click="vm.openDatePopup(\'start\')" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.filter.date" is-open="vm.datePopup.start.opened" datepicker-options="vm.dateOptions" close-text="{{\'global.datepicker.close\' | translate}}" clear-text="{{\'global.datepicker.clear\' | translate}}" current-text="{{\'global.datepicker.today\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openDatePopup(\'start\')"><i class="fa fa-calendar"></i></button></span></div></div><div class="col-sm-2"><label for="field_origin" translate="pharmaPortalApp.portalNotification.filter.origin">Origin</label><input type="text" class="form-control input-sm" ng-model="vm.filter.origin" id="field_origin" placeholder="{{\'pharmaPortalApp.portalNotification.filter.originPlaceholder\' | translate}}" autocomplete="off"></div><div class="col-sm-2"><label translate="pharmaPortalApp.portalNotification.filter.category">Category</label><ui-select name="category" ng-model="vm.filter.category"><ui-select-match allow-clear="true">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="category.value as category in vm.categories | filter: $select.search"><span ng-bind-html="category.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label translate="pharmaPortalApp.portalNotification.filter.priority">Priority</label><ui-select name="priority" ng-model="vm.filter.priority"><ui-select-match allow-clear="true">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="priority.value as priority in vm.priorities | filter: $select.search"><span ng-bind-html="priority.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2"><label translate="pharmaPortalApp.portalNotification.filter.isRead">State</label><ui-select name="isRead" ng-model="vm.filter.isRead"><ui-select-match allow-clear="true">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="isRead.value as isRead in vm.states | filter: $select.search"><span ng-bind-html="isRead.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="col-sm-2 text-center"><label class="col-sm-12">&nbsp;</label><div class="btn-group"><button class="btn btn-sm btn-warning" ng-click="vm.clearFilter()" title="{{\'entity.action.reset\' | translate}}"><i class="fa fa-times"></i></button> <button type="submit" class="btn btn-sm btn-info" ng-click="vm.filterPortalNotifications()" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i></button></div></div></div></form><div class="container-fluid well well-sm"><div class="col-sm-6"><div class="btn-group" role="group"><button ng-click="markAsReadOrUnread(true)" type="button" class="btn btn-primary btn-sm" ng-disabled="isAnyOptionSelected()"><i class="fa fas fa-envelope-open"></i> <span data-translate="pharmaPortalApp.portalNotification.read">Marcar como lida</span></button> <button ng-click="markAsReadOrUnread(false)" type="button" class="btn btn-info btn-sm" ng-disabled="isAnyOptionSelected()"><i class="fa fas fa-envelope"></i> <span data-translate="pharmaPortalApp.portalNotification.notRead">Marcar como n\xE3o lida</span></button></div></div><div class="col-sm-6"><div class="pull-right"><label for="sendEmail" class="form-check-label"><input ng-disabled="vm.user.id === null" type="checkbox" class="form-check-input" id="sendEmail" name="sendEmail" ng-model="vm.user.sendNotificationEmail" ng-change="saveUser()"> <span data-translate="pharmaPortalApp.portalNotification.sendNotificationEmail">Send Notification Email</span></label></div></div></div><div class="alert alert-warning" ng-show="vm.portalNotifications.length <= 0" data-translate="entity.noResults"></div><div class="table-responsive" ng-show="vm.portalNotifications.length > 0"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th for="checkbox_id" ng-click="$event.stopPropagation();"><div class="checkbox"><label><input ng-click="toggleAll()" ng-model="isAllSelected" id="checkbox_all_id" type="checkbox" value=""></label></div></th><th jh-sort-by="isRead"><span data-translate="pharmaPortalApp.portalNotification.isMsgRead">Is Read</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="date"><span data-translate="pharmaPortalApp.portalNotification.date">Date</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="subject"><span data-translate="pharmaPortalApp.portalNotification.subject">Subject</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="priority"><span data-translate="pharmaPortalApp.portalNotification.priority">Priority</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="category"><span data-translate="pharmaPortalApp.portalNotification.category">Category</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="portalNotificationToUserLogin"><span data-translate="pharmaPortalApp.portalNotification.notificationToUser">PortalNotification To User</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="destinationLogin"><span data-translate="pharmaPortalApp.portalNotification.destination">Destination</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="companyDestinationComercialName"><span data-translate="pharmaPortalApp.portalNotification.companyDestination">Company Destination</span>&nbsp;<i class="fa fa-sort"></i></th><th><span data-translate="pharmaPortalApp.portalNotification.userDestination">User Destination</span></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="portalNotification in vm.portalNotifications track by portalNotification.id" ng-click="goToDetail(portalNotification)"><td for="checkbox_id" ng-click="$event.stopPropagation();"><div class="checkbox"><label><input id="checkbox_id" type="checkbox" value="" ng-change="optionToggled()" ng-model="portalNotification.selected"></label></div></td><td><button class="btn btn-info btn-sm" ng-click="vm.setRead(portalNotification, true); $event.stopPropagation();" ng-show="!portalNotification.isRead"><i class="fa far fa-envelope"></i></button> <button class="btn btn-sm" ng-click="vm.setRead(portalNotification, false); $event.stopPropagation();" ng-show="portalNotification.isRead"><i class="fa fas fa-envelope-open"></i></button></td><td>{{portalNotification.date | date:\'medium\'}}</td><td>{{portalNotification.subject}}</td><td><i ng-show="portalNotification.priority == \'HIGH\'" class="fa fas fa-2x fa-arrow-up text-danger" title="{{\'PortalNotificationPriority.\' + portalNotification.priority | translate}}"></i> <i ng-show="portalNotification.priority == \'MEDIUM\'" class="fa fas fa-2x fa-arrow-right text-warning" title="{{\'PortalNotificationPriority.\' + portalNotification.priority | translate}}"></i> <i ng-show="portalNotification.priority == \'LOW\'" class="fa fas fa-2x fa-arrow-down text-success" title="{{\'PortalNotificationPriority.\' + portalNotification.priority | translate}}"></i></td><td><i ng-show="portalNotification.category == \'ERROR\'" class="fa fas fa-2x fa-times text-danger" title="{{\'PortalNotificationCategory.\' + portalNotification.category | translate}}"></i> <i ng-show="portalNotification.category == \'INFO\'" class="fa fas fa-2x fa-info-circle text-info" title="{{\'PortalNotificationCategory.\' + portalNotification.category | translate}}"></i> <i ng-show="portalNotification.category == \'MESSAGE\'" class="fa fas fa-2x fa-comments text-primary" title="{{\'PortalNotificationCategory.\' + portalNotification.category | translate}}"></i></td><td>{{portalNotification.portalNotificationToUserLogin}}</td><td>{{portalNotification.destinationLogin}}</td><td><a ng-if="portalNotification.companyDestinationComercialName != null" ui-sref="company-detail({id:portalNotification.companyDestinationId})">{{portalNotification.companyDestinationComercialName}}</a><p ng-if="portalNotification.companyDestinationComercialName == null">-</p></td><td><p ng-if="portalNotification.companyDestinationComercialName != null">-</p><p ng-if="portalNotification.companyDestinationComercialName == null">{{portalNotification.destinationLogin}}</p></td><td><div class="btn-group"><button type="submit" ui-sref="portal-notification-detail({id:portalNotification.id})" class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}"><span class="fa fa-search-plus"></span></button> <button type="button" ui-sref="portal-notification.delete({id:portalNotification.id})" class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}"><span class="fa fa-trash-o"></span></button></div></td></tr></tbody></table></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div></div>');
$templateCache.put('app/entities/portal-product/portal-product-cnp.detail-dialog.html','<form name="productCnpDetailForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Informa\xE7\xE3o do produto</h4></div><div class="modal-body" id="modal-body"><div class="table-responsive"><table class="table-bordered table-condensed table-striped cnpTable"><tbody><tr><td class="table-center"><strong>CNP: </strong>{{vm.product.cnp}}</td><td class="table-center"><strong>C\xF3digo Interno: </strong>{{vm.product.code}}</td><td class="table-center"><strong>Sociedade: </strong>{{vm.product.society}}</td></tr><tr><td class="table-center"><strong>Nome: </strong>{{vm.product.fullName}}</td><td class="table-center"><strong>PVP: </strong>{{vm.product.pvp | currency : \'%\' : 2}}</td><td class="table-center"><strong>Taxa IVA: </strong>{{vm.product.txiva | currency : \'%\' : 2}}</td></tr><tr><td class="table-center"><strong>Laborat\xF3rio: </strong>{{vm.product.labcode ? vm.product.labcode + \' - \' + vm.product.lab : ""}}</td><td class="table-center"><strong>Fornecedor: </strong>{{vm.product.forncode ? vm.product.forncode + \' - \' + vm.product.forn : ""}}</td><td class="table-center"></td></tr><tr><td class="table-center"><strong>Stock: </strong>{{vm.product.totalstock}}</td><td class="table-center"><strong>Ativo:</strong><any ng-switch="vm.product.inact"><any ng-switch-when="S"><i class="text-danger fa fa-ban"></i></any><any ng-switch-default><i class="text-success fa fa-check"></i></any></any></td><td class="table-center"><strong>Disp. Seg:</strong><any ng-switch="vm.product.dispositivoseguranca"><any ng-switch-when="true"><i class="text-success fa fa-check"></i></any><any ng-switch-default><i class="text-danger fa fa-ban"></i></any></any></td></tr><tr><td class="table-center"><table class="table-condensed table-bordered cnpTable"><thead><tr><th class="text-center" colspan="3">PD</th></tr></thead><tbody><tr><td class="table-center"><strong>Pre\xE7o: </strong>{{vm.product.pdeur | currency : \'&euro;\' : 2}}</td><td class="table-center"><strong>% Desconto: </strong>{{vm.product.pddesc * 100 | currency : \'%\' : 2}}</td><td class="table-center"><strong>L\xEDquido: </strong>{{vm.product.pdliq ? vm.product.pdliq : 0 | currency : \'&euro;\' : 2}}</td></tr></tbody></table></td><td class="table-center"><table class="table-condensed table-bordered cnpTable"><thead><tr><th class="text-center" colspan="3">PVA</th></tr></thead><tbody><tr><td class="table-center"><strong>Pre\xE7o: </strong>{{vm.product.pvaeur | currency : \'&euro;\' : 2}}</td><td class="table-center"><strong>% Desconto: </strong>{{vm.product.pvadesc * 100 | currency : \'%\' : 2}}</td><td class="table-center"><strong>L\xEDquido: </strong>{{vm.product.pvaliq ? vm.product.pvaliq : 0 | currency : \'&euro;\' : 2}}</td></tr></tbody></table></td><td class="table-center"><table class="table-condensed table-bordered cnpTable"><thead><tr><th class="text-center" colspan="3">PVF</th></tr></thead><tbody><tr><td class="table-center"><strong>Pre\xE7o: </strong>{{vm.product.pvfeur | currency : \'&euro;\' : 2}}</td><td class="table-center"><strong>% Desconto: </strong>{{vm.product.pvfdesc * 100 | currency : \'%\' : 2}}</td><td class="table-center"><strong>L\xEDquido: </strong>{{vm.product.pvfliq ? vm.product.pvfliq : 0 | currency : \'&euro;\' : 2}}</td></tr></tbody></table></td></tr></tbody></table><table class="table-bordered table-condensed table-striped cnpTable"><tbody><tr><td class="table-center"><strong>Denomina\xE7\xE3o Comum: </strong>{{vm.productInfo.dcipt}}</td><td class="table-center"><strong>Classif FarmacoTerap\xEAutica: </strong>{{vm.productInfo.cft}}</td></tr><tr><td class="table-center"><strong>Forma Farmac\xEAutica: </strong>{{vm.productInfo.formFarm}}</td><td class="table-center"><strong>Gen\xE9rico:</strong><any ng-switch="vm.productInfo.generico"><any ng-switch-when="N"><i class="text-danger fa fa-ban"></i></any><any ng-switch-default><i class="text-success fa fa-check"></i></any></any></td></tr><tr><td class="table-center"><strong>Classif Subst Controladas: </strong>{{vm.productInfo.classEstup}}</td><td class="table-center"><strong>Classif Regime Dispensa ao P\xFAblico: </strong>{{vm.productInfo.classDisp}}</td></tr><tr><td class="table-center"><strong>Diabetes:</strong><any ng-switch="vm.productInfo.diabetes"><any ng-switch-when="S"><i class="text-success fa fa-check"></i></any><any ng-switch-default><i class="text-danger fa fa-ban"></i></any></any></td><td class="table-center"><strong>Grupo Homog\xE9neo: </strong>{{vm.productInfo.grupoHom}}</td></tr><tr><td class="table-center"><strong>Tipo Embalagem: </strong>{{vm.productInfo.embUnit}}</td><td class="table-center"><strong>Tipo de Produto: </strong>{{vm.productInfo.tipoProd}}</td></tr></tbody></table></div><br><br><h4 class="modal-title text-center" data-translate="chart.priceEvo">Price evolution</h4><div id="container" style="width:100%; height:300px"></div></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/portal-product/portal-product-confirm.fullsearch-dialog.html','<form name="confirmFullSearchForm" ng-submit="vm.confirmAddProducts()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Informa\xE7\xE3o</h4></div><div class="modal-body" id="modal-body"><any ng-switch="message"><any ng-switch-when="NOK"><p>A op\xE7\xE3o "Incluir s/stock" est\xE1 selecionada.</p><p>Por quest\xF5es de performance, apenas \xE9 permitido efetuar pesquisas com 3 ou mais caracteres.</p></any><any ng-switch-when="OK"><p><b>Aten\xE7\xE3o</b>: a a\xE7\xE3o de procurar produtos usando menos de 3 caracteres no termo a pesquisar pode demorar alguns minutos.</p><p>Pretende continuar?</p></any></any></div><div class="modal-footer"><any ng-switch="message"><any ng-switch-when="NOK"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></any><any ng-switch-when="OK"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></any></any></div></form>');
$templateCache.put('app/entities/portal-product/portal-product-stock.detail-dialog.html','<form name="productStockDetailForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Stock por armaz\xE9m do produto</h4></div><div class="modal-body" id="modal-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th>C\xF3digo Armaz\xE9m</th><th>Descri\xE7\xE3o Armaz\xE9m</th><th>Quantidade em Stock</th></tr></thead><tbody><tr ng-repeat="warehouseStock in warehouseStockList"><td class="text-center">{{warehouseStock.code}}</td><td class="text-left">{{warehouseStock.description}}</td><td class="text-right">{{warehouseStock.stock ? warehouseStock.stock : 0 | number : 0}}</td></tr></tbody><tfoot><tr><th class="text-right" colspan="2">Total em Stock</th><th class="text-right">{{getTotal ()| number : 0}}</th></tr></tfoot></table></div></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/portal-product/portal-products.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><div class="panel-title pull-left" data-translate="pharmaPortalApp.portalProduct.home.title">Portal Apps</div><div class="panel-search-form col-md-6 pull-right"><form name="searchForm"><div class="input-group"><div class="input-group-btn" uib-dropdown auto-close="outsideClick"><span on-toggle="toggled(open)" class="btn btn-default btn-sm" ng-class="{\'btn-success\': search.showNoStock || search.showInactive || search.useExternalDB || search.dispSegFilter }" uib-dropdown-toggle><i class="fa fa-cogs"></i>&nbsp;<i class="caret"></i></span><ul class="dropdown-menu" uib-dropdown-menu><li><div class="checkbox dropdown-item"><label><input type="checkbox" ng-model="search.showNoStock" id="showNoStock">Incluir s/stock</label></div></li><li><div class="checkbox dropdown-item"><label><input type="checkbox" ng-model="search.showInactive" id="showInactive">Incluir inativos</label></div></li><li><div class="checkbox dropdown-item"><label><input type="checkbox" ng-model="search.useExternalDB" id="useExternalDB">Usar BD Externa</label></div></li><li class="divider"></li><li><span class="col-md-12"><label>Filtrar por Disp Seguran\xE7a</label><select class="form-control" ng-model="search.dispSegFilter" id="dispSegFilter"><option value="">(indiferente)</option><option value="true">Com Disp Seg</option><option value="false">Sem Disp Seg</option></select></span></li></ul></div><input type="text" class="form-control input-sm" ng-model="search.searchQuery" id="searchQuery" placeholder="{{\'global.form.search.placeholder.product.attr\' | translate}}" autocomplete="off"><div class="input-group-btn"><button class="btn btn-info btn-sm" ng-click="searchProducts()" title="{{\'entity.action.search\' | translate}}"><i class="fa fa-search"></i></button> <button has-authority="ROLE_ADMIN" class="btn btn-warning btn-sm" ng-click="syncProducts()"><i class="fa fa-refresh"></i>&nbsp;<span class="hidden-xs" data-translate="pharmaPortalApp.portalProducts.externalSyncs.dbPharmaSynchronize"> Synch Products</span></button></div></div></form></div><div class="clearfix"></div></div><div class="panel-body"><div class="jumbotron text-center" ng-hide="productsList.length"><i class="fa fa-search-minus fa-3x"></i>&nbsp;&nbsp;&nbsp;Por favor utilize o campo de pesquisa no topo da p\xE1gina</div><form name="portalProductForm" role="form" ng-show="productsList.length"><div class="row"><div class="col-md-6"><any ng-hide="searchInTable">A pesquisa por "{{search.searchQuery}}" retornou {{productsList.length}} items</any><any ng-show="searchInTable">Mostrando {{(productsList | filter:searchInTable).length}} items de um total de {{productsList.length}}</any></div><div class="col-md-offset-3 col-md-3"><div class="form-group"><div class="input-group"><input type="text" class="form-control input-sm" placeholder="{{\'global.form.search.placeholder.inTable\' | translate}}" ng-model="searchInTable"><div class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.clearSearchInTable()"><i class="fa fa-close"></i></button></div></div></div></div></div><div class="table-responsive"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="productsList"><thead><tr class="topHeader"><th colspan="5">Artigo</th><th>PVP</th><th ng-show="vm.loggedUserClientPe && vm.settings.includeCMPColumn">PCM</th><th colspan="3">PVF</th><th colspan="3">PVA</th><th colspan="3">PD</th><th>Stock</th></tr><tr><th>CNP</th><th>Descri\xE7\xE3o</th><th>Laborat\xF3rio</th><th>Forn. Pref</th><th>Disp. Seg</th><th>&euro;</th><th ng-show="vm.loggedUserClientPe && vm.settings.includeCMPColumn">&euro;</th><th>&euro;</th><th>% Desc</th><th>L\xEDq</th><th>&euro;</th><th>% Desc</th><th>L\xEDq</th><th>&euro;</th><th>% Desc</th><th>L\xEDq</th><th>Qtd</th></tr></thead><tbody><tr ng-repeat="portalProduct in productsList | filter:searchInTable track by $index"><td class="table-left"><button type="button" ui-sref="portal-product.showDetail({cnp:portalProduct.cnp,society:portalProduct.society,product:portalProduct})" class="btn btn-link"><i class="fa fa-search"></i>&nbsp;{{portalProduct.cnp}}</button></td><td class="table-left" ng-bind-html="portalProduct.fullHtmlName"></td><td class="table-left"><a ng-click="vm.searchByLab(portalProduct.lab)" ng-show="portalProduct.lab"><i class="fa fa-search"></i>&nbsp;{{portalProduct.lab}}</a></td><td class="table-left"><a ng-click="vm.searchByLab(portalProduct.forn)" ng-show="portalProduct.forncode"><i class="fa fa-search"></i>&nbsp;{{portalProduct.forncode ? portalProduct.forncode + \' - \' + portalProduct.forn : portalProduct.forn}}</a></td><td class="table-center"><any ng-switch="portalProduct.dispositivoseguranca"><any ng-switch-when="true"><i class="text-success fa fa-check"></i></any><any ng-switch-default><i class="text-danger fa fa-ban"></i></any></any></td><td class="table-right">{{portalProduct.pvp | currency : \'&euro;\' : 2}}</td><td class="table-right" ng-show="vm.loggedUserClientPe && vm.settings.includeCMPColumn">{{portalProduct.pcm | currency : \'&euro;\' : 2}}</td><td class="table-right">{{portalProduct.pvfeur | currency : \'&euro;\' : 2}}</td><td class="table-right">{{portalProduct.pvfdesc * 100 | currency : \'%\' : 2}}</td><td class="table-right">{{portalProduct.pvfliq | currency : \'&euro;\' : 2}}</td><td class="table-right">{{portalProduct.pvaeur | currency : \'&euro;\' : 2}}</td><td class="table-right">{{portalProduct.pvadesc * 100 | currency : \'%\' : 2}}</td><td class="table-right">{{portalProduct.pvaliq | currency : \'&euro;\' : 2}}</td><td class="table-right">{{portalProduct.pdeur | currency : \'&euro;\' : 2}}</td><td class="table-right">{{portalProduct.pddesc * 100 | currency : \'%\' : 2}}</td><td class="table-right">{{portalProduct.pdliq | currency : \'&euro;\' : 2}}</td><td class="table-right"><any ng-show="(portalProduct.totalstock != null && portalProduct.totalstock != 0)"><button type="button" ui-sref="portal-product.stockDetail({internalCode:portalProduct.code})" class="btn btn-link" title="{{\'entity.action.details\' | translate}}">{{portalProduct.totalstock}}&nbsp;<i class="fa fa-pie-chart"></i></button></any><any ng-hide="(portalProduct.totalstock != null && portalProduct.totalstock != 0)">0</any></td></tr></tbody></table></div></form></div><div class="panel-footer"><div class="text-right"><button class="btn btn-warning btn-sm" ng-disabled="isSearchEmpty()" ng-click="vm.exportToExcel()"><i class="fa fa-file-excel-o"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export excel</span></button></div></div></div></div>');
$templateCache.put('app/entities/portal-settings/intranet-settings.html','<div><form class="form-horizontal" name="intranetSettingsForm" ng-submit="vm.save()"><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left" data-translate="pharmaPortalApp.portalSettings.intranet.title">Intranet Settings</span> <span class="clearfix"></span></div><div class="panel-body"><fieldset ng-show="vm.moduleSettings.receptionsModule"><legend class="text-success"><i class="fa fa-truck"></i>&nbsp;<span data-translate="global.menu.entities.pharmaReception.title">Pharma Reception</span></legend><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="receptionDefineNoteCreation" class="form-check-label"><input type="checkbox" class="form-check-input" id="receptionDefineNoteCreation" ng-model="vm.settings.receptionDefineNoteCreation"> <span data-translate="pharmaPortalApp.portalSettings.intranet.receptionDefineNoteCreation">Allow not to generate receipt guide in communication with the ERP</span></label></div></div></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><div class="col-sm-12"><div class="form-check"><label for="exportPurchaseInvoice" class="form-check-label"><input type="checkbox" class="form-check-input" id="exportPurchaseInvoice" ng-model="vm.settings.exportPurchaseInvoice"> <span data-translate="pharmaPortalApp.portalSettings.intranet.exportPurchaseInvoice">Create purchase invoice (with closing in value for receipt guide)</span></label></div></div></div></div><div class="col-sm-6"><div class="form-group" ng-show="vm.settings.exportPurchaseInvoice"><div class="col-sm-12"><label class="col-sm-6"><span data-translate="pharmaPortalApp.portalSettings.intranet.serviceCodePurchasesLabel">Service code(s) for purchases differences</span></label></div><div class="col-sm-12"><table class="jh-table table table-condensed"><thead><tr><th><span data-translate="pharmaPortalApp.portalSettings.intranet.vatLabel">VAT (%)</span></th><th><span data-translate="pharmaPortalApp.portalSettings.intranet.service">Service</span></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.pharmaReceptionServiceByVats track by $index"><td class="table-left"><div class="input-group"><input type="text" id="vatRate" class="form-control input-sm" ng-model="item.serviceVatType.vatRate" ng-disabled="true"> <span class="input-group-addon">%</span></div><input type="hidden" id="vatCode" class="form-control input-sm" ng-model="item.serviceVatType.vatCode"></td><td class="table-left"><ui-select id="serviceVatType" ng-model="item.serviceVatType"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="serviceVatType in (serviceTypes | filter: $select.search) track by $index"><span ng-bind-html="serviceVatType.code +\' - \'+ serviceVatType.description | highlight: $select.search"></span></ui-select-choices></ui-select></td><td class="table-right"><span class="btn btn-danger btn-xs" ng-click="vm.pharmaReceptionServiceByVats.splice($index, 1)" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></span></td></tr></tbody></table><div class="text-right"><span class="btn btn-sm btn-success" ng-click="vm.addNewPharmaReceptionServiceByVat()"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.portalSettings.intranet.newService">New service</span></span></div></div></div></div></div><div class="row" ng-if="vm.settings.exportPurchaseInvoice"><div class="col-sm-12"><div class="form-group"><label for="attemptsBeforeTimeout" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.intranet.attemptsBeforeTimeout">Number of attempts before timeout on receipt guide status aquisition</label><div class="col-sm-3" ng-class="{\'has-error\': intranetSettingsForm.attemptsBeforeTimeout.$invalid && intranetSettingsForm.attemptsBeforeTimeout.$dirty}"><div class="input-group"><span class="input-group-addon" data-translate="{{\'pharmaPortalApp.portalSettings.intranet.attempt\' | translate}}">Number of attempts</span> <input type="number" class="form-control input-sm" id="attemptsBeforeTimeout" min="0" max="10" step="1" ng-model="vm.settings.attemptsBeforeTimeout" required></div></div><div class="col-sm-3" ng-class="{\'has-error\': intranetSettingsForm.attemptsIntervalBeforeTimeout.$invalid && intranetSettingsForm.attemptsIntervalBeforeTimeout.$dirty}"><div class="input-group"><span class="input-group-addon" data-translate="{{\'pharmaPortalApp.portalSettings.intranet.attemptInterval\' | translate}}">Attempt interval</span> <input type="number" class="form-control input-sm" id="attemptsIntervalBeforeTimeout" min="0" max="10" step="1" ng-model="vm.settings.attemptsIntervalBeforeTimeout" required></div></div></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><div class="col-sm-12"><div class="form-check"><label for="filterServicesToShow" class="form-check-label"><input type="checkbox" class="form-check-input" id="filterServicesToShow" ng-model="vm.settings.filterServicesToShow"> <span data-translate="pharmaPortalApp.portalSettings.intranet.filterServicesToShow">Don\'t show all services</span></label></div></div></div></div><div class="col-sm-6" ng-show="vm.settings.filterServicesToShow"><div class="form-group"><label class="col-sm-2 control-label" data-translate="pharmaPortalApp.portalSettings.intranet.filterServicesToShowList">List of services to show</label><div class="col-sm-10"><ui-select multiple="multiple" id="servicesToProvide" ng-model="vm.servicesToProvide" close-on-select="false"><ui-select-match>{{$item.code}} - {{$item.description}}</ui-select-match><ui-select-choices repeat="service in (serviceTypes | filter: $select.search) track by $index"><span ng-bind-html="service.code +\' - \'+ service.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="exportLogitoolsFile" class="form-check-label"><input type="checkbox" class="form-check-input" id="exportLogitoolsFile" ng-model="vm.settings.exportLogitoolsFile"> <span data-translate="pharmaPortalApp.portalSettings.intranet.exportLogitoolsFile">Allow export file in Logitools format</span></label></div></div></div></div></div></fieldset><fieldset ng-show="vm.moduleSettings.balanceModule"><legend class="text-success"><i class="fa fa-line-chart"></i>&nbsp;<span data-translate="pharmaPortalApp.portalSettings.portal.legend.pharmaBalance">Pharma Balance</span></legend><div class="row"><div class="form-group"><div class="col-sm-12"><label for="balanceCentralWarehouse" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.balanceCentralWarehouse">Balance Central Warehouse</label><div class="col-sm-6"><ui-select id="balanceCentralWarehouse" ng-model="vm.settings.balanceCentralWarehouse"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="warehouse in (warehouses | filter: $select.search) track by warehouse.code"><span ng-bind-html="warehouse.code +\' - \'+ warehouse.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="balanceServiceType" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.balanceServiceType">Balance service code</label><div class="col-sm-6"><ui-select id="balanceServiceType" ng-model="vm.settings.balanceServiceType"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="balanceServType in (serviceTypes | filter: $select.search) track by $index"><span ng-bind-html="balanceServType.code +\' - \'+ balanceServType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="balanceInvoiceType" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.balanceInvoiceType">Balance Invoice Type</label><div class="col-sm-6"><ui-select id="balanceInvoiceType" ng-model="vm.settings.balanceInvoiceType"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="docType in (documentTypes | filter: $select.search) track by docType.code"><span ng-bind-html="docType.code +\' - \'+ docType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="balanceCreditType" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.balanceCreditType">Balance Credit Type</label><div class="col-sm-6"><ui-select id="balanceCreditType" ng-model="vm.settings.balanceCreditType"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="docType in (documentTypes | filter: $select.search) track by docType.code"><span ng-bind-html="docType.code +\' - \'+ docType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div></fieldset></div><div class="panel-footer"><div class="text-right"><button type="submit" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></div></form></div>');
$templateCache.put('app/entities/portal-settings/portal-settings.html','<div><form class="form-horizontal form-settings" name="settingsForm" ng-submit="vm.save()"><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left" data-translate="pharmaPortalApp.portalSettings.portal.title">Portal Settings</span> <span class="clearfix"></span></div><div class="panel-body"><fieldset ng-show="vm.moduleSettings.productsModule"><legend class="text-success"><i class="fa fa-cubes"></i>&nbsp;<span data-translate="pharmaPortalApp.portalSettings.portal.legend.portalProduct">Portal Products</span></legend><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="includeCMPColumn" class="form-check-label"><input type="checkbox" class="form-check-input" id="includeCMPColumn" ng-model="vm.settings.includeCMPColumn"> <span data-translate="pharmaPortalApp.portalSettings.portal.includeCMPColumn">Show CMP column</span></label></div></div></div></div></div><!-- TODO: CHECK IF IS POSSIBLE DUE TO PERFORMANCE\n                    <div class="row">\n                        <div class="form-group">\n                            <div class="col-sm-12">\n                                <div class="col-sm-6">\n                                    <div class="form-check">\n                                        <label for="useCMPForDiscountCalc" class="form-check-label">\n                                            <input type="checkbox" class="form-check-input" id="useCMPForDiscountCalc" ng-model="vm.settings.useCMPForDiscountCalc">\n                                            <span data-translate="pharmaPortalApp.portalSettings.portal.useCMPForDiscountCalc">Use CMP for discount calculation</span>\n                                        </label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    --></fieldset><fieldset ng-show="vm.moduleSettings.purchasesModule || vm.moduleSettings.salesModule"><legend class="text-success"><i class="fa fa-shopping-cart"></i>&nbsp;<span data-translate="pharmaPortalApp.portalSettings.portal.legend.pharmaOrder">Pharma orders (purchase and sales)</span></legend><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="showPvfOnNegativeDiscount" class="form-check-label"><input type="checkbox" class="form-check-input" id="showPvfOnNegativeDiscount" ng-model="vm.settings.showPvfOnNegativeDiscount"> <span data-translate="pharmaPortalApp.portalSettings.portal.showPvfOnNegativeDiscount">Show PVA / PVF on negative discount</span></label></div></div></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><div class="col-sm-12"><div class="form-check"><label for="allowZeroPriceProducts" class="form-check-label"><input type="checkbox" class="form-check-input" id="allowZeroPriceProducts" ng-model="vm.settings.allowZeroPriceProducts"> <span data-translate="pharmaPortalApp.portalSettings.portal.allowZeroPriceProducts">Allow purchase products with price zero</span></label></div></div></div></div><div class="col-sm-6"><div class="form-group" ng-show="vm.settings.allowZeroPriceProducts"><div class="col-sm-12"><div class="form-check"><label for="allowZeroPriceOrders" class="form-check-label"><input type="checkbox" class="form-check-input" id="allowZeroPriceOrders" ng-model="vm.settings.allowZeroPriceOrders"> <span data-translate="pharmaPortalApp.portalSettings.portal.allowZeroPriceOrders">Allow orders with total price zero</span></label></div></div></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><div class="col-sm-12"><div class="form-check"><label for="hasMinOrderValue" class="form-check-label"><input type="checkbox" class="form-check-input" id="hasMinOrderValue" ng-model="vm.settings.hasMinOrderValue"> <span data-translate="pharmaPortalApp.portalSettings.portal.hasMinOrderValue">Consider minimum value to accept orders</span></label></div></div></div></div><div class="col-sm-6"><div class="form-group" ng-show="vm.settings.hasMinOrderValue"><label for="minOrderValue" class="col-sm-4" data-translate="pharmaPortalApp.portalSettings.portal.minOrderValue">Minimum value (exclude VAT)</label><div class="col-sm-8"><input type="text" class="form-control input-sm" id="minOrderValue" ng-model="vm.settings.minOrderValue" ng-disabled="!vm.settings.hasMinOrderValue" ng-required="vm.settings.hasMinOrderValue" price></div></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><div class="col-sm-12"><div class="form-check"><label for="chargeShippingCosts" class="form-check-label"><input type="checkbox" class="form-check-input" id="chargeShippingCosts" ng-model="vm.settings.chargeShippingCosts"> <span data-translate="pharmaPortalApp.portalSettings.portal.chargeShippingCosts">Charge shipping costs</span></label></div></div></div></div><div class="col-sm-6"><div class="form-group" ng-show="vm.settings.chargeShippingCosts"><label for="shippingCosts" class="col-sm-4" data-translate="pharmaPortalApp.portalSettings.portal.shippingCosts">Shipping cost value</label><div class="col-sm-8"><input type="text" class="form-control input-sm" id="shippingCosts" ng-model="vm.settings.shippingCosts" ng-disabled="!vm.settings.chargeShippingCosts" ng-required="vm.settings.chargeShippingCosts"></div></div></div></div><div class="row" ng-show="vm.settings.chargeShippingCosts"><div class="col-sm-offset-6 col-sm-6"><div class="form-group"><label for="cecServiceType" class="col-sm-4" data-translate="pharmaPortalApp.portalSettings.portal.cecServiceType">Service code</label><div class="col-sm-8"><ui-select id="cecServiceType" ng-model="vm.settings.cecServiceType" ng-required="vm.settings.chargeShippingCosts"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="cecServType in (serviceTypes | filter: $select.search) track by $index"><span ng-bind-html="cecServType.code +\' - \'+ cecServType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="defaultQtd" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.defaultQtd">Quantity, by default, to be considered in the input field after search</label><div class="col-sm-6"><input type="text" class="form-control input-sm" id="defaultQtd" ng-model="vm.settings.defaultQtd"></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="invoiceType" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.invoiceType">Invoice type for purchases</label><div class="col-sm-6"><ui-select id="invoiceType" ng-model="vm.settings.invoiceType"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="docType in (documentTypes | filter: $select.search) track by docType.code"><span ng-bind-html="docType.code +\' - \'+ docType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="conferenceType" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.conferenceType">Tipo de fatura\xE7\xE3o Produtos Retidos</label><div class="col-sm-6"><ui-select id="conferenceType" ng-model="vm.settings.conferenceType"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="docType in (documentTypes | filter: $select.search) track by docType.code"><span ng-bind-html="docType.code +\' - \'+ docType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row" ng-show="vm.moduleSettings.salesModule" has-any-authority="ROLE_PHARMA, ROLE_COMERCIAL"><div class="form-group"><div class="col-sm-12"><label for="warehouseSales" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.warehouseSales">Warehouse for sales</label><div class="col-sm-6"><ui-select id="warehouseSales" ng-model="vm.settings.warehouseSales"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="warehouse in (warehouses | filter: $select.search) track by warehouse.code"><span ng-bind-html="warehouse.code +\' - \'+ warehouse.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row" ng-show="vm.moduleSettings.salesModule" has-any-authority="ROLE_PHARMA, ROLE_COMERCIAL"><div class="form-group"><div class="col-sm-12"><label for="salesEmail" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.salesEmail">Email to send when sale is made</label><div class="col-sm-6"><input type="text" class="form-control input-sm" id="salesEmail" ng-model="vm.settings.salesEmail"></div></div></div></div></fieldset><fieldset ng-show="vm.moduleSettings.tradesModule"><legend class="text-success"><i class="fa fa-exchange"></i>&nbsp;<span data-translate="pharmaPortalApp.portalSettings.portal.legend.pharmaTrade">Pharma Trades</span></legend><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="priceFromPolicyForTrades" class="form-check-label"><input type="checkbox" class="form-check-input" id="priceFromPolicyForTrades" ng-model="vm.settings.priceFromPolicyForTrades"> <span data-translate="pharmaPortalApp.portalSettings.portal.priceFromPolicyForTrades">Get price through policy for pharmacy trades</span></label></div></div><div class="col-sm-6"><div class="form-check" ng-show="vm.settings.priceFromPolicyForTrades"><label for="sellerHasDiffPrice" class="form-check-label"><input type="checkbox" class="form-check-input" id="sellerHasDiffPrice" ng-model="vm.settings.sellerHasDiffPrice"> <span data-translate="pharmaPortalApp.portalSettings.portal.sellerHasDiffPrice">Calculate buyer and seller prices on a separated method</span></label></div></div></div></div></div><div class="row" ng-show="vm.settings.priceFromPolicyForTrades"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"></div><div class="col-sm-6"><div class="form-check"><label for="manualPriceIfNull" class="form-check-label"><input type="checkbox" class="form-check-input" id="manualPriceIfNull" ng-model="vm.settings.manualPriceIfNull"> <span data-translate="pharmaPortalApp.portalSettings.portal.manualPriceIfNull">Enter price manually if price returned is null</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="onlyTradeInGroup" class="form-check-label"><input type="checkbox" class="form-check-input" id="onlyTradeInGroup" ng-model="vm.settings.onlyTradeInGroup"> <span data-translate="pharmaPortalApp.portalSettings.portal.onlyTradeInGroup">Perform pharmacy trades only between pharmacies in the same group</span></label></div></div><div class="col-sm-6"><ui-select ng-disabled="!vm.settings.onlyTradeInGroup" multiple="multiple" id="activeGroups" name="activeGroups" ng-model="vm.activeGroups" close-on-select="false"><ui-select-match placeholder="{{\'Grupos\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="group in vm.clientGroups | filter: $select.search"><span ng-bind-html="group.name | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="tradeInvoiceType" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.tradeInvoiceType">Invoice type for trades</label><div class="col-sm-6"><ui-select id="tradeInvoiceType" ng-model="vm.settings.tradeInvoiceType"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="docType in (documentTypes | filter: $select.search) track by docType.code"><span ng-bind-html="docType.code +\' - \'+ docType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="tradeCreditType" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.tradeCreditType">Credit document type for trades</label><div class="col-sm-6"><ui-select id="tradeCreditType" ng-model="vm.settings.tradeCreditType" on-select="setDocReason($item)"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="docType in (documentTypesWithCorrection | filter: $select.search) track by docType.code"><span ng-bind-html="docType.code +\' - \'+ docType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row" ng-show="vm.settings.rectifDocReason"><div class="form-group"><div class="col-sm-6"><div class="col-sm-12"><small data-translate="pharmaPortalApp.portalSettings.portal.rectifDocHint">(the selected credit document implies to indicate a reason for the rectification. In the order screen it is still necessary to referenciate to the original document)</small></div></div><div class="col-sm-6"><label for="cecServiceType" class="col-sm-4" data-translate="pharmaPortalApp.portalSettings.portal.rectifDocReason">Reason for rectification</label><div class="col-sm-8">{{vm.settings.rectifDocReason}}</div></div></div></div></fieldset><fieldset ng-show="vm.moduleSettings.returnsModule"><legend class="text-success"><i class="fa fa-reply-all"></i>&nbsp;<span data-translate="pharmaPortalApp.portalSettings.portal.legend.pharmaReturn">Pharma Returns</span></legend><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="priceFromPolicyForReturns" class="form-check-label"><input type="checkbox" class="form-check-input" id="priceFromPolicyForReturns" ng-model="vm.settings.priceFromPolicyForReturns"> <span data-translate="pharmaPortalApp.portalSettings.portal.priceFromPolicyForReturns">Get price through policy for pharmacy returns</span></label></div></div><div class="col-sm-6"><div class="form-check" ng-show="vm.settings.priceFromPolicyForReturns"><label for="manualReturnPriceIfNull" class="form-check-label"><input type="checkbox" class="form-check-input" id="manualReturnPriceIfNull" ng-model="vm.settings.manualReturnPriceIfNull"> <span data-translate="pharmaPortalApp.portalSettings.portal.manualPriceIfNull">Enter price manually if price returned is null</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="returnWarehouseTransfType" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.returnWarehouseTransfType">Warehouse transfer document type</label><div class="col-sm-6"><ui-select id="returnWarehouseTransfType" ng-model="vm.settings.returnWarehouseTransfType"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="docType in (documentTypes | filter: $select.search) track by docType.code"><span ng-bind-html="docType.code +\' - \'+ docType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="returnCreditType" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.returnCreditType">Credit document type</label><div class="col-sm-6"><ui-select id="returnCreditType" ng-model="vm.settings.returnCreditType"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="docType in (documentTypes | filter: $select.search) track by docType.code"><span ng-bind-html="docType.code +\' - \'+ docType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="returnInternalClient" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.returnInternalClient">Internal client for returns</label><div class="col-sm-6"><ui-select id="returnInternalClient" name="returnInternalClient" ng-model="vm.settings.returnInternalClient"><ui-select-match allow-clear="true">{{$select.selected.namingForOptions}}</ui-select-match><ui-select-choices repeat="company in (companiesWithWarehouse | filter: { namingForOptions: $select.search } | orderBy:\'naming\') track by company.id"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div></fieldset><fieldset ng-show="vm.moduleSettings.selfInvoiceCollectionModule"><legend class="text-success"><i class="fa fa-file"></i>&nbsp;<span data-translate="pharmaPortalApp.portalSettings.portal.legend.selfInvoiceCollection">selfInvoiceCollection</span></legend><div class="row"><div class="form-group"><div class="col-sm-12"><label for="selfInvoiceCollectionEmail" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.selfInvoiceCollectionEmails">selfInvoiceCollectionEmails</label><div class="col-sm-6"><div class="input-group"><input type="email" class="form-control" id="selfInvoiceCollectionEmail" name="selfInvoiceCollectionEmail" ng-model="vm.selfInvoiceCollectionEmail"> <span class="input-group-btn"><button type="button" class="btn btn-success" ng-click="vm.addSelfInvoiceCollectionEmail()" ng-disabled="settingsForm.selfInvoiceCollectionEmail.$invalid"><i class="fa fa-plus"></i></button></span></div><table class="table table-responsive table-striped"><tbody><tr ng-repeat="item in vm.settings.selfInvoiceCollectionEmails"><td><i class="fa fa-envelope"></i>&nbsp;{{item.email}}</td><td><button type="button" class="btn btn-sm btn-danger" ng-click="vm.removeSelfInvoiceCollectionEmail(item)"><i class="fa fa-trash"></i></button></td></tr></tbody></table></div></div></div></div></fieldset><fieldset ng-show="vm.moduleSettings.pickingModule"><legend class="text-success"><i class="fa fa-list-alt"></i>&nbsp;<span data-translate="pharmaPortalApp.portalSettings.portal.legend.pharmaPicking">Pharma Picking</span></legend><div class="row"><div class="form-group"><div class="col-sm-12"><label for="pickingPassword" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.pickingPassword">Password to confirm incomplete picking / over quantity items</label><div class="col-sm-6"><input type="text" class="form-control input-sm" id="pickingPassword" ng-model="vm.settings.pickingPassword"></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><div class="col-sm-6"><div class="form-check"><label for="pickingQuantity" class="form-check-label"><input type="checkbox" class="form-check-input" id="pickingQuantity" ng-model="vm.settings.pickingQuantity"> <span data-translate="pharmaPortalApp.portalSettings.portal.pickingQuantityToggle">Allow quantity manual input</span></label></div></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="billingType" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.billingType">Billing type for invoice document</label><div class="col-sm-6"><ui-select id="billingType" ng-model="vm.settings.billingType"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="docType in (documentTypes | filter: $select.search) track by docType.code"><span ng-bind-html="docType.code +\' - \'+ docType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="transportType" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.transportType">Billing type for invoice document</label><div class="col-sm-6"><ui-select id="transportType" ng-model="vm.settings.transportType"><ui-select-match allow-clear="true">{{$select.selected.code}} - {{$select.selected.description}}</ui-select-match><ui-select-choices repeat="docType in (documentTypes | filter: $select.search) track by docType.code"><span ng-bind-html="docType.code +\' - \'+ docType.description | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="form-group"><div class="col-sm-12"><label for="targetCustomer" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.targetCustomer">Target Customer</label><div class="col-sm-6"><ui-select name="targetCustomer" id="targetCustomer" ng-model="vm.settings.targetCustomerCode"><ui-select-match allow-clear="true">{{$select.selected.namingForOptions}}</ui-select-match><ui-select-choices repeat="company in (companiesWithWarehouse | filter: { namingForOptions: $select.search } | orderBy:\'naming\') track by company.id"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div></div></fieldset><fieldset ng-show="vm.moduleSettings.innergyPortalProductVerificationModule"><legend class="text-success"><i class="fa fa-dashcube"></i>&nbsp; <span data-translate="pharmaPortalApp.portalSettings.portal.legend.innergyPortalProductVerification">innergyPortal Product Verification</span></legend><div class="row"><div class="form-group"><div class="col-sm-12"><label for="productVerificationPath" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.productVerificationPath">innergyPortal Product Verification Path</label><div class="col-sm-6"><input type="text" class="form-control input-sm" id="productVerificationPath" ng-model="vm.settings.productVerificationPath"></div></div></div></div></fieldset><fieldset ng-show="vm.moduleSettings.innergyPortalOrdersModule"><legend class="text-success"><i class="fa fa-cogs"></i>&nbsp; <span data-translate="pharmaPortalApp.portalSettings.portal.legend.innergyPortalOrders">innergyPortal Orders</span></legend><div class="row"><div class="form-group"><div class="col-sm-12"><label for="productVerificationPath" class="col-sm-6" data-translate="pharmaPortalApp.portalSettings.portal.innergyPortalOrdersPath">innergyPortal Orders Path</label><div class="col-sm-6"><input type="text" class="form-control input-sm" id="innergyPortalOrdersPath" ng-model="vm.settings.innergyPortalOrdersPath"></div></div></div></div></fieldset></div><div class="panel-footer"><div class="text-right"><button type="submit" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></div></form></div>');
$templateCache.put('app/entities/product-list/product-list-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.productSet.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-name" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p data-translate="pharmaPortalApp.productSet.delete.question" translate-values="{id: \'{{vm.productSet.name}}\'}">Are you sure you want to delete this ProductList?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm" autofocus><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/product-list/product-list-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-name" id="myProductListLabel" data-translate="pharmaPortalApp.productSet.home.createOrEditLabel">Create or edit a Product List</h4></div><div class="modal-body"><input type="hidden" class="form-control" name="id" id="id" ng-model="vm.productSet.id"><div class="form-group"><label class="control-label" data-translate="pharmaPortalApp.productSet.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.productSet.name"></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/product-list/product-lists.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-name pull-left" data-translate="pharmaPortalApp.productSet.home.title">Product Lists</span> <button class="btn btn-warning btn-sm pull-right" ui-sref="product-list.new"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.productSet.home.createLabel">Create new Product List</span></button> <span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="predicate" ascending="reverse"><th jh-sort-by="name"><span data-translate="pharmaPortalApp.productSet.name">Name</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="productSet in vm.productLists | filter:filter | orderBy:predicate:reverse track by productSet.id"><td class="table-left">{{productSet.name}}</td><td><div class="btn-group"><button type="submit" ui-sref="product-list.edit({id:productSet.id})" class="btn btn-primary btn-xs" name="{{\'entity.action.edit\' | translate}}"><i class="fa fa-pencil"></i></button> <button type="submit" ui-sref="product-list.delete({id:productSet.id})" class="btn btn-danger btn-xs" name="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/product-erp-integration/product-erp-integration-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.productErpIntegration.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p data-translate="pharmaPortalApp.productErpIntegration.delete.question" translate-values="{importationDate: \'{{vm.productErpIntegration.importationDate | date : \'dd/MM/yyyy \\\'\xE0s\\\' HH:mm\'}}\'}">Are you sure you want to delete the importation of {{importationDate}}?</p><p ng-if="vm.productErpIntegration.integrationStatus !== \'INTEGRATED\'" data-translate="pharmaPortalApp.productErpIntegration.delete.notIntegrated.observation">NOTE: This importation was not integrated into ERP yep</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid || vm.working" class="btn btn-danger" autofocus><span class="fa fa-trash-o"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/product-erp-integration/product-erp-integration-detail.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left"><span data-translate="pharmaPortalApp.productErpIntegration.detail.title">Product Erp Integration</span>&nbsp{{vm.productErpIntegration.importationDate | date : \'dd/MM/yyyy \\\'\xE0s\\\' HH:mm\'}}</span><div class="btn-group pull-right"><button type="button" ui-sref="product-erp-integration" class="btn btn-default"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button ng-if="vm.canBeIntegrated()" type="button" ng-click="vm.integrateIntoERP()" class="btn btn-info" ng-disabled="vm.working"><i class="fa fa-cloud-upload"></i>&nbsp;<span data-translate="pharmaPortalApp.productErpIntegration.integrateIntoERP">Integrate Into ERP</span></button></div><span class="clearfix"></span></div><div class="panel-body"><form class="form-horizontal container-fluid well well-sm"><div class="row col-sm-12"><div class="form-group col-sm-4"><label class="control-label col-sm-4" translate="pharmaPortalApp.productErpIntegration.importationDate">Importation Date</label><div class="col-sm-8"><p class="form-control-static">{{vm.productErpIntegration.importationDate | date: \'dd/MM/yyyy \\\' \xE0s \\\' HH:mm\'}}</p></div></div><div class="form-group col-sm-4"><label class="control-label col-sm-4" translate="pharmaPortalApp.productErpIntegration.integrationType">Integration Type</label><div class="col-sm-8"><p class="form-control-static">{{\'pharmaPortalApp.productErpIntegrationType.\'+vm.productErpIntegration.integrationType | translate}}</p></div></div><div class="form-group col-sm-4"><label class="control-label col-sm-4" translate="pharmaPortalApp.productErpIntegration.username">Username</label><div class="col-sm-8"><p class="form-control-static">{{vm.productErpIntegration.username}}</p></div></div></div><div class="row col-sm-12"><div class="form-group col-sm-4"><label class="control-label col-sm-4" translate="pharmaPortalApp.productErpIntegration.nbLines">Nb Lines</label><div class="col-sm-8"><p class="form-control-static">{{vm.getFormattedLineStatusMessage(vm.productErpIntegration)}}</p></div></div><div class="form-group col-md-4"><label class="control-label col-md-4" translate="pharmaPortalApp.productErpIntegration.originalFilename">Original Filename</label><div class="col-md-8"><p class="form-control-static">{{vm.productErpIntegration.originalFilename +\' (\'+ vm.formatSizeUnits(vm.productErpIntegration.fileSize) +\')\'}}</p></div></div></div><div class="row col-sm-12"><div class="form-group col-sm-4" ng-if="vm.productErpIntegration.integrationStatus == \'INTEGRATED\'"><label class="control-label col-sm-4" translate="pharmaPortalApp.productErpIntegration.integrationDate">Integration Date</label><div class="col-sm-8"><p class="form-control-static">{{vm.productErpIntegration.integrationDate | date: \'dd/MM/yyyy \\\' \xE0s \\\' HH:mm\'}}</p></div></div><div class="form-group col-sm-4"><label class="control-label col-sm-4" translate="pharmaPortalApp.productErpIntegration.integrationStatus">Status</label><div class="col-sm-8"><p class="form-control-static"><span>{{\'pharmaPortalApp.productErpIntegrationStatus.\'+vm.productErpIntegration.integrationStatus | translate}}</span> <span ng-if="vm.productErpIntegration.statusMessage">- {{vm.productErpIntegration.statusMessage | translate}}</span></p></div></div><div class="form-group col-sm-4" ng-if="vm.productErpIntegration.integrationStatus == \'INTEGRATED\'"><label class="control-label col-sm-4" translate="pharmaPortalApp.productErpIntegration.integrationResult">Integration Result</label><div class="col-sm-8"><p class="form-control-static">{{vm.getIntegrationResult()}}</p></div></div></div></form><div class="table-responsive"><table ng-if="vm.productErpIntegration.integrationType == \'PRODUCTS\'" class="jh-table table table-striped table-condensed"><thead><tr><th translate="pharmaPortalApp.productErpIntegration.productLine.rowNumber">rowNumber</th><th translate="pharmaPortalApp.productErpIntegration.productLine.sociedade">sociedade</th><th translate="pharmaPortalApp.productErpIntegration.productLine.template">template</th><th translate="pharmaPortalApp.productErpIntegration.productLine.codigo">codigo</th><th translate="pharmaPortalApp.productErpIntegration.productLine.descricao">descricao</th><th translate="pharmaPortalApp.productErpIntegration.productLine.alreadyExist">alreadyExist</th><th translate="pharmaPortalApp.productErpIntegration.productLine.iva">iva</th><th translate="pharmaPortalApp.productErpIntegration.productLine.categoriaProduto">categoriaProduto</th><th translate="pharmaPortalApp.productErpIntegration.productLine.grupoHomogeneo">grupoHomogeneo</th><th translate="pharmaPortalApp.productErpIntegration.productLine.generico">generico</th><th translate="pharmaPortalApp.productErpIntegration.productLine.labProdutor">labProdutor</th><th translate="pharmaPortalApp.productErpIntegration.productLine.labPreferencial">labPreferencial</th><th translate="pharmaPortalApp.productErpIntegration.productLine.tipoFornecimento">tipoFornecimento</th><th translate="pharmaPortalApp.productErpIntegration.productLine.marca">marca</th><th colspan="2" translate="pharmaPortalApp.productErpIntegration.productLine.status">status</th></tr></thead><tbody><tr ng-repeat="productLine in vm.lines track by $index"><td>{{productLine.rowNumber}}</td><td>{{productLine.sociedade}}</td><td>{{productLine.template}}</td><td>{{productLine.codigo}}</td><td class="table-left">{{productLine.descricao}}</td><td><span ng-if="!productLine.alreadyExist" class="text-success"><i class="fa fa-check"></i></span></td><td>{{productLine.iva}}</td><td>{{productLine.categoriaProduto}}</td><td>{{productLine.grupoHomogeneo}}</td><td>{{productLine.generico}}</td><td>{{productLine.labProdutor}}</td><td>{{productLine.labPreferencial}}</td><td>{{productLine.tipoFornecimento}}</td><td>{{productLine.marca}}</td><td class="table-right"><div ng-switch="productLine.status"><div ng-switch-when="OK"><span class="text-success"><i class="fa fa-thumbs-up"></i></span></div><div ng-switch-default><span class="text-danger"><i class="fa fa-thumbs-down"></i></span></div></div></td><td class="table-left"><div ng-if="productLine.status == \'OK\'"><i class="fa fa-check-square-o"></i>&nbsp; <small ng-if="vm.productErpIntegration.integrationStatus !== \'INTEGRATED\'" translate="pharmaPortalApp.productErpIntegration.integration.ready">Ready to be integrated</small> <small ng-if="vm.productErpIntegration.integrationStatus == \'INTEGRATED\'" translate="pharmaPortalApp.productErpIntegration.integration.integrated">Integrated successfully</small></div><div ng-repeat="errorLine in vm.formatErrorMessages(productLine.statusMessage) track by $index"><i class="fa fa-flash"></i>&nbsp;<small>{{errorLine}}</small><br></div></td></tr></tbody></table><table ng-if="vm.productErpIntegration.integrationType == \'PRICES\'" class="jh-table table table-striped table-condensed"><thead><tr><th translate="pharmaPortalApp.productErpIntegration.priceLine.rowNumber">rowNumber</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.sociedade">sociedade</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.tipo">tipo</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.moeda">moeda</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.clientePE">Cliente/Ponto Entrega</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.codigo">codigo</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.modelo">modelo</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.embalagem">embalagem</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.grandeFamilia">grandeFamilia</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.dataPreco">dataPreco</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.quantidadeEscalao">quantidadeEscalao</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.descricaoArtigoPrecario">descricaoArtigoPrecario</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.precoUnitario">precoUnitario</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.percentagemDesconto">percentagemDesconto</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.valorDesconto">valorDesconto</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.quantidadeBaseBonus">quantidadeBaseBonus</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.quantidadeBonus">quantidadeBonus</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.codigoIVA">codigoIVA</th><th translate="pharmaPortalApp.productErpIntegration.priceLine.dataFinal">dataFinal</th><th colspan="2" translate="pharmaPortalApp.productErpIntegration.priceLine.status">status</th></tr></thead><tbody><tr ng-repeat="priceLine in vm.lines track by $index"><td>{{priceLine.rowNumber}}</td><td>{{priceLine.sociedade}}</td><td>{{priceLine.tipo}}</td><td>{{priceLine.moeda}}</td><td>{{vm.getFormattedClientPE(priceLine)}}</td><td>{{priceLine.codigo}}</td><td>{{priceLine.modelo}}</td><td>{{priceLine.embalagem}}</td><td>{{priceLine.grandeFamilia}}</td><td>{{priceLine.dataPreco}}</td><td>{{priceLine.quantidadeEscalao}}</td><td>{{priceLine.descricaoArtigoPrecario}}</td><td>{{priceLine.precoUnitario}}</td><td>{{priceLine.percentagemDesconto}}</td><td>{{priceLine.valorDesconto}}</td><td>{{priceLine.quantidadeBaseBonus}}</td><td>{{priceLine.quantidadeBonus}}</td><td>{{priceLine.codigoIVA}}</td><td>{{priceLine.dataFinal}}</td><td class="table-right"><div ng-switch="priceLine.status"><div ng-switch-when="OK"><span class="text-success"><i class="fa fa-thumbs-up"></i></span></div><div ng-switch-default><span class="text-danger"><i class="fa fa-thumbs-down"></i></span></div></div></td><td class="table-left"><div ng-if="priceLine.status == \'OK\'"><i class="fa fa-check-square-o"></i>&nbsp; <small ng-if="vm.productErpIntegration.integrationStatus !== \'INTEGRATED\'" translate="pharmaPortalApp.productErpIntegration.integration.ready">Ready to be integrated</small> <small ng-if="vm.productErpIntegration.integrationStatus == \'INTEGRATED\'" translate="pharmaPortalApp.productErpIntegration.integration.integrated">Integrated successfully</small></div><div ng-repeat="errorLine in vm.formatErrorMessages(priceLine.statusMessage) track by $index"><i class="fa fa-flash"></i>&nbsp;<small>{{errorLine}}</small><br></div></td></tr></tbody></table><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" items-per-page="vm.itemsPerPage" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div><div class="panel-footer"><div class="text-right"><button type="button" ui-sref="product-erp-integration" class="btn btn-default"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button ng-if="vm.canBeIntegrated()" type="button" ng-click="vm.integrateIntoERP()" class="btn btn-info" ng-disabled="vm.working"><i class="fa fa-cloud-upload"></i>&nbsp;<span data-translate="pharmaPortalApp.productErpIntegration.integrateIntoERP">Integrate Into ERP</span></button></div></div></div></div>');
$templateCache.put('app/entities/product-erp-integration/product-erp-integration-dialog.html','<form class="form-horizontal" name="uploadForm" ng-submit="vm.uploadFile()"><div ng-cloak><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.productErpIntegration.newDialog.title">Integrate new excel file</h4></div><div class="modal-body" id="modal-body"><div class="form-group"><label class="col-md-4 control-label" data-translate="pharmaPortalApp.productErpIntegration.newDialog.fileType">Integration Type</label><div class="col-sm-6"><div class="radio"><label><input type="radio" name="integrationType" id="productsIntegrationType" ng-model="vm.productErpIntegration.integrationType" value="PRODUCTS" ng-checked="vm.productErpIntegration.integrationType == \'PRODUCTS\'" required> <span data-translate="pharmaPortalApp.productErpIntegrationType.PRODUCTS">Products</span></label></div><div class="radio"><label><input type="radio" name="integrationType" id="pricesIntegrationType" ng-model="vm.productErpIntegration.integrationType" value="PRICES" ng-checked="vm.productErpIntegration.integrationType == \'PRICES\'" required> <span data-translate="pharmaPortalApp.productErpIntegrationType.PRICES">Prices</span></label></div></div></div><div class="form-group"><label class="control-label col-sm-4" for="file" translate="global.form.file">File</label><div class="col-sm-7"><input type="file" class="file" ngf-select ng-model="vm.productErpIntegration.file" id="file" ngf-pattern="\'.xls,.xlsx\'" accept=".xls,.xlsx" ngf-max-size="20MB" ngf-model-invalid="errorFile"><div class="input-group input-group-sm"><span class="input-group-btn"><button class="browse btn btn-primary" type="button"><i class="fa fa-search"></i>&nbsp;<span translate="entity.action.search">Search</span></button> </span><input type="text" name="file" class="form-control" disabled="disabled"></div></div><script>$(\'.browse\').on(\'click\', function (event) {\n                        var file = $(this).parent().parent().parent().find(\'.file\');\n                        file.trigger(\'click\');\n                    });\n                    $(\'.file\').on(\'change\', function (event) {\n                        $(this).parent().find(\'.form-control\').val($(this).val().replace(/C:\\\\fakepath\\\\/i, \'\'));\n                    });</script></div><span class="clearfix"></span></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="uploadForm.$invalid || vm.working"><i class="fa fa-upload"></i>&nbsp;<span data-translate="entity.action.upload">Upload</span></button></div></div></form>');
$templateCache.put('app/entities/product-erp-integration/product-erp-integrations.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.productErpIntegration.home.title">Product Erp Integrations</span><div class="btn-group pull-right"><button class="btn btn-info btn-sm" ng-click="vm.getTemplate()"><i class="fa fa-download"></i>&nbsp;<span data-translate="entity.action.downloadTemplate">Download template</span></button> <button type="button" class="btn btn-warning btn-sm pull-right" ng-click="vm.openNewImportDialog()"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.productErpIntegration.newImportation">New Importation</span></button></div><span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="importationDate"><span translate="pharmaPortalApp.productErpIntegration.importationDate">Importation Date</span>&nbsp;<span class="fa fa-sort"></span></th><th jh-sort-by="originalFilename"><span translate="pharmaPortalApp.productErpIntegration.originalFilename">Original Filename</span>&nbsp;<span class="fa fa-sort"></span></th><th jh-sort-by="integrationType"><span translate="pharmaPortalApp.productErpIntegration.integrationType">Integration Type</span>&nbsp;<span class="fa fa-sort"></span></th><th jh-sort-by="nbLines"><span translate="pharmaPortalApp.productErpIntegration.nbLines">Nb Lines</span>&nbsp;<span class="fa fa-sort"></span></th><th jh-sort-by="username"><span translate="pharmaPortalApp.productErpIntegration.username">Username</span>&nbsp;<span class="fa fa-sort"></span></th><th jh-sort-by="integrationDate"><span translate="pharmaPortalApp.productErpIntegration.integrationDate">Integration Date</span>&nbsp;<span class="fa fa-sort"></span></th><th jh-sort-by="integrationStatus"><span translate="pharmaPortalApp.productErpIntegration.integrationStatus">Integration Status</span>&nbsp;<span class="fa fa-sort"></span></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="productErpIntegration in vm.productErpIntegrations track by productErpIntegration.id"><td>{{productErpIntegration.importationDate | date: \'dd/MM/yyyy \\\' \xE0s \\\' HH:mm\'}}</td><td class="table-left">{{productErpIntegration.originalFilename +\' (\' + vm.formatSizeUnits(productErpIntegration.fileSize) + \')\'}}</td><td class="table-left"><i ng-class="{\'fa fa-cubes\' : productErpIntegration.integrationType == \'PRODUCTS\', \'fa fa-euro\' : productErpIntegration.integrationType == \'PRICES\'}"></i> {{\'pharmaPortalApp.productErpIntegrationType.\' + productErpIntegration.integrationType | translate}}</td><td>{{vm.getFormattedLineStatusMessage(productErpIntegration)}}</td><td>{{productErpIntegration.username}}</td><td>{{productErpIntegration.integrationDate | date: \'dd/MM/yyyy \\\' \xE0s \\\' HH:mm\'}}</td><td><span>{{\'pharmaPortalApp.productErpIntegrationStatus.\' + productErpIntegration.integrationStatus | translate}} {{productErpIntegration.statusMessage != null ? "&nbsp;-&nbsp;" : ""}} {{productErpIntegration.statusMessage | translate}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" class="btn btn-info btn-xs" placeholder="{{\'entity.action.view\' | translate}}" ui-sref="product-erp-integration-detail({id:productErpIntegration.id})"><i class="fa fa-search-plus"></i></button> <button type="submit" class="btn btn-danger btn-xs" placeholder="{{\'entity.action.delete\' | translate}}" ui-sref="product-erp-integration.delete({id:productErpIntegration.id})"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/purchase-order/purchase-order-detail.html','<div><h2><span data-translate="pharmaPortalApp.purchaseOrder.detail.title">Purchase Order</span>&nbsp;{{vm.purchaseOrder.id}}</h2><hr><dl class="dl-horizontal jh-entity-details"></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div>');
$templateCache.put('app/entities/purchase-order/purchase-orders.html','<div><h2 data-translate="pharmaPortalApp.purchaseOrder.home.title">Purchase Orders</h2><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="purchaseOrder in vm.purchaseOrders track by purchaseOrder.id"><td><a ui-sref="purchase-order-detail({id:purchaseOrder.id})">{{purchaseOrder.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="purchase-order-detail({id:purchaseOrder.id})" class="btn btn-info btn-xs"><i class="fa fa-search-plus"></i>&nbsp;<span data-translate="entity.action.view">View</span></button></div></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div>');
$templateCache.put('app/entities/purchase-order-item/purchase-order-item-detail.html','<div><h2><span data-translate="pharmaPortalApp.purchaseOrderItem.detail.title">Purchase Order Item</span> {{vm.purchaseOrderItem.id}}</h2><hr><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.purchaseOrderItem.cnp">Cnp</span></dt><dd><span>{{vm.purchaseOrderItem.cnp}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div>');
$templateCache.put('app/entities/purchase-order-item/purchase-order-items.html','<div><h2 data-translate="pharmaPortalApp.purchaseOrderItem.home.title">Purchase Order Items</h2><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="cnp"><span data-translate="pharmaPortalApp.purchaseOrderItem.cnp">Cnp</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="purchaseOrderItem in vm.purchaseOrderItems track by purchaseOrderItem.id"><td><a ui-sref="purchase-order-item-detail({id:purchaseOrderItem.id})">{{purchaseOrderItem.id}}</a></td><td>{{purchaseOrderItem.cnp}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="purchase-order-item-detail({id:purchaseOrderItem.id})" class="btn btn-info btn-xs"><i class="fa fa-search-plus"></i>&nbsp;<span data-translate="entity.action.view">View</span></button></div></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div>');
$templateCache.put('app/entities/report-group/report-group-delete-dialog.html','<form name="deleteFrom" ng-submit="vm.confirmDelete(vm.reportGroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.reportGroup.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p data-translate="pharmaPortalApp.reportGroup.delete.question" translate-values="{id: \'{{vm.reportGroup.id}}\'}">Are you sure you want to delete this Report Group?</p><p data-translate="pharmaPortalApp.reportGroup.delete.warning" style="color: #d2322d">Warning: by deleting this group you will also delete all reports linked to it.</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span data-translate="pharmaPortalApp.reportGroup.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><span class="fa fa-trash-o"></span>&nbsp;<span data-translate="pharmaPortalApp.reportGroup.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/report-group/report-group-detail.html','<div><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left" data-translate="pharmaPortalApp.reportGroup.detail.title">Report Group</span>&nbsp;{{vm.reportGroups.name}} <span class="clearfix"></span></div><div class="panel-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.reportGroup.name">Name</span></dt><dd><span>{{vm.reportGroup.name}}</span></dd><dt><span data-translate="pharmaPortalApp.reportGroup.order">Order</span></dt><dd><span>{{vm.reportGroup.order}}</span></dd><dt><span data-translate="pharmaPortalApp.reportGroup.icon">Icon</span></dt><dd><i class="fa fa-fw fa-lg {{vm.reportGroup.icon}}"></i></dd></dl></div><div class="panel-footer"><div class="text-right"><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="button" ui-sref="report-group-detail.edit({id:vm.reportGroup.id})" class="btn btn-primary btn-sm"><i class="fa fa-pencil"></i>&nbsp;<span data-translate="entity.action.edit">Edit</span></button></div></div></div></div>');
$templateCache.put('app/entities/report-group/report-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times,</button><h4 class="modal-title" id="reportGroupLabel" data-translate="pharmaPortalApp.reportGroup.home.createOrEditLabel">Create or edit a Report Group</h4></div><div class="modal-body"><input type="hidden" class="form-control" name="id" id="id" ng-model="vm.reportGroup.id"><div class="form-group"><label class="control-label" for="field_name" data-translate="pharmaPortalApp.reportGroup.field.name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.reportGroup.name"></div><div class="form-group"><label class="control-label" for="field_order" data-translate="pharmaPortalApp.reportGroup.field.order">Order</label><input type="text" class="form-control" name="order" id="field_order" ng-model="vm.reportGroup.order"></div><div class="form-group"><label class="control-label" for="field_icon" data-translate="pharmaPortalApp.reportGroup.field.icon">Icon</label><input type="text" class="form-control" name="order" id="field_icon" ng-model="vm.reportGroup.icon"></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><span class="fa fa-ban"></span>&nbsp;<span data-translate="pharmaPortalApp.reportGroup.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success btn-sm"><span class="fa fa-floppy-o"></span>&nbsp;<span data-translate="pharmaPortalApp.reportGroup.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/report-group/report-group.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.reportGroup.home.title">Report Groups</span> <button class="btn btn-warning btn-sm pull-right" ui-sref="report-group.new"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.reportGroup.home.createLabel">Create new Report Group</span></button> <span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th><span data-translate="pharmaPortalApp.reportGroup.name">Name</span></th><th><span data-translate="pharmaPortalApp.reportGroup.order">Order</span></th><th><span data-translate="pharmaPortalApp.reportGroup.icon">Icon</span></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="group in vm.reportGroups track by group.id"><td class="table-left">{{group.name}}</td><td class="table-right">{{group.order}}</td><td class="table-center"><i class="fa fa-fw fa-lg {{group.icon}}"></i></td><td><div class="btn-group"><button type="submit" ui-sref="report-group-detail({id:group.id})" class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}"><i class="fa fa-search-plus"></i></button> <button type="submit" ui-sref="report-group.edit({id:group.id})" class="btn btn-primary btn-xs" title="{{\'entity.action.edit\' | translate}}"><i class="fa fa-pencil"></i></button> <button type="submit" ui-sref="report-group.delete({id:group.id})" class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/entities/report/report-by-report-group.html','<div><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left"><span data-translate="pharmaPortalApp.reports.home.title">Reports</span> &nbsp;<i class="fa fa-angle-double-right"></i>&nbsp; <span>{{vm.reportGroup.group}} </span></span><span class="clearfix"></span></div><div class="panel-body reportDnD"><ul class="reportDnD" dnd-list="vm.orderedReports" dnd-horizontal-list="true" style="list-style: none"><li ng-repeat="report in vm.orderedReports" dnd-draggable="report" dnd-effect-allowed="move" dnd-moved="vm.orderedReports.splice($index,1)" dnd-selected="" dnd-dragstart="onDragStart(report)" dnd-dragend="onDrop(report)" ng-hide="report.selected==true"><div class="col-lg-2 col-md-4 col-sm-6 report_box" style="margin-bottom: 30px"><div class="img_box text-center"><img data-ng-src="{{\'data:\' + report.thumbnailContentType + \';base64,\' + report.thumbnail}}" style="max-width: 200px"><div class="full-caption"><h4>{{report.title}}</h4><div class="export_types"><a href="{{report.fullLink}}&__format=html" target="_blank" class="html" title="ver dados no browser"><i class="fa fa-th-list"></i></a> <a href="{{report.fullLink}}&__format=pdf" target="_blank" class="pdf" title="exportar para pdf"><i class="fa fa-file-pdf-o"></i></a> <a href="{{report.fullLink}}&__format=xls" target="_blank" class="excel" title="exportar para xls"><i class="fa fa-file-excel-o"></i></a></div></div><div class="img_caption">{{report.title}}</div></div></div></li></ul></div><div class="panel-footer"><div class="text-right"><button type="submit" class="btn btn-success btn-sm" ng-disabled="!vm.canSave" ng-click="save(vm.orderedReports)"><i class="fa fa-save"></i>&nbsp;<span data-translate="pharmaPortalApp.reports.home.save">Save</span></button></div></div></div></div>');
$templateCache.put('app/entities/report/report-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.report.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><span data-translate="pharmaPortalApp.report.delete.question" translate-values="{id: \'{{vm.report.title}}\'}">Are you sure you want to delete this Report?</span></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/report/report-detail.html','<div><div class="panel panel-default"><div class="panel-heading"><span class="panel-title pull-left" data-translate="pharmaPortalApp.report.detail.title">Report</span>&nbsp;{{vm.report.id}} <span class="clearfix"></span></div><div class="panel-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="pharmaPortalApp.report.title">Title</span></dt><dd><span>{{vm.report.title}}</span></dd><dt><span data-translate="pharmaPortalApp.report.reportGroup">ReportGroup</span></dt><dd><span>{{vm.report.reportGroupLabel}}</span></dd><dt><span data-translate="pharmaPortalApp.report.name">Name</span></dt><dd><span>{{vm.report.link}}</span></dd><dt><span data-translate="pharmaPortalApp.report.link">Link</span></dt><dd><span>{{vm.report.fullLink}}</span></dd><dt><span data-translate="pharmaPortalApp.report.thumbnail">Thumbnail</span></dt><dd><div ng-if="vm.report.thumbnail"><a ng-click="vm.openFile(vm.report.thumbnailContentType, vm.report.thumbnail)"><img data-ng-src="{{\'data:\' + vm.report.thumbnailContentType + \';base64,\' + vm.report.thumbnail}}" style="max-width: 200px" alt="report image"></a></div></dd></dl></div><div class="panel-footer"><div class="text-right"><button type="submit" ui-sref="report" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="button" ui-sref="report-detail.edit({id:vm.report.id})" class="btn btn-primary btn-sm"><i class="fa fa-pencil"></i>&nbsp;<span data-translate="entity.action.edit">Edit</span></button></div></div></div></div>');
$templateCache.put('app/entities/report/report-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReportLabel" data-translate="pharmaPortalApp.report.home.createOrEditLabel">Create or edit a Report</h4></div><div class="modal-body"><input type="hidden" class="form-control" name="id" id="id" ng-model="vm.report.id"><div class="form-group"><label class="control-label label-required" data-translate="pharmaPortalApp.report.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.report.title"></div><div class="form-group"><label class="control-label label-required" data-translate="pharmaPortalApp.report.name" for="field_name">Name</label><input type="text" class="form-control" name="link" id="field_name" ng-model="vm.report.link"></div><div class="form-group" ngf-drop ngf-change="vm.setThumbnail($file, vm.report)" ngf-pattern="\'image/*\'"><label class="control-label" data-translate="pharmaPortalApp.report.thumbnail" for="field_thumbnail_button">Thumbnail</label><div><img data-ng-src="{{\'data:\' + vm.report.thumbnailContentType + \';base64,\' + vm.report.thumbnail}}" style="max-height: 100px" ng-if="vm.report.thumbnail" alt="report image"><div class="help-block clearfix"><button type="button" id="field_thumbnail_button" ngf-select class="btn btn-warning btn-sm" ngf-change="vm.setThumbnail($file, vm.report)" accept="image/*"><i class="fa fa-picture-o"></i>&nbsp;<span data-translate="entity.action.addimage">Add image</span></button> <span ng-if="vm.report.thumbnail"><button type="button" ng-click="vm.report.thumbnail=null;vm.report.thumbnailContentType=null;" class="btn btn-danger btn-sm"><i class="fa fa-trash-o"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button> <span>{{vm.report.thumbnailContentType}}, {{vm.byteSize(vm.report.thumbnail)}}</span></span></div></div><input type="hidden" class="form-control" name="thumbnail" id="field_thumbnail" ng-model="vm.report.thumbnail"> <input type="hidden" class="form-control" name="thumbnailContentType" id="field_thumbnailContentType" ng-model="vm.report.thumbnailContentType"></div><div class="form-group"><label class="control-label label-required" data-translate="pharmaPortalApp.report.reportGroup" for="field_reportGroup">Group</label><select class="form-control" id="field_reportGroup" name="group" ng-model="vm.report.reportGroup" ng-options="reportGroup as reportGroup.name for reportGroup in vm.reportGroups track by reportGroup.id" required><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success btn-sm"><i class="fa fa-floppy-o"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/report/reports.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" data-translate="pharmaPortalApp.report.home.title">Reports</span> <button class="btn btn-warning btn-sm pull-right" ui-sref="report.new"><i class="fa fa-plus"></i>&nbsp;<span data-translate="pharmaPortalApp.report.home.createLabel">Create new Report</span></button> <span class="clearfix"></span></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="title"><span data-translate="pharmaPortalApp.report.title">Title</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="link"><span data-translate="pharmaPortalApp.report.name">Name</span>&nbsp;<i class="fa fa-sort"></i></th><th jh-sort-by="reportGroup"><span data-translate="pharmaPortalApp.report.reportGroup">ReportGroup</span>&nbsp;<i class="fa fa-sort"></i></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="report in vm.reports track by report.id"><td class="table-left">{{report.title}}</td><td class="table-left">{{report.link}}</td><td class="table-left">{{report.reportGroupLabel}}</td><td><div class="btn-group"><button type="submit" ui-sref="report-detail({id:report.id})" class="btn btn-info btn-xs" title="{{\'entity.action.view\' | translate}}"><i class="fa fa-search-plus"></i></button> <button type="submit" ui-sref="report.edit({id:report.id})" class="btn btn-primary btn-xs" title="{{\'entity.action.edit\' | translate}}"><i class="fa fa-pencil"></i></button> <button type="submit" ui-sref="report.delete({id:report.id})" class="btn btn-danger btn-xs" title="{{\'entity.action.delete\' | translate}}"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></div><div class="panel-footer"><div class="text-center"><ul uib-pagination class="pagination-sm" direction-links="true" boundary-links="true" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div></div></div></div>');
$templateCache.put('app/entities/self-invoice-collection/self-invoice-collection-clear-dialog.html','<form ng-submit="vm.confirmClearOrder()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.selfInvoiceCollection.clearSelfInvoiceCollection.title">Clear return\'s list?</h4></div><div class="modal-body"><p><span data-translate="pharmaPortalApp.selfInvoiceCollection.clearSelfInvoiceCollection.body">You have selected to remove all products from your return list</span></p><p><span data-translate="pharmaPortalApp.selfInvoiceCollection.clearSelfInvoiceCollection.confirm">Do you want to continue?</span></p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/self-invoice-collection/self-invoice-collection-confirm-dialog.html','<form ng-submit="vm.confirm()" class="form-horizontal" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.selfInvoiceCollection.submitSelfInvoiceCollection.title">Submit pharmacy selfInvoiceCollection</h4></div><div class="modal-body"><div class="form-group"><div class="col-sm-12"><p><span data-translate="pharmaPortalApp.selfInvoiceCollection.submitSelfInvoiceCollection.body">Indicate, if desired, the selfInvoiceCollection guide number generated to accompany the merchandise.</span></p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" ng-disabled="vm.processing" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/self-invoice-collection/self-invoice-collection-remove-line-dialog.html','<form ng-submit="vm.confirmRemoveLine()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.selfInvoiceCollection.removeLine.title">Remove product from the selfInvoiceCollection list?</h4></div><div class="modal-body"><p><span data-translate="pharmaPortalApp.selfInvoiceCollection.removeLine.body">You have selected to remove the following product from your selfInvoiceCollection list</span></p><p>{{vm.product.nome}}&nbsp;{{vm.product.dosagem}}&nbsp;{{vm.product.emb}}</p><p><span data-translate="pharmaPortalApp.selfInvoiceCollection.cnp">CNP</span>: {{vm.product.cnp}}</p><p><span data-translate="pharmaPortalApp.selfInvoiceCollection.qtd">Quantity</span>: {{vm.product.qtd | number:0}}</p><p><span data-translate="pharmaPortalApp.selfInvoiceCollection.price">Unit price</span>: {{vm.product.price | currency : \'&euro;\' : 2}}</p><p><span data-translate="pharmaPortalApp.selfInvoiceCollection.removeLine.confirm">Do you want to continue?</span></p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.no">No</span></button> <button type="submit" class="btn btn-success btn-sm" autofocus><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.yes">Yes</span></button></div></form>');
$templateCache.put('app/entities/self-invoice-collection/self-invoice-collection.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><div class="panel-title col-sm-6 pull-left no-padding"><span class="pull-left" data-translate="pharmaPortalApp.selfInvoiceCollection.home.newSelfInvoiceCollection">New SelfInvoiceCollection</span><div class="col-sm-8 pull-left"><div has-any-authority="ROLE_ADMIN,ROLE_SUPER_ADMIN,ROLE_PHARMA_ADMIN"><ui-select name="company" ng-model="vm.currentCompany" on-select="vm.updateCompany($item, $model)"><ui-select-match placeholder="{{\'pharmaPortalApp.selfInvoiceCollection.placeholder.company\' | translate}}" allow-clear="true">{{$select.selected.namingForOptions}}</ui-select-match><ui-select-choices repeat="company as company in vm.companies | filter: $select.search | orderBy:\'naming\'"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div></div></div><div class="btn-group pull-right"><button class="btn btn-danger btn-sm" ui-sref="self-invoice-collection.clearSelfInvoiceCollection()" ng-disabled="isOrderEmpty()"><i class="fa fa-recycle"></i>&nbsp;<span data-translate="pharmaPortalApp.selfInvoiceCollection.home.clearSelfInvoiceCollection">Clear SelfInvoiceCollection</span></button></div><span class="clearfix"></span></div><div class="panel-body"><div ng-hide="vm.currentCompany"><div class="jumbotron text-center"><h4><i class="fa fa-building fa-3x"></i>&nbsp;&nbsp;&nbsp;Por favor escolha o cliente a partir do qual pretende efetuar a recolha de autofaturas.</h4></div></div><div ng-show="vm.currentCompany"><form id="selfInvoiceCollectionProductForm" name="selfInvoiceCollectionProductForm" class="form container-fluid well well-sm" ng-submit="vm.addProduct()"><div class="form-group form-group-sm col-md-4 col-sm-5"><ui-select id="filterProduct" ng-model="vm.products.selected" reset-search-input="false" fix-selected-item uis-open-close="onOpenClose(isOpen)" on-select="getPriceFromPolicy($item, $model, !vm.isTotalSet)" required><ui-select-match placeholder="{{\'global.form.search.placeholder.product\' | translate}}">{{$select.selected.cnp}} - {{$select.selected.fullName}}</ui-select-match><ui-select-choices repeat="product as product in vm.products track by product.cnp" refresh="refreshSelectModel($select.search)" refresh-delay="500" minimum-input-length="3"><span ng-bind-html="product.cnp +\' - \'+ product.fullHtmlName"></span></ui-select-choices></ui-select></div><div class="form-group col-md-2 col-sm-2"><div class="input-group input-group-sm"><input type="text" class="form-control" ng-model="vm.products.selected.qtd" ng-disabled="!vm.products.selected" placeholder="{{\'pharmaPortalApp.selfInvoiceCollection.placeholder.quantity\' | translate}}" required> <span class="input-group-addon"><i class="fa fa-archive"></i></span></div></div><div class="form-group col-md-2 col-sm-2"><div class="input-group input-group-sm" ng-if="!vm.isTotalSet"><input id="falseInput" type="text" class="form-control" ng-class="{\'download\': vm.showAnimation }" ng-model="vm.products.selected.price" ng-disabled="!vm.products.selected || vm.validPolicyPrice" placeholder="{{\'pharmaPortalApp.selfInvoiceCollection.placeholder.unitPrice\' | translate}}" required price> <span class="input-group-addon"><i class="fa fa-eur"></i></span></div><div class="input-group input-group-sm" ng-if="vm.isTotalSet"><input ng-class="{\'download\': vm.showAnimation }" id="trueInput" type="text" class="form-control" ng-model="vm.products.selected.total" ng-disabled="!vm.products.selected" placeholder="{{\'pharmaPortalApp.selfInvoiceCollection.placeholder.unitTotalPrice\' | translate}}" required price> <span class="input-group-addon"><i class="fa fa-eur"></i></span></div></div><div class="form-group col-md-1 col-sm-1"><button class="btn btn-success btn-sm" title="{{\'pharmaPortalApp.selfInvoiceCollection.placeholder.addItem\' | translate}}" ng-disabled="selfInvoiceCollectionProductForm.$invalid"><i class="fa fa-plus"></i></button></div><toggle ng-model="vm.isTotalSet" ng-change="vm.changeToggle()" on="{{  vm.getOnTranslation()}}" off="{{  vm.getOffTranslation()}}"></toggle></form><form name="selfInvoiceCollectionForm" role="form"><div class="table-responsive"><table class="jh-table table table-striped panel tableCell" table-hover-highlight float-thead="floatTheadOptions" ng-model="selfInvoiceCollectionOrderList"><thead><tr class="topHeader"><th><span data-translate="pharmaPortalApp.selfInvoiceCollection.cnp">CNP</span></th><th><span data-translate="pharmaPortalApp.selfInvoiceCollection.description">Description</span></th><th><span data-translate="pharmaPortalApp.selfInvoiceCollection.qtd">Quantity</span></th><th><span data-translate="pharmaPortalApp.selfInvoiceCollection.price">Unit price</span></th><th><span data-translate="pharmaPortalApp.selfInvoiceCollection.vat">IVA</span></th><th><span data-translate="pharmaPortalApp.selfInvoiceCollection.total">Total</span></th><th data-translate="table.actions">Actions</th></tr></thead><tbody><tr ng-repeat="selfInvoiceCollectionProd in selfInvoiceCollectionOrderList track by selfInvoiceCollectionProd.cnp"><td class="table-left" ng-init="selfInvoiceCollectionProd.editMode = \'\' ">{{selfInvoiceCollectionProd.cnp}}</td><td class="table-left" ng-bind-html="selfInvoiceCollectionProd.fullHtmlName" style="width: 30%"></td><td class="form-group" ng-class="{\'has-error has-feedback text-danger\': selfInvoiceCollectionProd.invalidQtd}"><span ng-if="selfInvoiceCollectionProd.editMode===\'\' || !selfInvoiceCollectionProd.editMode"><span class="alert alert-danger" ng-show="selfInvoiceCollectionProd.invalidQtd">{{selfInvoiceCollectionProd.qtd}}</span> <span ng-hide="selfInvoiceCollectionProd.invalidQtd">{{selfInvoiceCollectionProd.qtd | number : 0}}</span> </span><input ng-if="selfInvoiceCollectionProd.editMode!=\'\' && selfInvoiceCollectionProd.editMode" type="text" class="form-control input-xs text-center" id="qtd" ng-model="selfInvoiceCollectionProd.qtd" ng-class="{ \'alert-danger\': selfInvoiceCollectionProd.qtd <= 0 }" ng-keypress="vm.validateLines(selfInvoiceCollectionProd,$event)" ng-blur="vm.validateLines(selfInvoiceCollectionProd,$event)" on-enter="vm.validateLines(selfInvoiceCollectionProd,\'onEnter\');vm.toggleLineEditMode(selfInvoiceCollectionProd)"> <i class="fa fa-remove form-control-feedback"></i></td><td class="form-group" ng-class="{\'has-error has-feedback text-danger\': selfInvoiceCollectionProd.invalidPrice}"><span ng-if="selfInvoiceCollectionProd.editMode===\'\' || !selfInvoiceCollectionProd.editMode"><span class="alert alert-danger" ng-show="selfInvoiceCollectionProd.invalidPrice">{{selfInvoiceCollectionProd.price}}</span> <span ng-hide="selfInvoiceCollectionProd.invalidPrice">{{selfInvoiceCollectionProd.price | currency : \'&euro;\' : 2}}</span> </span><input ng-if="selfInvoiceCollectionProd.editMode!=\'\' && selfInvoiceCollectionProd.editMode" type="text" class="form-control input-xs text-center" id="price" ng-model="selfInvoiceCollectionProd.price" ng-class="{ \'alert-danger\': selfInvoiceCollectionProd.price <= 0 }" ng-keypress="vm.validateLines(selfInvoiceCollectionProd,$event)" ng-blur="vm.validateLines(selfInvoiceCollectionProd,$event)" ng-disabled="selfInvoiceCollectionProd.validPolicyPrice" on-enter="vm.validateLines(selfInvoiceCollectionProd,\'onEnter\');vm.toggleLineEditMode(selfInvoiceCollectionProd)" price> <i class="fa fa-remove form-control-feedback"></i></td><td class="table-right">{{selfInvoiceCollectionProd.txiva | currency : \'%\' : 2}}</td><td class="form-group" ng-class="{\'has-error has-feedback text-danger\': selfInvoiceCollectionProd.invalidPrice}"><span ng-if="selfInvoiceCollectionProd.editMode===\'\' || !selfInvoiceCollectionProd.editMode"><span class="alert alert-danger" ng-show="selfInvoiceCollectionProd.invalidPrice">{{selfInvoiceCollectionProd.total}}</span> <span>{{selfInvoiceCollectionProd.total | currency : \'&euro;\' : 2}}</span> </span><input ng-if="selfInvoiceCollectionProd.editMode!=\'\' && selfInvoiceCollectionProd.editMode" type="text" class="form-control input-xs text-center" id="total" ng-model="selfInvoiceCollectionProd.total" ng-class="{ \'alert-danger\': selfInvoiceCollectionProd.price <= 0 }" ng-keypress="vm.validateLines(selfInvoiceCollectionProd,$event)" ng-blur="vm.validateLines(selfInvoiceCollectionProd,$event)" on-enter="vm.validateLines(selfInvoiceCollectionProd,\'onEnter\');vm.toggleLineEditMode(selfInvoiceCollectionProd)" price required> <i class="fa fa-remove form-control-feedback"></i></td><td><div class="btn-group"><button class="btn btn-primary btn-xs" title="{{\'pharmaPortalApp.selfInvoiceCollection.placeholder.editItem\' | translate}}" ng-class="{ \'active\': selfInvoiceCollectionProd.editMode!=\'\' && selfInvoiceCollectionProd.editMode}" ng-click="vm.toggleLineEditMode(selfInvoiceCollectionProd);"><i class="fa fa-pencil"></i></button> <button class="btn btn-danger btn-xs" title="{{\'pharmaPortalApp.selfInvoiceCollection.placeholder.removeItem\' | translate}}" ui-sref="self-invoice-collection.removeLine({cnpToDel:selfInvoiceCollectionProd.cnp})"><i class="fa fa-trash-o"></i></button></div></td></tr></tbody></table></div></form></div><div class="panel-footer"><div class="row" ng-show="vm.currentCompany"><div class="col-sm-12 small"><label class="col-sm-offset-5 col-sm-4"><span data-translate="pharmaPortalApp.selfInvoiceCollection.totalizer.qtd">Total in quantity</span></label><div class="col-sm-2 text-right">{{totalizer.qtd | number : 0}}</div></div><div class="col-sm-12 small"><label class="col-sm-offset-5 col-sm-4"><span data-translate="pharmaPortalApp.selfInvoiceCollection.totalizer.value">Total in value</span></label><div class="col-sm-2 text-right">{{totalizer.price | currency : \'&euro;\' : 2}}</div></div><div class="col-sm-12 small"><label class="col-sm-offset-5 col-sm-4"><span data-translate="pharmaPortalApp.selfInvoiceCollection.totalizer.doc">Document Total (inc VAT)</span></label><div class="col-sm-2 text-right">{{totalizer.docTotal | currency : \'&euro;\' : 2}}</div></div></div><div class="row"><div class="col-md-12 text-right"><button class="btn btn-success btn-sm" ng-disabled="isOrderEmpty()" ui-sref="self-invoice-collection.confirmSelfInvoiceCollection()"><i class="fa fa-save"></i>&nbsp;<span data-translate="pharmaPortalApp.selfInvoiceCollection.home.submitSelfInvoiceCollection">Submit SelfInvoiceCollection</span></button></div></div></div></div></div></div>');
$templateCache.put('app/entities/self-invoice-collection/self-invoice-collection.inactive-dialog.html','<form name="confirmFullSearchForm" ng-submit="vm.confirmAddProducts()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title"><b>Aviso</b> - {{message.company}}</h4></div><div class="modal-body" id="modal-body"><any ng-switch="message.type"><any ng-switch-when="1"><p><b>Ponto de entrega deste cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate}}, {{message.regTime}}</p></any><any ng-switch-when="2"><p><b>Cliente est\xE1 inactivo.</b></p><p><b>Motivo</b> - {{message.reasonDescription}}</p><p><b>Observa\xE7\xF5es</b> - {{message.remarks}}</p><p>{{message.regUser}} - {{message.regDate | date : format : shortDate}}, {{message.regTime | date : \'hh:mm:ss\'}}</p></any></any></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/entities/sellout-integration/sellout-integration-dialog.html','<form class="form-horizontal" ng-submit="vm.uploadFile()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="pharmaPortalApp.selloutIntegrationDialog.title">Sellout Integration</h4></div><div class="modal-body" id="modal-body"><div class="form-group" ng-show="vm.curCompanyFault"><div class="col-md-12"><p translate="pharmaPortalApp.selloutIntegrationDialog.message.curCompanyFault.info1">You have not selected the pharmacy to import info</p><p translate="pharmaPortalApp.selloutIntegrationDialog.message.curCompanyFault.info2">Please, select a pharmacy from the available pharmacies list.</p></div></div><any ng-switch="vm.dayHasIntegrations"><div ng-switch-when="true"><p translate="pharmaPortalApp.selloutIntegrationDialog.message.info1">There are already Sellouts for the indicated Pharmacy / Date.</p><p translate="pharmaPortalApp.selloutIntegrationDialog.message.info2">You want to continue (if yes, the data will be accumulated to the existing ones)</p></div><div ng-switch-when="false"><div class="form-group"><label class="control-label col-sm-4" translate="pharmaPortalApp.selloutIntegrationDialog.form.company">Company</label><div class="col-sm-8"><p class="form-control-static">{{("00000"+vm.params.pharmaCode).slice(-5)}}({{("00"+vm.params.deliveryPoint).slice(-2)}}) - {{vm.params.selloutNickname}}</p></div></div><div class="form-group"><label class="control-label col-sm-4" translate="pharmaPortalApp.selloutIntegrationDialog.form.integrationDate">Integration Date</label><div class="col-sm-8"><p class="form-control-static">{{vm.params.date}}</p></div></div><div class="form-group"><label class="control-label col-sm-4" translate="pharmaPortalApp.selloutIntegrationDialog.form.selloutFileType">Sellout File Type</label><div class="col-sm-8"><p class="form-control-static">{{vm.params.selloutFileType}}</p></div></div><div class="form-group" ng-show="vm.settingsFault"><div class="col-md-12"><p translate="pharmaPortalApp.selloutIntegrationDialog.message.settingsFault.info1">Missing params were detected for the selected pharmacy.</p><p translate="pharmaPortalApp.selloutIntegrationDialog.message.settingsFault.info2">Please, complete the pharmacy params on the screen "Companies" or contact your system administrator.</p></div></div><div class="form-group" ng-hide="vm.settingsFault"><label class="control-label col-sm-4" for="file" translate="global.form.file">File</label><div class="col-sm-7"><input type="file" class="file" ngf-select ng-model="vm.selloutIntegrationDialog.file" id="file" ngf-pattern="\'.csv,.xls,.xlsx\'" accept=".csv,.xls,.xlsx" ngf-max-size="20MB" ngf-model-invalid="errorFile"><div class="input-group input-group-sm"><span class="input-group-btn"><button class="browse btn btn-primary" type="button"><i class="fa fa-search"></i>&nbsp;<span translate="entity.action.search">Search</span></button> </span><input type="text" name="file" class="form-control" disabled="disabled"></div></div><script>$(\'.browse\').on(\'click\', function(event){ var file = $(this).parent().parent().parent().find(\'.file\'); file.trigger(\'click\'); });\n\t\t\t\t\t\t$(\'.file\').on(\'change\', function(event){ $(this).parent().find(\'.form-control\').val($(this).val().replace(/C:\\\\fakepath\\\\/i, \'\')); });</script></div></div></any></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-success btn-sm" ng-show="vm.dayHasIntegrations" ng-click="vm.proceed()"><i class="fa fa-arrow-right"></i>&nbsp;<span data-translate="entity.action.proceed">Proceed</span></button> <button type="submit" class="btn btn-success btn-sm" ng-hide="vm.dayHasIntegrations" ng-disabled="vm.settingsFault || vm.curCompanyFault"><i class="fa fa-upload"></i>&nbsp;<span data-translate="entity.action.upload">Upload</span></button></div></form>');
$templateCache.put('app/entities/sellout-integration/sellout-integration-histories.html','<div><div class="panel panel-default"><div class="panel-heading panel-heading-filter"><span class="panel-title pull-left" translate="pharmaPortalApp.selloutIntegrationHistory.home.title">Sellout Integration History</span> <span class="clearfix"></span></div><div class="panel-body"><form class="form-horizontal container-fluid well well-sm" has-any-authority="ROLE_PHARMA_ADMIN"><label for="company" class="pull-left control-label" translate="pharmaPortalApp.selloutIntegrationHistory.pharmacy">Pharmacy</label><div class="col-md-4"><ui-select id="company" name="company" ng-model="vm.currentCompany" on-select="vm.updateCompany($item, $model)"><ui-select-match>{{$select.selected.namingForOptions}}</ui-select-match><ui-select-choices repeat="company as company in vm.companies | filter: $select.search | orderBy:\'naming\'"><span ng-bind-html="company.namingForOptions | highlight: $select.search"></span></ui-select-choices></ui-select></div></form><div class="container-fluid"><div ui-calendar="vm.calendarConfig" id="selloutIntegrationHistoryCalendar" calendar="selloutIntegrationHistoryCalendar" ng-model="vm.eventSources"></div></div></div></div></div>');
$templateCache.put('app/entities/sellout-integration/sellout-integration-status-dialog.html','<form class="form-horizontal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="pharmaPortalApp.selloutIntegrationStatusDialog.title">Sellout Integration Status</h4></div><div class="modal-body" id="modal-body" ng-show="vm.integrationHistory"><div class="form-group"><label class="control-label col-sm-4" translate="pharmaPortalApp.selloutIntegrationDialog.form.selloutFileStatus">Sellout File Status</label><div class="col-sm-8"><p class="form-control-static"><any ng-switch="vm.integrationHistory.selloutFileStatus"><any ng-switch-when="GREEN" style="color:green"><span translate="pharmaPortalApp.selloutIntegrationDialog.message.success">File totally integrated</span></any><any ng-switch-when="ORANGE" style="color:orange"><span translate="pharmaPortalApp.selloutIntegrationDialog.message.parcialSuccess">File partialy integrated</span></any><any ng-switch-when="BLUE" style="color:blue"><span translate="pharmaPortalApp.selloutIntegrationDialog.message.inProcess">File in process</span></any><any ng-switch-default class="text-danger" style="color:red"><span translate="pharmaPortalApp.selloutIntegrationDialog.message.error">Error integrating file</span></any></any></p></div></div><div class="form-group"><label class="control-label col-sm-4" translate="pharmaPortalApp.selloutIntegrationDialog.form.createdDate">File send date</label><div class="col-sm-8"><p class="form-control-static">{{vm.integrationHistory.createdDate | date:\'mediumDate\'}}</p></div></div><div class="form-group"><label class="control-label col-sm-4" translate="pharmaPortalApp.selloutIntegrationDialog.form.company">Company</label><div class="col-sm-8"><p class="form-control-static">{{vm.integrationHistory.company.naming}}</p></div></div><div class="form-group"><label class="control-label col-sm-4" translate="pharmaPortalApp.selloutIntegrationDialog.form.integrationDate">Integration Date</label><div class="col-sm-8"><p class="form-control-static">{{vm.integrationHistory.integrationDate | date:\'mediumDate\'}}</p></div></div><div class="form-group"><label class="control-label col-sm-4" translate="pharmaPortalApp.selloutIntegrationDialog.form.counter">Sellouts read/inserted</label><div class="col-sm-8"><p class="form-control-static">{{vm.integrationHistory.validLineCounter ? vm.integrationHistory.validLineCounter : 0}}&nbsp;/&nbsp;{{vm.integrationHistory.insertedCounter ? vm.integrationHistory.insertedCounter : 0}}</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" ng-click="vm.removeIntegration()" ng-if="vm.integrationHistory.selloutFileStatus == \'RED\'"><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.deleteIntegration">Delete Integration</span></button> <button type="button" class="btn btn-success btn-sm" data-dismiss="modal" ng-click="vm.clear()" autofocus><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.ok">Ok</span></button></div></form>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div class="container" ng-cloak><div class="row text-center"><div class="col-md-12"><h1 data-translate="forbidden.title">Access Denied!</h1><div class="alert alert-danger" data-translate="forbidden.403">You don\'t have permissions to view this page.</div></div></div><div class="row text-center"><div class="col-md-12"><img ng-src="content/images/forbidden.png" class="img-responsive" style="display: inline-block"></div></div><button class="btn btn-warning btn-block btn-sm" ui-sref="home"><i class="fa fa-home"></i>&nbsp; <span data-translate="entity.action.back-home">Back Home</span></button></div>');
$templateCache.put('app/layouts/error/error.html','<div class="container" ng-cloak><div class="row text-center"><div class="col-md-12"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage" class="alert alert-danger">{{errorMessage}}</div></div></div><div class="row text-center"><div class="col-md-12"><img ng-src="content/images/forbidden.png" class="img-responsive" style="display: inline-block"></div></div><button class="btn btn-warning btn-block btn-sm" ui-sref="home"><i class="fa fa-home"></i>&nbsp; <span data-translate="entity.action.back-home">Back Home</span></button></div>');
$templateCache.put('app/layouts/footer/footer-io.html','<footer class="footer_wrapper navbar navbar-inverse"><div class="container"><div class="col-sm-6"><ul class="social_links"><li><a class="linkedin" title="LinkedIn" href="https://www.linkedin.com/company/inout-farma" target="_blank"><i class="fa fa-linkedin"></i></a></li></ul>s</div><div class="col-sm-6"><span class="navbar-version"><i class="fa fa-copyright" aria-hidden="true"></i> 2026, powered by <a title="flowinn.biz" href="http://www.flowinn.biz"></a></span></div></div></footer>');
$templateCache.put('app/layouts/footer/footer-no-version.html','<footer class="footer_wrapper navbar navbar-inverse"><div class="container"><div class="col-sm-6"><ul class="social_links"><li><a class="facebook" href="javascript:void(0)"><i class="fa fa-facebook"></i></a></li><li><a class="twitter" href="javascript:void(0)"><i class="fa fa-twitter"></i></a></li><li><a class="gplus" href="javascript:void(0)"><i class="fa fa-google-plus"></i></a></li></ul></div><div class="col-sm-6"><span class="navbar-version"><i class="fa fa-copyright" aria-hidden="true"></i> 2026, powered by <a href="http://www.flowinn.biz"></a></span></div></div></footer>');
$templateCache.put('app/layouts/footer/footer.html','<footer class="footer_wrapper navbar navbar-inverse"><div class="container"><div class="col-sm-6"><ul class="social_links"><li><a class="facebook" title="facebook" href="javascript:void(0)"><i class="fa fa-facebook"></i></a></li><li><a class="twitter" title="twitter" href="javascript:void(0)"><i class="fa fa-twitter"></i></a></li><li><a class="gplus" title="google_plus" href="javascript:void(0)"><i class="fa fa-google-plus"></i></a></li></ul></div><div class="col-sm-6"><span class="navbar-version">v{{VERSION}}, <i class="fa fa-copyright" aria-hidden="true"></i> 2026, powered by <a title="flowinn.biz" href="http://www.flowinn.biz"></a></span></div></div></footer>');
$templateCache.put('app/layouts/navbar-io/navbar-io.html','<div class="row website"><!-- HEADER SECTION =================================================================================== --><header id="header_wrapper" class="navbar-fixed-top"><nav class="navbar navbar-default"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="isNavCollapsed = !isNavCollapsed"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo no-padding" href="/"><img class="logo-img" ng-if="vm.settings.logo" data-ng-src="{{\'data:\' + vm.settings.logoContentType + \';base64,\' + vm.settings.logo}}" style="padding-left: 50px" alt="{{vm.settings.logoDescription}}"></a></div><div class="collapse navbar-collapse navbar-menu" uib-collapse="isNavCollapsed"><ul class="nav navbar-nav navbar-right"><li du-scrollspy="first_section"><a href="#first_section" du-smooth-scroll>In\xEDcio</a></li><li du-scrollspy="aboutUs"><a href="#aboutUs" du-smooth-scroll>Sobre N\xF3s</a></li><li du-scrollspy="partners"><a href="#partners" du-smooth-scroll>Parceiros</a></li><li du-scrollspy="contact"><a href="#contact" du-smooth-scroll>Contactos</a></li><li><a href="https://inout.flowinn.biz/" target="_blank">\xC1rea Reservada</a></li><!-- LOGIN SECTION =================================================================================== --><!--\t\t\t\t\t<li uib-dropdown is-open="status.isLoginOpen" auto-close="outsideClick">--><!--\t\t\t\t\t\t<a uib-dropdown-toggle><i class="fa fa-lock"></i> Login <i class="caret"></i></a>--><!----><!--\t\t\t\t\t\t<ul id="login-dp" class="navbar-default dropdown-menu" uib-dropdown-menu>--><!--\t\t\t\t\t\t\t<li>--><!--\t\t\t\t\t\t\t\t<div class="row">--><!--\t\t\t\t\t\t\t\t\t<div ng-hide="vm.isAuthenticated()">--><!--\t\t\t\t\t\t\t\t\t\t<div class="col-md-12" ng-show="vm.authenticationError">--><!--\t\t\t\t\t\t\t\t\t\t\t<p class="alert alert-danger">--><!--\t\t\t\t\t\t\t\t\t\t\t\t<i class="fa fa-exclamation-triangle"></i>&nbsp;<span data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials.</span>--><!--\t\t\t\t\t\t\t\t\t\t\t</p>--><!--\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t\t<div class="col-md-12 text-center" ng-hide="vm.authenticationError">--><!--\t\t\t\t\t\t\t\t\t\t\t<h4>Inicie sess\xE3o e ser\xE1 encaminhado para a sua \xE1rea reservada.</h4>--><!--\t\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t\t<div class="col-md-12">--><!--\t\t\t\t\t\t\t\t\t\t\t<form class="form-inline" ng-submit="vm.login($event)">--><!--\t\t\t\t\t\t\t\t\t\t\t\t<div class="form-group input-group input-group-sm col-md-12">--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="input-group-addon">--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="fa fa-user"></i>--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t</span>--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username" value="" autocomplete="off">--><!--\t\t\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t\t\t\t<div class="form-group input-group input-group-sm col-md-12">--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="input-group-addon">--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="fa fa-lock"></i>--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t</span>--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="password" class="form-control" id="password" placeholder="{{\'global.form.password.placeholder\' | translate}}" ng-model="vm.password" value="" autocomplete="off">--><!--\t\t\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t\t\t\t<div class="btn-group btn-group-justified">--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="btn-group">--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button type="submit" class="btn btn-success btn-sm"><i class="fa fa-sign-in"></i>&nbsp;<span data-translate="login.form.button">Sign in</span></button>--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="btn-group">--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button type="button" class="btn btn-warning btn-sm" ng-click="vm.requestResetPassword()"><i class="fa fa-key"></i>&nbsp;<span data-translate="login.password.forgot">Did you forget your password?</span></button>--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t\t\t</form>--><!--\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t<div ng-show="vm.isAuthenticated()">--><!--\t\t\t\t\t\t\t\t\t\t<div class="col-md-12 text-center">--><!--\t\t\t\t\t\t\t\t\t\t\t<h4>Bem vindo ao portal InOut.</h4>--><!--\t\t\t\t\t\t\t\t\t\t\t<h4><i class="fa fa-user"></i> {{vm.account.firstName + " " + vm.account.lastName}}</h4>--><!--\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t\t<div class="col-md-12">--><!--\t\t\t\t\t\t\t\t\t\t\t<form class="form-inline">--><!--\t\t\t\t\t\t\t\t\t\t\t\t<div class="btn-group btn-group-justified">--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="btn-group">--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button ui-sref="pharma-purchase" class="btn btn-success btn-sm"><i class="fa fa-shopping-cart"></i>&nbsp;<span data-translate="global.menu.entities.intranet">Intranet</span></button>--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="btn-group">--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button ng-click="vm.logout()" class="btn btn-danger btn-sm"><i class="fa fa-sign-out"></i>&nbsp;<span data-translate="global.menu.account.logout">Sign out</span>({{vm.account.login}})</button>--><!--\t\t\t\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t\t\t</form>--><!--\t\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t\t</div>--><!--\t\t\t\t\t\t\t</li>--><!--\t\t\t\t\t\t</ul>--><!--\t\t\t\t\t</li>--><!--\t\t\t\t</ul>--></ul></div></div></nav></header></div><!-- IO GOOGLE ANALYTICS --><script>(function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n  })(window,document,\'script\',\'https://www.google-analytics.com/analytics.js\',\'ga\');\n  ga(\'create\', \'UA-15317683-35\', \'auto\');ga(\'send\', \'pageview\');</script>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><a class="navbar-brand logo no-padding" href="/" ng-click="vm.collapseNavbar()"><img class="logo-img" ng-if="vm.settings.logo" data-ng-src="{{\'data:\' + vm.settings.logoContentType + \';base64,\' + vm.settings.logo}}" style="padding-left: 65px" alt="{{vm.settings.logoDescription}}"></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ng-show="vm.isFullyAuthenticated"><div class="no-padding pointer small" ui-sref="settings"><small title="{{ \'global.menu.loggedAs\' | translate}} {{vm.loggedUser.firstName + \' \' + vm.loggedUser.lastName + \' (\' + vm.loggedUser.company.naming + \')\'}}"><div ng-if="!vm.loggedUser.thumbnail"><ng-avatar initials="{{vm.nameInitials}}" bind="true" auto-color="true" width="50" corner-radius="20" style="padding: 5px"></ng-avatar></div><img ng-src="{{\'data:\' + vm.loggedUser.thumbnailContentType + \';base64,\' + vm.loggedUser.thumbnail}}" ng-if="vm.loggedUser.thumbnail" style="max-height: 50px; max-width: 100px; padding: 5px; border-radius: 20px"></small></div></li></ul><ul class="nav navbar-nav navbar-right" has-any-authority="ROLE_SUPER_ADMIN"><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_SUPER_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><i class="fa fa-building"></i>&nbsp;<span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><i class="fa fa-bell"></i>&nbsp;<span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><i class="fa fa-list-alt"></i>&nbsp;<span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><i class="fa fa-heart-o"></i>&nbsp;<span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><i class="fa fa-tasks"></i>&nbsp;<span data-translate="global.menu.admin.logs">Logs</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><i class="fa fa-tachometer"></i>&nbsp;<span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><i class="fa fa-users"></i>&nbsp;<span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><i class="fa fa-cloud"></i>&nbsp;<span data-translate="global.menu.account.sessions">Sessions</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><i class="fa fa-globe"></i>&nbsp;<span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><i class="fa fa-flag-o"></i>&nbsp;<a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul><div class="navbar-header pull-right hidden-sm hidden-xs" ng-show="vm.isFullyAuthenticated"><div class="navbar-brand"><span class="small"><small><span data-translate="global.menu.welcome">Welcome</span>&nbsp;<strong>{{vm.loggedUser.firstName + \' \' + vm.loggedUser.lastName}}</strong> <small>({{vm.loggedUser.company.naming}})</small> </small></span><a ui-sref="portal-notification({sort: \'isRead,asc\'})" ng-if="vm.numberOfNotifications > 0"><span class="badge" style="background-color: transparent; color:#31b0d5;font-size: 1.0em"><i class="fa far fa-bell"></i> <small>{{vm.numberOfNotifications}}</small></span></a></div></div></div></div></nav>');
$templateCache.put('app/layouts/sidenav/sidenav.html','<div has-any-authority="ROLE_USER,ROLE_PRODUCT_IMPORT" style="height:0"><div id="mySidenav" class="navbar-default sidenav"><span class="closebtn btn btn-link" ng-click="vm.closeNav()">&times;</span><ul class="nav nav-pills nav-stacked small"><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_INTRANET" ng-show="vm.moduleSettings.applicationsModule"><a ui-sref="portal-notification" ng-click="vm.closeNav()"><i class="fa far fa-bell fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.notificacoes">Notifica\xE7\xF5es</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_INTRANET" ng-show="vm.moduleSettings.applicationsModule"><a ui-sref="portal-app-board" ng-click="vm.closeNav()"><i class="fa fa-external-link fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.portalApp">Portal Apps</span></a></li><li ng-class="{active: (\'report\' | includedByState)}" has-any-authority="ROLE_ADMIN,ROLE_INTRANET" ng-show="vm.moduleSettings.queriesModule"><a ng-click="vm.getReportGroups(nodeStatus);vm.expandNode(1)"><i class="fa fa-search fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.report">Report</span> <i class="pull-right fa fa-lg fa-fw" ng-class="{\'fa-chevron-down\': nodeStatus == 1, \'fa-chevron-right\': nodeStatus != 1}"></i></a><ul class="nav nav-pills nav-stacked spacer" uib-collapse="nodeStatus != 1"><li ng-repeat="reportGroup in vm.reportGroups | orderBy: \'order\'" ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_INTRANET"><a ui-sref="reportByReportGroup({reportGroup:reportGroup.name})" ng-click="vm.closeNav()"><i class="fa fa-fw fa-lg {{reportGroup.icon}}"></i>&nbsp;<span>{{reportGroup.name}}</span></a></li></ul></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_INTRANET,ROLE_PRODUCT_IMPORT" ng-show="vm.moduleSettings.productsModule"><a ng-click="vm.expandNode(\'products\')"><i class="fa fa-cubes fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.portalProduct.title">Portal Products</span> <i class="pull-right fa fa-lg fa-fw" ng-class="{\'fa-chevron-down\': nodeStatus == \'products\', \'fa-chevron-right\': nodeStatus != \'products\'}"></i></a><ul class="nav nav-pills nav-stacked spacer" uib-collapse="nodeStatus != \'products\'"><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_INTRANET" ng-show="vm.moduleSettings.productsModule"><a ui-sref="portal-product" ng-click="vm.closeNav()"><i class="fa fa-shopping-cart fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.portalProduct.search">Search Portal Products</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_INTRANET,ROLE_PRODUCT_IMPORT" ng-show="vm.moduleSettings.productsModule"><a ui-sref="product-erp-integration" ng-click="vm.closeNav()"><i class="fa fa-exchange fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.portalProduct.excelIntegration">External Excel Integration</span></a></li></ul></li><li ng-class="{active: (\'pharma-purchase\' | includedByState) || (\'pharma-trade\' | includedByState)}" has-any-authority="ROLE_ADMIN,ROLE_PHARMA" ng-show="vm.moduleSettings.purchasesModule || vm.moduleSettings.tradesModule"><a ng-click="vm.expandNode(2)"><i class="fa fa-shopping-bag fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.purchases">Purchases</span> <i class="pull-right fa fa-lg fa-fw" ng-class="{\'fa-chevron-down\': nodeStatus == 2, \'fa-chevron-right\': nodeStatus != 2}"></i></a><ul class="nav nav-pills nav-stacked spacer" uib-collapse="nodeStatus != 2"><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_PHARMA" ng-show="vm.moduleSettings.purchasesModule && !vm.moduleSettings.innergyPortalOrdersModule"><a ui-sref="pharma-purchase" ng-click="vm.closeNav()"><i class="fa fa-shopping-cart fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaPurchase">Pharma Purchase</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_PHARMA" ng-show="vm.moduleSettings.innergyPortalOrdersModule"><a href="{{vm.portalSettings.innergyPortalOrdersPath}}" target="_blank" ng-click="vm.closeNav()"><i class="fa fa-shopping-cart fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaPurchase">Pharma Purchase</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_PHARMA" ng-show="vm.moduleSettings.tradesModule && vm.isPharma && vm.canTrade"><a ui-sref="pharma-trade" ng-click="vm.closeNav()"><i class="fa fa-exchange fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaTrade">Pharma Trade</span></a></li></ul></li><li ng-class="{active: (\'pharma-sale\' | includedByState)}" has-any-authority="ROLE_ADMIN,ROLE_COMERCIAL" ng-show="vm.moduleSettings.salesModule"><a ng-click="vm.expandNode(3)"><i class="fa fa-briefcase fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.sales">Sales</span> <i class="pull-right fa fa-lg fa-fw" ng-class="{\'fa-chevron-down\': nodeStatus == 3, \'fa-chevron-right\': nodeStatus != 3}"></i></a><ul class="nav nav-pills nav-stacked spacer" uib-collapse="nodeStatus != 3"><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_COMERCIAL" ng-show="vm.moduleSettings.salesModule"><a ui-sref="pharma-sale" ng-click="vm.closeNav()"><i class="fa fa-paper-plane-o fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaSale">Pharma Sale</span></a></li></ul></li><li ng-class="{active: (\'psychotropics\' | includedByState)  || (\'pharma-covid\' | includedByState) || (\'pharma-self-test\' | includedByState)}" has-any-authority="ROLE_INFARMED,ROLE_ADMIN" ng-show="vm.moduleSettings.infarmedModule"><a ng-click="vm.expandNode(4)"><i class="fl fl-infarmed fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.infarmed">Infarmed</span> <i class="pull-right fa fa-lg fa-fw" ng-class="{\'fa-chevron-down\': nodeStatus == 4, \'fa-chevron-right\': nodeStatus != 4}"></i></a><ul class="nav nav-pills nav-stacked spacer" uib-collapse="nodeStatus != 4"><li ui-sref-active="active" has-any-authority="ROLE_INFARMED,ROLE_INTRANET,ROLE_ADMIN" ng-show="vm.moduleSettings.infarmedModule"><a ui-sref="psychotropics" ng-click="vm.closeNav()"><i class="fa fa-medkit fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.psychotropic">Psychotropics</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_INTRANET,ROLE_ADMIN" ng-show="vm.moduleSettings.infarmedModule"><a ui-sref="pharma-covid" ng-click="vm.closeNav()"><i class="fa fa-bug fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.covid">COVID-19</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_INTRANET,ROLE_ADMIN" ng-show="vm.moduleSettings.infarmedModule"><a ui-sref="pharma-fault-report-header" ng-click="vm.closeNav()"><i class="fa fa-file-text fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaFaultReports">Pharma Fault Report</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_INTRANET,ROLE_ADMIN" ng-show="vm.moduleSettings.infarmedModule"><a ui-sref="pharma-self-test" ng-click="vm.closeNav()"><i class="fa fa-stethoscope fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.selfTest">Pharma Self Test</span></a></li></ul></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_PHARMA" ng-show="vm.moduleSettings.returnsModule"><a ui-sref="pharma-return" ng-click="vm.closeNav()"><i class="fa fa-reply-all fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaReturn">Pharma Returns</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_PHARMA" ng-show="vm.moduleSettings.innergyPortalProductVerificationModule"><a href="{{vm.portalSettings.productVerificationPath}}" target="_blank" ng-click="vm.closeNav()"><i class="fa fa-dashboard fa-lg fa-fw"></i>&nbsp;Verifica\xE7\xE3o de Produtos</a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_INTRANET" ng-show="vm.moduleSettings.selfInvoiceCollectionModule"><a ui-sref="self-invoice-collection" ng-click="vm.closeNav()"><i class="fa fa-file fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.selfInvoiceCollection">Self Invoice</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_PHARMA" ng-show="vm.moduleSettings.selloutsModule"><a ui-sref="sellout-integration-history" ng-click="vm.closeNav()"><i class="fa fa-object-group fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.selloutIntegrationhistory">Sell Out Integration History</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_PHARMA" ng-show="vm.moduleSettings.campaignsModule"><a ui-sref="campaign" ng-click="vm.closeNav()"><i class="fa fa-lightbulb-o fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.campaign">Campaign</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_PHARMA" ng-show="vm.moduleSettings.campaignsModule"><a ui-sref="pharma-dashboard" ng-click="vm.closeNav()"><i class="fa fa-dashboard fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaDashboard">Dashboard</span></a></li><li ng-class="{active: (\'pharma-reception\' | includedByState) || (\'pharma-transf-reception\' | includedByState) || (\'pharma-picking\' | includedByState)}" has-any-authority="ROLE_ADMIN,ROLE_INTRANET" ng-show="vm.moduleSettings.receptionsModule || vm.moduleSettings.receptionsWarehouseTransfModule || vm.moduleSettings.pickingModule"><a ng-click="vm.expandNode(5)"><i class="fa fa-truck fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaReception.title">Pharma Reception</span> <i class="pull-right fa fa-lg fa-fw" ng-class="{\'fa-chevron-down\': nodeStatus == 5, \'fa-chevron-right\': nodeStatus != 5}"></i></a><ul class="nav nav-pills nav-stacked spacer" uib-collapse="nodeStatus != 5"><li ui-sref-active="active" has-any-authority="ROLE_USER" ng-show="vm.moduleSettings.receptionsModule"><a ui-sref="pharma-reception" ng-click="vm.closeNav()"><i class="fa fa-line-chart fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaReception.purchases">Purchases Reception</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_USER" ng-show="vm.moduleSettings.receptionsWarehouseTransfModule"><a ui-sref="pharma-transf-reception" ng-click="vm.closeNav()"><i class="fa fa-bar-chart fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaReception.warehouseTransfer">Warehouse Transf Reception</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_USER" ng-show="vm.moduleSettings.pickingModule"><a ui-sref="pharma-picking" ng-click="vm.closeNav()"><i class="fa fa-list-alt fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaReception.pickingControl">Retained Products Picking</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_USER" ng-show="vm.moduleSettings.pickingModule"><a ui-sref="pharma-picking-show-history" ng-click="vm.closeNav()"><i class="fa far fa-clipboard fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaReception.pickingControlShowHistory">Retained Products Picking</span></a></li></ul></li><li ng-class="{active: (\'pharma-balance\' | includedByState)}" has-any-authority="ROLE_ADMIN,ROLE_INTRANET" ng-show="vm.moduleSettings.balanceModule"><a ng-click="vm.expandNode(6)"><i class="fa fa-area-chart fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaBalance.title">Pharma Balance</span> <i class="pull-right fa fa-lg fa-fw" ng-class="{\'fa-chevron-down\': nodeStatus == 6, \'fa-chevron-right\': nodeStatus != 6}"></i></a><ul class="nav nav-pills nav-stacked spacer" uib-collapse="nodeStatus != 6"><li ui-sref-active="active" has-any-authority="ROLE_USER"><a ui-sref="pharma-balance" ng-click="vm.closeNav()"><i class="fa fa-line-chart fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaBalance.productsAccount">Products Account</span></a></li></ul></li><li ng-class="{active: (\'settings\' | includedByState) || (\'password\' | includedByState)}" has-any-authority="ROLE_USER"><a ng-click="vm.expandNode(7)"><i class="fa fa-user fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.account.main">Account</span> <i class="pull-right fa fa-lg fa-fw" ng-class="{\'fa-chevron-down\': nodeStatus == 7, \'fa-chevron-right\': nodeStatus != 7}"></i></a><ul class="nav nav-pills nav-stacked spacer" uib-collapse="nodeStatus != 7"><li ui-sref-active="active" has-any-authority="ROLE_USER"><a ui-sref="settings" ng-click="vm.closeNav()"><i class="fa fa-wrench fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_USER"><a ui-sref="password" ng-click="vm.closeNav()"><i class="fa fa-lock fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_USER"><a ui-sref="as400-messages" ng-click="vm.closeNav()"><i class="fa fa-envelope fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.account.messages">Messages</span></a></li></ul></li><li ng-class="{active: (\'user-management\' | includedByState) || (\'company\' | includedByState) || (\'portal-app\' | includedByState) || (\'report\' | includedByState) ||\n\t\t\t\t(\'admin-settings\' | includedByState) || (\'portal-settings\' | includedByState) || (\'intranet-settings\' | includedByState) ||\n\t\t\t\t(\'policy-definition\' | includedByState) || (\'pharma-fault-settings\' | includedByState)}" has-any-authority="ROLE_ADMIN"><a ng-click="vm.expandNode(8)"><i class="fa fa-cogs fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.portalSettings.title">Portal Settings</span> <i class="pull-right fa fa-lg fa-fw" ng-class="{\'fa-chevron-down\': nodeStatus == 8, \'fa-chevron-right\': nodeStatus != 8}"></i></a><ul class="nav nav-pills nav-stacked spacer" uib-collapse="nodeStatus != 8"><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="user-management" ng-click="vm.closeNav()"><i class="fa fa-users fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="company" ng-click="vm.closeNav()"><i class="fa fa-building fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.company">Company</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="product-list" ng-click="vm.closeNav()"><i class="fa fa-product-hunt fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.productListMaintenance">Product List Maintenance</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN" ng-show="vm.moduleSettings.applicationsModule"><a ui-sref="portal-app" ng-click="vm.closeNav()"><i class="fa fa-external-link fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.portalAppMaintenance">Portal Apps Maintenance</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_PHARMA" ng-show="vm.moduleSettings.queriesModule"><a ui-sref="report-group" ng-click="vm.closeNav()"><i class="fa fa-search-plus fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.reportGroup">Report Group</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN" ng-show="vm.moduleSettings.queriesModule"><a ui-sref="report" ng-click="vm.closeNav()"><i class="fa fa-search fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.reportMaintenance">Report Maintenance</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_SUPER_ADMIN"><a ui-sref="admin-settings" ng-click="vm.closeNav()"><i class="fa fa-heartbeat fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.adminSettings">Admin Settings</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="portal-settings" ng-click="vm.closeNav()"><i class="fa fa-wrench fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.portalSettings.portal">Portal Settings</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="intranet-settings" ng-click="vm.closeNav()"><i class="fa fa-windows fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.portalSettings.intranet">Intranet Settings</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN" ng-show="vm.moduleSettings.infarmedModule"><a ui-sref="pharma-fault-settings" ng-click="vm.closeNav()"><i class="fa fa-file-text fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.pharmaFaultSettings">Pharma Fault Settings</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="policy-definition" ng-click="vm.closeNav()"><i class="fa fa-tachometer fa-lg fa-fw"></i>&nbsp;<span data-translate="global.menu.entities.portalSettings.policies">Policies</span></a></li></ul></li><li ui-sref-active="active"><a ng-click="vm.logout()" ng-click="vm.closeNav()"><i class="fa fa-sign-out fa-lg fa-fw"></i>&nbsp;<span>Logout ({{vm.loggedUser}})</span></a></li></ul></div><div class="sidenav-overlay" ng-click="vm.closeNav()"></div><span class="navbar-default"><button type="button" class="sidenav-toggle navbar-toggle" style="display: block; margin-left: 15px; float: left" ng-click="vm.openNav()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button></span></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="container"><div class="col-md-8 col-md-offset-2"><form role="form" name="form" ng-submit="vm.requestReset()" class="form-horizontal" novalidate show-validation><div class="panel panel-default margin-top-20"><div class="panel-heading"><span class="panel-title pull-left" data-translate="reset.request.title">Reset your password</span> <span class="clearfix"></span></div><div class="panel-body"><div class="alert alert-success" ng-show="vm.success" data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</div><div class="alert alert-danger" ng-show="vm.errorEmailNotExists" data-translate="reset.request.messages.notfound"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><any ng-hide="vm.success"><div><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="form-group"><label class="col-sm-2 control-label" for="email" data-translate="global.form.email">E-mail</label><div class="col-sm-10"><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div></div></any></div><div class="panel-footer"><div class="text-right"><any ng-hide="vm.success"><button type="button" ui-sref="home" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="submit" ng-disabled="form.$invalid" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> <span data-translate="reset.request.form.button">Reset</span></button></any><any ng-show="vm.success"><button type="buttom" ui-sref="home" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> <span data-translate="entity.action.ok">Ok</span></button></any></div></div></div></form></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div class="container"><div class="col-md-8 col-md-offset-2"><form role="form" name="form" ng-submit="vm.finishReset()" class="form-horizontal" show-validation novalidate><div class="panel panel-default margin-top-20"><div class="panel-heading"><span class="panel-title pull-left" data-translate="reset.finish.title">Reset password</span> <span class="clearfix"></span></div><div class="panel-body"><div class="alert alert-danger" ng-show="vm.keyMissing" data-translate="reset.finish.messages.keymissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</div><div class="alert alert-success" ng-show="vm.success" data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ui-sref="home">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><any ng-hide="vm.success || vm.keyMissing"><div><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="form-group"><label class="col-sm-3 control-label" for="password" data-translate="global.form.newpassword">New password</label><div class="col-sm-9"><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-sm-3 control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><div class="col-sm-9"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div></div><div class="col-sm-12"><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div></any></div><div class="panel-footer"><div class="text-right"><any ng-hide="vm.success"><button type="button" ui-sref="home" class="btn btn-default btn-sm"><i class="fa fa-undo"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="submit" ng-disabled="form.$invalid" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> <span data-translate="reset.finish.form.button">Reset Password</span></button></any><any ng-show="vm.success"><button type="buttom" ui-sref="home" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> <span data-translate="entity.action.ok">Ok</span></button></any></div></div></div></form></div></div>');
$templateCache.put('app/entities/policy-definition/policy-entities/product-stock-qtd-export.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.policyDefinition.productStockQtd.export">Export list of items</h4></div><div class="modal-body"><p>Tem a certeza que pretende exportar um ficheiro excel com todos os produtos atualmente presentes nesta pol\xEDtica?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-success btn-sm" ng-click="vm.exportToExcel()"><i class="fa fa-upload"></i>&nbsp;<span data-translate="entity.action.exportToExcel">Export to excel</span></button></div></div>');
$templateCache.put('app/entities/policy-definition/policy-entities/product-stock-qtd-import.html','<form class="form" id="importTemplateForm" name="importTemplateForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.policyDefinition.productStockQtd.import">Import list of items to be conditioned</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" data-translate="pharmaPortalApp.policyDefinition.productStockQtd.excelAction" for="field_excelAction">Excel Action</label><span class="btn-group btn-group-sm" id="field_excelAction"><label class="btn btn-default" ng-model="vm.excelAction" uib-btn-radio="\'update\'"><i class="fa fa-check-square-o" ng-class="{\'fa-square-o\' : vm.excelAction != \'update\' }"></i>&nbsp; <span data-translate="pharmaPortalApp.policyDefinition.productStockQtd.update">Update common items</span></label><label class="btn btn-default" ng-model="vm.excelAction" uib-btn-radio="\'replace\'"><i class="fa fa-check-square-o" ng-class="{\'fa-square-o\' : vm.excelAction != \'replace\' }"></i>&nbsp; <span data-translate="pharmaPortalApp.policyDefinition.productStockQtd.replace">Replace entire list</span></label></span></div><div class="form-group"><input type="file" class="file" ngf-select ng-model="vm.policy.file" name="file" ngf-pattern="\'.xls,.xlsx\'" accept=".xls,.xlsx" ngf-max-size="20MB" required ngf-model-invalid="errorFile"><div class="input-group input-group-sm"><span class="input-group-btn"><button class="browse btn btn-primary" type="button"><i class="fa fa-search"></i>&nbsp;<span translate="global.form.file">File</span></button> </span><input type="text" name="file" class="form-control" disabled="disabled"></div></div><script>$(\'.browse\').on(\'click\', function (event) {\n                var file = $(this).parent().parent().parent().find(\'.file\');\n                file.trigger(\'click\');\n            });\n            $(\'.file\').on(\'change\', function (event) {\n                $(this).parent().find(\'.form-control\').val($(this).val().replace(/C:\\\\fakepath\\\\/i, \'\'));\n            });</script></div><div class="modal-footer"><button type="button" class="btn btn-default btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success btn-sm" ng-click="importTemplateForm.$valid && vm.uploadFile(vm.policy.file)"><i class="fa fa-upload"></i>&nbsp;<span data-translate="entity.action.upload">Upload</span></button></div></form>');
$templateCache.put('app/entities/policy-definition/policy-entities/product-stock-qtd.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="pharmaPortalApp.policyDefinition.productStockQtd.details">List of items to be conditioned</h4></div><div class="modal-body"><form class="form-inline text-right"><div class="input-group input-group-sm"><input type="text" id="filter" ng-model="filter" class="form-control input-sm"> <span class="input-group-addon"><i class="fa fa-search"></i></span></div></form><div class="table-responsive"><table class="jh-table table table-striped" table-hover-highlight><thead><tr><th data-translate="pharmaPortalApp.policyDefinition.productStockQtd.productCnp">Product Cnp</th><th data-translate="pharmaPortalApp.policyDefinition.productStockQtd.productDesc">Product Desc</th><th data-translate="pharmaPortalApp.policyDefinition.productStockQtd.qtd">Qtd</th></tr></thead><tbody><tr ng-repeat="productStockQtd in vm.productStockQtds | filter:filter track by productStockQtd.id"><td class="table-left">{{productStockQtd.productCnp}}</td><td class="table-left">{{productStockQtd.productDesc}}</td><td class="table-right">{{productStockQtd.qtd}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" ng-click="vm.clear()"><i class="fa fa-check-square-o"></i>&nbsp;<span data-translate="entity.action.ok">OK</span></button></div></div>');}]);})();